webpackJsonp([61],{

/***/ 1017:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.getDelegation = exports.GET_DELEGATION = undefined;

var _Utils = __webpack_require__(2);

var Utils = _interopRequireWildcard(_Utils);

var _ClientHttpRequest = __webpack_require__(5);

var _ClientHttpRequest2 = _interopRequireDefault(_ClientHttpRequest);

var _immutable = __webpack_require__(1);

var _Modal = __webpack_require__(4);

var _Loading = __webpack_require__(3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var initialState = (0, _immutable.List)([]);

/* Types */
var GET_DELEGATION = exports.GET_DELEGATION = 'GET_DELEGATION';

/* Reducer */

exports.default = function () {
	var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	var action = arguments[1];


	switch (action.type) {
		case GET_DELEGATION:
			return new _immutable.List(action.Obj);
		default:
			return state;
	}
};

/* Action Creators */

var getDelegation = exports.getDelegation = function getDelegation(form) {

	return function (dispatch) {

		dispatch((0, _Loading.isLoading)(true));

		return new _ClientHttpRequest2.default({
			service: 'api/getDelegation',
			method: "POST",
			data: form,
			headers: Object.assign({ "Authorization": sessionStorage.access_token, "uid": sessionStorage.uid })
		}).request().then(function (response) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch({ type: GET_DELEGATION, Obj: response.data });
		}).catch(function (error) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
			throw error;
		});
	};
};

/***/ }),

/***/ 1018:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.setGeneralInfo = exports.getGeneralInfo = exports.SET_DOCUMENTS = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _Utils = __webpack_require__(2);

var Utils = _interopRequireWildcard(_Utils);

var _ClientHttpRequest = __webpack_require__(5);

var _ClientHttpRequest2 = _interopRequireDefault(_ClientHttpRequest);

var _immutable = __webpack_require__(1);

var _immutable2 = _interopRequireDefault(_immutable);

var _Modal = __webpack_require__(4);

var _Loading = __webpack_require__(3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var initialState = _immutable2.default.Map({ documentos: { documento: [] } });

/* Types */
var SET_DOCUMENTS = exports.SET_DOCUMENTS = 'SET_DOCUMENTS';

/* Reducer */

exports.default = function () {
	var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	var action = arguments[1];


	switch (action.type) {
		case SET_DOCUMENTS:
			return new _immutable2.default.Map(action.dataObj);
		default:
			return state;
	}
};

/* Action Creators */

var getGeneralInfo = exports.getGeneralInfo = function getGeneralInfo(form) {

	return function (dispatch) {

		dispatch((0, _Loading.isLoading)(true));

		return new _ClientHttpRequest2.default({
			service: 'api/getInfoGeneral',
			method: "POST",
			data: _extends({}, form),
			headers: Object.assign({ "Authorization": sessionStorage.access_token, "uid": sessionStorage.uid })
		}).request().then(function (response) {
			dispatch((0, _Loading.isLoading)(false));

			console.log(response);
			var llaves = Object.keys(response);

			for (var key in llaves) {
				response[llaves[key]] = response[llaves[key]] === null ? null : cryptr.decrypt(response[llaves[key]]);
			}

			console.log(response, 'JSON desencryptado');

			if (response.key.length > 0) {
				for (var key in response.key) {
					response[response.key[key]] = JSON.parse(response[response.key[key]]);
				}
			}

			console.log(response, 'JSON COMO ANTES');

			var dataObj = {
				cluni: response.data.informacionGeneral.cluni,
				constitutionDate: new Date(Number(response.data.informacionGeneral.fechaConstitucion)).toISOString(),
				operationsDate: new Date(Number(response.data.informacionGeneral.fechaInicioOperacion)).toISOString(),
				iap: response.data.informacionGeneral.transformadaIAP,
				jap: response.data.informacionGeneral.organismoRegulador.id,
				socialIntervention: response.data.informacionGeneral.intervencionSocial
			};

			dispatch({ type: SET_DOCUMENTS, dataObj: dataObj });
		}).catch(function (error) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
			throw error;
		});
	};
};

var setGeneralInfo = exports.setGeneralInfo = function setGeneralInfo(form) {

	return function (dispatch) {

		dispatch((0, _Loading.isLoading)(true));

		return new _ClientHttpRequest2.default({
			service: 'api/setInfoGeneral',
			method: "POST",
			data: form,
			headers: Object.assign({ "Authorization": sessionStorage.access_token, "uid": sessionStorage.uid })
		}).request().then(function (response) {
			dispatch({ type: SET_DOCUMENTS, dataObj: form });
			dispatch((0, _Loading.isLoading)(false));
		}).catch(function (error) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
			throw error;
		});
	};
};

/***/ }),

/***/ 1019:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.getGovernment = exports.GET_GOVERNMENT = undefined;

var _Utils = __webpack_require__(2);

var Utils = _interopRequireWildcard(_Utils);

var _ClientHttpRequest = __webpack_require__(5);

var _ClientHttpRequest2 = _interopRequireDefault(_ClientHttpRequest);

var _immutable = __webpack_require__(1);

var _Modal = __webpack_require__(4);

var _Loading = __webpack_require__(3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var initialState = (0, _immutable.List)([]);

/* Types */
var GET_GOVERNMENT = exports.GET_GOVERNMENT = 'GET_GOVERNMENT';

/* Reducer */

exports.default = function () {
	var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	var action = arguments[1];


	switch (action.type) {
		case GET_GOVERNMENT:
			return new _immutable.List(action.Obj);
		default:
			return state;
	}
};

/* Action Creators */

var getGovernment = exports.getGovernment = function getGovernment(form) {

	return function (dispatch) {

		dispatch((0, _Loading.isLoading)(true));

		return new _ClientHttpRequest2.default({
			service: 'api/getGovernment',
			method: "POST",
			data: form,
			headers: Object.assign({ "Authorization": sessionStorage.access_token, "uid": sessionStorage.uid })
		}).request().then(function (response) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch({ type: GET_GOVERNMENT, Obj: response.data });
		}).catch(function (error) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
			throw error;
		});
	};
};

/***/ }),

/***/ 1020:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.ACTION_TEST = undefined;

var _immutable = __webpack_require__(1);

var _immutable2 = _interopRequireDefault(_immutable);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var initialState = _immutable2.default.Map({});

/* Types */
var ACTION_TEST = exports.ACTION_TEST = 'ACTION_TEST';

/* Reducer */

exports.default = function () {
	var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	var action = arguments[1];

	switch (action.type) {
		case ACTION_TEST:
			return action.flag;
		default:
			return state;
	}
};

/* Action Creators */

/***/ }),

/***/ 1021:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function () {
  var socket = _socket2.default.connect("https://donatarias.montepiedad.com.mx", { forceNew: true });

  socket.on("error", function (err) {
    console.log("Socket_error_:", err);
  });

  function receiveACK() {
    socket.on("receiveACK", function (data) {
      console.log("receiveACK:", data);
    });
  }

  function notification(message) {
    socket.emit("notification", message);
  }

  function receive(dispatch, type) {
    socket.on("receive", function (data) {
      dispatch({ type: type, Obj: data });
    });
  }

  return {
    receiveACK: receiveACK,
    receive: receive,
    notification: notification
  };
};

var _socket = __webpack_require__(1022);

var _socket2 = _interopRequireDefault(_socket);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),

/***/ 1043:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 1046:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.clearResultsReport = exports.getReportList = exports.ACTION_GET_REPORTS_LIST = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _Utils = __webpack_require__(2);

var Utils = _interopRequireWildcard(_Utils);

var _ClientHttpRequest = __webpack_require__(5);

var _ClientHttpRequest2 = _interopRequireDefault(_ClientHttpRequest);

var _immutable = __webpack_require__(1);

var _immutable2 = _interopRequireDefault(_immutable);

var _Modal = __webpack_require__(4);

var _Loading = __webpack_require__(3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var initialState = _immutable2.default.Map({}).set('GetReportsList', new _immutable2.default.Map({}));

/*Types*/
var ACTION_GET_REPORTS_LIST = exports.ACTION_GET_REPORTS_LIST = "ACTION_GET_REPORTS_LIST";

/*Reducer*/

exports.default = function () {
	var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	var action = arguments[1];


	switch (action.type) {
		case ACTION_GET_REPORTS_LIST:
			return state.set('GetReportsList', new _immutable2.default.Map(action.Obj));
		default:
			return state;
	}
};

/*Action Creators*/

var getReportList = exports.getReportList = function getReportList(form) {

	return function (dispatch) {
		dispatch((0, _Loading.isLoading)(true));

		return new _ClientHttpRequest2.default({
			service: 'api/getReportList',
			method: 'POST',
			data: _extends({}, form),
			headers: Object.assign({ 'Authorization': sessionStorage.access_token, 'uid': sessionStorage.uid })
		}).request().then(function (response) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch({ type: ACTION_GET_REPORTS_LIST, Obj: response.data });
			return response;
		}).catch(function (error) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
			throw error;
		});
	};
};

var clearResultsReport = exports.clearResultsReport = function clearResultsReport() {

	return function (dispatch) {

		dispatch({ type: ACTION_GET_REPORTS_LIST, Obj: {} });
	};
};

/***/ }),

/***/ 2:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.conver_ = exports.ec_ = exports.ds_ = exports.listaSeleccionadas = exports.buscarReporte = exports.seleccionCampos = exports.createSelectEvaluacionEstado = exports.createSelectEstadoBandera = exports.createSelectEvaluacionTipo = exports.createSelectYear = exports.createSelectDonataria = exports.createSelectSolutions = exports.createSelectReportes = exports.createTableDonatarias = exports.disabledConfig = exports.treeSearch = exports.getToday = exports.getSum = exports.isEmpty = exports.formatDate = exports.isAfter = exports.isBefore = exports.setDefaultValues = exports.isNullOrEmpty = exports.clearNullAndEmpty = exports.successMessageReport = exports.successMessage = exports.errorMessage = exports.customMessage = exports.docsMessage = exports.showMessage = exports.htmlContentMessage = exports.warningMessage = exports.questionMessage = exports.getMessageResponse = exports.replaceObject = exports.getObjPropsRemove = exports.getListPropsOmitById = exports.getListPropsOmit = exports.indexOfItem = exports.getItem = exports.containsItem = exports.sortByAttr = exports.isChange = exports.getUUID = exports.unionArray = exports.filterItemRemove = exports.filterItem = exports.cleanPositionInArray = exports.removeItemByPositions = exports.removeItem = exports.getItems = exports.isValidRFC = exports.isValidEmail2 = exports.isValidEmail = exports.groupedBy = exports.uniqArray = exports.infoMessage = undefined;

var _underscore = __webpack_require__(391);

var _Labels = __webpack_require__(211);

var _Labels2 = _interopRequireDefault(_Labels);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _moment = __webpack_require__(215);

var _moment2 = _interopRequireDefault(_moment);

var _cryptoJs = __webpack_require__(636);

var _cryptoJs2 = _interopRequireDefault(_cryptoJs);

var _reactBootstrap = __webpack_require__(103);

var _TableData = __webpack_require__(389);

var _TableData2 = _interopRequireDefault(_TableData);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var styles = {
	msg: {
		icon: { margin: '0 0 4vh 0' },
		iconnm: { margin: '0' }
	}
};

var uuidv4 = __webpack_require__(996);

var infoMessage = exports.infoMessage = function infoMessage(message) {
	var modalObj = {
		body: _react2.default.createElement(
			'div',
			null,
			_react2.default.createElement('i', { style: styles.msg.icon, className: 'fa fa-envelope fa-3x' }),
			_react2.default.createElement(
				'p',
				null,
				message
			)
		)
	};
	return modalObj;
};

var uniqArray = exports.uniqArray = function uniqArray(list, item) {
	return (0, _underscore.uniq)(list, item);
};

var groupedBy = exports.groupedBy = function groupedBy(list, item) {
	return (0, _underscore.map)((0, _underscore.groupBy)(list, item), function (clist) {
		return clist.map(function (i) {
			return (0, _underscore.omit)(i, item);
		});
	});
};

var isValidEmail = exports.isValidEmail = function isValidEmail(mail) {
	return (/^\w+([\.\+\-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,})+$/.test(mail)
	);
};

var isValidEmail2 = exports.isValidEmail2 = function isValidEmail2(mail) {
	var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
	return re.test(String(mail).toLowerCase());
};

var isValidRFC = exports.isValidRFC = function isValidRFC(rfc) {
	return (/^([A-ZÑ]{3}([0-9]{2})(0[1-9]|1[0-2])(0[1-9]|1[0-9]|2[0-9]|3[0-1])([A-Z\d][A-Z\d][A-Z\d]))$/.test(rfc)
	);
};

var getItems = exports.getItems = function getItems(list, item) {
	return (0, _underscore.where)(list, item);
};

var removeItem = exports.removeItem = function removeItem(list, item) {

	var elements = (0, _underscore.where)(list, item);

	if (elements && elements.length > 0) {

		var listElements = list;

		elements.map(function (item) {
			listElements = (0, _underscore.without)(listElements, item);
		});

		return listElements;
	} else {
		return list;
	}
};

var removeItemByPositions = exports.removeItemByPositions = function removeItemByPositions(list, ini, end) {
	return list.filter(function (item, index) {
		if (index < ini || index > end) return item;
	});
};

var cleanPositionInArray = exports.cleanPositionInArray = function cleanPositionInArray(list, ini, end, key, value) {
	var newList = list.map(function (a) {
		return Object.assign({}, a);
	});

	return newList.map(function (item, index) {
		if (index >= ini && index <= end) {
			item[key] = value;return item;
		} else return item;
	});
};

var filterItem = exports.filterItem = function filterItem(list, item) {
	return (0, _underscore.filter)(list, function (value) {
		return value.cp.includes(item.cp);
	});
};

var filterItemRemove = exports.filterItemRemove = function filterItemRemove(list, item) {
	return (0, _underscore.filter)(list, function (value) {
		return value != item;
	});
};

var unionArray = exports.unionArray = function unionArray(list1, list2) {
	return (0, _underscore.union)(list1, list2);
};

var getUUID = exports.getUUID = function getUUID() {
	return uuidv4();
};

var isChange = exports.isChange = function isChange(object, other) {
	return (0, _underscore.isEqual)(object, other);
};

var sortByAttr = exports.sortByAttr = function sortByAttr(list, attr) {
	return (0, _underscore.sortBy)(list, attr);
};

var containsItem = exports.containsItem = function containsItem(list, item) {
	return (0, _underscore.findWhere)(list, item) ? true : false;
};

var getItem = exports.getItem = function getItem(list, item) {
	return (0, _underscore.findWhere)(list, item);
};

var indexOfItem = exports.indexOfItem = function indexOfItem(list, item) {
	return (0, _underscore.indexOf)(list, item);
};

var getListPropsOmit = exports.getListPropsOmit = function getListPropsOmit(list, props) {
	return (0, _underscore.map)(list, function (o) {
		if (o.tmp || o.custom || o.id) {
			return (0, _underscore.omit)(o, props);
		} else {
			return o;
		}
	});
};

var getListPropsOmitById = exports.getListPropsOmitById = function getListPropsOmitById(list, id, props) {
	return (0, _underscore.map)(list, function (o) {
		if ((0, _underscore.has)(o, id)) {
			return (0, _underscore.omit)(o, props);
		} else {
			return o;
		}
	});
};

var getObjPropsRemove = exports.getObjPropsRemove = function getObjPropsRemove(obj, props) {
	return (0, _underscore.omit)(obj, props);
};

var replaceObject = exports.replaceObject = function replaceObject(list, item, newItem) {
	return (0, _underscore.map)(list, function (o) {
		if ((0, _underscore.isMatch)(o, item)) {
			return newItem;
		} else {
			return o;
		}
	});
};

var getMessageResponse = exports.getMessageResponse = function getMessageResponse(response) {

	var message = _Labels2.default.errorMessage;

	if (response.message) {
		message = response.message;
	} else if (response.descripcionError) {
		message = response.descripcionError;
	} else if (response.errorMessage) {
		message = response.errorMessage;
	}

	return message;
};

var questionMessage = exports.questionMessage = function questionMessage(message, okClick, cancelClick) {
	var modalObj = {
		body: _react2.default.createElement(
			'div',
			null,
			_react2.default.createElement('i', { style: styles.msg.icon, className: 'fa fa-question-circle fa-3x text-info' }),
			_react2.default.createElement(
				'p',
				null,
				message
			)
		),
		footer: [{
			txt: "SI",
			type: "primary",
			onClick: okClick
		}, {
			txt: "NO",
			type: "primary",
			onClick: cancelClick
		}]
	};

	return modalObj;
};

var warningMessage = exports.warningMessage = function warningMessage(message) {
	var modalObj = {
		body: _react2.default.createElement(
			'div',
			null,
			_react2.default.createElement('i', { style: styles.msg.icon, className: 'fa fa-exclamation-triangle fa-3x text-warning' }),
			_react2.default.createElement(
				'p',
				null,
				message
			)
		)
	};
	return modalObj;
};

var htmlContentMessage = exports.htmlContentMessage = function htmlContentMessage(content) {
	var modalObj = {
		body: _react2.default.createElement(
			'div',
			null,
			_react2.default.createElement('i', { style: styles.msg.iconnm, className: 'fa fa-exclamation-triangle fa-3x text-warning' }),
			content
		)
	};
	return modalObj;
};

var showMessage = exports.showMessage = function showMessage(message) {
	var modalObj = {
		closeButton: true,
		body: _react2.default.createElement(
			'div',
			null,
			_react2.default.createElement('i', { style: styles.msg.icon, className: 'fa fa-check fa-3x text-success' }),
			_react2.default.createElement(
				'p',
				null,
				message
			)
		)
	};

	return modalObj;
};

var docsMessage = exports.docsMessage = function docsMessage() {
	var arrayLinks = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	var onClickView = arguments[1];

	var handlerDocumentById = function handlerDocumentById(row) {
		onClickView(row.id);
	};
	if (!arrayLinks) arrayLinks = [];
	var modalObj = {
		closeButton: true,
		title: "Documentación PLD",
		body: _react2.default.createElement(
			'div',
			null,
			_react2.default.createElement('i', { style: styles.msg.icon, className: 'fa fa-file fa-3x text-info' }),
			_react2.default.createElement(_TableData2.default, {
				columns: [{ name: 'Nombre de Documento', id: 'alias', type: 'simple', headerAlign: 'center', dataAlign: 'left' }],
				data: arrayLinks,
				onClickView: handlerDocumentById,
				view: true
			})
		)
	};

	return modalObj;
};

var customMessage = exports.customMessage = function customMessage(title, body, bsSize, footer) {
	var modalObj = {
		title: title,
		body: body,
		bsSize: bsSize,
		footer: footer
	};

	return modalObj;
};

var errorMessage = exports.errorMessage = function errorMessage(message) {
	var modalObj = {
		body: _react2.default.createElement(
			'div',
			null,
			_react2.default.createElement('i', { style: styles.msg.icon, className: 'fa fa-times-circle fa-3x text-danger' }),
			_react2.default.createElement(
				'p',
				{ className: message.length > 52 ? "textOverflow" : "" },
				message
			)
		)
	};

	return modalObj;
};

var successMessage = exports.successMessage = function successMessage() {
	var modalObj = {
		body: _react2.default.createElement(
			'div',
			null,
			_react2.default.createElement('i', { style: styles.msg.icon, className: 'fa fa-check fa-3x text-success' }),
			_react2.default.createElement(
				'p',
				null,
				_Labels2.default.successMessage
			)
		)
	};

	return modalObj;
};

var successMessageReport = exports.successMessageReport = function successMessageReport() {
	var modalObj = {
		body: _react2.default.createElement(
			'div',
			null,
			_react2.default.createElement('i', { style: styles.msg.icon, className: 'fa fa-check fa-3x text-success' }),
			_react2.default.createElement(
				'p',
				null,
				_Labels2.default.successReport
			)
		)
	};

	return modalObj;
};

var clearNullAndEmpty = exports.clearNullAndEmpty = function clearNullAndEmpty(jsonObj) {

	(0, _underscore.each)(jsonObj, function (value, key) {
		if (value === "" || value === null) {
			delete jsonObj[key];
		} else if (Object.prototype.toString.call(value) === '[object Object]') {
			clearNullAndEmpty(value);
		} else if ((0, _underscore.isArray)(value)) {
			(0, _underscore.each)(value, function (k, v) {
				clearNullAndEmpty(v);
			});
		}
	});
};

var isNullOrEmpty = exports.isNullOrEmpty = function isNullOrEmpty(jsonObj) {

	var result = false;

	(0, _underscore.each)(jsonObj, function (value) {
		if (value === "" || value === null) {
			result = true;
		} else if (Object.prototype.toString.call(value) === '[object Object]') {
			isNullOrEmpty(value);
		} else if ((0, _underscore.isArray)(value)) {
			(0, _underscore.each)(value, function (k, v) {
				isNullOrEmpty(v);
			});
		}
	});

	return result;
};

var setDefaultValues = exports.setDefaultValues = function setDefaultValues(object) {

	var jsonObj = Object.assign({}, object);

	(0, _underscore.each)(jsonObj, function (value, key) {
		if (typeof value === "string") {
			jsonObj[key] = '';
		} else if (typeof value === "number") {
			jsonObj[key] = '';
		} else if (typeof value === "boolean") {
			jsonObj[key] = false;
		} else if (Object.prototype.toString.call(value) === '[object Object]') {
			clearNullAndEmpty(value);
		} else if ((0, _underscore.isArray)(value)) {
			jsonObj[key] = [];
		} else if (value instanceof File) {
			jsonObj[key] = null;
		}
	});

	return jsonObj;
};

var isBefore = exports.isBefore = function isBefore(date1, date2) {
	return (0, _moment2.default)(date1).isBefore(date2);
};

var isAfter = exports.isAfter = function isAfter(date1, date2) {
	return (0, _moment2.default)(date1).isAfter(date2);
};

var formatDate = exports.formatDate = function formatDate(date) {
	var format = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'YYYY-MM-DD';

	return (0, _moment2.default)(date).format(format);
};

var isEmpty = exports.isEmpty = function isEmpty(prop) {
	return prop === null || prop === undefined || prop.hasOwnProperty('length') && prop.length === 0 || prop.constructor === Object && Object.keys(prop).length === 0;
};

var getSum = exports.getSum = function getSum() {
	var arr = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	var attr = arguments[1];

	return arr.reduce(function (a, b) {
		return +a + +parseFloat(b[attr]);
	}, 0);
};

var getToday = exports.getToday = function getToday() {
	var format = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'YYYY-MM-DD';

	return (0, _moment2.default)(new Date()).format(format);
};

var treeSearch = exports.treeSearch = function treeSearch(treeList, attribute, elementSearch) {
	for (var i = 0; i < treeList.length; i++) {
		var result = searchTreeRecursive(treeList[i], attribute, elementSearch);
		if (result) return result;
	}
};

function searchTreeRecursive(element, attribute, matchingLabel) {
	if (element[attribute] == matchingLabel) {
		return element;
	} else if (element.children != null) {
		var result = null;
		for (var i = 0; result == null && i < element.children.length; i++) {
			result = searchTreeRecursive(element.children[i], attribute, matchingLabel);
		}
		return result;
	}
	return null;
}

var disabledConfig = exports.disabledConfig = function disabledConfig(etapa, subEtapa, perfil, esActualizacion) {
	if (!perfil || perfil === "Donataria") perfil = -1;

	var ETAPA = {
		REGISTRO: 1,
		INFORMACION: 2,
		SOLICITUD: 3
	};

	var SUBETAPA = {
		R_DONATARIA: 1,
		R_EJ_RECURSOS: 2,
		R_COMENTARIOS: 3,
		R_ABOGADO: 4,
		R_APROBADO: 5,
		R_RECHAZADO: 6,
		I_EJ_RECURSOS: 7,
		I_INICIO: 1,
		I_DONATARIA: 8,
		I_EJ_INVERSION: 9,
		I_ABOGADO: 10,
		I_APROBADO: 11,
		S_DONATARIA: 1,
		S_EJ_INVERSION: 12,
		S_APROBADO: 13,
		S_RECHAZADO: 14,
		S_SOLICITUD: 37,
		S_COMENTARIOS_REGISTRO: 40,
		S_COMENTARIOS_INFORMACION: 41
	};

	var PERFIL = {
		DONATARIA: -1,
		RECURSOS: 1,
		INVERSION: 2,
		JURIDICO: 3,
		CONTROL: 7
	};
	switch (etapa) {

		case ETAPA.REGISTRO:
			switch (subEtapa) {
				case SUBETAPA.R_DONATARIA:
				case SUBETAPA.R_COMENTARIOS:
					switch (perfil) {
						case PERFIL.DONATARIA:
							return { all: false };
						default:
							return { all: true };
					}
				case SUBETAPA.R_EJ_RECURSOS:
					switch (perfil) {
						case PERFIL.RECURSOS:
							return {
								all: true,
								Documents: { all: false },
								PatronsCouncelors: {
									all: false,
									email: true
								},
								LegalRepresentation: { all: false }
							};
						default:
							return { all: true };
					}
				case SUBETAPA.R_ABOGADO:
					switch (perfil) {
						case PERFIL.JURIDICO:
							return {
								all: true,
								GeneralInfo: {
									all: true,
									constitutionDate: true,
									operationsDate: true,
									jap: true,
									iap: true,
									socialIntervention: true,
									submitButton: true
								},
								PatronsCouncelors: {
									all: true,
									email: true
								},
								Documents: {
									all: true
								},
								CompanyCharter: {
									all: true
								},
								LegalRepresentation: {
									all: true
								}
							};
						default:
							return { "all": true };
					}
				case SUBETAPA.R_APROBADO:
				case SUBETAPA.R_RECHAZADO:
				default:
					return { all: true };
			}
		case ETAPA.INFORMACION:
			switch (subEtapa) {
				case SUBETAPA.I_EJ_INVERSION:
					switch (perfil) {
						case PERFIL.INVERSION:
							return {
								ActivePassiveTable: { all: true },
								AdditionalInfo: {
									all: true,
									theme: false,
									theme1: false,
									theme2: false,
									service: false,
									approach: false,
									addClassification: false,
									classification: false
								},
								Contacts: {
									all: true,
									tableContacts: false,
									submitButton: false
								},
								DocumentsInfo: { all: false },
								Fiscal: { all: true },
								Financial: { all: true },
								IncomeExpensesTable: { all: true },
								Locations: { all: true },
								Objectives: { all: false },
								Population: { all: true }
							};
						default:
							return { all: true };
					}
				case SUBETAPA.I_INICIO:
					return {
						all: false,
						GeneralInfo: {
							all: true
						},
						ContactData: {
							all: true
						},
						PatronsCouncelors: {
							all: true
						},
						Documents: {
							all: true
						},
						CompanyCharter: {
							all: true
						},
						LegalRepresentation: {
							all: true
						}
					};
				case SUBETAPA.I_DONATARIA:
					switch (perfil) {
						case PERFIL.DONATARIA:
							return {
								all: false,
								GeneralInfo: { all: true },
								ContactData: { all: true },
								PatronsCouncelors: { all: true },
								Documents: { all: true },
								CompanyCharter: { all: true },
								LegalRepresentation: { all: true }
							};
						default:
							return { "all": true };
					}
				case SUBETAPA.I_EJ_RECURSOS:
					{
						switch (perfil) {
							case PERFIL.CONTROL:
								{
									return {
										GeneralInfo: { all: true },
										ContactData: { all: true },
										PatronsCouncelors: { all: true },
										Documents: { all: true },
										CompanyCharter: { all: true },
										LegalRepresentation: { all: true },
										ActivePassiveTable: { all: false },
										AdditionalInfo: { all: true },
										Contacts: { all: true },
										DocumentsInfo: { all: false },
										Fiscal: { all: true },
										Financial: { all: false },
										IncomeExpensesTable: { all: false },
										Locations: { all: true },
										Objectives: { all: true },
										Population: { all: true },
										tableContacts: { all: true }
									};
								}
							default:
								return {
									GeneralInfo: { all: true },
									ContactData: { all: true },
									PatronsCouncelors: { all: true },
									Documents: { all: true },
									CompanyCharter: { all: true },
									LegalRepresentation: { all: true },
									ActivePassiveTable: { all: true },
									AdditionalInfo: { all: true },
									Contacts: { all: true },
									DocumentsInfo: { all: false },
									Fiscal: { all: true },
									Financial: { all: true },
									IncomeExpensesTable: { all: true },
									Locations: { all: true },
									Objectives: { all: true },
									Population: { all: true },
									tableContacts: { all: true }
								};
						}
					}
				case SUBETAPA.I_ABOGADO:
				case SUBETAPA.I_APROBADO:
				default:
					return { all: true };
			}
		case ETAPA.SOLICITUD:
			switch (subEtapa) {
				case SUBETAPA.S_SOLICITUD:

					if (esActualizacion) {
						return {
							DocumentsInfo: { all: false },
							Documents: { all: false }
						};
					} else {
						return { all: false };
					}
				case SUBETAPA.S_COMENTARIOS_REGISTRO:
					return {
						GeneralInfo: { all: false },
						ContactData: { all: false },
						PatronsCouncelors: { all: false },
						Documents: { all: false },
						CompanyCharter: { all: false },
						LegalRepresentation: { all: false },
						ActivePassiveTable: { all: true },
						AdditionalInfo: { all: true },
						Contacts: { all: true },
						DocumentsInfo: { all: true },
						Fiscal: { all: true },
						Financial: { all: true },
						IncomeExpensesTable: { all: true },
						Locations: { all: true },
						Objectives: { all: true },
						Population: { all: true }
					};
				case SUBETAPA.S_COMENTARIOS_INFORMACION:

					if (perfil == "Ejecutivo Inversion") {
						return {
							all: true,
							ActivePassiveTable: { all: true },
							AdditionalInfo: { all: true },
							Contacts: { all: true },
							DocumentsInfo: { all: true },
							Fiscal: { all: true },
							Financial: { all: true },
							IncomeExpensesTable: { all: true },
							Locations: { all: true },
							Objectives: { all: true },
							Population: { all: true }
						};
					} else {
						return {
							all: true,
							ActivePassiveTable: { all: false },
							AdditionalInfo: { all: false },
							Contacts: { all: false },
							DocumentsInfo: { all: false },
							Fiscal: { all: false },
							Financial: { all: false },
							IncomeExpensesTable: { all: false },
							Locations: { all: false },
							Objectives: { all: false },
							Population: { all: false }
						};
					}
				default:
					return { all: true };
			}
		default:
			return { "all": true };
	}
};

var createTableDonatarias = exports.createTableDonatarias = function createTableDonatarias(data) {
	return (0, _underscore.each)(data, function (element, index) {
		(0, _underscore.extend)(element, {
			name: element.nombreDonataria
		});
	});
};

var createSelectReportes = exports.createSelectReportes = function createSelectReportes(data) {
	return (0, _underscore.each)(data, function (element, index) {
		(0, _underscore.extend)(element, {
			valor: element.nombre,
			tipoReporte: element.id
		});
	});
};

var createSelectSolutions = exports.createSelectSolutions = function createSelectSolutions(data) {
	var arr = [];
	for (var key in data) {
		arr.push({ id: data[key].corridaId, valor: data[key].nombre });
	}

	return arr;
};

var createSelectDonataria = exports.createSelectDonataria = function createSelectDonataria(data) {
	var arr = [];
	for (var key in data) {
		arr.push({ id: data[key].idDonataria, valor: data[key].donataria });
	}

	return arr;
};

var createSelectYear = exports.createSelectYear = function createSelectYear(data) {
	var arr = [];
	for (var key in data) {
		arr.push({ id: data[key].id, valor: data[key].anio });
	}

	return arr;
};

var createSelectEvaluacionTipo = exports.createSelectEvaluacionTipo = function createSelectEvaluacionTipo(data) {
	var arr = [];
	for (var key in data) {
		arr.push({ id: data[key].id, valor: data[key].estadoEvaluacion });
	}

	return arr;
};

var createSelectEstadoBandera = exports.createSelectEstadoBandera = function createSelectEstadoBandera(data) {
	var arr = [];
	for (var key in data) {
		arr.push({ id: data[key].id, valor: data[key].estado });
	}

	return arr;
};

var createSelectEvaluacionEstado = exports.createSelectEvaluacionEstado = function createSelectEvaluacionEstado(data) {
	var arr = [];
	for (var key in data) {
		arr.push({ id: data[key].id, valor: data[key].evaluacion });
	}

	return arr;
};

var seleccionCampos = exports.seleccionCampos = function seleccionCampos(data) {
	var listaSel = [];

	data.forEach(function (element) {
		if (element.revisado) {

			listaSel.push(element.id);
		}
	});

	return listaSel;
};

var buscarReporte = exports.buscarReporte = function buscarReporte(data, id) {
	var seleccionado = void 0;

	seleccionado = (0, _underscore.find)(data, function (element) {
		if (element.id === id) {
			return element;
		}
	});
	return seleccionado;
};

var listaSeleccionadas = exports.listaSeleccionadas = function listaSeleccionadas(data) {
	var total = 0;

	data.forEach(function (elemt) {
		if (elemt.revisado) {
			total += 1;
		}
	});
	return total;
};

var ds_ = exports.ds_ = function ds_(json) {
	// Función para desencriptar datos
	json = _cryptoJs2.default.AES.decrypt(json, localStorage.n).toString(_cryptoJs2.default.enc.Utf8);
	json = JSON.parse(json);

	return json;
};

var ec_ = exports.ec_ = function ec_(json) {
	// función para encriptar datos
	json = JSON.stringify(json);
	json = _cryptoJs2.default.AES.encrypt(json, localStorage.n).toString();

	return json;
};

var conver_ = exports.conver_ = function conver_(data) {
	// Función para desencriptar datos
	var byteCharacters = atob(data);
	var byteNumbers = new Array(byteCharacters.length);
	for (var i = 0; i < byteCharacters.length; i++) {
		byteNumbers[i] = byteCharacters.charCodeAt(i);
	}
	var byteArray = new Uint8Array(byteNumbers);
	var blob = new Blob([byteArray], { type: 'application/pdf' });
	var blobUrl = URL.createObjectURL(blob);
	window.open(blobUrl, '_blank');
};

/***/ }),

/***/ 205:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.isLoader = exports.DEC_COUNTER_LOADER = exports.INC_COUNTER_LOADER = undefined;

var _immutable = __webpack_require__(1);

var _immutable2 = _interopRequireDefault(_immutable);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var initialState = _immutable2.default.Map({}).set('isLoader', false);

/* Types */
var INC_COUNTER_LOADER = exports.INC_COUNTER_LOADER = 'INC_COUNTER_LOADER';
var DEC_COUNTER_LOADER = exports.DEC_COUNTER_LOADER = 'DEC_COUNTER_LOADER';

/* Reducer */

exports.default = function () {
	var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	var action = arguments[1];

	switch (action.type) {
		case INC_COUNTER_LOADER:
			return state.set('isLoader', true);
		case DEC_COUNTER_LOADER:
			return state.set('isLoader', false);
		default:
			return state;
	}
};

/* Action Creators */


var isLoader = exports.isLoader = function isLoader(flag) {
	return function (dispatch) {
		if (flag) {
			dispatch({ type: INC_COUNTER_LOADER });
		} else {
			dispatch({ type: DEC_COUNTER_LOADER });
		}
	};
};

/***/ }),

/***/ 211:
/***/ (function(module, exports) {

module.exports = {"add":"Agregar","reject":"Rechazar","setAssignment":"Fijar asignación","clear":"Limpiar","config":"Configuración","continue":"Continuar","edit":"Edición","editItems":"Consultar","historic":"Historico","details":"Detalle","messageTitle":"Plataforma DIS","successMessage":"Acción realizada con éxito","errorMessage":"La acción no pudo completarse, vuelve a intentarlo","listMessage":"El elemento seleccionado ya se encuentra agregado","listMessageIn":"El elemento ingresado ya se encuentra agregado","listNotDonor":"No existe donantes Asignados","listEventActive":"No se puede eleminar el presupuesto porque tiene Corridas asiganadas","selectElement":"Debe Seleccionar la opción para editar","selectGoal":"Debe Seleccionar la Meta","selectComplete":"Debes completar la configuración","notImplement":"Fase no Implementada","existsMessage":"Registro ya Existe","warningMessage":"Favor de completar los campos obligatorios","findRecs":"Consulta","delete":"Eliminar","info":"Información general","modify":"Guardar modificaciones","newItem":"Crear","next":"Siguiente","register":"Registrar","save":"Guardar","sendEmail":"Enviar Correo","search":"Buscar","saveSelectAgain":"Guardar y seleccionar de nuevo","saveAndContinue":"Guardar y continuar","data":"Datos Generales","exit":"Salir","accept":"Aceptar","update":"Guardar Cambio","validated":"Validar","year":"Año","dateStart":"Fecha Inicial","dateEnd":"Fecha Final","apply":"Si estamos seguros de aplicar por esta oportunidad","cancel":"Cancelar","send":"Enviar","approvement":"Aprobar","approve":"Aprobar Información","approveInfo":"Aprobar Registro","refuse":"Rechazar Solicitud","sendGrantee":"Revisar Donataria","sendLawyer":"Revisar Abogado","saveComments":"Guardar comentarios","sendComments":"Enviar comentarios","Catalog":{"title":"Catálogos","Items":{"title":"Rubros","item":"Rubro","newItem":"Nombre del rubro","stateItem":"Estatus","stateType":"Tipo","addConcepts":"Agregar Conceptos","concepts":"Conceptos"},"Concepts":{"title":"Conceptos","concept":"Concepto","newConcept":"Concepto","statusConcept":"Estatus","descriptionConcept":"Descripción"}},"Login":{"return":"Regresar al sitio","title":"Iniciar sesión","username":"Correo electrónico","password":"Contraseña","btnLogin":"Ingresar","btnForgotten":"Olvidé mi contraseña","title2":"¿Su organización no está registrada?","regInstitution":"Registrar a mi organización","regInstructionsTitle":"Mi organización está registrada, pero yo no","regPhone":"inversionsocial@montepiedad.com.mx"},"Prueba":{"title":"Título de prueba","username":"Nombre de usuario","age":"Edad","tel":"Teléfono","btnSend":"Enviar a Middleware"},"Configuration":{"title":"Configuración","Documents":{"DocsStatus":{"title":"Estatus de documento","docsStatus":"Estatus Documento","stateItem":"Estatus","newDocsStatus":"Nombre del Estatus"},"DocsNames":{"title":"Documentos","docsName":"Documento","stateItem":"Estatus","yearDocs":"Año","newDocsName":"Nombre del Documento","docsStatus":"Estatus"}},"ProjectConfig":{"title":"Configuración del proyecto","project":"Proyecto","newProject":"Nombre del proyecto","section":"Sección","placeholderSection":"Nombre de la sección de las preguntas","titleCatalog":"Catálogo","titleQuestion":"Pregunta","table":"Asignación de preguntas"},"Question":{"edit":"Edición","title":"Preguntas","titleInputQuestion":"Pregunta","titleInputResponse":"Respuesta","titleInputRetro":"Retroalimentación","titleInputPunMax":"Puntuación máxima","newInputMax":"Ingrese valor","invalidPunMax":"La puntuación Máxima debe ser mayor a 0","titleInputTipoPregunta":"Tipo de pregunta","titleInputTipoResponse":"Tipo de respuesta","nmp":"NMP","donataria":"Donataria","titleInputValor":"Valor","pHInputPregunta":"Ingrese el nombre de la pregunta","pHInputFindQuestion":"Buscar por pregunta","pHInputFindResponse":"Buscar por respuesta","pHInputResponse":"Ingrese la respuesta","pHInputRetro":"Ingrese retroalimentación","titleConfiguration":"Configuración de pregunta","titleConfigurationResp":"Configuración de respuesta","indicator":"Indicador","newIndicator":"Nombre del Indicador","type":"Tipo","stateItem":"Estatus","tableColNum":"No","tableColRes":"Respuesta","tableColRetro":"Retroalimentación","tableColValor":"Valor","tableColEstatus":"Estatus","tableColAcción":"Acción","exportPDF":"Exportar PDF"},"Variable":{"title":"Variable","titleVariable":"Configuración de variables","variable":"Variable","newVariable":"Nombre de la Variable","stateItem":"Estatus","titleRange":"Rangos","from":"Desde","to":"Hasta","points":"Puntos","newPoints":"Ingrese Número","level":"Nivel","newLevel":"Ingrese Nivel","titleQuestion":"Asignación de preguntas","questions":"Preguntas","score":"Puntuación Máxima","exportPDF":"Exportar PDF"},"Evaluation":{"title":"Tipo de evaluación","evaluation":"Evaluación","newEvaluation":"Ingrese Evaluación","stateItem":"Estatus","requiresVisit":"Requiere Visita","dependsEvaluation":"Depende de otra Evaluación","depends":"Depende de","minimumRequired":"Resultado Mínimo requerido","newMinimumRequired":"","maximumRequired":"Resultado anteriores","newMaximumRequired":"","titleNewEvaluation":"Configuración de tipo de evaluación","titleRange":"Rangos","from":"Desde","to":"Hasta","points":"Puntos","newPoints":"Ingrese Número","level":"Nivel","newLevel":"Ingrese Nivel","month":"Meses","newMonth":"Meses","titleVariable":"Asignación de Variables","variables":"Variables","weighing":"Ponderación","newWeighing":"Ingrese Ponderación","score":"Total Ponderación Máxima Variable","exportPDF":"Exportar PDF"},"Questions":{"question":"Pregunta","subtitle":"Subtitulo","subtitleText":"Subtitulo del campo de texto","newQuestion":"Descripción de la Pregunta","newSubtitle":"Descripción del Subtitulo","newSubtitleText":"Subtitulo para el campo de texto","condicionalText":"¿Que opción a elegir sera la condicional para la pregunta planteada?","whatShould":"¿Qué debo capturar aquí?","seeExampleVideo":"Ver video de ejemplo","OpenQuestions":{"title":"Preguntas abiertas"},"ClosedQuestions":{"title":"Preguntas cerradas"},"SpecialQuestions":{"title":"Preguntas especiales"},"CommentsQuestions":{"title":"Preguntas cerradas con comentarios"}},"Ranges":{"title":"Rangos","newRange":"Nombre del Rango","newCategory":"Nombre de la Categoría","range":"Rango","category":"Categoría","table":"Asignación de Categoría","stateItem":"Estatus"},"TypeTable":{"title":"Tipo de tablas","newTable":"Nombre de Tabla","table":"Tabla","stateItem":"Estatus"},"Scales":{"title":"Escalas","newScale":"Nombre de la Escala","newCategory":"Nombre de la Categoría","scale":"Escala","category":"Categoría","table":"Asignación de Categoría","stateItem":"Estatus"},"Indicators":{"title":"Indicadores","indicator":"Indicador","definitionVariable":"Definición de variable","newIndicator":"Nombre del Indicador","type":"Tipo","stateItem":"Estatus","fact":"Dato"},"Goals":{"title":"Metas","goal":"Meta","newGoal":"Nombre de la Meta","table":"Asignación de indicadores","metaObjetivo":"Objetivos","metasObjetivo":"Metas","metasEstatus":"Estatus"},"ObjectivesConfig":{"title":"Objetivos de desarrollo","objective":"Objetivo","metas":"Metas","newObjective":"Nombre del objetivo","stateItem":"Estatus","table":"Asignación de Metas"},"StateStreng":{"title":"Estatus fortalecimiento","stateItem":"Estatus de Fortalecimiento","newStateItem":"Nombre del Estatus"},"StrengConfig":{"title":"Etapa del fortalecimiento","stage":"Etapa","newStage":"Nombre de la Etapa","stateItem":"Estatus"},"SpecialQuestions":{"title":"","success":"Cambios realizados con éxito","SpecialQuestion1":{"title":"Pregunta Especial 1"},"SpecialQuestion2":{"title":"Pregunta Especial 2"},"SpecialQuestion3":{"title":"Pregunta Especial 3","label3":"Rango Edad","label4":"Total","label6":"Rango Socioeconomico","label12":"Total"},"SpecialQuestion4":{"title":"Pregunta Especial 4"},"SpecialQuestion5":{"title":"Pregunta Especial 5"},"SpecialQuestion6":{"title":"Pregunta Especial 6"},"SpecialQuestion7":{"title":"Pregunta Especial 7"},"SpecialQuestion8":{"title":"Pregunta Especial 8"},"SpecialQuestion9":{"labelquestion1":"1. ¿A quiénes se dirige su intervención?","labelquestion2":"2. Características de cada titular","labelquestion3":"3. Productos o servicios que ofrece a cada titular","labelquestion4":"4. Capacidades que su intervención  desarrolla en cada titular","labelquestion5":"5. Cambios positivos a mediano y largo plazo que su intervención busca generar en cada titular","title":"Pregunta Especial 9"}},"Grantee":{"title":"Donatarias","granteeItem":"Donataria","newGrantee":"Nombre de la Donataria","executive":"Ejecutivo","supervisor":"Supervisor","stateItem":"Estatus","supervisor_control":"Supervisor de control"},"Groups":{"title":"Grupos","subtitle1":"Información General","subtitle2":"Asignación","donor":"Asignación de Donantes","grantee":"Asignación de Donantarias","subtitle3":"Configuración de etapas","label1":"Nombre Grupo","placeholder1":"Ingrese el nombre del grupo","label2":"Estatus","placeholderSearch":"Buscar por grupo","group":"Grupos","actions":"Acciones","stageRegister":"Fase de Registro","pay":"Pago","stageInformation":"Fase de Información","stageRequest":"Fase de Solicitud","stageEvaluation":"Fase de Evaluación","project":"Proyectos","goals":"Meta","indicators":"Indicadores","paymentTracking":"Seguimiento de pago"},"EligibilityCriteria":{"title":"Criterios de elegibilidad","automaticCriteria":"Automáticos","evaluationScore":"Calificación","completeEvaluation":"Completas","variable":"Variable","variables":"Variables","manualCriteria":"Manuales","criterion":"Criterio","accomplishment":"Cumplimiento","rule":"Regla","description":"Descripción","status":"Estatus","evaluation":"Evaluación"},"Event":{"title":"Configuración de corrida","fiscalYear":"Año Fiscal","year":"Año","table":"Asignación de donantes","tableAdd":"Donantes Asignados","donor":"Donante","balanceInit":"Presupuesto Inicial","balance":"Saldo","newBalance":"Ingrese Cantidad","admNMP":"Administración NMP","totalBalanceInit":"Total de Presupuesto Inicial","totalBalance":"Total de Saldo","totalEvents":"Total Asignado a corridas","event":"Corrida","keyEvent":"Clave Corrida","newKeyEvent":"Ingrese Clave","nameEvent":"Nombre Corrida","newNameEvent":"Ingrese Nombre","dateInit":"Fecha Inicio","dateEnd":"Fecha Fin","stateItem":"Estatus","typeEvent":"Corrida Normal","percentIncrease":"Porcentaje de Incremento","newPercentIncrease":"Ingrese Cantidad","group":"Asignación de Grupo","function":"Tipo de Función","selectBalance":"Selección de Presupuesto","selectDonor":"Donantes Asociandos por Grupo","amount":"Importe","eligibilityCriteria":"Criterios de Elegibilidad","configEvent":"Corridas Asignadas","expressDonation":"Donativo Express"},"Subtheme":{"title":"Subtema 1","subtheme":"Subtema 1","status":"Estatus","subtema2":"Subtema 2","newSubtheme":"Ingrese nombre del subtema 1"},"Subtheme2":{"title":"Subtema 2","subtheme":"Subtema 2","nameTheme":"Subtema 2","stateItem":"Estatus","newSubtheme":"Ingrese nombre del subtema 2","searchSubtheme":"Buscar por subtema 2"},"Topic":{"title":"Tema","topic":"Tema","subtema1":"Subtema 1","catalog":"Catalogo","stateItem":"Estatus","newTopic":"Ingrese nombre del tema","searchTopic":"Buscar por tema"},"Profile":{"title":"Perfil","profile":"Perfil","newProfile":"Ingrese nombre del perfil","stateItem":"Estatus","function":"Asignación de Funcionalidad","addProfile":"Asignación de Perfil","category":"Funcionalidad","searchProfile":"Buscar por perfil","assignment":{"title":"Asignación de perfil","assignment":"Nombre","user":"Usuario","newUser":"Ingrese Usuario","newAssignment":"Ingrese nombre de la persona","searchAssignment":"Buscar por asignación"}},"Role":{"title":"Función patrono","role":"Función","newRole":"Ingrese nombre de la funcion","searchRole":"Buscar por funcion","stateItem":"Estatus"},"LegalEntity":{"title":"Figura jurídica","acronym":"Siglas","newEntity":"Ingrese nombre de la figura jurídica","searchEntity":"Buscar por figura jurídica","newAcronym":"Ingrese siglas","searchAcronym":"Buscar por siglas"},"InterventionLevel":{"title":"Nivel de intervención","newIntervention":"Ingrese nombre de la intervención","statusIntervention":"Estatus","searchIntervention":"Buscar nivel de intervención","stateItem":"Estatus"},"ExerciseInfo":{"title":"Información del ejercicio"},"Approach":{"title":"Enfoque","stateItem":"Estatus","newApproach":"Ingrese nombre del Enfoque","searchApproach":"Buscar enfoque"},"Services":{"title":"Servicios","service":"Servicio","newServices":"Ingrese nombre del servicio","searchServices":"Buscar servicio"},"otherActor":{"title":"Otros Actores","service":"Servicio","newServices":"Ingrese nombre del servicio","searchServices":"Buscar servicio","id":"id","razonSocial":"Razón Social","siglas":"Siglas","state":"Estado","telefono":"Teléfono","correo":"Correo","paginaweb":"Página web","descripcion":"Descripcion","archivo":"Archivo","Address":{"title":"Domicilio","Street":"Calles","Number":"Numeros","codigoPostal":"Codigo Postal","colony":"Colonia","BetweenStreets":"Entre calles","references":"Referencias"},"AddressBottom":{"areasEspecialidad":"Áreas de especialidad","experiencia":"Experiencia","comentarios":"Comentarios"}},"RegulatoryBody":{"title":"Organismo regulador","stateItem":"Estatus","SearchRegulatory":{"Name":"Nombre del organismo","Employment":"Puesto"},"PersonalData":{"title":"Datos del Organismo Regulador","Name":"Nombre del organismo","newName":"Ingrese el nombre","Acronym":"Siglas","Phone":"Teléfono","Extension":"Extension","Email":"e-Mail","WebSite":"Página Web"},"Address":{"title":"Domicilio fiscal","titleCorrespondencia":"Domicilio de correspondencia","Government":"Estado","City":"Ciudad","Delegation":"Delegación o municipio","Colony":"Colonia","Street":"Calle","NumberExt":"Número exterior","NumberInt":"Número interior","CP":"CP","BetweenStreet1":"Entre Calle 1","BetweenStreet2":"y calle 2","Reference":"Referencia","NotHome":"El domicilio de correspondencia no es el mismo"},"Commentaries":"Comentarios","Commentary":"Comentario","Documents":"Documentos","Contacts":{"title":"Contactos","Name":"Nombre","LastName":"Apellido Paterno","MaternalSurname":"Apellido Materno","Employment":"Puesto","Phone":"Teléfono","Extension":"Extension","Email":"e-Mail"}},"Consultant":{"title":"Consultor","stateItem":"Estatus","Search":{"Name":"Razón social","Acronym":"Siglas","Employment":"Puesto"},"PersonalData":{"title":"Datos del consultor","Name":"Razón social","newName":"Ingrese la razón social","Acronym":"Siglas","Phone":"Teléfono","Extension":"Extension","Email":"e-Mail","WebSite":"Página Web"},"Address":{"title":"Domicilio fiscal","titleCorrespondencia":"Domicilio de correspondencia","Government":"Estado","City":"Ciudad","Delegation":"Delegación o municipio","Colony":"Colonia","Street":"Calle","NumberExt":"Número exterior","NumberInt":"Número interior","CP":"CP","BetweenStreet1":"Entre Calle 1","BetweenStreet2":"y calle 2","Reference":"Referencia","NotHome":"El domicilio de correspondencia no es el mismo"},"Commentaries":"Comentarios","Commentary":"Comentario","Areas":"Áreas de especialidad","Experience":"Experiencia","Documents":"Documentos","Contacts":{"title":"Contactos","Name":"Nombre","LastName":"Apellido Paterno","MaternalSurname":"Apellido Materno","Employment":"Puesto","Phone":"Teléfono","Extension":"Extension","Email":"e-Mail"}},"ChangeOfDestination":{"title":"Cambio de destino","responsibleRequest":"Responsable de la solicitud","dateSend":"Fecha de envio","authorization":"Autorización","dateAuthorization":"Fecha de autorización","amount":"Monto cambio destino","amountAutorized":"Monto autorizado","justification":"Justificación de la petición","resourceAdjustment":"Ajuste de recurso","comments":"Comentarios","concept":"Concepto","item":"Rubro","conceptAdjust":"Concepto Ajustado","itemAdjust":"Rubro Ajustado","reject":"Motivo del rechazo","exportExcel":"Exportar Reporte","dateAuthorizationCorrida":"Fecha Sesión","authorizationBody":"Órgano Autorizador","totalAuthorizedAmount":"Total Monto Autorizado"},"Donors":{"title":"Donantes","stateItem":"Estatus","name":"Nombre","lastname":"Apellido paterno","mothersurname":"Apellido materno","notaryName":"Nombre notario","notaryLastname":"Apellido paterno notario","notaryMothersurname":"Apellido materno notario","phone":"Teléfono","extension":"Extension","email":"e-Mail","webSite":"Sitio Web","Donator":{"title":"Datos del Donante","name":"Nombre del Donante","legalPersonality":"Personalidad jurídica","rfc":"RFC","cluni":"CLUNI","constitutionDate":"Fecha de constitución","startDateOperation":"Fecha inicio de operación","jap":"JAP u organismo regulador"},"Offices":{"title":"Domicilio fiscal","Government":"Estado","City":"Ciudad","Delegation":"Municipio o Delegacion","Colony":"Colonia","Street":"Calle","NumberExt":"Número exterior","NumberInt":"Número interior","CP":"CP","BetweenStreet1":"Entre Calle 1","BetweenStreet2":"Entre Calle 2","Reference":"Referencia","NotHome":"El domicilio de correspondencia no es el mismo"},"ActivitiesObjetives":{"title":"Actividades y Objetivos","socialActivity":"Actividad social","socialGoal":"Objetivo social"},"Notary":{"documentNumber":"Número de escritura","documentDate":"Fecha de escritura","notaryNumber":"Número de notaría","Government":"Estado","rppFolio":"Folio del RPP","dateFolio":"Fecha de folio"},"ConstitutiveActDonor":{"title":"Acta constitutiva del donante"},"LegalRepresentatives":{"title":"Representantes Legales","startDateValidity":"Periodo de vigencia inicial","endDateValidity":"Periodo de vigencia final"},"Documents":"Documentos","EmployersAdvisers":{"title":"Patronos ó Consejeros","function":"Función"},"Contacts":{"title":"Contactos","employment":"Puesto"},"SearchDonors":{"name":"Nombre de donante"}},"Functions":{"title":"Funciones","montoMaximo":"Monto máximo","montoMinimo":"Monto mínimo","evaluacion":"Evaluación","AverageOfExpenses":{"title":"Promedio de egresos","descripcion":"Descripción","monto":"Monto","state":"Estatus","subTitle":"Variables","anios":"Años","m":"Variable m","a":"Variable a","b":"Variable b"},"AverageExpAndSeveralEval":{"title":"Promedio de egresos y Diversas evaluaciones","titlePlusSeveralEval":"Promedio de egresos + Diversas evaluaciones","descripcion":"Descripción","monto":"Monto","state":"Estatus","subTitle":"Variables","ponderacionEgresos":"Ponderación de egresos","anosEsgresos":"Años egresos","anios":"Años","m":"Variable m","a":"Variable a","b":"Variable b","typeEvaluation":"Tipo de evaluación","asignacionRango":"Asignación de Rango","evaluacion":"Evaluación","ponderacion":"Ponderación","de":"De","hasta":"Hasta","porc":"%","ajustable":"% Ajustable"},"DecOrIncDonationAssigned":{"title":"Disminución o incremento","titleLarge":"% de disminución o incremento sobre último donativo asignado","descripcion":"Descripción","monto":"Monto","state":"Estatus","subTitle":"Variables","ponderacionEgresos":"Ponderación de egresos","anosEsgresos":"Años egresos","typeEvaluation":"Tipo de evaluación","asignacionRango":"Asignación de Rango","evaluacion":"Evaluación","ponderacion":"Ponderación","de":"De","hasta":"Hasta","porc":"%","ajustable":"% Ajustable"},"VariationEvaluationClosed":{"title":"Variación en las evaluaciones (Grupo Cerrado)","titleLarge":"Variación en las evaluaciones - Grupo Cerrado","typeEvaluation":"Tipo de evaluación","egresoAnoAnterior":"Egreso del Año Anterior","descripcion":"Descripción","monto":"Monto","state":"Estatus","subTitle":"Variables","anios":"Años","maximoAportacionIngreso":"% Máximo de Aportación por Ingreso","de":"De","del":"Del","al":"al","evaluacion":"Evaluación","ponderacion":"Ponderación","ajustable":"ajustable","porcentajeAjuste":"% Ajustable","nivel":"NIVEL"},"VariationEvaluationOpened":{"title":"Variación en las evaluaciones (Grupo Abierto)","titleLarge":"Variación en las evaluaciones - Grupo Abierto","typeEvaluation":"Tipo de evaluación","descripcion":"Descripción","monto":"Monto","state":"Estatus","maximoAportacionIngreso":"% Máximo de Aportación por Ingreso","anos":"Años","subTitle":"Variables","egresoCompararAnos":"Egreso a comparar-Años","exponente":"Exponente","del":"Del","al":"al","evaluacion":"Evaluación","ponderacion":"Ponderación","ajustable":"% Ajustable","nivel":"NIVEL"}},"Notifications":{"tipoDeNotificacion":"Tipo de notificación","tipoDeEnvio":"Tipo de envío: ","plantilla":"Plantilla","adjuntarArchivos":"Adjuntar archivo","envioIndividual":"Envío Individual","envioMasivo":"Envío Masivo","donataria":"Donataria","donatarias":"Donatarias","donante":"Donante","organismoRegulador":"Organismo regulador","consultor":"Consultor","otros":"Otros actores","asunto":"Asunto","cuerpoDeTexto":"Cuerpo de texto","cuerpoCorreo":"Cuerpo del correo","incluirImagen":"Incluir imagen en el texto","declaracion":"Declaración","corrida":"Corrida","grupo":"Grupo","universo":"Todo el universo","figJuridica":"Figura Jurídica","estatusDonataria":"Estatus Donataria","catResultados":"Catálogo de Resultados","estatusAplicacionDonativo":"Estatus de Aplicación del Donativo","estatusPago":"Estatus de Pago","programaAsociado":"Programa Asociado"},"Template":{"letters":{"title":"Plantilla de cartas","logo1":"Logotipo 1","logo2":"Logotipo 2","description":"Texto","to":"Para","body":"Cuerpo de la carta","signature1":"Firma 1","signature2":"Firma 2","signatureFullName":"Nombre y Apellidos","position":"Cargo","ccp":"c.c.p","footer":"Pie de página","stateItem":"Estatus","templName":"Nombre Plantilla","templDate":"Fecha de Plantilla"}},"Contracts":{"title":"Configuración de Contrato","newContract":"Ingrese nombre del contrato","stateItem":"Estatus","Type":{"title":"Tipo de Contrato"}},"Payments":{"Requirements":{"title":"Requisito de Pago","new":"Requisito","detail":"Detalle","type":"Tipo","stateItem":"Estatus"}},"Reception":{"Requests":{"title":"Recepción de solicitudes","run":"Visualizando registros de la corrida"}},"Results":{"title":"Consulta informe de resultados"},"Update":{"Data":{"title":"Actualización de datos"}},"DonationCheck":{"title":"Estatus del donativo","ApplicationStatus":{"title":"Estatus de aplicación del donativo"},"CheckStatus":{"title":"Estatus de comprobación del donativo"}},"Goods":{"title":"Bienes","good":"Bien","stateItem":"Estatus","newApproach":"Ingrese nombre del Bien","searchApproach":"Buscar Bien"},"Type":{"title":"Catalogo Tipo","type":{"title":"Tipo","applyTo":"Aplica a"}},"IntegralValuation":{"title":"Valoración integral","description":"Descripción","Range":{"title":"Rangos","stars":"Estrellas","value":"Valor"},"Evaluation":{"title":"Evaluación","consideration":"Ponderación"}},"ReceptionAudit":{"title":"Conciliación"},"PortfolioReallocation":{"title":"Asignación de Cartera"},"ConfiguracionPld":{"title":"PLD","activatePld":"¿Activar PLD?","montoMinimoActivarPld":"Monto mínimo en que se activará PLD","numeroDiasDisponiblePld":"Número de días en que estará disponible PLD","buttonSaveConfiguracionPld":"Guardar","documento":"Documento","plcDocumento":"Nombre del Documento","subirArchivo":"Adjuntar documento","plcEnlaceDocumento":"https://ejemplo.com","accionActivarPld":"¿Está seguro que desea ACTIVAR PLD?","accionDesactivarPld":"¿Está seguro que desea DESACTIVAR PLD?","buttonHeaderDonataria":"PLD","tituloModalDonataria":"Documentación PLD","buttonCerrarModal":"Cerrar"}},"Reports":{"reports":"Reportes","Search":"Buscar","searchGrantee":"Seleccionar","id":"ID","donataria":"Donataria","generate":"Generar","indicator":"Indicador","sinceYear":"Desde","untilYear":"Hasta","type":"Tipo","corridas":"Corridas","selectedGrantee":"Donatarias seleccionadas","paramsExtras":"Parámetros Adicionales","infomationProject":"Información de proyecto","return":"Regresar","create":"Crear","infoRegistro":"Información de Registro","domDatosContacto":"Domicilio y datos de contacto","datosConstitucion":"Datos de constitución","patronatoCompleto":"Patronato completo","repreLegales":"Representantes legales","infoOperativa":"Informacíon Operativa","infoGeneral":"Información general","odsMetas":"ODS y metas","clasificacion":"Clasificación","contactos":"Contactos","ubiaciones":"Ubicaciones","poblacionAtendida":"Población atendida","informacionFinanciera":"Información Financiera","completa":"Completa","completaDesdeAnio":"Completa desde año","soloIngreso":"Sólo ingresos, egresos desde año","desdeAnio":"Desde año","observaciones":"Observaciones","donativosAnteriores":"Donativos Anteriores","comprobacion":"Comprobación","resumen":"Resumen","detalleDonaciones":"Detalle de donaciones","informacionProyecto":"Información Proyecto","proyecto":"Proyecto","rubros":"Rubros","valoracionRubros":"Valoración de rubros","criteriosElegibilidad":"Criterios de elegibilidad","definicionIndicador":"Definición del indicador","valoraciones":"Valoraciones","capacidadesOrganizativas":"Capacidades organizativas","nivelIntervencion":"Nivel de intervención","apropiacion":"Apropiación","movilidad":"Movilidad","valoracionIntegral":"Valoración integral","detalle":"Detalle","fortalecimiento":"Fortalecimiento","todasEtapas":"Todas las etapas","bitacora":"Bitácora","desde":"Desde","hasta":"Hasta","tipo":"Tipo"},"Principal":{"Dashboard":{"title":"Dashboard","newRun":"Nueva corrida","ChangeOfDestiny":"Cambio de destino","records":"Registro","pendingUpdates":"Información","tasks":"Tareas","operation":"Operación","evaluation":"Evaluación","activeRaces":"Corridas activas","registeredDonations":"Donatarias registradas","configuracion":"Módulo de Configuración","perfil":"Perfil","asignacionPerfil":"Asignación Perfil","portfolio":"Cartera","notification":"Notificaciones","query":"Consulta","assignment":"Asignación","filterByEvaluation":"Filtro por evaluación","reports":"Reportes","process":["Registro","Información","Evaluación","Cartera | Consulta","Información faltante","Pagos parciales","Cartera contabilizadas","Informe de resultados"],"evaluationFilter":"Filtro por evaluación","condicionesEntrega":"Condiciones de entrega de donativos","missingInformation":"Información Faltante","integralValuation":"Valoración integral","blogs":"Bitácora General","preDonation":"Donativo - Pre","managementDonation":"Gestión Donatarias"}},"Asignacion":{"donationPre":"Donativo Pre","assignmentFilter":"Filtro de Asignación","proposalAssignment":"Propuesta de Asignación","proposalAssignmentExec":"Fijar propuesta de asignación","Filter":{"event":"Corrida","criteria":"Criterios","JustificationRequest":"Justificación de la solicitud","comments":"Comentarios","causeNegation":"Causas de la negación","resultAssingment":"Resultados de asignación","causeJustify":"Causas de no justificación"}},"ProposalAssignment":{"title":"Propuesta de asignación","editDonataria":"Editar donataria","presupuestoDisponible":"Presupuesto disponible","solicitadoProgramaAsociado":"Solicitado programa asociado","montoProgramaAsociado":"Monto programa Asociado","montoPropuestoEdit":"Monto propuesto","causasNegacion":"Causas de negación","resultadosAsignacion":"Resultados de asignación","comentarios":"Comentarios","proposal":{"comentarios":"Comentarios","totalAsignado":"Total Asignado","saldoPresupuesto":"Saldo Presupuesto","autoriza":"Órgano que autoriza","dateAutorization":"Fecha en que autorizó","corrida":"Corrida","TipoFuncion":"Tipo función","funcion":"Función","evaluaciónes":"Evaluaciónes","redondeo":"Redondeo","corridaAsociada":"Corrida asociada","presupuestoCorrida":"Presupuesto corrida","montoPropuesto":"Monto Propuesto","montoNMP":"Monto NMP","montoDUM":"Monto DUM","montoProgramaAsociado":"Monto programa asociado"},"budgetAvailable":"Presupuesto disponible","totalAssigment":"Total asignado","budget":"Saldo Presupuesto","export":"Exportar","autorization":"Autorización","accion":"Accion","certificate":"Certificado"},"PreRegister":{"title":"Registro de donatarias","registerSuccessAction":"Ingresar al sistema","resendMail":"Aún no he recibido e-Mail para activar mi cuenta","sendRecoveryAccountTitle":"No he recibido el correo de Activación","sendRecoveryAccount":"Antes de continuar por favor verifique en su bandeja de correo no deseado y asegúrese que el correo sea correcto","InstitutionData":{"title":"Datos de la organización","RFC":"RFC","newRFC":"Ingrese RFC","legalConcept":"Figura jurídica","granteeName":"Nombre de la donataria con la denominación completa","newGranteeName":"Ingrese Nombre de la Donataria"},"UserData":{"title":"Datos del usuario","name":"Nombre","newName":"Ingrese Nombre","paternalSurname":"Apellido paterno","newPaternalSurname":"Ingrese Apellido paterno","maternalSurname":"Apellido materno","newMaternalSurname":"Ingrese Apellido materno","email":"e-Mail","newEmail":"Ingrese e-Mail","password":"Contraseña","newPassword":"Ingrese contraseña","confirmPwd":"Confirmar contraseña","newConfirmPwd":"Ingrese contraseña"}},"Register":{"GeneralInfo":{"title":"Datos generales","granteeName":"Nombre de la donataria","cluni":"CLUNI","rfc":"RFC","legalFigure":"Figura jurídica","constitutionDate":"Fecha de constitución","operationsDate":"Fecha de inicio de operación","turnedIntoIAP":"¿Se transformó en IAP?","jap":"JAP u organismo regulador","socialIntervention":"Descripción de la intervención social","twitter":"Twitter","facebook":"Facebook","checkInfo":"Acepto recibir información de NMP"},"ContactData":{"title":"Domicilio fiscal","street":"Calle","numberExt":"Número exterior","numberInt":"Número interior","cp":"C.P.","street1":"Entre calle 1","street2":"y calle 2","reference":"Referencia","colony":"Colonia","town":"Delegación o municipio","city":"Ciudad","state":"Estado","mail":"El domicilio para correspondencia no es el mismo","phone":"Teléfono","webpage":"Página web","mail1":"e-Mail 1","mail2":"e-Mail 2","mailAddressTitle":"Domicilio para correspondencia"},"PatronsCouncelors":{"title":"Patronos/Consejeros","name":"Nombre","paternalSurname":"Apellido paterno","maternalSurname":"Apellido materno","function":"Función","email":"e-Mail personal"},"CompanyCharter":{"title":"Acta constitutiva","deedNumber":"Número de escritura","deedDate":"Fecha de escritura","notaryName":"Nombre notario","notaryPaternalSurname":"Apellido paterno notario","notaryMaternalSurname":"Apellido materno notario","notarysOfficeNumber":"Número de notaría","State":"Estado","RPPFolio":"Folio de RPP","folioDate":"Fecha de folio"},"LegalRepresentation":{"title":"Representante legal","name":"Nombre","paternalSurname":"Apellido paterno","maternalSurname":"Apellido materno","powerType":"Tipo de poder","periodSince":"Vigente desde","periodUntil":"Hasta","mail":"Correo electrónico"},"Documents":{"title":"Documentos","stateItem":"Estatus"},"Summary":{"title":"Enviar"},"Notifications":{"title":"Notificaciones"}},"Information":{"Antecedentes":{"titleButton":"Información general","displayAll":"Desplegar todo","antecedent":"Antecedentes","mision":"Misión","vision":"Visión","characteristics":"Características de la población atendida","requirements":"Requisitos para otorgar el servicio","socialProblem":{"title":"Problema social que atiende","subelements":[{"title":"¿Cuál/es es/son el/los problema/s social/es que atiende su organización?","subtitle":"Describa qué problema/s central/es busca resolver su organización y cuáles son los derecho/s vulnerado/s que busca garantizar con sus intervenciones. Se entiende por problema social a aquel asunto o tema de interés público que afecta a un grupo poblacional determinado, que se encuentra vulnerado en el ejercicio de sus derechos humanos.","maxLength":"500 caracteres","note":""},{"title":"¿Cuáles son las causas inmediatas del problema que atiende?","subtitle":"Por causas inmediatas se entienden a aquellos factores directamente asociados al problema en cuestión.","maxLength":"400 caracteres","note":"Incluya fecha y fuente de información"},{"title":"Si el problema social en cuestión no se atiende, ¿Cuáles serían las consecuencias o efectos negativos en la población que atienden?","subtitle":"","maxLength":"500 caracteres","note":"En su respuesta incluya fecha y fuente de información"}]},"installedCapacity":"Capacidad instalada","theoryChange":"Teoría de cambio","allFields":"","socialIntervention":"Describa la intervención social","odsContributes":"Objetivos de Desarrollo Sostenible a los que contribuye","carteraProgramatica":{"title":"Cartera programática","columnProyectos":"Nombre del proyecto","columnObjetivos":"Objetivos","columnServicioProductos":"Servicios/Productos","titularesDerechos":"Enliste los principales programas o proyectos que implementa su organización, sus principales objetivos, los servicios/productos que ofrecen, y las capacidades que buscan desarrollar en la población que atienden (titulares de derechos).","maxLength":"Máx. 300 caracteres por cada campo de texto","programaProyecto":"Programa/Proyecto","enfoqueSistemico":"Alguno de sus programas/proyectos ¿cuentan con enfoque sistémico?","subEnfoqueSistemico":"Se entiende por enfoque sistémico aquel que prioriza entendimiento de los factores y las dinámicas que existen en un problema complejo, es decir su foco es entender que un problema social tiene múltiples causas, algunas de ellas son de carácter estructural o de raíz. Se enfoca en el desarrollar un entendimiento matizado de un problema basado en un mapa de las causas del problema con relaciones causales no exclusivamente lineares, es decir para una misma causa se tienen diferentes causas relacionadas a varios actores. Aspira a crear soluciones que no crean consecuencias no intencionadas en la población objetivo.","radioSi":"Si","radioNo":"No","afirmativoEnfoqueSistemico":"(En caso de que si) ¿Cuál de sus proyectos, en qué temática, en qué ámbito (Internacional, nacional, estatal, municipal, o local) y en qué articulación con qué instituciones incide de manera sistemática en el tratamiento del problema social para el cuál su organización trabaja?","maxLengthEnfoqueSistemico":"300 caracteres","btnAdd":"Agregar información de otro proyecto","btnCancel":"Cancelar","btnSave":"Agregar","btnEdit":"Editar","subelements":[{"title":"Nombre del Programa/ Proyecto","maxLength":"Campo de texto 200 caracteres"},{"title":"Objetivo principal","maxLength":"Campo de texto 200 caracteres"},{"title":"Servicios/ Productos que ofrece a la población destinataria y/o a su comunidad","maxLength":"Campo de texto 300 caracteres"},{"title":"Capacidades que desarrolla en la población atendida","maxLength":"Campo de texto 300 caracteres"}]},"evaluacionMonitoreo":{"title":"Evaluación y monitoreo","subelements":[{"title":"¿La organización cuenta con instrumentos de recolección de información para el correcto monitoreo del proyecto?","note":"Se entiende por instrumentos de recolección a formularios, fichas, planillas, cuestionarios, encuestas y otros documentos que se apliquen para recolectar datos de la intervención.","radioSi":"Si","radioNo":"No","recoleccionInformacion":"Mencione los medios de verificación que utiliza."},{"title":"¿Qué tipo de información solicitan y recopilan a los/as destinatarios/as de sus intervenciones?","note":"(Por ejemplo: edad, género, nivel socioeconómico, características específicas acerca de la problemática con la cual se busca contribuir a través de la intervención)"},{"title":"¿Con qué periodicidad recolectan la información de sus destinatarios/as y actividades de los proyectos/programas?","options":["Mensualmente","Trimestralmente","Semestralmente","Anualmente"]},{"title":"En el caso de que articule sus acciones con titulares de responsabilidades y obligaciones ¿Qué tipo de información solicitan y recopilan de estos?"},{"title":"¿Utiliza algún tipo de herramientas tecnológicas para recolectar, analizar, almacenar y procesar los datos recolectados?","note":"(Por ejemplo, algún tipo de sistema y/o tablero de visualización de datos, entre otros)","radioSi":"Si","radioNo":"No","afirmativo":"Por favor, indique cuál/cuáles (200 caracteres)"},{"title":"¿Para qué se utilizan los datos? (500 caracteres)","note":"(Por ejemplo: observar cambios y/o mejoras en la población destinataria, reflexionar sobre los modelos de intervención y tomar decisiones para eficientizarlos, entre otros)"},{"title":"¿Los programas/proyectos de su organización se han sometido a algún tipo de evaluación externa?","radioSi":"Si","radioNo":"No"},{"title":"Seleccione qué tipo/s de evaluación/es se han llevado adelante en su organización","options":["Evaluación de diseño","Evaluación de procesos","Evaluación de resultados/impacto","Evaluación de eficiencia (ROI | SROI)"]}]},"alianzas":{"title":"Alianzas","subtitleAliado":"Aliado (Opcional)","columnTipoAliado":"Tipo de aliado","columnTipoVinculacion":"Tipo de vinculación","subtitleDonante":"Donantes","subtitleProveedor":"Proveedores","question":"En el caso de que corresponda, especifique los principales actores con los que su organización trabaja en alianzas, describa el objetivo que persigue dicha alianza. (Omitir donantes y proveedores)","nombreAliado":"Nombre del aliado","objetivoAlianza":"Objetivo de la alianza","btnAdd":"Agregar otro aliado","btnCancel":"Cancelar","btnSave":"Agregar","tipoAliados":{"title":"Seleccione el tipo de aliado","options":["Organización de la sociedad civil","Académico","Gubernamental","Privado","Persona Física","Otro"],"descriptionOtro":"Especifique el tipo de aliado"},"tipoVinculacion":{"title":"Tipo de vinculación","options":["Acuerdo de palabra","Convenio/Contrato/Compromiso por Escrito","Memorando de entendimiento","Otro"],"descriptionOtro":"Escriba el tipo de Vinculación"},"tableDonante":{"title":"Enliste los 5 principales donantes en efectivo que aportan a la causa de su organización y menciona cuál es el porcentaje que cada uno representa respecto a los ingresos anuales","nombreDonante":"Nombre del donante","subNombreDonante":"(En el caso de los donantes individuales, agruparlos bajo el nombre 'Personas físicas')","porcentajeDonante":"% de donativo respecto a su ingreso anual","errorPorcentaje":"El porcentaje total de los donantes no debe ser mayor a 100%","errorExcesoDonantes":"Solo se admiten de 1 a 5 donantes"},"tableProveedor":{"title":"Enliste los 3 principales proveedores de su organización (productos, insumos, servicios)","nombreProveedor":"Nombre del proveedor","tipoProducto":"Tipo de producto / insumo / que le presta","errorExcesoProveedores":"Solo se admiten de 1 a 3 donantes"}},"resultados":{"title":"Resultados","resultadosProgramas":"¿Qué resultados demostraron los programas o proyectos que implementa su organización?","note":"Con base en los efectos de tu intervención social, incluye datos cuantitativos y cualitativos, así como la fuente y fecha de la información. Resultados son cambios y efectos observables en la población que atiendes.","maxLength":"(500 caracteres)","impactosProgramas":"¿Qué impactos demostraron los programas o proyectos que implementa su organización?","noteImpactos":"Con base en los efectos de tu intervención social, en la respuesta especifica si son impactos cuantitativos y cualitativos, así como la fuente y fecha de la información. Por impactos nos referimos a los cambios transformadores y sostenibles que es posible atribuir, a tu intervención social.","maxLengthImpactos":"(500 caracteres)","etapasProyecto":"Considerando las siguientes etapas de un programa o proyecto: diagnóstico, diseño y planificación de la intervención, implementación, monitoreo y evaluación:","subelements":[{"title":"¿Cómo y cuál/es de las distintas etapas del programa/proyecto mencionadas anteriormente participan los/as titulares de derecho (destinatarios/as directos/as) de su organización?","maxLength":"500 caracteres","note":""},{"title":"¿Cómo y cuál/es de las distintas etapas del programa/proyecto mencionadas anteriormente participan los/as titulares de responsabilidad con los que articula su organización?","maxLength":"300 caracteres","note":""},{"title":"¿Cómo y cuál/es de las distintas etapas del programa/proyecto mencionadas anteriormente participan los/as titulares de obligación (instituciones estatales y comunidad internacional) con los que articula su organización?","maxLength":"300 caracteres","note":"En caso de que los titulares de obligación no participen en ninguna de las etapas mencionadas de tus programas/proyectos escriba 'N/A' (no aplica)"}],"informacionAdicional":"Si existe otra información adicional que considere relevante sobre los programas y proyectos de su organización, por favor menciónela a continuación:"},"alcanceTerritorial":{"title":"Alcance territorial","label":"Alcance territorial de la organización","note":"Favor de poner el alcance territorial que tiene la organización con sus proyectos","options":["Internacional","Nacional","Estatal","Municipal","Local"]}},"Objetivos":{"title":"Objetivos","selectorObjective":"Objetivo","selectorGoal":"Meta","formLabel":"Objetivos de desarrollo sostenible a los que contribuye"},"Classification":{"title":"Clasificación","theme":"Tema","theme1":"Subtema1","theme2":"Subtema2","service":"Servicio","approach":"Enfoque"},"Contactos":{"title":"Contactos","fullName":"Nombre completo","name":"Nombre","paternalSurname":"Apellido paterno","maternalSurname":"Apellido materno","jobDescription":"Puesto","phone":"Teléfono (lada + número)","Email":"e-Mail","tipoRelacion":"Tipo de relación"},"Documentos":{"title":"Documentos","titleComponent":"Documentos de la donataria","registerAsociated":"Asociados el registro","anotherInfoAsociated":"Asociados a otra información","history":"Ver historial"},"Fiscal":{"title":"Actividad anual","titleSelect":"Seleccione actividad anual","toContinue":"Para continuar debe indicar de que año fiscal desea cargar información de ubicaciones, población e información financiera"},"Actividad":{"title":"Actividad anual","locations":"Ubicaciones","population":"Población","financial":"Información financiera","places":"Sedes"},"Ubicaciones":{"title":"Ubicaciones","street":"Calle","number":"Número exterior","interiorNumber":"Número interior","cp":"Código Postal","street1":"Entre calle 1","street2":"y calle 2","reference":"Referencia","colony":"Colonia","town":"Delegación o municipio","city":"Ciudad","state":"Estado","selectObjective":"Actividad que desarrolla","typePopulation":"Número de personas atendidas","isSede":"Clasificación"},"Poblacion":{"title":"Población","panelAgeTitle":"Población por edad y sexo","panelEconomicTitle":"Población por nivel socioeconómico","panelLocationTitle":"Organizaciones apoyadas","age":"Edad y sexo","range":"Rango de edad","women":"Número de mujeres","men":"Número de hombres","other":"Número de otros géneros","socioeconomic":"Nivel Socioeconómico","economicRange":"Rango socioeconómico","peopleNumber":"Número de personas","organizations":"Número de organizaciones apoyadas","type":"Tipo de Donataria","etniesAttention":"En nuestra organización atendemos población indígena","specifyEtnies":"Especifique la(s) etnia(s) separadas por comas","recoveryFree":"En nuestra organización cobramos cuota de recuperación","donorType":"Tipo de donataria","average":"Especifique promedio o rango","atiendePoblacionIndigena":"¿Atiende población indígena?","siAtiendePoblacionIndigena":"(En caso de que si) Especifique la etnia","atiendePersonasDiscapacidad":"¿Atiende personas con discapacidad?","apoyaOtrasOrganizaciones":"¿Su organización apoya a otras organizaciones?","nombreOtrasOrganizaciones":"(En caso de que si) Nombre de la organización","tieneCriteriosSeleccion":"¿Poseen criterios de selección y procesos de admisión de los/as destinatarios/as de sus programas/proyectos?","criteriosSeleccionDestinataria":"(En caso de que si) ¿Cómo se seleccionan a las personas destinatarias de sus intervenciones?","noteCriteriosSeleccionDestinataria":"En tu respuesta incluye los criterios de seleción y el proceso de admisión. Por intervención social nos referimos al conjunto de servicios, proyectos y programas que opera tu organización. (400 caracteres)"},"Sedes":{"title":"Sedes","territorialScope":"Alcance territorial de la organización","territorialScopeOptions":["Internacional","Nacional","Estatal","Municipal","Local"],"numberLocations":"Cantidad de sedes con las que cuenta la organización","numberLocationsOptions":["1 sede","2 sedes","3-5 sedes","6-9 sedes","10 o más"],"geoInformationTitle":"Información geográfica de la/s sede/s de la organización","geoInformationSubtitle":"Sede","cp":"Código Postal","state":"Estado","town":"Delegación o municipio","city":"Ciudad","colony":"Colonia","street":"Calle","number":"Número exterior","interiorNumber":"Número interior","street1":"Entre calle 1","street2":"y calle 2","reference":"Referencia","selectObjective":"Actividad que desarrolla"},"Financiera":{"title":"Financiera","income":"Ingresos","input":"Aportación patronos/consejeros","associateFees":"Cuotas de asociados","physicalDonations":"Donativos personas físicas","businessDonations":"Donativos empresas","nmpDonations":"Donativos NMP","oscNational":"OSC nacionales","oscInternational":"OSC Internacionales","governmentDonations":"Donativos de gobierno","yieldFunds":"Rendimiento de fondos","yieldEquityFunds":"Rendimientos fondo patrimonial","leasingIncome":"Ingresos por arrendamiento","recoveryFees":"Cuotas de recuperación","productiveActivities":"Otras actividades productivas","otherActivities":"Otras actividades","descriptionOtherActivities":"Descripción de otras actividades","totalIncome":"Total ingresos:","assets":"Activos","currentAssets":"Activo circulante","noteCurrentAssets":"Aquellos que cumplen con alguna de las siguientes consideraciones: i) se espera realizar el activo, consumirlo o tiene la intención de venderlo en su ciclo normal de operación; ii) se espera realizar el activo dentro de los doce meses posteriores a la fecha del estado de situación financiera; iii) se mantiene el activo principalmente con fines de negociación; iv) o el activo es efectivo o equivalente de efectivo, a menos que este se encuentre restringido.","fixedAssets":"Activo fijo","noteFixedAssets":"Son activos tangibles, intangibles y financieros que, por su naturaleza, son recuperables a largo plazo; es decir, no son recuperables en el ciclo normal de operaciones.","deferredAssets":"Activo diferido","noteDeferredAssets":"Son pagos que la organización realiza de forma adelantada por un bien o servicio que se utilizará en las actividades de la misma.","totalAssets":"Total activos:","expenses":"Egresos","operatingExpenses":"Gastos operativos","administrativeExpenses":"Gastos administrativos","otherExpenses":"Otros gastos","fundraisingExpenses":"Gastos por recaudación de fondos","totalExpenditures":"Total egresos:","liabilities":"Pasivos","suppliers":"Proveedores","debtsToPay":"Cuentas por pagar","taxes":"Impuestos","subTotal":"Total pasivo circulante:","noteSubTotal":"Aquellos que cumplen con alguna de las siguientes consideraciones: i) se espera liquidar en el ciclo normal de operación de la entidad; ii) la entidad lo mantiene principalmente con el propósito de negociarlo; iii) se liquidará dentro de los doce meses posteriores a la fecha de cierre del periodo sobre el que se informa; iv) la entidad no tiene un derecho incondicional para posponer su liquidación durante, al menos, los doce meses posteriores a la fecha de cierre del periodo sobre el que se informa.","subTotalExpenses":"Subtotal egresos","otherPassives":"Otros pasivos","longTermLiabilities":"Pasivo largo plazo","noteLongTermLiabilities":"Se trata del pasivo no circulante o pasivo no corriente, y comprende las obligaciones a satisfacer en un plazo superior al ejercicio contable, es decir, más de un año.","heritage":"Capital (Patrimonio)","noteHerigate":"El patrimonio o capital contable es la parte residual de los activos una vez deducidos todos los pasivos e incluye las aportaciones realizadas, ya sea el momento de la constitución o en momentos posteriores, así como los resultados acumulados.","descriptions":"A continuación, describa los siguientes elementos según la información anterior","totalPassive":"Total pasivos + Capital (Patrimonio):","resultExcersice":"Resultado del ejercicio = ","incomeExpenses":"Ingresos - egresos","administrativeExpenditure":"Gastos administrativos = ","feesExpenses":"Gastos administrativos/Gastos operativos * 100","employeesNumber":{"title":"Cantidad de personas Remuneradas en la Organización","man":"# Hombres remunerados","woman":"# Mujeres remuneradas","other":"# Otros géneros remunerados","total":"Total"},"volunteersNumber":{"title":"Cantidad de voluntarios/as de la organización","man":"# Hombres voluntarios","woman":"# Mujeres voluntarias","other":"# Otros géneros voluntarios","total":"Total"},"transportEquipment":"Número de equipos de transporte","donationsSpecies":"Hemos recibido donativos en especie","specifyDonation":"Especifique donativo","approximateAmount":"Monto aproximado ($)","sustainability":"Sustentabilidad","selfSufficiency":"Autosuficiencia","selfSufficiencyNMP":"Autosuficiencia NMP","selfSufficiencyNMPvs":"Aportación NMP vs otros privados","liquidity":"Liquidez","capital":"Capital de trabajo","indebtedness":"Endeudamiento","leverage":"Apalancamiento","breach":"Incumplimientos Graves","visitInformation":"Información para visita"},"Resumen":{"title":"Enviar"}},"Oportunidades":{"Instrucciones":{"title":"Instrucciones"},"Convocatoria":{"title":"Convocatorias","participateButton":"Quiero participar","detailsButton":"Ver detalles","maxAmmount":"Monto autorizado","dateLimit":"Fecha límite","continueRequest":"Continuar solicitud"},"Proyectos":{"instructions":"Instrucciones","project":"Proyecto","item":"Monto solicitado","documents":"Documentos","sendCriterio":"Enviar criterios","sendRubros":"Enviar monto solicitado","summary":"Enviar","preauthorizedAmmount":"Monto máximo que puede solicitar: ","dateLimit":"Fecha límite: ","exportDoc":"Exportar proyecto"},"Rubros":{"title":"Montos solicitados para el proyecto","concept":"Concepto solicitado","justification":"Descripción detallada del concepto solicitado","ammount":"Monto ($)","type":"Rubro","support":"Documento soporte","maxAmmount":"Monto total solicitado","totalCost":"Costo total del proyecto","difference":"Diferencia","financialSources":"Mencione cuáles serían sus fuentes de financiamiento para completar el costo total del proyecto","resume":"Resumen de gastos","donors":"Donantes","detailsReference":"Ver detalles"}},"Evaluation":{"title":"Evaluaciones","results":"Resultados","send":"Enviar","returnToEvals":"Regresar a evaluaciones","ElegibilityCriteria":{"title":"Criterios de elegibilidad"},"EvaluationVariable":{"title":"Evaluaciones Variables","continueEvaluation":"Evaluaciones","evaluation":"Evaluación","variables":"Variables","initEval":"Origen de Evaluación","dateInit":"Fecha de llenado","dateValid":"Fecha de validación","dateVisit":"Fecha de visita","executive":"Ejecutivo","responsableGrantee":"Responsable donataria","evaluator":"Evaluador","pointsMax":"Puntos Máximos","pointsScored":"Puntos Obtenidos","results":"Resultado %","highPraise":"Ponderación","resultTotal":"Resultado Total","answers":"Respuestas","documents":"Documentos"}},"MonitoringStrength":{"title":"Monitoreo del proceso de Fortalecimiento","tipoFortalecimientoTitle":"Tipo de Fortalecimiento: Grupo","objetivosFortalecimiento":"Objetivos de Fortalecimiento y Plan de entregas","avancePlan":"Avance del Plan de trabajo","validacionEntregables":"Validacion de entregables","cambiosRelevantes":"Cambios relevantes de la intervención","enviar":"Enviar Correo","guardar":"Guardar","cierreProceso":"Cierre del proceso de monitoreo","nivelIntervencion":"Nivel de Intervención","fechaInicio":"Fecha de Inicio de Etapa","consultor":"Consultor","tipoFortalecimiento":"Tipo de Fortalecimiento","etapaFortalecimiento":"Etapa de Fortalecimiento","estatusFortalecimiento":"Estatus de Fortalecimiento","prioritaria":"Prioritaria","temaCapacitacion":"Tema de Capacitación","asistencia":"Asistencia","conocimientos":"Conocimientos Adquiridos","calidad":"Calidad del Servicio","otro":"Otro"},"Supervisor":{"Screen":{"supervisor":"Supervisor","executive":"Ejecutivo","status":"Estatus","size":"Tamaño","group":"Grupo","donataryGroup":"Grupo donataria","training":"Capacitación intervención"},"Status":{"stage":"Estatus etapa","comments":"Comentarios"}},"Valoracion":{"Contenedor":{"title":"Valoración de rubros","nav":["Rubros","Justificación de los rubros solicitados","Objetivos de desarrollo sostenible"],"columns":{"Items":["Concepto","Justificación","Monto","Tipo de gasto","Documento"],"Valuation":["Rubro","Concepto","Monto solicitado","Monto justificado","Justificación","¿La necesidad de lo solicitado será utilizado para la prestación de servicios o bienes de la población?","¿Cuenta con un plan de trabajo o procuración de fondos que avale la realización del proyecto?","Justificación del rubro"],"SustainableGoals":["Objetivo de desarrollo sostenible"],"Themes":["Tema","Subtema 1","Subtema 2","Servicios","Enfoque"]}},"Items":{"maxAmmount":"Monto máximo a solicitar","projectCost":"Costo total del proyecto","diference":"Diferencia","sources":"Fuentes de financiamiento para completar el costo total del proyecto"},"Requested":{"GeneralQuestions":"Preguntas generales","congruent":"¿El donativo solicitado es congruente con el objeto asistencial de la institución y el objetivo del proyecto?","requested":"¿Lo solicitado contribuye a generar los cambios esperados en la población objetivo y son congruentes con las actividades y metas planteadas?","identified":"¿Se tiene identificada a la población que recibirá los servicios establecidos en el proyecto?","justify":"Justifica","items":"Rubros","need":"¿Lo solicitado será utilizado para la prestación de servicios o bienes de la población?","plan":"¿Cuenta con un plan de trabajo o procuración de fondos que avale la realización del proyecto?","review":"¿Requiere revisión de otras áreas?","justificationRequest":"Justificación de la solicitud","noJustify":"Causa de no justificación"},"Sustainable":{"objectives":"¿Los objetivos de desarrollo sostenible y metas a los que contribuye el proyecto elegidos por la institución son correctos?","goals":"Objetivo de desarrollo sostenible","objectiveGoal":"Meta de objetivo de desarrollo sostenible","coverage":"Indicador de cobertura","institutionGoal":"Meta de la institución","results":"Indicador de resultados"},"comments":"Comentarios"},"Certificate":{"Contenedor":{"title":"Certificado de Asignación","button":"Generar"},"HeaderCertificate":{"logotipo":"Logotipo","Textos":["Texto 1","Texto 2","Texto 3","Texto 4","Texto 5","Texto 6","Texto 7","Texto 8"]},"Signs":{"title":"Título","puesto":"Puesto","nombre":"Nombre","paterno":"Apellido Paterno","materno":"Apellido Materno","Firmas":["Firma 1","Firma 2"],"sign":"Firma","button":"Guardar firma"}},"Requirements":{"Container":{"Tab1":"Documentos y Representante Legal","Tab2":"Contratos","Tab3":"Requisitos de pago","InfoMessage":"En breve recibirá un correo con las indicaciones para actualizar sus datos"},"Documents":{"Documents":"Documentos","DocumentName":"Nombre","Checked":"Revisado"},"LegalRep":{"title":"Representante Legal","Name":"Nombre completo","Type":"Tipo de poder","Writing":"Escritura","Notary":"Notario","NotaryPlace":"Notaría","Validity":"Vigencia","SelectInput":"¿El o los representantes legales son correctos?"},"Contracts":{"CVE":"Id","Contract":"Contrato","Download":"Descargar","SignedContract":"Contrato firmado","AddContract":"Agregar contrato"},"Requirements":{"id":"Id","Requirement":"Requisito","Attached":"Documento","Delivered":"Entregó","Bank":"Banco","Clabe":"Clabe","Monto":"Monto a entregar","Receipt":"No. de recibo","Reference":"Referencia","ReceiptDoc":"Recibo PDF","XMLDoc":"Recibo XML","Validate":"Validar pago","MontoMaximo":"Monto Autorizado"},"Financial":{"Id":"Id","Bank":"Banco","Clabe":"Clabe","References":"Monto a entregar","NoReceipt":"No. de recibo","ReceiptPDF":"Recibo PDF","ReceiptXML":"Recibo XML"}},"ProgramPerformance":{"title":"Desempeño del programa financiado","columns":{"Indicadores":["Criterio","Nivel de cumplimiento","Observaciones"],"Valoracion":["Criterio","Nivel de cumplimiento"]},"criteria":{"first_criteria":"1. Resultados del programa financiado.","second_criteria":"2. Aprendizajes y toma de decisiones","third_criteria":"3. Promoción de los Derechos Humanos y Potencial de Sostenibilidad","fourth_criteria":"4. Distribución de gasto.","five_criteria":"5. Acciones de mejora.","finalAssessment":"Valoración final"},"form":{"estatus":"Estatus","nivelDesempeno":"Nivel de desempeño","recomendacionesTitle":"Recomendaciones","recomendaciones":"Enlista las recomendaciones y propuestas de mejora identificadas en el análisis de los resultados y niveles de desempeño"},"title1":"Resultados evaluación Desempeño del programa financiado","performanceLevel":"Nivel de desempeño"},"ResultsReport":{"tab1":"1. Resultados del programa financiado","tab2":"2. Aprendizajes y toma de decisiones","tab3":"3. Promoción de los Derechos Humanos y Potencial de Sostenibilidad","tab4":"4. Distribución de gasto","tab5":"5. Acciones de mejoras","titleTable":"Objetivo de Desarrollo Sostenible","ProgramResults":{"title1":"1.1 Indicadores de Resultados","title2":"Evidencias de los Indicadores","question2":"1.2 Describa brevemente la metodología utilizada para la evaluación de resultados de este programa/proyecto(indicadores prioritarios y opcionales)","question3":"1.3 Describa brevemente las actividades implementadas en el programa/proyecto durante el período de financiamiento","question4":"1.4 ¿Cuáles fueron los resultados más significativos de la implementación de su programa/proyecto durante el período de financiamiento ?","question5":"1.5 ¿Qué aspectos de su gestión(actividades, recursos, capacidad operativa, contenidos, liderazgo de las personas atendidas, metodología, etc) fueron más determinantes para que se lograran estos resultados?","question6":"1.6 ¿Qué resultados considera que no se lograron o no se cumplieron de acuerdo a sus metas? ¿Por qué?","question7":"1.7 ¿Existió algún tipo de efecto(s) del programa/proyecto que no estaba previsto y que lo afectara de manera positiva o negativa? *Se refiere a los efectos en la población, por ejemplo, situaciones de violencia de género derivadas del empoderamiento económico de mujeres indigenas.","question8":"1.8 En proyección, ¿Qué resultados esperan alcanzar el siguiente año, que sean consecuencia o que estén vínculados a los avances de este periodo?","goalGoals":"Metas de Objetivos de Desarrollo Sostenible","indicators":"Indicadores","goalAchieved":"Meta alcanzada","attachEvidence":"Adjuntar evidencia"},"LessonDecision":{"questionLesson21":"2.1 De acuerdo a la evaluación de su programa/ proyecto, ¿Cuáles fueron las principales conclusiones o aprendizajes a los que llegó la institución sobre su desempeño?","questionLesson22":"2.2 ¿Qué cambios, ajustes o mejoras planea implementar el próximo año de acuerdo a los aprendizajes obtenidos de su evaluación?"},"PromotionHumanRights":{"questionPromotion31":"3.1 ¿De qué forma este programa/proyecto permite que las personas participantes ejerzan sus derechos humanos?","questionPromotion32":"3.2 ¿Qué actividades en especifico se llevan a cabo para promover el ejercicio de los derechos humanos?","questionPromotion33":"3.3 ¿El programa/proyecto promueve explicitamente el protagonismo de las personas en su propio desarrollo y en el liderazgo de la intervención? ¿Cómo lo hace y cuales han sido sus principales logros?","questionPromotion34":"3.4 Durante la implementación de este programa/proyecto, ¿Con qué otros actores se vincularon para mejorar los resultados y la promoción de los derechos humanos? ¿Cuál fue su rol?","idPromotion":"ID","nameInstitution":"Nombre de la institución, OSC, empresa o persona aliada","descriptionSupport":"Descripción del apoyo"},"DistributionExpenditure":{"title1":"4.1 Complete la siguiente tabla con los montos asignados en relación a las metas específicas de los Objetivos de Desarrollo Sostenible elegidos","title2":"4.1 Gastos reales por rubro e inversionista","developmentGoal":"Objetivo de Desarrollo Sostenible","goalGoals":"Metas de Objetivos de Desarrollo Sostenible","numberParticipants":"Número de participantes","assignedResource":"Recurso Asignado","totalResource":"Total recurso asignado","rubro":"Rubro","amountExercised":"Monto Ejercido","concept":"Concepto Editado","proofExpenses":"Comprobantes de Gastos","questionDistribution":"Explica a que se deben las diferencias entre las cantidades entregadas y ejercidas por cada concepto","questionDistribution43":"4.2 ¿Considera que los recursos aplicados fueron utilizados de manera eficiente? ¿Por qué? ¿Qué mejoras realizaria?"},"ImprovementActions":{"questionImprovement51":"5.1 ¿De qué manera ha atendido a las recomendaciones de mejora que se dieron a la IAP en su solicitud de financiamiento?","questionImprovement52":"5.2 ¿Cómo ha mejorado la atención que le da a su población el atender a estas recomendaciones?"},"Breakdown":{"objectives":"Objetivo de desarrollo de desarrollo sostenible","goal":"Meta","indicator":"Indicador","subtitle1":"Servicios de alimentación (PERSONAS)","subtitle2":"Servicios de alimentación (HOGARES)"},"checkInfo":"Manifestamos que la institución cuenta con toda la información y documentos que respaldan la aplicación correcta del recurso, misma que está disponible cuando el Nacional Monte de Piedad lo requiera para efectos de revisión y/o auditoria","saveInfo":"Guardar y continuar","report":"Reporte","modalQuestion":["Favor de ingresar la información correspondiente a los resultados del programa/proyecto financiado del año en curso.\n La información presentada en este formato deberá contener un resumen con los datos cuantitativos y la narrativa cualitativa más\n destacable de sus logros, así como de los obstáculos y facilitadores clave del desempeño.\n","Adicionalmente como archivos adjuntos se ","deberán ingresar los documentos comprobatorios o de desglose de resultados\n (máximo 3), ","estos pueden ser: reporte de evaluación (interna o externa) del programa, tableros de indicadores, informes\n anuales de actividades, etc.\n","Para resolver cualquier duda comuniquese con su ejecutivo(a) de inversión social asignado.\n","De acuerdo a los Objetivos de Desarrollo Sostenible, las metas y los indicadores elegidos para rendición de cuentas de su\n programa, ingrese los datos correspondientes a las metas y logros alcanzados.\n","Los indicadores de resultado prioritarios para rendir cuentas son los vinculados a los Objetivos de Desarrollo Sostenible, sin\n embargo la donataria podrá también reportar aquellos que consideró pertinentes desde su solicitud de donativo, aún cuando\n se encuentre desarrollando o perfeccionando su metodologia de evaluación.\n","En ","las tablas de la columna 'Desgloce' ","se encuentran los indicadores (principalmente de Resultados) que se cargarán en el\n sistema. Al dar click en Llenar tabla se desplegará una matriz para ingresar los datos de acuerdo al indicador.\n","De click en el botón 'Agregar' en la sección Evidencia se abrirá la opción de cargar archivos digitales que evidencien el\n seguimiento que se ha dado a los indicadores. Por ejemplo: muestras de instrumentos para recolección de información.\n","Podrá cargar un máximo de 5 archivos que no superen los 10MB en conjunto."]},"IntegralValuation":{"title":"Valoración integral","run":"Ejecutar","publish":"Publicar","valuationSelection":"Selección de Valoración","valuationComments":"Comentarios a la Valoración","goalNMP":"Objetivo de NMP","executiveObservations":"Observaciones del ejecutivo","evaluations":"Evaluaciones"},"PreDonation":{"Calculation":{"title":"Cálculo donativo Pre"},"Approval":{"title":"Aprobación donativo Pre"}},"ValidacionTelefono":"Se enviará confirmación de Reporte al siguiente E-mail","successReport":"Solicitud exitosa","successErrorReport":"Favor de llenar los campos requeridos"}

/***/ }),

/***/ 216:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.clearQuestionProject = exports.updateQuestionProject = exports.deleteQuestionProject = exports.getQuestionsProject = exports.getQuestionProject = exports.getHelpVideoByQuestion = exports.searchQuestionProject = exports.addQuestionProject = exports.ACTION_UPDATE_QUESTION_PROJECT = exports.ACTION_DELETE_QUESTION_PROJECT = exports.ACTION_GET_HELP_VIDEO_QUESTION = exports.ACTION_GET_QUESTION_PROJECT = exports.ACTION_SEARCH_QUESTION_PROJECT = exports.ACTION_NEW_QUESTION_PROJECT = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _Utils = __webpack_require__(2);

var Utils = _interopRequireWildcard(_Utils);

var _ClientHttpRequest = __webpack_require__(5);

var _ClientHttpRequest2 = _interopRequireDefault(_ClientHttpRequest);

var _immutable = __webpack_require__(1);

var _immutable2 = _interopRequireDefault(_immutable);

var _Modal = __webpack_require__(4);

var _Loading = __webpack_require__(3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var initialState = _immutable2.default.Map({}).set('Search', new _immutable2.default.List([])).set('Response', new _immutable2.default.Map({})).set('Get', new _immutable2.default.Map({})).set('HelpVideo', new _immutable2.default.Map(null));

/* Types */

var ACTION_NEW_QUESTION_PROJECT = exports.ACTION_NEW_QUESTION_PROJECT = 'ACTION_NEW_QUESTION_PROJECT';

var ACTION_SEARCH_QUESTION_PROJECT = exports.ACTION_SEARCH_QUESTION_PROJECT = 'ACTION_SEARCH_QUESTION_PROJECT';

var ACTION_GET_QUESTION_PROJECT = exports.ACTION_GET_QUESTION_PROJECT = 'ACTION_GET_QUESTION_PROJECT';

var ACTION_GET_HELP_VIDEO_QUESTION = exports.ACTION_GET_HELP_VIDEO_QUESTION = 'ACTION_GET_HELP_VIDEO_QUESTION';

var ACTION_DELETE_QUESTION_PROJECT = exports.ACTION_DELETE_QUESTION_PROJECT = 'ACTION_DELETE_QUESTION_PROJECT';

var ACTION_UPDATE_QUESTION_PROJECT = exports.ACTION_UPDATE_QUESTION_PROJECT = 'ACTION_UPDATE_QUESTION_PROJECT';

/* Reducer */

exports.default = function () {
	var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	var action = arguments[1];


	switch (action.type) {
		case ACTION_NEW_QUESTION_PROJECT:
			return state.set('Response', new _immutable2.default.Map(action.Obj));
		case ACTION_SEARCH_QUESTION_PROJECT:
			return state.set('Search', new _immutable2.default.List(action.Obj));
		case ACTION_GET_QUESTION_PROJECT:
			return state.set('Get', new _immutable2.default.Map(action.Obj));
		case ACTION_DELETE_QUESTION_PROJECT:
			return state.set('Response', new _immutable2.default.Map(action.Obj));
		case ACTION_UPDATE_QUESTION_PROJECT:
			return state.set('Response', new _immutable2.default.Map(action.Obj));
		case ACTION_GET_HELP_VIDEO_QUESTION:
			return state.set('HelpVideo', new _immutable2.default.Map(action.Obj));
		default:
			return state;
	}
};

/* Action Creators */

var addQuestionProject = exports.addQuestionProject = function addQuestionProject(form) {

	return function (dispatch) {

		dispatch((0, _Loading.isLoading)(true));

		return new _ClientHttpRequest2.default({
			service: 'api/newQuestionProject',
			method: "POST",
			data: _extends({}, form),
			headers: Object.assign({ "Authorization": sessionStorage.access_token, "uid": sessionStorage.uid })
		}).request().then(function (response) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch({ type: ACTION_NEW_QUESTION_PROJECT, Obj: response.data });
			dispatch((0, _Modal.createModal)(Utils.successMessage()));
		}).catch(function (error) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
			throw error;
		});
	};
};

var searchQuestionProject = exports.searchQuestionProject = function searchQuestionProject(form) {

	Utils.clearNullAndEmpty(form);

	return function (dispatch) {

		dispatch((0, _Loading.isLoading)(true));

		return new _ClientHttpRequest2.default({
			service: 'api/searchParamQuestionProject',
			method: "POST",
			data: _extends({}, form),
			headers: Object.assign({ "Authorization": sessionStorage.access_token, "uid": sessionStorage.uid })
		}).request().then(function (response) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch({ type: ACTION_SEARCH_QUESTION_PROJECT, Obj: response.data });
		}).catch(function (error) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
			throw error;
		});
	};
};

var getHelpVideoByQuestion = exports.getHelpVideoByQuestion = function getHelpVideoByQuestion(id) {

	return function (dispatch) {
		return new _ClientHttpRequest2.default({
			service: 'api/getHelpVideoByQuestion',
			method: "POST",
			data: { id: id },
			headers: Object.assign({ "Authorization": sessionStorage.access_token, "uid": sessionStorage.uid })
		}).request().then(function (response) {
			dispatch({ type: ACTION_GET_HELP_VIDEO_QUESTION, Obj: response.data });
		}).catch(function (error) {
			dispatch({ type: ACTION_GET_HELP_VIDEO_QUESTION, Obj: null });
			throw error;
		});
	};
};

var getQuestionProject = exports.getQuestionProject = function getQuestionProject(id) {

	return function (dispatch) {

		dispatch((0, _Loading.isLoading)(true));

		return new _ClientHttpRequest2.default({
			service: 'api/getQuestionProject',
			method: "POST",
			data: { id: id },
			headers: Object.assign({ "Authorization": sessionStorage.access_token, "uid": sessionStorage.uid })
		}).request().then(function (response) {
			if (response.data.pregunta.includes('|')) {
				var d = response.data.pregunta.split('|');
				response.data.pregunta = d[0];
				response.data.long = d[1];
			}
			dispatch({ type: ACTION_GET_QUESTION_PROJECT, Obj: response.data });
			dispatch((0, _Loading.isLoading)(false));
		}).catch(function (error) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
			throw error;
		});
	};
};

var getQuestionsProject = exports.getQuestionsProject = function getQuestionsProject(id) {

	return function (dispatch) {

		dispatch((0, _Loading.isLoading)(true));
		dispatch({ type: ACTION_GET_QUESTION_PROJECT, Obj: {} });

		return new _ClientHttpRequest2.default({
			service: 'api/getQuestionsProject',
			method: "POST",
			data: { id: id },
			headers: Object.assign({ "Authorization": sessionStorage.access_token, "uid": sessionStorage.uid })
		}).request().then(function (response) {
			response.data.forEach(function (item, i) {
				item.pregunta = item.pregunta.slice(0, item.pregunta.length - 4);
				item.pregunta = item.pregunta.replace('|', '');
				if (!item.seccion) item.seccion = 'Preguntas generales';
			});
			dispatch({ type: ACTION_SEARCH_QUESTION_PROJECT, Obj: response.data });
			dispatch((0, _Loading.isLoading)(false));
		}).catch(function (error) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
			throw error;
		});
	};
};

var deleteQuestionProject = exports.deleteQuestionProject = function deleteQuestionProject() {
	return function (dispatch) {
		return dispatch({ type: ACTION_DELETE_QUESTION_PROJECT, Obj: { code: '', message: '' } });
	};
};

var updateQuestionProject = exports.updateQuestionProject = function updateQuestionProject(form) {

	return function (dispatch) {

		dispatch((0, _Loading.isLoading)(true));
		dispatch({ type: ACTION_GET_QUESTION_PROJECT, Obj: {} });

		return new _ClientHttpRequest2.default({
			service: 'api/updateQuestionProject',
			method: "POST",
			data: _extends({}, form),
			headers: Object.assign({ "Authorization": sessionStorage.access_token, "uid": sessionStorage.uid })
		}).request().then(function (response) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch({ type: ACTION_UPDATE_QUESTION_PROJECT, Obj: response.data });
			dispatch((0, _Modal.createModal)(Utils.successMessage()));
		}).catch(function (error) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
			throw error;
		});
	};
};

var clearQuestionProject = exports.clearQuestionProject = function clearQuestionProject() {
	return function (dispatch) {
		dispatch({ type: ACTION_GET_QUESTION_PROJECT, Obj: {} });
		dispatch({ type: ACTION_SEARCH_QUESTION_PROJECT, Obj: [] });
	};
};

/***/ }),

/***/ 3:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.isLoading = exports.DEC_COUNTER = exports.INC_COUNTER = undefined;

var _immutable = __webpack_require__(1);

var _immutable2 = _interopRequireDefault(_immutable);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var initialState = _immutable2.default.Map({}).set('isLoading', false).set('counter', 0);

/* Types */
var INC_COUNTER = exports.INC_COUNTER = 'INC_COUNTER';
var DEC_COUNTER = exports.DEC_COUNTER = 'DEC_COUNTER';

/* Reducer */

exports.default = function () {
	var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	var action = arguments[1];

	var counter = void 0;
	switch (action.type) {
		case INC_COUNTER:
			counter = state.get('counter') + 1;
			if (counter) {
				return state.set('counter', counter).set('isLoading', true);
			} else {
				return state.set('counter', counter);
			}
		case DEC_COUNTER:
			counter = state.get('counter') - 1;
			if (!counter) {
				return state.set('counter', counter).set('isLoading', false);
			} else {
				return state.set('counter', counter);
			}
		default:
			return state;
	}
};

/* Action Creators */


var isLoading = exports.isLoading = function isLoading(flag) {
	return function (dispatch) {
		if (flag) {
			dispatch({ type: INC_COUNTER });
		} else {
			dispatch({ type: DEC_COUNTER });
		}
	};
};

/***/ }),

/***/ 389:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _reactBootstrapTable = __webpack_require__(497);

var _CheckBoxGroup = __webpack_require__(392);

var _CheckBoxGroup2 = _interopRequireDefault(_CheckBoxGroup);

var _RadioButtonGroup = __webpack_require__(397);

var _RadioButtonGroup2 = _interopRequireDefault(_RadioButtonGroup);

var _moment = __webpack_require__(215);

var _moment2 = _interopRequireDefault(_moment);

var _reactBootstrap = __webpack_require__(103);

var _Utils = __webpack_require__(2);

var Utils = _interopRequireWildcard(_Utils);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _numeral = __webpack_require__(393);

var _numeral2 = _interopRequireDefault(_numeral);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_moment2.default.locale();

var TableData = function TableData(_ref) {
  var id = _ref.id,
      onClickEdit = _ref.onClickEdit,
      onClickRemove = _ref.onClickRemove,
      onClickProcess = _ref.onClickProcess,
      onClickView = _ref.onClickView,
      onClickComponent = _ref.onClickComponent,
      create = _ref.create,
      process = _ref.process,
      edit = _ref.edit,
      remove = _ref.remove,
      state = _ref.state,
      document = _ref.document,
      equalSize = _ref.equalSize,
      toggleTableAll = _ref.toggleTableAll,
      page = _ref.page,
      cellEditCheck = _ref.cellEditCheck,
      onBeforeSaveCell = _ref.onBeforeSaveCell,
      onAfterSaveCell = _ref.onAfterSaveCell,
      selectRowCheck = _ref.selectRowCheck,
      onRowSelect = _ref.onRowSelect,
      onSelectAll = _ref.onSelectAll,
      selected = _ref.selected,
      sizePerPage = _ref.sizePerPage,
      pageStartIndex = _ref.pageStartIndex,
      paginationSize = _ref.paginationSize,
      data = _ref.data,
      columns = _ref.columns,
      disabled = _ref.disabled,
      search = _ref.search,
      multiColumnSearch = _ref.multiColumnSearch,
      footer = _ref.footer,
      footerData = _ref.footerData,
      expandableRow = _ref.expandableRow,
      expandComponent = _ref.expandComponent,
      expandColumnOptions = _ref.expandColumnOptions,
      isNoPagination = _ref.isNoPagination,
      onClickEtapas = _ref.onClickEtapas,
      rowSpan = _ref.rowSpan,
      custom = _ref.custom,
      onClickCustom = _ref.onClickCustom,
      rangosAsignar = _ref.rangosAsignar,
      onClickRangosyAsignar = _ref.onClickRangosyAsignar,
      selecion = _ref.selecion,
      onClickSelecion = _ref.onClickSelecion,
      arrayLink = _ref.arrayLink,
      onClickArrayLink = _ref.onClickArrayLink,
      arrayChange = _ref.arrayChange,
      onClickChangeLink = _ref.onClickChangeLink,
      customStyle = _ref.customStyle,
      certificate = _ref.certificate,
      onClickCertificate = _ref.onClickCertificate,
      ajuste = _ref.ajuste,
      onClickAjuste = _ref.onClickAjuste,
      onClickArrayLinkRadioCheck = _ref.onClickArrayLinkRadioCheck,
      upload = _ref.upload,
      onClickUpload = _ref.onClickUpload,
      onClickContract = _ref.onClickContract,
      createModal = _ref.createModal,
      viewDocument = _ref.viewDocument,
      viewDocumentReporte = _ref.viewDocumentReporte,
      trClassName = _ref.trClassName,
      idRole = _ref.idRole,
      customToggle = _ref.customToggle,
      disabledCheck = _ref.disabledCheck,
      labelEdit = _ref.labelEdit,
      _ref$disableSlideTop = _ref.disableSlideTop,
      disableSlideTop = _ref$disableSlideTop === undefined ? false : _ref$disableSlideTop,
      _ref$deletedKey = _ref.deletedKey,
      deletedKey = _ref$deletedKey === undefined ? "deleted" : _ref$deletedKey,
      view = _ref.view;

  var handleChange = function handleChange(e, row) {
    var validation = false; // eslint-disable-line

    Array.from(e.target.files).forEach(function (f) {
      if (f.type !== 'application/pdf') {
        e.target.value = '';
        validation = true;

        createModal(Utils.warningMessage('Únicamente archivos en formato PDF'));
      } else {
        if (onClickUpload) onClickUpload(e, row);
      }
    });
  };

  var createCustomSearchField = function createCustomSearchField() {
    return _react2.default.createElement(_reactBootstrapTable.SearchField, { className: 'custom-searchfield', placeholder: 'Buscar' });
  };

  var createCustomClearButton = function createCustomClearButton(onClick) {
    return _react2.default.createElement(
      'button',
      { className: 'btn btn-primary', onClick: onClick },
      'Limpiar b\xFAsqueda'
    );
  };

  var renderShowsTotal = function renderShowsTotal(start, to, total) {
    return _react2.default.createElement(
      'p',
      null,
      start,
      ' a ',
      to,
      ' de ',
      total
    );
  };

  var cellEditProp = {
    mode: 'click',
    blurToSave: true,
    beforeSaveCell: onBeforeSaveCell,
    afterSaveCell: onAfterSaveCell
  };

  var selectRowPropCheck = {
    mode: 'checkbox',
    clickToSelect: false,
    selected: selected ? selected : [],
    onSelect: onRowSelect,
    onSelectAll: onSelectAll
  };

  if (disabledCheck == true) {
    var keysDisabled = [];
    for (var key in data) {
      keysDisabled.push(data[key].id);
    }
    selectRowPropCheck.unselectable = keysDisabled;
  }

  var tableOptions = {
    page: page || 1,
    sizePerPage: sizePerPage || 10,
    pageStartIndex: pageStartIndex || 1,
    paginationSize: paginationSize || 5,
    prePage: '<',
    nextPage: '>',
    paginationShowsTotal: renderShowsTotal,
    paginationPosition: 'bottom',
    withoutNoDataText: false,
    noDataText: create ? ' ' : 'No hay registros por mostrar',
    hideSizePerPage: true,
    searchField: createCustomSearchField,
    clearSearch: true,
    clearSearchBtn: createCustomClearButton,
    expandRowBgColor: 'rgba(201, 201, 201, 0.2)',
    expanding: toggleTableAll,
    expandBy: 'column'
  };

  var tableColumns = [];

  columns.map(function (option, key) {
    var itemConfig = {
      dataField: option.id,
      dataSort: option.sort,
      starHide: option.stars,
      headerAlign: option.headerAlign ? option.headerAlign : 'left',
      dataAlign: option.dataAlign ? option.dataAlign : 'left',
      editable: option.editable ? option.editable : false,
      className: option.className ? option.className : option.index ? 'table-column-id' : option.columnaTipo ? 'table-column-type' : option.starHide ? 'table-column-hide' : 'table-column-data',
      columnClassName: option.columnClassName ? option.columnClassName : option.index ? 'table-column-id' : option.columnaTipo ? 'table-column-type' : 'table-column-data',
      key: key,
      hidden: option.hidden,
      row: option.row,
      rowSpan: option.rowSpan,
      colSpan: option.colSpan,
      width: option.width ? option.width : null,
      expandable: option.expandable
    };

    tableColumns.push(_react2.default.createElement(
      _reactBootstrapTable.TableHeaderColumn,
      _extends({}, itemConfig, {
        dataFormat: function dataFormat(cell, row) {
          var field = '';

          if (option.type === 'simple') {
            field = row[option.id];
          } else if (option.type === 'object') {
            field = row[[option.object]] ? row[[option.object]][option.id] : '';
          } else if (option.type === 'currency') {
            field = (0, _numeral2.default)(row[option.id]).format('$ 0,0.00');
          } else if (option.type === 'percentage') {
            field = row[option.id] + ' %';
          } else if (option.type === 'date') {
            var date = row[option.id];
            field = 'No existe la fecha';
            if (date) {
              if (typeof date == 'string') {
                field = (0, _moment2.default)(date.substr(0, 10), 'YYYY-MM-DD').format('DD/MM/YYYY');
              }
            }
          } else if (option.type === 'datetime') {
            var _date = row[option.id];
            field = 'No existe la fecha';
            if (_date) {
              if (typeof _date == 'string') {
                field = (0, _moment2.default)(_date.substr(0, 19), 'YYYY-MM-DD hh:mm:ss').format('DD/MM/YYYY hh:mm:ss');
              }
            }
          } else if (option.type === 'doc-link') {
            field = _react2.default.createElement(
              'a',
              {
                href: '#',
                onClick: function onClick() {
                  onClickView(row[option.id]);
                }
              },
              _react2.default.createElement('i', { className: 'fa fa-paperclip' }),
              '\xA0',
              'Ver'
            );
          } else if (option.type === 'readOnlyCheck') {
            field = _react2.default.createElement(
              'span',
              { className: 'table-icons check' },
              row[option.id] === true ? _react2.default.createElement('i', { className: 'fa fa-check-square' }) : '-'
            );
          } else if (option.type === 'checkbox') {
            field = _react2.default.createElement(_CheckBoxGroup2.default, {
              id: option.nameOption,
              disabled: option.disabled ? option.disabled : false,
              options: [{ name: option.nameOption, checked: row[option.nameOption] }],
              onChange: function onChange(e) {
                onClickComponent(e, 'checkbox', row);
              }
            });
          } else if (option.type === 'radio') {
            field = _react2.default.createElement(_RadioButtonGroup2.default, {
              id: option.nameOption,
              disabled: option.disabled ? option.disabled : false,
              name: id ? id + '_' + option.nameOption : row.id + '_' + option.nameOption,
              value: row[option.nameOption],
              options: [{ value: row[option.nameOption], label: '' }],
              onChange: function onChange(e) {
                onClickComponent(e, 'radio', row);
              }
            });
          } else if (option.type === 'radio_registro') {
            if (row.firmara) {
              field = _react2.default.createElement(
                'span',
                null,
                _react2.default.createElement(
                  'a',
                  { href: '', disabled: true },
                  _react2.default.createElement('i', { className: 'fa fa-check-square-o' }),
                  ' ',
                  'Firmara'
                )
              );
            } else {
              field = _react2.default.createElement(_RadioButtonGroup2.default, {
                id: option.nameOption,
                disabled: row.function === "Mancomunado" ? true : false,
                name: id ? id + '_' + option.nameOption : row.id + '_' + option.nameOption,
                value: row[option.nameOption],
                options: [{ value: row[option.nameOption], label: '' }],
                onChange: function onChange(e) {
                  onClickComponent(e, 'radio', row);
                }
              });
            }
          } else if (option.type === 'contrato') {
            field = _react2.default.createElement(
              'span',
              null,
              _react2.default.createElement(
                'a',
                { href: '#', onClick: function onClick() {
                    return onClickContract(row);
                  } },
                _react2.default.createElement('i', { className: 'fa fa-download' }),
                ' ',
                'Generar contrato'
              )
            );
          } else if (option.type === 'reciboPDF') {
            field = _react2.default.createElement(
              'div',
              null,
              disabled && _react2.default.createElement(
                'label',
                null,
                _react2.default.createElement(
                  'span',
                  { className: 'a-href' },
                  _react2.default.createElement('input', {
                    name: 'reciboDocumento',
                    accept: 'application/pdf',
                    type: 'file',
                    style: { display: 'none' },
                    onChange: function onChange(e) {
                      e.preventDefault();
                      onClickUpload(e, row);
                    }
                  }),
                  ' ',
                  row[option.id] ? _react2.default.createElement(
                    'div',
                    null,
                    _react2.default.createElement('i', { className: 'fa fa-refresh' }),
                    ' Actualizar'
                  ) : _react2.default.createElement(
                    'div',
                    null,
                    _react2.default.createElement('i', { className: 'fa fa-upload' }),
                    ' Subir'
                  )
                )
              ),
              '\xA0',
              _react2.default.createElement(
                'label',
                null,
                _react2.default.createElement(
                  'span',
                  null,
                  _react2.default.createElement(
                    'a',
                    {
                      href: '#',
                      className: !row[option.id] ? 'disabled' : '',
                      onClick: function onClick() {
                        onClickView(row[option.id]);
                      }
                    },
                    _react2.default.createElement('i', { className: 'fa ' + (!row[option.id] ? 'fa fa-eye-slash' : 'fa fa-eye') }),
                    '\xA0',
                    'Ver'
                  )
                )
              )
            );
          } else if (option.type === 'XML') {
            field = _react2.default.createElement(
              'div',
              null,
              disabled && _react2.default.createElement(
                'label',
                null,
                _react2.default.createElement(
                  'span',
                  { className: 'a-href' },
                  _react2.default.createElement('input', {
                    name: 'xmlDocumento',
                    accept: 'text/xml',
                    type: 'file',
                    style: { display: 'none' },
                    onChange: function onChange(e) {
                      e.preventDefault();
                      onClickUpload(e, row);
                    }
                  }),
                  ' ',
                  row[option.id] ? _react2.default.createElement(
                    'div',
                    null,
                    _react2.default.createElement('i', { className: 'fa fa-refresh' }),
                    ' Actualizar'
                  ) : _react2.default.createElement(
                    'div',
                    null,
                    _react2.default.createElement('i', { className: 'fa fa-upload' }),
                    ' Subir'
                  )
                )
              ),
              '\xA0',
              _react2.default.createElement(
                'label',
                null,
                _react2.default.createElement(
                  'span',
                  null,
                  _react2.default.createElement(
                    'a',
                    {
                      href: '#',
                      className: !row[option.id] ? 'disabled' : '',
                      onClick: !row[option.id] ? function () {
                        onClickUpload(row);
                      } : function () {
                        onClickView(row[option.id]);
                      }
                    },
                    _react2.default.createElement('i', { className: 'fa ' + (!row[option.id] ? 'fa fa-eye-slash' : 'fa fa-eye') }),
                    '\xA0',
                    'Ver'
                  )
                )
              )
            );
          } else if (option.type === 'href') {
            field = _react2.default.createElement(
              'span',
              null,
              _react2.default.createElement(
                'a',
                {
                  href: '#',
                  className: row.estadoCambioDestinoId == 2 || row.estadoCambioDestinoId == null ? 'float-left' : 'clean-link',
                  onClick: function onClick() {
                    onClickView(row);
                  }
                },
                ' ',
                row[option.id],
                ' '
              )
            );
          } else if (option.type === 'star') {
            var fieldStars = [];

            for (var index = 1; index <= row.stars; index++) {
              fieldStars.push(_react2.default.createElement(
                'span',
                null,
                _react2.default.createElement('i', { className: 'fa fa-star' })
              ));
            }

            for (var _index = row.stars; _index < 5; _index++) {
              fieldStars.push(_react2.default.createElement(
                'span',
                null,
                _react2.default.createElement('i', { className: 'fa fa-star-o' })
              ));
            }

            field = _react2.default.createElement(
              'div',
              null,
              fieldStars
            );
          }
          return field;
        }
      }),
      option.name
    ));
  });

  if (state) {
    tableColumns.push(_react2.default.createElement(
      _reactBootstrapTable.TableHeaderColumn,
      {
        headerAlign: 'right',
        dataAlign: 'right',
        key: 2,
        dataField: 'deleted',
        className: 'table-column-state',
        columnClassName: 'table-column-state',
        editable: false,
        dataFormat: function dataFormat(cell, row) {
          var fieldDeleted = _react2.default.createElement(
            'div',
            null,
            row[deletedKey] ? 'Inactivo' : 'Activo'
          );

          var fieldEstado = _react2.default.createElement(
            'div',
            null,
            row.subestado ? row.subestado : row.estado ? row.estado : ''
          );

          var field = '';

          if (row.estado) {
            field = _react2.default.createElement(
              'div',
              null,
              fieldEstado
            );
          } else {
            field = _react2.default.createElement(
              'div',
              null,
              fieldDeleted
            );
          }

          return field;
        }
      },
      'Estatus'
    ));
  }

  if (!disabled && (edit || remove || process || document || onClickEtapas || custom || certificate || upload || viewDocument || viewDocumentReporte || view)) {

    tableColumns.push(_react2.default.createElement(
      _reactBootstrapTable.TableHeaderColumn,
      {
        rowSpan: rowSpan,
        headerAlign: 'center',
        dataAlign: 'center',
        key: -2,
        expandable: false,
        dataField: 'actions',
        className: equalSize ? equalSize : !document ? 'assets-table-action' : '',
        columnClassName: equalSize ? equalSize : !document ? 'assets-table-action' : '',
        dataFormat: function dataFormat(cell, row) {
          var customOption = void 0;
          var selectEditCustom = void 0;
          if (customToggle) {
            selectEditCustom = _react2.default.createElement(
              'span',
              { className: '' },
              _react2.default.createElement(
                'a',
                {
                  href: '#',
                  className: '',
                  onClick: function onClick(e) {
                    e.preventDefault();
                    window.scroll(0, 200);
                    onClickCustom(row.id ? row.id : row);
                  }
                },
                _react2.default.createElement(
                  'i',
                  { className: 'fa ' + (row.activo * 1 ? 'fa-toggle-off' : 'fa-toggle-on') },
                  '\xA0',
                  _react2.default.createElement(
                    'b',
                    null,
                    row.activo * 1 ? 'Desactivar' : 'Activar'
                  ),
                  ' '
                )
              ),
              '\xA0'
            );
          } else {
            selectEditCustom = _react2.default.createElement(
              'span',
              { className: !row.select ? customStyle : '' },
              _react2.default.createElement(
                'a',
                {
                  href: '#',
                  className: row.disabledEdit && row.disabledEdit === true ? 'disabled' : '',
                  onClick: function onClick(e) {
                    e.preventDefault();
                    if (!disableSlideTop) window.scroll(0, 200);
                    onClickEdit(row.id ? row.id : row);
                  }
                },
                _react2.default.createElement('i', { className: 'fa fa-pencil' }),
                '\xA0',
                row.custom ? row.disabled ? "" : _react2.default.createElement(
                  'b',
                  null,
                  labelEdit ? labelEdit : 'Editar'
                ) : _react2.default.createElement(
                  'b',
                  null,
                  labelEdit ? labelEdit : 'Editar',
                  ' '
                )
              ),
              '\xA0'
            );
          }
          var editOption = edit && selectEditCustom;
          var removeOption = remove && _react2.default.createElement(
            'span',
            null,
            _react2.default.createElement(
              'a',
              {
                href: '#',
                className: row.disabledRemove && row.disabledRemove === true ? 'disabled' : '',
                onClick: function onClick(e) {
                  e.preventDefault();
                  onClickRemove(row.id ? row.id : row);
                }
              },
              _react2.default.createElement('i', { className: 'fa fa-trash' }),
              '\xA0',
              'Eliminar'
            ),
            '\xA0'
          );
          var viewOption = view && _react2.default.createElement(
            'span',
            null,
            _react2.default.createElement(
              'a',
              {
                href: '#',
                className: row.disabledView && row.disabledView === true ? 'disabled' : '',
                onClick: function onClick(e) {
                  e.preventDefault();
                  onClickView(row);
                }
              },
              _react2.default.createElement('i', { className: 'fa fa-eye' }),
              '\xA0',
              'Ver'
            ),
            '\xA0'
          );
          var processOption = process && _react2.default.createElement(
            'span',
            null,
            _react2.default.createElement(
              'a',
              {
                href: '#',
                onClick: function onClick(e) {
                  e.preventDefault();
                  onClickProcess(row.idTarea ? row.idTarea : row);
                },
                className: idRole === 7 && row.adquiridaPor && row.adquiridaPor !== sessionStorage.uid ? 'disabled' : ''
              },
              _react2.default.createElement('i', { className: 'fa fa-tasks' }),
              '\xA0',
              row.subestado == 'ADQUIRIDO' || !row.subestado ? 'Revisar' : 'Asignar'
            ),
            '\xA0'
          );
          var documentOption = document && _react2.default.createElement(
            'span',
            null,
            _react2.default.createElement(
              'a',
              {
                href: '#',
                className: !row.documento.idDocumento ? 'disabled' : '',
                onClick: function onClick(e) {
                  e.preventDefault();
                  onClickView(row.documento.idDocumento);
                }
              },
              _react2.default.createElement('i', { className: !row.documento.idDocumento ? 'fa fa-eye-slash ' : 'fa fa-eye' }),
              '\xA0',
              !row.documento.idDocumento ? 'N/A' : 'Ver'
            ),
            '\xA0'
          );
          var etapasOption = onClickEtapas && _react2.default.createElement(
            'span',
            null,
            _react2.default.createElement(
              'a',
              {
                href: '#',
                onClick: function onClick(e) {
                  e.preventDefault();
                  onClickEtapas(row.id);
                }
              },
              _react2.default.createElement('i', { className: 'fa fa-tasks' }),
              '\xA0',
              'Revisar'
            ),
            '\xA0'
          );
          customOption = custom && Array.isArray(custom) && custom.map(function (custom, index) {
            return _react2.default.createElement(
              'tr',
              { key: index },
              _react2.default.createElement(
                'td',
                null,
                _react2.default.createElement(
                  'span',
                  null,
                  _react2.default.createElement(
                    'a',
                    {
                      href: '#',
                      onClick: function onClick(e) {
                        e.preventDefault();
                        custom.actioner(row.id ? row.id : row);
                      }
                    },
                    _react2.default.createElement('i', { className: 'fa ' + custom.fa }),
                    '\xA0',
                    custom.label
                  ),
                  '\xA0'
                )
              )
            );
          });

          if (custom && !Array.isArray(custom)) customOption = custom && !Array.isArray(custom) && _react2.default.createElement(
            'span',
            null,
            _react2.default.createElement(
              'a',
              {
                href: '#',
                onClick: function onClick(e) {
                  e.preventDefault();
                  onClickCustom(row.id ? row.id : row);
                }
              },
              _react2.default.createElement('i', { className: 'fa ' + custom.fa }),
              '\xA0',
              custom.label
            ),
            '\xA0'
          );

          var certificateOption = certificate && _react2.default.createElement(
            'span',
            null,
            _react2.default.createElement(
              'a',
              {
                href: '#',
                className: certificate.disabled ? 'disabled' : '',
                onClick: function onClick(e) {
                  e.preventDefault();
                  onClickCertificate(row.id ? row.id : row);
                }
              },
              _react2.default.createElement('i', { className: 'fa fa-file-pdf-o' }),
              '\xA0',
              'Certificado'
            ),
            '\xA0'
          );
          var uploadOption = upload && _react2.default.createElement(
            'label',
            null,
            _react2.default.createElement(
              'span',
              { className: 'a-href' },
              _react2.default.createElement('input', {
                name: row.tipo && row.tipo.id ? row.tipo.id : '',
                type: 'file',
                style: { display: 'none' },
                onChange: function onChange(e) {
                  e.preventDefault();
                  handleChange(e, row);
                }
              }),
              ' ',
              row.documento && row.documento.idDocumento ? _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement('i', { className: 'fa fa-refresh' }),
                ' Actualizar'
              ) : _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement('i', { className: 'fa fa-upload' }),
                ' Subir'
              ),
              ' '
            )
          );
          var viewDocumentOption = viewDocument && _react2.default.createElement(
            'span',
            null,
            _react2.default.createElement(
              'a',
              {
                href: '#',
                className: row.documento && row.documento.idDocumento || row.dropboxId ? '' : 'disabled',
                onClick: function onClick(e) {
                  e.preventDefault();
                  onClickView(row.documento ? row.documento : row.dropboxId);
                }
              },
              _react2.default.createElement('i', { className: row.documento && row.documento.idDocumento || row.dropboxId ? 'fa fa-eye' : 'fa fa-eye-slash' }),
              ' ',
              'Ver'
            ),
            '\xA0'
          );
          var viewDocumentOptionReporte = viewDocumentReporte && _react2.default.createElement(
            'span',
            null,
            _react2.default.createElement(
              'a',
              {
                href: '#',
                className: row.estado && row.estado === 'PROCESADO' ? '' : 'disabled',
                onClick: function onClick(e) {
                  e.preventDefault();
                  onClickView(row.url ? row.url : row.url);
                }
              },
              _react2.default.createElement('i', { className: row.estado && row.estado === 'PROCESADO' ? 'fa fa-eye' : 'fa fa-eye-slash' }),
              ' Ver'
            ),
            '\xA0'
          );

          var availableOptions = [{
            option: edit,
            component: editOption
          }, {
            option: remove,
            component: removeOption
          }, {
            option: view,
            component: viewOption
          }, {
            option: process,
            component: processOption
          }, {
            option: document,
            component: documentOption
          }, {
            option: onClickEtapas,
            component: etapasOption
          }, {
            option: custom || Array.isArray(custom),
            component: customOption
          }, {
            option: certificate,
            component: certificateOption
          }, {
            option: upload,
            component: uploadOption
          }, {
            option: viewDocument,
            component: viewDocumentOption
          }, {
            option: viewDocumentReporte,
            component: viewDocumentOptionReporte
          }];

          var popOverOptions = _react2.default.createElement(
            _reactBootstrap.Popover,
            { id: 'popover-options', title: 'Men\xFA de ' + '\n' + 'opciones' },
            _react2.default.createElement(
              'div',
              null,
              _react2.default.createElement(
                'table',
                null,
                _react2.default.createElement(
                  'tbody',
                  null,
                  availableOptions.filter(function (available) {
                    return !(available.option === undefined || !available.option);
                  }).map(function (_ref2, index) {
                    var component = _ref2.component;
                    return _react2.default.createElement(
                      'tr',
                      { key: index },
                      _react2.default.createElement(
                        'td',
                        null,
                        component
                      )
                    );
                  })
                )
              )
            )
          );

          var field = void 0;

          if (upload) {
            field = _react2.default.createElement(
              'div',
              null,
              editOption,
              '\xA0',
              removeOption,
              '\xA0',
              processOption,
              '\xA0',
              documentOption,
              '\xA0',
              etapasOption,
              '\xA0',
              customOption,
              '\xA0',
              certificateOption,
              '\xA0',
              uploadOption,
              '\xA0',
              viewDocumentOption
            );
          } else {
            if (availableOptions.filter(function (available) {
              return !(available.option === undefined || !available.option);
            }).length >= 3) {
              field = _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(
                  _reactBootstrap.OverlayTrigger,
                  { trigger: 'focus', placement: 'right', overlay: popOverOptions },
                  _react2.default.createElement(
                    'span',
                    null,
                    _react2.default.createElement(
                      'a',
                      {
                        href: '#',
                        onClick: function onClick(e) {
                          e.preventDefault();
                        }
                      },
                      _react2.default.createElement('i', { className: 'fa fa-bars' }),
                      ' Opciones'
                    )
                  )
                )
              );
            } else {
              field = _react2.default.createElement(
                'div',
                null,
                availableOptions.filter(function (available) {
                  return !(available.option === undefined || !available.option);
                }).map(function (_ref3) {
                  var component = _ref3.component;
                  return component;
                })
              );
            }
          }
          return field;
        }
      },
      'Acción'
    ));
  }

  if (arrayLink || onClickArrayLink) {
    arrayLink.map(function (item) {
      tableColumns.splice(item.pos ? item.pos : tableColumns.length - 1, 0, _react2.default.createElement(
        _reactBootstrapTable.TableHeaderColumn,
        {
          rowSpan: rowSpan,
          headerAlign: 'center',
          dataAlign: 'center',
          key: -2,
          dataField: 'actions',
          className: equalSize ? equalSize : !document ? 'assets-table-action' : '',
          columnClassName: equalSize ? equalSize : !document ? 'assets-table-action' : '',
          dataFormat: function dataFormat(cell, row) {
            var arrayLinkOption = item.goTo && _react2.default.createElement(
              'span',
              { className: row.evaluacionActiva ? customStyle : '' },
              _react2.default.createElement(
                'a',
                {
                  href: '#',
                  style: { textDecoration: 'underline' },
                  onClick: function onClick(e) {
                    e.preventDefault();
                    onClickArrayLink(e, row.id ? row.id : row, item.goTo);
                  }
                },
                ' ',
                item.bodyColumn,
                ' '
              )
            );
            var arraySeleccionOption = item.titleHeader.includes('Selección') && _react2.default.createElement(
              'span',
              null,
              _react2.default.createElement('input', {
                type: 'checkbox',
                defaultChecked: row.select ? row.select : row.notificable,
                onChange: function onChange(e) {
                  onClickSelecion(e, row.id ? row.id : row);
                }
              })
            );
            var columnRangosAsignar = item.titleHeader == 'Rangos' && _react2.default.createElement(
              'span',
              { className: !row.select ? customStyle : '' },
              _react2.default.createElement(
                'a',
                {
                  href: '#',
                  onClick: function onClick(e) {
                    e.preventDefault();
                    onClickRangosyAsignar(row.id ? row.id : row);
                  }
                },
                _react2.default.createElement('i', { className: 'fa fa-bullseye' }),
                '\xA0 ',
                item.bodyColumn,
                ' '
              )
            );
            var ajusteOption = item.titleHeader == 'Ajustes' && _react2.default.createElement(
              'span',
              null,
              _react2.default.createElement(
                _reactBootstrap.Button,
                {
                  bsSize: 'xsmall',
                  disabled: row.proyectoActivo ? true : false,
                  onClick: function onClick(e) {
                    e.preventDefault();
                    onClickArrayLink(row.id ? row.id : row);
                  }
                },
                ' ',
                _react2.default.createElement('i', { className: 'fa fa-thumb-tack' }),
                '\xA0 ',
                item.bodyColumn,
                ' '
              )
            );
            var radioSelectOption = item.customRadioCheck && _react2.default.createElement(
              'span',
              null,
              _react2.default.createElement('input', {
                type: item.customRadioCheck == 'checkbox' ? 'checkbox' : 'radio',
                name: 'site_name',
                checked: row.select,
                onClick: function onClick(e) {
                  e.preventDefault();
                  onClickArrayLinkRadioCheck(row.id ? row.id : row);
                }
              }),
              ' ',
              '\xA0 ',
              item.bodyColumn,
              ' '
            );
            var changeOption = item.titleHeader == 'Acción' && _react2.default.createElement(
              'span',
              null,
              _react2.default.createElement(
                'a',
                {
                  href: '#',
                  className: row.estadoCambioDestinoId == 2 || row.estadoCambioDestinoId == null ? '' : 'disabled',
                  onClick: function onClick(e) {
                    e.preventDefault();
                    onClickArrayLink(row.id ? row.id : row);
                  }
                },
                _react2.default.createElement('i', { className: row.flagActive ? 'fa fa-eye' : 'fa fa-refresh' }),
                '\xA0 ',
                row.flagActive ? 'Ver' : item.bodyColumn,
                ' '
              )
            );

            var field = _react2.default.createElement(
              'div',
              null,
              arrayLinkOption,
              arraySeleccionOption,
              columnRangosAsignar,
              ajusteOption,
              radioSelectOption,
              changeOption
            );

            return field;
          }
        },
        item.titleHeader
      ));
    });
  }

  if (arrayChange || onClickChangeLink) {
    arrayChange.map(function (item) {
      tableColumns.splice(item.pos ? item.pos : tableColumns.length - 1, 0, _react2.default.createElement(
        _reactBootstrapTable.TableHeaderColumn,
        {
          rowSpan: rowSpan,
          headerAlign: 'center',
          dataAlign: 'center',
          key: -2,
          dataField: 'actions',
          className: equalSize ? equalSize : !document ? 'assets-table-action' : '',
          columnClassName: equalSize ? equalSize : !document ? 'assets-table-action' : '',
          dataFormat: function dataFormat(cell, row) {
            var arrayLinkOption = item.goTo && _react2.default.createElement(
              'span',
              { className: row.evaluacionActiva ? customStyle : '' },
              _react2.default.createElement(
                'a',
                {
                  href: '#',
                  style: { textDecoration: 'underline' },
                  onClick: function onClick(e) {
                    e.preventDefault();
                    onClickChangeLink(e, row.id ? row.id : row, item.goTo);
                  }
                },
                ' ',
                item.bodyColumn,
                ' '
              )
            );
            var arraySelecciónOption = item.titleHeader.includes('Selección') && _react2.default.createElement(
              'span',
              null,
              _react2.default.createElement('input', {
                type: 'checkbox',
                defaultChecked: row.select ? row.select : row.notificable,
                onChange: function onChange(e) {
                  onClickSelecion(e, row.id ? row.id : row);
                }
              })
            );
            var columnRangosAsignar = item.titleHeader == 'Rangos' && _react2.default.createElement(
              'span',
              { className: !row.select ? customStyle : '' },
              _react2.default.createElement(
                'a',
                {
                  href: '#',
                  onClick: function onClick(e) {
                    e.preventDefault();
                    onClickRangosyAsignar(row.id ? row.id : row);
                  }
                },
                _react2.default.createElement('i', { className: 'fa fa-bullseye' }),
                '\xA0 ',
                item.bodyColumn,
                ' '
              )
            );
            var ajusteOption = item.titleHeader == 'Ajustes' && _react2.default.createElement(
              'span',
              null,
              _react2.default.createElement(
                _reactBootstrap.Button,
                {
                  bsSize: 'xsmall',
                  disabled: row.actualizarProyecto ? true : false,
                  onClick: function onClick(e) {
                    e.preventDefault();
                    onClickChangeLink(row.id ? row.id : row);
                  }
                },
                ' ',
                _react2.default.createElement('i', { className: 'fa fa-thumb-tack' }),
                '\xA0 ',
                item.bodyColumn,
                ' '
              )
            );
            var radioSelectOption = item.customRadioCheck && _react2.default.createElement(
              'span',
              null,
              _react2.default.createElement('input', {
                type: item.customRadioCheck == 'checkbox' ? 'checkbox' : 'radio',
                name: 'site_name',
                checked: row.select,
                onClick: function onClick(e) {
                  e.preventDefault();
                  onClickArrayLinkRadioCheck(row.id ? row.id : row);
                }
              }),
              ' ',
              '\xA0 ',
              item.bodyColumn,
              ' '
            );
            var changeOption = item.titleHeader == 'Acción' && _react2.default.createElement(
              'span',
              null,
              _react2.default.createElement(
                'a',
                {
                  href: '#',
                  onClick: function onClick(e) {
                    e.preventDefault();
                    onClickChangeLink(row.id ? row.id : row);
                  }
                },
                _react2.default.createElement('i', { className: row.flagActive ? 'fa fa-eye' : 'fa fa-refresh' }),
                '\xA0 ',
                row.flagActive ? 'Ver' : item.bodyColumn,
                ' '
              )
            );

            var field = _react2.default.createElement(
              'div',
              null,
              arrayLinkOption,
              arraySelecciónOption,
              columnRangosAsignar,
              ajusteOption,
              radioSelectOption,
              changeOption
            );

            return field;
          }
        },
        item.titleHeader
      ));
    });
  }

  var newData = [];
  if (data && data.length !== undefined) {
    data.forEach(function (x) {
      if (x.show !== undefined) {
        if (x.show) {
          newData.push(x);
        }
      } else {
        newData.push(x);
      }
    });
  }

  return _react2.default.createElement(
    _reactBootstrapTable.BootstrapTable,
    {
      striped: true,
      containerClass: 'table-responsive-bootstrap',
      bordered: false,
      pagination: !isNoPagination ? true : false,
      data: newData,
      options: tableOptions,
      remote: false,
      selectRow: selectRowCheck ? selectRowPropCheck : {},
      cellEdit: cellEditCheck ? cellEditProp : {},
      keyField: 'id',
      search: search,
      multiColumnSearch: multiColumnSearch,
      footer: footer,
      footerData: footerData || [],
      expandableRow: expandableRow,
      expandComponent: expandComponent,
      expandColumnOptions: expandColumnOptions,
      trClassName: trClassName
    },
    tableColumns
  );
};

exports.default = TableData;

/***/ }),

/***/ 392:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactBootstrap = __webpack_require__(103);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CheckBoxGroup = function CheckBoxGroup(_ref) {
	var error = _ref.error,
	    name = _ref.name,
	    label = _ref.label,
	    subLabel = _ref.subLabel,
	    options = _ref.options,
	    onChange = _ref.onChange,
	    readOnly = _ref.readOnly,
	    required = _ref.required,
	    disabled = _ref.disabled,
	    bsClass = _ref.bsClass;


	var data = [];

	options.map(function (option) {
		data.push(_react2.default.createElement(
			_reactBootstrap.Checkbox,
			{
				bsClass: option.bsClass,
				key: option.name,
				name: option.name,
				checked: option.checked,
				disabled: disabled,
				readOnly: readOnly,
				onChange: onChange,
				inline: true },
			option.space && _react2.default.createElement(
				"span",
				null,
				"\xA0"
			),
			option.label
		));
	});

	var wrapperClass = bsClass + " form-group";
	if (error && required) {
		wrapperClass += " has-error";
	}

	return _react2.default.createElement(
		"div",
		{ className: wrapperClass },
		data,
		error && required && _react2.default.createElement(
			"p",
			null,
			'Este campo es requerido'
		)
	);
};

exports.default = CheckBoxGroup;

/***/ }),

/***/ 394:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.clearProcessData = exports.setProcessData = exports.updateInformeTask = exports.detailInformeTask = exports.initializeInforme = exports.getResultsReport = exports.updateStateRequirementTask = exports.updateDetailRequirementTask = exports.getDetailRequirementTask = exports.postAdquireTask = exports.getRequirementTasks = exports.updateRequest = exports.updateEvaluationTask = exports.getEvaluationLockTaks = exports.getDetailTask = exports.getEvaluations = exports.getEvaluationsTasks = exports.updateRegisterTask = exports.getRegisterLockTask = exports.getRegisterDetailTask = exports.getRegisterTaskByGrantee = exports.getRegisterTasks = exports.updateInformationTask = exports.getInformationLockTask = exports.getInformationDetailTask = exports.getInformationTaskByGrantee = exports.getInformationTasks = exports.ACTION_GET_BPM_RESULTS_REPORT = exports.ACTION_GET_BPM_REQUIREMENT = exports.ACTION_ADQUIRE_BPM_REQUIREMENTS = exports.ACTION_SET_BPM_REQUIREMENTS = exports.ACTION_SET_BPM_PROCESS = exports.ACTION_GET_BPM_REGISTER = exports.ACTION_SEARCH_BPM_REGISTER = exports.ACTION_GET_BPM_INFORMATION = exports.ACTION_SEARCH_BPM_INFORMATION = exports.ACTION_GET_BPM_EVALUATION = exports.ACTION_SEARCH_BPM_EVALUATION = exports.ACTION_GET_BPM_EVALUATIONS = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _Utils = __webpack_require__(2);

var Utils = _interopRequireWildcard(_Utils);

var _ClientHttpRequest = __webpack_require__(5);

var _ClientHttpRequest2 = _interopRequireDefault(_ClientHttpRequest);

var _immutable = __webpack_require__(1);

var _immutable2 = _interopRequireDefault(_immutable);

var _Modal = __webpack_require__(4);

var _Loading = __webpack_require__(3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var initialState = _immutable2.default.Map({}).set('SearchRequirements', new _immutable2.default.List([])).set('SearchEvaluation', new _immutable2.default.List([])).set('SearchInformation', new _immutable2.default.List([])).set('TaskInformation', new _immutable2.default.Map({})).set('SearchRegister', new _immutable2.default.List([])).set('TaskRegister', new _immutable2.default.Map({})).set('Set', new _immutable2.default.Map({})).set('TaskEvaluation', new _immutable2.default.Map({})).set('SetAdquire', new _immutable2.default.Map({})).set('EvaluationTask', new _immutable2.default.List([])).set('TaskRequirement', new _immutable2.default.List([])).set('TaskResultsReports', new _immutable2.default.List([]));

/* Types */

var ACTION_GET_BPM_EVALUATIONS = exports.ACTION_GET_BPM_EVALUATIONS = 'ACTION_GET_BPM_EVALUATIONS';

var ACTION_SEARCH_BPM_EVALUATION = exports.ACTION_SEARCH_BPM_EVALUATION = 'ACTION_SEARCH_BPM_EVALUATION';

var ACTION_GET_BPM_EVALUATION = exports.ACTION_GET_BPM_EVALUATION = 'ACTION_GET_BPM_EVALUATION';

var ACTION_SEARCH_BPM_INFORMATION = exports.ACTION_SEARCH_BPM_INFORMATION = 'ACTION_SEARCH_BPM_INFORMATION';

var ACTION_GET_BPM_INFORMATION = exports.ACTION_GET_BPM_INFORMATION = 'ACTION_GET_BPM_INFORMATION';

var ACTION_SEARCH_BPM_REGISTER = exports.ACTION_SEARCH_BPM_REGISTER = 'ACTION_SEARCH_BPM_REGISTER';

var ACTION_GET_BPM_REGISTER = exports.ACTION_GET_BPM_REGISTER = 'ACTION_GET_BPM_REGISTER';

var ACTION_SET_BPM_PROCESS = exports.ACTION_SET_BPM_PROCESS = 'ACTION_SET_BPM_PROCESS';

var ACTION_SET_BPM_REQUIREMENTS = exports.ACTION_SET_BPM_REQUIREMENTS = 'ACTION_SET_BPM_REQUIREMENTS';

var ACTION_ADQUIRE_BPM_REQUIREMENTS = exports.ACTION_ADQUIRE_BPM_REQUIREMENTS = 'ACTION_ADQUIRE_BPM_REQUIREMENTS';

var ACTION_GET_BPM_REQUIREMENT = exports.ACTION_GET_BPM_REQUIREMENT = 'ACTION_GET_BPM_REQUIREMENT';

var ACTION_GET_BPM_RESULTS_REPORT = exports.ACTION_GET_BPM_RESULTS_REPORT = 'ACTION_GET_BPM_RESULTS_REPORT';

/* Reducer */

exports.default = function () {
	var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	var action = arguments[1];


	switch (action.type) {
		case ACTION_SEARCH_BPM_EVALUATION:
			return state.set('SearchEvaluation', new _immutable2.default.List(action.Obj));
		case ACTION_GET_BPM_EVALUATIONS:
			return state.set('EvaluationTask', new _immutable2.default.List(action.Obj));
		case ACTION_GET_BPM_EVALUATION:
			return state.set('TaskEvaluation', new _immutable2.default.Map(action.Obj));
		case ACTION_SEARCH_BPM_INFORMATION:
			return state.set('SearchInformation', new _immutable2.default.List(action.Obj));
		case ACTION_GET_BPM_INFORMATION:
			return state.set('TaskInformation', new _immutable2.default.Map(action.Obj));
		case ACTION_SEARCH_BPM_REGISTER:
			return state.set('SearchRegister', new _immutable2.default.List(action.Obj));
		case ACTION_SET_BPM_REQUIREMENTS:
			return state.set('SearchRequirements', new _immutable2.default.List(action.Obj));
		case ACTION_GET_BPM_REGISTER:
			return state.set('TaskRegister', new _immutable2.default.Map(action.Obj));
		case ACTION_SET_BPM_PROCESS:
			return state.set('Set', new _immutable2.default.Map(action.Obj));
		case ACTION_ADQUIRE_BPM_REQUIREMENTS:
			return state.set('SetAdquire', new _immutable2.default.Map(action.Obj));
		case ACTION_GET_BPM_REQUIREMENT:
			return state.set('TaskRequirement', new _immutable2.default.Map(action.Obj));
		case ACTION_GET_BPM_RESULTS_REPORT:
			return state.set('TaskResultsReports', new _immutable2.default.List(action.Obj));
		default:
			return state;
	}
};

/* Action Creators */

var getInformationTasks = exports.getInformationTasks = function getInformationTasks() {

	return function (dispatch) {

		dispatch((0, _Loading.isLoading)(true));

		return new _ClientHttpRequest2.default({
			service: 'api/information/getTasks',
			method: "POST",
			data: {},
			headers: Object.assign({ "Authorization": sessionStorage.access_token, "Bpm": sessionStorage.bpm_token, "uid": sessionStorage.uid })
		}).request().then(function (response) {
			response.data.uniqueId = Utils.getUUID();

			dispatch((0, _Loading.isLoading)(false));
			dispatch({ type: ACTION_SEARCH_BPM_INFORMATION, Obj: response.data });
		}).catch(function (error) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
			throw error;
		});
	};
};

var getInformationTaskByGrantee = exports.getInformationTaskByGrantee = function getInformationTaskByGrantee(form) {

	return function (dispatch) {

		dispatch((0, _Loading.isLoading)(true));

		return new _ClientHttpRequest2.default({
			service: 'api/information/getTaskByGrantee',
			method: "POST",
			data: _extends({}, form),
			headers: Object.assign({ "Authorization": sessionStorage.access_token, "Bpm": sessionStorage.bpm_token, "uid": sessionStorage.uid })
		}).request().then(function (response) {
			dispatch((0, _Loading.isLoading)(false));
			return response.data;
		}).catch(function (error) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
			throw error;
		});
	};
};

var getInformationDetailTask = exports.getInformationDetailTask = function getInformationDetailTask(form) {

	return function (dispatch) {

		dispatch((0, _Loading.isLoading)(true));

		return new _ClientHttpRequest2.default({
			service: 'api/information/getDetailTask',
			method: "POST",
			data: _extends({}, form),
			headers: Object.assign({ "Authorization": sessionStorage.access_token, "Bpm": sessionStorage.bpm_token, "uid": sessionStorage.uid })
		}).request().then(function (response) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch({ type: ACTION_GET_BPM_INFORMATION, Obj: response.data });
			return response.data;
		}).catch(function (error) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
			throw error;
		});
	};
};

var getInformationLockTask = exports.getInformationLockTask = function getInformationLockTask(form) {

	return function (dispatch) {

		dispatch((0, _Loading.isLoading)(true));

		return new _ClientHttpRequest2.default({
			service: 'api/information/getLockTask',
			method: "POST",
			data: _extends({}, form),
			headers: Object.assign({ "Authorization": sessionStorage.access_token, "Bpm": sessionStorage.bpm_token, "uid": sessionStorage.uid })
		}).request().then(function (response) {
			dispatch((0, _Loading.isLoading)(false));
			return response;
		}).catch(function (error) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
			throw error;
		});
	};
};

var updateInformationTask = exports.updateInformationTask = function updateInformationTask(form) {

	return function (dispatch) {

		dispatch((0, _Loading.isLoading)(true));

		return new _ClientHttpRequest2.default({
			service: 'api/information/updateTask',
			method: "POST",
			data: _extends({}, form),
			headers: Object.assign({ "Authorization": sessionStorage.access_token, "Bpm": sessionStorage.bpm_token, "uid": sessionStorage.uid })
		}).request().then(function () {
			dispatch((0, _Loading.isLoading)(false));
			dispatch({ type: ACTION_GET_BPM_INFORMATION, Obj: {} });
		}).catch(function (error) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
			throw error;
		});
	};
};

var getRegisterTasks = exports.getRegisterTasks = function getRegisterTasks() {

	return function (dispatch) {

		dispatch((0, _Loading.isLoading)(true));

		return new _ClientHttpRequest2.default({
			service: 'api/register/getTasks',
			method: "POST",
			data: {},
			headers: Object.assign({ "Authorization": sessionStorage.access_token, "Bpm": sessionStorage.bpm_token, "uid": sessionStorage.uid })
		}).request().then(function (response) {
			response.data.uniqueId = Utils.getUUID();

			dispatch((0, _Loading.isLoading)(false));
			dispatch({ type: ACTION_SEARCH_BPM_REGISTER, Obj: response.data });
		}).catch(function (error) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
			throw error;
		});
	};
};

var getRegisterTaskByGrantee = exports.getRegisterTaskByGrantee = function getRegisterTaskByGrantee(form) {

	return function (dispatch) {

		dispatch((0, _Loading.isLoading)(true));

		return new _ClientHttpRequest2.default({
			service: 'api/register/getTaskByGrantee',
			method: "POST",
			data: _extends({}, form),
			headers: Object.assign({ "Authorization": sessionStorage.access_token, "Bpm": sessionStorage.bpm_token, "uid": sessionStorage.uid })
		}).request().then(function (response) {
			dispatch((0, _Loading.isLoading)(false));
			return response.data;
		}).catch(function (error) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
			throw error;
		});
	};
};

var getRegisterDetailTask = exports.getRegisterDetailTask = function getRegisterDetailTask(form) {

	return function (dispatch) {

		dispatch((0, _Loading.isLoading)(true));

		return new _ClientHttpRequest2.default({
			service: 'api/register/getDetailTask',
			method: "POST",
			data: _extends({}, form),
			headers: Object.assign({ "Authorization": sessionStorage.access_token, "Bpm": sessionStorage.bpm_token, "uid": sessionStorage.uid })
		}).request().then(function (response) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch({ type: ACTION_GET_BPM_REGISTER, Obj: response.data });
			return response.data;
		}).catch(function (error) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
			throw error;
		});
	};
};

var getRegisterLockTask = exports.getRegisterLockTask = function getRegisterLockTask(form) {

	return function (dispatch) {

		dispatch((0, _Loading.isLoading)(true));

		return new _ClientHttpRequest2.default({
			service: 'api/register/getLockTask',
			method: "POST",
			data: _extends({}, form),
			headers: Object.assign({ "Authorization": sessionStorage.access_token, "Bpm": sessionStorage.bpm_token, "uid": sessionStorage.uid })
		}).request().then(function (response) {
			dispatch((0, _Loading.isLoading)(false));
			return response;
		}).catch(function (error) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
			throw error;
		});
	};
};

var updateRegisterTask = exports.updateRegisterTask = function updateRegisterTask(form) {

	return function (dispatch) {

		dispatch((0, _Loading.isLoading)(true));

		return new _ClientHttpRequest2.default({
			service: 'api/register/updateTask',
			method: "POST",
			data: _extends({}, form),
			headers: Object.assign({ "Authorization": sessionStorage.access_token, "Bpm": sessionStorage.bpm_token, "uid": sessionStorage.uid })
		}).request().then(function () {
			dispatch((0, _Loading.isLoading)(false));
			dispatch({ type: ACTION_GET_BPM_REGISTER, Obj: {} });
		}).catch(function (error) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
			throw error;
		});
	};
};

var getEvaluationsTasks = exports.getEvaluationsTasks = function getEvaluationsTasks() {

	return function (dispatch) {

		dispatch((0, _Loading.isLoading)(true));

		return new _ClientHttpRequest2.default({
			service: 'api/evaluation/getTasks',
			method: "POST",
			data: {},
			headers: Object.assign({ "Authorization": sessionStorage.access_token, "Bpm": sessionStorage.bpm_token, "uid": sessionStorage.uid })
		}).request().then(function (response) {
			dispatch((0, _Loading.isLoading)(false));
			response.data.uniqueId = Utils.getUUID();
			dispatch({ type: ACTION_SEARCH_BPM_EVALUATION, Obj: response.data });
		}).catch(function (error) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
			throw error;
		});
	};
};

var getEvaluations = exports.getEvaluations = function getEvaluations(form) {

	return function (dispatch) {

		dispatch((0, _Loading.isLoading)(true));

		return new _ClientHttpRequest2.default({
			service: 'api/evaluation/getEvaluations',
			method: "POST",
			data: _extends({}, form),
			headers: Object.assign({ "Authorization": sessionStorage.access_token, "Bpm": sessionStorage.bpm_token, "uid": sessionStorage.uid })
		}).request().then(function (response) {
			dispatch((0, _Loading.isLoading)(false));
			response.data.uniqueId = Utils.getUUID();
			dispatch({ type: ACTION_GET_BPM_EVALUATIONS, Obj: !response.data.tareas ? [] : response.data.tareas.tarea });
			return response.data;
		}).catch(function (error) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response))));
			throw error;
		});
	};
};
var getDetailTask = exports.getDetailTask = function getDetailTask(idTarea) {

	return function (dispatch) {

		dispatch((0, _Loading.isLoading)(true));

		return new _ClientHttpRequest2.default({
			service: 'api/evaluation/getDetailTask',
			method: "POST",
			data: { idTarea: idTarea },
			headers: Object.assign({ "Authorization": sessionStorage.access_token, "Bpm": sessionStorage.bpm_token, "uid": sessionStorage.uid })
		}).request().then(function (response) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch({ type: ACTION_GET_BPM_EVALUATION, Obj: response.data });
		}).catch(function (error) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
			throw error;
		});
	};
};

var getEvaluationLockTaks = exports.getEvaluationLockTaks = function getEvaluationLockTaks(form) {

	return function (dispatch) {

		dispatch((0, _Loading.isLoading)(true));

		return new _ClientHttpRequest2.default({
			service: 'api/evaluation/getEvaluationLockTaks',
			method: "POST",
			data: _extends({}, form),
			headers: Object.assign({ "Authorization": sessionStorage.access_token, "Bpm": sessionStorage.bpm_token, "uid": sessionStorage.uid })
		}).request().then(function (response) {
			dispatch((0, _Loading.isLoading)(false));
			return response.data;
		}).catch(function (error) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
			throw error;
		});
	};
};

var updateEvaluationTask = exports.updateEvaluationTask = function updateEvaluationTask(form) {

	return function (dispatch) {

		dispatch((0, _Loading.isLoading)(true));

		return new _ClientHttpRequest2.default({
			service: 'api/evaluation/updateEvaluationTask',
			method: "POST",
			data: _extends({}, form),
			headers: Object.assign({ "Authorization": sessionStorage.access_token, "Bpm": sessionStorage.bpm_token, "uid": sessionStorage.uid })
		}).request().then(function (response) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch({ type: ACTION_GET_BPM_EVALUATION, Obj: {} });
			return response.data;
		}).catch(function (error) {
			dispatch((0, _Loading.isLoading)(false));
			if (error.response.data.message && error.response.data.message === 'Error de conectividad') return;
			dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
			throw error;
		});
	};
};

var updateRequest = exports.updateRequest = function updateRequest(form) {

	return function (dispatch) {

		dispatch((0, _Loading.isLoading)(true));

		return new _ClientHttpRequest2.default({
			service: 'api/evaluation/updateRequest',
			method: "POST",
			data: _extends({}, form),
			headers: Object.assign({ "Authorization": sessionStorage.access_token, "Bpm": sessionStorage.bpm_token, "uid": sessionStorage.uid })
		}).request().then(function (response) {
			dispatch((0, _Loading.isLoading)(false));
			return response.data;
		}).catch(function (error) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
			throw error;
		});
	};
};

var getRequirementTasks = exports.getRequirementTasks = function getRequirementTasks(form) {

	return function (dispatch) {

		dispatch((0, _Loading.isLoading)(true));

		return new _ClientHttpRequest2.default({
			service: 'api/requirements/getRequirementTasks',
			method: "POST",
			data: _extends({}, form),
			headers: Object.assign({ "Authorization": sessionStorage.access_token, "Bpm": sessionStorage.bpm_token, "uid": sessionStorage.uid })
		}).request().then(function (response) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch({ type: ACTION_SET_BPM_REQUIREMENTS, Obj: response.data });
			return response.data;
		}).catch(function (error) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
			throw error;
		});
	};
};

var postAdquireTask = exports.postAdquireTask = function postAdquireTask(form) {

	return function (dispatch) {

		dispatch((0, _Loading.isLoading)(true));

		return new _ClientHttpRequest2.default({
			service: 'api/requirements/postAdquireTask',
			method: "POST",
			data: _extends({}, form),
			headers: Object.assign({ "Authorization": sessionStorage.access_token, "Bpm": sessionStorage.bpm_token, "uid": sessionStorage.uid })
		}).request().then(function (response) {
			dispatch((0, _Loading.isLoading)(false));
			return response.data;
		}).catch(function (error) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
			throw error;
		});
	};
};

var getDetailRequirementTask = exports.getDetailRequirementTask = function getDetailRequirementTask(form) {

	return function (dispatch) {

		dispatch((0, _Loading.isLoading)(true));

		return new _ClientHttpRequest2.default({
			service: 'api/requirements/getDetailTask',
			method: "POST",
			data: _extends({}, form),
			headers: Object.assign({ "Authorization": sessionStorage.access_token, "Bpm": sessionStorage.bpm_token, "uid": sessionStorage.uid })
		}).request().then(function (response) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch({ type: ACTION_GET_BPM_REQUIREMENT, Obj: response.data });
			return response.data;
		}).catch(function (error) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
			throw error;
		});
	};
};

var updateDetailRequirementTask = exports.updateDetailRequirementTask = function updateDetailRequirementTask(form) {

	return function (dispatch) {

		dispatch((0, _Loading.isLoading)(true));

		return new _ClientHttpRequest2.default({
			service: 'api/requirements/updateTask',
			method: "POST",
			data: _extends({}, form),
			headers: Object.assign({ "Authorization": sessionStorage.access_token, "Bpm": sessionStorage.bpm_token, "uid": sessionStorage.uid })
		}).request().then(function (response) {
			dispatch((0, _Loading.isLoading)(false));
			return response.data;
		}).catch(function (error) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
			throw error;
		});
	};
};

var updateStateRequirementTask = exports.updateStateRequirementTask = function updateStateRequirementTask(form) {

	return function (dispatch) {

		dispatch((0, _Loading.isLoading)(true));

		return new _ClientHttpRequest2.default({
			service: 'api/requirements/updateStateTask',
			method: "POST",
			data: _extends({}, form),
			headers: Object.assign({ "Authorization": sessionStorage.access_token, "Bpm": sessionStorage.bpm_token, "uid": sessionStorage.uid })
		}).request().then(function (response) {
			dispatch((0, _Loading.isLoading)(false));
			return response.data;
		}).catch(function (error) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
			throw error;
		});
	};
};

var getResultsReport = exports.getResultsReport = function getResultsReport(form) {

	return function (dispatch) {

		dispatch((0, _Loading.isLoading)(true));

		return new _ClientHttpRequest2.default({
			service: 'api/informeResultados/getResultsReport',
			method: "POST",
			data: _extends({}, form),
			headers: Object.assign({ "Authorization": sessionStorage.access_token, "Bpm": sessionStorage.bpm_token, "uid": sessionStorage.uid })
		}).request().then(function (response) {
			dispatch((0, _Loading.isLoading)(false));
			response.data.uniqueId = Utils.getUUID();
			dispatch({ type: ACTION_GET_BPM_RESULTS_REPORT, Obj: response.data });
			return response.data;
		}).catch(function (error) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
			throw error;
		});
	};
};

var initializeInforme = exports.initializeInforme = function initializeInforme(form) {

	return function (dispatch) {

		dispatch((0, _Loading.isLoading)(true));

		return new _ClientHttpRequest2.default({
			service: 'api/informeResultados/initializeInforme',
			method: "POST",
			data: _extends({}, form),
			headers: Object.assign({ "Authorization": sessionStorage.access_token, "Bpm": sessionStorage.bpm_token, "uid": sessionStorage.uid })
		}).request().then(function (response) {
			dispatch((0, _Loading.isLoading)(false));
			return response.data;
		}).catch(function (error) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
			throw error;
		});
	};
};

var detailInformeTask = exports.detailInformeTask = function detailInformeTask(idTarea) {

	return function (dispatch) {

		dispatch((0, _Loading.isLoading)(true));

		return new _ClientHttpRequest2.default({
			service: 'api/informeResultados/detailInformeTask',
			method: "POST",
			data: { idTarea: idTarea },
			headers: Object.assign({ "Authorization": sessionStorage.access_token, "Bpm": sessionStorage.bpm_token, "uid": sessionStorage.uid })
		}).request().then(function (response) {
			dispatch((0, _Loading.isLoading)(false));
			return response.data;
		}).catch(function (error) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
			throw error;
		});
	};
};

var updateInformeTask = exports.updateInformeTask = function updateInformeTask(form) {

	return function (dispatch) {

		dispatch((0, _Loading.isLoading)(true));

		return new _ClientHttpRequest2.default({
			service: 'api/informeResultados/updateInformeTask',
			method: "POST",
			data: _extends({}, form),
			headers: Object.assign({ "Authorization": sessionStorage.access_token, "Bpm": sessionStorage.bpm_token, "uid": sessionStorage.uid })
		}).request().then(function (response) {
			dispatch((0, _Loading.isLoading)(false));
			return response.data;
		}).catch(function (error) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
			throw error;
		});
	};
};

var setProcessData = exports.setProcessData = function setProcessData(form) {

	return function (dispatch) {
		dispatch({ type: ACTION_SET_BPM_PROCESS, Obj: form });
	};
};

var clearProcessData = exports.clearProcessData = function clearProcessData() {
	return function (dispatch) {

		dispatch({ type: ACTION_GET_BPM_REGISTER, Obj: {} });
		dispatch({ type: ACTION_SEARCH_BPM_REGISTER, Obj: [] });

		dispatch({ type: ACTION_GET_BPM_INFORMATION, Obj: {} });
		dispatch({ type: ACTION_SEARCH_BPM_INFORMATION, Obj: [] });

		dispatch({ type: ACTION_GET_BPM_EVALUATION, Obj: {} });
		dispatch({ type: ACTION_SEARCH_BPM_EVALUATION, Obj: [] });

		dispatch({ type: ACTION_GET_BPM_EVALUATIONS, Obj: [] });
	};
};

/***/ }),

/***/ 395:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.exportListDonatariaCSV = exports.getMontosDonativoPreByCSV = exports.getDonatariasByCSV = exports.deleteDocument = exports.getURLDocuments = exports.uploadDocument = exports.getIdDocuments = exports.getDocuments = exports.GET_URL_DOCUMENTS = exports.SAVE_FILE = exports.GET_DOCUMENTS = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _Utils = __webpack_require__(2);

var Utils = _interopRequireWildcard(_Utils);

var _ClientHttpRequest = __webpack_require__(5);

var _ClientHttpRequest2 = _interopRequireDefault(_ClientHttpRequest);

var _immutable = __webpack_require__(1);

var _immutable2 = _interopRequireDefault(_immutable);

var _Modal = __webpack_require__(4);

var _Loading = __webpack_require__(3);

var _axios = __webpack_require__(132);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var initialState = _immutable2.default.Map({}).set("Search", new _immutable2.default.List([])).set("Response", new _immutable2.default.Map({})).set("Get", new _immutable2.default.Map({}));

/* Types */
var GET_DOCUMENTS = exports.GET_DOCUMENTS = "GET_DOCUMENTS";
var SAVE_FILE = exports.SAVE_FILE = "SAVE_FILE";
var GET_URL_DOCUMENTS = exports.GET_URL_DOCUMENTS = "GET_URL_DOCUMENTS";

/* Reducer */

exports.default = function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments[1];

  switch (action.type) {
    case GET_DOCUMENTS:
      return state.set("Get", new _immutable2.default.Map(action.Obj));
    case SAVE_FILE:
      return state.set("Response", new _immutable2.default.Map(action.Obj));
    case GET_URL_DOCUMENTS:
      return state.set("Search", new _immutable2.default.Map(action.Obj));
    default:
      return state;
  }
};

/* Action Creators */

var getDocuments = exports.getDocuments = function getDocuments(form) {
  return function (dispatch) {
    dispatch((0, _Loading.isLoading)(true));
    var data = Utils.ec_(form);

    return new _ClientHttpRequest2.default({
      service: "api/getDocuments",
      method: "POST",
      data: { reference: data },
      headers: Object.assign({
        Authorization: sessionStorage.access_token,
        uid: sessionStorage.uid,
        "n": localStorage.n
      })
    }).request().then(function (response) {
      dispatch((0, _Loading.isLoading)(false));
      response.data = Utils.ds_(response.data.reference);
      response.data.UID = Utils.getUUID();
      dispatch({ type: GET_DOCUMENTS, Obj: response.data });
    }).catch(function (error) {
      dispatch((0, _Loading.isLoading)(false));
      dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
      throw error;
    });
  };
};

var getIdDocuments = exports.getIdDocuments = function getIdDocuments(form) {
  return function (dispatch) {
    dispatch((0, _Loading.isLoading)(true));
    var data = Utils.ec_(form);

    return new _ClientHttpRequest2.default({
      service: "api/getIdDocuments",
      method: "POST",
      data: { reference: data },
      headers: Object.assign({
        Authorization: sessionStorage.access_token,
        uid: sessionStorage.uid,
        "n": localStorage.n
      })
    }).request().then(function (response) {
      dispatch((0, _Loading.isLoading)(false));
      response.data = Utils.ds_(response.data.reference);
      return response.data;
    }).catch(function (error) {
      dispatch((0, _Loading.isLoading)(false));
      dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
      throw error;
    });
  };
};

var uploadDocument = exports.uploadDocument = function uploadDocument(form) {
  var headers = {
    "Content-Type": "multipart/form-data",
    Authorization: sessionStorage.access_token,
    uid: sessionStorage.uid
  };

  if (localStorage.type == 'Donataria') {
    headers.idDonataria = localStorage.idDonataria || '';
  }

  return function (dispatch) {
    dispatch((0, _Loading.isLoading)(true));

    return (0, _axios.post)("/api/uploadDocument", form, { headers: headers }).then(function (response) {
      dispatch((0, _Loading.isLoading)(false));
      dispatch({ type: SAVE_FILE, Obj: response.data });
      return response.data;
    }).catch(function (error) {
      dispatch((0, _Loading.isLoading)(false));
      dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
      throw error;
    });
  };
};

var getURLDocuments = exports.getURLDocuments = function getURLDocuments(form) {
  return function (dispatch) {
    dispatch((0, _Loading.isLoading)(true));
    var data = Utils.ec_(form);
    return new _ClientHttpRequest2.default({
      service: "api/getURLDocuments",
      method: "POST",
      data: { reference: data },
      headers: Object.assign({
        Authorization: sessionStorage.access_token,
        uid: sessionStorage.uid,
        "n": localStorage.n
      })
    }).request().then(function (response) {
      response.data = Utils.ds_(response.data.reference);
      dispatch((0, _Loading.isLoading)(false));
      dispatch({ type: GET_URL_DOCUMENTS, Obj: response.data });
    }).catch(function (error) {
      dispatch((0, _Loading.isLoading)(false));
      dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
      throw error;
    });
  };
};

var deleteDocument = exports.deleteDocument = function deleteDocument(form) {
  return function (dispatch) {
    dispatch((0, _Loading.isLoading)(true));

    return new _ClientHttpRequest2.default({
      service: "api/deleteDocument",
      method: "POST",
      data: _extends({}, form),
      headers: Object.assign({
        Authorization: sessionStorage.access_token,
        uid: sessionStorage.uid
      })
    }).request().then(function (response) {
      dispatch((0, _Loading.isLoading)(false));
      return response.data;
    }).catch(function (error) {
      dispatch((0, _Loading.isLoading)(false));
      dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
      throw error;
    });
  };
};

var getDonatariasByCSV = exports.getDonatariasByCSV = function getDonatariasByCSV(form) {
  var headers = {
    "Content-Type": "multipart/form-data",
    Authorization: sessionStorage.access_token,
    uid: sessionStorage.uid
  };

  if (localStorage.type == 'Donataria') {
    headers.idDonataria = localStorage.idDonataria || '';
  }

  return function (dispatch) {
    dispatch((0, _Loading.isLoading)(true));

    return (0, _axios.post)("/api/getDonatariasByCSV", form, { headers: headers }).then(function (response) {
      dispatch((0, _Loading.isLoading)(false));
      return response.data;
    }).catch(function (error) {
      dispatch((0, _Loading.isLoading)(false));
      dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
      throw error;
    });
  };
};

var getMontosDonativoPreByCSV = exports.getMontosDonativoPreByCSV = function getMontosDonativoPreByCSV(form) {
  var headers = {
    "Content-Type": "multipart/form-data",
    Authorization: sessionStorage.access_token,
    uid: sessionStorage.uid
  };

  if (localStorage.type == 'Donataria') {
    headers.idDonataria = localStorage.idDonataria || '';
  }

  return function (dispatch) {
    dispatch((0, _Loading.isLoading)(true));

    return (0, _axios.post)("/api/getMontosDonativoPreByCSV", form, { headers: headers }).then(function (response) {
      dispatch((0, _Loading.isLoading)(false));
      return response.data;
    }).catch(function (error) {
      dispatch((0, _Loading.isLoading)(false));
      dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
      throw error;
    });
  };
};

var exportListDonatariaCSV = exports.exportListDonatariaCSV = function exportListDonatariaCSV(form) {

  var temp = {
    donatarias: form
  };
  return function (dispatch) {
    dispatch((0, _Loading.isLoading)(true));

    return new _ClientHttpRequest2.default({
      service: 'api/exportListDonatariaCSV',
      method: "POST",
      data: _extends({}, temp),
      headers: Object.assign({ "Authorization": sessionStorage.access_token, "uid": sessionStorage.uid }),
      responseType: 'arraybuffer'
    }).request().then(function (response) {
      dispatch((0, _Loading.isLoading)(false));
      // const uint8Array = new Uint8Array(response.data);
      var blob = new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
      var fileName = 'Lista-Donataria.xlsx';
      var objectUrl = URL.createObjectURL(blob);
      var a = document.createElement('a');
      a.href = objectUrl;
      a.download = fileName;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      URL.revokeObjectURL(objectUrl);
    }).catch(function (error) {
      dispatch((0, _Loading.isLoading)(false));
      dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
      throw error;
    });
  };
};

/***/ }),

/***/ 397:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _reactBootstrap = __webpack_require__(103);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var RadioButtonGroup = function RadioButtonGroup(_ref) {
	var id = _ref.id,
	    options = _ref.options,
	    label = _ref.label,
	    error = _ref.error,
	    value = _ref.value,
	    required = _ref.required,
	    name = _ref.name,
	    _onChange = _ref.onChange,
	    disabled = _ref.disabled;


	var wrapperClass = "form-group ";

	if (error && required && (value === undefined || value === null)) {
		wrapperClass += " has-error";
	}

	var handleChange = function handleChange(e, type) {
		if (type === 'number') {
			var _name = e.target.name;
			var _value = Number(e.target.value);
			_onChange({ target: { name: _name, value: _value } });
		} else {
			var _name2 = e.target.name;
			var _value2 = e.target.value;
			var _id = e.target.id;
			_onChange({ target: { name: _name2, value: _value2, id: _id } });
		}
	};

	var mapOptions = function mapOptions(option) {
		return _react2.default.createElement(
			_reactBootstrap.Radio,
			{
				id: id,
				key: option.value,
				readOnly: option.readOnly,
				disabled: disabled,
				name: name,
				value: option.value,
				checked: option.value ? option.value === value : false,
				onChange: function onChange(e) {
					if (_onChange) handleChange(e, _typeof(option.value));
				},
				inline: true },
			option.label
		);
	};

	return _react2.default.createElement(
		_reactBootstrap.FormGroup,
		null,
		_react2.default.createElement(
			'div',
			{ className: wrapperClass },
			label && _react2.default.createElement(
				'label',
				{ className: 'control-label', style: { width: '100%' } },
				' ',
				label,
				' '
			),
			options.map(mapOptions),
			error && required && (value === undefined || value === null) && _react2.default.createElement(
				'p',
				null,
				'Este campo es requerido'
			)
		)
	);
};

exports.default = RadioButtonGroup;

/***/ }),

/***/ 398:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.clearComments = exports.deleteComments = exports.searchComments = exports.updateComments = exports.addComments = exports.ACTION_DELETE_COMMENTS = exports.ACTION_SEARCH_COMMENTS = exports.ACTION_NEW_COMMENTS = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _Utils = __webpack_require__(2);

var Utils = _interopRequireWildcard(_Utils);

var _ClientHttpRequest = __webpack_require__(5);

var _ClientHttpRequest2 = _interopRequireDefault(_ClientHttpRequest);

var _immutable = __webpack_require__(1);

var _immutable2 = _interopRequireDefault(_immutable);

var _Modal = __webpack_require__(4);

var _Loading = __webpack_require__(3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var initialState = _immutable2.default.Map({}).set('Search', new _immutable2.default.List([])).set('Response', new _immutable2.default.Map({})).set('Get', new _immutable2.default.Map({}));

/* Types */

var ACTION_NEW_COMMENTS = exports.ACTION_NEW_COMMENTS = 'ACTION_NEW_COMMENTS';

var ACTION_SEARCH_COMMENTS = exports.ACTION_SEARCH_COMMENTS = 'ACTION_SEARCH_COMMENTS';

var ACTION_DELETE_COMMENTS = exports.ACTION_DELETE_COMMENTS = 'ACTION_DELETE_COMMENTS';

/* Reducer */

exports.default = function () {
	var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	var action = arguments[1];


	switch (action.type) {
		case ACTION_NEW_COMMENTS:
			return state.set('Response', new _immutable2.default.Map(action.Obj));
		case ACTION_SEARCH_COMMENTS:
			return state.set('Search', new _immutable2.default.List(action.Obj));
		case ACTION_DELETE_COMMENTS:
			return state.set('Response', new _immutable2.default.Map(action.Obj));
		default:
			return state;
	}
};

/* Action Creators */

var addComments = exports.addComments = function addComments(form) {

	return function (dispatch) {

		dispatch((0, _Loading.isLoading)(true));

		return new _ClientHttpRequest2.default({
			service: 'api/newComments',
			method: "POST",
			data: _extends({}, form),
			headers: Object.assign({ "Authorization": sessionStorage.access_token, "uid": sessionStorage.uid })
		}).request().then(function (response) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch({ type: ACTION_NEW_COMMENTS, Obj: response.data });
			dispatch((0, _Modal.createModal)(Utils.successMessage()));
		}).catch(function (error) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
			throw error;
		});
	};
};

var updateComments = exports.updateComments = function updateComments(form) {

	return function (dispatch) {

		dispatch((0, _Loading.isLoading)(true));

		return new _ClientHttpRequest2.default({
			service: 'api/updateComments',
			method: "POST",
			data: _extends({}, form),
			headers: Object.assign({ "Authorization": sessionStorage.access_token, "uid": sessionStorage.uid })
		}).request().then(function (response) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch({ type: ACTION_NEW_COMMENTS, Obj: response.data });
			dispatch((0, _Modal.createModal)(Utils.successMessage()));
		}).catch(function (error) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
			throw error;
		});
	};
};

var searchComments = exports.searchComments = function searchComments(form) {

	Utils.clearNullAndEmpty(form);

	return function (dispatch) {

		dispatch((0, _Loading.isLoading)(true));

		return new _ClientHttpRequest2.default({
			service: 'api/searchParamComments',
			method: "POST",
			data: _extends({}, form),
			headers: Object.assign({ "Authorization": sessionStorage.access_token, "uid": sessionStorage.uid })
		}).request().then(function (response) {
			dispatch((0, _Loading.isLoading)(false));

			var data = response.data.map(function (c) {
				return _extends({}, c, { status: true });
			});

			dispatch({ type: ACTION_SEARCH_COMMENTS, Obj: data });
			return response.data;
		}).catch(function (error) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
			throw error;
		});
	};
};

var deleteComments = exports.deleteComments = function deleteComments(form) {

	return function (dispatch) {

		dispatch((0, _Loading.isLoading)(true));

		return new _ClientHttpRequest2.default({
			service: 'api/deleteComments',
			method: "POST",
			data: _extends({}, form),
			headers: Object.assign({ "Authorization": sessionStorage.access_token, "uid": sessionStorage.uid })
		}).request().then(function (response) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch({ type: ACTION_DELETE_COMMENTS, Obj: response.data });
			dispatch((0, _Modal.createModal)(Utils.successMessage()));
		}).catch(function (error) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
			throw error;
		});
	};
};

var clearComments = exports.clearComments = function clearComments() {
	return function (dispatch) {
		dispatch({ type: ACTION_SEARCH_COMMENTS, Obj: [] });
	};
};

/***/ }),

/***/ 4:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.createModal = exports.closeModal = exports.SET_CONTENT = exports.TOGGLE_MODAL = undefined;

var _immutable = __webpack_require__(1);

var _immutable2 = _interopRequireDefault(_immutable);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var initialState = _immutable2.default.Map({}).set('show', false).set('content', new _immutable2.default.Map({ title: '', closeButton: false, body: '', footer: [] }));

/* Types */
var TOGGLE_MODAL = exports.TOGGLE_MODAL = 'TOGGLE_MODAL';

var SET_CONTENT = exports.SET_CONTENT = 'SET_CONTENT';

/* Reducer */

exports.default = function () {
	var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	var action = arguments[1];


	switch (action.type) {
		case TOGGLE_MODAL:
			return state.set('show', action.show);
		case SET_CONTENT:
			return state.set('content', new _immutable2.default.Map(action.content));
		default:
			return state;
	}
};

/* Action Creators */


var closeModal = exports.closeModal = function closeModal() {
	return function (dispatch) {
		dispatch({ type: TOGGLE_MODAL, show: false });
	};
};

var createModal = exports.createModal = function createModal(config) {

	var content = {
		title: config.title || '',
		body: config.body || '',
		closeButton: config.closeButton || false,
		footer: config.footer,
		close: config.onClose,
		className: config.className || '',
		bsSize: config.bsSize || null,
		noFooter: config.noFooter || false
	};

	return function (dispatch) {
		dispatch({ type: SET_CONTENT, content: content });
		dispatch({ type: TOGGLE_MODAL, show: true });
	};
};

/***/ }),

/***/ 401:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.setAccount = exports.getAccountByBPM = exports.getAccount = exports.SET_ACCOUNT = undefined;

var _Utils = __webpack_require__(2);

var Utils = _interopRequireWildcard(_Utils);

var _ClientHttpRequest = __webpack_require__(5);

var _ClientHttpRequest2 = _interopRequireDefault(_ClientHttpRequest);

var _immutable = __webpack_require__(1);

var _immutable2 = _interopRequireDefault(_immutable);

var _Modal = __webpack_require__(4);

var _Loading = __webpack_require__(3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var initialState = _immutable2.default.Map({});

/* Types */
var SET_ACCOUNT = exports.SET_ACCOUNT = 'SET_ACCOUNT';

/* Reducer */

exports.default = function () {
	var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	var action = arguments[1];


	switch (action.type) {
		case SET_ACCOUNT:
			return new _immutable2.default.Map(action.Obj);
		default:
			return state;
	}
};

/* Action Creators */

var getAccount = exports.getAccount = function getAccount(form) {

	return function (dispatch) {

		dispatch((0, _Loading.isLoading)(true));

		return new _ClientHttpRequest2.default({
			service: 'api/getAccount',
			method: "POST",
			data: form,
			headers: Object.assign({ "Authorization": sessionStorage.access_token, "uid": sessionStorage.uid })
		}).request().then(function (response) {
			dispatch((0, _Loading.isLoading)(false));
			localStorage.n = response.data.donataria.identificador;
			localStorage.idDonataria = response.data.donataria.idDonataria;
			dispatch({ type: SET_ACCOUNT, Obj: response.data });
			return response.data;
		}).catch(function (error) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
			throw error;
		});
	};
};

var getAccountByBPM = exports.getAccountByBPM = function getAccountByBPM(form) {

	return function (dispatch) {
		dispatch({ type: SET_ACCOUNT, Obj: form });
		return Promise.resolve();
	};
};

var setAccount = exports.setAccount = function setAccount(form) {

	return function (dispatch) {

		dispatch((0, _Loading.isLoading)(true));

		return new _ClientHttpRequest2.default({
			service: 'api/setAccount',
			method: "POST",
			data: form,
			headers: Object.assign({ "Authorization": sessionStorage.access_token, "uid": sessionStorage.uid })
		}).request().then(function () {
			dispatch((0, _Loading.isLoading)(false));
		}).catch(function (error) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
			throw error;
		});
	};
};

/***/ }),

/***/ 402:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.exportReport = exports.clearQuestions = exports.saveQuestions = exports.getQuestions = exports.EXPORT_REPORT = exports.SET_ANSWERS = exports.GET_QUESTIONS = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _Utils = __webpack_require__(2);

var Utils = _interopRequireWildcard(_Utils);

var _immutable = __webpack_require__(1);

var _ClientHttpRequest = __webpack_require__(5);

var _ClientHttpRequest2 = _interopRequireDefault(_ClientHttpRequest);

var _Modal = __webpack_require__(4);

var _Loading = __webpack_require__(3);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var initialState = (0, _immutable.Map)({}).set('questions', new _immutable.Map({}).set('preguntas', new _immutable.Map({}).set('pregunta', new _immutable.List([])))).set('answers', new _immutable.Map({}).set('exportReport'));

/* Types */
var GET_QUESTIONS = exports.GET_QUESTIONS = 'GET_QUESTIONS';
var SET_ANSWERS = exports.SET_ANSWERS = 'SET_ANSWERS';
var EXPORT_REPORT = exports.EXPORT_REPORT = 'EXPORT_REPORT';

/* Reducer */

exports.default = function () {
	var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	var action = arguments[1];


	switch (action.type) {
		case GET_QUESTIONS:
			return state.set('questions', new _immutable.Map(action.Obj));
		case SET_ANSWERS:
			return state.set('answers', new _immutable.Map(action.Obj));
		case EXPORT_REPORT:
			return state.set('exportReport', new _immutable.Map(action.Obj));
		default:
			return state;
	}
};
/* Action Creators */

var getQuestions = exports.getQuestions = function getQuestions(form) {

	return function (dispatch) {

		dispatch((0, _Loading.isLoading)(true));

		return new _ClientHttpRequest2.default({
			service: 'api/getQuestions',
			method: "POST",
			data: _extends({}, form),
			headers: Object.assign({ "Authorization": sessionStorage.access_token, "uid": sessionStorage.uid })
		}).request().then(function (response) {
			dispatch((0, _Loading.isLoading)(false));

			var data = response.data;
			var answers = { uniqueId: Utils.getUUID() };
			var objetivos = [];
			if (data) {
				data.preguntas.pregunta.forEach(function (d) {
					var idPregunta = d.idPregunta;
					var idPreguntaPadre = d.idPreguntaPadre ? d.idPreguntaPadre : idPregunta;
					var tipo = d.tipo.id;
					if (!d.seccion) {
						d.seccion = "Preguntas generales";
					}

					if (tipo === 1) {
						//Especial
						switch (idPreguntaPadre) {
							case 1:
								answers = _extends({}, answers, {
									'SPQ-1': {
										'SPQ1-C1': d.formularios.formulario[0].respuestas.respuesta[0].textoRespuesta ? d.formularios.formulario[0].respuestas.respuesta[0].textoRespuesta[0] : '',
										'SPQ1-C2': d.formularios.formulario[0].respuestas.respuesta[1].textoRespuesta ? d.formularios.formulario[0].respuestas.respuesta[1].textoRespuesta[0] : ''
									}
								});
								break;
							case 2:
								{

									answers = _extends({}, answers);

									if (d.formularios.formulario[0].respuestas.respuesta[0] && d.formularios.formulario[0].respuestas.respuesta[0].textoRespuesta && d.formularios.formulario[0].respuestas.respuesta[0].textoRespuesta[0]) {

										var objetivo = Utils.getItem(d.objetivos.objetivo, { idObjetivo: parseInt(d.formularios.formulario[0].respuestas.respuesta[0].textoRespuesta[0]) }) ? Utils.getItem(d.objetivos.objetivo, { idObjetivo: parseInt(d.formularios.formulario[0].respuestas.respuesta[0].textoRespuesta[0]) }) : {};

										var objetivoObj = { id: objetivo.idObjetivo, objetivo: objetivo };
										var metas = [];

										if (objetivo.metas) {

											d.formularios.formulario[0].respuestas.respuesta[1].textoRespuesta.forEach(function (m, indexMeta) {

												var meta = Utils.getItem(objetivo.metas.meta, { idMeta: parseInt(m) });
												if (meta) {
													var metaObj = { idObjetivo: objetivo.idObjetivo, idMeta: meta.idMeta, meta: meta };
													var idIndicadoresCobertura = d.formularios.formulario[0].respuestas.respuesta[2].textoRespuesta[indexMeta === 0 ? 0 : indexMeta] !== "0" ? d.formularios.formulario[0].respuestas.respuesta[2].textoRespuesta[indexMeta === 0 ? 0 : indexMeta] : "";
													var idIndicadoresCoberturaMetas = d.formularios.formulario[0].respuestas.respuesta[3].textoRespuesta[indexMeta === 0 ? 0 : indexMeta];
													var idIndicadoresResultados = d.formularios.formulario[0].respuestas.respuesta[4].textoRespuesta[indexMeta === 0 ? 0 : indexMeta] !== "0" ? d.formularios.formulario[0].respuestas.respuesta[4].textoRespuesta[indexMeta === 0 ? 0 : indexMeta] : "";
													var idIndicadoresResultadosMetas = d.formularios.formulario[0].respuestas.respuesta[5].textoRespuesta[indexMeta === 0 ? 0 : indexMeta];
													var IndicadoresCobertura = function IndicadoresCobertura() {
														var iteratorList = idIndicadoresCobertura ? idIndicadoresCobertura.split(",") : [];
														var indicatorsList = iteratorList.map(function (i, index) {
															var _Utils$getItem = Utils.getItem(meta.indicadores.indicador, { idIndicador: parseInt(i) }),
															    descripcion = _Utils$getItem.descripcion;

															var metaItem = idIndicadoresCoberturaMetas.split(",");
															return _react2.default.createElement(
																'li',
																{ key: descripcion.toString() },
																_react2.default.createElement(
																	'p',
																	null,
																	descripcion,
																	_react2.default.createElement('br', null),
																	_react2.default.createElement(
																		'small',
																		null,
																		'Meta instituci\xF3n: ' + metaItem[index]
																	)
																)
															);
														});
														return _react2.default.createElement(
															'ul',
															{ className: 'indicadores-question' },
															indicatorsList.length ? indicatorsList : '¡No se seleccionaron indicadores!'
														);
													};

													var IndicadoresResultados = function IndicadoresResultados() {
														var iteratorList = idIndicadoresResultados ? idIndicadoresResultados.split(",") : [];
														var indicatorsList = iteratorList.map(function (i, index) {
															var _Utils$getItem2 = Utils.getItem(meta.indicadores.indicador, { idIndicador: parseInt(i) }),
															    descripcion = _Utils$getItem2.descripcion;

															var metaItem = idIndicadoresResultadosMetas.split(",");
															return _react2.default.createElement(
																'li',
																{ key: descripcion.toString() },
																_react2.default.createElement(
																	'p',
																	null,
																	descripcion,
																	_react2.default.createElement('br', null),
																	_react2.default.createElement(
																		'small',
																		null,
																		'Meta instituci\xF3n: ' + metaItem[index]
																	)
																)
															);
														});
														return _react2.default.createElement(
															'ul',
															{ className: 'indicadores-question' },
															indicatorsList.length ? indicatorsList : '¡No se seleccionaron indicadores!'
														);
													};

													metaObj = _extends({}, metaObj, {
														idObjetivo: objetivo.idObjetivo,
														idIndicadoresCobertura: idIndicadoresCobertura,
														idIndicadoresResultados: idIndicadoresResultados,
														idIndicadoresCoberturaMetas: idIndicadoresCoberturaMetas,
														idIndicadoresResultadosMetas: idIndicadoresResultadosMetas,
														indicadoresCobertura: _react2.default.createElement(IndicadoresCobertura, null),
														indicadoresResultados: _react2.default.createElement(IndicadoresResultados, null)
													});
													metas.push(metaObj);
												}
											});
											objetivoObj = _extends({}, objetivoObj, { metas: metas });
											objetivos.push(objetivoObj);
										}
									}

									if (d.formularios.formulario[0].respuestas.respuesta[6] && d.formularios.formulario[0].respuestas.respuesta[6].textoRespuesta && d.formularios.formulario[0].respuestas.respuesta[6].textoRespuesta[0]) {

										var _objetivo = Utils.getItem(d.objetivos.objetivo, { idObjetivo: parseInt(d.formularios.formulario[0].respuestas.respuesta[6].textoRespuesta[0]) }) ? Utils.getItem(d.objetivos.objetivo, { idObjetivo: parseInt(d.formularios.formulario[0].respuestas.respuesta[6].textoRespuesta[0]) }) : {};
										var _objetivoObj = { id: _objetivo.idObjetivo, objetivo: _objetivo };
										var _metas = [];

										if (_objetivo.metas) {

											d.formularios.formulario[0].respuestas.respuesta[7].textoRespuesta.forEach(function (m, indexMeta) {

												var meta = Utils.getItem(_objetivo.metas.meta, { idMeta: parseInt(m) });

												if (meta) {

													var metaObj = { idObjetivo: _objetivo.idObjetivo, idMeta: meta.idMeta, meta: meta };
													var idIndicadoresCobertura = d.formularios.formulario[0].respuestas.respuesta[8].textoRespuesta[indexMeta === 0 ? 0 : indexMeta] !== "0" ? d.formularios.formulario[0].respuestas.respuesta[8].textoRespuesta[indexMeta === 0 ? 0 : 1] : "";
													var idIndicadoresCoberturaMetas = d.formularios.formulario[0].respuestas.respuesta[9].textoRespuesta[indexMeta === 0 ? 0 : indexMeta];

													var idIndicadoresResultados = d.formularios.formulario[0].respuestas.respuesta[10].textoRespuesta[indexMeta === 0 ? 0 : indexMeta] !== "0" ? d.formularios.formulario[0].respuestas.respuesta[10].textoRespuesta[indexMeta === 0 ? 0 : 1] : "";
													var idIndicadoresResultadosMetas = d.formularios.formulario[0].respuestas.respuesta[11].textoRespuesta[indexMeta === 0 ? 0 : indexMeta];
													var IndicadoresCobertura = function IndicadoresCobertura() {
														var iteratorList = idIndicadoresCobertura ? idIndicadoresCobertura.split(",") : [];
														var indicatorsList = iteratorList.map(function (i, index) {
															var descripcion = Utils.getItem(meta.indicadores.indicador, { idIndicador: parseInt(i) }) ? Utils.getItem(meta.indicadores.indicador, { idIndicador: parseInt(i) }).descripcion : '';
															var metaItem = idIndicadoresCoberturaMetas.split(",");

															return _react2.default.createElement(
																'li',
																{ key: descripcion.toString() },
																_react2.default.createElement(
																	'p',
																	null,
																	descripcion,
																	_react2.default.createElement('br', null),
																	_react2.default.createElement(
																		'small',
																		null,
																		'Meta instituci\xF3n: ' + metaItem[index]
																	)
																)
															);
														});
														return _react2.default.createElement(
															'ul',
															{ className: 'indicadores-question' },
															indicatorsList.length ? indicatorsList : '¡No se seleccionaron indicadores!'
														);
													};

													var IndicadoresResultados = function IndicadoresResultados() {
														var iteratorList = idIndicadoresResultados ? idIndicadoresResultados.split(",") : [];
														var indicatorsList = iteratorList.map(function (i, index) {
															var _Utils$getItem3 = Utils.getItem(meta.indicadores.indicador, { idIndicador: parseInt(i) }),
															    descripcion = _Utils$getItem3.descripcion;

															var metaItem = idIndicadoresResultadosMetas.split(",");
															return _react2.default.createElement(
																'li',
																{ key: descripcion.toString() },
																_react2.default.createElement(
																	'p',
																	null,
																	descripcion,
																	_react2.default.createElement('br', null),
																	_react2.default.createElement(
																		'small',
																		null,
																		'Meta instituci\xF3n: ' + metaItem[index]
																	)
																)
															);
														});
														return _react2.default.createElement(
															'ul',
															{ className: 'indicadores-question' },
															indicatorsList.length ? indicatorsList : '¡No se seleccionaron indicadores!'
														);
													};

													metaObj = _extends({}, metaObj, {
														idObjetivo: _objetivo.idObjetivo,
														idIndicadoresCobertura: idIndicadoresCobertura,
														idIndicadoresResultados: idIndicadoresResultados,
														idIndicadoresCoberturaMetas: idIndicadoresCoberturaMetas,
														idIndicadoresResultadosMetas: idIndicadoresResultadosMetas,
														indicadoresCobertura: _react2.default.createElement(IndicadoresCobertura, null),
														indicadoresResultados: _react2.default.createElement(IndicadoresResultados, null)
													});
													_metas.push(metaObj);
												}
											});
											_objetivoObj = _extends({}, _objetivoObj, { metas: _metas });
											objetivos.push(_objetivoObj);
										}
									}
									answers = _extends({}, answers, {
										'SPQ-2': {
											objetivos: objetivos
										}
									});
								}
								break;
							case 3:
								answers = _extends({}, answers, {
									'SPQ-3': {
										'SPQ3-C1': d.formularios.formulario[0].respuestas.respuesta[0].textoRespuesta ? d.formularios.formulario[0].respuestas.respuesta[0].textoRespuesta[0] : 0,
										'SPQ3-C2': d.formularios.formulario[0].respuestas.respuesta[1].textoRespuesta ? d.formularios.formulario[0].respuestas.respuesta[1].textoRespuesta[0] : 0,
										'SPQ3-C3': d.formularios.formulario[0].respuestas.respuesta[0].textoRespuesta ? d.formularios.formulario[0].respuestas.respuesta[0].textoRespuesta[1] : 0,
										'SPQ3-C4': d.formularios.formulario[0].respuestas.respuesta[1].textoRespuesta ? d.formularios.formulario[0].respuestas.respuesta[1].textoRespuesta[1] : 0,
										'SPQ3-C5': d.formularios.formulario[0].respuestas.respuesta[0].textoRespuesta ? d.formularios.formulario[0].respuestas.respuesta[0].textoRespuesta[2] : 0,
										'SPQ3-C6': d.formularios.formulario[0].respuestas.respuesta[1].textoRespuesta ? d.formularios.formulario[0].respuestas.respuesta[1].textoRespuesta[2] : 0,
										'SPQ3-C7': d.formularios.formulario[0].respuestas.respuesta[0].textoRespuesta ? d.formularios.formulario[0].respuestas.respuesta[0].textoRespuesta[3] : 0,
										'SPQ3-C8': d.formularios.formulario[0].respuestas.respuesta[1].textoRespuesta ? d.formularios.formulario[0].respuestas.respuesta[1].textoRespuesta[3] : 0,
										'SPQ3-C9': d.formularios.formulario[0].respuestas.respuesta[0].textoRespuesta ? d.formularios.formulario[0].respuestas.respuesta[0].textoRespuesta[4] : 0,
										'SPQ3-C10': d.formularios.formulario[0].respuestas.respuesta[1].textoRespuesta ? d.formularios.formulario[0].respuestas.respuesta[1].textoRespuesta[4] : 0,
										'SPQ3-C11': d.formularios.formulario[0].respuestas.respuesta[0].textoRespuesta ? d.formularios.formulario[0].respuestas.respuesta[0].textoRespuesta[5] : 0,
										'SPQ3-C12': d.formularios.formulario[0].respuestas.respuesta[1].textoRespuesta ? d.formularios.formulario[0].respuestas.respuesta[1].textoRespuesta[5] : 0,
										'SPQ3-C13': d.formularios.formulario[0].respuestas.respuesta[0].textoRespuesta ? d.formularios.formulario[0].respuestas.respuesta[0].textoRespuesta[6] : 0,
										'SPQ3-C14': d.formularios.formulario[0].respuestas.respuesta[1].textoRespuesta ? d.formularios.formulario[0].respuestas.respuesta[1].textoRespuesta[6] : 0,

										'SPQ3-C15': d.formularios.formulario[1].respuestas.respuesta[0].textoRespuesta ? d.formularios.formulario[1].respuestas.respuesta[0].textoRespuesta[0] : 0,
										'SPQ3-C16': d.formularios.formulario[1].respuestas.respuesta[0].textoRespuesta ? d.formularios.formulario[1].respuestas.respuesta[0].textoRespuesta[1] : 0,
										'SPQ3-C17': d.formularios.formulario[1].respuestas.respuesta[0].textoRespuesta ? d.formularios.formulario[1].respuestas.respuesta[0].textoRespuesta[2] : 0,
										'SPQ3-C18': d.formularios.formulario[1].respuestas.respuesta[0].textoRespuesta ? d.formularios.formulario[1].respuestas.respuesta[0].textoRespuesta[3] : 0,

										'SPQ3-C19': d.formularios.formulario[3].respuestas.respuesta[0].textoRespuesta ? d.formularios.formulario[3].respuestas.respuesta[0].textoRespuesta[0] : 0,

										'SPQ3-C20': d.formularios.formulario[2].respuestas.respuesta[0].textoRespuesta ? parseInt(d.formularios.formulario[2].respuestas.respuesta[0].textoRespuesta[0]) : '',
										'SPQ3-C21': d.formularios.formulario[2].respuestas.respuesta[1].textoRespuesta ? d.formularios.formulario[2].respuestas.respuesta[1].textoRespuesta[0] : '',

										/*Se agrega columna de otros generos*/
										'SPQ3-C22': d.formularios.formulario[0].respuestas.respuesta[2].textoRespuesta ? d.formularios.formulario[0].respuestas.respuesta[2].textoRespuesta[0] : 0,
										'SPQ3-C23': d.formularios.formulario[0].respuestas.respuesta[2].textoRespuesta ? d.formularios.formulario[0].respuestas.respuesta[2].textoRespuesta[1] : 0,
										'SPQ3-C24': d.formularios.formulario[0].respuestas.respuesta[2].textoRespuesta ? d.formularios.formulario[0].respuestas.respuesta[2].textoRespuesta[2] : 0,
										'SPQ3-C25': d.formularios.formulario[0].respuestas.respuesta[2].textoRespuesta ? d.formularios.formulario[0].respuestas.respuesta[2].textoRespuesta[3] : 0,
										'SPQ3-C26': d.formularios.formulario[0].respuestas.respuesta[2].textoRespuesta ? d.formularios.formulario[0].respuestas.respuesta[2].textoRespuesta[4] : 0,
										'SPQ3-C27': d.formularios.formulario[0].respuestas.respuesta[2].textoRespuesta ? d.formularios.formulario[0].respuestas.respuesta[2].textoRespuesta[5] : 0,
										'SPQ3-C28': d.formularios.formulario[0].respuestas.respuesta[2].textoRespuesta ? d.formularios.formulario[0].respuestas.respuesta[2].textoRespuesta[6] : 0,

										/*Se agrega pregunta de poblacion indigena con discapacidad*/
										'SPQ3-C29': d.formularios.formulario[4].respuestas.respuesta[0].textoRespuesta ? parseInt(d.formularios.formulario[4].respuestas.respuesta[0].textoRespuesta[0]) : '',
										'SPQ3-C30': d.formularios.formulario[4].respuestas.respuesta[1].textoRespuesta ? d.formularios.formulario[4].respuestas.respuesta[1].textoRespuesta[0] : '',

										/*Se agrega pregunta de Su organizacion apoya a otras organizaciones*/
										'SPQ3-C31': d.formularios.formulario[5].respuestas.respuesta[0].textoRespuesta ? parseInt(d.formularios.formulario[5].respuestas.respuesta[0].textoRespuesta[0]) : '',
										'SPQ3-C32': d.formularios.formulario[5].respuestas.respuesta[1].textoRespuesta ? d.formularios.formulario[5].respuestas.respuesta[1].textoRespuesta[0] : '',
										/*Se agrega nuevo campo para especificar de que forma apoya a las organizaciones*/
										'SPQ3-C63': d.formularios.formulario[5].respuestas.respuesta[2].textoRespuesta ? d.formularios.formulario[5].respuestas.respuesta[2].textoRespuesta[0] : '',

										/*Se agregan las dos columnas en nivel socioeconómico*/
										'SPQ3-C33': d.formularios.formulario[1].respuestas.respuesta[1].textoRespuesta ? d.formularios.formulario[1].respuestas.respuesta[1].textoRespuesta[0] : 0,
										'SPQ3-C34': d.formularios.formulario[1].respuestas.respuesta[1].textoRespuesta ? d.formularios.formulario[1].respuestas.respuesta[2].textoRespuesta[0] : 0,
										'SPQ3-C35': d.formularios.formulario[1].respuestas.respuesta[1].textoRespuesta ? d.formularios.formulario[1].respuestas.respuesta[1].textoRespuesta[1] : 0,
										'SPQ3-C36': d.formularios.formulario[1].respuestas.respuesta[1].textoRespuesta ? d.formularios.formulario[1].respuestas.respuesta[2].textoRespuesta[1] : 0,
										'SPQ3-C37': d.formularios.formulario[1].respuestas.respuesta[2].textoRespuesta ? d.formularios.formulario[1].respuestas.respuesta[1].textoRespuesta[2] : 0,
										'SPQ3-C38': d.formularios.formulario[1].respuestas.respuesta[2].textoRespuesta ? d.formularios.formulario[1].respuestas.respuesta[2].textoRespuesta[2] : 0,
										'SPQ3-C39': d.formularios.formulario[1].respuestas.respuesta[2].textoRespuesta ? d.formularios.formulario[1].respuestas.respuesta[1].textoRespuesta[3] : 0,
										'SPQ3-C40': d.formularios.formulario[1].respuestas.respuesta[2].textoRespuesta ? d.formularios.formulario[1].respuestas.respuesta[2].textoRespuesta[3] : 0,

										/*Se agrega nueva pregunta de financiamiento NMP*/
										'SPQ3-C41': d.formularios.formulario[6].respuestas.respuesta[0].textoRespuesta ? parseInt(d.formularios.formulario[6].respuestas.respuesta[0].textoRespuesta[0]) : '',

										/*Se agrega la tabla ligada a la pregunta nueva*/
										'SPQ3-C42': d.formularios.formulario[7].respuestas.respuesta[0].textoRespuesta ? d.formularios.formulario[7].respuestas.respuesta[0].textoRespuesta[0] : 0,
										'SPQ3-C43': d.formularios.formulario[7].respuestas.respuesta[0].textoRespuesta ? d.formularios.formulario[7].respuestas.respuesta[1].textoRespuesta[0] : 0,
										'SPQ3-C44': d.formularios.formulario[7].respuestas.respuesta[0].textoRespuesta ? d.formularios.formulario[7].respuestas.respuesta[2].textoRespuesta[0] : 0,
										'SPQ3-C45': d.formularios.formulario[7].respuestas.respuesta[0].textoRespuesta ? d.formularios.formulario[7].respuestas.respuesta[0].textoRespuesta[1] : 0,
										'SPQ3-C46': d.formularios.formulario[7].respuestas.respuesta[1].textoRespuesta ? d.formularios.formulario[7].respuestas.respuesta[1].textoRespuesta[1] : 0,
										'SPQ3-C47': d.formularios.formulario[7].respuestas.respuesta[1].textoRespuesta ? d.formularios.formulario[7].respuestas.respuesta[2].textoRespuesta[1] : 0,
										'SPQ3-C48': d.formularios.formulario[7].respuestas.respuesta[1].textoRespuesta ? d.formularios.formulario[7].respuestas.respuesta[0].textoRespuesta[2] : 0,
										'SPQ3-C49': d.formularios.formulario[7].respuestas.respuesta[1].textoRespuesta ? d.formularios.formulario[7].respuestas.respuesta[1].textoRespuesta[2] : 0,
										'SPQ3-C50': d.formularios.formulario[7].respuestas.respuesta[2].textoRespuesta ? d.formularios.formulario[7].respuestas.respuesta[2].textoRespuesta[2] : 0,
										'SPQ3-C51': d.formularios.formulario[7].respuestas.respuesta[2].textoRespuesta ? d.formularios.formulario[7].respuestas.respuesta[0].textoRespuesta[3] : 0,
										'SPQ3-C52': d.formularios.formulario[7].respuestas.respuesta[2].textoRespuesta ? d.formularios.formulario[7].respuestas.respuesta[1].textoRespuesta[3] : 0,
										'SPQ3-C53': d.formularios.formulario[7].respuestas.respuesta[2].textoRespuesta ? d.formularios.formulario[7].respuestas.respuesta[2].textoRespuesta[3] : 0,

										/*Se agrega nueva tabla de personas destinatarias según el tipo de población.*/
										'SPQ3-C54': d.formularios.formulario[8].respuestas.respuesta[0].textoRespuesta ? d.formularios.formulario[8].respuestas.respuesta[0].textoRespuesta[0] : 0,
										'SPQ3-C55': d.formularios.formulario[8].respuestas.respuesta[0].textoRespuesta ? d.formularios.formulario[8].respuestas.respuesta[0].textoRespuesta[1] : 0,
										'SPQ3-C56': d.formularios.formulario[8].respuestas.respuesta[0].textoRespuesta ? d.formularios.formulario[8].respuestas.respuesta[0].textoRespuesta[2] : 0,
										'SPQ3-C57': d.formularios.formulario[8].respuestas.respuesta[0].textoRespuesta ? d.formularios.formulario[8].respuestas.respuesta[0].textoRespuesta[3] : 0,
										'SPQ3-C58': d.formularios.formulario[8].respuestas.respuesta[0].textoRespuesta ? d.formularios.formulario[8].respuestas.respuesta[0].textoRespuesta[4] : 0,
										'SPQ3-C59': d.formularios.formulario[8].respuestas.respuesta[0].textoRespuesta ? d.formularios.formulario[8].respuestas.respuesta[0].textoRespuesta[5] : 0,
										'SPQ3-C60': d.formularios.formulario[8].respuestas.respuesta[0].textoRespuesta ? d.formularios.formulario[8].respuestas.respuesta[0].textoRespuesta[6] : 0,
										'SPQ3-C61': d.formularios.formulario[8].respuestas.respuesta[1].textoRespuesta ? d.formularios.formulario[8].respuestas.respuesta[1].textoRespuesta[0] : "",
										'SPQ3-C62': d.formularios.formulario[8].respuestas.respuesta[1].textoRespuesta ? d.formularios.formulario[8].respuestas.respuesta[1].textoRespuesta[1] : ""
									}
								});
								break;
							case 4:
								{

									var resp = {};

									if (d.formularios.formulario[0].respuestas.respuesta[0].textoRespuesta && d.formularios.formulario[0].respuestas.respuesta[0].textoRespuesta[0]) {
										d.formularios.formulario[0].respuestas.respuesta[0].textoRespuesta.forEach(function (i, index) {
											var _extends2;

											resp = _extends({}, resp, (_extends2 = {}, _defineProperty(_extends2, 'SPQ4-CP' + i, d.formularios.formulario[0].respuestas.respuesta[2].textoRespuesta[index]), _defineProperty(_extends2, 'SPQ4-CC' + i, d.formularios.formulario[0].respuestas.respuesta[3].textoRespuesta[index]), _extends2));
											if (d.formularios.formulario[0].respuestas.respuesta[4].textoRespuesta[index]) {
												d.formularios.formulario[0].respuestas.respuesta[4].textoRespuesta[index].split(",").forEach(function (a, b) {
													var _extends3;

													var val1 = d.formularios.formulario[0].respuestas.respuesta[5].textoRespuesta[index].split('|') || '';
													var val2 = d.formularios.formulario[0].respuestas.respuesta[6].textoRespuesta[index].split('|') || '';

													resp = _extends({}, resp, (_extends3 = {}, _defineProperty(_extends3, 'SPQ4-RP' + a, val1[b]), _defineProperty(_extends3, 'SPQ4-RC' + a, val2[b]), _extends3));
												});
											}
										});
									}

									if (d.formularios.formulario[0].respuestas.respuesta[7].textoRespuesta && d.formularios.formulario[0].respuestas.respuesta[7].textoRespuesta[0]) {
										d.formularios.formulario[0].respuestas.respuesta[7].textoRespuesta.forEach(function (i, index) {
											var _extends4;

											resp = _extends({}, resp, (_extends4 = {}, _defineProperty(_extends4, 'SPQ4-CP' + i, d.formularios.formulario[0].respuestas.respuesta[9].textoRespuesta[index]), _defineProperty(_extends4, 'SPQ4-CC' + i, d.formularios.formulario[0].respuestas.respuesta[10].textoRespuesta[index]), _extends4));
											if (d.formularios.formulario[0].respuestas.respuesta[11].textoRespuesta[index]) {
												d.formularios.formulario[0].respuestas.respuesta[11].textoRespuesta[index].split(",").forEach(function (a, b) {
													var _extends5;

													var val1 = d.formularios.formulario[0].respuestas.respuesta[12].textoRespuesta[index].split('|') || '';
													var val2 = d.formularios.formulario[0].respuestas.respuesta[13].textoRespuesta[index].split('|') || '';

													resp = _extends({}, resp, (_extends5 = {}, _defineProperty(_extends5, 'SPQ4-RP' + a, val1[b]), _defineProperty(_extends5, 'SPQ4-RC' + a, val2[b]), _extends5));
												});
											}
										});
									}

									answers = _extends({}, answers, {
										'SPQ-4': _extends({}, resp)
									});
								}
								break;
							case 5:
								answers = _extends({}, answers, {
									'SPQ-5': {
										'SPQ5-C1': d.formularios.formulario[0].respuestas.respuesta[0].textoRespuesta ? d.formularios.formulario[0].respuestas.respuesta[0].textoRespuesta : '',
										'SPQ5-C2': d.formularios.formulario[0].respuestas.respuesta[1].textoRespuesta ? d.formularios.formulario[0].respuestas.respuesta[1].textoRespuesta : '',
										'SPQ5-C3': d.formularios.formulario[0].respuestas.respuesta[2].textoRespuesta ? d.formularios.formulario[0].respuestas.respuesta[2].textoRespuesta : '',
										'SPQ5-C4': d.formularios.formulario[0].respuestas.respuesta[4].textoRespuesta ? d.formularios.formulario[0].respuestas.respuesta[4].textoRespuesta : '',
										'SPQ5-C5': d.formularios.formulario[0].respuestas.respuesta[5].textoRespuesta ? d.formularios.formulario[0].respuestas.respuesta[5].textoRespuesta : '',

										/*Datos para ORGANIZACIONES DE LA SOCIEDAD CIVIL*/
										'SPQ5-C6': d.formularios.formulario[1].respuestas.respuesta[0].textoRespuesta ? d.formularios.formulario[1].respuestas.respuesta[0].textoRespuesta[0] : '',
										'SPQ5-C7': d.formularios.formulario[1].respuestas.respuesta[1].textoRespuesta ? d.formularios.formulario[1].respuestas.respuesta[1].textoRespuesta[0] : '',
										'SPQ5-C8': d.formularios.formulario[1].respuestas.respuesta[2].textoRespuesta ? d.formularios.formulario[1].respuestas.respuesta[2].textoRespuesta[0] : '',
										'SPQ5-C9': d.formularios.formulario[1].respuestas.respuesta[3].textoRespuesta ? d.formularios.formulario[1].respuestas.respuesta[3].textoRespuesta[0] : '',

										/*Datos para ACADEMIA*/
										'SPQ5-C10': d.formularios.formulario[2].respuestas.respuesta[0].textoRespuesta ? d.formularios.formulario[2].respuestas.respuesta[0].textoRespuesta[0] : '',
										'SPQ5-C11': d.formularios.formulario[2].respuestas.respuesta[1].textoRespuesta ? d.formularios.formulario[2].respuestas.respuesta[1].textoRespuesta[0] : '',
										'SPQ5-C12': d.formularios.formulario[2].respuestas.respuesta[2].textoRespuesta ? d.formularios.formulario[2].respuestas.respuesta[2].textoRespuesta[0] : '',
										'SPQ5-C13': d.formularios.formulario[2].respuestas.respuesta[3].textoRespuesta ? d.formularios.formulario[2].respuestas.respuesta[3].textoRespuesta[0] : '',

										/*Datos para GUBERNAMENTAL*/
										'SPQ5-C14': d.formularios.formulario[3].respuestas.respuesta[0].textoRespuesta ? d.formularios.formulario[3].respuestas.respuesta[0].textoRespuesta[0] : '',
										'SPQ5-C15': d.formularios.formulario[3].respuestas.respuesta[1].textoRespuesta ? d.formularios.formulario[3].respuestas.respuesta[1].textoRespuesta[0] : '',
										'SPQ5-C16': d.formularios.formulario[3].respuestas.respuesta[2].textoRespuesta ? d.formularios.formulario[3].respuestas.respuesta[2].textoRespuesta[0] : '',
										'SPQ5-C17': d.formularios.formulario[3].respuestas.respuesta[3].textoRespuesta ? d.formularios.formulario[3].respuestas.respuesta[3].textoRespuesta[0] : '',

										/*Datos para PRIVADO*/
										'SPQ5-C18': d.formularios.formulario[4].respuestas.respuesta[0].textoRespuesta ? d.formularios.formulario[4].respuestas.respuesta[0].textoRespuesta[0] : '',
										'SPQ5-C19': d.formularios.formulario[4].respuestas.respuesta[1].textoRespuesta ? d.formularios.formulario[4].respuestas.respuesta[1].textoRespuesta[0] : '',
										'SPQ5-C20': d.formularios.formulario[4].respuestas.respuesta[2].textoRespuesta ? d.formularios.formulario[4].respuestas.respuesta[2].textoRespuesta[0] : '',
										'SPQ5-C21': d.formularios.formulario[4].respuestas.respuesta[3].textoRespuesta ? d.formularios.formulario[4].respuestas.respuesta[3].textoRespuesta[0] : '',

										/*Datos para OTROS ALIADOS NO LISTADOS*/
										'SPQ5-C22': d.formularios.formulario[5].respuestas.respuesta[0].textoRespuesta ? d.formularios.formulario[5].respuestas.respuesta[0].textoRespuesta[0] : '',
										'SPQ5-C23': d.formularios.formulario[5].respuestas.respuesta[1].textoRespuesta ? d.formularios.formulario[5].respuestas.respuesta[1].textoRespuesta[0] : '',
										'SPQ5-C24': d.formularios.formulario[5].respuestas.respuesta[2].textoRespuesta ? d.formularios.formulario[5].respuestas.respuesta[2].textoRespuesta[0] : '',
										'SPQ5-C25': d.formularios.formulario[5].respuestas.respuesta[3].textoRespuesta ? d.formularios.formulario[5].respuestas.respuesta[3].textoRespuesta[0] : ''
									}
								});
								break;
							case 6:
								answers = _extends({}, answers, {
									'SPQ-6': {
										'SPQ6-C1': d.formularios.formulario[0].respuestas.respuesta[0].textoRespuesta ? d.formularios.formulario[0].respuestas.respuesta[0].textoRespuesta : '',
										'SPQ6-C2': d.formularios.formulario[0].respuestas.respuesta[1].textoRespuesta ? d.formularios.formulario[0].respuestas.respuesta[1].textoRespuesta : '',
										'SPQ6-C3': d.formularios.formulario[0].respuestas.respuesta[2].textoRespuesta ? d.formularios.formulario[0].respuestas.respuesta[2].textoRespuesta : '',
										'SPQ6-C4': d.formularios.formulario[0].respuestas.respuesta[4].textoRespuesta ? d.formularios.formulario[0].respuestas.respuesta[4].textoRespuesta : '',
										'SPQ6-C5': d.formularios.formulario[0].respuestas.respuesta[5].textoRespuesta ? d.formularios.formulario[0].respuestas.respuesta[5].textoRespuesta : '',

										/*INICIA FORMULARIO 2*/
										/*Se agregan nuevos campos modificacion paquete 3*/
										/*Objetivo 1*/
										'SPQ6-C6': d.formularios.formulario[1].respuestas.respuesta[0].textoRespuesta ? d.formularios.formulario[1].respuestas.respuesta[0].textoRespuesta[0] : '',
										'SPQ6-C7': d.formularios.formulario[1].respuestas.respuesta[1].textoRespuesta ? d.formularios.formulario[1].respuestas.respuesta[1].textoRespuesta[0] : '',
										'SPQ6-C8': d.formularios.formulario[1].respuestas.respuesta[2].textoRespuesta ? d.formularios.formulario[1].respuestas.respuesta[2].textoRespuesta[0] : undefined,
										'SPQ6-C9': d.formularios.formulario[1].respuestas.respuesta[3].textoRespuesta ? d.formularios.formulario[1].respuestas.respuesta[3].textoRespuesta[0] : undefined,
										'SPQ6-C10': d.formularios.formulario[1].respuestas.respuesta[4].textoRespuesta ? d.formularios.formulario[1].respuestas.respuesta[4].textoRespuesta[0] : '',
										'SPQ6-C11': d.formularios.formulario[1].respuestas.respuesta[5].textoRespuesta ? d.formularios.formulario[1].respuestas.respuesta[5].textoRespuesta[0] : 0,

										'SPQ6-C12': d.formularios.formulario[1].respuestas.respuesta[6].textoRespuesta ? d.formularios.formulario[1].respuestas.respuesta[6].textoRespuesta[0] : '',
										'SPQ6-C13': d.formularios.formulario[1].respuestas.respuesta[7].textoRespuesta ? d.formularios.formulario[1].respuestas.respuesta[7].textoRespuesta[0] : undefined,
										'SPQ6-C14': d.formularios.formulario[1].respuestas.respuesta[8].textoRespuesta ? d.formularios.formulario[1].respuestas.respuesta[8].textoRespuesta[0] : undefined,
										'SPQ6-C15': d.formularios.formulario[1].respuestas.respuesta[9].textoRespuesta ? d.formularios.formulario[1].respuestas.respuesta[9].textoRespuesta[0] : '',
										/*TERMINA FORMULARIO 2*/

										/*INICIA FORMULARIO 3*/
										/*Se agrega objetivo 2*/
										'SPQ6-C16': d.formularios.formulario[2].respuestas.respuesta[0].textoRespuesta ? d.formularios.formulario[2].respuestas.respuesta[0].textoRespuesta[0] : '',
										'SPQ6-C17': d.formularios.formulario[2].respuestas.respuesta[1].textoRespuesta ? d.formularios.formulario[2].respuestas.respuesta[1].textoRespuesta[0] : '',
										'SPQ6-C18': d.formularios.formulario[2].respuestas.respuesta[2].textoRespuesta ? d.formularios.formulario[2].respuestas.respuesta[2].textoRespuesta[0] : undefined,
										'SPQ6-C19': d.formularios.formulario[2].respuestas.respuesta[3].textoRespuesta ? d.formularios.formulario[2].respuestas.respuesta[3].textoRespuesta[0] : undefined,
										'SPQ6-C20': d.formularios.formulario[2].respuestas.respuesta[4].textoRespuesta ? d.formularios.formulario[2].respuestas.respuesta[4].textoRespuesta[0] : '',

										'SPQ6-C21': d.formularios.formulario[2].respuestas.respuesta[5].textoRespuesta ? d.formularios.formulario[2].respuestas.respuesta[5].textoRespuesta[0] : 0,

										'SPQ6-C22': d.formularios.formulario[2].respuestas.respuesta[6].textoRespuesta ? d.formularios.formulario[2].respuestas.respuesta[6].textoRespuesta[0] : '',
										'SPQ6-C23': d.formularios.formulario[2].respuestas.respuesta[7].textoRespuesta ? d.formularios.formulario[2].respuestas.respuesta[7].textoRespuesta[0] : undefined,
										'SPQ6-C24': d.formularios.formulario[2].respuestas.respuesta[8].textoRespuesta ? d.formularios.formulario[2].respuestas.respuesta[8].textoRespuesta[0] : undefined,
										'SPQ6-C25': d.formularios.formulario[2].respuestas.respuesta[9].textoRespuesta ? d.formularios.formulario[2].respuestas.respuesta[9].textoRespuesta[0] : '',
										/*TERMINA FORMULARIO 3*/

										/*INICIA FORMULARIO 4*/
										/*Se agrega objetivo 3*/
										'SPQ6-C26': d.formularios.formulario[3].respuestas.respuesta[0].textoRespuesta ? d.formularios.formulario[3].respuestas.respuesta[0].textoRespuesta[0] : '',
										'SPQ6-C27': d.formularios.formulario[3].respuestas.respuesta[1].textoRespuesta ? d.formularios.formulario[3].respuestas.respuesta[1].textoRespuesta[0] : '',
										'SPQ6-C28': d.formularios.formulario[3].respuestas.respuesta[2].textoRespuesta ? d.formularios.formulario[3].respuestas.respuesta[2].textoRespuesta[0] : undefined,
										'SPQ6-C29': d.formularios.formulario[3].respuestas.respuesta[3].textoRespuesta ? d.formularios.formulario[3].respuestas.respuesta[3].textoRespuesta[0] : undefined,
										'SPQ6-C30': d.formularios.formulario[3].respuestas.respuesta[4].textoRespuesta ? d.formularios.formulario[3].respuestas.respuesta[4].textoRespuesta[0] : '',
										/*Se agrega condicional para la actividad 2 objetivo 3*/
										'SPQ6-C31': d.formularios.formulario[3].respuestas.respuesta[5].textoRespuesta ? d.formularios.formulario[3].respuestas.respuesta[5].textoRespuesta[0] : 0,
										/*Se agregan nuevas opciones de la actividad 2 objetivo 3*/
										'SPQ6-C32': d.formularios.formulario[3].respuestas.respuesta[6].textoRespuesta ? d.formularios.formulario[3].respuestas.respuesta[6].textoRespuesta[0] : '',
										'SPQ6-C33': d.formularios.formulario[3].respuestas.respuesta[7].textoRespuesta ? d.formularios.formulario[3].respuestas.respuesta[7].textoRespuesta[0] : undefined,
										'SPQ6-C34': d.formularios.formulario[3].respuestas.respuesta[8].textoRespuesta ? d.formularios.formulario[3].respuestas.respuesta[8].textoRespuesta[0] : undefined,
										'SPQ6-C35': d.formularios.formulario[3].respuestas.respuesta[9].textoRespuesta ? d.formularios.formulario[3].respuestas.respuesta[9].textoRespuesta[0] : ''
										/*TERMINA FORMULARIO 4*/
									}
								});
								break;
							case 7:
								answers = _extends({}, answers, {
									'SPQ-7': {
										'SPQ7-C1': d.formularios.formulario[0].respuestas.respuesta[0].textoRespuesta ? d.formularios.formulario[0].respuestas.respuesta[0].textoRespuesta : '',
										'SPQ7-C2': d.formularios.formulario[0].respuestas.respuesta[1].textoRespuesta ? d.formularios.formulario[0].respuestas.respuesta[1].textoRespuesta : '',
										'SPQ7-C3': d.formularios.formulario[0].respuestas.respuesta[2].textoRespuesta ? d.formularios.formulario[0].respuestas.respuesta[2].textoRespuesta : '',
										'SPQ7-C4': d.formularios.formulario[0].respuestas.respuesta[3].textoRespuesta ? d.formularios.formulario[0].respuestas.respuesta[3].textoRespuesta : '',
										'SPQ7-C5': d.formularios.formulario[0].respuestas.respuesta[5].textoRespuesta ? d.formularios.formulario[0].respuestas.respuesta[5].textoRespuesta : '',
										'SPQ7-C6': d.formularios.formulario[0].respuestas.respuesta[6].textoRespuesta ? d.formularios.formulario[0].respuestas.respuesta[6].textoRespuesta : ''
									}
								});
								break;
							case 8:
								{

									answers = _extends({}, answers);

									var obj = [];

									if (objetivos[0]) {
										var indicadores = [];
										var objetivosObj = {};
										var indObj = {};

										objetivosObj = {
											id: objetivos[0].objetivo.idObjetivo,
											objetivo: {
												idObjetivo: objetivos[0].objetivo.idObjetivo,
												descripcion: objetivos[0].objetivo.descripcion
											}
										};

										var metodoEvaluacion = d.formularios.formulario[0].respuestas.respuesta[1].textoRespuesta || '';
										var metodoVerificacion = d.formularios.formulario[0].respuestas.respuesta[2].textoRespuesta || '';

										objetivos[0].metas.forEach(function (m) {
											if (m.idIndicadoresResultados) {
												m.idIndicadoresResultados.split(",").forEach(function (i, index) {
													if (i) {
														var item = Utils.getItem(m.meta.indicadores.indicador, { idIndicador: parseInt(i) });
														indObj = {
															idObjetivo: objetivos[0].objetivo.idObjetivo,
															idIndicador: item.idIndicador,
															descripcion: item.descripcion,
															evaluacion: metodoEvaluacion ? metodoEvaluacion[index] : '',
															verificacion: metodoVerificacion ? metodoVerificacion[index] : ''
														};
														indicadores.push(indObj);
													}
												});
											}
											return m;
										});

										if (indicadores.length) {
											objetivosObj = _extends({}, objetivosObj, { indicadores: indicadores });
											obj.push(objetivosObj);
										}
									}

									if (objetivos[1]) {

										var _indicadores = [];
										var _objetivosObj = {};
										var _indObj = {};

										_objetivosObj = {
											id: objetivos[1].objetivo.idObjetivo,
											objetivo: {
												idObjetivo: objetivos[1].objetivo.idObjetivo,
												descripcion: objetivos[1].objetivo.descripcion
											}
										};

										var _metodoEvaluacion = d.formularios.formulario[0].respuestas.respuesta[4].textoRespuesta || '';
										var _metodoVerificacion = d.formularios.formulario[0].respuestas.respuesta[5].textoRespuesta || '';

										objetivos[1].metas.forEach(function (m) {
											if (m.indicadoresResultados) {
												m.idIndicadoresResultados.split(",").forEach(function (i, index) {
													if (i) {
														var item = Utils.getItem(m.meta.indicadores.indicador, { idIndicador: parseInt(i) });
														_indObj = {
															idObjetivo: objetivos[1].objetivo.idObjetivo,
															idIndicador: item.idIndicador,
															descripcion: item.descripcion,
															evaluacion: _metodoEvaluacion ? _metodoEvaluacion[index] : '',
															verificacion: _metodoVerificacion ? _metodoVerificacion[index] : ''
														};
														_indicadores.push(_indObj);
													}
												});
											}
											return m;
										});

										if (_indicadores.length) {
											_objetivosObj = _extends({}, _objetivosObj, { indicadores: _indicadores });
											obj.push(_objetivosObj);
										}
									}

									answers = _extends({}, answers, {
										'SPQ-8': {
											obj: obj
										}
									});
								}
								break;
							case 9:
								answers = _extends({}, answers, {
									'SPQ-9': {
										'SPQ9-C1': d.formularios.formulario[0].respuestas.respuesta[0].textoRespuesta ? parseInt(d.formularios.formulario[0].respuestas.respuesta[0].textoRespuesta[0]) : '',
										'SPQ9-C2': d.formularios.formulario[0].respuestas.respuesta[1].textoRespuesta ? d.formularios.formulario[0].respuestas.respuesta[1].textoRespuesta[0] : '',
										'SPQ9-C3': d.formularios.formulario[0].respuestas.respuesta[2].textoRespuesta ? d.formularios.formulario[0].respuestas.respuesta[2].textoRespuesta[0] : '',
										'SPQ9-C4': d.formularios.formulario[0].respuestas.respuesta[3].textoRespuesta ? d.formularios.formulario[0].respuestas.respuesta[3].textoRespuesta[0] : '',
										'SPQ9-C5': d.formularios.formulario[0].respuestas.respuesta[0].textoRespuesta ? d.formularios.formulario[0].respuestas.respuesta[0].textoRespuesta[1] : '',
										'SPQ9-C6': d.formularios.formulario[0].respuestas.respuesta[1].textoRespuesta ? d.formularios.formulario[0].respuestas.respuesta[1].textoRespuesta[1] : '',
										'SPQ9-C7': d.formularios.formulario[0].respuestas.respuesta[2].textoRespuesta ? d.formularios.formulario[0].respuestas.respuesta[2].textoRespuesta[1] : '',
										'SPQ9-C8': d.formularios.formulario[0].respuestas.respuesta[3].textoRespuesta ? d.formularios.formulario[0].respuestas.respuesta[3].textoRespuesta[1] : '',
										'SPQ9-C9': d.formularios.formulario[0].respuestas.respuesta[0].textoRespuesta ? d.formularios.formulario[0].respuestas.respuesta[0].textoRespuesta[2] : '',
										'SPQ9-C10': d.formularios.formulario[0].respuestas.respuesta[1].textoRespuesta ? d.formularios.formulario[0].respuestas.respuesta[1].textoRespuesta[2] : '',
										'SPQ9-C11': d.formularios.formulario[0].respuestas.respuesta[2].textoRespuesta ? d.formularios.formulario[0].respuestas.respuesta[2].textoRespuesta[2] : '',
										'SPQ9-C12': d.formularios.formulario[0].respuestas.respuesta[3].textoRespuesta ? d.formularios.formulario[0].respuestas.respuesta[3].textoRespuesta[2] : '',
										'SPQ9-C13': d.formularios.formulario[0].respuestas.respuesta[0].textoRespuesta ? d.formularios.formulario[0].respuestas.respuesta[0].textoRespuesta[3] : '',
										'SPQ9-C14': d.formularios.formulario[0].respuestas.respuesta[1].textoRespuesta ? d.formularios.formulario[0].respuestas.respuesta[1].textoRespuesta[3] : '',
										'SPQ9-C15': d.formularios.formulario[0].respuestas.respuesta[2].textoRespuesta ? d.formularios.formulario[0].respuestas.respuesta[2].textoRespuesta[3] : '',
										'SPQ9-C16': d.formularios.formulario[0].respuestas.respuesta[3].textoRespuesta ? d.formularios.formulario[0].respuestas.respuesta[3].textoRespuesta[3] : '',
										'SPQ9-C17': d.formularios.formulario[0].respuestas.respuesta[0].textoRespuesta ? d.formularios.formulario[0].respuestas.respuesta[0].textoRespuesta[4] : '',
										'SPQ9-C18': d.formularios.formulario[0].respuestas.respuesta[1].textoRespuesta ? d.formularios.formulario[0].respuestas.respuesta[1].textoRespuesta[4] : '',
										'SPQ9-C19': d.formularios.formulario[0].respuestas.respuesta[2].textoRespuesta ? d.formularios.formulario[0].respuestas.respuesta[2].textoRespuesta[4] : '',
										'SPQ9-C20': d.formularios.formulario[0].respuestas.respuesta[3].textoRespuesta ? d.formularios.formulario[0].respuestas.respuesta[3].textoRespuesta[4] : ''
									}
								});
								break;
							case 10:
								answers = _extends({}, answers, {
									'SPQ-10': {
										'SPQ10-C1': d.formularios.formulario[0].respuestas.respuesta[0].textoRespuesta ? d.formularios.formulario[0].respuestas.respuesta[0].textoRespuesta[0] : '',
										'SPQ10-C2': d.formularios.formulario[0].respuestas.respuesta[1].textoRespuesta ? d.formularios.formulario[0].respuestas.respuesta[1].textoRespuesta[0] : '',
										'SPQ10-C3': d.formularios.formulario[0].respuestas.respuesta[2].textoRespuesta ? d.formularios.formulario[0].respuestas.respuesta[2].textoRespuesta[0] : '',
										'SPQ10-C4': d.formularios.formulario[0].respuestas.respuesta[3].textoRespuesta ? d.formularios.formulario[0].respuestas.respuesta[3].textoRespuesta[0] : ''
									}
								});
								break;
							case 11:
								answers = _extends({}, answers, {
									'SPQ-11': {
										'SPQ11-C1': d.formularios.formulario[0].respuestas.respuesta[0].textoRespuesta ? d.formularios.formulario[0].respuestas.respuesta[0].textoRespuesta[0] : '',
										'SPQ11-C2': d.formularios.formulario[0].respuestas.respuesta[1].textoRespuesta ? d.formularios.formulario[0].respuestas.respuesta[1].textoRespuesta[0] : ''
									}
								});
								break;
							case 12:
								answers = _extends({}, answers, {
									'SPQ-12': {
										'SPQ12-C1': d.formularios.formulario[0].respuestas.respuesta[0].textoRespuesta ? d.formularios.formulario[0].respuestas.respuesta[0].textoRespuesta[0] : '',
										'SPQ12-C2': d.formularios.formulario[0].respuestas.respuesta[1].textoRespuesta ? d.formularios.formulario[0].respuestas.respuesta[1].textoRespuesta[0] : '',
										'SPQ12-C3': d.formularios.formulario[0].respuestas.respuesta[2].textoRespuesta ? d.formularios.formulario[0].respuestas.respuesta[2].textoRespuesta[0] : '',
										'SPQ12-C4': d.formularios.formulario[0].respuestas.respuesta[3].textoRespuesta ? d.formularios.formulario[0].respuestas.respuesta[3].textoRespuesta[0] : '',
										'SPQ12-C5': d.formularios.formulario[0].respuestas.respuesta[4].textoRespuesta ? d.formularios.formulario[0].respuestas.respuesta[4].textoRespuesta[0] : ''
									}
								});
								break;
							case 13:
								answers = _extends({}, answers, {
									'SPQ-13': {
										'SPQ13-C1': d.formularios.formulario[0].respuestas.respuesta[0].textoRespuesta ? d.formularios.formulario[0].respuestas.respuesta[0].textoRespuesta[0] : '',
										'SPQ13-C2': d.formularios.formulario[0].respuestas.respuesta[1].textoRespuesta ? d.formularios.formulario[0].respuestas.respuesta[1].textoRespuesta[0] : '',
										'SPQ13-C3': d.formularios.formulario[0].respuestas.respuesta[2].textoRespuesta ? d.formularios.formulario[0].respuestas.respuesta[2].textoRespuesta[0] : '',
										'SPQ13-C4': d.formularios.formulario[0].respuestas.respuesta[3].textoRespuesta ? d.formularios.formulario[0].respuestas.respuesta[3].textoRespuesta[0] : '',
										'SPQ13-C5': d.formularios.formulario[0].respuestas.respuesta[4].textoRespuesta ? d.formularios.formulario[0].respuestas.respuesta[4].textoRespuesta[0] : ''
									}
								});
								break;
							case 14:
								answers = _extends({}, answers, {
									'SPQ-14': {
										'SPQ14-C1': d.formularios.formulario[0].respuestas.respuesta[0].textoRespuesta ? d.formularios.formulario[0].respuestas.respuesta[0].textoRespuesta[0] : '',
										'SPQ14-C2': d.formularios.formulario[0].respuestas.respuesta[1].textoRespuesta ? d.formularios.formulario[0].respuestas.respuesta[1].textoRespuesta[0] : '',
										'SPQ14-C3': d.formularios.formulario[0].respuestas.respuesta[2].textoRespuesta ? d.formularios.formulario[0].respuestas.respuesta[2].textoRespuesta[0] : '',
										'SPQ14-C4': d.formularios.formulario[0].respuestas.respuesta[3].textoRespuesta ? d.formularios.formulario[0].respuestas.respuesta[3].textoRespuesta[0] : '',
										'SPQ14-C5': d.formularios.formulario[0].respuestas.respuesta[4].textoRespuesta ? d.formularios.formulario[0].respuestas.respuesta[4].textoRespuesta[0] : ''
									}
								});
								break;
							default:
						}
					} else if (tipo === 2) {
						//Abierta
						answers = _extends({}, answers, _defineProperty({}, 'PA-' + d.idPregunta, d.formularios.formulario[0].respuestas.respuesta[0].textoRespuesta ? d.formularios.formulario[0].respuestas.respuesta[0].textoRespuesta : ''));
					} else if (tipo === 3) {
						//Cerrada
						answers = _extends({}, answers, _defineProperty({}, 'PC-' + d.idPregunta, d.formularios.formulario[0].respuestas.respuesta[0].textoRespuesta ? parseInt(d.formularios.formulario[0].respuestas.respuesta[0].textoRespuesta) : ''));
					} else if (tipo === 4) {
						var _extends8;

						//Cerrada con comentario
						answers = _extends({}, answers, (_extends8 = {}, _defineProperty(_extends8, 'PCCR-' + d.idPregunta, d.formularios.formulario[0].respuestas.respuesta[0].textoRespuesta ? parseInt(d.formularios.formulario[0].respuestas.respuesta[0].textoRespuesta) : ''), _defineProperty(_extends8, 'PCC-' + d.idPregunta, d.formularios.formulario[0].respuestas.respuesta[1].textoRespuesta ? d.formularios.formulario[0].respuestas.respuesta[1].textoRespuesta : ''), _extends8));
					}
				});
			}
			dispatch({ type: GET_QUESTIONS, Obj: data });
			dispatch({ type: SET_ANSWERS, Obj: answers });
		}).catch(function (error) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
			throw error;
		});
	};
};

var saveQuestions = exports.saveQuestions = function saveQuestions(form, id, tipo, idPadre) {
	var idDonataria = form.idDonataria,
	    idCorrida = form.idCorrida,
	    idProyecto = form.idProyecto;

	var obj = {
		idDonataria: idDonataria,
		idCorrida: idCorrida,
		idProyecto: idProyecto
	};
	if (tipo === 1) {
		//Especial

		switch (idPadre) {
			case 1:
				obj = _extends({}, obj, {
					pregunta: {
						idPregunta: id,
						formularios: {
							formulario: [{
								idFormulario: 1,
								respuestas: {
									respuesta: [{
										idRespuesta: 1,
										textoRespuesta: form['SPQ-1']['SPQ1-C1']
									}, {
										idRespuesta: 2,
										textoRespuesta: form['SPQ-1']['SPQ1-C2']
									}]
								}
							}]
						}
					}
				});
				break;
			case 2:
				{

					var objetivos = form["SPQ-2"].objetivos;

					var metasArr = function metasArr(idObjetivo) {
						var objetivo = Utils.getItem(objetivos, { id: idObjetivo });
						return objetivo.metas.map(function (m) {
							return m.meta.idMeta;
						});
					};

					var indicadoresArr = function indicadoresArr(idObjetivo, param) {
						var objetivo = Utils.getItem(objetivos, { id: idObjetivo });
						return objetivo.metas.map(function (m) {
							return m[param];
						});
					};

					var respuesta = [{
						idRespuesta: 1,
						textoRespuesta: [objetivos[0].objetivo.idObjetivo]
					}, {
						idRespuesta: 2,
						textoRespuesta: metasArr(objetivos[0].objetivo.idObjetivo)
					}, {
						idRespuesta: 3,
						textoRespuesta: indicadoresArr(objetivos[0].objetivo.idObjetivo, 'idIndicadoresCobertura')
					}, {
						idRespuesta: 4,
						textoRespuesta: indicadoresArr(objetivos[0].objetivo.idObjetivo, 'idIndicadoresCoberturaMetas')
					}, {
						idRespuesta: 5,
						textoRespuesta: indicadoresArr(objetivos[0].objetivo.idObjetivo, 'idIndicadoresResultados').map(function (i) {
							if (!i) {
								i = "0";
							}
							return i;
						})
					}, {
						idRespuesta: 6,
						textoRespuesta: indicadoresArr(objetivos[0].objetivo.idObjetivo, 'idIndicadoresResultadosMetas').map(function (i) {
							if (!i) {
								i = "0";
							}
							return i;
						})
					}, {
						idRespuesta: 7,
						textoRespuesta: objetivos.length > 1 ? [objetivos[1].objetivo.idObjetivo] : ['']
					}, {
						idRespuesta: 8,
						textoRespuesta: objetivos.length > 1 ? metasArr(objetivos[1].objetivo.idObjetivo) : ['', '']
					}, {
						idRespuesta: 9,
						textoRespuesta: objetivos.length > 1 ? indicadoresArr(objetivos[1].objetivo.idObjetivo, 'idIndicadoresCobertura') : ['', '']
					}, {
						idRespuesta: 10,
						textoRespuesta: objetivos.length > 1 ? indicadoresArr(objetivos[1].objetivo.idObjetivo, 'idIndicadoresCoberturaMetas') : ['', '']
					}, {
						idRespuesta: 11,
						textoRespuesta: objetivos.length > 1 ? indicadoresArr(objetivos[1].objetivo.idObjetivo, 'idIndicadoresResultados').map(function (i) {
							if (!i) {
								i = "0";
							}
							return i;
						}) : ['', '']
					}, {
						idRespuesta: 12,
						textoRespuesta: objetivos.length > 1 ? indicadoresArr(objetivos[1].objetivo.idObjetivo, 'idIndicadoresResultadosMetas').map(function (i) {
							if (!i) {
								i = "0";
							}
							return i;
						}) : ['', '']
					}];

					obj = _extends({}, obj, {
						pregunta: {
							idPregunta: id,
							formularios: {
								formulario: [{
									idFormulario: 1,
									respuestas: {
										respuesta: respuesta
									}
								}]
							}
						}
					});
				}

				break;
			case 3:
				obj = _extends({}, obj, {
					"pregunta": {
						"idPregunta": id,
						"formularios": {
							"formulario": [{
								"idFormulario": 1,
								"respuestas": {
									"respuesta": [{
										"idRespuesta": 1,
										"textoRespuesta": [form['SPQ-3']['SPQ3-C1'] || 0, form['SPQ-3']['SPQ3-C3'] || 0, form['SPQ-3']['SPQ3-C5'] || 0, form['SPQ-3']['SPQ3-C7'] || 0, form['SPQ-3']['SPQ3-C9'] || 0, form['SPQ-3']['SPQ3-C11'] || 0, form['SPQ-3']['SPQ3-C13'] || 0]
									}, {
										"idRespuesta": 2,
										"textoRespuesta": [form['SPQ-3']['SPQ3-C2'] || 0, form['SPQ-3']['SPQ3-C4'] || 0, form['SPQ-3']['SPQ3-C6'] || 0, form['SPQ-3']['SPQ3-C8'] || 0, form['SPQ-3']['SPQ3-C10'] || 0, form['SPQ-3']['SPQ3-C12'] || 0, form['SPQ-3']['SPQ3-C14'] || 0]
									}, {
										"idRespuesta": 3,
										"textoRespuesta": [form['SPQ-3']['SPQ3-C22'] || 0, form['SPQ-3']['SPQ3-C23'] || 0, form['SPQ-3']['SPQ3-C24'] || 0, form['SPQ-3']['SPQ3-C25'] || 0, form['SPQ-3']['SPQ3-C26'] || 0, form['SPQ-3']['SPQ3-C27'] || 0, form['SPQ-3']['SPQ3-C28'] || 0]
									}]
								}
							}, {
								"idFormulario": 2,
								"respuestas": {
									"respuesta": [{
										"idRespuesta": 1,
										"textoRespuesta": [form['SPQ-3']['SPQ3-C15'] || 0, form['SPQ-3']['SPQ3-C16'] || 0, form['SPQ-3']['SPQ3-C17'] || 0, form['SPQ-3']['SPQ3-C18'] || 0]
									}, {
										"idRespuesta": 2,
										"textoRespuesta": [form['SPQ-3']['SPQ3-C33'] || 0, form['SPQ-3']['SPQ3-C35'] || 0, form['SPQ-3']['SPQ3-C37'] || 0, form['SPQ-3']['SPQ3-C39'] || 0]
									}, {
										"idRespuesta": 3,
										"textoRespuesta": [form['SPQ-3']['SPQ3-C34'] || 0, form['SPQ-3']['SPQ3-C36'] || 0, form['SPQ-3']['SPQ3-C38'] || 0, form['SPQ-3']['SPQ3-C40'] || 0]
									}]
								}
							}, {
								"idFormulario": 3,
								"respuestas": {
									"respuesta": [{
										"idRespuesta": 1,
										"textoRespuesta": form['SPQ-3']['SPQ3-C20'].toString() || ''
									}, {
										"idRespuesta": 2,
										"textoRespuesta": form['SPQ-3']['SPQ3-C20'] === 1 ? form['SPQ-3']['SPQ3-C21'] : ''
									}]
								}
							}, {
								"idFormulario": 4,
								"respuestas": {
									"respuesta": [{
										"idRespuesta": 1,
										"textoRespuesta": form["SPQ-3"]["SPQ3-C31"] === 1 ? form['SPQ-3']['SPQ3-C19'] : 0 || 0
									}]
								}
							}, {
								"idFormulario": 5,
								"respuestas": {
									"respuesta": [{
										"idRespuesta": 1,
										"textoRespuesta": form['SPQ-3']['SPQ3-C29'].toString() || ''
									}, {
										"idRespuesta": 2,
										"textoRespuesta": form['SPQ-3']['SPQ3-C29'] === 1 ? form['SPQ-3']['SPQ3-C30'] : ''
									}]
								}
							}, {
								"idFormulario": 6,
								"respuestas": {
									"respuesta": [{
										"idRespuesta": 1,
										"textoRespuesta": form['SPQ-3']['SPQ3-C31'].toString() || ''
									}, {
										"idRespuesta": 2,
										"textoRespuesta": form['SPQ-3']['SPQ3-C31'] === 1 ? form['SPQ-3']['SPQ3-C32'] : ''
									}, {
										"idRespuesta": 3,
										"textoRespuesta": form['SPQ-3']['SPQ3-C31'] === 1 ? form['SPQ-3']['SPQ3-C63'] : ''
									}]
								}
							}, {
								"idFormulario": 7,
								"respuestas": {
									"respuesta": [{
										"idRespuesta": 1,
										"textoRespuesta": form['SPQ-3']['SPQ3-C41'].toString() || ''
									}]
								}
							}, {
								"idFormulario": 8,
								"respuestas": {
									"respuesta": [{
										"idRespuesta": 1,
										"textoRespuesta": [form['SPQ-3']['SPQ3-C41'] === 1 || !form['SPQ-3']['SPQ3-C42'] ? 0 : form['SPQ-3']['SPQ3-C42'], form['SPQ-3']['SPQ3-C41'] === 1 || !form['SPQ-3']['SPQ3-C45'] ? 0 : form['SPQ-3']['SPQ3-C45'], form['SPQ-3']['SPQ3-C41'] === 1 || !form['SPQ-3']['SPQ3-C48'] ? 0 : form['SPQ-3']['SPQ3-C48'], form['SPQ-3']['SPQ3-C41'] === 1 || !form['SPQ-3']['SPQ3-C51'] ? 0 : form['SPQ-3']['SPQ3-C51']]
									}, {
										"idRespuesta": 2,
										"textoRespuesta": [form['SPQ-3']['SPQ3-C41'] === 1 || !form['SPQ-3']['SPQ3-C43'] ? 0 : form['SPQ-3']['SPQ3-C43'], form['SPQ-3']['SPQ3-C41'] === 1 || !form['SPQ-3']['SPQ3-C46'] ? 0 : form['SPQ-3']['SPQ3-C46'], form['SPQ-3']['SPQ3-C41'] === 1 || !form['SPQ-3']['SPQ3-C49'] ? 0 : form['SPQ-3']['SPQ3-C49'], form['SPQ-3']['SPQ3-C41'] === 1 || !form['SPQ-3']['SPQ3-C52'] ? 0 : form['SPQ-3']['SPQ3-C52']]
									}, {
										"idRespuesta": 3,
										"textoRespuesta": [form['SPQ-3']['SPQ3-C41'] === 1 || !form['SPQ-3']['SPQ3-C44'] ? 0 : form['SPQ-3']['SPQ3-C44'], form['SPQ-3']['SPQ3-C41'] === 1 || !form['SPQ-3']['SPQ3-C47'] ? 0 : form['SPQ-3']['SPQ3-C47'], form['SPQ-3']['SPQ3-C41'] === 1 || !form['SPQ-3']['SPQ3-C50'] ? 0 : form['SPQ-3']['SPQ3-C50'], form['SPQ-3']['SPQ3-C41'] === 1 || !form['SPQ-3']['SPQ3-C53'] ? 0 : form['SPQ-3']['SPQ3-C53']]
									}]
								}
							}, {
								"idFormulario": 9,
								"respuestas": {
									"respuesta": [{
										"idRespuesta": 1,
										"textoRespuesta": [form['SPQ-3']['SPQ3-C54'] || 0, form['SPQ-3']['SPQ3-C55'] || 0, form['SPQ-3']['SPQ3-C56'] || 0, form['SPQ-3']['SPQ3-C57'] || 0, form['SPQ-3']['SPQ3-C58'] || 0, form['SPQ-3']['SPQ3-C59'] || 0, form['SPQ-3']['SPQ3-C60'] || 0]
									}, {
										"idRespuesta": 2,
										"textoRespuesta": [form['SPQ-3']['SPQ3-C55'] * 1 === 0 || form['SPQ-3']['SPQ3-C55'] === null ? "." : form['SPQ-3']['SPQ3-C61'], form['SPQ-3']['SPQ3-C60'] * 1 === 0 || form['SPQ-3']['SPQ3-C60'] === null ? "." : form['SPQ-3']['SPQ3-C62']]
									}]
								}
							}]
						}
					}
				});
				break;
			case 4:
				{

					var _objetivos = form["SPQ-2"].objetivos;

					var _metasArr = function _metasArr(idObjetivo) {
						var objetivo = Utils.getItem(_objetivos, { id: idObjetivo });
						return objetivo.metas.map(function (m) {
							return m.meta.idMeta;
						});
					};

					var _indicadoresArr = function _indicadoresArr(idObjetivo, param) {
						var objetivo = Utils.getItem(_objetivos, { id: idObjetivo });
						return objetivo.metas.map(function (m) {
							return m[param];
						});
					};

					var prodCobertura = function prodCobertura(idObjetivo) {
						var objetivo = Utils.getItem(_objetivos, { id: idObjetivo });
						return objetivo.metas.map(function (m) {
							return form["SPQ-4"]['SPQ4-CP' + m.meta.idMeta];
						});
					};

					var procesosCobertura = function procesosCobertura(idObjetivo) {
						var objetivo = Utils.getItem(_objetivos, { id: idObjetivo });
						return objetivo.metas.map(function (m) {
							return form["SPQ-4"]['SPQ4-CC' + m.meta.idMeta];
						});
					};

					var productosArr = function productosArr(idObjetivo, param) {
						var objetivo = Utils.getItem(_objetivos, { id: idObjetivo });
						return objetivo.metas.map(function (m) {
							return m[param].split(",").map(function (i) {
								return form["SPQ-4"]['SPQ4-RP' + i];
							}).toString().replace(/,/g, "|");
						});
					};

					var procesosArr = function procesosArr(idObjetivo, param) {
						var objetivo = Utils.getItem(_objetivos, { id: idObjetivo });
						return objetivo.metas.map(function (m) {
							return m[param].split(",").map(function (i) {
								return form["SPQ-4"]['SPQ4-RC' + i];
							}).toString().replace(/,/g, "|");
						});
					};

					var _respuesta = [{
						idRespuesta: 1,
						textoRespuesta: _metasArr(_objetivos[0].objetivo.idObjetivo)
					}, {
						idRespuesta: 2,
						textoRespuesta: _indicadoresArr(_objetivos[0].objetivo.idObjetivo, 'idIndicadoresCobertura')
					}, {
						idRespuesta: 3,
						textoRespuesta: prodCobertura(_objetivos[0].objetivo.idObjetivo)
					}, {
						idRespuesta: 4,
						textoRespuesta: procesosCobertura(_objetivos[0].objetivo.idObjetivo)
					}, {
						idRespuesta: 5,
						textoRespuesta: _indicadoresArr(_objetivos[0].objetivo.idObjetivo, 'idIndicadoresResultados').map(function (i) {
							if (!i) {
								i = "0";
							}
							return i;
						})
					}, {
						idRespuesta: 6,
						textoRespuesta: productosArr(_objetivos[0].objetivo.idObjetivo, 'idIndicadoresResultados').map(function (i) {
							if (!i) {
								i = "0";
							}
							return i;
						})
					}, {
						idRespuesta: 7,
						textoRespuesta: procesosArr(_objetivos[0].objetivo.idObjetivo, 'idIndicadoresResultados').map(function (i) {
							if (!i) {
								i = "0";
							}
							return i;
						})
					}, {
						idRespuesta: 8,
						textoRespuesta: _objetivos.length > 1 ? _metasArr(_objetivos[1].objetivo.idObjetivo) : ['', '']
					}, {
						idRespuesta: 9,
						textoRespuesta: _objetivos.length > 1 ? _indicadoresArr(_objetivos[1].objetivo.idObjetivo, 'idIndicadoresCobertura') : ['', '']
					}, {
						idRespuesta: 10,
						textoRespuesta: _objetivos.length > 1 ? prodCobertura(_objetivos[1].objetivo.idObjetivo) : ['', '']
					}, {
						idRespuesta: 11,
						textoRespuesta: _objetivos.length > 1 ? procesosCobertura(_objetivos[1].objetivo.idObjetivo) : ['', '']
					}, {
						idRespuesta: 12,
						textoRespuesta: _objetivos.length > 1 ? _indicadoresArr(_objetivos[1].objetivo.idObjetivo, 'idIndicadoresResultados').map(function (i) {
							if (!i) {
								i = "0";
							}
							return i;
						}) : ['', '']
					}, {
						idRespuesta: 13,
						textoRespuesta: _objetivos.length > 1 ? productosArr(_objetivos[1].objetivo.idObjetivo, 'idIndicadoresResultados').map(function (i) {
							if (!i) {
								i = "0";
							}
							return i;
						}) : ['', '']
					}, {
						idRespuesta: 14,
						textoRespuesta: _objetivos.length > 1 ? procesosArr(_objetivos[1].objetivo.idObjetivo, 'idIndicadoresResultados').map(function (i) {
							if (!i) {
								i = "0";
							}
							return i;
						}) : ['', '']
					}];

					obj = _extends({}, obj, {
						pregunta: {
							idPregunta: id,
							formularios: {
								formulario: [{
									idFormulario: 1,
									respuestas: {
										respuesta: _respuesta
									}
								}]
							}
						}
					});
				}
				break;
			case 5:
				obj = _extends({}, obj, {
					pregunta: {
						idPregunta: id,
						formularios: {
							formulario: [{
								idFormulario: 1,
								respuestas: {
									respuesta: [{
										idRespuesta: 1,
										textoRespuesta: form['SPQ-5']['SPQ5-C1']
									}, {
										idRespuesta: 2,
										textoRespuesta: form['SPQ-5']['SPQ5-C2']
									}, {
										idRespuesta: 3,
										textoRespuesta: form['SPQ-5']['SPQ5-C3']
									}, {
										idRespuesta: 4,
										textoRespuesta: ''
									}, {
										idRespuesta: 5,
										textoRespuesta: form['SPQ-5']['SPQ5-C4']
									}, {
										idRespuesta: 6,
										textoRespuesta: form['SPQ-5']['SPQ5-C5']
									}]
								}
							}, {
								idFormulario: 2,
								respuestas: {
									respuesta: [{
										idRespuesta: 1,
										textoRespuesta: form['SPQ-5']['SPQ5-C9'] * 1 === 1 ? form['SPQ-5']['SPQ5-C6'] : ""
									}, {
										idRespuesta: 2,
										textoRespuesta: form['SPQ-5']['SPQ5-C9'] * 1 === 1 ? form['SPQ-5']['SPQ5-C7'] : ""
									}, {
										idRespuesta: 3,
										textoRespuesta: form['SPQ-5']['SPQ5-C9'] * 1 === 1 ? form["SPQ-5"]["SPQ5-C7"] === "Otro (Especifique)" ? form['SPQ-5']['SPQ5-C8'] : "" : ""
									}, {
										idRespuesta: 4,
										textoRespuesta: form['SPQ-5']['SPQ5-C9']
									}]
								}
							}, {
								idFormulario: 3,
								respuestas: {
									respuesta: [{
										idRespuesta: 1,
										textoRespuesta: form['SPQ-5']['SPQ5-C13'] * 1 === 1 ? form['SPQ-5']['SPQ5-C10'] : ""
									}, {
										idRespuesta: 2,
										textoRespuesta: form['SPQ-5']['SPQ5-C13'] * 1 === 1 ? form['SPQ-5']['SPQ5-C11'] : ""
									}, {
										idRespuesta: 3,
										textoRespuesta: form['SPQ-5']['SPQ5-C13'] * 1 === 1 ? form["SPQ-5"]["SPQ5-C11"] === "Otro (Especifique)" ? form['SPQ-5']['SPQ5-C12'] : "" : ""
									}, {
										idRespuesta: 4,
										textoRespuesta: form['SPQ-5']['SPQ5-C13']
									}]
								}
							}, {
								idFormulario: 4,
								respuestas: {
									respuesta: [{
										idRespuesta: 1,
										textoRespuesta: form['SPQ-5']['SPQ5-C17'] * 1 === 1 ? form['SPQ-5']['SPQ5-C14'] : ""
									}, {
										idRespuesta: 2,
										textoRespuesta: form['SPQ-5']['SPQ5-C17'] * 1 === 1 ? form['SPQ-5']['SPQ5-C15'] : ""
									}, {
										idRespuesta: 3,
										textoRespuesta: form['SPQ-5']['SPQ5-C17'] * 1 === 1 ? form["SPQ-5"]["SPQ5-C15"] === "Otro (Especifique)" ? form['SPQ-5']['SPQ5-C16'] : "" : ""
									}, {
										idRespuesta: 4,
										textoRespuesta: form['SPQ-5']['SPQ5-C17']
									}]
								}
							}, {
								idFormulario: 5,
								respuestas: {
									respuesta: [{
										idRespuesta: 1,
										textoRespuesta: form['SPQ-5']['SPQ5-C21'] * 1 === 1 ? form['SPQ-5']['SPQ5-C18'] : ""
									}, {
										idRespuesta: 2,
										textoRespuesta: form['SPQ-5']['SPQ5-C21'] * 1 === 1 ? form['SPQ-5']['SPQ5-C19'] : ""
									}, {
										idRespuesta: 3,
										textoRespuesta: form['SPQ-5']['SPQ5-C21'] * 1 === 1 ? form["SPQ-5"]["SPQ5-C19"] === "Otro (Especifique)" ? form['SPQ-5']['SPQ5-C20'] : "" : ""
									}, {
										idRespuesta: 4,
										textoRespuesta: form['SPQ-5']['SPQ5-C21']
									}]
								}
							}, {
								idFormulario: 6,
								respuestas: {
									respuesta: [{
										idRespuesta: 1,
										textoRespuesta: form['SPQ-5']['SPQ5-C25'] * 1 === 1 ? form['SPQ-5']['SPQ5-C22'] : ""
									}, {
										idRespuesta: 2,
										textoRespuesta: form['SPQ-5']['SPQ5-C25'] * 1 === 1 ? form['SPQ-5']['SPQ5-C23'] : ""
									}, {
										idRespuesta: 3,
										textoRespuesta: form['SPQ-5']['SPQ5-C25'] * 1 === 1 ? form["SPQ-5"]["SPQ5-C23"] === "Otro (Especifique)" ? form['SPQ-5']['SPQ5-C24'] : "" : ""
									}, {
										idRespuesta: 4,
										textoRespuesta: form['SPQ-5']['SPQ5-C25']
									}]
								}
							}]
						}
					}
				});
				break;
			case 6:
				obj = _extends({}, obj, {
					pregunta: {
						idPregunta: id,
						formularios: {
							formulario: [{
								idFormulario: 1,
								respuestas: {
									respuesta: [{
										idRespuesta: 1,
										textoRespuesta: form['SPQ-6']['SPQ6-C1']
									}, {
										idRespuesta: 2,
										textoRespuesta: form['SPQ-6']['SPQ6-C2']
									}, {
										idRespuesta: 3,
										textoRespuesta: form['SPQ-6']['SPQ6-C3']
									}, {
										idRespuesta: 4,
										textoRespuesta: ''
									}, {
										idRespuesta: 5,
										textoRespuesta: form['SPQ-6']['SPQ6-C4']
									}, {
										idRespuesta: 6,
										textoRespuesta: form['SPQ-6']['SPQ6-C5']
									}]
								}
							}, {
								idFormulario: 2,
								respuestas: {
									respuesta: [{
										idRespuesta: 1,
										textoRespuesta: form['SPQ-6']['SPQ6-C6']
									}, {
										idRespuesta: 2,
										textoRespuesta: form['SPQ-6']['SPQ6-C7']
									}, {
										idRespuesta: 3,
										textoRespuesta: form['SPQ-6']['SPQ6-C8']
									}, {
										idRespuesta: 4,
										textoRespuesta: form['SPQ-6']['SPQ6-C9']
									}, {
										idRespuesta: 5,
										textoRespuesta: form['SPQ-6']['SPQ6-C10']
									}, {
										idRespuesta: 6,
										textoRespuesta: form['SPQ-6']['SPQ6-C11']
									}, {
										idRespuesta: 7,
										textoRespuesta: form['SPQ-6']['SPQ6-C11'] * 1 === 0 ? "" : form['SPQ-6']['SPQ6-C12']
									}, {
										idRespuesta: 8,
										textoRespuesta: form['SPQ-6']['SPQ6-C11'] * 1 === 0 ? "" : form['SPQ-6']['SPQ6-C13']
									}, {
										idRespuesta: 9,
										textoRespuesta: form['SPQ-6']['SPQ6-C11'] * 1 === 0 ? "" : form['SPQ-6']['SPQ6-C14']
									}, {
										idRespuesta: 10,
										textoRespuesta: form['SPQ-6']['SPQ6-C11'] * 1 === 0 ? "" : form['SPQ-6']['SPQ6-C15']
									}]
								}
							}, {
								idFormulario: 3,
								respuestas: {
									respuesta: [{
										idRespuesta: 1,
										textoRespuesta: form['SPQ-6']['SPQ6-C16']
									}, {
										idRespuesta: 2,
										textoRespuesta: form['SPQ-6']['SPQ6-C17']
									}, {
										idRespuesta: 3,
										textoRespuesta: form['SPQ-6']['SPQ6-C18']
									}, {
										idRespuesta: 4,
										textoRespuesta: form['SPQ-6']['SPQ6-C19']
									}, {
										idRespuesta: 5,
										textoRespuesta: form['SPQ-6']['SPQ6-C20']
									}, {
										idRespuesta: 6,
										textoRespuesta: form['SPQ-6']['SPQ6-C21']
									}, {
										idRespuesta: 7,
										textoRespuesta: form['SPQ-6']['SPQ6-C21'] * 1 === 0 ? "" : form['SPQ-6']['SPQ6-C22']
									}, {
										idRespuesta: 8,
										textoRespuesta: form['SPQ-6']['SPQ6-C21'] * 1 === 0 ? "" : form['SPQ-6']['SPQ6-C23']
									}, {
										idRespuesta: 9,
										textoRespuesta: form['SPQ-6']['SPQ6-C21'] * 1 === 0 ? "" : form['SPQ-6']['SPQ6-C24']
									}, {
										idRespuesta: 10,
										textoRespuesta: form['SPQ-6']['SPQ6-C21'] * 1 === 0 ? "" : form['SPQ-6']['SPQ6-C25']
									}]
								}
							}, {
								idFormulario: 4,
								respuestas: {
									respuesta: [{
										idRespuesta: 1,
										textoRespuesta: form['SPQ-6']['SPQ6-C26']
									}, {
										idRespuesta: 2,
										textoRespuesta: form['SPQ-6']['SPQ6-C27']
									}, {
										idRespuesta: 3,
										textoRespuesta: form['SPQ-6']['SPQ6-C28']
									}, {
										idRespuesta: 4,
										textoRespuesta: form['SPQ-6']['SPQ6-C29']
									}, {
										idRespuesta: 5,
										textoRespuesta: form['SPQ-6']['SPQ6-C30']
									}, {
										idRespuesta: 6,
										textoRespuesta: form['SPQ-6']['SPQ6-C31']
									}, {
										idRespuesta: 7,
										textoRespuesta: form['SPQ-6']['SPQ6-C31'] * 1 === 0 ? "" : form['SPQ-6']['SPQ6-C32']
									}, {
										idRespuesta: 8,
										textoRespuesta: form['SPQ-6']['SPQ6-C31'] * 1 === 0 ? "" : form['SPQ-6']['SPQ6-C33']
									}, {
										idRespuesta: 9,
										textoRespuesta: form['SPQ-6']['SPQ6-C31'] * 1 === 0 ? "" : form['SPQ-6']['SPQ6-C34']
									}, {
										idRespuesta: 10,
										textoRespuesta: form['SPQ-6']['SPQ6-C31'] * 1 === 0 ? "" : form['SPQ-6']['SPQ6-C35']
									}]
								}
							}]
						}
					}
				});
				break;
			case 7:
				obj = _extends({}, obj, {
					pregunta: {
						idPregunta: id,
						formularios: {
							formulario: [{
								idFormulario: 1,
								respuestas: {
									respuesta: [{
										idRespuesta: 1,
										textoRespuesta: form['SPQ-7']['SPQ7-C1']
									}, {
										idRespuesta: 2,
										textoRespuesta: form['SPQ-7']['SPQ7-C2']
									}, {
										idRespuesta: 3,
										textoRespuesta: form['SPQ-7']['SPQ7-C3']
									}, {
										idRespuesta: 4,
										textoRespuesta: form['SPQ-7']['SPQ7-C4']
									}, {
										idRespuesta: 5,
										textoRespuesta: ''
									}, {
										idRespuesta: 6,
										textoRespuesta: form['SPQ-7']['SPQ7-C5']
									}, {
										idRespuesta: 7,
										textoRespuesta: form['SPQ-7']['SPQ7-C6']
									}]
								}
							}]
						}
					}
				});
				break;
			case 8:
				{

					var _objetivos2 = form["SPQ-2"].objetivos;
					var indicadores = form["SPQ-8"].obj;

					var _indicadoresArr2 = function _indicadoresArr2(idObjetivo, param) {
						var objetivo = Utils.getItem(_objetivos2, { id: idObjetivo });
						return objetivo.metas.map(function (m) {
							return m[param];
						});
					};

					var evaluacionArr = function evaluacionArr(idObjetivo) {
						var indicador = Utils.getItem(indicadores, { id: idObjetivo });
						if (!indicador) {
							return ['', ''];
						} else {
							return indicador.indicadores.map(function (m) {
								return m.evaluacion;
							});
						}
					};

					var verificacionArr = function verificacionArr(idObjetivo) {
						var indicador = Utils.getItem(indicadores, { id: idObjetivo });
						if (!indicador) {
							return ['', ''];
						} else {
							return indicador.indicadores.map(function (m) {
								return m.verificacion;
							});
						}
					};

					var _respuesta2 = [{
						idRespuesta: 1,
						textoRespuesta: _indicadoresArr2(_objetivos2[0].objetivo.idObjetivo, 'idIndicadoresResultados')
					}, {
						idRespuesta: 2,
						textoRespuesta: evaluacionArr(_objetivos2[0].objetivo.idObjetivo, 'idIndicadoresResultados')
					}, {
						idRespuesta: 3,
						textoRespuesta: verificacionArr(_objetivos2[0].objetivo.idObjetivo, 'idIndicadoresResultados')
					}, {
						idRespuesta: 4,
						textoRespuesta: _objetivos2.length > 1 ? _indicadoresArr2(_objetivos2[1].objetivo.idObjetivo, 'idIndicadoresResultados') : ['', '']
					}, {
						idRespuesta: 5,
						textoRespuesta: _objetivos2.length > 1 ? evaluacionArr(_objetivos2[1].objetivo.idObjetivo, 'idIndicadoresResultados') : ['', '']
					}, {
						idRespuesta: 6,
						textoRespuesta: _objetivos2.length > 1 ? verificacionArr(_objetivos2[1].objetivo.idObjetivo, 'idIndicadoresResultados') : ['', '']
					}];

					obj = _extends({}, obj, {
						pregunta: {
							idPregunta: id,
							formularios: {
								formulario: [{
									idFormulario: 1,
									respuestas: {
										respuesta: _respuesta2
									}
								}]
							}
						}
					});
				}
				break;
			case 9:
				obj = _extends({}, obj, {
					pregunta: {
						idPregunta: id,
						formularios: {
							formulario: [{
								idFormulario: 1,
								respuestas: {
									respuesta: [{
										idRespuesta: 1,
										textoRespuesta: [form['SPQ-9']['SPQ9-C1'], form['SPQ-9']['SPQ9-C5'] ? form['SPQ-9']['SPQ9-C5'] : '', form['SPQ-9']['SPQ9-C9'] ? form['SPQ-9']['SPQ9-C9'] : '', form['SPQ-9']['SPQ9-C13'] ? form['SPQ-9']['SPQ9-C13'] : '', form['SPQ-9']['SPQ9-C17'] ? form['SPQ-9']['SPQ9-C17'] : '']
									}, {
										idRespuesta: 2,
										textoRespuesta: [form['SPQ-9']['SPQ9-C2'], form['SPQ-9']['SPQ9-C6'] ? form['SPQ-9']['SPQ9-C6'] : '', form['SPQ-9']['SPQ9-C10'] ? form['SPQ-9']['SPQ9-C10'] : '', form['SPQ-9']['SPQ9-C14'] ? form['SPQ-9']['SPQ9-C14'] : '', form['SPQ-9']['SPQ9-C18'] ? form['SPQ-9']['SPQ9-C18'] : '']
									}, {
										idRespuesta: 3,
										textoRespuesta: [form['SPQ-9']['SPQ9-C3'], form['SPQ-9']['SPQ9-C7'] ? form['SPQ-9']['SPQ9-C7'] : '', form['SPQ-9']['SPQ9-C11'] ? form['SPQ-9']['SPQ9-C11'] : '', form['SPQ-9']['SPQ9-C15'] ? form['SPQ-9']['SPQ9-C15'] : '', form['SPQ-9']['SPQ9-C19'] ? form['SPQ-9']['SPQ9-C19'] : '']
									}, {
										idRespuesta: 4,
										textoRespuesta: [form['SPQ-9']['SPQ9-C4'], form['SPQ-9']['SPQ9-C8'] ? form['SPQ-9']['SPQ9-C8'] : '', form['SPQ-9']['SPQ9-C12'] ? form['SPQ-9']['SPQ9-C12'] : '', form['SPQ-9']['SPQ9-C16'] ? form['SPQ-9']['SPQ9-C16'] : '', form['SPQ-9']['SPQ9-C20'] ? form['SPQ-9']['SPQ9-C20'] : '']
									}]
								}
							}]
						}
					}
				});
				break;
			case 10:
				obj = _extends({}, obj, {
					pregunta: {
						idPregunta: id,
						formularios: {
							formulario: [{
								idFormulario: 1,
								respuestas: {
									respuesta: [{
										idRespuesta: 1,
										textoRespuesta: form['SPQ-10']['SPQ10-C1']
									}, {
										idRespuesta: 2,
										textoRespuesta: form['SPQ-10']['SPQ10-C2']
									}, {
										idRespuesta: 3,
										textoRespuesta: form['SPQ-10']['SPQ10-C3']
									}, {
										idRespuesta: 4,
										textoRespuesta: form['SPQ-10']['SPQ10-C1'] === 'Alto' || form['SPQ-10']['SPQ10-C2'] === 'Alto' || form['SPQ-10']['SPQ10-C3'] === 'Alto' ? form['SPQ-10']['SPQ10-C4'] : ""
									}]
								}
							}]
						}
					}
				});
				break;
			case 11:
				obj = _extends({}, obj, {
					pregunta: {
						idPregunta: id,
						formularios: {
							formulario: [{
								idFormulario: 1,
								respuestas: {
									respuesta: [{
										idRespuesta: 1,
										textoRespuesta: form['SPQ-11']['SPQ11-C1']
									}, {
										idRespuesta: 2,
										textoRespuesta: form['SPQ-11']['SPQ11-C1'] === 1 ? form['SPQ-11']['SPQ11-C2'] : ""
									}]
								}
							}]
						}
					}
				});
				break;
			case 12:
				obj = _extends({}, obj, {
					pregunta: {
						idPregunta: id,
						formularios: {
							formulario: [{
								idFormulario: 1,
								respuestas: {
									respuesta: [{
										idRespuesta: 1,
										textoRespuesta: form['SPQ-12']['SPQ12-C1']
									}, {
										idRespuesta: 2,
										textoRespuesta: form['SPQ-12']['SPQ12-C2']
									}, {
										idRespuesta: 3,
										textoRespuesta: form['SPQ-12']['SPQ12-C3']
									}, {
										idRespuesta: 4,
										textoRespuesta: form['SPQ-12']['SPQ12-C4']
									}, {
										idRespuesta: 5,
										textoRespuesta: form['SPQ-12']['SPQ12-C2'] === 'Alto' || form['SPQ-12']['SPQ12-C3'] === 'Alto' || form['SPQ-12']['SPQ12-C4'] === 'Alto' ? form['SPQ-12']['SPQ12-C5'] : ""
									}]
								}
							}]
						}
					}
				});
				break;
			case 13:
				obj = _extends({}, obj, {
					pregunta: {
						idPregunta: id,
						formularios: {
							formulario: [{
								idFormulario: 1,
								respuestas: {
									respuesta: [{
										idRespuesta: 1,
										textoRespuesta: form['SPQ-13']['SPQ13-C1']
									}, {
										idRespuesta: 2,
										textoRespuesta: form['SPQ-13']['SPQ13-C2']
									}, {
										idRespuesta: 3,
										textoRespuesta: form['SPQ-13']['SPQ13-C3']
									}, {
										idRespuesta: 4,
										textoRespuesta: form['SPQ-13']['SPQ13-C4']
									}, {
										idRespuesta: 5,
										textoRespuesta: form['SPQ-13']['SPQ13-C2'] === 'Alto' || form['SPQ-13']['SPQ13-C3'] === 'Alto' || form['SPQ-13']['SPQ13-C4'] === 'Alto' ? form['SPQ-13']['SPQ13-C5'] : ""
									}]
								}
							}]
						}
					}
				});
				break;
			case 14:
				obj = _extends({}, obj, {
					pregunta: {
						idPregunta: id,
						formularios: {
							formulario: [{
								idFormulario: 1,
								respuestas: {
									respuesta: [{
										idRespuesta: 1,
										textoRespuesta: form['SPQ-14']['SPQ14-C1']
									}, {
										idRespuesta: 2,
										textoRespuesta: form['SPQ-14']['SPQ14-C2']
									}, {
										idRespuesta: 3,
										textoRespuesta: form['SPQ-14']['SPQ14-C3']
									}, {
										idRespuesta: 4,
										textoRespuesta: form['SPQ-14']['SPQ14-C4']
									}, {
										idRespuesta: 5,
										textoRespuesta: form['SPQ-14']['SPQ14-C2'] === 'Alto' || form['SPQ-14']['SPQ14-C3'] === 'Alto' || form['SPQ-14']['SPQ14-C4'] === 'Alto' ? form['SPQ-14']['SPQ14-C5'] : ""
									}]
								}
							}]
						}
					}
				});
				break;
			default:
		}
	} else if (tipo === 2) {
		//Abierta
		obj = _extends({}, obj, {
			pregunta: {
				idPregunta: id,
				formularios: {
					formulario: [{
						idFormulario: 1,
						respuestas: {
							respuesta: [{
								idRespuesta: 1,
								textoRespuesta: form['PA-' + id]
							}]
						}
					}]
				}
			}
		});
	} else if (tipo === 3) {
		//Cerrada
		obj = _extends({}, obj, {
			pregunta: {
				idPregunta: id,
				formularios: {
					formulario: [{
						idFormulario: 1,
						respuestas: {
							respuesta: [{
								idRespuesta: 1,
								textoRespuesta: form['PC-' + id]
							}]
						}
					}]
				}
			}
		});
	} else if (tipo === 4) {
		//Cerrada con comentario
		obj = _extends({}, obj, {
			pregunta: {
				idPregunta: id,
				formularios: {
					formulario: [{
						idFormulario: 1,
						respuestas: {
							respuesta: [{
								idRespuesta: 1,
								textoRespuesta: form['PCCR-' + id]
							}, {
								idRespuesta: 2,
								textoRespuesta: !form['PCC-' + id][0] ? "N/A" : form['PCC-' + id]
							}]
						}
					}]
				}
			}
		});
	}

	return function (dispatch) {

		dispatch((0, _Loading.isLoading)(true));

		return new _ClientHttpRequest2.default({
			service: 'api/saveQuestions',
			method: "POST",
			data: _extends({}, obj),
			headers: Object.assign({ "Authorization": sessionStorage.access_token, "uid": sessionStorage.uid })
		}).request().then(function (response) {
			dispatch((0, _Loading.isLoading)(false));
			return response.data;
		}).catch(function (error) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
			throw error;
		});
	};
};

var clearQuestions = exports.clearQuestions = function clearQuestions() {

	return function (dispatch) {
		dispatch({ type: GET_QUESTIONS, Obj: { preguntas: { pregunta: [] } } });
		dispatch({ type: SET_ANSWERS, Obj: {} });
		return Promise.resolve();
	};
};

var exportReport = exports.exportReport = function exportReport(form) {

	return function (dispatch) {

		dispatch((0, _Loading.isLoading)(true));

		return new _ClientHttpRequest2.default({
			service: 'api/exportReport',
			method: 'POST',
			data: _extends({}, form),
			headers: Object.assign({ "Authorization": sessionStorage.access_token, "uid": sessionStorage.uid }),
			responseType: 'arraybuffer'
		}).request().then(function (response) {
			dispatch((0, _Loading.isLoading)(false));
			var blob = new Blob([response.data], { type: 'application/pdf' });
			var fileName = 'proyecto-documento-' + Utils.getToday() + '.pdf';
			var objectUrl = URL.createObjectURL(blob);
			var a = document.createElement('a');

			a.href = objectUrl;
			a.download = fileName;
			document.body.appendChild(a);
			a.click();

			document.body.removeChild(a);
			URL.revokeObjectURL(objectUrl);
		}).catch(function (error) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
			throw error;
		});
	};
};

/***/ }),

/***/ 403:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.clearItems = exports.getDonor = exports.addItems = exports.getItems = exports.GET_DONOR = exports.GET_ITEMS = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _Utils = __webpack_require__(2);

var Utils = _interopRequireWildcard(_Utils);

var _Loading = __webpack_require__(3);

var _Modal = __webpack_require__(4);

var _ClientHttpRequest = __webpack_require__(5);

var _ClientHttpRequest2 = _interopRequireDefault(_ClientHttpRequest);

var _immutable = __webpack_require__(1);

var _immutable2 = _interopRequireDefault(_immutable);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var initialState = _immutable2.default.Map({}).set('Search', new _immutable2.default.List([])).set('Response', new _immutable2.default.Map({})).set('Get', new _immutable2.default.Map({}));

/* Types */
var GET_ITEMS = exports.GET_ITEMS = 'GET_ITEMS';
var GET_DONOR = exports.GET_DONOR = 'GET_DONOR';

/* Reducer */

exports.default = function () {
	var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	var action = arguments[1];


	switch (action.type) {
		case GET_ITEMS:
			return state.set('Get', new _immutable2.default.Map(action.Obj));
		case GET_DONOR:
			return state.set('Search', new _immutable2.default.Map(action.Obj));
		default:
			return state;
	}
};

/* Action Creators */

var getItems = exports.getItems = function getItems(form) {

	return function (dispatch) {

		dispatch((0, _Loading.isLoading)(true));

		return new _ClientHttpRequest2.default({
			service: 'api/getItems',
			method: "POST",
			data: _extends({}, form),
			headers: Object.assign({ "Authorization": sessionStorage.access_token, "uid": sessionStorage.uid })
		}).request().then(function (response) {
			dispatch((0, _Loading.isLoading)(false));

			var newRubros = [];

			if (response.data.rubrosSolicitud) {
				response.data.rubrosSolicitud.rubros.rubro.forEach(function (r) {
					r = _extends({}, r, { id: Utils.getUUID(), tmp: 'tmp', idTipoGasto: r.tipoGasto.id });
					newRubros.push(r);
				});
			}

			var formItems = {
				costoTotalProyecto: response.data.rubrosSolicitud ? response.data.rubrosSolicitud.costoTotalProyecto : '',
				montoMaximoSolicitar: response.data.rubrosSolicitud ? response.data.rubrosSolicitud.montoMaximoSolicitar : '',
				donativoPre: response.data.rubrosSolicitud ? response.data.rubrosSolicitud.donativoPre : '',
				fuentes: response.data.rubrosSolicitud ? response.data.rubrosSolicitud.fuentesFinanciamiento : '',
				rubros: newRubros
			};

			formItems.uniqueId = Utils.getUUID();
			dispatch({ type: GET_ITEMS, Obj: formItems });
			return formItems;
		}).catch(function (error) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
			throw error;
		});
	};
};

var addItems = exports.addItems = function addItems(form) {

	var temp = _extends({}, form);
	temp.rubros = Utils.getListPropsOmit(temp.rubros, ['id', 'tmp', 'idTipoGasto']);

	return function (dispatch) {

		dispatch((0, _Loading.isLoading)(true));

		return new _ClientHttpRequest2.default({
			service: 'api/addItems',
			method: "POST",
			data: _extends({}, temp),
			headers: Object.assign({ "Authorization": sessionStorage.access_token, "uid": sessionStorage.uid })
		}).request().then(function (response) {
			dispatch((0, _Loading.isLoading)(false));
			return response.data;
		}).catch(function (error) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
			throw error;
		});
	};
};

var getDonor = exports.getDonor = function getDonor(form) {

	return function (dispatch) {

		dispatch((0, _Loading.isLoading)(true));

		return new _ClientHttpRequest2.default({
			service: 'api/getItemDonors',
			method: "POST",
			data: _extends({}, form),
			headers: Object.assign({ "Authorization": sessionStorage.access_token, "uid": sessionStorage.uid })
		}).request().then(function (response) {
			dispatch((0, _Loading.isLoading)(false));

			var data = Object.assign({}, response.data);
			var expenseType = [];

			if (data.rubrosSolicitud.rubros) {
				data.rubrosSolicitud.rubros.rubro.forEach(function (r) {
					expenseType.push({
						id: r.idRubro,
						valor: r.concepto
					});
				});
			}

			if (data.donantes) {
				data.donantes.uniqueId = Utils.getUUID();
			}

			dispatch({ type: GET_DONOR, Obj: { donors: data.donantes ? data.donantes.donante : [], expenseType: expenseType } });
			return data.donantes ? data.donantes.donante : [];
		}).catch(function (error) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
			throw error;
		});
	};
};

var clearItems = exports.clearItems = function clearItems() {

	return function (dispatch) {
		dispatch({ type: GET_DONOR, Obj: {} });
		dispatch({ type: GET_ITEMS, Obj: {} });
		return Promise.resolve();
	};
};

/***/ }),

/***/ 404:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.getAddress = exports.postalCodes = exports.GET_ADDRESS = exports.GET_POSTALS = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _Utils = __webpack_require__(2);

var Utils = _interopRequireWildcard(_Utils);

var _ClientHttpRequest = __webpack_require__(5);

var _ClientHttpRequest2 = _interopRequireDefault(_ClientHttpRequest);

var _immutable = __webpack_require__(1);

var _immutable2 = _interopRequireDefault(_immutable);

var _Modal = __webpack_require__(4);

var _Loading = __webpack_require__(3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var initialState = _immutable2.default.Map({}).set('Search', new _immutable2.default.List([])).set('Response', new _immutable2.default.Map({})).set('Get', new _immutable2.default.Map({}));

/* Types */
var GET_POSTALS = exports.GET_POSTALS = 'GET_POSTALS';

var GET_ADDRESS = exports.GET_ADDRESS = 'GET_ADDRESS';

/* Reducer */

exports.default = function () {
	var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	var action = arguments[1];


	switch (action.type) {
		case GET_POSTALS:
			return state.set('Search', new _immutable2.default.List(action.Obj));
		case GET_ADDRESS:
			return state.set('Get', new _immutable2.default.Map(action.Obj));
		default:
			return state;
	}
};

/* Action Creators */

var postalCodes = exports.postalCodes = function postalCodes() {

	return function (dispatch) {

		dispatch((0, _Loading.isLoading)(true));

		return new _ClientHttpRequest2.default({
			service: 'api/postalCodes',
			method: "POST",
			data: {},
			headers: Object.assign({ "Authorization": sessionStorage.access_token, "uid": sessionStorage.uid })
		}).request().then(function (response) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch({ type: GET_POSTALS, Obj: response.data });
		}).catch(function (error) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
			throw error;
		});
	};
};

var getAddress = exports.getAddress = function getAddress(form) {
	var formName = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";


	return function (dispatch) {

		dispatch((0, _Loading.isLoading)(true));

		return new _ClientHttpRequest2.default({
			service: 'api/getAddress',
			method: "POST",
			data: _extends({}, form),
			headers: Object.assign({ "Authorization": sessionStorage.access_token, "uid": sessionStorage.uid })
		}).request().then(function (response) {
			dispatch((0, _Loading.isLoading)(false));

			var data = response.data;

			var estado = [];
			estado.push({ id: data.estados.id, valor: data.estados.estado });
			var municipio = [];
			municipio.push({ id: data.municipioDelegacion.id, valor: data.municipioDelegacion.municipioDelegacion });
			var ciudad = [];
			ciudad.push({ id: data.ciudad.id, valor: data.ciudad.ciudad });

			var obj = {
				identificador: Utils.getUUID(),
				estado: estado,
				municipio: municipio,
				ciudad: ciudad,
				colonia: data.colonias,
				state: data.estados.id,
				town: data.municipioDelegacion.id,
				city: data.ciudad.id,
				colony: data.colonias.length === 1 ? data.colonias[0].id : undefined,
				formName: formName
			};

			dispatch({ type: GET_ADDRESS, Obj: obj });
		}).catch(function (error) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
			throw error;
		});
	};
};

/***/ }),

/***/ 405:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.getProfileGrantee = exports.clearProfileUser = exports.updateProfileUser = exports.deleteProfileUser = exports.getProfileUserByUser = exports.getProfileUser = exports.searchProfileUser = exports.addProfileUser = exports.ACTION_GET_ROL = exports.ACTION_GET_PROFILEGRANTEE = exports.ACTION_UPDATE_PROFILEUSER = exports.ACTION_DELETE_PROFILEUSER = exports.ACTION_GET_PROFILEUSER = exports.ACTION_SEARCH_PROFILEUSER = exports.ACTION_NEW_PROFILEUSER = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _Utils = __webpack_require__(2);

var Utils = _interopRequireWildcard(_Utils);

var _ClientHttpRequest = __webpack_require__(5);

var _ClientHttpRequest2 = _interopRequireDefault(_ClientHttpRequest);

var _immutable = __webpack_require__(1);

var _immutable2 = _interopRequireDefault(_immutable);

var _Modal = __webpack_require__(4);

var _Loading = __webpack_require__(3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var initialState = _immutable2.default.Map({}).set('Search', new _immutable2.default.List([])).set('Response', new _immutable2.default.Map({})).set('Get', new _immutable2.default.Map({})).set('Rol', new _immutable2.default.List([]));

/* Types */

var ACTION_NEW_PROFILEUSER = exports.ACTION_NEW_PROFILEUSER = 'ACTION_NEW_PROFILEUSER';

var ACTION_SEARCH_PROFILEUSER = exports.ACTION_SEARCH_PROFILEUSER = 'ACTION_SEARCH_PROFILEUSER';

var ACTION_GET_PROFILEUSER = exports.ACTION_GET_PROFILEUSER = 'ACTION_GET_PROFILEUSER';

var ACTION_DELETE_PROFILEUSER = exports.ACTION_DELETE_PROFILEUSER = 'ACTION_DELETE_PROFILEUSER';

var ACTION_UPDATE_PROFILEUSER = exports.ACTION_UPDATE_PROFILEUSER = 'ACTION_UPDATE_PROFILEUSER';

var ACTION_GET_PROFILEGRANTEE = exports.ACTION_GET_PROFILEGRANTEE = 'ACTION_GET_PROFILEUSER';

var ACTION_GET_ROL = exports.ACTION_GET_ROL = 'ACTION_GET_ROL';

/* Reducer */

exports.default = function () {
	var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	var action = arguments[1];

	switch (action.type) {
		case ACTION_NEW_PROFILEUSER:
			return state.set('Response', new _immutable2.default.Map(action.Obj));
		case ACTION_SEARCH_PROFILEUSER:
			return state.set('Search', new _immutable2.default.List(action.Obj));
		case ACTION_GET_ROL:
			return state.set('Rol', new _immutable2.default.List(action.Obj));
		case ACTION_GET_PROFILEUSER:
			return state.set('Get', new _immutable2.default.Map(action.Obj));
		case ACTION_DELETE_PROFILEUSER:
			return state.set('Response', new _immutable2.default.Map(action.Obj));
		case ACTION_UPDATE_PROFILEUSER:
			return state.set('Response', new _immutable2.default.Map(action.Obj));
		case ACTION_GET_PROFILEGRANTEE:
			return state.set('Get', new _immutable2.default.List(action.Obj));
		default:
			return state;
	}
};

/* Action Creators */

var addProfileUser = exports.addProfileUser = function addProfileUser(form) {

	return function (dispatch) {

		dispatch((0, _Loading.isLoading)(true));

		return new _ClientHttpRequest2.default({
			service: 'api/newProfileUser',
			method: "POST",
			data: _extends({}, form),
			headers: Object.assign({ "Authorization": sessionStorage.access_token, "uid": sessionStorage.uid })
		}).request().then(function (response) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch({ type: ACTION_NEW_PROFILEUSER, Obj: response.data });
			dispatch((0, _Modal.createModal)(Utils.successMessage()));
		}).catch(function (error) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
			throw error;
		});
	};
};

var searchProfileUser = exports.searchProfileUser = function searchProfileUser(form) {

	Utils.clearNullAndEmpty(form);

	return function (dispatch) {

		dispatch((0, _Loading.isLoading)(true));

		return new _ClientHttpRequest2.default({
			service: Object.keys(form).length == 0 ? 'api/searchProfileUser' : 'api/searchParamProfileUser',
			method: "POST",
			data: _extends({}, form),
			headers: Object.assign({ "Authorization": sessionStorage.access_token, "uid": sessionStorage.uid })
		}).request().then(function (response) {
			dispatch((0, _Loading.isLoading)(false));
			if (response.data[0].identificador) {
				localStorage.n = Object.keys(form).length == 0 ? sessionStorage.mail : response.data[0].identificador;
			} else {
				localStorage.n = sessionStorage.mail;
			}
			dispatch({ type: ACTION_SEARCH_PROFILEUSER, Obj: response.data });
			return response.data;
		}).catch(function (error) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
			throw error;
		});
	};
};

var getProfileUser = exports.getProfileUser = function getProfileUser(id) {

	return function (dispatch) {

		dispatch((0, _Loading.isLoading)(true));

		return new _ClientHttpRequest2.default({
			service: 'api/getProfileUser',
			method: "POST",
			data: { id: id },
			headers: Object.assign({ "Authorization": sessionStorage.access_token, "uid": sessionStorage.uid })
		}).request().then(function (response) {
			dispatch({ type: ACTION_GET_PROFILEUSER, Obj: response.data });
			dispatch((0, _Loading.isLoading)(false));
			return response.data;
		}).catch(function (error) {
			dispatch((0, _Loading.isLoading)(false));
			//dispatch(createModal(Utils.errorMessage(Utils.getMessageResponse(error.response.data))))
			throw error;
		});
	};
};

var getProfileUserByUser = exports.getProfileUserByUser = function getProfileUserByUser(form) {

	return function (dispatch) {

		dispatch((0, _Loading.isLoading)(true));

		return new _ClientHttpRequest2.default({
			service: 'api/getProfileUserByUser',
			method: "POST",
			data: { form: form },
			headers: Object.assign({ "Authorization": sessionStorage.access_token, "uid": sessionStorage.uid })
		}).request().then(function (response) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch({ type: ACTION_GET_ROL, Obj: response.data.perfiles });
			return response.data;
		}).catch(function (error) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
			throw error;
		});
	};
};

var deleteProfileUser = exports.deleteProfileUser = function deleteProfileUser() {
	return function (dispatch) {
		return dispatch({ type: ACTION_DELETE_PROFILEUSER, Obj: { code: '', message: '' } });
	};
};

var updateProfileUser = exports.updateProfileUser = function updateProfileUser(form) {

	var data = Object.assign({}, form);
	//data.perfil = Utils.unionArray(data.perfil, data.perfilRemove)

	return function (dispatch) {

		dispatch((0, _Loading.isLoading)(true));
		dispatch({ type: ACTION_GET_PROFILEUSER, Obj: {} });

		return new _ClientHttpRequest2.default({
			service: 'api/updateProfileUser',
			method: "POST",
			data: _extends({}, data),
			headers: Object.assign({ "Authorization": sessionStorage.access_token, "uid": sessionStorage.uid })
		}).request().then(function (response) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch({ type: ACTION_UPDATE_PROFILEUSER, Obj: response.data });
			dispatch((0, _Modal.createModal)(Utils.successMessage()));
		}).catch(function (error) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
			throw error;
		});
	};
};

var clearProfileUser = exports.clearProfileUser = function clearProfileUser() {
	return function (dispatch) {
		dispatch({ type: ACTION_GET_PROFILEUSER, Obj: {} });
		dispatch({ type: ACTION_SEARCH_PROFILEUSER, Obj: [] });
	};
};

var getProfileGrantee = exports.getProfileGrantee = function getProfileGrantee(id) {

	return function (dispatch) {

		dispatch((0, _Loading.isLoading)(true));

		return new _ClientHttpRequest2.default({
			service: 'api/getProfileGrantee',
			method: "POST",
			data: { id: id },
			headers: Object.assign({ "Authorization": sessionStorage.access_token, "uid": sessionStorage.uid })
		}).request().then(function (response) {
			dispatch({ type: ACTION_GET_PROFILEGRANTEE, Obj: response.data });
			dispatch((0, _Loading.isLoading)(false));
			return response.data;
		}).catch(function (error) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
			throw error;
		});
	};
};

/***/ }),

/***/ 406:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.getStates = exports.GET_STATES = undefined;

var _Utils = __webpack_require__(2);

var Utils = _interopRequireWildcard(_Utils);

var _ClientHttpRequest = __webpack_require__(5);

var _ClientHttpRequest2 = _interopRequireDefault(_ClientHttpRequest);

var _immutable = __webpack_require__(1);

var _immutable2 = _interopRequireDefault(_immutable);

var _Modal = __webpack_require__(4);

var _Loading = __webpack_require__(3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var initialState = _immutable2.default.Map({}).set('Search', new _immutable2.default.List([])).set('Response', new _immutable2.default.Map({})).set('Get', new _immutable2.default.Map({}));

/* Types */
var GET_STATES = exports.GET_STATES = 'GET_STATES';

/* Reducer */

exports.default = function () {
	var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	var action = arguments[1];


	switch (action.type) {
		case GET_STATES:
			return state.set('Search', new _immutable2.default.List(action.Obj));
		default:
			return state;
	}
};

/* Action Creators */


var getStates = exports.getStates = function getStates() {

	return function (dispatch) {

		dispatch((0, _Loading.isLoading)(true));

		return new _ClientHttpRequest2.default({
			service: 'api/getStates',
			method: "POST",
			data: {},
			headers: Object.assign({ "Authorization": sessionStorage.access_token, "uid": sessionStorage.uid })
		}).request().then(function (response) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch({ type: GET_STATES, Obj: response.data });
		}).catch(function (error) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
			throw error;
		});
	};
};

/***/ }),

/***/ 407:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.clearItem = exports.getProposalByEjec = exports.clearProposalDetail = exports.closeSocketConnection = exports.socketConnection = exports.setVaribleToHTML = exports.getItemProposalForCertificate = exports.generateCertificate = exports.saveCertificate = exports.validateProposal = exports.editProposal = exports.getProposalDetail = exports.executeFunction = exports.getEvaluationsByEvent = exports.getProposal = exports.getOpenedEvents = exports.GET_PROPOSAL_BY_EJECT = exports.GENERATE_CERTIFICATE = exports.GET_PROPOSAL_CERTIFICATE = exports.ACTION_SET_VARIABLE_HTML = exports.SAVE_CERTIFICATE = exports.GET_PROPOSAL_DETAIL = exports.SOCKET = exports.EXECUTE_FUNCTION = exports.GET_EVALUATIONS_BY_EVENT = exports.GET_PROPOSAL = exports.GET_OPENED_EVENTS = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _Utils = __webpack_require__(2);

var Utils = _interopRequireWildcard(_Utils);

var _ClientHttpRequest = __webpack_require__(5);

var _ClientHttpRequest2 = _interopRequireDefault(_ClientHttpRequest);

var _immutable = __webpack_require__(1);

var _immutable2 = _interopRequireDefault(_immutable);

var _Modal = __webpack_require__(4);

var _Loading = __webpack_require__(3);

var _Loader = __webpack_require__(205);

var _Socket = __webpack_require__(1021);

var _Socket2 = _interopRequireDefault(_Socket);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var initialState = _immutable2.default.Map({}).set('Get', new _immutable2.default.List([])).set('Response', new _immutable2.default.List([])).set('Search', new _immutable2.default.List([])).set('Uid', new _immutable2.default.Map({})).set('Socket', new _immutable2.default.Map({})).set('Detail', new _immutable2.default.Map({})).set('Certificate', new _immutable2.default.Map({})).set('GetHTML', new _immutable2.default.Map({})).set('ProposalForCertificate', new _immutable2.default.Map({})).set('GenerateCertificate', new _immutable2.default.Map({})).set('ProposalByEjec', new _immutable2.default.Map({}));

/* Types */
var GET_OPENED_EVENTS = exports.GET_OPENED_EVENTS = 'GET_OPENED_EVENTS';
var GET_PROPOSAL = exports.GET_PROPOSAL = 'GET_PROPOSAL';
var GET_EVALUATIONS_BY_EVENT = exports.GET_EVALUATIONS_BY_EVENT = 'GET_EVALUATIONS_BY_EVENT';
var EXECUTE_FUNCTION = exports.EXECUTE_FUNCTION = 'EXECUTE_FUNCTION';
var SOCKET = exports.SOCKET = 'SOCKET';
var GET_PROPOSAL_DETAIL = exports.GET_PROPOSAL_DETAIL = 'GET_PROPOSAL_DETAIL';
var SAVE_CERTIFICATE = exports.SAVE_CERTIFICATE = 'SAVE_CERTIFICATE';
var ACTION_SET_VARIABLE_HTML = exports.ACTION_SET_VARIABLE_HTML = 'ACTION_SET_VARIABLE_HTML';
var GET_PROPOSAL_CERTIFICATE = exports.GET_PROPOSAL_CERTIFICATE = 'GET_PROPOSAL_CERTIFICATE';
var GENERATE_CERTIFICATE = exports.GENERATE_CERTIFICATE = 'GENERATE_CERTIFICATE';
var GET_PROPOSAL_BY_EJECT = exports.GET_PROPOSAL_BY_EJECT = 'GET_PROPOSAL_BY_EJECT';

/* Reducer */

exports.default = function () {
	var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	var action = arguments[1];


	switch (action.type) {
		case GET_OPENED_EVENTS:
			return state.set('Get', new _immutable2.default.List(action.Obj));
		case GET_PROPOSAL:
			return state.set('Response', new _immutable2.default.List(action.Obj));
		case GET_EVALUATIONS_BY_EVENT:
			return state.set('Search', new _immutable2.default.List(action.Obj));
		case EXECUTE_FUNCTION:
			return state.set('Uid', new _immutable2.default.Map(action.Obj));
		case SOCKET:
			return state.set('Socket', new _immutable2.default.Map(action.Obj));
		case GET_PROPOSAL_DETAIL:
			return state.set('Detail', new _immutable2.default.Map(action.Obj));
		case SAVE_CERTIFICATE:
			return state.set('Certificate', new _immutable2.default.Map(action.Obj));
		case GENERATE_CERTIFICATE:
			return state.set('GenerateCertificate', new _immutable2.default.Map(action.Obj));
		case GET_PROPOSAL_CERTIFICATE:
			return state.set('ProposalForCertificate', new _immutable2.default.Map(action.Obj));
		case ACTION_SET_VARIABLE_HTML:
			return state.set('GetHTML', new _immutable2.default.Map(action.Obj));
		case GET_PROPOSAL_BY_EJECT:
			return state.set('ProposalByEjec', new _immutable2.default.Map(action.Obj));
		default:
			return state;
	}
};

/* Action Creators */

var getOpenedEvents = exports.getOpenedEvents = function getOpenedEvents() {

	return function (dispatch) {

		dispatch((0, _Loading.isLoading)(true));

		return new _ClientHttpRequest2.default({
			service: 'api/getOpenedEvents',
			method: "POST",
			data: {},
			headers: Object.assign({ "Authorization": sessionStorage.access_token, "uid": sessionStorage.uid })
		}).request().then(function (response) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch({ type: GET_OPENED_EVENTS, Obj: response.data });
			return response.data;
		}).catch(function (error) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
			throw error;
		});
	};
};

var getProposal = exports.getProposal = function getProposal(form) {

	return function (dispatch) {

		dispatch((0, _Loading.isLoading)(true));

		return new _ClientHttpRequest2.default({
			service: 'api/getProposal',
			method: "POST",
			data: _extends({}, form),
			headers: Object.assign({ "Authorization": sessionStorage.access_token, "uid": sessionStorage.uid })
		}).request().then(function (response) {
			dispatch((0, _Loading.isLoading)(false));
			var data = response.data;
			data = data.map(function (d) {
				d.uniqueId = Utils.getUUID();
				return d;
			});
			dispatch({ type: GET_PROPOSAL, Obj: data });
			return response.data;
		}).catch(function (error) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
			throw error;
		});
	};
};

var getEvaluationsByEvent = exports.getEvaluationsByEvent = function getEvaluationsByEvent(form) {

	return function (dispatch) {

		dispatch((0, _Loading.isLoading)(true));

		return new _ClientHttpRequest2.default({
			service: 'api/getEvaluationsByEvent',
			method: "POST",
			data: _extends({}, form),
			headers: Object.assign({ "Authorization": sessionStorage.access_token, "uid": sessionStorage.uid })
		}).request().then(function (response) {
			dispatch((0, _Loading.isLoading)(false));
			response.data.uniqueId = Utils.getUUID();
			dispatch({ type: GET_EVALUATIONS_BY_EVENT, Obj: response.data });
			return response.data;
		}).catch(function (error) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
			throw error;
		});
	};
};

var executeFunction = exports.executeFunction = function executeFunction(form) {

	var evaluaciones = [];

	if (form.evaluaciones) {
		evaluaciones = form.evaluaciones.split(",").map(function (e) {
			return e;
		});
	}

	var temp = {
		configuracionFuncionId: form.funcion,
		presupuestoProgramaAsociado: form.montoProgramaAsociadoFuncion || null,
		corridaId: form.corrida,
		evaluaciones: evaluaciones || [],
		funcion: form.tipoFuncion,
		redondeo: form.redondeo,
		usuario: sessionStorage.uid
	};

	return function (dispatch) {

		dispatch((0, _Loading.isLoading)(true));

		return new _ClientHttpRequest2.default({
			service: 'api/executeFunction',
			method: "POST",
			data: _extends({}, temp),
			headers: Object.assign({ "Authorization": sessionStorage.access_token, "uid": sessionStorage.uid })
		}).request().then(function (response) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch({ type: EXECUTE_FUNCTION, Obj: response.data });
			return response.data;
		}).catch(function (error) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
			throw error;
		});
	};
};

var getProposalDetail = exports.getProposalDetail = function getProposalDetail(form) {

	return function (dispatch) {

		dispatch((0, _Loading.isLoading)(true));

		return new _ClientHttpRequest2.default({
			service: 'api/getProposalDetail',
			method: "POST",
			data: _extends({}, form),
			headers: Object.assign({ "Authorization": sessionStorage.access_token, "uid": sessionStorage.uid })
		}).request().then(function (response) {
			dispatch((0, _Loading.isLoading)(false));
			response.data.uniqueId = Utils.getUUID();
			dispatch({ type: GET_PROPOSAL_DETAIL, Obj: response.data });
			return response.data;
		}).catch(function (error) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
			throw error;
		});
	};
};

var editProposal = exports.editProposal = function editProposal(form) {

	var temp = {
		causaNegacionId: form.causaNegacionId,
		comentarios: form.comentarios,
		donatariaId: form.donatariaId,
		montoProgramaAsociado: form.montoPrograma,
		montoPropuesto: form.montoPropuesto,
		propuestaId: form.propuestaId,
		resultadoAsignacionId: form.resultadoAsignacionId,
		solicitadoProgramaAsociado: form.solicitadoPrograma,
		usuario: sessionStorage.uid
	};

	return function (dispatch) {

		dispatch((0, _Loading.isLoading)(true));

		return new _ClientHttpRequest2.default({
			service: 'api/editProposal',
			method: "POST",
			data: _extends({}, temp),
			headers: Object.assign({ "Authorization": sessionStorage.access_token, "uid": sessionStorage.uid })
		}).request().then(function (response) {
			dispatch((0, _Loading.isLoading)(false));
			return response.data;
		}).catch(function (error) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
			throw error;
		});
	};
};

var validateProposal = exports.validateProposal = function validateProposal(form) {

	return function (dispatch) {

		dispatch((0, _Loading.isLoading)(true));

		return new _ClientHttpRequest2.default({
			service: 'api/validateProposal',
			method: "POST",
			data: _extends({}, form),
			headers: Object.assign({ "Authorization": sessionStorage.access_token, "uid": sessionStorage.uid })
		}).request().then(function (response) {
			dispatch((0, _Loading.isLoading)(false));
			return response.data;
		}).catch(function (error) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
			throw error;
		});
	};
};

var saveCertificate = exports.saveCertificate = function saveCertificate(form) {

	return function (dispatch) {

		dispatch((0, _Loading.isLoading)(true));

		var adapterForm = {
			certificadoId: form.certificadoId && form.certificadoId !== null ? form.certificadoId : 0,
			propuestaId: form.propuesta.propuestaId,
			dropboxId: form.logotipo,
			texto1: form.texto1,
			texto2: form.texto2,
			texto3: form.texto3,
			texto4: form.textEditor,
			texto5: form.texto5,
			texto6: form.texto6,
			texto7: form.texto7,
			piePagina: form.pieDePagina,
			firma1: form.firma1,
			firma2: form.firma2,
			firma3: form.texto7Firma1,
			firma4: form.texto7Firma2,
			usuario: sessionStorage.uid
		};

		adapterForm.participantesDTO = [];
		adapterForm.equiposTrabajoDTO = [];

		form.signs.map(function (item) {
			adapterForm.participantesDTO.push({
				apellidoMaterno: item.maternoOriginal,
				apellidoPaterno: item.paternoOriginal,
				nombre: item.nombreOriginal,
				puesto: item.puesto,
				titulo: item.titulo
			});
		});

		form.body.map(function (item) {
			var auxArrayParticipantes = [];

			item.original.map(function (data) {
				auxArrayParticipantes.push({ firmaParticipanteEquipo: data.firma });
			});

			adapterForm.equiposTrabajoDTO.push({
				participantesEquipoDTO: auxArrayParticipantes,
				texto8: item.texto8,
				texto9: item.texto9
			});
		});

		return new _ClientHttpRequest2.default({
			service: 'api/saveCertificate',
			method: "POST",
			data: _extends({}, adapterForm),
			headers: Object.assign({ "Authorization": sessionStorage.access_token, "uid": sessionStorage.uid })
		}).request().then(function (response) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch({ type: SAVE_CERTIFICATE, Obj: response.data });
			return response.data;
		}).catch(function (error) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
			throw error;
		});
	};
};

var generateCertificate = exports.generateCertificate = function generateCertificate(form) {

	return function (dispatch) {

		dispatch((0, _Loading.isLoading)(true));

		var adapterForm = {
			certificadoId: form.certificadoId && form.certificadoId !== null ? form.certificadoId : 0,
			propuestaId: form.propuesta.propuestaId,
			dropboxId: form.logotipo,
			texto1: form.texto1,
			texto2: form.texto2,
			texto3: form.texto3,
			texto4: form.textEditor,
			texto5: form.texto5,
			texto6: form.texto6,
			texto7: form.texto7,
			piePagina: form.pieDePagina,
			firma1: form.firma1,
			firma2: form.firma2,
			firma3: form.texto7Firma1,
			firma4: form.texto7Firma2,
			usuario: sessionStorage.uid
		};

		adapterForm.participantesDTO = [];
		adapterForm.equiposTrabajoDTO = [];

		form.signs.map(function (item) {
			adapterForm.participantesDTO.push({
				apellidoMaterno: item.maternoOriginal,
				apellidoPaterno: item.paternoOriginal,
				nombre: item.nombreOriginal,
				puesto: item.puesto,
				titulo: item.titulo
			});
		});

		form.body.map(function (item) {
			var auxArrayParticipantes = [];

			item.original.map(function (data) {
				auxArrayParticipantes.push({ firmaParticipanteEquipo: data.firma });
			});

			adapterForm.equiposTrabajoDTO.push({
				participantesEquipoDTO: auxArrayParticipantes,
				texto8: item.texto8,
				texto9: item.texto9
			});
		});

		return new _ClientHttpRequest2.default({
			service: 'api/generateCertificate',
			method: "POST",
			data: _extends({}, adapterForm),
			headers: Object.assign({ "Authorization": sessionStorage.access_token, "uid": sessionStorage.uid }),
			responseType: 'arraybuffer'
		}).request().then(function (response) {
			dispatch((0, _Loading.isLoading)(false));

			var blob = new Blob([response.data], { type: 'application/pdf' });
			var fileName = 'certificado-' + Utils.getToday() + '.pdf';
			var objectUrl = URL.createObjectURL(blob);
			var a = document.createElement('a');

			a.href = objectUrl;
			a.download = fileName;
			document.body.appendChild(a);
			a.click();

			document.body.removeChild(a);
			URL.revokeObjectURL(objectUrl);
		}).catch(function (error) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
			throw error;
		});
	};
};

var getItemProposalForCertificate = exports.getItemProposalForCertificate = function getItemProposalForCertificate(form) {

	return function (dispatch) {

		dispatch((0, _Loading.isLoading)(true));

		return new _ClientHttpRequest2.default({
			service: 'api/getItemProposalForCertificate',
			method: "POST",
			data: _extends({}, form),
			headers: Object.assign({ "Authorization": sessionStorage.access_token, "uid": sessionStorage.uid })
		}).request().then(function (response) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch({ type: GET_PROPOSAL_CERTIFICATE, Obj: response.data });
			return response.data;
		}).catch(function (error) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
			throw error;
		});
	};
};

var setVaribleToHTML = exports.setVaribleToHTML = function setVaribleToHTML(form) {

	return function (dispatch) {
		dispatch({ type: ACTION_SET_VARIABLE_HTML, Obj: form });
		var promise = new Promise(function (resolve) {
			resolve(form);
		});
		return promise;
	};
};

var socketConnection = exports.socketConnection = function socketConnection() {
	return function (dispatch) {
		dispatch((0, _Loader.isLoader)(true));
		var client = (0, _Socket2.default)();
		client.receive(dispatch, SOCKET);
	};
};

var closeSocketConnection = exports.closeSocketConnection = function closeSocketConnection() {
	return function (dispatch) {
		dispatch((0, _Loader.isLoader)(false));
		var promise = new Promise(function (resolve) {
			resolve();
		});
		return promise;
	};
};

var clearProposalDetail = exports.clearProposalDetail = function clearProposalDetail() {
	return function (dispatch) {
		dispatch({ type: GET_PROPOSAL_DETAIL, Obj: {} });
	};
};

var getProposalByEjec = exports.getProposalByEjec = function getProposalByEjec(form) {

	return function (dispatch) {

		dispatch((0, _Loading.isLoading)(true));

		return new _ClientHttpRequest2.default({
			service: 'api/getProposalByEjec',
			method: "POST",
			data: _extends({}, form),
			headers: Object.assign({ "Authorization": sessionStorage.access_token, "uid": sessionStorage.uid })
		}).request().then(function (response) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch({ type: GET_PROPOSAL_BY_EJECT, Obj: response.data });
		}).catch(function (error) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
			throw error;
		});
	};
};

var clearItem = exports.clearItem = function clearItem() {
	return function (dispatch) {
		dispatch({ type: GET_PROPOSAL_BY_EJECT, Obj: {} }), dispatch({ type: GET_PROPOSAL_DETAIL, Obj: {} });
	};
};

/***/ }),

/***/ 408:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getMontoAutorizado = exports.getReportChangeDestination = exports.updateStatusChange = exports.saveExecutiveChange = exports.saveGranteesChange = exports.saveSupervisorAndDirector = exports.getDirectorChangeDest = exports.getSupervisorChangeDest = exports.getExacutiveChangeDest = exports.detailChangeDest = exports.updateTaskSupervisorDirector = exports.initTaskExecutiveGrantees = exports.initialChangeDestinity = exports.getIdtareaChangeDest = exports.getCatalogoMontos = exports.ACTION_GET_AUTHORIZED_DATE = exports.ACTION_GET_MONTO_AUTORIZADO = exports.ACTION_GET_REPORT_CHANGE_DESTINATION = exports.ACTION_UPDATE_STATUS_CHANGE = exports.ACTION_UPDATE_STATUS = exports.ACTION_SAVE_CHANGE = exports.ACTION_GET_MONTOS_CHANGE = exports.ACTION_GET_LIST_DIRECTOR_CHANGE = exports.ACTION_GET_LIST_SUPERVISOR_CHANGE = exports.ACTION_GET_LIST_DETAILS_CHANGE = exports.ACTION_GET_LIST_CHANGE = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _Utils = __webpack_require__(2);

var Utils = _interopRequireWildcard(_Utils);

var _ClientHttpRequest = __webpack_require__(5);

var _ClientHttpRequest2 = _interopRequireDefault(_ClientHttpRequest);

var _immutable = __webpack_require__(1);

var _immutable2 = _interopRequireDefault(_immutable);

var _Modal = __webpack_require__(4);

var _Loading = __webpack_require__(3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var initialState = _immutable2.default.Map({}).set('Response', new _immutable2.default.Map({})).set('Search', new _immutable2.default.List([])).set('GetListChangeDestinity', new _immutable2.default.List([])).set('GetDetailsChangeDestinity', new _immutable2.default.Map({})).set('GetSupervisorChangeDest', new _immutable2.default.List([])).set('GetDirectorChangeDest', new _immutable2.default.List([])).set('GetMontosChangeDest', new _immutable2.default.List([])).set('Save', new _immutable2.default.Map({})).set('update_status', new _immutable2.default.Map({})).set('update_status_cambio', new _immutable2.default.Map({})).set('get_report_change_destination', new _immutable2.default.List([])).set('get_monto_autorizado', new _immutable2.default.Map([])).set('get_authorized_date', new _immutable2.default.Map([]));

/* Types */

var ACTION_GET_LIST_CHANGE = exports.ACTION_GET_LIST_CHANGE = 'ACTION_GET_LIST_CHANGE';
var ACTION_GET_LIST_DETAILS_CHANGE = exports.ACTION_GET_LIST_DETAILS_CHANGE = 'ACTION_GET_LIST_DETAILS_CHANGE';
var ACTION_GET_LIST_SUPERVISOR_CHANGE = exports.ACTION_GET_LIST_SUPERVISOR_CHANGE = 'ACTION_GET_LIST_SUPERVISOR_CHANGE';
var ACTION_GET_LIST_DIRECTOR_CHANGE = exports.ACTION_GET_LIST_DIRECTOR_CHANGE = 'ACTION_GET_LIST_DIRECTOR_CHANGE';
var ACTION_GET_MONTOS_CHANGE = exports.ACTION_GET_MONTOS_CHANGE = 'ACTION_GET_MONTOS_CHANGE';
var ACTION_SAVE_CHANGE = exports.ACTION_SAVE_CHANGE = 'ACTION_SAVE_CHANGE';
var ACTION_UPDATE_STATUS = exports.ACTION_UPDATE_STATUS = 'ACTION_UPDATE_STATUS';
var ACTION_UPDATE_STATUS_CHANGE = exports.ACTION_UPDATE_STATUS_CHANGE = 'ACTION_UPDATE_STATUS_CHANGE';
var ACTION_GET_REPORT_CHANGE_DESTINATION = exports.ACTION_GET_REPORT_CHANGE_DESTINATION = 'ACTION_GET_REPORT_CHANGE_DESTINATION';
var ACTION_GET_MONTO_AUTORIZADO = exports.ACTION_GET_MONTO_AUTORIZADO = 'ACTION_GET_MONTO_AUTORIZADO';
var ACTION_GET_AUTHORIZED_DATE = exports.ACTION_GET_AUTHORIZED_DATE = 'ACTION_GET_AUTHORIZED_DATE';

/* Reducer */

exports.default = function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments[1];

  switch (action.type) {
    case ACTION_GET_LIST_CHANGE:
      return state.set('GetListChangeDestinity', new _immutable2.default.List(action.Obj));
    case ACTION_GET_LIST_DETAILS_CHANGE:
      return state.set('GetDetailsChangeDestinity', new _immutable2.default.Map(action.Obj));
    case ACTION_GET_LIST_SUPERVISOR_CHANGE:
      return state.set('GetSupervisorChangeDest', new _immutable2.default.List(action.Obj));
    case ACTION_GET_LIST_DIRECTOR_CHANGE:
      return state.set('GetDirectorChangeDest', new _immutable2.default.List(action.Obj));
    case ACTION_GET_MONTOS_CHANGE:
      return state.set('GetMontosChangeDest', new _immutable2.default.List(action.Obj));
    case ACTION_SAVE_CHANGE:
      return state.set('Save', new _immutable2.default.Map(action.Obj));
    case ACTION_UPDATE_STATUS:
      return state.set('update_status', new _immutable2.default.Map(action.Obj));
    case ACTION_UPDATE_STATUS_CHANGE:
      return state.set('update_status_cambio', new _immutable2.default.Map(action.Obj));
    case ACTION_GET_REPORT_CHANGE_DESTINATION:
      return state.set('get_report_change_destination', new _immutable2.default.Map(action.Obj));
    case ACTION_GET_MONTO_AUTORIZADO:
      return state.set('get_monto_autorizado', new _immutable2.default.Map(action.Obj));
    case ACTION_GET_AUTHORIZED_DATE:
      return state.set('get_authorized_date', new _immutable2.default.Map(action.Obj));
    default:
      return state;
  }
};

/* Action Creators */

var getCatalogoMontos = exports.getCatalogoMontos = function getCatalogoMontos() {
  return function (dispatch) {
    dispatch((0, _Loading.isLoading)(true));

    return new _ClientHttpRequest2.default({
      service: 'api/getCatalogoMontos',
      method: 'POST',
      data: {},
      headers: Object.assign({ Authorization: sessionStorage.access_token, uid: sessionStorage.uid })
    }).request().then(function (response) {
      dispatch((0, _Loading.isLoading)(false));
      dispatch({ type: ACTION_GET_MONTOS_CHANGE, Obj: response.data });
      return response.data;
    }).catch(function (error) {
      dispatch((0, _Loading.isLoading)(false));
      dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
      throw error;
    });
  };
};

var getIdtareaChangeDest = exports.getIdtareaChangeDest = function getIdtareaChangeDest(form) {
  return function (dispatch) {
    dispatch((0, _Loading.isLoading)(true));

    return new _ClientHttpRequest2.default({
      service: 'api/bpm/getIdtareaChangeDest',
      method: 'POST',
      data: _extends({}, form),
      headers: Object.assign({
        Authorization: sessionStorage.access_token,
        Bpm: sessionStorage.bpm_token,
        uid: sessionStorage.uid
      })
    }).request().then(function (response) {
      dispatch((0, _Loading.isLoading)(false));
      return response.data;
    }).catch(function (error) {
      dispatch((0, _Loading.isLoading)(false));
      dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
      throw error;
    });
  };
};

/** inicar cambio destino ejecutivo */
var initialChangeDestinity = exports.initialChangeDestinity = function initialChangeDestinity(form) {
  var concepto = [];
  form.conceptos.map(function (d) {
    concepto.push({
      idDonatariaRubro: d.idRubroDonataria,
      concepto: d.concepto,
      montoAutorizado: d.montoAutorizado,
      montoAjusteRecurso: d.ajuste
    });
  });

  var tmp = {
    donataria: {
      idDonataria: form.donataria.id,
      nombreDonataria: form.donataria.nombre,
      correoElectronico: [],
      idCorrida: form.corrida.id,
      descripcionOportunidad: form.corrida.nombre,
      responsableSolicita: form.responsableSolicitud,
      fechaEnvio: form.fechaEnvio ? form.fechaEnvio.slice(0, 10) : new Date().toISOString().slice(0, 10),
      ejecutivo: {
        idUsuario: sessionStorage.uid,
        nombreUsuario: sessionStorage.firstname
      },
      conceptos: {
        concepto: concepto
      }
    }
  };

  if (concepto.length === 0) delete tmp.donataria.conceptos;

  return function (dispatch) {
    dispatch((0, _Loading.isLoading)(true));

    return new _ClientHttpRequest2.default({
      service: 'api/bpm/initialChangeDestinity',
      method: 'POST',
      data: _extends({}, tmp),
      headers: Object.assign({
        Authorization: sessionStorage.access_token,
        Bpm: sessionStorage.bpm_token,
        uid: sessionStorage.uid
      })
    }).request().then(function (response) {
      dispatch((0, _Loading.isLoading)(false));
      dispatch((0, _Modal.createModal)(Utils.successMessage()));
      return response.data;
    }).catch(function (error) {
      dispatch((0, _Loading.isLoading)(false));
      dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
      throw error;
    });
  };
};

/** para ejecutivo detalle y donataria */
var initTaskExecutiveGrantees = exports.initTaskExecutiveGrantees = function initTaskExecutiveGrantees(form, isExecutive, tag) {
  var concepto = [];
  form.conceptos.map(function (d) {
    concepto.push({
      idDonatariaRubro: d.idRubroDonataria,
      concepto: d.concepto,
      montoAutorizado: d.montoAutorizado,
      montoAjusteRecurso: d.ajuste
    });
  });

  var resultado = tag;

  var ejecutivo = {};

  if (isExecutive) {
    ejecutivo = { idUsuario: sessionStorage.uid, nombreUsuario: sessionStorage.firstname };
  } else {
    ejecutivo = { idUsuario: form.donataria.usuarioEjecutivo };
  }

  var tmp = {
    idTarea: form.idTarea,
    resultado: resultado,
    donataria: {
      idDonataria: form.donataria.id,
      nombreDonataria: form.donataria.nombre,
      idCorrida: form.corrida.id,
      descripcionOportunidad: form.corrida.nombre,
      idTarea: form.idTarea,
      responsableSolicita: form.responsableSolicitud,
      fechaEnvio: new Date().toISOString().slice(0, 10),
      ejecutivo: ejecutivo,
      montoCambioDestino: form.montoCambioDestino,
      montoTotalAutorizado: form.montoAutorizadoTotal,
      montoTotalAjuste: form.ajusteTotal,
      justificacion: form.justificacion //,
      //conceptos: { concepto }
    }
  };
  if (concepto.length === 0) delete tmp.donataria.conceptos;

  return function (dispatch) {
    dispatch((0, _Loading.isLoading)(true));

    return new _ClientHttpRequest2.default({
      service: 'api/bpm/updateTaskChangeDest',
      method: 'POST',
      data: _extends({}, tmp),
      headers: Object.assign({
        Authorization: sessionStorage.access_token,
        Bpm: sessionStorage.bpm_token,
        uid: sessionStorage.uid
      })
    }).request().then(function (response) {
      dispatch((0, _Loading.isLoading)(false));
      return response.data;
    }).catch(function (error) {
      dispatch((0, _Loading.isLoading)(false));
      dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
      throw error;
    });
  };
};

/** Metodos para supervisor y director */
var updateTaskSupervisorDirector = exports.updateTaskSupervisorDirector = function updateTaskSupervisorDirector(form, isSupervisor /* , isExecutive, tag */) {

  var donataria = [];
  form.map(function (data) {

    var obj = {};
    var perfil = {};
    var fechaAutorizacion = '';
    var montos = {};

    if (isSupervisor) {
      perfil.supervisor = {
        idUsuario: sessionStorage.uid,
        nombreUsuario: sessionStorage.firstname
      };
      fechaAutorizacion = data.fechaAutorizacion ? data.fechaAutorizacion.slice(0, 10) : '';
    } else {
      perfil.director = {
        idUsuario: sessionStorage.uid,
        nombreUsuario: sessionStorage.firstname
      };
      fechaAutorizacion = data.fechaAutorizacion ? data.fechaAutorizacion.slice(0, 10) : new Date().toISOString().slice(0, 10);
      montos = {
        montoCambioDestino: data.montoCambioDestino,
        montoTotalAutorizado: data.montoTotalAutorizado,
        montoTotalAjuste: data.montoTotalAjuste
      };
    }

    obj = _extends({
      idDonataria: data.idDonataria,
      nombreDonataria: data.nombreDonataria,
      correoElectronico: [],
      idCorrida: data.idCorrida,
      descripcionOportunidad: data.descripcionOportunidad,
      idTarea: data.idTarea || '',
      //responsableSolicita : data.responsableSolicitud,
      fechaEnvio: new Date().toISOString().slice(0, 10)
    }, perfil, {
      fechaAutorizacion: fechaAutorizacion
    }, montos, {

      autoriza: data.aprobar ? 1 : data.rechazar ? 0 : 0,
      rolAutorizacion: isSupervisor ? "Supervisor" : "Director",
      autorizacionCambioDestino: data.autorizacionCambioDestino || false
    });
    if (fechaAutorizacion === '' || fechaAutorizacion === null) delete obj.fechaAutorizacion;

    if (data.idTarea && (data.aprobar !== null || data.rechazar !== null)) donataria.push(_extends({}, obj));
  });

  var tmp = {
    donatarias: {
      donataria: donataria
    }
  };

  return function (dispatch) {

    dispatch((0, _Loading.isLoading)(true));

    return new _ClientHttpRequest2.default({
      service: 'api/bpm/updateTaskSupervisorDirector',
      method: "POST",
      data: _extends({}, tmp),
      headers: Object.assign({ "Authorization": sessionStorage.access_token, "Bpm": sessionStorage.bpm_token, "uid": sessionStorage.uid })
    }).request().then(function (response) {
      dispatch((0, _Loading.isLoading)(false));
      return response.data;
    }).catch(function (error) {
      dispatch((0, _Loading.isLoading)(false));
      dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
      throw error;
    });
  };
};

var detailChangeDest = exports.detailChangeDest = function detailChangeDest(form) {
  return function (dispatch) {
    dispatch((0, _Loading.isLoading)(true));

    return new _ClientHttpRequest2.default({
      service: 'api/detailChangeDest',
      method: 'POST',
      data: _extends({}, form),
      headers: Object.assign({ Authorization: sessionStorage.access_token, uid: sessionStorage.uid })
    }).request().then(function (response) {
      dispatch((0, _Loading.isLoading)(false));
      dispatch({ type: ACTION_GET_LIST_DETAILS_CHANGE, Obj: response.data });
      return response.data;
    }).catch(function (error) {
      console.log(error, '<-----');
      dispatch((0, _Loading.isLoading)(false));
      dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
      throw error;
    });
  };
};

var getExacutiveChangeDest = exports.getExacutiveChangeDest = function getExacutiveChangeDest(form) {
  return function (dispatch) {
    dispatch((0, _Loading.isLoading)(true));

    return new _ClientHttpRequest2.default({
      service: 'api/bpm/executiveChangeDest',
      method: 'POST',
      data: _extends({}, form),
      headers: Object.assign({
        Authorization: sessionStorage.access_token,
        Bpm: sessionStorage.bpm_token,
        uid: sessionStorage.uid
      })
    }).request().then(function (response) {
      dispatch((0, _Loading.isLoading)(false));

      var tmp = response.data;

      if (tmp.donatarias) {
        tmp.donatarias.donataria.map(function (item) {
          item.nombreCorrida = item.descripcionOportunidad;
          item.flagActive = item.idTarea ? true : false;
        });
      }

      dispatch({ type: ACTION_GET_LIST_CHANGE, Obj: tmp.donatarias ? tmp.donatarias.donataria : [] });
      return tmp;
    }).catch(function (error) {
      dispatch((0, _Loading.isLoading)(false));
      dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
      throw error;
    });
  };
};

var getSupervisorChangeDest = exports.getSupervisorChangeDest = function getSupervisorChangeDest(form) {
  return function (dispatch) {
    dispatch((0, _Loading.isLoading)(true));
    form.perfil_id = 81;
    return new _ClientHttpRequest2.default({
      service: 'api/bpm/supervisorChangeDest',
      method: 'POST',
      data: _extends({}, form),
      headers: Object.assign({
        Authorization: sessionStorage.access_token,
        Bpm: sessionStorage.bpm_token,
        uid: sessionStorage.uid
      })
    }).request().then(function (response) {
      dispatch((0, _Loading.isLoading)(false));
      if (response.data.donatarias) {
        var tmp = [];
        response.data.donatarias.donataria.map(function (item) {
          tmp.push(_extends({
            id: item.idDonataria,
            nombreCorrida: item.descripcionOportunidad,
            aprobar: item.autorizacionCambioDestino === null ? false : item.autorizacionCambioDestino ? true : false,
            rechazar: item.autorizacionCambioDestino === null ? false : !item.autorizacionCambioDestino ? true : false,

            fechaAutorizacion: item.fechaAutorizacion ? item.fechaAutorizacion : '',
            comentarios: item.autorizacionCambioDestino ? item.comentarios : '',
            motivoRechazo: item.autorizacionCambioDestino ? '' : item.comentarios,
            justificacion: item.justificacion || '',
            estadodescripcion: item.estado.descripcion
          }, item));
        });

        dispatch({ type: ACTION_GET_LIST_SUPERVISOR_CHANGE, Obj: tmp });
        return tmp;
      } else {
        dispatch({ type: ACTION_GET_LIST_SUPERVISOR_CHANGE, Obj: [] });
        return [];
      }
    }).catch(function (error) {
      dispatch((0, _Loading.isLoading)(false));
      dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
      throw error;
    });
  };
};

var getDirectorChangeDest = exports.getDirectorChangeDest = function getDirectorChangeDest() {
  return function (dispatch) {
    dispatch((0, _Loading.isLoading)(true));

    return new _ClientHttpRequest2.default({
      service: 'api/bpm/directionChangeDest',
      method: 'POST',
      data: {},
      headers: Object.assign({
        Authorization: sessionStorage.access_token,
        Bpm: sessionStorage.bpm_token,
        uid: sessionStorage.uid
      })
    }).request().then(function (response) {
      dispatch((0, _Loading.isLoading)(false));

      var tmp = Object.assign([], response.data.donatarias ? response.data.donatarias.donataria : []);
      if (response.data.donatarias) {
        response.data.donatarias.donataria.map(function (item) {
          item.id = item.idDonataria;
          item.nombreCorrida = item.descripcionOportunidad;
          item.aprobar = item.autorizacionCambioDestino === null ? false : item.autorizacionCambioDestino ? true : false;
          item.rechazar = item.autorizacionCambioDestino === null ? false : !item.autorizacionCambioDestino ? true : false;
          item.comentarios = item.comentarios ? item.comentarios : item.motivoRechazo ? item.motivoRechazo : '';
          item.motivoRechazo = item.motivoRechazo || '';
          item.justificacion = item.justificacion || '';
        });
      }
      dispatch({ type: ACTION_GET_LIST_DIRECTOR_CHANGE, Obj: tmp });
      return tmp;
    }).catch(function (error) {
      dispatch((0, _Loading.isLoading)(false));
      dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
      throw error;
    });
  };
};

var saveSupervisorAndDirector = exports.saveSupervisorAndDirector = function saveSupervisorAndDirector(form, isSupervisor) {

  var tmp = [];

  form.data.map(function (data) {

    var jsonDinamyc = {};
    if (data.rechazar) {
      jsonDinamyc.motivoRechazo = data.motivoRechazo ? data.motivoRechazo : data.comentarios ? data.comentarios : null; // decirle a back
    } else if (data.aprobar && isSupervisor) {
      jsonDinamyc.comentarioSupervisor = data.comentarios || null;
      jsonDinamyc.fechaDeAutorizacion = data.fechaAutorizacion || null;
    } else if (data.aprobar && isSupervisor === false) {
      jsonDinamyc.comentarioDirector = data.comentarios || null;
    }

    if (data.aprobar || data.rechazar) {
      tmp.push(_extends({
        aprobado: data.aprobar ? true : data.rechazar ? false : null,
        correo: data.correo ? true : false,
        corrida: {
          id: data.idCorrida
        },
        donataria: {
          id: data.idDonataria
        }
      }, jsonDinamyc));
    }
  });

  return function (dispatch) {

    dispatch((0, _Loading.isLoading)(true));

    return new _ClientHttpRequest2.default({
      service: isSupervisor ? 'api/saveSupervisorChange' : 'api/saveDirectorChange',
      method: "POST",
      data: _extends({}, tmp),
      headers: Object.assign({ "Authorization": sessionStorage.access_token, "uid": sessionStorage.uid })
    }).request().then(function (response) {
      dispatch((0, _Loading.isLoading)(false));
      return response.data;
    }).catch(function (error) {
      dispatch((0, _Loading.isLoading)(false));
      dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
      throw error;
    });
  };
};

var saveGranteesChange = exports.saveGranteesChange = function saveGranteesChange(form) {
  var tmp = Object.assign({}, form);
  tmp = Utils.getObjPropsRemove(tmp, ['idEdit', 'ajuste', 'concepto', 'responsable', 'conceptoAjustado']);
  tmp.data = Utils.getObjPropsRemove(tmp.data, ['montoAutorizadoTotal', 'message', 'ajusteTotal', 'autorizacion', 'fechaEnvio']);
  tmp.data.conceptos = Utils.getListPropsOmit(tmp.data.conceptos, ['id', 'ajusteTotal']);

  tmp.data.conceptos.map(function (item) {
    item.ajustes = item.ajustes.map(function (d) {
      if (typeof d.idAjuste === 'string') {
        delete d.idAjuste;
      }
      d.conceptoAjustadoList = '';
      delete d.conceptoAjustadoList;
      delete d.rubroAjustado;
      return _extends({}, d);
    });
  });

  var temp = _extends({}, tmp.data, {
    usuario: sessionStorage.uid,
    justificacion: form.justificacion,
    montoCambioDestino: form.montoCambioDestino,
    responsableSolicitud: form.responsableSolicitud
  });

  return function (dispatch) {
    dispatch((0, _Loading.isLoading)(true));

    return new _ClientHttpRequest2.default({
      service: 'api/saveGranteesChange',
      method: 'POST',
      data: _extends({}, temp),
      headers: Object.assign({ Authorization: sessionStorage.access_token, uid: sessionStorage.uid })
    }).request().then(function (response) {
      dispatch((0, _Loading.isLoading)(false));
      return response.data;
    }).catch(function (error) {
      dispatch((0, _Loading.isLoading)(false));
      dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
      throw error;
    });
  };
};

var saveExecutiveChange = exports.saveExecutiveChange = function saveExecutiveChange(form) {
  var tmp = _extends({}, form, {
    usuario: sessionStorage.uid
  });
  return function (dispatch) {
    dispatch((0, _Loading.isLoading)(true));
    return new _ClientHttpRequest2.default({
      service: 'api/saveExecutiveChange',
      method: 'POST',
      data: _extends({}, tmp),
      headers: Object.assign({ Authorization: sessionStorage.access_token, uid: sessionStorage.uid })
    }).request().then(function (response) {
      dispatch((0, _Loading.isLoading)(false));
      return response.data;
    }).catch(function (error) {
      dispatch((0, _Loading.isLoading)(false));
      dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
      throw error;
    });
  };
};

var updateStatusChange = exports.updateStatusChange = function updateStatusChange(form) {
  return function (dispatch) {
    dispatch((0, _Loading.isLoading)(true));

    return new _ClientHttpRequest2.default({
      service: 'api/changeStatusChange',
      method: 'POST',
      data: _extends({}, form),
      headers: Object.assign({ Authorization: sessionStorage.access_token, uid: sessionStorage.uid })
    }).request().then(function (response) {
      dispatch((0, _Loading.isLoading)(false));
      dispatch({ type: ACTION_UPDATE_STATUS_CHANGE, Obj: response.data });
      return response.data;
    }).catch(function (error) {
      dispatch((0, _Loading.isLoading)(false));
      dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
      throw error;
    });
  };
};

var getReportChangeDestination = exports.getReportChangeDestination = function getReportChangeDestination(form) {
  return function (dispatch) {
    dispatch((0, _Loading.isLoading)(true));

    return new _ClientHttpRequest2.default({
      service: 'api/getReportChangeDestination',
      method: 'POST',
      data: _extends({}, form),
      headers: Object.assign({ Authorization: sessionStorage.access_token, uid: sessionStorage.uid })
    }).request().then(function (response) {
      dispatch((0, _Loading.isLoading)(false));
      dispatch({ type: ACTION_GET_REPORT_CHANGE_DESTINATION, Obj: response.data });
      return response.data;
    }).catch(function (error) {
      dispatch((0, _Loading.isLoading)(false));
      dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
      throw error;
    });
  };
};

var getMontoAutorizado = exports.getMontoAutorizado = function getMontoAutorizado(form) {
  return function (dispatch) {
    dispatch((0, _Loading.isLoading)(true));

    return new _ClientHttpRequest2.default({
      service: 'api/getMontoAutorizado',
      method: 'POST',
      data: _extends({}, form),
      headers: Object.assign({ Authorization: sessionStorage.access_token, uid: sessionStorage.uid })
    }).request().then(function (response) {
      dispatch((0, _Loading.isLoading)(false));
      dispatch({ type: ACTION_GET_MONTO_AUTORIZADO, Obj: response.data });
      return response.data;
    }).catch(function (error) {
      dispatch((0, _Loading.isLoading)(false));
      dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
      throw error;
    });
  };
};

/***/ }),

/***/ 409:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.clearGrantee = exports.getInfoGrantee = exports.updateGrantee = exports.getGrantee = exports.searchParamGrantee = exports.searchGrantee = exports.ACTION_UPDATE_GRANTEE = exports.ACTION_INFO_GRANTEE = exports.ACTION_GET_GRANTEE = exports.ACTION_SEARCH_PARAM_GRANTEE = exports.ACTION_SEARCH_GRANTEE = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _Utils = __webpack_require__(2);

var Utils = _interopRequireWildcard(_Utils);

var _ClientHttpRequest = __webpack_require__(5);

var _ClientHttpRequest2 = _interopRequireDefault(_ClientHttpRequest);

var _immutable = __webpack_require__(1);

var _immutable2 = _interopRequireDefault(_immutable);

var _Modal = __webpack_require__(4);

var _Loading = __webpack_require__(3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var initialState = _immutable2.default.Map({}).set('Search', new _immutable2.default.List([])).set('Response', new _immutable2.default.Map({})).set('Get', new _immutable2.default.Map({})).set('Info', new _immutable2.default.Map({})).set('SearchParam', new _immutable2.default.List([]));

/* Types */

var ACTION_SEARCH_GRANTEE = exports.ACTION_SEARCH_GRANTEE = 'ACTION_SEARCH_GRANTEE';

var ACTION_SEARCH_PARAM_GRANTEE = exports.ACTION_SEARCH_PARAM_GRANTEE = 'ACTION_SEARCH_PARAM_GRANTEE';

var ACTION_GET_GRANTEE = exports.ACTION_GET_GRANTEE = 'ACTION_GET_GRANTEE';

var ACTION_INFO_GRANTEE = exports.ACTION_INFO_GRANTEE = 'ACTION_INFO_GRANTEE';

var ACTION_UPDATE_GRANTEE = exports.ACTION_UPDATE_GRANTEE = 'ACTION_UPDATE_GRANTEE';

/* Reducer */

exports.default = function () {
	var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	var action = arguments[1];


	switch (action.type) {
		case ACTION_SEARCH_GRANTEE:
			return state.set('Search', new _immutable2.default.List(action.Obj));
		case ACTION_SEARCH_PARAM_GRANTEE:
			return state.set('SearchParam', new _immutable2.default.List(action.Obj));
		case ACTION_GET_GRANTEE:
			return state.set('Get', new _immutable2.default.Map(action.Obj));
		case ACTION_INFO_GRANTEE:
			return state.set('Info', new _immutable2.default.Map(action.Obj));
		case ACTION_UPDATE_GRANTEE:
			return state.set('Response', new _immutable2.default.Map(action.Obj));
		default:
			return state;
	}
};

/* Action Creators */

var searchGrantee = exports.searchGrantee = function searchGrantee(form) {

	Utils.clearNullAndEmpty(form);

	return function (dispatch) {

		dispatch((0, _Loading.isLoading)(true));

		return new _ClientHttpRequest2.default({
			service: Object.keys(form).length == 0 ? 'api/searchGrantee' : 'api/searchParamGrantee',
			method: "POST",
			data: _extends({}, form),
			headers: Object.assign({ "Authorization": sessionStorage.access_token, "uid": sessionStorage.uid })
		}).request().then(function (response) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch({ type: ACTION_SEARCH_GRANTEE, Obj: response.data });
			return response.data;
		}).catch(function (error) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
			throw error;
		});
	};
};

var searchParamGrantee = exports.searchParamGrantee = function searchParamGrantee(form) {

	return function (dispatch) {

		dispatch((0, _Loading.isLoading)(true));

		return new _ClientHttpRequest2.default({
			service: 'api/searchParamGrantee',
			method: "POST",
			data: _extends({}, form),
			headers: Object.assign({ "Authorization": sessionStorage.access_token, "uid": sessionStorage.uid })
		}).request().then(function (response) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch({ type: ACTION_SEARCH_PARAM_GRANTEE, Obj: response.data });
			return response.data;
		}).catch(function (error) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
			throw error;
		});
	};
};

var getGrantee = exports.getGrantee = function getGrantee(id) {

	return function (dispatch) {

		dispatch((0, _Loading.isLoading)(true));

		return new _ClientHttpRequest2.default({
			service: 'api/getGrantee',
			method: "POST",
			data: { id: id },
			headers: Object.assign({ "Authorization": sessionStorage.access_token, "uid": sessionStorage.uid })
		}).request().then(function (response) {
			dispatch({ type: ACTION_GET_GRANTEE, Obj: response.data });
			dispatch((0, _Loading.isLoading)(false));
			return response.data;
		}).catch(function (error) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
			throw error;
		});
	};
};

var updateGrantee = exports.updateGrantee = function updateGrantee(form) {

	return function (dispatch) {

		dispatch((0, _Loading.isLoading)(true));
		dispatch({ type: ACTION_GET_GRANTEE, Obj: {} });

		return new _ClientHttpRequest2.default({
			service: 'api/updateGrantee',
			method: "POST",
			data: _extends({}, form),
			headers: Object.assign({ "Authorization": sessionStorage.access_token, "uid": sessionStorage.uid })
		}).request().then(function (response) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch({ type: ACTION_UPDATE_GRANTEE, Obj: response.data });
			dispatch((0, _Modal.createModal)(Utils.successMessage()));
		}).catch(function (error) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
			throw error;
		});
	};
};

var getInfoGrantee = exports.getInfoGrantee = function getInfoGrantee(id) {

	return function (dispatch) {

		dispatch((0, _Loading.isLoading)(true));

		return new _ClientHttpRequest2.default({
			service: 'api/getInfoGrantee',
			method: "POST",
			data: { id: id },
			headers: Object.assign({ "Authorization": sessionStorage.access_token, "uid": sessionStorage.uid })
		}).request().then(function (response) {
			dispatch({ type: ACTION_INFO_GRANTEE, Obj: response.data });
			dispatch((0, _Loading.isLoading)(false));
			return response.data;
		}).catch(function (error) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
			throw error;
		});
	};
};

var clearGrantee = exports.clearGrantee = function clearGrantee() {
	return function (dispatch) {
		dispatch({ type: ACTION_GET_GRANTEE, Obj: {} });
		dispatch({ type: ACTION_SEARCH_GRANTEE, Obj: [] });
	};
};

/***/ }),

/***/ 410:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.getGranteeIntegralValuation = exports.getGranteeCurrentStatusNoState = exports.getGranteeCurrentStatus = exports.setGranteeCurrentStatus = exports.clearGranteeCurrentStatus = exports.GET_GRANTEE_INTEGRAL_VALUATION = exports.SET_ACCOUNT = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _Utils = __webpack_require__(2);

var Utils = _interopRequireWildcard(_Utils);

var _Loading = __webpack_require__(3);

var _Modal = __webpack_require__(4);

var _ClientHttpRequest = __webpack_require__(5);

var _ClientHttpRequest2 = _interopRequireDefault(_ClientHttpRequest);

var _immutable = __webpack_require__(1);

var _immutable2 = _interopRequireDefault(_immutable);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var initialState = _immutable2.default.Map({}).set('Status', new _immutable2.default.Map({})).set('Response', new _immutable2.default.Map({}));

/* Types */
var SET_ACCOUNT = exports.SET_ACCOUNT = 'SET_STATUS';

var GET_GRANTEE_INTEGRAL_VALUATION = exports.GET_GRANTEE_INTEGRAL_VALUATION = 'GET_GRANTEE_INTEGRAL_VALUATION';

/* Reducer */

exports.default = function () {
	var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	var action = arguments[1];


	switch (action.type) {
		case SET_ACCOUNT:
			return state.set('Status', new _immutable2.default.Map(action.Obj));
		case GET_GRANTEE_INTEGRAL_VALUATION:
			return state.set('Response', new _immutable2.default.Map(action.Obj));
		default:
			return state;
	}
};

/* Action Creators */

var clearGranteeCurrentStatus = exports.clearGranteeCurrentStatus = function clearGranteeCurrentStatus() {
	return function (dispatch) {
		dispatch({ type: SET_ACCOUNT, Obj: {} }), dispatch({ type: GET_GRANTEE_INTEGRAL_VALUATION, Obj: {} });
		return Promise.resolve();
	};
};

var setGranteeCurrentStatus = exports.setGranteeCurrentStatus = function setGranteeCurrentStatus(form) {
	return function (dispatch) {
		dispatch({ type: SET_ACCOUNT, Obj: form });
	};
};

var getGranteeCurrentStatus = exports.getGranteeCurrentStatus = function getGranteeCurrentStatus(form) {

	return function (dispatch) {

		dispatch((0, _Loading.isLoading)(true));

		return new _ClientHttpRequest2.default({
			service: 'api/getGranteeCurrentStatus',
			method: "POST",
			data: form,
			headers: Object.assign({ "Authorization": sessionStorage.access_token, "uid": sessionStorage.uid })
		}).request().then(function (response) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch({ type: SET_ACCOUNT, Obj: response.data });
		}).catch(function (error) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
			throw error;
		});
	};
};

var getGranteeCurrentStatusNoState = exports.getGranteeCurrentStatusNoState = function getGranteeCurrentStatusNoState(form) {

	return function (dispatch) {

		dispatch((0, _Loading.isLoading)(true));

		return new _ClientHttpRequest2.default({
			service: 'api/getGranteeCurrentStatus',
			method: "POST",
			data: form,
			headers: Object.assign({ "Authorization": sessionStorage.access_token, "uid": sessionStorage.uid })
		}).request().then(function (response) {
			dispatch((0, _Loading.isLoading)(false));
			return response.data;
		}).catch(function (error) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
			throw error;
		});
	};
};

var getGranteeIntegralValuation = exports.getGranteeIntegralValuation = function getGranteeIntegralValuation(form) {

	return function (dispatch) {

		dispatch((0, _Loading.isLoading)(true));
		return new _ClientHttpRequest2.default({
			service: 'api/getGranteeIntegralValuation',
			method: "POST",
			data: _extends({}, form),
			headers: Object.assign({ "Authorization": sessionStorage.access_token, "uid": sessionStorage.uid })
		}).request().then(function (response) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch({ type: GET_GRANTEE_INTEGRAL_VALUATION, Obj: response.data });
		}).catch(function (error) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
			throw error;
		});
	};
};

/***/ }),

/***/ 411:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.clearItem = exports.updateItem = exports.deleteItem = exports.getItem = exports.searchItem = exports.addItem = exports.ACTION_UPDATE_ITEM = exports.ACTION_DELETE_ITEM = exports.ACTION_GET_ITEM = exports.ACTION_SEARCH_ITEM = exports.ACTION_NEW_ITEM = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _Utils = __webpack_require__(2);

var Utils = _interopRequireWildcard(_Utils);

var _ClientHttpRequest = __webpack_require__(5);

var _ClientHttpRequest2 = _interopRequireDefault(_ClientHttpRequest);

var _immutable = __webpack_require__(1);

var _immutable2 = _interopRequireDefault(_immutable);

var _Modal = __webpack_require__(4);

var _Loading = __webpack_require__(3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var initialState = _immutable2.default.Map({}).set('Search', new _immutable2.default.List([])).set('Response', new _immutable2.default.Map({})).set('Get', new _immutable2.default.Map({}));

/* Types */
var ACTION_NEW_ITEM = exports.ACTION_NEW_ITEM = 'ACTION_NEW_ITEM';

var ACTION_SEARCH_ITEM = exports.ACTION_SEARCH_ITEM = 'ACTION_SEARCH_ITEM';

var ACTION_GET_ITEM = exports.ACTION_GET_ITEM = 'ACTION_GET_ITEM';

var ACTION_DELETE_ITEM = exports.ACTION_DELETE_ITEM = 'ACTION_DELETE_ITEM';

var ACTION_UPDATE_ITEM = exports.ACTION_UPDATE_ITEM = 'ACTION_UPDATE_ITEM';

/* Reducer */

exports.default = function () {
	var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	var action = arguments[1];


	switch (action.type) {
		case ACTION_NEW_ITEM:
			return state.set('Response', new _immutable2.default.Map(action.Obj));
		case ACTION_SEARCH_ITEM:
			return state.set('Search', new _immutable2.default.List(action.Obj));
		case ACTION_GET_ITEM:
			return state.set('Get', new _immutable2.default.Map(action.Obj));
		case ACTION_DELETE_ITEM:
			return state.set('Response', new _immutable2.default.Map(action.Obj));
		case ACTION_UPDATE_ITEM:
			return state.set('Response', new _immutable2.default.Map(action.Obj));
		default:
			return state;
	}
};

/* Action Creators */

var addItem = exports.addItem = function addItem(form) {
	return function (dispatch) {

		dispatch((0, _Loading.isLoading)(true));

		return new _ClientHttpRequest2.default({
			service: 'api/newRubro',
			method: "POST",
			data: _extends({}, form),
			headers: Object.assign({ "Authorization": sessionStorage.access_token, "uid": sessionStorage.uid })
		}).request().then(function () {
			dispatch((0, _Loading.isLoading)(false));
			dispatch((0, _Modal.createModal)(Utils.successMessage()));
		}).catch(function (error) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
			throw error;
		});
	};
};

var searchItem = exports.searchItem = function searchItem(form) {
	Utils.clearNullAndEmpty(form);

	return function (dispatch) {

		dispatch((0, _Loading.isLoading)(true));

		return new _ClientHttpRequest2.default({
			service: Object.keys(form).length == 0 ? 'api/searchRubro' : 'api/searchParamRubro',
			method: "POST",
			data: _extends({}, form),
			headers: Object.assign({ "Authorization": sessionStorage.access_token, "uid": sessionStorage.uid })
		}).request().then(function (response) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch({ type: ACTION_SEARCH_ITEM, Obj: response.data });
		}).catch(function (error) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
			throw error;
		});
	};
};

var getItem = exports.getItem = function getItem(id) {
	return function (dispatch) {

		dispatch((0, _Loading.isLoading)(true));

		return new _ClientHttpRequest2.default({
			service: 'api/getRubro',
			method: "POST",
			data: { id: id },
			headers: Object.assign({ "Authorization": sessionStorage.access_token, "uid": sessionStorage.uid })
		}).request().then(function (response) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch({ type: ACTION_GET_ITEM, Obj: response.data });
		}).catch(function (error) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
			throw error;
		});
	};
};

var deleteItem = exports.deleteItem = function deleteItem() {
	return function (dispatch) {
		return dispatch({ type: ACTION_DELETE_ITEM, Obj: { code: '', message: '' } });
	};
};

var updateItem = exports.updateItem = function updateItem(form) {

	return function (dispatch) {

		dispatch((0, _Loading.isLoading)(true));
		dispatch({ type: ACTION_GET_ITEM, Obj: {} });

		return new _ClientHttpRequest2.default({
			service: 'api/updateRubro',
			method: "POST",
			data: _extends({}, form),
			headers: Object.assign({ "Authorization": sessionStorage.access_token, "uid": sessionStorage.uid })
		}).request().then(function (response) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch({ type: ACTION_UPDATE_ITEM, Obj: response.data });
			dispatch((0, _Modal.createModal)(Utils.successMessage()));
		}).catch(function (error) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
			throw error;
		});
	};
};

var clearItem = exports.clearItem = function clearItem() {
	return function (dispatch) {
		dispatch({ type: ACTION_GET_ITEM, Obj: {} });
		dispatch({ type: ACTION_SEARCH_ITEM, Obj: [] });
	};
};

/***/ }),

/***/ 412:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.clearProfile = exports.updateProfile = exports.deleteProfile = exports.getProfile = exports.searchProfile = exports.addProfile = exports.ACTION_UPDATE_PROFILE = exports.ACTION_DELETE_PROFILE = exports.ACTION_GET_PROFILE = exports.ACTION_SEARCH_PROFILE = exports.ACTION_NEW_PROFILE = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _Utils = __webpack_require__(2);

var Utils = _interopRequireWildcard(_Utils);

var _ClientHttpRequest = __webpack_require__(5);

var _ClientHttpRequest2 = _interopRequireDefault(_ClientHttpRequest);

var _immutable = __webpack_require__(1);

var _immutable2 = _interopRequireDefault(_immutable);

var _Modal = __webpack_require__(4);

var _Loading = __webpack_require__(3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var initialState = _immutable2.default.Map({}).set('Search', new _immutable2.default.List([])).set('Response', new _immutable2.default.Map({})).set('Get', new _immutable2.default.Map({}));

/* Types */

var ACTION_NEW_PROFILE = exports.ACTION_NEW_PROFILE = 'ACTION_NEW_PROFILE';

var ACTION_SEARCH_PROFILE = exports.ACTION_SEARCH_PROFILE = 'ACTION_SEARCH_PROFILE';

var ACTION_GET_PROFILE = exports.ACTION_GET_PROFILE = 'ACTION_GET_PROFILE';

var ACTION_DELETE_PROFILE = exports.ACTION_DELETE_PROFILE = 'ACTION_DELETE_PROFILE';

var ACTION_UPDATE_PROFILE = exports.ACTION_UPDATE_PROFILE = 'ACTION_UPDATE_PROFILE';

/* Reducer */

exports.default = function () {
	var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	var action = arguments[1];


	switch (action.type) {
		case ACTION_NEW_PROFILE:
			return state.set('Response', new _immutable2.default.Map(action.Obj));
		case ACTION_SEARCH_PROFILE:
			return state.set('Search', new _immutable2.default.List(action.Obj));
		case ACTION_GET_PROFILE:
			return state.set('Get', new _immutable2.default.Map(action.Obj));
		case ACTION_DELETE_PROFILE:
			return state.set('Response', new _immutable2.default.Map(action.Obj));
		case ACTION_UPDATE_PROFILE:
			return state.set('Response', new _immutable2.default.Map(action.Obj));
		default:
			return state;
	}
};

/* Action Creators */

var addProfile = exports.addProfile = function addProfile(form) {

	return function (dispatch) {

		dispatch((0, _Loading.isLoading)(true));

		return new _ClientHttpRequest2.default({
			service: 'api/newProfile',
			method: "POST",
			data: _extends({}, form),
			headers: Object.assign({ "Authorization": sessionStorage.access_token, "uid": sessionStorage.uid })
		}).request().then(function (response) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch({ type: ACTION_NEW_PROFILE, Obj: response.data });
			dispatch((0, _Modal.createModal)(Utils.successMessage()));
		}).catch(function (error) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
			throw error;
		});
	};
};

var searchProfile = exports.searchProfile = function searchProfile(form) {

	Utils.clearNullAndEmpty(form);

	return function (dispatch) {

		dispatch((0, _Loading.isLoading)(true));

		return new _ClientHttpRequest2.default({
			service: Object.keys(form).length == 0 ? 'api/searchProfile' : 'api/searchParamProfile',
			method: "POST",
			data: _extends({}, form),
			headers: Object.assign({ "Authorization": sessionStorage.access_token, "uid": sessionStorage.uid })
		}).request().then(function (response) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch({ type: ACTION_SEARCH_PROFILE, Obj: response.data });
			return response.data;
		}).catch(function (error) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
			throw error;
		});
	};
};

var getProfile = exports.getProfile = function getProfile(id) {

	return function (dispatch) {

		dispatch((0, _Loading.isLoading)(true));

		return new _ClientHttpRequest2.default({
			service: 'api/getProfile',
			method: "POST",
			data: { id: id },
			headers: Object.assign({ "Authorization": sessionStorage.access_token, "uid": sessionStorage.uid })
		}).request().then(function (response) {
			dispatch({ type: ACTION_GET_PROFILE, Obj: response.data });
			dispatch((0, _Loading.isLoading)(false));
		}).catch(function (error) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
			throw error;
		});
	};
};

var deleteProfile = exports.deleteProfile = function deleteProfile() {
	return function (dispatch) {
		return dispatch({ type: ACTION_DELETE_PROFILE, Obj: { code: '', message: '' } });
	};
};

var updateProfile = exports.updateProfile = function updateProfile(form) {

	var data = Object.assign({}, form);
	//data.funcionalidad = Utils.unionArray(data.funcionalidad, data.funcionalidadRemove)

	return function (dispatch) {

		dispatch((0, _Loading.isLoading)(true));
		dispatch({ type: ACTION_GET_PROFILE, Obj: {} });

		return new _ClientHttpRequest2.default({
			service: 'api/updateProfile',
			method: "POST",
			data: _extends({}, data),
			headers: Object.assign({ "Authorization": sessionStorage.access_token, "uid": sessionStorage.uid })
		}).request().then(function (response) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch({ type: ACTION_UPDATE_PROFILE, Obj: response.data });
			dispatch((0, _Modal.createModal)(Utils.successMessage()));
		}).catch(function (error) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
			throw error;
		});
	};
};

var clearProfile = exports.clearProfile = function clearProfile() {
	return function (dispatch) {
		dispatch({ type: ACTION_GET_PROFILE, Obj: {} });
		dispatch({ type: ACTION_SEARCH_PROFILE, Obj: [] });
	};
};

/***/ }),

/***/ 413:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.searchQuestionTypeByName = exports.searchQuestionType = exports.ACTION_GET_QUESTION_TYPE = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _Utils = __webpack_require__(2);

var Utils = _interopRequireWildcard(_Utils);

var _QuestionProject = __webpack_require__(216);

var _ClientHttpRequest = __webpack_require__(5);

var _ClientHttpRequest2 = _interopRequireDefault(_ClientHttpRequest);

var _immutable = __webpack_require__(1);

var _immutable2 = _interopRequireDefault(_immutable);

var _Modal = __webpack_require__(4);

var _Loading = __webpack_require__(3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var initialState = _immutable2.default.Map({}).set('Search', new _immutable2.default.List([]));

/* Types */
var ACTION_GET_QUESTION_TYPE = exports.ACTION_GET_QUESTION_TYPE = 'ACTION_GET_QUESTION_TYPE';

/* Reducer */

exports.default = function () {
	var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	var action = arguments[1];


	switch (action.type) {
		case ACTION_GET_QUESTION_TYPE:
			return state.set('Search', new _immutable2.default.List(action.Obj));
		default:
			return state;
	}
};

/* Action Creators */

var searchQuestionType = exports.searchQuestionType = function searchQuestionType(form) {

	return function (dispatch) {

		dispatch((0, _Loading.isLoading)(true));

		return new _ClientHttpRequest2.default({
			service: 'api/searchQuestionType',
			method: "POST",
			data: _extends({}, form),
			headers: Object.assign({ "Authorization": sessionStorage.access_token, "uid": sessionStorage.uid })
		}).request().then(function (response) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch({ type: ACTION_GET_QUESTION_TYPE, Obj: response.data });
		}).catch(function (error) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
			throw error;
		});
	};
};

var searchQuestionTypeByName = exports.searchQuestionTypeByName = function searchQuestionTypeByName(form) {

	return function (dispatch) {

		dispatch((0, _Loading.isLoading)(true));
		dispatch({ type: _QuestionProject.ACTION_GET_QUESTION_PROJECT, Obj: {} });
		return new _ClientHttpRequest2.default({
			service: 'api/searchQuestionTypeByName',
			method: "POST",
			data: _extends({}, form),
			headers: Object.assign({ "Authorization": sessionStorage.access_token, "uid": sessionStorage.uid })
		}).request().then(function (response) {
			dispatch((0, _Loading.isLoading)(false));
			return response.data;
		}).catch(function (error) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
			throw error;
		});
	};
};

/***/ }),

/***/ 414:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.clearVariable = exports.exportPDFVariable = exports.updateVariable = exports.deleteVariable = exports.getVariable = exports.searchVariable = exports.addVariable = exports.ACTION_UPDATE_VARIABLE = exports.ACTION_DELETE_VARIABLE = exports.ACTION_GET_VARIABLE = exports.ACTION_SEARCH_VARIABLE = exports.ACTION_NEW_VARIABLE = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _Utils = __webpack_require__(2);

var Utils = _interopRequireWildcard(_Utils);

var _ClientHttpRequest = __webpack_require__(5);

var _ClientHttpRequest2 = _interopRequireDefault(_ClientHttpRequest);

var _immutable = __webpack_require__(1);

var _immutable2 = _interopRequireDefault(_immutable);

var _Modal = __webpack_require__(4);

var _Loading = __webpack_require__(3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var initialState = _immutable2.default.Map({}).set('Search', new _immutable2.default.List([])).set('Response', new _immutable2.default.Map({})).set('Get', new _immutable2.default.Map({}));

/* Types */

var ACTION_NEW_VARIABLE = exports.ACTION_NEW_VARIABLE = 'ACTION_NEW_VARIABLE';

var ACTION_SEARCH_VARIABLE = exports.ACTION_SEARCH_VARIABLE = 'ACTION_SEARCH_VARIABLE';

var ACTION_GET_VARIABLE = exports.ACTION_GET_VARIABLE = 'ACTION_GET_VARIABLE';

var ACTION_DELETE_VARIABLE = exports.ACTION_DELETE_VARIABLE = 'ACTION_DELETE_VARIABLE';

var ACTION_UPDATE_VARIABLE = exports.ACTION_UPDATE_VARIABLE = 'ACTION_UPDATE_VARIABLE';

/* Reducer */

exports.default = function () {
	var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	var action = arguments[1];


	switch (action.type) {
		case ACTION_NEW_VARIABLE:
			return state.set('Response', new _immutable2.default.Map(action.Obj));
		case ACTION_SEARCH_VARIABLE:
			return state.set('Search', new _immutable2.default.List(action.Obj));
		case ACTION_GET_VARIABLE:
			return state.set('Get', new _immutable2.default.Map(action.Obj));
		case ACTION_DELETE_VARIABLE:
			return state.set('Response', new _immutable2.default.Map(action.Obj));
		case ACTION_UPDATE_VARIABLE:
			return state.set('Response', new _immutable2.default.Map(action.Obj));
		default:
			return state;
	}
};

/* Action Creators */

var addVariable = exports.addVariable = function addVariable(form) {

	var data = Object.assign({}, form);
	data.preguntasValoracion = Utils.getListPropsOmit(data.preguntasValoracion, ['custom', 'id', 'puntuacionMaxima', 'preguntaValoracionItem']);
	data.rangos = Utils.getListPropsOmit(data.rangos, ['id', 'tmp']);

	return function (dispatch) {

		dispatch((0, _Loading.isLoading)(true));

		return new _ClientHttpRequest2.default({
			service: 'api/newVariable',
			method: "POST",
			data: _extends({}, data),
			headers: Object.assign({ "Authorization": sessionStorage.access_token, "uid": sessionStorage.uid })
		}).request().then(function (response) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch({ type: ACTION_NEW_VARIABLE, Obj: response.data });
			dispatch((0, _Modal.createModal)(Utils.successMessage()));
		}).catch(function (error) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
			throw error;
		});
	};
};

var searchVariable = exports.searchVariable = function searchVariable(form) {

	Utils.clearNullAndEmpty(form);

	return function (dispatch) {

		dispatch((0, _Loading.isLoading)(true));

		return new _ClientHttpRequest2.default({
			service: Object.keys(form).length == 0 ? 'api/searchVariable' : 'api/searchParamVariable',
			method: "POST",
			data: _extends({}, form),
			headers: Object.assign({ "Authorization": sessionStorage.access_token, "uid": sessionStorage.uid })
		}).request().then(function (response) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch({ type: ACTION_SEARCH_VARIABLE, Obj: response.data });
		}).catch(function (error) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
			throw error;
		});
	};
};

var getVariable = exports.getVariable = function getVariable(id) {

	return function (dispatch) {

		dispatch((0, _Loading.isLoading)(true));

		return new _ClientHttpRequest2.default({
			service: 'api/getVariable',
			method: "POST",
			data: { id: id },
			headers: Object.assign({ "Authorization": sessionStorage.access_token, "uid": sessionStorage.uid })
		}).request().then(function (response) {
			dispatch({ type: ACTION_GET_VARIABLE, Obj: response.data });
			dispatch((0, _Loading.isLoading)(false));
		}).catch(function (error) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
			throw error;
		});
	};
};

var deleteVariable = exports.deleteVariable = function deleteVariable() {
	return function (dispatch) {
		return dispatch({ type: ACTION_DELETE_VARIABLE, Obj: { code: '', message: '' } });
	};
};

var updateVariable = exports.updateVariable = function updateVariable(form) {

	var data = Object.assign({}, form);
	data.preguntasValoracion = Utils.getListPropsOmit(data.preguntasValoracion, ['custom', 'id', 'preguntaValoracionItem', 'puntuacionMaxima']);
	data.preguntasValoracion = Utils.unionArray(data.preguntasValoracion, data.preguntasValoracionRemove);

	data.rangos = Utils.getListPropsOmit(data.rangos, ['id', 'tmp']);
	data.rangos = Utils.unionArray(data.rangos, data.rangosRemove);

	return function (dispatch) {

		dispatch((0, _Loading.isLoading)(true));
		dispatch({ type: ACTION_GET_VARIABLE, Obj: {} });

		return new _ClientHttpRequest2.default({
			service: 'api/updateVariable',
			method: "POST",
			data: _extends({}, data),
			headers: Object.assign({ "Authorization": sessionStorage.access_token, "uid": sessionStorage.uid })
		}).request().then(function (response) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch({ type: ACTION_UPDATE_VARIABLE, Obj: response.data });
			dispatch((0, _Modal.createModal)(Utils.successMessage()));
		}).catch(function (error) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
			throw error;
		});
	};
};

var exportPDFVariable = exports.exportPDFVariable = function exportPDFVariable(form) {
	return function (dispatch) {
		dispatch((0, _Loading.isLoading)(true));
		return new _ClientHttpRequest2.default({
			service: 'api/exportPDFVariable',
			method: 'POST',
			data: _extends({}, form),
			responseType: 'arraybuffer',
			headers: Object.assign({ "Authorization": sessionStorage.access_token, "uid": sessionStorage.uid })
		}).request().then(function (response) {
			dispatch((0, _Loading.isLoading)(false));
			var fileURL = "https://donatarias.montepiedad.com.mx" + '/reporte-configuracion-variables.pdf';
			window.open(fileURL);
		}).catch(function (error) {
			dispatch((0, _Loading.isLoading)(false));
			throw error;
		});
	};
};

var clearVariable = exports.clearVariable = function clearVariable() {
	return function (dispatch) {
		dispatch({ type: ACTION_GET_VARIABLE, Obj: {} });
		dispatch({ type: ACTION_SEARCH_VARIABLE, Obj: [] });
	};
};

/***/ }),

/***/ 415:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.setAccountModify = exports.changeUser = exports.resetPassword = exports.sendRecoveryAccount = exports.getValidateCorreoToken = exports.setCorreoRegistro = exports.activateAccount = exports.preRegistro = exports.permissionFeature = exports.GET_MAIL_TOKEN = exports.SET_MAIL_TOKEN = exports.SET_ACCOUNT_MODIFY = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _Utils = __webpack_require__(2);

var Utils = _interopRequireWildcard(_Utils);

var _ClientHttpRequest = __webpack_require__(5);

var _ClientHttpRequest2 = _interopRequireDefault(_ClientHttpRequest);

var _immutable = __webpack_require__(1);

var _immutable2 = _interopRequireDefault(_immutable);

var _Modal = __webpack_require__(4);

var _Loading = __webpack_require__(3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var initialState = _immutable2.default.Map({}).set('modifyUser', new _immutable2.default.Map({})).set('setMailToken', new _immutable2.default.Map({})).set('getMailToken', new _immutable2.default.Map({}));

/* Types */
var SET_ACCOUNT_MODIFY = exports.SET_ACCOUNT_MODIFY = 'SET_ACCOUNT_MODIFY';
var SET_MAIL_TOKEN = exports.SET_MAIL_TOKEN = 'SET_MAIL_TOKEN';
var GET_MAIL_TOKEN = exports.GET_MAIL_TOKEN = 'GET_MAIL_TOKEN';

/* Reducer */

exports.default = function () {
	var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	var action = arguments[1];


	switch (action.type) {
		case SET_ACCOUNT_MODIFY:
			return state.set('modifyUser', new _immutable2.default.Map(action.Obj));
		case SET_MAIL_TOKEN:
			return state.set('setMailToken', new _immutable2.default.Map(action.Obj));
		case GET_MAIL_TOKEN:
			return state.set('getMailToken', new _immutable2.default.Map(action.Obj));
		default:
			return state;
	}
};

var permissionFeature = exports.permissionFeature = function permissionFeature(form) {

	return function (dispatch) {

		dispatch((0, _Loading.isLoading)(true));

		return new _ClientHttpRequest2.default({
			service: 'auth/permissionFeature',
			method: "POST",
			data: _extends({}, form)
		}).request().then(function (response) {
			dispatch((0, _Loading.isLoading)(false));
			return response.data.result;
		}).catch(function (error) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
			throw error;
		});
	};
};

var preRegistro = exports.preRegistro = function preRegistro(form) {

	return function (dispatch) {

		dispatch((0, _Loading.isLoading)(true));

		return new _ClientHttpRequest2.default({
			service: 'auth/newAccount',
			method: "POST",
			data: _extends({}, form)
		}).request().then(function () {
			dispatch((0, _Loading.isLoading)(false));
			return true;
		}).catch(function (error) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
			throw error;
		});
	};
};

var activateAccount = exports.activateAccount = function activateAccount(form) {

	return function (dispatch) {

		dispatch((0, _Loading.isLoading)(true));

		return new _ClientHttpRequest2.default({
			service: 'auth/activateAccount',
			method: "POST",
			data: _extends({}, form)
		}).request().then(function () {
			dispatch((0, _Loading.isLoading)(false));
			return true;
		}).catch(function (error) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
			throw error;
		});
	};
};

var setCorreoRegistro = exports.setCorreoRegistro = function setCorreoRegistro(form) {

	return function (dispatch) {

		dispatch((0, _Loading.isLoading)(true));

		return new _ClientHttpRequest2.default({
			service: 'auth/setCorreoRegistro',
			method: "POST",
			data: _extends({}, form)
		}).request().then(function (obj) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch({ type: SET_MAIL_TOKEN, Obj: obj.data });
			return true;
		}).catch(function (error) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
			throw error;
		});
	};
};

var getValidateCorreoToken = exports.getValidateCorreoToken = function getValidateCorreoToken(form) {

	return function (dispatch) {

		dispatch((0, _Loading.isLoading)(true));

		return new _ClientHttpRequest2.default({
			service: 'auth/getValidateCorreoToken',
			method: "POST",
			data: _extends({}, form)
		}).request().then(function (obj) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch({ type: GET_MAIL_TOKEN, Obj: obj.data });
			return true;
		}).catch(function (error) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
			throw error;
		});
	};
};

var sendRecoveryAccount = exports.sendRecoveryAccount = function sendRecoveryAccount(form) {

	return function (dispatch) {

		dispatch((0, _Loading.isLoading)(true));

		return new _ClientHttpRequest2.default({
			service: 'auth/sendRecoveryAccount',
			method: "POST",
			data: _extends({}, form)
		}).request().then(function () {
			dispatch((0, _Loading.isLoading)(false));
			return true;
		}).catch(function (error) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
			throw error;
		});
	};
};

var resetPassword = exports.resetPassword = function resetPassword(arrayReset) {

	return function (dispatch) {

		dispatch((0, _Loading.isLoading)(true));

		return new _ClientHttpRequest2.default({
			service: 'api/resetPassword',
			method: "POST",
			data: { arrayReset: arrayReset },
			headers: Object.assign({ "Authorization": sessionStorage.access_token, "uid": sessionStorage.uid })
		}).request().then(function (response) {
			dispatch((0, _Loading.isLoading)(false));
			return response;
		}).catch(function (error) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
			throw error;
		});
	};
};

var changeUser = exports.changeUser = function changeUser(data) {
	var payloadReset = {
		actualizarUsuarios: {
			actualizarUsuario: [{
				createdBy: sessionStorage.uid,
				idDonataria: data.idDonataria,
				idUsuarioAnterior: data.idUsuario,
				usuarioNuevo: {
					idUsuario: data.form.direccionCorreo,
					nombre: data.form.nombre,
					apellidoPaterno: data.form.apellidoPaterno,
					apellidoMaterno: data.form.apellidoMaterno
				}
			}]
		}
	};

	return function (dispatch) {

		dispatch((0, _Loading.isLoading)(true));
		return new _ClientHttpRequest2.default({
			service: 'api/changeUser',
			method: "POST",
			data: payloadReset,
			headers: Object.assign({ "Authorization": sessionStorage.access_token, "uid": sessionStorage.uid })
		}).request().then(function (response) {
			dispatch((0, _Loading.isLoading)(false));
			return response;
		}).catch(function (error) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
			throw error;
		});
	};
};

var setAccountModify = exports.setAccountModify = function setAccountModify(obj) {

	return function (dispatch) {
		dispatch({ type: SET_ACCOUNT_MODIFY, Obj: obj });
		return Promise.resolve();
	};
};

/***/ }),

/***/ 416:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.clearEvaluation = exports.exportPDFEvaluacion = exports.updateEvaluation = exports.deleteEvaluation = exports.getEvaluation = exports.searchEvaluation = exports.addEvaluation = exports.ACTION_UPDATE_EVALUATION = exports.ACTION_DELETE_EVALUATION = exports.ACTION_GET_EVALUATION = exports.ACTION_SEARCH_EVALUATION = exports.ACTION_NEW_EVALUATION = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _Utils = __webpack_require__(2);

var Utils = _interopRequireWildcard(_Utils);

var _ClientHttpRequest = __webpack_require__(5);

var _ClientHttpRequest2 = _interopRequireDefault(_ClientHttpRequest);

var _immutable = __webpack_require__(1);

var _immutable2 = _interopRequireDefault(_immutable);

var _Modal = __webpack_require__(4);

var _Loading = __webpack_require__(3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var initialState = _immutable2.default.Map({}).set('Search', new _immutable2.default.List([])).set('Response', new _immutable2.default.Map({})).set('Get', new _immutable2.default.Map({}));

/* Types */

var ACTION_NEW_EVALUATION = exports.ACTION_NEW_EVALUATION = 'ACTION_NEW_EVALUATION';

var ACTION_SEARCH_EVALUATION = exports.ACTION_SEARCH_EVALUATION = 'ACTION_SEARCH_EVALUATION';

var ACTION_GET_EVALUATION = exports.ACTION_GET_EVALUATION = 'ACTION_GET_EVALUATION';

var ACTION_DELETE_EVALUATION = exports.ACTION_DELETE_EVALUATION = 'ACTION_DELETE_EVALUATION';

var ACTION_UPDATE_EVALUATION = exports.ACTION_UPDATE_EVALUATION = 'ACTION_UPDATE_EVALUATION';

/* Reducer */

exports.default = function () {
	var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	var action = arguments[1];


	switch (action.type) {
		case ACTION_NEW_EVALUATION:
			return state.set('Response', new _immutable2.default.Map(action.Obj));
		case ACTION_SEARCH_EVALUATION:
			return state.set('Search', new _immutable2.default.List(action.Obj));
		case ACTION_GET_EVALUATION:
			return state.set('Get', new _immutable2.default.Map(action.Obj));
		case ACTION_DELETE_EVALUATION:
			return state.set('Response', new _immutable2.default.Map(action.Obj));
		case ACTION_UPDATE_EVALUATION:
			return state.set('Response', new _immutable2.default.Map(action.Obj));
		default:
			return state;
	}
};

/* Action Creators */

var addEvaluation = exports.addEvaluation = function addEvaluation(form) {

	var data = Object.assign({}, form);
	data.variables = Utils.getListPropsOmit(data.variables, ['custom', 'id', 'variableItem', 'puntuacionMaxima']);
	data.rangos = Utils.getListPropsOmit(data.rangos, ['id', 'tmp', 'entrePuntosSelect', 'hastaPuntosSelect']);

	return function (dispatch) {

		dispatch((0, _Loading.isLoading)(true));

		return new _ClientHttpRequest2.default({
			service: 'api/newEvaluation',
			method: "POST",
			data: _extends({}, data),
			headers: Object.assign({ "Authorization": sessionStorage.access_token, "uid": sessionStorage.uid })
		}).request().then(function (response) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch({ type: ACTION_NEW_EVALUATION, Obj: response.data });
			dispatch((0, _Modal.createModal)(Utils.successMessage()));
		}).catch(function (error) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
			throw error;
		});
	};
};

var searchEvaluation = exports.searchEvaluation = function searchEvaluation(form) {

	Utils.clearNullAndEmpty(form);

	return function (dispatch) {

		dispatch((0, _Loading.isLoading)(true));

		return new _ClientHttpRequest2.default({
			service: Object.keys(form).length == 0 ? 'api/searchEvaluation' : 'api/searchParamEvaluation',
			method: "POST",
			data: _extends({}, form),
			headers: Object.assign({ "Authorization": sessionStorage.access_token, "uid": sessionStorage.uid })
		}).request().then(function (response) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch({ type: ACTION_SEARCH_EVALUATION, Obj: response.data });
		}).catch(function (error) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
			throw error;
		});
	};
};

var getEvaluation = exports.getEvaluation = function getEvaluation(id) {

	return function (dispatch) {

		dispatch((0, _Loading.isLoading)(true));

		return new _ClientHttpRequest2.default({
			service: 'api/getEvaluation',
			method: "POST",
			data: { id: id },
			headers: Object.assign({ "Authorization": sessionStorage.access_token, "uid": sessionStorage.uid })
		}).request().then(function (response) {
			var data = response.data;
			if (data.dependeOtraEvaluacion === 0) data = _extends({}, data, { dependeOtraEvaluacion: 2, checkOtraEval: true });
			dispatch({ type: ACTION_GET_EVALUATION, Obj: data });
			dispatch((0, _Loading.isLoading)(false));
		}).catch(function (error) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
			throw error;
		});
	};
};

var deleteEvaluation = exports.deleteEvaluation = function deleteEvaluation() {

	return function (dispatch) {
		return dispatch({ type: ACTION_DELETE_EVALUATION, Obj: { code: '', message: '' } });
	};
};

var updateEvaluation = exports.updateEvaluation = function updateEvaluation(form) {

	var data = Object.assign({}, form);
	data.variables = Utils.getListPropsOmit(data.variables, ['custom', 'id', 'variableItem', 'puntuacionMaxima']);
	data.variables = Utils.unionArray(data.variables, data.variablesRemove);

	data.rangos = Utils.getListPropsOmit(data.rangos, ['entrePuntosSelect', 'hastaPuntosSelect']);

	data.rangos = data.rangos.map(function (r) {
		if (r.tmp) {
			delete r.id;
			delete r.tmp;
		}
		return r;
	});

	data.rangos = Utils.unionArray(data.rangos, data.rangosRemove);

	return function (dispatch) {

		dispatch((0, _Loading.isLoading)(true));
		dispatch({ type: ACTION_GET_EVALUATION, Obj: {} });

		return new _ClientHttpRequest2.default({
			service: 'api/updateEvaluation',
			method: "POST",
			data: _extends({}, data),
			headers: Object.assign({ "Authorization": sessionStorage.access_token, "uid": sessionStorage.uid })
		}).request().then(function (response) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch({ type: ACTION_UPDATE_EVALUATION, Obj: response.data });
			dispatch((0, _Modal.createModal)(Utils.successMessage()));
		}).catch(function (error) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
			throw error;
		});
	};
};

var exportPDFEvaluacion = exports.exportPDFEvaluacion = function exportPDFEvaluacion(form) {
	return function (dispatch) {
		dispatch((0, _Loading.isLoading)(true));
		return new _ClientHttpRequest2.default({
			service: 'api/exportPDFEvaluation',
			method: 'POST',
			data: _extends({}, form),
			responseType: 'arraybuffer',
			headers: Object.assign({ "Authorization": sessionStorage.access_token, "uid": sessionStorage.uid })
		}).request().then(function (response) {
			dispatch((0, _Loading.isLoading)(false));
			var fileURL = "https://donatarias.montepiedad.com.mx" + '/reporte-configuracion-tipo-evaluacion.pdf';
			window.open(fileURL);
		}).catch(function (error) {
			dispatch((0, _Loading.isLoading)(false));
			throw error;
		});
	};
};

var clearEvaluation = exports.clearEvaluation = function clearEvaluation() {
	return function (dispatch) {
		dispatch({ type: ACTION_GET_EVALUATION, Obj: {} });
		dispatch({ type: ACTION_SEARCH_EVALUATION, Obj: [] });
	};
};

/***/ }),

/***/ 417:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.clearLegalConcept = exports.updateLegalConcept = exports.getLegalConcept = exports.addLegalConcept = exports.searchLegalConcept = exports.ACTION_UPDATE__LEGAL_CONCEPT = exports.ACTION_GET__LEGAL_CONCEPT = exports.ACTION_NEW__LEGAL_CONCEPT = exports.ACTION_SEARCH__LEGAL_CONCEPT = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _Utils = __webpack_require__(2);

var Utils = _interopRequireWildcard(_Utils);

var _ClientHttpRequest = __webpack_require__(5);

var _ClientHttpRequest2 = _interopRequireDefault(_ClientHttpRequest);

var _immutable = __webpack_require__(1);

var _immutable2 = _interopRequireDefault(_immutable);

var _Modal = __webpack_require__(4);

var _Loading = __webpack_require__(3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var initialState = _immutable2.default.Map({}).set('Search', new _immutable2.default.List([])).set('Response', new _immutable2.default.Map({})).set('Get', new _immutable2.default.Map({}));

/* Types */

var ACTION_SEARCH__LEGAL_CONCEPT = exports.ACTION_SEARCH__LEGAL_CONCEPT = 'ACTION_SEARCH__LEGAL_CONCEPT';

var ACTION_NEW__LEGAL_CONCEPT = exports.ACTION_NEW__LEGAL_CONCEPT = 'ACTION_NEW__LEGAL_CONCEPT';

var ACTION_GET__LEGAL_CONCEPT = exports.ACTION_GET__LEGAL_CONCEPT = 'ACTION_GET__LEGAL_CONCEPT';

var ACTION_UPDATE__LEGAL_CONCEPT = exports.ACTION_UPDATE__LEGAL_CONCEPT = 'ACTION_UPDATE__LEGAL_CONCEPT';

/* Reducer */

exports.default = function () {
	var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	var action = arguments[1];


	switch (action.type) {
		case ACTION_SEARCH__LEGAL_CONCEPT:
			return state.set('Search', new _immutable2.default.List(action.Obj));
		case ACTION_NEW__LEGAL_CONCEPT:
			return state.set('Response', new _immutable2.default.Map(action.Obj));
		case ACTION_GET__LEGAL_CONCEPT:
			return state.set('Get', new _immutable2.default.Map(action.Obj));
		case ACTION_UPDATE__LEGAL_CONCEPT:
			return state.set('Response', new _immutable2.default.Map(action.Obj));
		default:
			return state;
	}
};

/* Action Creators */

var searchLegalConcept = exports.searchLegalConcept = function searchLegalConcept(form) {

	Utils.clearNullAndEmpty(form);

	return function (dispatch) {

		dispatch((0, _Loading.isLoading)(true));

		return new _ClientHttpRequest2.default({
			service: Object.keys(form).length == 0 ? 'api/searchLegalConcept' : 'api/searchParamLegalConcept',
			method: "POST",
			data: _extends({}, form),
			headers: Object.assign({ "Authorization": sessionStorage.access_token, "uid": sessionStorage.uid })
		}).request().then(function (response) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch({ type: ACTION_SEARCH__LEGAL_CONCEPT, Obj: response.data });
		}).catch(function (error) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
			throw error;
		});
	};
};

var addLegalConcept = exports.addLegalConcept = function addLegalConcept(form) {

	return function (dispatch) {

		dispatch((0, _Loading.isLoading)(true));

		return new _ClientHttpRequest2.default({
			service: 'api/newLegalConcept',
			method: "POST",
			data: _extends({}, form),
			headers: Object.assign({ "Authorization": sessionStorage.access_token, "uid": sessionStorage.uid })
		}).request().then(function (response) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch({ type: ACTION_NEW__LEGAL_CONCEPT, Obj: response.data });
			dispatch((0, _Modal.createModal)(Utils.successMessage()));
		}).catch(function (error) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
			throw error;
		});
	};
};

var getLegalConcept = exports.getLegalConcept = function getLegalConcept(id) {

	return function (dispatch) {

		dispatch((0, _Loading.isLoading)(true));

		return new _ClientHttpRequest2.default({
			service: 'api/getLegalConcept',
			method: "POST",
			data: { id: id },
			headers: Object.assign({ "Authorization": sessionStorage.access_token, "uid": sessionStorage.uid })
		}).request().then(function (response) {
			dispatch({ type: ACTION_GET__LEGAL_CONCEPT, Obj: response.data });
			dispatch((0, _Loading.isLoading)(false));
		}).catch(function (error) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
			throw error;
		});
	};
};

var updateLegalConcept = exports.updateLegalConcept = function updateLegalConcept(form) {

	return function (dispatch) {

		dispatch((0, _Loading.isLoading)(true));
		dispatch({ type: ACTION_GET__LEGAL_CONCEPT, Obj: {} });

		return new _ClientHttpRequest2.default({
			service: 'api/updateLegalConcept',
			method: "POST",
			data: _extends({}, form),
			headers: Object.assign({ "Authorization": sessionStorage.access_token, "uid": sessionStorage.uid })
		}).request().then(function (response) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch({ type: ACTION_UPDATE__LEGAL_CONCEPT, Obj: response.data });
			dispatch((0, _Modal.createModal)(Utils.successMessage()));
		}).catch(function (error) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
			throw error;
		});
	};
};

var clearLegalConcept = exports.clearLegalConcept = function clearLegalConcept() {
	return function (dispatch) {
		dispatch({ type: ACTION_GET__LEGAL_CONCEPT, Obj: {} });
		dispatch({ type: ACTION_SEARCH__LEGAL_CONCEPT, Obj: [] });
	};
};

/***/ }),

/***/ 418:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.searchSymbols = exports.ACTION_GET_SYMBOLS = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _Utils = __webpack_require__(2);

var Utils = _interopRequireWildcard(_Utils);

var _ClientHttpRequest = __webpack_require__(5);

var _ClientHttpRequest2 = _interopRequireDefault(_ClientHttpRequest);

var _immutable = __webpack_require__(1);

var _immutable2 = _interopRequireDefault(_immutable);

var _Modal = __webpack_require__(4);

var _Loading = __webpack_require__(3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var initialState = _immutable2.default.Map({}).set('Symbols', new _immutable2.default.List([])).set('Search', new _immutable2.default.List([])).set('Response', new _immutable2.default.Map({})).set('Get', new _immutable2.default.Map({}));

/* Types */
var ACTION_GET_SYMBOLS = exports.ACTION_GET_SYMBOLS = 'ACTION_GET_SYMBOLS';

/* Reducer */

exports.default = function () {
	var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	var action = arguments[1];


	switch (action.type) {
		case ACTION_GET_SYMBOLS:
			return state.set('Symbols', new _immutable2.default.List(action.Obj));
		default:
			return state;
	}
};

/* Action Creators */

var searchSymbols = exports.searchSymbols = function searchSymbols(form) {

	return function (dispatch) {

		dispatch((0, _Loading.isLoading)(true));

		return new _ClientHttpRequest2.default({
			service: 'api/searchSymbols',
			method: "POST",
			data: _extends({}, form),
			headers: Object.assign({ "Authorization": sessionStorage.access_token, "uid": sessionStorage.uid })
		}).request().then(function (response) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch({ type: ACTION_GET_SYMBOLS, Obj: response.data });
		}).catch(function (error) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
			throw error;
		});
	};
};

/***/ }),

/***/ 419:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.getTownById = exports.GET_TOWN_BY_ID = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _Utils = __webpack_require__(2);

var Utils = _interopRequireWildcard(_Utils);

var _ClientHttpRequest = __webpack_require__(5);

var _ClientHttpRequest2 = _interopRequireDefault(_ClientHttpRequest);

var _immutable = __webpack_require__(1);

var _immutable2 = _interopRequireDefault(_immutable);

var _Modal = __webpack_require__(4);

var _Loading = __webpack_require__(3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var initialState = _immutable2.default.Map({}).set('Search', new _immutable2.default.List([])).set('Response', new _immutable2.default.Map({})).set('Get', new _immutable2.default.Map({}));

/* Types */
var GET_TOWN_BY_ID = exports.GET_TOWN_BY_ID = 'GET_TOWN_BY_ID';

/* Reducer */

exports.default = function () {
	var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	var action = arguments[1];


	switch (action.type) {
		case GET_TOWN_BY_ID:
			return state.set('Search', new _immutable2.default.List(action.Obj));
		default:
			return state;
	}
};

/* Action Creators */


var getTownById = exports.getTownById = function getTownById(form) {

	return function (dispatch) {

		dispatch((0, _Loading.isLoading)(true));

		return new _ClientHttpRequest2.default({
			service: 'api/getTownById',
			method: "POST",
			data: _extends({}, form),
			headers: Object.assign({ "Authorization": sessionStorage.access_token, "uid": sessionStorage.uid })
		}).request().then(function (response) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch({ type: GET_TOWN_BY_ID, Obj: response.data });
		}).catch(function (error) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
			throw error;
		});
	};
};

/***/ }),

/***/ 420:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.clearRegulatoryBody = exports.deleteRegulatoryBody = exports.updateRegulatoryBody = exports.getRegulatoryBody = exports.searchRegulatoryBody = exports.addRegulatoryBody = exports.ACTION_UPDATE_REGULATORY_BODY = exports.ACTION_DELETE_REGULATORY_BODY = exports.ACTION_GET_REGULATORY_BODY = exports.ACTION_SEARCH_REGULATORY_BODY = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _Utils = __webpack_require__(2);

var Utils = _interopRequireWildcard(_Utils);

var _ClientHttpRequest = __webpack_require__(5);

var _ClientHttpRequest2 = _interopRequireDefault(_ClientHttpRequest);

var _immutable = __webpack_require__(1);

var _immutable2 = _interopRequireDefault(_immutable);

var _Modal = __webpack_require__(4);

var _Loading = __webpack_require__(3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var initialState = _immutable2.default.Map({}).set('Search', new _immutable2.default.List([])).set('Response', new _immutable2.default.Map({})).set('Get', new _immutable2.default.Map({}));

/* Types */
var ACTION_SEARCH_REGULATORY_BODY = exports.ACTION_SEARCH_REGULATORY_BODY = 'ACTION_SEARCH_REGULATORY_BODY';

var ACTION_GET_REGULATORY_BODY = exports.ACTION_GET_REGULATORY_BODY = 'ACTION_GET_REGULATORY_BODY';

var ACTION_DELETE_REGULATORY_BODY = exports.ACTION_DELETE_REGULATORY_BODY = 'ACTION_DELETE_REGULATORY_BODY';

var ACTION_UPDATE_REGULATORY_BODY = exports.ACTION_UPDATE_REGULATORY_BODY = 'ACTION_UPDATE_REGULATORY_BODY';

/* Reducer */

exports.default = function () {
	var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	var action = arguments[1];


	switch (action.type) {

		case ACTION_SEARCH_REGULATORY_BODY:
			return state.set('Search', new _immutable2.default.List(action.Obj));
		case ACTION_GET_REGULATORY_BODY:
			return state.set('Get', new _immutable2.default.Map(action.Obj));
		case ACTION_DELETE_REGULATORY_BODY:
			return state.set('Response', new _immutable2.default.Map(action.Obj));
		case ACTION_UPDATE_REGULATORY_BODY:
			return state.set('Response', new _immutable2.default.Map(action.Obj));
		default:
			return state;
	}
};

/* Action Creators */

var addRegulatoryBody = exports.addRegulatoryBody = function addRegulatoryBody(form) {

	var contactos = contactos = form.contactos.map(function (contacto) {
		if (contacto.tmp) {
			delete contacto.id;
			delete contacto.tmp;
			delete contacto.name;
		}
		return contacto;
	});

	var temp = {
		presidente: 1,
		comentarios: form.commentaries,
		contactos: contactos,
		createdBy: sessionStorage.uid,
		deleted: form.status === 1 ? false : true,
		documentos: [],
		domicilioCorrespondencia: {
			calle: !form.toggle ? form.street : form.streetCorrespondencia,
			entreCalle1: !form.toggle ? form.bstreet1 : form.bstreet1Correspondencia,
			entreCalle2: !form.toggle ? form.bstreet2 : form.bstreet2Correspondencia,
			idCiudad: !form.toggle ? form.city : form.cityCorrespondencia,
			idCodigoPostal: !form.toggle ? form.cp : form.cpCorrespondencia,
			idColonia: !form.toggle ? form.colony : form.colonyCorrespondencia,
			idEstado: !form.toggle ? form.state : form.stateCorrespondencia,
			idMunicipioDelegacion: !form.toggle ? form.town : form.townCorrespondencia,
			numeroExterior: !form.toggle ? form.numext : form.numextCorrespondencia,
			numeroInterior: !form.toggle ? form.numint : form.numintCorrespondencia,
			referencia: !form.toggle ? form.reference : form.referenceCorrespondencia,
			tipoDomicilio: "Correspondencia",
			deleted: false
		},
		domicilioCorrespondenciaNoEsMismo: form.toggle ? true : false,
		domicilioFiscal: {
			calle: form.street,
			entreCalle1: form.bstreet1,
			entreCalle2: form.bstreet2,
			idCiudad: form.city,
			idCodigoPostal: form.cp,
			idColonia: form.colony,
			idEstado: form.state,
			idMunicipioDelegacion: form.town,
			numeroExterior: form.numext,
			numeroInterior: form.numint,
			referencia: form.reference,
			tipoDomicilio: "Fiscal",
			deleted: false
		},
		email: form.mail,
		estatus: "1",
		extension: form.ext || "",
		lastModifiedBy: sessionStorage.uid,
		nombre: form.nombre,
		paginaWeb: form.website || "",
		siglas: form.acronym,
		telefono: form.telefono
	};

	return function (dispatch) {

		dispatch((0, _Loading.isLoading)(true));

		return new _ClientHttpRequest2.default({
			service: 'api/addRegulatoryBody',
			method: "POST",
			data: temp,
			headers: Object.assign({ "Authorization": sessionStorage.access_token, "uid": sessionStorage.uid })
		}).request().then(function (response) {
			dispatch((0, _Loading.isLoading)(false));
			return response.data;
		}).catch(function (error) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
			throw error;
		});
	};
};

var searchRegulatoryBody = exports.searchRegulatoryBody = function searchRegulatoryBody(form) {

	Utils.clearNullAndEmpty(form);

	return function (dispatch) {

		dispatch((0, _Loading.isLoading)(true));

		return new _ClientHttpRequest2.default({
			service: Object.keys(form).length == 0 ? 'api/searchRegulatoryBody' : 'api/searchParamRegulatoryBody',
			method: "POST",
			data: form,
			headers: Object.assign({ "Authorization": sessionStorage.access_token, "uid": sessionStorage.uid })
		}).request().then(function (response) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch({ type: ACTION_SEARCH_REGULATORY_BODY, Obj: response.data });
		}).catch(function (error) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
			throw error;
		});
	};
};

var getRegulatoryBody = exports.getRegulatoryBody = function getRegulatoryBody(id) {

	return function (dispatch) {

		dispatch((0, _Loading.isLoading)(true));

		return new _ClientHttpRequest2.default({
			service: 'api/getRegulatoryBody',
			method: "POST",
			data: { id: id },
			headers: Object.assign({ "Authorization": sessionStorage.access_token, "uid": sessionStorage.uid })
		}).request().then(function (response) {
			dispatch((0, _Loading.isLoading)(false));

			var data = response.data;

			var domicilioFiscal = data.domicilioFiscal;
			var domicilioCorrespondencia = data.domicilioCorrespondencia;
			var domicilioCorrespondenciaNoEsMismo = data.domicilioCorrespondenciaNoEsMismo;

			var contactos = [];

			if (data.contactos !== null) {

				contactos = data.contactos.map(function (c) {
					return _extends({}, c, { name: c.nombre + ' ' + c.apellidoPaterno + ' ' + c.apellidoMaterno });
				});
			}

			var temp = {
				idOrganismoRegulador: data.id,
				nombre: data.nombre,
				acronym: data.siglas,
				status: !data.deleted ? 1 : 2,
				telefono: data.telefono,
				ext: data.extension,
				mail: data.email,
				website: data.paginaWeb,
				cp: domicilioFiscal.idCodigoPostal,
				state: domicilioFiscal.idEstado,
				town: domicilioFiscal.idMunicipioDelegacion,
				city: domicilioFiscal.idCiudad,
				colony: domicilioFiscal.idColonia,
				street: domicilioFiscal.calle,
				numext: domicilioFiscal.numeroExterior,
				numint: domicilioFiscal.numeroInterior,
				bstreet1: domicilioFiscal.entreCalle1,
				bstreet2: domicilioFiscal.entreCalle2,
				reference: domicilioFiscal.referencia,
				toggle: domicilioCorrespondenciaNoEsMismo,
				cpCorrespondencia: domicilioCorrespondenciaNoEsMismo ? domicilioCorrespondencia.idCodigoPostal : "",
				stateCorrespondencia: domicilioCorrespondenciaNoEsMismo ? domicilioCorrespondencia.idEstado : "",
				townCorrespondencia: domicilioCorrespondenciaNoEsMismo ? domicilioCorrespondencia.idMunicipioDelegacion : "",
				cityCorrespondencia: domicilioCorrespondenciaNoEsMismo ? domicilioCorrespondencia.idCiudad : "",
				colonyCorrespondencia: domicilioCorrespondenciaNoEsMismo ? domicilioCorrespondencia.idColonia : "",
				streetCorrespondencia: domicilioCorrespondenciaNoEsMismo ? domicilioCorrespondencia.calle : "",
				numextCorrespondencia: domicilioCorrespondenciaNoEsMismo ? domicilioCorrespondencia.numeroExterior : "",
				numintCorrespondencia: domicilioCorrespondenciaNoEsMismo ? domicilioCorrespondencia.numeroInterior : "",
				bstreet1Correspondencia: domicilioCorrespondenciaNoEsMismo ? domicilioCorrespondencia.entreCalle1 : "",
				bstreet2Correspondencia: domicilioCorrespondenciaNoEsMismo ? domicilioCorrespondencia.entreCalle2 : "",
				referenceCorrespondencia: domicilioCorrespondenciaNoEsMismo ? domicilioCorrespondencia.referencia : "",
				commentaries: data.comentarios,
				contactos: contactos
			};

			dispatch({ type: ACTION_GET_REGULATORY_BODY, Obj: temp });
		}).catch(function (error) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
			throw error;
		});
	};
};

var updateRegulatoryBody = exports.updateRegulatoryBody = function updateRegulatoryBody(form) {

	var data = Object.assign({}, form);
	data.contactos = data.contactos.map(function (contacto) {
		if (contacto.tmp) {
			delete contacto.id;
			delete contacto.tmp;
		}
		return contacto;
	});
	data.contactos = Utils.unionArray(data.contactos, data.contactosRemove);

	var contactos = data.contactos.map(function (c) {
		delete c.name;
		return _extends({}, c);
	});

	var temp = {
		id: data.idOrganismoRegulador,
		presidente: 1,
		comentarios: data.commentaries,
		contactos: contactos,
		createdBy: sessionStorage.uid,
		deleted: data.status === 1 ? false : true,
		documentos: [],
		domicilioCorrespondencia: {
			calle: !data.toggle ? data.street : data.streetCorrespondencia,
			entreCalle1: !data.toggle ? data.bstreet1 : data.bstreet1Correspondencia,
			entreCalle2: !data.toggle ? data.bstreet2 : data.bstreet2Correspondencia,
			idCiudad: !data.toggle ? data.city : data.cityCorrespondencia,
			idCodigoPostal: !data.toggle ? data.cp : data.cpCorrespondencia,
			idColonia: !data.toggle ? data.colony : data.colonyCorrespondencia,
			idEstado: !data.toggle ? data.state : data.stateCorrespondencia,
			idMunicipioDelegacion: !data.toggle ? data.town : data.townCorrespondencia,
			numeroExterior: !data.toggle ? data.numext : data.numextCorrespondencia,
			numeroInterior: !data.toggle ? data.numint : data.numintCorrespondencia,
			referencia: !data.toggle ? data.reference : data.referenceCorrespondencia,
			tipoDomicilio: "Correspondencia",
			deleted: false
		},
		domicilioCorrespondenciaNoEsMismo: data.toggle ? true : false,
		domicilioFiscal: {
			calle: data.street,
			entreCalle1: data.bstreet1,
			entreCalle2: data.bstreet2,
			idCiudad: data.city,
			idCodigoPostal: data.cp,
			idColonia: data.colony,
			idEstado: data.state,
			idMunicipioDelegacion: data.town,
			numeroExterior: data.numext,
			numeroInterior: data.numint,
			referencia: data.reference,
			tipoDomicilio: "Fiscal",
			deleted: false
		},
		email: data.mail,
		estatus: "1",
		extension: data.ext || "",
		lastModifiedBy: sessionStorage.uid,
		nombre: data.nombre,
		paginaWeb: data.website || "",
		siglas: data.acronym,
		telefono: data.telefono
	};

	return function (dispatch) {

		dispatch((0, _Loading.isLoading)(true));

		return new _ClientHttpRequest2.default({
			service: 'api/updateRegulatoryBody',
			method: "POST",
			data: temp,
			headers: Object.assign({ "Authorization": sessionStorage.access_token, "uid": sessionStorage.uid })
		}).request().then(function (response) {
			dispatch((0, _Loading.isLoading)(false));
			return response.data;
		}).catch(function (error) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
			throw error;
		});
	};
};

var deleteRegulatoryBody = exports.deleteRegulatoryBody = function deleteRegulatoryBody() {
	return function (dispatch) {
		return dispatch({ type: ACTION_DELETE_REGULATORY_BODY, Obj: { code: '', message: '' } });
	};
};

var clearRegulatoryBody = exports.clearRegulatoryBody = function clearRegulatoryBody() {
	return function (dispatch) {
		dispatch({ type: ACTION_GET_REGULATORY_BODY, Obj: {} });
		dispatch({ type: ACTION_SEARCH_REGULATORY_BODY, Obj: [] });
	};
};

/***/ }),

/***/ 421:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.clearObjectives = exports.deleteObjectivesAndPlans = exports.saveObjectivesAndPlans = exports.closeProcess = exports.sendMail = exports.saveData = exports.getObjectives = exports.getKnowledge = exports.getStage = exports.getType = exports.monitoringInterventionLevel = exports.ACTION_DELETE_DATA = exports.ACTION_CLOSE_PROCESS = exports.ACTION_SEND_MAIL = exports.ACTION_SAVE_GLOBAL = exports.ACTION_SAVE_DATA = exports.ACTION_GET_OBJECTIVES = exports.ACTION_GET_KNOWLEDGE = exports.ACTION_GET_STAGE = exports.ACTION_GET_TYPE = exports.ACTION_GET_INTERVENTION_LEVEL = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _Utils = __webpack_require__(2);

var Utils = _interopRequireWildcard(_Utils);

var _immutable = __webpack_require__(1);

var _immutable2 = _interopRequireDefault(_immutable);

var _ClientHttpRequest = __webpack_require__(5);

var _ClientHttpRequest2 = _interopRequireDefault(_ClientHttpRequest);

var _Modal = __webpack_require__(4);

var _Loading = __webpack_require__(3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var initialState = _immutable2.default.Map({}).set('GetIntervention', new _immutable2.default.Map({})).set('Get', new _immutable2.default.List([])).set('Stage', new _immutable2.default.Map({ etapas: { etapa: [] } })).set('Knowledge', new _immutable2.default.List([])).set('Objectives', new _immutable2.default.Map({ objetivos: { objetivo: [] }, porcentajeAvancePlanTrabajo: 0, porcentajeValidacionEntregables: 0 })).set('Save', new _immutable2.default.Map({})).set('SaveGlobal', new _immutable2.default.List([])).set('Send', new _immutable2.default.List([])).set('Close', new _immutable2.default.List([])).set('Delete', new _immutable2.default.Map({}));

/*Types*/
var ACTION_GET_INTERVENTION_LEVEL = exports.ACTION_GET_INTERVENTION_LEVEL = 'ACTION_GET_INTERVENTION_LEVEL';
var ACTION_GET_TYPE = exports.ACTION_GET_TYPE = 'ACTION_GET_TYPE';
var ACTION_GET_STAGE = exports.ACTION_GET_STAGE = 'ACTION_GET_STAGE';
var ACTION_GET_KNOWLEDGE = exports.ACTION_GET_KNOWLEDGE = 'ACTION_GET_KNOWLEDGE';
var ACTION_GET_OBJECTIVES = exports.ACTION_GET_OBJECTIVES = 'ACTION_GET_OBJECTIVES';
var ACTION_SAVE_DATA = exports.ACTION_SAVE_DATA = 'ACTION_SAVE_DATA';
var ACTION_SAVE_GLOBAL = exports.ACTION_SAVE_GLOBAL = 'ACTION_SAVE_GLOBAL';
var ACTION_SEND_MAIL = exports.ACTION_SEND_MAIL = 'ACTION_SEND_MAIL';
var ACTION_CLOSE_PROCESS = exports.ACTION_CLOSE_PROCESS = 'ACTION_CLOSE_PROCESS';
var ACTION_DELETE_DATA = exports.ACTION_DELETE_DATA = 'ACTION_DELETE_DATA';

/*Reducer*/

exports.default = function () {
	var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	var action = arguments[1];

	switch (action.type) {
		case ACTION_GET_INTERVENTION_LEVEL:
			return state.set('GetIntervention', new _immutable2.default.Map(action.Obj));
		case ACTION_GET_TYPE:
			return state.set('Get', new _immutable2.default.List(action.Obj));
		case ACTION_GET_STAGE:
			return state.set('Stage', new _immutable2.default.Map(action.Obj));
		case ACTION_GET_KNOWLEDGE:
			return state.set('Knowledge', new _immutable2.default.List(action.Obj));
		case ACTION_GET_OBJECTIVES:
			return state.set('Objectives', new _immutable2.default.Map(action.Obj));
		case ACTION_SAVE_DATA:
			return state.set('Save', new _immutable2.default.Map(action.Obj));
		case ACTION_SAVE_GLOBAL:
			return state.set('SaveGlobal', new _immutable2.default.List(action.Obj));
		case ACTION_SEND_MAIL:
			return state.set('Send', new _immutable2.default.List(action.Obj));
		case ACTION_CLOSE_PROCESS:
			return state.set('Close', new _immutable2.default.List(action.Obj));
		case ACTION_DELETE_DATA:
			return state.set('Delete', new _immutable2.default.Map(action.Obj));
		default:
			return state;
	}
};

/*Action Creators*/

var monitoringInterventionLevel = exports.monitoringInterventionLevel = function monitoringInterventionLevel(idDonataria) {

	return function (dispatch) {
		dispatch((0, _Loading.isLoading)(true));

		return new _ClientHttpRequest2.default({
			service: 'api/getInterventionLevelMonitoring',
			method: 'POST',
			data: { idDonataria: idDonataria },
			headers: Object.assign({ 'Authorization': sessionStorage.access_token, 'uid': sessionStorage.uid })
		}).request().then(function (response) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch({ type: ACTION_GET_INTERVENTION_LEVEL, Obj: response.data });
		}).catch(function (error) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
			throw error;
		});
	};
};

var getType = exports.getType = function getType() {
	return function (dispatch) {
		dispatch((0, _Loading.isLoading)(true));

		return new _ClientHttpRequest2.default({
			service: 'api/getType',
			method: 'POST',
			data: {},
			headers: Object.assign({ 'Authorization': sessionStorage.access_token, 'uid': sessionStorage.uid })
		}).request().then(function (response) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch({ type: ACTION_GET_TYPE, Obj: response.data });
		}).catch(function (error) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
			throw error;
		});
	};
};

var getStage = exports.getStage = function getStage(form) {
	return function (dispatch) {
		dispatch((0, _Loading.isLoading)(true));

		return new _ClientHttpRequest2.default({
			service: 'api/getStage',
			method: 'POST',
			data: _extends({}, form),
			headers: Object.assign({ 'Authorization': sessionStorage.access_token, "Bpm": sessionStorage.bpm_token, 'uid': sessionStorage.uid })
		}).request().then(function (response) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch({ type: ACTION_GET_STAGE, Obj: response.data });
		}).catch(function (error) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
			throw error;
		});
	};
};

var getKnowledge = exports.getKnowledge = function getKnowledge() {
	return function (dispatch) {
		dispatch((0, _Loading.isLoading)(true));

		return new _ClientHttpRequest2.default({
			service: 'api/getKnowledge',
			method: 'POST',
			data: {},
			headers: Object.assign({ 'Authorization': sessionStorage.access_token, 'uid': sessionStorage.uid })
		}).request().then(function (response) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch({ type: ACTION_GET_KNOWLEDGE, Obj: response.data });
		}).catch(function (error) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
			throw error;
		});
	};
};

var getObjectives = exports.getObjectives = function getObjectives(form) {
	return function (dispatch) {
		dispatch((0, _Loading.isLoading)(true));

		return new _ClientHttpRequest2.default({
			service: 'api/getObjectives',
			method: 'POST',
			data: _extends({}, form),
			headers: Object.assign({ 'Authorization': sessionStorage.access_token, "Bpm": sessionStorage.bpm_token, 'uid': sessionStorage.uid })
		}).request().then(function (response) {
			dispatch((0, _Loading.isLoading)(false));
			response.data.uniqueId = Utils.getUUID();
			dispatch({ type: ACTION_GET_OBJECTIVES, Obj: response.data });
		}).catch(function (error) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
			throw error;
		});
	};
};

var saveData = exports.saveData = function saveData(form) {

	var objetivo = form.goalStrength.map(function (g) {
		return { idObjetivoFortalecimientoPlan: g.id, validado: g.validado, habilitarRegistro: g.habilitarRegistro };
	});

	form.relevantChanges.map(function (r) {
		delete r.id;
		return r;
	});

	form.relevantChangesRemove.map(function (r) {
		delete r.id;
		return r;
	});

	var cambio = Utils.unionArray(form.relevantChanges, form.relevantChangesRemove);
	var fechaInicioEtapa = "";

	if (form.dateStart) {
		fechaInicioEtapa = form.dateStart.slice(0, 10).split('-');
		fechaInicioEtapa = fechaInicioEtapa[2] + '-' + fechaInicioEtapa[1] + '-' + fechaInicioEtapa[0];
	}

	var temp = {
		// nivelIntervencion: form.intervention.nivelIntervencion || null,
		etapa: {
			idEtapa: form.stageStrength
		},
		fechaInicioEtapa: fechaInicioEtapa,
		consultor: {
			idConsultor: form.consultant
		},
		tipoFortalecimiento: {
			idTipoFortalecimiento: form.typeStrength
		},
		estatusFortalecimiento: {
			idEstatusFortalecimiento: form.statusStrength
		},
		prioritario: form.checkedPriority,
		tipoFortalecimientoGrupo: {
			temaCapacitacion: form.trainingTopic || "",
			asistencia: form.assistance || "",
			tipoConocimientoAdquiridoAsistencia: {
				idTipoConocimientoAdquirido: form.acquiredKnowledge || null
			},
			calidadServicio: form.qualityService || "",
			otro: form.other || "",
			tipoConocimientoAdquiridoOtro: {
				idTipoConocimientoAdquirido: form.noLabel || null
			}
		},
		objetivos: { objetivo: objetivo },
		cambiosRelevantesIntervencion: { cambio: cambio },
		objetivosFortalecimiento: form.goalStrengthArea,
		cierreEtapa: /*form.closeStage || false*/null,
		idEvaluacion: form.idEvaluacion,
		idDonataria: form.idDonataria,
		idCorrida: form.idCorrida
	};

	return function (dispatch) {
		dispatch((0, _Loading.isLoading)(true));

		return new _ClientHttpRequest2.default({
			service: 'api/saveData',
			method: 'POST',
			data: _extends({}, temp),
			headers: Object.assign({ 'Authorization': sessionStorage.access_token, "Bpm": sessionStorage.bpm_token, 'uid': sessionStorage.uid })
		}).request().then(function (response) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch({ type: ACTION_SAVE_DATA, Obj: response.data });
		}).catch(function (error) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
			throw error;
		});
	};
};

var sendMail = exports.sendMail = function sendMail() {

	return function (dispatch) {
		dispatch((0, _Loading.isLoading)(true));

		return new _ClientHttpRequest2.default({
			service: 'api/sendMail',
			method: 'POST',
			data: {},
			headers: Object.assign({ 'Authorization': sessionStorage.access_token, 'uid': sessionStorage.uid })
		}).request().then(function (response) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch({ type: ACTION_SEND_MAIL, Obj: response.data });
		}).catch(function (error) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
			throw error;
		});
	};
};

var closeProcess = exports.closeProcess = function closeProcess() {

	return function (dispatch) {
		dispatch((0, _Loading.isLoading)(true));

		return new _ClientHttpRequest2.default({
			service: 'api/closeProcess',
			method: 'POST',
			data: {},
			headers: Object.assign({ 'Authorization': sessionStorage.access_token, 'uid': sessionStorage.uid })
		}).request().then(function (response) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch({ type: ACTION_CLOSE_PROCESS, Obj: response.data });
		}).catch(function (error) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
			throw error;
		});
	};
};

var saveObjectivesAndPlans = exports.saveObjectivesAndPlans = function saveObjectivesAndPlans(form) {

	var fechaCompromiso = void 0;

	if (form.commitmentDate) {
		fechaCompromiso = form.commitmentDate.slice(0, 10).split('-');
		fechaCompromiso = fechaCompromiso[2] + '-' + fechaCompromiso[1] + '-' + fechaCompromiso[0];
	}

	var temp = {
		id: form.idObjective || null,
		idEtapa: form.stageStrength || null,
		variable: { id: form.variable },
		objetivoFortalecimiento: form.objectivesStrength || null,
		fechaCompromiso: fechaCompromiso ? fechaCompromiso : null,
		// fechaConclusionEntrega: null,
		// retrasoEntregables: null,
		tecnicasHerramientaRecomendada: form.recommendedTechnique || null,
		// documento: {
		//     deleted: null,
		//     fechaCreacion: null,
		//     autor: null,
		//     fechaUltimaModificacion: null,
		//     autorUltimaModificacion: null,
		//     idDocumento: null,
		//     nombre: null,
		//     rutaAcceso: null,
		//     dropboxId: null,
		//     descripcion: null,
		//     urlPermanente: null,
		//     tipoDocumento: null
		// },
		recomendaciones: form.recommendations || null,
		// validado: false,
		habilitarRegistro: form.habilitarRegistro
		// deleted: null
	};

	return function (dispatch) {
		dispatch((0, _Loading.isLoading)(true));

		return new _ClientHttpRequest2.default({
			service: form.idObjective ? 'api/updateObjectivesAndPlans' : 'api/saveObjectivesAndPlans',
			method: 'POST',
			data: _extends({}, temp),
			headers: Object.assign({ 'Authorization': sessionStorage.access_token, 'uid': sessionStorage.uid })
		}).request().then(function (response) {
			dispatch((0, _Loading.isLoading)(false));
			return response.data;
		}).catch(function (error) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
			throw error;
		});
	};
};

var deleteObjectivesAndPlans = exports.deleteObjectivesAndPlans = function deleteObjectivesAndPlans(idObjetivo) {

	return function (dispatch) {
		dispatch((0, _Loading.isLoading)(true));

		return new _ClientHttpRequest2.default({
			service: 'api/deleteObjectivesAndPlans',
			method: 'POST',
			data: { idObjetivo: idObjetivo },
			headers: Object.assign({ 'Authorization': sessionStorage.access_token, 'uid': sessionStorage.uid })
		}).request().then(function (response) {
			dispatch((0, _Loading.isLoading)(false));
			return response.datas;
		}).catch(function (error) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
			throw error;
		});
	};
};

var clearObjectives = exports.clearObjectives = function clearObjectives() {
	return function (dispatch) {
		dispatch({ type: ACTION_GET_OBJECTIVES, Obj: { objetivos: { objetivo: [] }, porcentajeAvancePlanTrabajo: 0, porcentajeValidacionEntregables: 0 } });
		return Promise.resolve();
	};
};

/***/ }),

/***/ 422:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.getResultadosEvaluacion = exports.getRangoTipoEvaluacionTodo = exports.getRangoTipoEvaluacion = exports.getRetroAlimentacion = exports.clearVariableResults = exports.clearResults = exports.getVariableResults = exports.setResults = exports.getResults = exports.GET_RESULTADO_EVALUACION = exports.GET_RANGO_TIPO_EVALUACION_TODO = exports.GET_RANGO_TIPO_EVALUACION = exports.GET_RETROALIMENTACION = exports.GET_VARIABLE_RESULTS = exports.GET_RESULTS = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _Utils = __webpack_require__(2);

var Utils = _interopRequireWildcard(_Utils);

var _immutable = __webpack_require__(1);

var _immutable2 = _interopRequireDefault(_immutable);

var _ClientHttpRequest = __webpack_require__(5);

var _ClientHttpRequest2 = _interopRequireDefault(_ClientHttpRequest);

var _Modal = __webpack_require__(4);

var _Loading = __webpack_require__(3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var initialState = _immutable2.default.Map({}).set('Get', new _immutable2.default.Map({ evaluacionVariable: { resultadosVariable: { resultadoVariable: [] } } })).set('Search', new _immutable2.default.Map({ evaluacionVariable: { resultadosVariable: { resultadoVariable: [] } } })).set('get_retroalimentacion', new _immutable2.default.Map({})).set('get_rango_tipo_evaluacion', new _immutable2.default.Map({})).set('get_rango_tipo_evaluacion_todo', new _immutable2.default.Map({})).set('get_resultado_evaluacion', new _immutable2.default.Map({}));

/* Types */
var GET_RESULTS = exports.GET_RESULTS = 'GET_RESULTS';
var GET_VARIABLE_RESULTS = exports.GET_VARIABLE_RESULTS = 'GET_VARIABLE_RESULTS';
var GET_RETROALIMENTACION = exports.GET_RETROALIMENTACION = 'GET_RETROALIMENTACION';
var GET_RANGO_TIPO_EVALUACION = exports.GET_RANGO_TIPO_EVALUACION = 'GET_RANGO_TIPO_EVALUACION';
var GET_RANGO_TIPO_EVALUACION_TODO = exports.GET_RANGO_TIPO_EVALUACION_TODO = 'GET_RANGO_TIPO_EVALUACION_TODO';
var GET_RESULTADO_EVALUACION = exports.GET_RESULTADO_EVALUACION = 'GET_RESULTADO_EVALUACION';

/* Reducer */

exports.default = function () {
	var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	var action = arguments[1];


	switch (action.type) {
		case GET_VARIABLE_RESULTS:
			return state.set('Search', new _immutable2.default.Map(action.Obj));
		case GET_RESULTS:
			return state.set('Get', new _immutable2.default.Map(action.Obj));
		case GET_RETROALIMENTACION:
			return state.set('get_retroalimentacion', new _immutable2.default.Map(action.Obj));
		case GET_RANGO_TIPO_EVALUACION:
			return state.set('get_rango_tipo_evaluacion', new _immutable2.default.Map(action.Obj));
		case GET_RANGO_TIPO_EVALUACION_TODO:
			return state.set('get_rango_tipo_evaluacion_todo', new _immutable2.default.Map(action.Obj));
		case GET_RESULTADO_EVALUACION:
			return state.set('get_resultado_evaluacion', new _immutable2.default.Map(action.Obj));
		default:
			return state;
	}
};

/* Action Creators */

var getResults = exports.getResults = function getResults(form) {

	return function (dispatch) {

		dispatch((0, _Loading.isLoading)(true));

		return new _ClientHttpRequest2.default({
			service: 'api/getResults',
			method: "POST",
			data: _extends({}, form),
			headers: Object.assign({ "Authorization": sessionStorage.access_token, "uid": sessionStorage.uid })
		}).request().then(function (response) {
			dispatch((0, _Loading.isLoading)(false));
			response.data.uniqueId = Utils.getUUID();
			dispatch({ type: GET_RESULTS, Obj: response.data });
		}).catch(function (error) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
			throw error;
		});
	};
};

var setResults = exports.setResults = function setResults(form) {
	var idEvaluacion = form.idEvaluacion,
	    resultadoVariable = form.resultadoVariable;


	resultadoVariable = resultadoVariable.map(function (r) {
		delete r.retroalimentacionCatalogo;
		delete r.retroArray;
		return _extends({}, r);
	});

	var temp = {
		evaluacionVariable: {
			idEvaluacion: idEvaluacion,
			resultadosVariable: {
				resultadoVariable: resultadoVariable
			}
		}
	};

	return function (dispatch) {

		dispatch((0, _Loading.isLoading)(true));

		return new _ClientHttpRequest2.default({
			service: 'api/setResults',
			method: "POST",
			data: _extends({}, temp),
			headers: Object.assign({ "Authorization": sessionStorage.access_token, "uid": sessionStorage.uid })
		}).request().then(function (response) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch({ type: GET_VARIABLE_RESULTS, Obj: response.data });
		}).catch(function (error) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
			throw error;
		});
	};
};

var getVariableResults = exports.getVariableResults = function getVariableResults(form) {

	return function (dispatch) {

		dispatch((0, _Loading.isLoading)(true));

		return new _ClientHttpRequest2.default({
			service: 'api/getVariableResults',
			method: "POST",
			data: _extends({}, form),
			headers: Object.assign({ "Authorization": sessionStorage.access_token, "uid": sessionStorage.uid })
		}).request().then(function (response) {
			dispatch((0, _Loading.isLoading)(false));
			response.data.uniqueId = Utils.getUUID();
			dispatch({ type: GET_VARIABLE_RESULTS, Obj: response.data });
		}).catch(function (error) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
			throw error;
		});
	};
};

var clearResults = exports.clearResults = function clearResults() {
	return function (dispatch) {
		dispatch({ type: GET_RESULTS, Obj: { evaluacionVariable: { resultadosVariable: { resultadoVariable: [] } } } });
	};
};

var clearVariableResults = exports.clearVariableResults = function clearVariableResults() {
	return function (dispatch) {
		dispatch({ type: GET_VARIABLE_RESULTS, Obj: { evaluacionVariable: { resultadosVariable: { resultadoVariable: [] } } } });
	};
};

var getRetroAlimentacion = exports.getRetroAlimentacion = function getRetroAlimentacion(form) {

	return function (dispatch) {

		dispatch((0, _Loading.isLoading)(true));

		return new _ClientHttpRequest2.default({
			service: 'api/getRetroAlimentacion',
			method: "POST",
			data: _extends({}, form),
			headers: Object.assign({ "Authorization": sessionStorage.access_token, "uid": sessionStorage.uid })
		}).request().then(function (response) {
			dispatch((0, _Loading.isLoading)(false));
			response.data.uniqueId = Utils.getUUID();
			dispatch({ type: GET_RETROALIMENTACION, Obj: response.data });
		}).catch(function (error) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
			throw error;
		});
	};
};

var getRangoTipoEvaluacion = exports.getRangoTipoEvaluacion = function getRangoTipoEvaluacion(form) {

	return function (dispatch) {

		dispatch((0, _Loading.isLoading)(true));

		return new _ClientHttpRequest2.default({
			service: 'api/getRangoTipoEvaluacion',
			method: "POST",
			data: _extends({}, form),
			headers: Object.assign({ "Authorization": sessionStorage.access_token, "uid": sessionStorage.uid })
		}).request().then(function (response) {
			dispatch((0, _Loading.isLoading)(false));
			response.data.uniqueId = Utils.getUUID();
			dispatch({ type: GET_RANGO_TIPO_EVALUACION, Obj: response.data });
		}).catch(function (error) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
			throw error;
		});
	};
};

var getRangoTipoEvaluacionTodo = exports.getRangoTipoEvaluacionTodo = function getRangoTipoEvaluacionTodo() {

	return function (dispatch) {

		dispatch((0, _Loading.isLoading)(true));

		return new _ClientHttpRequest2.default({
			service: 'api/getRangoTipoEvaluacionTodo',
			method: "POST",
			data: {},
			headers: Object.assign({ "Authorization": sessionStorage.access_token, "uid": sessionStorage.uid })
		}).request().then(function (response) {
			dispatch((0, _Loading.isLoading)(false));
			response.data.uniqueId = Utils.getUUID();
			dispatch({ type: GET_RANGO_TIPO_EVALUACION_TODO, Obj: response.data });
		}).catch(function (error) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
			throw error;
		});
	};
};

var getResultadosEvaluacion = exports.getResultadosEvaluacion = function getResultadosEvaluacion(form) {

	return function (dispatch) {

		dispatch((0, _Loading.isLoading)(true));

		return new _ClientHttpRequest2.default({
			service: 'api/getResultadosEvaluacion',
			method: "POST",
			data: _extends({}, form),
			headers: Object.assign({ "Authorization": sessionStorage.access_token, "uid": sessionStorage.uid })
		}).request().then(function (response) {
			dispatch((0, _Loading.isLoading)(false));
			response.data.uniqueId = Utils.getUUID();
			dispatch({ type: GET_RESULTADO_EVALUACION, Obj: response.data });
		}).catch(function (error) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
			throw error;
		});
	};
};

/***/ }),

/***/ 423:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.getCatalogDonataria = exports.getCatalogYear = exports.getCatalogFase = exports.getDataRun = exports.getDataSolutionRequest = exports.ACTION_GET_CATALOG_DONATARIA = exports.ACTION_GET_CATALOG_YEAR = exports.ACTION_GET_CATALOG_FASE = exports.ACTION_GET_RUN = exports.ACTION_GET_SOLUTION_REQUEST = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _Utils = __webpack_require__(2);

var Utils = _interopRequireWildcard(_Utils);

var _ClientHttpRequest = __webpack_require__(5);

var _ClientHttpRequest2 = _interopRequireDefault(_ClientHttpRequest);

var _immutable = __webpack_require__(1);

var _immutable2 = _interopRequireDefault(_immutable);

var _Modal = __webpack_require__(4);

var _Loading = __webpack_require__(3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var initialState = _immutable2.default.Map({}).set('request_solution', new _immutable2.default.Map({})).set('request_run', new _immutable2.default.Map({})).set('request_catalog_fase', new _immutable2.default.Map({})).set('request_catalog_year', new _immutable2.default.Map({})).set('request_catalog_donataria', new _immutable2.default.Map({}));

/* Types */

var ACTION_GET_SOLUTION_REQUEST = exports.ACTION_GET_SOLUTION_REQUEST = 'ACTION_GET_SOLUTION_REQUEST';
var ACTION_GET_RUN = exports.ACTION_GET_RUN = 'ACTION_GET_RUN';
var ACTION_GET_CATALOG_FASE = exports.ACTION_GET_CATALOG_FASE = 'ACTION_GET_CATALOG_FASE';
var ACTION_GET_CATALOG_YEAR = exports.ACTION_GET_CATALOG_YEAR = 'ACTION_GET_CATALOG_YEAR';
var ACTION_GET_CATALOG_DONATARIA = exports.ACTION_GET_CATALOG_DONATARIA = 'ACTION_GET_CATALOG_DONATARIA';

/* Reducer */

exports.default = function () {
	var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	var action = arguments[1];


	switch (action.type) {
		case ACTION_GET_SOLUTION_REQUEST:
			return state.set('request_solution', new _immutable2.default.Map(action.Obj));
		case ACTION_GET_RUN:
			return state.set('request_run', new _immutable2.default.Map(action.Obj));
		case ACTION_GET_CATALOG_FASE:
			return state.set('request_catalog_fase', new _immutable2.default.Map(action.Obj));
		case ACTION_GET_CATALOG_YEAR:
			return state.set('request_catalog_year', new _immutable2.default.Map(action.Obj));
		case ACTION_GET_CATALOG_DONATARIA:
			return state.set('request_catalog_donataria', new _immutable2.default.Map(action.Obj));
		default:
			return state;
	}
};

/* Action Creators */

var getDataSolutionRequest = exports.getDataSolutionRequest = function getDataSolutionRequest(form) {

	return function (dispatch) {

		dispatch((0, _Loading.isLoading)(true));
		dispatch({ type: ACTION_GET_SOLUTION_REQUEST, Obj: {} });

		return new _ClientHttpRequest2.default({
			service: 'api/getDataSolutionRequest/' + 0,
			method: "POST",
			data: _extends({}, form),
			headers: Object.assign({ "Authorization": sessionStorage.access_token, "uid": sessionStorage.uid })
		}).request().then(function (response) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch({ type: ACTION_GET_SOLUTION_REQUEST, Obj: response.data });
		}).catch(function (error) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
			throw error;
		});
	};
};

var getDataRun = exports.getDataRun = function getDataRun(form) {

	return function (dispatch) {

		dispatch((0, _Loading.isLoading)(true));
		dispatch({ type: ACTION_GET_RUN, Obj: {} });

		return new _ClientHttpRequest2.default({
			service: 'api/getDataRun',
			method: "GET",
			data: {},
			headers: Object.assign({ "Authorization": sessionStorage.access_token, "uid": sessionStorage.uid })
		}).request().then(function (response) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch({ type: ACTION_GET_RUN, Obj: response.data });
		}).catch(function (error) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
			throw error;
		});
	};
};

var getCatalogFase = exports.getCatalogFase = function getCatalogFase(form) {

	return function (dispatch) {

		dispatch((0, _Loading.isLoading)(true));
		dispatch({ type: ACTION_GET_CATALOG_FASE, Obj: {} });

		return new _ClientHttpRequest2.default({
			service: 'api/getCatalogFase',
			method: "GET",
			data: {},
			headers: Object.assign({ "Authorization": sessionStorage.access_token, "uid": sessionStorage.uid })
		}).request().then(function (response) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch({ type: ACTION_GET_CATALOG_FASE, Obj: response.data });
		}).catch(function (error) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
			throw error;
		});
	};
};

var getCatalogYear = exports.getCatalogYear = function getCatalogYear(form) {

	return function (dispatch) {

		dispatch((0, _Loading.isLoading)(true));
		dispatch({ type: ACTION_GET_CATALOG_YEAR, Obj: {} });

		return new _ClientHttpRequest2.default({
			service: 'api/getCatalogYear',
			method: "GET",
			data: {},
			headers: Object.assign({ "Authorization": sessionStorage.access_token, "uid": sessionStorage.uid })
		}).request().then(function (response) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch({ type: ACTION_GET_CATALOG_YEAR, Obj: response.data });
		}).catch(function (error) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
			throw error;
		});
	};
};

var getCatalogDonataria = exports.getCatalogDonataria = function getCatalogDonataria(form) {

	return function (dispatch) {

		dispatch((0, _Loading.isLoading)(true));
		dispatch({ type: ACTION_GET_CATALOG_DONATARIA, Obj: {} });

		return new _ClientHttpRequest2.default({
			service: 'api/getCatalogDonataria',
			method: "GET",
			data: {},
			headers: Object.assign({ "Authorization": sessionStorage.access_token, "uid": sessionStorage.uid })
		}).request().then(function (response) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch({ type: ACTION_GET_CATALOG_DONATARIA, Obj: response.data });
		}).catch(function (error) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
			throw error;
		});
	};
};

/***/ }),

/***/ 424:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.clearDataMSGEjec = exports.clearDataMSGDon = exports.clearContactData = exports.clearListadoMensajes = exports.clearListadoConversaciones = exports.setInfoDonataria = exports.confirmNewConversationsDon = exports.confirmNewConversationsEjec = exports.sendMensajesEjecutivo = exports.saveMensajesEjecutivo = exports.getListMensajesForEjec = exports.getInfoDonataria = exports.getListadoConversaciones = exports.ACTION_GET_NEW_CONVERSATIONS_DON = exports.ACTION_GET_NEW_CONVERSATIONS_EJEC = exports.ACTION_GET_CONTACT_DATA_EJECUTIVO = exports.ACTION_GET_CONTACT_DATA = exports.ACTION_GET_MENSAJES_PAGINACION = exports.ACTION_GET_LIST_MENSAJES_FOR_EJEC = exports.ACTION_SET_INFO_DONATARIA_MENSAJES = exports.ACTION_GET_CONVERSACIONES_PAGINACION = exports.ACTION_GET_CONVERSACIONES_LIST = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _Utils = __webpack_require__(2);

var Utils = _interopRequireWildcard(_Utils);

var _ClientHttpRequest = __webpack_require__(5);

var _ClientHttpRequest2 = _interopRequireDefault(_ClientHttpRequest);

var _immutable = __webpack_require__(1);

var _immutable2 = _interopRequireDefault(_immutable);

var _Modal = __webpack_require__(4);

var _Loading = __webpack_require__(3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var initialState = _immutable2.default.Map({}).set('GetListConversaciones', new _immutable2.default.List([])).set('GetListConversacionesPaginacion', new _immutable2.default.Map({})).set('GetMensajesForEjec', new _immutable2.default.List([])).set('GetListMensajesPaginacion', new _immutable2.default.Map({})).set('GetContactDataDonataria', new _immutable2.default.Map({})).set('GetContactDataEjecutivo', new _immutable2.default.Map({})).set('SearchParameter', new _immutable2.default.Map({})).set('GetNewConversationsEjec', new _immutable2.default.Map({})).set('GetNewConversationsDon', new _immutable2.default.Map({}));

/*Types*/
var ACTION_GET_CONVERSACIONES_LIST = exports.ACTION_GET_CONVERSACIONES_LIST = "ACTION_GET_CONVERSACIONES_LIST";
var ACTION_GET_CONVERSACIONES_PAGINACION = exports.ACTION_GET_CONVERSACIONES_PAGINACION = "ACTION_GET_CONVERSACIONES_PAGINACION";
var ACTION_SET_INFO_DONATARIA_MENSAJES = exports.ACTION_SET_INFO_DONATARIA_MENSAJES = 'ACTION_SET_INFO_DONATARIA_MENSAJES';
var ACTION_GET_LIST_MENSAJES_FOR_EJEC = exports.ACTION_GET_LIST_MENSAJES_FOR_EJEC = "ACTION_GET_LIST_MENSAJES_FOR_EJEC";
var ACTION_GET_MENSAJES_PAGINACION = exports.ACTION_GET_MENSAJES_PAGINACION = "ACTION_GET_MENSAJES_PAGINACION";
var ACTION_GET_CONTACT_DATA = exports.ACTION_GET_CONTACT_DATA = "ACTION_GET_CONTACT_DATA";
var ACTION_GET_CONTACT_DATA_EJECUTIVO = exports.ACTION_GET_CONTACT_DATA_EJECUTIVO = "ACTION_GET_CONTACT_DATA_EJECUTIVO";
var ACTION_GET_NEW_CONVERSATIONS_EJEC = exports.ACTION_GET_NEW_CONVERSATIONS_EJEC = "ACTION_GET_NEW_CONVERSATIONS_EJEC";
var ACTION_GET_NEW_CONVERSATIONS_DON = exports.ACTION_GET_NEW_CONVERSATIONS_DON = "ACTION_GET_NEW_CONVERSATIONS_DON";

exports.default = function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments[1];


  switch (action.type) {
    case ACTION_GET_CONVERSACIONES_LIST:
      return state.set('GetListConversaciones', new _immutable2.default.List(action.Obj));
    case ACTION_GET_CONVERSACIONES_PAGINACION:
      return state.set('GetListConversacionesPaginacion', new _immutable2.default.Map(action.Obj));
    case ACTION_SET_INFO_DONATARIA_MENSAJES:
      return state.set('GetInfoDonatariaMensajes', new _immutable2.default.Map(action.Obj));
    case ACTION_GET_LIST_MENSAJES_FOR_EJEC:
      return state.set('GetMensajesForEjec', new _immutable2.default.List(action.Obj));
    case ACTION_GET_MENSAJES_PAGINACION:
      return state.set('GetListMensajesPaginacion', new _immutable2.default.Map(action.Obj));
    case ACTION_GET_CONTACT_DATA:
      return state.set('GetContactDataDonataria', new _immutable2.default.Map(action.Obj));
    case ACTION_GET_CONTACT_DATA_EJECUTIVO:
      return state.set('GetContactDataEjecutivo', new _immutable2.default.Map(action.Obj));
    case ACTION_GET_NEW_CONVERSATIONS_EJEC:
      return state.set('GetNewConversationsEjec', new _immutable2.default.Map(action.Obj));
    case ACTION_GET_NEW_CONVERSATIONS_DON:
      return state.set('GetNewConversationsDon', new _immutable2.default.Map(action.Obj));
    default:
      return state;
  }
};

/*Action Creators*/

var getListadoConversaciones = exports.getListadoConversaciones = function getListadoConversaciones(form) {
  return function (dispatch) {
    dispatch((0, _Loading.isLoading)(true));
    return new _ClientHttpRequest2.default({
      service: 'api/getListConversaciones',
      method: 'POST',
      data: _extends({}, form),
      headers: Object.assign({ 'Authorization': sessionStorage.access_token, 'uid': sessionStorage.uid })
    }).request().then(function (response) {
      dispatch((0, _Loading.isLoading)(false));
      dispatch({ type: ACTION_GET_CONVERSACIONES_LIST, Obj: response.data });
      // dispatch({ type: ACTION_GET_CONVERSACIONES_PAGINACION, Obj: response.data.paginacion })
    }).catch(function (error) {
      dispatch((0, _Loading.isLoading)(false));
      dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
      throw error;
    });
  };
};

var getInfoDonataria = exports.getInfoDonataria = function getInfoDonataria(idDonataria) {
  return function (dispatch) {
    dispatch((0, _Loading.isLoading)(true));
    return new _ClientHttpRequest2.default({
      service: 'api/getInfoDonataria',
      method: 'POST',
      data: { idDonataria: idDonataria },
      headers: Object.assign({ 'Authorization': sessionStorage.access_token, 'uid': sessionStorage.uid })
    }).request().then(function (response) {
      dispatch((0, _Loading.isLoading)(false));
      dispatch({ type: ACTION_GET_CONTACT_DATA, Obj: response.data });
    }).catch(function (error) {
      dispatch((0, _Loading.isLoading)(false));
      dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
      throw error;
    });
  };
};

var getListMensajesForEjec = exports.getListMensajesForEjec = function getListMensajesForEjec(form) {
  return function (dispatch) {
    dispatch((0, _Loading.isLoading)(true));
    return new _ClientHttpRequest2.default({
      service: 'api/getListMensajesForEjec',
      method: 'POST',
      data: _extends({}, form),
      headers: Object.assign({ 'Authorization': sessionStorage.access_token, 'uid': sessionStorage.uid })
    }).request().then(function (response) {
      dispatch((0, _Loading.isLoading)(false));
      dispatch({ type: ACTION_GET_CONTACT_DATA_EJECUTIVO, Obj: response.data });
      dispatch({ type: ACTION_GET_LIST_MENSAJES_FOR_EJEC, Obj: response.data.mensajes });
      dispatch({ type: ACTION_GET_MENSAJES_PAGINACION, Obj: response.data.paginacion });
    }).catch(function (error) {
      dispatch((0, _Loading.isLoading)(false));
      dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
      throw error;
    });
  };
};

var saveMensajesEjecutivo = exports.saveMensajesEjecutivo = function saveMensajesEjecutivo(form) {
  return function (dispatch) {

    var temp = {
      idDonataria: form.idDonataria,
      ejecutivo: form.ejecutivo,
      aviso: form.aviso,
      usuario: sessionStorage.uid
    };

    dispatch((0, _Loading.isLoading)(true));

    return new _ClientHttpRequest2.default({
      service: 'api/saveMensajesEjecutivo',
      method: "POST",
      data: _extends({}, temp),
      headers: Object.assign({ 'Authorization': sessionStorage.access_token, 'uid': sessionStorage.uid })
    }).request().then(function (response) {
      dispatch((0, _Loading.isLoading)(false));
      return response.data;
    }).catch(function (error) {
      dispatch((0, _Loading.isLoading)(false));
      dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
      throw error;
    });
  };
};

var sendMensajesEjecutivo = exports.sendMensajesEjecutivo = function sendMensajesEjecutivo(form) {
  return function (dispatch) {
    var temp = {
      idDonataria: form.idDonataria,
      nombreDonataria: form.nombreDonataria,
      ejecutivo: {
        idUsuario: form.ejecutivo
      },
      aviso: form.aviso
    };

    dispatch((0, _Loading.isLoading)(true));

    return new _ClientHttpRequest2.default({
      service: 'api/sendMensajesEjecutivo',
      method: "POST",
      data: _extends({}, temp),
      headers: Object.assign({ 'Authorization': sessionStorage.access_token, 'uid': sessionStorage.uid })
    }).request().then(function (response) {
      dispatch((0, _Loading.isLoading)(false));
      return response.data;
    }).catch(function (error) {
      dispatch((0, _Loading.isLoading)(false));
      dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
      throw error;
    });
  };
};

var confirmNewConversationsEjec = exports.confirmNewConversationsEjec = function confirmNewConversationsEjec() {
  var temp = {
    ejecutivo: sessionStorage.uid
  };
  return function (dispatch) {
    dispatch((0, _Loading.isLoading)(true));
    return new _ClientHttpRequest2.default({
      service: 'api/confirmNewConversationsEjec',
      method: 'POST',
      data: _extends({}, temp),
      headers: Object.assign({ 'Authorization': sessionStorage.access_token, 'uid': sessionStorage.uid })
    }).request().then(function (response) {
      dispatch((0, _Loading.isLoading)(false));
      dispatch({ type: ACTION_GET_NEW_CONVERSATIONS_EJEC, Obj: response.data });
    }).catch(function (error) {
      dispatch((0, _Loading.isLoading)(false));
      dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
      throw error;
    });
  };
};

var confirmNewConversationsDon = exports.confirmNewConversationsDon = function confirmNewConversationsDon(idDonataria) {

  return function (dispatch) {
    dispatch((0, _Loading.isLoading)(true));
    return new _ClientHttpRequest2.default({
      service: 'api/confirmNewConversationsDon',
      method: 'POST',
      data: { idDonataria: idDonataria },
      headers: Object.assign({ 'Authorization': sessionStorage.access_token, 'uid': sessionStorage.uid })
    }).request().then(function (response) {
      dispatch((0, _Loading.isLoading)(false));
      dispatch({ type: ACTION_GET_NEW_CONVERSATIONS_DON, Obj: response.data });
    }).catch(function (error) {
      dispatch((0, _Loading.isLoading)(false));
      dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
      throw error;
    });
  };
};

var setInfoDonataria = exports.setInfoDonataria = function setInfoDonataria(form) {
  return function (dispatch) {
    dispatch({ type: ACTION_SET_INFO_DONATARIA_MENSAJES, Obj: form });
    return Promise.resolve();
  };
};

var clearListadoConversaciones = exports.clearListadoConversaciones = function clearListadoConversaciones() {
  return function (dispatch) {
    dispatch({ type: ACTION_GET_CONVERSACIONES_LIST, Obj: [] });
    dispatch({ type: ACTION_GET_CONVERSACIONES_PAGINACION, Obj: {} });
  };
};

var clearListadoMensajes = exports.clearListadoMensajes = function clearListadoMensajes() {
  return function (dispatch) {
    dispatch({ type: ACTION_GET_LIST_MENSAJES_FOR_EJEC, Obj: [] });
    dispatch({ type: ACTION_GET_MENSAJES_PAGINACION, Obj: {} });
  };
};

var clearContactData = exports.clearContactData = function clearContactData() {
  return function (dispatch) {
    dispatch({ type: ACTION_GET_CONTACT_DATA, Obj: {} });
    dispatch({ type: ACTION_GET_CONTACT_DATA_EJECUTIVO, Obj: {} });
  };
};

var clearDataMSGDon = exports.clearDataMSGDon = function clearDataMSGDon() {
  return function (dispatch) {
    dispatch({ type: ACTION_GET_NEW_CONVERSATIONS_DON, Obj: {} });
  };
};
var clearDataMSGEjec = exports.clearDataMSGEjec = function clearDataMSGEjec() {
  return function (dispatch) {
    dispatch({ type: ACTION_GET_NEW_CONVERSATIONS_EJEC, Obj: {} });
  };
};

/***/ }),

/***/ 435:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.setClassification = exports.getClassification = exports.GET_CLASSIFICATION = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _Utils = __webpack_require__(2);

var Utils = _interopRequireWildcard(_Utils);

var _ClientHttpRequest = __webpack_require__(5);

var _ClientHttpRequest2 = _interopRequireDefault(_ClientHttpRequest);

var _immutable = __webpack_require__(1);

var _immutable2 = _interopRequireDefault(_immutable);

var _Modal = __webpack_require__(4);

var _Loading = __webpack_require__(3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var initialState = _immutable2.default.Map({}).set('Search', new _immutable2.default.List([])).set('Response', new _immutable2.default.Map({})).set('Get', new _immutable2.default.Map({}));

/* Types */
var GET_CLASSIFICATION = exports.GET_CLASSIFICATION = 'GET_CLASSIFICATION';

/* Reducer */

exports.default = function () {
	var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	var action = arguments[1];


	switch (action.type) {
		case GET_CLASSIFICATION:
			return state.set('Get', new _immutable2.default.Map(action.Obj));
		default:
			return state;
	}
};

/* Action Creators */

var getClassification = exports.getClassification = function getClassification(form) {

	return function (dispatch) {

		dispatch((0, _Loading.isLoading)(true));

		return new _ClientHttpRequest2.default({
			service: 'api/getClassification',
			method: "POST",
			data: _extends({}, form),
			headers: Object.assign({ "Authorization": sessionStorage.access_token, "uid": sessionStorage.uid })
		}).request().then(function (response) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch({ type: GET_CLASSIFICATION, Obj: response.data });
		}).catch(function (error) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
			throw error;
		});
	};
};

var setClassification = exports.setClassification = function setClassification(form) {

	return function (dispatch) {

		dispatch((0, _Loading.isLoading)(true));

		return new _ClientHttpRequest2.default({
			service: 'api/setClassification',
			method: "POST",
			data: _extends({}, form),
			headers: Object.assign({ "Authorization": sessionStorage.access_token, "uid": sessionStorage.uid })
		}).request().then(function (response) {
			dispatch((0, _Loading.isLoading)(false));
			return response.data;
		}).catch(function (error) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
			throw error;
		});
	};
};

/***/ }),

/***/ 436:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.clearDonor = exports.updateDonor = exports.getDonor = exports.searchDonor = exports.newDonor = exports.ACTION_GET_DONOR = exports.ACTION_SEARCH_DONOR = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _Utils = __webpack_require__(2);

var Utils = _interopRequireWildcard(_Utils);

var _ClientHttpRequest = __webpack_require__(5);

var _ClientHttpRequest2 = _interopRequireDefault(_ClientHttpRequest);

var _immutable = __webpack_require__(1);

var _immutable2 = _interopRequireDefault(_immutable);

var _Modal = __webpack_require__(4);

var _Loading = __webpack_require__(3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var initialState = _immutable2.default.Map({}).set('Search', new _immutable2.default.List([])).set('Response', new _immutable2.default.Map({})).set('Get', new _immutable2.default.Map({}));

/* Types */

var ACTION_SEARCH_DONOR = exports.ACTION_SEARCH_DONOR = 'ACTION_SEARCH_DONOR';

var ACTION_GET_DONOR = exports.ACTION_GET_DONOR = 'ACTION_GET_DONOR';

/* Reducer */

exports.default = function () {
	var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	var action = arguments[1];


	switch (action.type) {
		case ACTION_SEARCH_DONOR:
			return state.set('Search', new _immutable2.default.List(action.Obj));
		case ACTION_GET_DONOR:
			return state.set('Get', new _immutable2.default.Map(action.Obj));
		default:
			return state;
	}
};

/* Action Creators */

var newDonor = exports.newDonor = function newDonor(form) {

	var temp = Object.assign({}, form);

	temp.legalRepresentatives = Utils.getListPropsOmit(temp.legalRepresentatives, ['id', 'tmp']);
	temp.legalRepresentatives = Utils.unionArray(temp.legalRepresentatives, temp.legalRepresentativesRemove);
	temp.legalRepresentatives = temp.legalRepresentatives.map(function (r) {
		return _extends({}, r, {
			fechaFolio: Utils.formatDate(r.fechaFolio),
			fechaEscritura: Utils.formatDate(r.fechaEscritura),
			periodoDesde: Utils.formatDate(r.periodoDesde),
			periodoHasta: Utils.formatDate(r.periodoHasta)
		});
	});

	temp.employersAdvisers = Utils.getListPropsOmit(temp.employersAdvisers, ['id', 'tmp']);
	temp.employersAdvisers = Utils.unionArray(temp.employersAdvisers, temp.employersAdvisersRemove);

	temp.contacts = Utils.getListPropsOmit(temp.contacts, ['id', 'tmp', 'cfullname']);
	temp.contacts = Utils.unionArray(temp.contacts, temp.contactsRemove);

	var obj = {
		id: temp.idDonor || undefined,
		actaConstitutiva: {
			apellidoMaternoNotario: temp.notaryLastname,
			apellidoPaternoNotario: temp.notarySurname,
			fechaEscritura: Utils.formatDate(temp.writingDate),
			fechaFolioRPP: Utils.formatDate(temp.folioDate),
			folioRPP: temp.folioRPP,
			idEstado: temp.writingState,
			nombreNotario: temp.notaryName,
			numeroEscritura: temp.writingNumber,
			numeroNotaria: temp.notaryNumber
		},
		actividadSocial: temp.socialActivity,
		cluni: temp.cluni || '',
		contactos: temp.contacts,
		deleted: temp.status === 1 ? false : true,
		createdBy: sessionStorage.uid,
		estatus: '1',
		documentos: [],
		domicilioCorrespondencia: {
			calle: temp.toggle ? temp.streetFiscal : temp.street,
			entreCalle1: temp.toggle ? temp.bstreet1Fiscal : temp.bstreet1,
			entreCalle2: temp.toggle ? temp.bstreet2Fiscal : temp.bstreet2,
			idCiudad: temp.toggle ? temp.cityFiscal : temp.city,
			idCodigoPostal: temp.toggle ? temp.cpFiscal : temp.cp,
			idColonia: temp.toggle ? temp.colonyFiscal : temp.colony,
			idEstado: temp.toggle ? temp.stateFiscal : temp.state,
			idMunicipioDelegacion: temp.toggle ? temp.townFiscal : temp.town,
			numeroExterior: temp.toggle ? temp.numextFiscal : temp.numext,
			numeroInterior: temp.toggle ? temp.numintFiscal : temp.numint,
			referencia: temp.toggle ? temp.referenceFiscal : temp.reference
		},
		domicilioCorrespondenciaNoEsMismo: temp.toggle ? true : false,
		domicilioFiscal: {
			calle: temp.street,
			entreCalle1: temp.bstreet1,
			entreCalle2: temp.bstreet2,
			idCiudad: temp.city,
			idCodigoPostal: temp.cp,
			idColonia: temp.colony,
			idEstado: temp.state,
			idMunicipioDelegacion: temp.town,
			numeroExterior: temp.numext,
			numeroInterior: temp.numint || '',
			referencia: temp.reference
		},
		email: temp.donorEmail || '',
		fechaConstitucion: Utils.formatDate(temp.constDate),
		fechaInicioOperacion: Utils.formatDate(temp.opDate),
		idOrganismoRegulador: temp.jap,
		idPersonalidadJuridica: temp.legalPersonality,
		nombreInstitucion: temp.donorName,
		objetoSocial: temp.socialGoal,
		paginaWeb: temp.donorWebsite || '',
		patronosConsejeros: temp.employersAdvisers,
		representantesLegales: temp.legalRepresentatives,
		rfc: temp.rfc,
		telefono: temp.donorPhone
	};

	return function (dispatch) {

		dispatch((0, _Loading.isLoading)(true));

		return new _ClientHttpRequest2.default({
			service: 'api/newDonor',
			method: "POST",
			data: _extends({}, obj),
			headers: Object.assign({ "Authorization": sessionStorage.access_token, "uid": sessionStorage.uid })
		}).request().then(function (response) {
			dispatch((0, _Loading.isLoading)(false));
			return response.data;
		}).catch(function (error) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
			throw error;
		});
	};
};

var searchDonor = exports.searchDonor = function searchDonor(form) {

	Utils.clearNullAndEmpty(form);

	return function (dispatch) {

		dispatch((0, _Loading.isLoading)(true));

		return new _ClientHttpRequest2.default({
			service: Object.keys(form).length == 0 ? 'api/searchDonor' : 'api/searchDonorParam',
			method: "POST",
			data: _extends({}, form),
			headers: Object.assign({ "Authorization": sessionStorage.access_token, "uid": sessionStorage.uid })
		}).request().then(function (response) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch({ type: ACTION_SEARCH_DONOR, Obj: response.data });
		}).catch(function (error) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
			throw error;
		});
	};
};

var getDonor = exports.getDonor = function getDonor(id) {

	return function (dispatch) {

		dispatch((0, _Loading.isLoading)(true));

		return new _ClientHttpRequest2.default({
			service: 'api/getDonor',
			method: "POST",
			data: { id: id },
			headers: Object.assign({ "Authorization": sessionStorage.access_token, "uid": sessionStorage.uid })
		}).request().then(function (response) {

			var data = response.data;

			var domicilioFiscal = data.domicilioFiscal;
			var domicilioCorrespondencia = data.domicilioCorrespondencia;
			var domicilioCorrespondenciaNoEsMismo = data.domicilioCorrespondenciaNoEsMismo;
			var actaConstitutiva = data.actaConstitutiva;
			var documentosDonante = [];
			var logoDonante = void 0;

			if (data.documentosDonante) {
				data.documentosDonante.forEach(function (d) {

					var documentObj = {
						id: d.idDocumento,
						nombre: decodeURI(d.nombre),
						descripcion: d.descripcion,
						documento: {
							idDocumento: d.dropboxId
						}
					};

					if (d.tipoDocumento) {
						logoDonante = d.dropboxId;
					} else {
						documentosDonante.push(documentObj);
					}
				});
			}

			var representantesLegales = data.representantesLegales ? data.representantesLegales.map(function (r) {
				return _extends({}, r, { rep: r.nombre + ' ' + r.apellidoPaterno + ' ' + r.apellidoMaterno });
			}) : new Array();

			var patronosConsejeros = data.patronosConsejeros ? data.patronosConsejeros.map(function (p) {
				return _extends({}, p, { empfullname: p.nombre + ' ' + p.apellidoPaterno + ' ' + p.apellidoMaterno });
			}) : new Array();

			var contactos = data.contactos ? data.contactos.map(function (c) {
				return _extends({}, c, { cfullname: c.nombre + ' ' + c.apellidoPaterno + ' ' + c.apellidoMaterno });
			}) : new Array();

			var obj = {
				idDonor: data.id,
				donorName: data.nombreInstitucion || '',
				legalPersonality: data.idPersonalidadJuridica || '',
				status: data.deleted ? 2 : 1,
				rfc: data.rfc || '',
				cluni: data.cluni || '',
				constDate: data.fechaConstitucion || '',
				opDate: data.fechaInicioOperacion || '',
				jap: data.idOrganismoRegulador || '',
				donorPhone: data.telefono || '',
				donorEmail: data.email || '',
				donorWebsite: data.paginaWeb || '',
				cp: domicilioFiscal.idCodigoPostal,
				state: domicilioFiscal.idEstado,
				town: domicilioFiscal.idMunicipioDelegacion,
				city: domicilioFiscal.idCiudad,
				colony: domicilioFiscal.idColonia,
				street: domicilioFiscal.calle,
				numext: domicilioFiscal.numeroExterior,
				numint: domicilioFiscal.numeroInterior || '',
				bstreet1: domicilioFiscal.entreCalle1,
				bstreet2: domicilioFiscal.entreCalle2,
				reference: domicilioFiscal.referencia,
				toggle: domicilioCorrespondenciaNoEsMismo ? domicilioCorrespondenciaNoEsMismo : false,
				cpFiscal: domicilioCorrespondenciaNoEsMismo ? domicilioCorrespondencia.idCodigoPostal : '',
				stateFiscal: domicilioCorrespondenciaNoEsMismo ? domicilioCorrespondencia.idEstado : '',
				townFiscal: domicilioCorrespondenciaNoEsMismo ? domicilioCorrespondencia.idMunicipioDelegacion : '',
				cityFiscal: domicilioCorrespondenciaNoEsMismo ? domicilioCorrespondencia.idCiudad : '',
				colonyFiscal: domicilioCorrespondenciaNoEsMismo ? domicilioCorrespondencia.idColonia : '',
				streetFiscal: domicilioCorrespondenciaNoEsMismo ? domicilioCorrespondencia.calle : '',
				numextFiscal: domicilioCorrespondenciaNoEsMismo ? domicilioCorrespondencia.numeroExterior : '',
				numintFiscal: domicilioCorrespondenciaNoEsMismo ? domicilioCorrespondencia.numeroInterior : '',
				bstreet1Fiscal: domicilioCorrespondenciaNoEsMismo ? domicilioCorrespondencia.entreCalle1 : '',
				bstreet2Fiscal: domicilioCorrespondenciaNoEsMismo ? domicilioCorrespondencia.entreCalle2 : '',
				referenceFiscal: domicilioCorrespondenciaNoEsMismo ? domicilioCorrespondencia.referencia : '',
				socialActivity: data.actividadSocial,
				socialGoal: data.objetoSocial || '',
				writingNumber: actaConstitutiva.numeroEscritura || '',
				writingDate: actaConstitutiva.fechaEscritura || '',
				notaryNumber: actaConstitutiva.numeroNotaria || '',
				writingState: actaConstitutiva.idEstado || '',
				notaryName: actaConstitutiva.nombreNotario || '',
				notaryLastname: actaConstitutiva.apellidoPaternoNotario || '',
				notarySurname: actaConstitutiva.apellidoMaternoNotario || '',
				folioRPP: actaConstitutiva.folioRPP || '',
				folioDate: actaConstitutiva.fechaFolioRPP || '',
				legalRepresentatives: representantesLegales,
				employersAdvisers: patronosConsejeros,
				contacts: contactos,
				documents: documentosDonante,
				logoDonante: logoDonante
			};

			dispatch({ type: ACTION_GET_DONOR, Obj: obj });
			dispatch((0, _Loading.isLoading)(false));
			return obj;
		}).catch(function (error) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
			throw error;
		});
	};
};

var updateDonor = exports.updateDonor = function updateDonor(form) {

	return function (dispatch) {

		dispatch((0, _Loading.isLoading)(true));

		return new _ClientHttpRequest2.default({
			service: 'api/updateDonor',
			method: "POST",
			data: _extends({}, form),
			headers: Object.assign({ "Authorization": sessionStorage.access_token, "uid": sessionStorage.uid })
		}).request().then(function (response) {
			dispatch((0, _Loading.isLoading)(false));
			return response.data;
		}).catch(function (error) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
			throw error;
		});
	};
};

var clearDonor = exports.clearDonor = function clearDonor() {
	return function (dispatch) {
		dispatch({ type: ACTION_GET_DONOR, Obj: {} });
		dispatch({ type: ACTION_SEARCH_DONOR, Obj: [] });
	};
};

/***/ }),

/***/ 437:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.clearExerciseInfo = exports.updateExerciseInfo = exports.deleteExerciseInfo = exports.getExerciseInfo = exports.searchExerciseInfo = exports.addExerciseInfo = exports.ACTION_UPDATE_EXERCISE_INFO = exports.ACTION_DELETE_EXERCISE_INFO = exports.ACTION_GET_EXERCISE_INFO = exports.ACTION_SEARCH_EXERCISE_INFO = exports.ACTION_NEW_EXERCISE_INFO = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _Utils = __webpack_require__(2);

var Utils = _interopRequireWildcard(_Utils);

var _ClientHttpRequest = __webpack_require__(5);

var _ClientHttpRequest2 = _interopRequireDefault(_ClientHttpRequest);

var _immutable = __webpack_require__(1);

var _immutable2 = _interopRequireDefault(_immutable);

var _Modal = __webpack_require__(4);

var _Loading = __webpack_require__(3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var initialState = _immutable2.default.Map({}).set('Search', new _immutable2.default.List([])).set('Response', new _immutable2.default.Map({})).set('Get', new _immutable2.default.Map({}));

/* Types */
var ACTION_NEW_EXERCISE_INFO = exports.ACTION_NEW_EXERCISE_INFO = 'ACTION_NEW_EXERCISE_INFO';

var ACTION_SEARCH_EXERCISE_INFO = exports.ACTION_SEARCH_EXERCISE_INFO = 'ACTION_SEARCH_EXERCISE_INFO';

var ACTION_GET_EXERCISE_INFO = exports.ACTION_GET_EXERCISE_INFO = 'ACTION_GET_EXERCISE_INFO';

var ACTION_DELETE_EXERCISE_INFO = exports.ACTION_DELETE_EXERCISE_INFO = 'ACTION_DELETE_EXERCISE_INFO';

var ACTION_UPDATE_EXERCISE_INFO = exports.ACTION_UPDATE_EXERCISE_INFO = 'ACTION_UPDATE_EXERCISE_INFO';

/* Reducer */

exports.default = function () {
	var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	var action = arguments[1];


	switch (action.type) {
		case ACTION_NEW_EXERCISE_INFO:
			return state.set('Response', new _immutable2.default.Map(action.Obj));
		case ACTION_SEARCH_EXERCISE_INFO:
			return state.set('Search', new _immutable2.default.List(action.Obj));
		case ACTION_GET_EXERCISE_INFO:
			return state.set('Get', new _immutable2.default.Map(action.Obj));
		case ACTION_DELETE_EXERCISE_INFO:
			return state.set('Response', new _immutable2.default.Map(action.Obj));
		case ACTION_UPDATE_EXERCISE_INFO:
			return state.set('Response', new _immutable2.default.Map(action.Obj));
		default:
			return state;
	}
};

/* Action Creators */


var addExerciseInfo = exports.addExerciseInfo = function addExerciseInfo(form) {

	return function (dispatch) {

		dispatch((0, _Loading.isLoading)(true));

		return new _ClientHttpRequest2.default({
			service: 'api/newExerciseInfo',
			method: "POST",
			data: _extends({}, form),
			headers: Object.assign({ "Authorization": sessionStorage.access_token, "uid": sessionStorage.uid })
		}).request().then(function (response) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch({ type: ACTION_NEW_EXERCISE_INFO, Obj: response.data });
			dispatch((0, _Modal.createModal)(Utils.successMessage()));
		}).catch(function (error) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
			throw error;
		});
	};
};

var searchExerciseInfo = exports.searchExerciseInfo = function searchExerciseInfo(form) {

	Utils.clearNullAndEmpty(form);

	return function (dispatch) {

		dispatch((0, _Loading.isLoading)(true));

		return new _ClientHttpRequest2.default({
			service: Object.keys(form).length == 0 ? 'api/searchExerciseInfo' : 'api/searchParamExerciseInfo',
			method: "POST",
			data: _extends({}, form),
			headers: Object.assign({ "Authorization": sessionStorage.access_token, "uid": sessionStorage.uid })
		}).request().then(function (response) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch({ type: ACTION_SEARCH_EXERCISE_INFO, Obj: response.data });
		}).catch(function (error) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
			throw error;
		});
	};
};

var getExerciseInfo = exports.getExerciseInfo = function getExerciseInfo(id) {

	return function (dispatch) {

		dispatch((0, _Loading.isLoading)(true));

		return new _ClientHttpRequest2.default({
			service: 'api/getExerciseInfo',
			method: "POST",
			data: { id: id },
			headers: Object.assign({ "Authorization": sessionStorage.access_token, "uid": sessionStorage.uid })
		}).request().then(function (response) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch({ type: ACTION_GET_EXERCISE_INFO, Obj: response.data });
		}).catch(function (error) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
			throw error;
		});
	};
};

var deleteExerciseInfo = exports.deleteExerciseInfo = function deleteExerciseInfo() {
	return function (dispatch) {
		return dispatch({ type: ACTION_DELETE_EXERCISE_INFO, Obj: { code: '', message: '' } });
	};
};

var updateExerciseInfo = exports.updateExerciseInfo = function updateExerciseInfo(form) {

	return function (dispatch) {

		dispatch((0, _Loading.isLoading)(true));
		dispatch({ type: ACTION_GET_EXERCISE_INFO, Obj: {} });

		return new _ClientHttpRequest2.default({
			service: 'api/updateExerciseInfo',
			method: "POST",
			data: _extends({}, form),
			headers: Object.assign({ "Authorization": sessionStorage.access_token, "uid": sessionStorage.uid })
		}).request().then(function (response) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch({ type: ACTION_UPDATE_EXERCISE_INFO, Obj: response.data });
			dispatch((0, _Modal.createModal)(Utils.successMessage()));
		}).catch(function (error) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
			throw error;
		});
	};
};

var clearExerciseInfo = exports.clearExerciseInfo = function clearExerciseInfo() {
	return function (dispatch) {
		dispatch({ type: ACTION_GET_EXERCISE_INFO, Obj: {} });
		dispatch({ type: ACTION_SEARCH_EXERCISE_INFO, Obj: [] });
	};
};

/***/ }),

/***/ 438:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.clearIndicator = exports.updateIndicator = exports.deleteIndicator = exports.getIndicator = exports.searchIndicator = exports.addIndicator = exports.ACTION_UPDATE_INDICATORS = exports.ACTION_DELETE_INDICATORS = exports.ACTION_GET_INDICATORS = exports.ACTION_SEARCH_INDICATORS = exports.ACTION_NEW_INDICATORS = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _Utils = __webpack_require__(2);

var Utils = _interopRequireWildcard(_Utils);

var _ClientHttpRequest = __webpack_require__(5);

var _ClientHttpRequest2 = _interopRequireDefault(_ClientHttpRequest);

var _immutable = __webpack_require__(1);

var _immutable2 = _interopRequireDefault(_immutable);

var _Modal = __webpack_require__(4);

var _Loading = __webpack_require__(3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var initialState = _immutable2.default.Map({}).set('Search', new _immutable2.default.List([])).set('Response', new _immutable2.default.Map({})).set('Get', new _immutable2.default.Map({}));

/* Types */
var ACTION_NEW_INDICATORS = exports.ACTION_NEW_INDICATORS = 'ACTION_NEW_INDICATORS';

var ACTION_SEARCH_INDICATORS = exports.ACTION_SEARCH_INDICATORS = 'ACTION_SEARCH_INDICATORS';

var ACTION_GET_INDICATORS = exports.ACTION_GET_INDICATORS = 'ACTION_GET_INDICATORS';

var ACTION_DELETE_INDICATORS = exports.ACTION_DELETE_INDICATORS = 'ACTION_DELETE_INDICATORS';

var ACTION_UPDATE_INDICATORS = exports.ACTION_UPDATE_INDICATORS = 'ACTION_UPDATE_INDICATORS';

/* Reducer */

exports.default = function () {
	var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	var action = arguments[1];


	switch (action.type) {
		case ACTION_NEW_INDICATORS:
			return state.set('Response', new _immutable2.default.Map(action.Obj));
		case ACTION_SEARCH_INDICATORS:
			return state.set('Search', new _immutable2.default.List(action.Obj));
		case ACTION_GET_INDICATORS:
			return state.set('Get', new _immutable2.default.Map(action.Obj));
		case ACTION_DELETE_INDICATORS:
			return state.set('Response', new _immutable2.default.Map(action.Obj));
		case ACTION_UPDATE_INDICATORS:
			return state.set('Response', new _immutable2.default.Map(action.Obj));
		default:
			return state;
	}
};

/* Action Creators */

var addIndicator = exports.addIndicator = function addIndicator(form) {

	var data = Object.assign({}, form);
	data.detalleIndicadorList = Utils.getListPropsOmit(data.detalleIndicadorList, ['id', 'tmp', 'rango', 'tabla', 'escala']);

	return function (dispatch) {

		dispatch((0, _Loading.isLoading)(true));

		return new _ClientHttpRequest2.default({
			service: 'api/newIndicator',
			method: "POST",
			data: _extends({}, data),
			headers: Object.assign({ "Authorization": sessionStorage.access_token, "uid": sessionStorage.uid })
		}).request().then(function (response) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch((0, _Modal.createModal)(Utils.successMessage()));
			return response;
		}).catch(function (error) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
			throw error;
		});
	};
};

var searchIndicator = exports.searchIndicator = function searchIndicator(form) {

	Utils.clearNullAndEmpty(form);

	return function (dispatch) {

		dispatch((0, _Loading.isLoading)(true));

		return new _ClientHttpRequest2.default({
			service: Object.keys(form).length == 0 ? 'api/searchIndicator' : 'api/searchParamIndicator',
			method: "POST",
			data: _extends({}, form),
			headers: Object.assign({ "Authorization": sessionStorage.access_token, "uid": sessionStorage.uid })
		}).request().then(function (response) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch({ type: ACTION_SEARCH_INDICATORS, Obj: response.data });
			return response;
		}).catch(function (error) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch((0, _Modal.createModal)(Utils.errorMessage(error)));
			throw error;
		});
	};
};

var getIndicator = exports.getIndicator = function getIndicator(id) {

	return function (dispatch) {

		dispatch((0, _Loading.isLoading)(true));

		return new _ClientHttpRequest2.default({
			service: 'api/getIndicator',
			method: "POST",
			data: { id: id },
			headers: Object.assign({ "Authorization": sessionStorage.access_token, "uid": sessionStorage.uid })
		}).request().then(function (response) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch({ type: ACTION_GET_INDICATORS, Obj: response.data });
			return response;
		}).catch(function (error) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
			throw error;
		});
	};
};

var deleteIndicator = exports.deleteIndicator = function deleteIndicator() {
	return function (dispatch) {
		return dispatch({ type: ACTION_DELETE_INDICATORS, Obj: { code: '', message: '' } });
	};
};

var updateIndicator = exports.updateIndicator = function updateIndicator(form) {

	var data = Object.assign({}, form);
	data.detalleIndicadorList = Utils.getListPropsOmit(data.detalleIndicadorList, ['id', 'tmp', 'custom', 'rango', 'tabla', 'escala']);
	data.detalleIndicadorListRemove = Utils.getListPropsOmit(data.detalleIndicadorListRemove, ['id', 'custom', 'rango', 'tabla', 'escala']);
	data.detalleIndicadorList = Utils.unionArray(data.detalleIndicadorList, data.detalleIndicadorListRemove);

	return function (dispatch) {

		dispatch((0, _Loading.isLoading)(true));
		dispatch({ type: ACTION_GET_INDICATORS, Obj: {} });

		return new _ClientHttpRequest2.default({
			service: 'api/updateIndicator',
			method: "POST",
			data: _extends({}, data),
			headers: Object.assign({ "Authorization": sessionStorage.access_token, "uid": sessionStorage.uid })
		}).request().then(function (response) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch({ type: ACTION_UPDATE_INDICATORS, Obj: response.data });
			dispatch((0, _Modal.createModal)(Utils.successMessage()));
			return response;
		}).catch(function (error) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
			throw error;
		});
	};
};

var clearIndicator = exports.clearIndicator = function clearIndicator() {
	return function (dispatch) {
		dispatch({ type: ACTION_GET_INDICATORS, Obj: {} });
		dispatch({ type: ACTION_SEARCH_INDICATORS, Obj: [] });
	};
};

/***/ }),

/***/ 439:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.clearInterventionLevel = exports.updateInterventionLevel = exports.deleteInterventionLevel = exports.getInterventionLevel = exports.searchInterventionLevel = exports.addInterventionLevel = exports.ACTION_UPDATE_INTERVENTION_LEVEL = exports.ACTION_DELETE_INTERVENTION_LEVEL = exports.ACTION_GET_INTERVENTION_LEVEL = exports.ACTION_SEARCH_INTERVENTION_LEVEL = undefined;

var _Utils = __webpack_require__(2);

var Utils = _interopRequireWildcard(_Utils);

var _ClientHttpRequest = __webpack_require__(5);

var _ClientHttpRequest2 = _interopRequireDefault(_ClientHttpRequest);

var _immutable = __webpack_require__(1);

var _immutable2 = _interopRequireDefault(_immutable);

var _Modal = __webpack_require__(4);

var _Loading = __webpack_require__(3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var initialState = _immutable2.default.Map({}).set('Search', new _immutable2.default.List([])).set('Response', new _immutable2.default.Map({})).set('Get', new _immutable2.default.Map({}));

/* Types */
var ACTION_SEARCH_INTERVENTION_LEVEL = exports.ACTION_SEARCH_INTERVENTION_LEVEL = 'ACTION_SEARCH_INTERVENTION_LEVEL';

var ACTION_GET_INTERVENTION_LEVEL = exports.ACTION_GET_INTERVENTION_LEVEL = 'ACTION_GET_INTERVENTION_LEVEL';

var ACTION_DELETE_INTERVENTION_LEVEL = exports.ACTION_DELETE_INTERVENTION_LEVEL = 'ACTION_DELETE_INTERVENTION_LEVEL';

var ACTION_UPDATE_INTERVENTION_LEVEL = exports.ACTION_UPDATE_INTERVENTION_LEVEL = 'ACTION_UPDATE_INTERVENTION_LEVEL';

/* Reducer */

exports.default = function () {
	var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	var action = arguments[1];


	switch (action.type) {
		case ACTION_SEARCH_INTERVENTION_LEVEL:
			return state.set('Search', new _immutable2.default.List(action.Obj));
		case ACTION_GET_INTERVENTION_LEVEL:
			return state.set('Get', new _immutable2.default.Map(action.Obj));
		case ACTION_DELETE_INTERVENTION_LEVEL:
			return state.set('Response', new _immutable2.default.Map(action.Obj));
		case ACTION_UPDATE_INTERVENTION_LEVEL:
			return state.set('Response', new _immutable2.default.Map(action.Obj));
		default:
			return state;
	}
};

/* Action Creators */

var addInterventionLevel = exports.addInterventionLevel = function addInterventionLevel(form) {

	return function (dispatch) {

		dispatch((0, _Loading.isLoading)(true));

		return new _ClientHttpRequest2.default({
			service: 'api/newInterventionLevel',
			method: "POST",
			data: form,
			headers: Object.assign({ "Authorization": sessionStorage.access_token, "uid": sessionStorage.uid })
		}).request().then(function () {
			dispatch((0, _Loading.isLoading)(false));
			dispatch((0, _Modal.createModal)(Utils.successMessage()));
		}).catch(function (error) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
			throw error;
		});
	};
};

var searchInterventionLevel = exports.searchInterventionLevel = function searchInterventionLevel(form) {

	Utils.clearNullAndEmpty(form);

	return function (dispatch) {

		dispatch((0, _Loading.isLoading)(true));

		return new _ClientHttpRequest2.default({
			service: Object.keys(form).length == 0 ? 'api/searchInterventionLevel' : 'api/searchParamInterventionLevel',
			method: "POST",
			data: form,
			headers: Object.assign({ "Authorization": sessionStorage.access_token, "uid": sessionStorage.uid })
		}).request().then(function (response) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch({ type: ACTION_SEARCH_INTERVENTION_LEVEL, Obj: response.data });
		}).catch(function (error) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
			throw error;
		});
	};
};

var getInterventionLevel = exports.getInterventionLevel = function getInterventionLevel(id) {

	return function (dispatch) {

		dispatch((0, _Loading.isLoading)(true));

		return new _ClientHttpRequest2.default({
			service: 'api/getInterventionLevel',
			method: "POST",
			data: { id: id },
			headers: Object.assign({ "Authorization": sessionStorage.access_token, "uid": sessionStorage.uid })
		}).request().then(function (response) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch({ type: ACTION_GET_INTERVENTION_LEVEL, Obj: response.data });
		}).catch(function (error) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
			throw error;
		});
	};
};

var deleteInterventionLevel = exports.deleteInterventionLevel = function deleteInterventionLevel() {
	return function (dispatch) {
		return dispatch({ type: ACTION_DELETE_INTERVENTION_LEVEL, Obj: { code: '', message: '' } });
	};
};

var updateInterventionLevel = exports.updateInterventionLevel = function updateInterventionLevel(form) {

	return function (dispatch) {

		dispatch((0, _Loading.isLoading)(true));
		dispatch({ type: ACTION_GET_INTERVENTION_LEVEL, Obj: {} });

		return new _ClientHttpRequest2.default({
			service: 'api/updateInterventionLevel',
			method: "POST",
			data: form,
			headers: Object.assign({ "Authorization": sessionStorage.access_token, "uid": sessionStorage.uid })
		}).request().then(function (response) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch({ type: ACTION_UPDATE_INTERVENTION_LEVEL, Obj: response.data });
			dispatch((0, _Modal.createModal)(Utils.successMessage()));
		}).catch(function (error) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
			throw error;
		});
	};
};

var clearInterventionLevel = exports.clearInterventionLevel = function clearInterventionLevel() {
	return function (dispatch) {
		dispatch({ type: ACTION_GET_INTERVENTION_LEVEL, Obj: {} });
		dispatch({ type: ACTION_SEARCH_INTERVENTION_LEVEL, Obj: [] });
	};
};

/***/ }),

/***/ 440:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.logoutOAuth = exports.loginCognito = exports.loginOAuth = exports.ACTION_LOGIN_OAUTH = exports.ACTION_LOGIN_COGNITO = undefined;

var _ClientHttpRequest = __webpack_require__(5);

var _ClientHttpRequest2 = _interopRequireDefault(_ClientHttpRequest);

var _immutable = __webpack_require__(1);

var _immutable2 = _interopRequireDefault(_immutable);

var _Loading = __webpack_require__(3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var initialState = _immutable2.default.Map({}).set('Login', new _immutable2.default.Map({}));

/* Types */
var ACTION_LOGIN_COGNITO = exports.ACTION_LOGIN_COGNITO = 'ACTION_LOGIN_COGNITO';

var ACTION_LOGIN_OAUTH = exports.ACTION_LOGIN_OAUTH = 'ACTION_LOGIN_OAUTH';

/* Reducer */

exports.default = function () {
	var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	var action = arguments[1];


	var object = action.Obj;

	switch (action.type) {
		case ACTION_LOGIN_OAUTH:

			object.type = 'ejecutivo';
			sessionStorage.uid = object.profile.samaccountname;
			sessionStorage.mail = object.profile.mail;
			sessionStorage.lastname = object.profile.lastname;
			sessionStorage.firstname = object.profile.firstname;
			sessionStorage.access_token = object.access.access_token;
			sessionStorage.refresh_token = object.access.refresh_token;
			sessionStorage.bpm_token = object.access.bpm_token;
			sessionStorage.type = 'Ejecutivo';
			localStorage.type = 'Ejecutivo';

			return state.set('Login', new _immutable2.default.Map(object));

		case ACTION_LOGIN_COGNITO:

			object.type = 'donataria';
			sessionStorage.access_token = object.access_token;
			sessionStorage.refresh_token = object.refresh_token;
			sessionStorage.bpm_token = object.bpm_token;
			sessionStorage.mail = object.mail;
			sessionStorage.uid = object.mail;
			sessionStorage.type = 'Donataria';
			localStorage.type = 'Donataria';

			return state.set('Login', new _immutable2.default.Map(object));
		default:
			return state;
	}
};

/* Action Creators */

var loginOAuth = exports.loginOAuth = function loginOAuth(form) {

	return function (dispatch) {

		dispatch((0, _Loading.isLoading)(true));

		return new _ClientHttpRequest2.default({
			service: 'auth/oauth/login',
			method: "POST",
			data: Object.assign({
				"username": form.username,
				"password": form.password
			})
		}).request().then(function (response) {
			dispatch({ type: ACTION_LOGIN_OAUTH, Obj: response.data });
			dispatch((0, _Loading.isLoading)(false));
		}).catch(function (error) {
			dispatch((0, _Loading.isLoading)(false));
			throw error;
		});
	};
};

var loginCognito = exports.loginCognito = function loginCognito(form) {
	localStorage.idDonataria = '';

	return function (dispatch) {

		dispatch((0, _Loading.isLoading)(true));

		return new _ClientHttpRequest2.default({
			service: 'auth/cognito/login',
			method: "POST",
			data: Object.assign({
				"username": form.username,
				"password": form.password
			})
		}).request().then(function (response) {
			response.data.mail = form.username;
			dispatch({ type: ACTION_LOGIN_COGNITO, Obj: response.data });
			dispatch((0, _Loading.isLoading)(false));
		}).catch(function (error) {
			dispatch((0, _Loading.isLoading)(false));
			throw error;
		});
	};
};

var logoutOAuth = exports.logoutOAuth = function logoutOAuth(token) {

	return function (dispatch) {
		dispatch((0, _Loading.isLoading)(true));
		return new _ClientHttpRequest2.default({
			service: 'auth/oauth/logout',
			method: "POST",
			data: Object.assign({
				"token": token
			})
		}).request().then(function () {
			dispatch((0, _Loading.isLoading)(false));
		}).catch(function (error) {
			dispatch((0, _Loading.isLoading)(false));
			throw error;
		});
	};
};

/***/ }),

/***/ 441:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.clearObjective = exports.updateObjective = exports.deleteObjective = exports.getObjective = exports.searchObjective = exports.addObjective = exports.ACTION_UPDATE_OBJECTIVE = exports.ACTION_DELETE_OBJECTIVE = exports.ACTION_GET_OBJECTIVE = exports.ACTION_SEARCH_OBJECTIVE = exports.ACTION_NEW_OBJECTIVE = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _Utils = __webpack_require__(2);

var Utils = _interopRequireWildcard(_Utils);

var _ClientHttpRequest = __webpack_require__(5);

var _ClientHttpRequest2 = _interopRequireDefault(_ClientHttpRequest);

var _immutable = __webpack_require__(1);

var _immutable2 = _interopRequireDefault(_immutable);

var _Modal = __webpack_require__(4);

var _Loading = __webpack_require__(3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var initialState = _immutable2.default.Map({}).set('Search', new _immutable2.default.List([])).set('Response', new _immutable2.default.Map({})).set('Get', new _immutable2.default.Map({}));

/* Types */
var ACTION_NEW_OBJECTIVE = exports.ACTION_NEW_OBJECTIVE = 'ACTION_NEW_OBJECTIVE';

var ACTION_SEARCH_OBJECTIVE = exports.ACTION_SEARCH_OBJECTIVE = 'ACTION_SEARCH_OBJECTIVE';

var ACTION_GET_OBJECTIVE = exports.ACTION_GET_OBJECTIVE = 'ACTION_GET_OBJECTIVE';

var ACTION_DELETE_OBJECTIVE = exports.ACTION_DELETE_OBJECTIVE = 'ACTION_DELETE_OBJECTIVE';

var ACTION_UPDATE_OBJECTIVE = exports.ACTION_UPDATE_OBJECTIVE = 'ACTION_UPDATE_OBJECTIVE';

/* Reducer */

exports.default = function () {
	var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	var action = arguments[1];


	switch (action.type) {
		case ACTION_NEW_OBJECTIVE:
			return state.set('Response', new _immutable2.default.Map(action.Obj));
		case ACTION_SEARCH_OBJECTIVE:
			return state.set('Search', new _immutable2.default.List(action.Obj));
		case ACTION_GET_OBJECTIVE:
			return state.set('Get', new _immutable2.default.Map(action.Obj));
		case ACTION_DELETE_OBJECTIVE:
			return state.set('Response', new _immutable2.default.Map(action.Obj));
		case ACTION_UPDATE_OBJECTIVE:
			return state.set('Response', new _immutable2.default.Map(action.Obj));
		default:
			return state;
	}
};

/* Action Creators */

var addObjective = exports.addObjective = function addObjective(form) {

	return function (dispatch) {

		dispatch((0, _Loading.isLoading)(true));

		return new _ClientHttpRequest2.default({
			service: 'api/newObjective',
			method: "POST",
			data: _extends({}, form),
			headers: Object.assign({ "Authorization": sessionStorage.access_token, "uid": sessionStorage.uid })
		}).request().then(function () {
			dispatch((0, _Loading.isLoading)(false));
			dispatch((0, _Modal.createModal)(Utils.successMessage()));
		}).catch(function (error) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
			throw error;
		});
	};
};

var searchObjective = exports.searchObjective = function searchObjective(form) {

	Utils.clearNullAndEmpty(form);

	return function (dispatch) {

		dispatch((0, _Loading.isLoading)(true));

		return new _ClientHttpRequest2.default({
			service: Object.keys(form).length == 0 ? 'api/searchObjective' : 'api/searchParamObjective',
			method: "POST",
			data: _extends({}, form),
			headers: Object.assign({ "Authorization": sessionStorage.access_token, "uid": sessionStorage.uid })
		}).request().then(function (response) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch({ type: ACTION_SEARCH_OBJECTIVE, Obj: response.data });
		}).catch(function (error) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
			throw error;
		});
	};
};

var getObjective = exports.getObjective = function getObjective(id) {

	return function (dispatch) {

		dispatch((0, _Loading.isLoading)(true));

		return new _ClientHttpRequest2.default({
			service: 'api/getObjective',
			method: "POST",
			data: { id: id },
			headers: Object.assign({ "Authorization": sessionStorage.access_token, "uid": sessionStorage.uid })
		}).request().then(function (response) {
			dispatch({ type: ACTION_GET_OBJECTIVE, Obj: response.data });
			dispatch((0, _Loading.isLoading)(false));
		}).catch(function (error) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
			throw error;
		});
	};
};

var deleteObjective = exports.deleteObjective = function deleteObjective() {
	return function (dispatch) {
		return dispatch({ type: ACTION_DELETE_OBJECTIVE, Obj: { code: '', message: '' } });
	};
};

var updateObjective = exports.updateObjective = function updateObjective(form) {

	var data = Object.assign({}, form);
	//data.metaObjetivo = Utils.unionArray(data.metaObjetivo, data.goalRemove)

	return function (dispatch) {

		dispatch((0, _Loading.isLoading)(true));
		dispatch({ type: ACTION_GET_OBJECTIVE, Obj: {} });

		return new _ClientHttpRequest2.default({
			service: 'api/updateObjective',
			method: "POST",
			data: _extends({}, data),
			headers: Object.assign({ "Authorization": sessionStorage.access_token, "uid": sessionStorage.uid })
		}).request().then(function (response) {
			dispatch({ type: ACTION_UPDATE_OBJECTIVE, Obj: response.data });
			dispatch((0, _Loading.isLoading)(false));
			dispatch((0, _Modal.createModal)(Utils.successMessage()));
		}).catch(function (error) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
			throw error;
		});
	};
};

var clearObjective = exports.clearObjective = function clearObjective() {
	return function (dispatch) {
		dispatch({ type: ACTION_GET_OBJECTIVE, Obj: {} });
		dispatch({ type: ACTION_SEARCH_OBJECTIVE, Obj: [] });
	};
};

/***/ }),

/***/ 442:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.clearCorrida = exports.setIdCorrida = exports.applyOportunity = exports.getOportunities = exports.SET_CORRIDA = exports.GET_OPORTUNITIES = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _Utils = __webpack_require__(2);

var Utils = _interopRequireWildcard(_Utils);

var _Loading = __webpack_require__(3);

var _Modal = __webpack_require__(4);

var _ClientHttpRequest = __webpack_require__(5);

var _ClientHttpRequest2 = _interopRequireDefault(_ClientHttpRequest);

var _immutable = __webpack_require__(1);

var _immutable2 = _interopRequireDefault(_immutable);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var initialState = _immutable2.default.Map({}).set('Search', new _immutable2.default.List([])).set('Response', new _immutable2.default.Map({})).set('Get', new _immutable2.default.Map({ oportunidades: { oportunidad: [] } }));

/* Types */
var GET_OPORTUNITIES = exports.GET_OPORTUNITIES = 'GET_OPORTUNITIES';
var SET_CORRIDA = exports.SET_CORRIDA = 'SET_CORRIDA';

/* Reducer */

exports.default = function () {
	var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	var action = arguments[1];


	switch (action.type) {
		case GET_OPORTUNITIES:
			return state.set('Get', new _immutable2.default.Map(action.Obj));
		case SET_CORRIDA:
			return state.set('Response', new _immutable2.default.Map(action.Obj));
		default:
			return state;
	}
};

/* Action Creators */

var getOportunities = exports.getOportunities = function getOportunities(form) {

	return function (dispatch) {

		dispatch((0, _Loading.isLoading)(true));

		return new _ClientHttpRequest2.default({
			service: 'api/getOportunities',
			method: "POST",
			data: _extends({}, form),
			headers: Object.assign({ "Authorization": sessionStorage.access_token, "uid": sessionStorage.uid })
		}).request().then(function (response) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch({ type: GET_OPORTUNITIES, Obj: response.data });
		}).catch(function (error) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
			throw error;
		});
	};
};

var applyOportunity = exports.applyOportunity = function applyOportunity(form) {

	return function (dispatch) {

		dispatch((0, _Loading.isLoading)(true));

		return new _ClientHttpRequest2.default({
			service: 'api/applyOportunity',
			method: "POST",
			data: _extends({}, form),
			headers: Object.assign({ "Authorization": sessionStorage.access_token, "uid": sessionStorage.uid })
		}).request().then(function (response) {
			dispatch((0, _Loading.isLoading)(false));
			return response.data;
		}).catch(function (error) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
			throw error;
		});
	};
};

var setIdCorrida = exports.setIdCorrida = function setIdCorrida(selection) {
	return function (dispatch) {
		dispatch({ type: SET_CORRIDA, Obj: _extends({}, selection) });
		return Promise.resolve();
	};
};

var clearCorrida = exports.clearCorrida = function clearCorrida() {
	return function (dispatch) {
		dispatch({ type: SET_CORRIDA, Obj: {} });
		return Promise.resolve();
	};
};

/***/ }),

/***/ 443:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.clearQuestion = exports.exportPDFQuestion = exports.updateQuestion = exports.deleteQuestion = exports.getQuestion = exports.searchQuestion = exports.addQuestion = exports.searchTypeAnswer = exports.searchTypeQuestion = exports.updateVersion = exports.ACTION_UPDATE_QUESTION_VERSION = exports.ACTION_UPDATE_QUESTION = exports.ACTION_DELETE_QUESTION = exports.ACTION_GET_QUESTION = exports.ACTION_SEARCH_QUESTION = exports.ACTION_NEW_QUESTION = exports.ACTION_TYPE_ANSWER = exports.ACTION_TYPE_QUESTION = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _Utils = __webpack_require__(2);

var Utils = _interopRequireWildcard(_Utils);

var _ClientHttpRequest = __webpack_require__(5);

var _ClientHttpRequest2 = _interopRequireDefault(_ClientHttpRequest);

var _immutable = __webpack_require__(1);

var _immutable2 = _interopRequireDefault(_immutable);

var _Modal = __webpack_require__(4);

var _Loading = __webpack_require__(3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var initialState = _immutable2.default.Map({}).set('TypeAnswer', new _immutable2.default.List([])).set('TypeQuestion', new _immutable2.default.List([])).set('Search', new _immutable2.default.List([])).set('Response', new _immutable2.default.Map({})).set('Get', new _immutable2.default.Map({})).set('UpdateVersion', new _immutable2.default.Map({}));

/* Types */
var ACTION_TYPE_QUESTION = exports.ACTION_TYPE_QUESTION = 'ACTION_TYPE_QUESTION';

var ACTION_TYPE_ANSWER = exports.ACTION_TYPE_ANSWER = 'ACTION_TYPE_ANSWER';

var ACTION_NEW_QUESTION = exports.ACTION_NEW_QUESTION = 'ACTION_NEW_QUESTION';

var ACTION_SEARCH_QUESTION = exports.ACTION_SEARCH_QUESTION = 'ACTION_SEARCH_QUESTION';

var ACTION_GET_QUESTION = exports.ACTION_GET_QUESTION = 'ACTION_GET_QUESTION';

var ACTION_DELETE_QUESTION = exports.ACTION_DELETE_QUESTION = 'ACTION_DELETE_QUESTION';

var ACTION_UPDATE_QUESTION = exports.ACTION_UPDATE_QUESTION = 'ACTION_UPDATE_QUESTION';

var ACTION_UPDATE_QUESTION_VERSION = exports.ACTION_UPDATE_QUESTION_VERSION = 'ACTION_UPDATE_QUESTION_VERSION';

/* Reducer */

exports.default = function () {
	var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	var action = arguments[1];


	switch (action.type) {
		case ACTION_TYPE_QUESTION:
			return state.set('TypeQuestion', new _immutable2.default.List(action.Obj));
		case ACTION_TYPE_ANSWER:
			return state.set('TypeAnswer', new _immutable2.default.List(action.Obj));
		case ACTION_NEW_QUESTION:
			return state.set('Response', new _immutable2.default.Map(action.Obj));
		case ACTION_SEARCH_QUESTION:
			return state.set('Search', new _immutable2.default.List(action.Obj));
		case ACTION_GET_QUESTION:
			return state.set('Get', new _immutable2.default.Map(action.Obj));
		case ACTION_DELETE_QUESTION:
			return state.set('Response', new _immutable2.default.Map(action.Obj));
		case ACTION_UPDATE_QUESTION:
			return state.set('Response', new _immutable2.default.Map(action.Obj));
		case ACTION_UPDATE_QUESTION_VERSION:
			return state.set('UpdateVersion', new _immutable2.default.Map(action.Obj));
		default:
			return state;
	}
};

/* Action Creators */

var updateVersion = exports.updateVersion = function updateVersion(form) {

	return function (dispatch) {

		dispatch((0, _Loading.isLoading)(true));

		return new _ClientHttpRequest2.default({
			service: 'api/updateVersion',
			method: "POST",
			data: _extends({}, form),
			headers: Object.assign({ "Authorization": sessionStorage.access_token, "uid": sessionStorage.uid })
		}).request().then(function (response) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch({ type: ACTION_UPDATE_QUESTION_VERSION, Obj: response.data });
		}).catch(function (error) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
			throw error;
		});
	};
};

var searchTypeQuestion = exports.searchTypeQuestion = function searchTypeQuestion(form) {

	return function (dispatch) {

		dispatch((0, _Loading.isLoading)(true));

		return new _ClientHttpRequest2.default({
			service: 'api/searchTypeQuestion',
			method: "POST",
			data: _extends({}, form),
			headers: Object.assign({ "Authorization": sessionStorage.access_token, "uid": sessionStorage.uid })
		}).request().then(function (response) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch({ type: ACTION_TYPE_QUESTION, Obj: response.data });
		}).catch(function (error) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
			throw error;
		});
	};
};

var searchTypeAnswer = exports.searchTypeAnswer = function searchTypeAnswer(form) {

	return function (dispatch) {

		dispatch((0, _Loading.isLoading)(true));

		return new _ClientHttpRequest2.default({
			service: 'api/searchTypeAnswer',
			method: "POST",
			data: _extends({}, form),
			headers: Object.assign({ "Authorization": sessionStorage.access_token, "uid": sessionStorage.uid })
		}).request().then(function (response) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch({ type: ACTION_TYPE_ANSWER, Obj: response.data });
		}).catch(function (error) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
			throw error;
		});
	};
};

var addQuestion = exports.addQuestion = function addQuestion(form) {

	var data = Object.assign({}, form);
	data.respuestas = Utils.getListPropsOmit(data.respuestas, ['id', 'tmp']);

	return function (dispatch) {

		dispatch((0, _Loading.isLoading)(true));

		return new _ClientHttpRequest2.default({
			service: 'api/newQuestion',
			method: "POST",
			data: _extends({}, data),
			headers: Object.assign({ "Authorization": sessionStorage.access_token, "uid": sessionStorage.uid })
		}).request().then(function (response) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch({ type: ACTION_NEW_QUESTION, Obj: response.data });
			dispatch((0, _Modal.createModal)(Utils.successMessage()));
		}).catch(function (error) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
			throw error;
		});
	};
};

var searchQuestion = exports.searchQuestion = function searchQuestion(form) {

	Utils.clearNullAndEmpty(form);

	return function (dispatch) {

		dispatch((0, _Loading.isLoading)(true));

		return new _ClientHttpRequest2.default({
			service: Object.keys(form).length == 0 ? 'api/searchQuestion' : 'api/searchParamQuestion',
			method: "POST",
			data: _extends({}, form),
			headers: Object.assign({ "Authorization": sessionStorage.access_token, "uid": sessionStorage.uid })
		}).request().then(function (response) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch({ type: ACTION_SEARCH_QUESTION, Obj: response.data });
		}).catch(function (error) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
			throw error;
		});
	};
};

var getQuestion = exports.getQuestion = function getQuestion(id) {

	return function (dispatch) {

		dispatch((0, _Loading.isLoading)(true));

		return new _ClientHttpRequest2.default({
			service: 'api/getQuestion',
			method: "POST",
			data: { id: id },
			headers: Object.assign({ "Authorization": sessionStorage.access_token, "uid": sessionStorage.uid })
		}).request().then(function (response) {
			dispatch({ type: ACTION_GET_QUESTION, Obj: response.data });
			dispatch((0, _Loading.isLoading)(false));
		}).catch(function (error) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
			throw error;
		});
	};
};

var deleteQuestion = exports.deleteQuestion = function deleteQuestion() {
	return function (dispatch) {
		return dispatch({ type: ACTION_DELETE_QUESTION, Obj: { code: '', message: '' } });
	};
};

var updateQuestion = exports.updateQuestion = function updateQuestion(form) {

	var data = Object.assign({}, form);
	data.respuestas = data.respuestas.map(function (r) {
		if (r.tmp) {
			delete r.id;
		}
		return r;
	});
	data.respuestas = Utils.unionArray(data.respuestas, data.respuestasRemove);

	return function (dispatch) {

		dispatch((0, _Loading.isLoading)(true));
		dispatch({ type: ACTION_GET_QUESTION, Obj: {} });

		return new _ClientHttpRequest2.default({
			service: 'api/updateQuestion',
			method: "POST",
			data: _extends({}, data),
			headers: Object.assign({ "Authorization": sessionStorage.access_token, "uid": sessionStorage.uid })
		}).request().then(function (response) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch({ type: ACTION_UPDATE_QUESTION, Obj: response.data });
			dispatch((0, _Modal.createModal)(Utils.successMessage()));
		}).catch(function (error) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
			throw error;
		});
	};
};

var exportPDFQuestion = exports.exportPDFQuestion = function exportPDFQuestion(form) {
	return function (dispatch) {
		dispatch((0, _Loading.isLoading)(true));
		return new _ClientHttpRequest2.default({
			service: 'api/exportPDFQuestion',
			method: 'POST',
			data: _extends({}, form),
			responseType: 'arraybuffer',
			headers: Object.assign({ "Authorization": sessionStorage.access_token, "uid": sessionStorage.uid })
		}).request().then(function (response) {
			dispatch((0, _Loading.isLoading)(false));
			var fileURL = "https://donatarias.montepiedad.com.mx" + '/reporte-configuracion-pregunta.pdf';
			window.open(fileURL);
		}).catch(function (error) {
			dispatch((0, _Loading.isLoading)(false));
			throw error;
		});
	};
};

var clearQuestion = exports.clearQuestion = function clearQuestion() {
	return function (dispatch) {
		dispatch({ type: ACTION_GET_QUESTION, Obj: {} });
		dispatch({ type: ACTION_SEARCH_QUESTION, Obj: [] });
	};
};

/***/ }),

/***/ 444:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.clearSubFunction = exports.clearTypeFunction = exports.getTypeFunction = exports.searchTypeFunction = exports.ACTION_GET_TYPE_FUNCTION = exports.ACTION_SEARCH_TYPE_FUNCTION = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _Utils = __webpack_require__(2);

var Utils = _interopRequireWildcard(_Utils);

var _ClientHttpRequest = __webpack_require__(5);

var _ClientHttpRequest2 = _interopRequireDefault(_ClientHttpRequest);

var _immutable = __webpack_require__(1);

var _immutable2 = _interopRequireDefault(_immutable);

var _Modal = __webpack_require__(4);

var _Loading = __webpack_require__(3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var initialState = _immutable2.default.Map({}).set('Search', new _immutable2.default.List([])).set('Response', new _immutable2.default.Map({})).set('Get', new _immutable2.default.List([]));

/* Types */

var ACTION_SEARCH_TYPE_FUNCTION = exports.ACTION_SEARCH_TYPE_FUNCTION = 'ACTION_SEARCH_TYPE_FUNCTION';

var ACTION_GET_TYPE_FUNCTION = exports.ACTION_GET_TYPE_FUNCTION = 'ACTION_GET_TYPE_FUNCTION';

/* Reducer */

exports.default = function () {
	var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	var action = arguments[1];


	switch (action.type) {
		case ACTION_SEARCH_TYPE_FUNCTION:
			return state.set('Search', new _immutable2.default.List(action.Obj));
		case ACTION_GET_TYPE_FUNCTION:
			return state.set('Get', new _immutable2.default.List(action.Obj));
		default:
			return state;
	}
};

/* Action Creators */

var searchTypeFunction = exports.searchTypeFunction = function searchTypeFunction(form) {

	Utils.clearNullAndEmpty(form);

	return function (dispatch) {

		dispatch((0, _Loading.isLoading)(true));

		return new _ClientHttpRequest2.default({
			service: 'api/searchTypeFunction',
			method: "POST",
			data: _extends({}, form),
			headers: Object.assign({ "Authorization": sessionStorage.access_token, "uid": sessionStorage.uid })
		}).request().then(function (response) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch({ type: ACTION_SEARCH_TYPE_FUNCTION, Obj: response.data });
		}).catch(function (error) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
			throw error;
		});
	};
};

var getTypeFunction = exports.getTypeFunction = function getTypeFunction(id) {

	return function (dispatch) {

		dispatch((0, _Loading.isLoading)(true));

		return new _ClientHttpRequest2.default({
			service: 'api/getTypeFunction',
			method: "POST",
			data: { id: id },
			headers: Object.assign({ "Authorization": sessionStorage.access_token, "uid": sessionStorage.uid })
		}).request().then(function (response) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch({ type: ACTION_GET_TYPE_FUNCTION, Obj: response.data });
			return response.data;
		}).catch(function (error) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
			throw error;
		});
	};
};

var clearTypeFunction = exports.clearTypeFunction = function clearTypeFunction() {
	return function (dispatch) {
		dispatch({ type: ACTION_SEARCH_TYPE_FUNCTION, Obj: [] });
	};
};

var clearSubFunction = exports.clearSubFunction = function clearSubFunction() {
	return function (dispatch) {
		dispatch({ type: ACTION_GET_TYPE_FUNCTION, Obj: [] });
	};
};

/***/ }),

/***/ 445:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.clearConsultant = exports.updateConsultantDoc = exports.updateConsultant = exports.getConsultant = exports.searchConsultant = exports.addConsultant = exports.ACTION_UPDATE_CONSULTANT = exports.ACTION_DELETE_CONSULTANT = exports.ACTION_GET_CONSULTANT = exports.ACTION_SEARCH_CONSULTANT = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _Utils = __webpack_require__(2);

var Utils = _interopRequireWildcard(_Utils);

var _ClientHttpRequest = __webpack_require__(5);

var _ClientHttpRequest2 = _interopRequireDefault(_ClientHttpRequest);

var _immutable = __webpack_require__(1);

var _immutable2 = _interopRequireDefault(_immutable);

var _Modal = __webpack_require__(4);

var _Loading = __webpack_require__(3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var initialState = _immutable2.default.Map({}).set('Search', new _immutable2.default.List([])).set('Response', new _immutable2.default.Map({})).set('Get', new _immutable2.default.Map({}));

/* Types */
var ACTION_SEARCH_CONSULTANT = exports.ACTION_SEARCH_CONSULTANT = 'ACTION_SEARCH_CONSULTANT';

var ACTION_GET_CONSULTANT = exports.ACTION_GET_CONSULTANT = 'ACTION_GET_CONSULTANT';

var ACTION_DELETE_CONSULTANT = exports.ACTION_DELETE_CONSULTANT = 'ACTION_DELETE_CONSULTANT';

var ACTION_UPDATE_CONSULTANT = exports.ACTION_UPDATE_CONSULTANT = 'ACTION_UPDATE_CONSULTANT';

/* Reducer */

exports.default = function () {
	var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	var action = arguments[1];


	switch (action.type) {

		case ACTION_SEARCH_CONSULTANT:
			return state.set('Search', new _immutable2.default.List(action.Obj));
		case ACTION_GET_CONSULTANT:
			return state.set('Get', new _immutable2.default.Map(action.Obj));
		case ACTION_DELETE_CONSULTANT:
			return state.set('Response', new _immutable2.default.Map(action.Obj));
		case ACTION_UPDATE_CONSULTANT:
			return state.set('Response', new _immutable2.default.Map(action.Obj));
		default:
			return state;
	}
};

/* Action Creators */

var addConsultant = exports.addConsultant = function addConsultant(form) {

	var contactos = Utils.getListPropsOmit(form.contactos, ['id', 'tmp', 'name']);

	var temp = {
		"areaEspecialidad": form.expAreas,
		"comentarios": form.commentaries,
		contactos: contactos,
		"createdBy": sessionStorage.uid,
		"createdDate": new Date().toISOString(),
		"deleted": false,
		"documentosConsultor": form.documentosConsultor,
		"domicilio": {
			"calle": form.street,
			"deleted": false,
			"entreCalle1": form.bstreet1,
			"entreCalle2": form.bstreet2,
			"idCiudad": form.city,
			"idCodigoPostal": form.cp,
			"idColonia": form.colony,
			"idEstado": form.state,
			"idMunicipioDelegacion": form.town,
			"numeroExterior": form.numext,
			"numeroInterior": form.numint,
			"referencia": form.reference,
			"tipoDomicilio": "Fiscal"
		},
		"email": form.mail,
		"estatus": form.status == 2 ? 'I' : 'A',
		"experiencia": form.experience,
		"extension": form.ext,
		"lastModifiedBy": null,
		"lastModifiedDate": null,
		"paginaWeb": form.website,
		"razonSocial": form.razonSocial,
		"siglas": form.acronym,
		"telefono": form.telefono
	};

	return function (dispatch) {

		dispatch((0, _Loading.isLoading)(true));

		return new _ClientHttpRequest2.default({
			service: 'api/newConsultant',
			method: "POST",
			data: temp,
			headers: Object.assign({ "Authorization": sessionStorage.access_token, "uid": sessionStorage.uid })
		}).request().then(function (response) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch({ type: ACTION_UPDATE_CONSULTANT, Obj: _extends({}, form, { id: response.data.id }) });
			return response.data;
		}).catch(function (error) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
			throw error;
		});
	};
};

var searchConsultant = exports.searchConsultant = function searchConsultant(form) {

	var temp = {
		razonSocial: form.razonSocial || '',
		siglas: form.siglas || '',
		deleted: form.deleted === 1 ? false : form.deleted === 2 ? true : null
	};

	return function (dispatch) {

		dispatch((0, _Loading.isLoading)(true));

		return new _ClientHttpRequest2.default({
			service: 'api/searchConsultant',
			method: "POST",
			data: _extends({}, temp),
			headers: Object.assign({ "Authorization": sessionStorage.access_token, "uid": sessionStorage.uid })
		}).request().then(function (response) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch({ type: ACTION_SEARCH_CONSULTANT, Obj: response.data });
			return response.data;
		}).catch(function (error) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
			throw error;
		});
	};
};

var getConsultant = exports.getConsultant = function getConsultant(id) {

	return function (dispatch) {

		dispatch((0, _Loading.isLoading)(true));

		return new _ClientHttpRequest2.default({
			service: 'api/getConsultant',
			method: "POST",
			data: { id: id },
			headers: Object.assign({ "Authorization": sessionStorage.access_token, "uid": sessionStorage.uid })
		}).request().then(function (response) {
			dispatch((0, _Loading.isLoading)(false));

			var data = response.data;

			var contactos = [];

			if (data.contactos !== null) {

				contactos = data.contactos.map(function (c) {
					return _extends({}, c, { name: c.nombre + ' ' + c.apellidoPaterno + ' ' + c.apellidoMaterno });
				});
				contactos = contactos.filter(function (c) {
					return !c.deleted;
				});
			}

			var temp = {
				id: data.id,
				razonSocial: data.razonSocial,
				acronym: data.siglas,
				status: !data.deleted ? 1 : 2,
				telefono: data.telefono,
				ext: data.extension,
				mail: data.email,
				website: data.paginaWeb,
				cp: data.domicilio.codigoPostal.id,
				state: data.domicilio.estados.id,
				town: data.domicilio.municipioDelegacion.id,
				city: data.domicilio.ciudad.id,
				colony: data.domicilio.colonia.id,
				street: data.domicilio.calle,
				numext: data.domicilio.numeroExterior,
				numint: data.domicilio.numeroInterior,
				bstreet1: data.domicilio.entreCalle1,
				bstreet2: data.domicilio.entreCalle2,
				reference: data.domicilio.referencia,
				commentaries: data.comentarios,
				experience: data.experiencia,
				expAreas: data.areaEspecialidad,
				contactos: contactos,
				documentosConsultor: data.documentosConsultor.filter(function (d) {
					return !d.deleted;
				})
			};

			dispatch({ type: ACTION_GET_CONSULTANT, Obj: temp });
			return response.data;
		}).catch(function (error) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
			throw error;
		});
	};
};

var updateConsultant = exports.updateConsultant = function updateConsultant(form) {
	var data = Object.assign({}, form);

	data.contactos = data.contactos.map(function (c) {
		if (c.tmp) {
			delete c.id;
			delete c.tmp;
			delete c.name;
		}
		return c;
	});

	// data.contactos = Utils.getListPropsOmit(data.contactos, ['tmp','name'])
	data.contactos = Utils.unionArray(data.contactos, data.contactosRemove);

	var contactos = data.contactos.map(function (c) {
		delete c.name;
		return _extends({}, c);
	});

	var temp = {
		"id": form.id,
		"areaEspecialidad": form.expAreas,
		"comentarios": form.commentaries,
		contactos: contactos,
		"deleted": form.status == 2,
		"documentosConsultor": form.documentosConsultor,
		"domicilio": {
			"calle": form.street,
			"deleted": false,
			"entreCalle1": form.bstreet1,
			"entreCalle2": form.bstreet2,
			"idCiudad": form.city,
			"idCodigoPostal": form.cp,
			"idColonia": form.colony,
			"idEstado": form.state,
			"idMunicipioDelegacion": form.town,
			"numeroExterior": form.numext,
			"numeroInterior": form.numint,
			"referencia": form.reference
		},
		"email": form.mail,
		"estatus": form.status == 2 ? 'I' : 'A',
		"experiencia": form.experience,
		"extension": form.ext,
		"lastModifiedBy": sessionStorage.uid,
		"lastModifiedDate": new Date().toISOString(),
		"paginaWeb": form.website,
		"razonSocial": form.razonSocial,
		"siglas": form.acronym,
		"telefono": form.telefono
	};

	return function (dispatch) {

		dispatch((0, _Loading.isLoading)(true));

		return new _ClientHttpRequest2.default({
			service: 'api/setConsultant',
			method: "POST",
			data: temp,
			headers: Object.assign({ "Authorization": sessionStorage.access_token, "uid": sessionStorage.uid })
		}).request().then(function (response) {
			dispatch((0, _Loading.isLoading)(false));
			return response.data;
		}).catch(function (error) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
			throw error;
		});
	};
};

var updateConsultantDoc = exports.updateConsultantDoc = function updateConsultantDoc(form) {

	return function (dispatch) {

		dispatch((0, _Loading.isLoading)(true));

		return new _ClientHttpRequest2.default({
			service: 'api/setConsultantDoc',
			method: "POST",
			data: form,
			headers: Object.assign({ "Authorization": sessionStorage.access_token, "uid": sessionStorage.uid })
		}).request().then(function (response) {
			dispatch((0, _Loading.isLoading)(false));
			return response.data;
		}).catch(function (error) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
			throw error;
		});
	};
};

var clearConsultant = exports.clearConsultant = function clearConsultant() {
	return function (dispatch) {
		dispatch({ type: ACTION_GET_CONSULTANT, Obj: {} });
		dispatch({ type: ACTION_SEARCH_CONSULTANT, Obj: [] });
		return Promise.resolve();
	};
};

/***/ }),

/***/ 446:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.setPath = exports.clearEvaluationVariable = exports.setEvaluationVariableInfo = exports.getEvaluationVariableInfo = exports.setEvaluationVariable = exports.getEvaluationVariable = exports.ACTION_SET_PATH = exports.ACTION_GET_GENERAL_INFO = exports.ACTION_GET_VARIABLE = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _Utils = __webpack_require__(2);

var Utils = _interopRequireWildcard(_Utils);

var _immutable = __webpack_require__(1);

var _immutable2 = _interopRequireDefault(_immutable);

var _ClientHttpRequest = __webpack_require__(5);

var _ClientHttpRequest2 = _interopRequireDefault(_ClientHttpRequest);

var _Modal = __webpack_require__(4);

var _Loading = __webpack_require__(3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var initialState = _immutable2.default.Map({}).set('Get', new _immutable2.default.Map({})).set('Info', new _immutable2.default.Map({})).set('Path', new _immutable2.default.Map({ path: "" }));

/* Types */
var ACTION_GET_VARIABLE = exports.ACTION_GET_VARIABLE = 'ACTION_GET_VARIABLE';

var ACTION_GET_GENERAL_INFO = exports.ACTION_GET_GENERAL_INFO = 'ACTION_GET_GENERAL_INFO';

var ACTION_SET_PATH = exports.ACTION_SET_PATH = 'ACTION_SET_PATH';
/* Reducer */

exports.default = function () {
	var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	var action = arguments[1];


	switch (action.type) {
		case ACTION_GET_VARIABLE:
			return state.set('Get', new _immutable2.default.Map(action.Obj));
		case ACTION_GET_GENERAL_INFO:
			return state.set('Info', new _immutable2.default.Map(action.Obj));
		case ACTION_SET_PATH:
			return state.set('Path', new _immutable2.default.Map(action.Obj));
		default:
			return state;
	}
};

/* Action Creators */


var getEvaluationVariable = exports.getEvaluationVariable = function getEvaluationVariable(form) {

	return function (dispatch) {

		dispatch((0, _Loading.isLoading)(true));

		return new _ClientHttpRequest2.default({
			service: 'api/getEvaluationVariable',
			method: "POST",
			data: _extends({}, form),
			headers: Object.assign({ "Authorization": sessionStorage.access_token, "uid": sessionStorage.uid })
		}).request().then(function (response) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch({ type: ACTION_GET_VARIABLE, Obj: response.data });
		}).catch(function (error) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
			throw error;
		});
	};
};

var setEvaluationVariable = exports.setEvaluationVariable = function setEvaluationVariable(form) {

	var idEvaluacion = form.idEvaluacion;
	delete form.idEvaluacion;

	var data = Object.assign({ idEvaluacion: idEvaluacion, usuario: sessionStorage.uid }, form);

	return function (dispatch) {

		dispatch((0, _Loading.isLoading)(true));

		return new _ClientHttpRequest2.default({
			service: 'api/setEvaluationVariable',
			method: "POST",
			data: _extends({}, data),
			headers: Object.assign({ "Authorization": sessionStorage.access_token, "uid": sessionStorage.uid })
		}).request().then(function (response) {
			dispatch((0, _Loading.isLoading)(false));
			return response.data;
		}).catch(function (error) {
			dispatch((0, _Loading.isLoading)(false));
			if (error.response.data.message && error.response.data.message === 'Error de conectividad') return;
			dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
			throw error;
		});
	};
};

/* Action Creators */
var getEvaluationVariableInfo = exports.getEvaluationVariableInfo = function getEvaluationVariableInfo(form) {

	return function (dispatch) {

		dispatch((0, _Loading.isLoading)(true));

		return new _ClientHttpRequest2.default({
			service: 'api/getEvaluationVariableInfo',
			method: "POST",
			data: _extends({}, form),
			headers: Object.assign({ "Authorization": sessionStorage.access_token, "uid": sessionStorage.uid })
		}).request().then(function (response) {
			dispatch({ type: ACTION_GET_GENERAL_INFO, Obj: response.data });
			dispatch((0, _Loading.isLoading)(false));
		}).catch(function (error) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
			throw error;
		});
	};
};

var setEvaluationVariableInfo = exports.setEvaluationVariableInfo = function setEvaluationVariableInfo(form) {

	return function (dispatch) {

		dispatch((0, _Loading.isLoading)(true));

		return new _ClientHttpRequest2.default({
			service: 'api/setEvaluationVariableInfo',
			method: "POST",
			data: _extends({}, form),
			headers: Object.assign({ "Authorization": sessionStorage.access_token, "uid": sessionStorage.uid })
		}).request().then(function (response) {
			dispatch((0, _Loading.isLoading)(false));
			return response.data;
		}).catch(function (error) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
			throw error;
		});
	};
};

var clearEvaluationVariable = exports.clearEvaluationVariable = function clearEvaluationVariable() {
	return function (dispatch) {
		dispatch({ type: ACTION_GET_VARIABLE, Obj: {} });
		dispatch({ type: ACTION_GET_GENERAL_INFO, Obj: {} });
	};
};

var setPath = exports.setPath = function setPath(path) {
	return function (dispatch) {
		dispatch({ type: ACTION_SET_PATH, Obj: { path: path } });
	};
};

/***/ }),

/***/ 447:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.clearGranteeEvaluations = exports.clearCorrida = exports.setIdCorrida = exports.getGranteeEvaluations = exports.getEvaluations = exports.GET_GRANTEE_EVALUATIONS = exports.SET_EVALUATION = exports.GET_EVALUATIONS = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _Utils = __webpack_require__(2);

var Utils = _interopRequireWildcard(_Utils);

var _ClientHttpRequest = __webpack_require__(5);

var _ClientHttpRequest2 = _interopRequireDefault(_ClientHttpRequest);

var _immutable = __webpack_require__(1);

var _immutable2 = _interopRequireDefault(_immutable);

var _Modal = __webpack_require__(4);

var _Loading = __webpack_require__(3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var initialState = _immutable2.default.Map({}).set('Get', new _immutable2.default.List([])).set('Response', new _immutable2.default.Map({})).set('Search', new _immutable2.default.Map({ evaluaciones: { evaluacion: [] } }));

/* Types */
var GET_EVALUATIONS = exports.GET_EVALUATIONS = 'GET_EVALUATIONS';
var SET_EVALUATION = exports.SET_EVALUATION = 'SET_EVALUATION';
var GET_GRANTEE_EVALUATIONS = exports.GET_GRANTEE_EVALUATIONS = 'GET_GRANTEE_EVALUATIONS';

/* Reducer */

exports.default = function () {
	var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	var action = arguments[1];


	switch (action.type) {
		case GET_EVALUATIONS:
			return state.set('Get', new _immutable2.default.List(action.Obj));
		case SET_EVALUATION:
			return state.set('Response', new _immutable2.default.Map(action.Obj));
		case GET_GRANTEE_EVALUATIONS:
			return state.set('Search', new _immutable2.default.Map(action.Obj));
		default:
			return state;
	}
};

/* Action Creators */

var getEvaluations = exports.getEvaluations = function getEvaluations(form) {

	return function (dispatch) {

		dispatch((0, _Loading.isLoading)(true));

		return new _ClientHttpRequest2.default({
			service: 'api/getOportunities',
			method: "POST",
			data: _extends({}, form),
			headers: Object.assign({ "Authorization": sessionStorage.access_token, "uid": sessionStorage.uid })
		}).request().then(function (response) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch({ type: GET_EVALUATIONS, Obj: response.data });
		}).catch(function (error) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
			throw error;
		});
	};
};

var getGranteeEvaluations = exports.getGranteeEvaluations = function getGranteeEvaluations(form) {

	return function (dispatch) {

		dispatch((0, _Loading.isLoading)(true));

		return new _ClientHttpRequest2.default({
			service: 'api/getGranteeEvaluations',
			method: "POST",
			data: _extends({}, form),
			headers: Object.assign({ "Authorization": sessionStorage.access_token, "uid": sessionStorage.uid })
		}).request().then(function (response) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch({ type: GET_GRANTEE_EVALUATIONS, Obj: response.data });
		}).catch(function (error) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
			throw error;
		});
	};
};

var setIdCorrida = exports.setIdCorrida = function setIdCorrida(id) {
	return function (dispatch) {
		dispatch({ type: SET_EVALUATION, Obj: { idCorrida: id } });
	};
};

var clearCorrida = exports.clearCorrida = function clearCorrida() {
	return function (dispatch) {
		dispatch({ type: SET_EVALUATION, Obj: {} });
		return Promise.resolve();
	};
};

var clearGranteeEvaluations = exports.clearGranteeEvaluations = function clearGranteeEvaluations() {
	return function (dispatch) {
		dispatch({ type: GET_GRANTEE_EVALUATIONS, Obj: {} });
		return Promise.resolve();
	};
};

/***/ }),

/***/ 451:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.clearApproach = exports.updateApproach = exports.deleteApproach = exports.getApproach = exports.searchApproach = exports.addApproach = exports.ACTION_UPDATE_APPROACH = exports.ACTION_DELETE_APPROACH = exports.ACTION_GET_APPROACH = exports.ACTION_SEARCH_APPROACH = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _Utils = __webpack_require__(2);

var Utils = _interopRequireWildcard(_Utils);

var _ClientHttpRequest = __webpack_require__(5);

var _ClientHttpRequest2 = _interopRequireDefault(_ClientHttpRequest);

var _immutable = __webpack_require__(1);

var _immutable2 = _interopRequireDefault(_immutable);

var _Modal = __webpack_require__(4);

var _Loading = __webpack_require__(3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var initialState = _immutable2.default.Map({}).set('Search', new _immutable2.default.List([])).set('Response', new _immutable2.default.Map({})).set('Get', new _immutable2.default.Map({}));

/* Types */
var ACTION_SEARCH_APPROACH = exports.ACTION_SEARCH_APPROACH = 'ACTION_SEARCH_APPROACH';

var ACTION_GET_APPROACH = exports.ACTION_GET_APPROACH = 'ACTION_GET_APPROACH';

var ACTION_DELETE_APPROACH = exports.ACTION_DELETE_APPROACH = 'ACTION_DELETE_APPROACH';

var ACTION_UPDATE_APPROACH = exports.ACTION_UPDATE_APPROACH = 'ACTION_UPDATE_APPROACH';

/* Reducer */

exports.default = function () {
	var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	var action = arguments[1];


	switch (action.type) {

		case ACTION_SEARCH_APPROACH:
			return state.set('Search', new _immutable2.default.List(action.Obj));
		case ACTION_GET_APPROACH:
			return state.set('Get', new _immutable2.default.Map(action.Obj));
		case ACTION_DELETE_APPROACH:
			return state.set('Response', new _immutable2.default.Map(action.Obj));
		case ACTION_UPDATE_APPROACH:
			return state.set('Response', new _immutable2.default.Map(action.Obj));
		default:
			return state;
	}
};

/* Action Creators */

var addApproach = exports.addApproach = function addApproach(form) {

	return function (dispatch) {

		dispatch((0, _Loading.isLoading)(true));

		return new _ClientHttpRequest2.default({
			service: 'api/newApproach',
			method: "POST",
			data: _extends({}, form),
			headers: Object.assign({ "Authorization": sessionStorage.access_token, "uid": sessionStorage.uid })
		}).request().then(function () {
			dispatch((0, _Loading.isLoading)(false));
			dispatch((0, _Modal.createModal)(Utils.successMessage()));
		}).catch(function (error) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
			throw error;
		});
	};
};

var searchApproach = exports.searchApproach = function searchApproach(form) {

	Utils.clearNullAndEmpty(form);

	return function (dispatch) {

		dispatch((0, _Loading.isLoading)(true));

		return new _ClientHttpRequest2.default({
			service: Object.keys(form).length == 0 ? 'api/searchApproach' : 'api/searchParamApproach',
			method: "POST",
			data: _extends({}, form),
			headers: Object.assign({ "Authorization": sessionStorage.access_token, "uid": sessionStorage.uid })
		}).request().then(function (response) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch({ type: ACTION_SEARCH_APPROACH, Obj: response.data });
		}).catch(function (error) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
			throw error;
		});
	};
};

var getApproach = exports.getApproach = function getApproach(id) {

	return function (dispatch) {

		dispatch((0, _Loading.isLoading)(true));

		return new _ClientHttpRequest2.default({
			service: 'api/getApproach',
			method: "POST",
			data: { id: id },
			headers: Object.assign({ "Authorization": sessionStorage.access_token, "uid": sessionStorage.uid })
		}).request().then(function (response) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch({ type: ACTION_GET_APPROACH, Obj: response.data });
		}).catch(function (error) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
			throw error;
		});
	};
};

var deleteApproach = exports.deleteApproach = function deleteApproach() {
	return function (dispatch) {
		return dispatch({ type: ACTION_DELETE_APPROACH, Obj: { code: '', message: '' } });
	};
};

var updateApproach = exports.updateApproach = function updateApproach(form) {

	return function (dispatch) {

		dispatch((0, _Loading.isLoading)(true));
		dispatch({ type: ACTION_GET_APPROACH, Obj: {} });

		return new _ClientHttpRequest2.default({
			service: 'api/updateApproach',
			method: "POST",
			data: _extends({}, form),
			headers: Object.assign({ "Authorization": sessionStorage.access_token, "uid": sessionStorage.uid })
		}).request().then(function (response) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch({ type: ACTION_UPDATE_APPROACH, Obj: response.data });
			dispatch((0, _Modal.createModal)(Utils.successMessage()));
		}).catch(function (error) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
			throw error;
		});
	};
};

var clearApproach = exports.clearApproach = function clearApproach() {
	return function (dispatch) {
		dispatch({ type: ACTION_GET_APPROACH, Obj: {} });
		dispatch({ type: ACTION_SEARCH_APPROACH, Obj: [] });
	};
};

/***/ }),

/***/ 452:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.getSetDonataria = exports.sendMailFilterAssignment = exports.setVaribleToPopUp = exports.updateFilterAssignment = exports.searchFilterAssignment = exports.getStateJustificacion = exports.getCauseNegation = exports.getResultAssignment = exports.getCriterios = exports.getCorridasAbiertas = exports.ACTION_GET_SET_FILTER = exports.ACTION_SEND_ASSIGNMENT_FILTER = exports.ACTION_SET_VARIABLE_POPUP = exports.ACTION_UPDATE_ASSIGNMENT_FILTER = exports.ACTION_SEARCH_FILTER = exports.ACTION_GET_STATE_JUSTIFICACION = exports.ACTION_GET_CAUSE_NEGATION = exports.ACTION_GET_RESULT_ASSIGNMENT = exports.ACTION_GET_CRITERIOS = exports.ACTION_GET_CORRIDAS_ABIERTAS = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _Utils = __webpack_require__(2);

var Utils = _interopRequireWildcard(_Utils);

var _ClientHttpRequest = __webpack_require__(5);

var _ClientHttpRequest2 = _interopRequireDefault(_ClientHttpRequest);

var _immutable = __webpack_require__(1);

var _immutable2 = _interopRequireDefault(_immutable);

var _Modal = __webpack_require__(4);

var _Loading = __webpack_require__(3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var initialState = _immutable2.default.Map({}).set('Response', new _immutable2.default.Map({})).set('Search', new _immutable2.default.List([])).set('GetCorridasAbiertas', new _immutable2.default.List([])).set('GetCriterios', new _immutable2.default.List([])).set('GetResultAssignment', new _immutable2.default.List([])).set('GetCauseNegation', new _immutable2.default.List([])).set('GetStateJustificacion', new _immutable2.default.List([])).set('Mail', new _immutable2.default.Map({})).set('Donataria', new _immutable2.default.Map({}));

/* Types */

var ACTION_GET_CORRIDAS_ABIERTAS = exports.ACTION_GET_CORRIDAS_ABIERTAS = 'ACTION_GET_CORRIDAS_ABIERTAS';

var ACTION_GET_CRITERIOS = exports.ACTION_GET_CRITERIOS = 'ACTION_GET_CRITERIOS';

var ACTION_GET_RESULT_ASSIGNMENT = exports.ACTION_GET_RESULT_ASSIGNMENT = 'ACTION_GET_RESULT_ASSIGNMENT';

var ACTION_GET_CAUSE_NEGATION = exports.ACTION_GET_CAUSE_NEGATION = 'ACTION_GET_CAUSE_NEGATION';

var ACTION_GET_STATE_JUSTIFICACION = exports.ACTION_GET_STATE_JUSTIFICACION = 'ACTION_GET_STATE_JUSTIFICACION';

var ACTION_SEARCH_FILTER = exports.ACTION_SEARCH_FILTER = 'ACTION_SEARCH_FILTER';

var ACTION_UPDATE_ASSIGNMENT_FILTER = exports.ACTION_UPDATE_ASSIGNMENT_FILTER = 'ACTION_UPDATE_ASSIGNMENT_FILTER';

var ACTION_SET_VARIABLE_POPUP = exports.ACTION_SET_VARIABLE_POPUP = 'ACTION_SET_VARIABLE_POPUP';

var ACTION_SEND_ASSIGNMENT_FILTER = exports.ACTION_SEND_ASSIGNMENT_FILTER = 'ACTION_SEND_ASSIGNMENT_FILTER';

var ACTION_GET_SET_FILTER = exports.ACTION_GET_SET_FILTER = 'ACTION_GET_SET_FILTER';

/* Reducer */

exports.default = function () {
	var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	var action = arguments[1];


	switch (action.type) {
		case ACTION_GET_CORRIDAS_ABIERTAS:
			return state.set('GetCorridasAbiertas', new _immutable2.default.List(action.Obj));
		case ACTION_GET_CRITERIOS:
			return state.set('GetCriterios', new _immutable2.default.List(action.Obj));
		case ACTION_GET_RESULT_ASSIGNMENT:
			return state.set('GetResultAssignment', new _immutable2.default.List(action.Obj));
		case ACTION_GET_CAUSE_NEGATION:
			return state.set('GetCauseNegation', new _immutable2.default.List(action.Obj));
		case ACTION_GET_STATE_JUSTIFICACION:
			return state.set('GetStateJustificacion', new _immutable2.default.List(action.Obj));

		case ACTION_SET_VARIABLE_POPUP:
			return state.set('VariablePopUp', new _immutable2.default.Map(action.Obj));

		case ACTION_SEARCH_FILTER:
			return state.set('Search', new _immutable2.default.List(action.Obj));

		case ACTION_UPDATE_ASSIGNMENT_FILTER:
			return state.set('Response', new _immutable2.default.Map(action.Obj));

		case ACTION_SEND_ASSIGNMENT_FILTER:
			return state.set('Mail', new _immutable2.default.Map(action.Obj));

		case ACTION_GET_SET_FILTER:
			return state.set('Donataria', new _immutable2.default.Map(action.Obj));

		default:
			return state;
	}
};

/* Action Creators */

var getCorridasAbiertas = exports.getCorridasAbiertas = function getCorridasAbiertas() {

	return function (dispatch) {

		dispatch((0, _Loading.isLoading)(true));

		return new _ClientHttpRequest2.default({
			service: 'api/getCorridasAbiertas',
			method: "POST",
			data: {},
			headers: Object.assign({ "Authorization": sessionStorage.access_token, "uid": sessionStorage.uid })
		}).request().then(function (response) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch({ type: ACTION_GET_CORRIDAS_ABIERTAS, Obj: response.data });
			return response.data;
		}).catch(function (error) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
			throw error;
		});
	};
};

var getCriterios = exports.getCriterios = function getCriterios() {

	return function (dispatch) {

		dispatch((0, _Loading.isLoading)(true));

		return new _ClientHttpRequest2.default({
			service: 'api/getCriterios',
			method: "POST",
			data: {},
			headers: Object.assign({ "Authorization": sessionStorage.access_token, "uid": sessionStorage.uid })
		}).request().then(function (response) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch({ type: ACTION_GET_CRITERIOS, Obj: response.data });
		}).catch(function (error) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
			throw error;
		});
	};
};

var getResultAssignment = exports.getResultAssignment = function getResultAssignment() {

	return function (dispatch) {

		dispatch((0, _Loading.isLoading)(true));

		return new _ClientHttpRequest2.default({
			service: 'api/getResultAssignment',
			method: "POST",
			data: {},
			headers: Object.assign({ "Authorization": sessionStorage.access_token, "uid": sessionStorage.uid })
		}).request().then(function (response) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch({ type: ACTION_GET_RESULT_ASSIGNMENT, Obj: response.data });
		}).catch(function (error) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
			throw error;
		});
	};
};

var getCauseNegation = exports.getCauseNegation = function getCauseNegation() {

	return function (dispatch) {

		dispatch((0, _Loading.isLoading)(true));

		return new _ClientHttpRequest2.default({
			service: 'api/getCauseNegation',
			method: "POST",
			data: {},
			headers: Object.assign({ "Authorization": sessionStorage.access_token, "uid": sessionStorage.uid })
		}).request().then(function (response) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch({ type: ACTION_GET_CAUSE_NEGATION, Obj: response.data });
		}).catch(function (error) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
			throw error;
		});
	};
};

var getStateJustificacion = exports.getStateJustificacion = function getStateJustificacion() {

	return function (dispatch) {

		dispatch((0, _Loading.isLoading)(true));

		return new _ClientHttpRequest2.default({
			service: 'api/getStateJustificacion',
			method: "POST",
			data: {},
			headers: Object.assign({ "Authorization": sessionStorage.access_token, "uid": sessionStorage.uid })
		}).request().then(function (response) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch({ type: ACTION_GET_STATE_JUSTIFICACION, Obj: response.data });
		}).catch(function (error) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
			throw error;
		});
	};
};

var searchFilterAssignment = exports.searchFilterAssignment = function searchFilterAssignment(form) {

	return function (dispatch) {

		dispatch((0, _Loading.isLoading)(true));

		var formAux = Object.assign({}, form);
		delete formAux.dataFiltros;

		return new _ClientHttpRequest2.default({
			service: 'api/searchFilterAssignment',
			method: "POST",
			data: _extends({}, formAux),
			headers: Object.assign({ "Authorization": sessionStorage.access_token, "uid": sessionStorage.uid })
		}).request().then(function (response) {
			dispatch((0, _Loading.isLoading)(false));

			dispatch({ type: ACTION_SEARCH_FILTER, Obj: response.data });

			return response.data;
		}).catch(function (error) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
			throw error;
		});
	};
};

var updateFilterAssignment = exports.updateFilterAssignment = function updateFilterAssignment(form) {

	return function (dispatch) {

		dispatch((0, _Loading.isLoading)(true));

		var formAux = Object.assign({}, form);
		delete formAux.dataFiltros;

		return new _ClientHttpRequest2.default({
			service: 'api/updateFilterAssignment',
			method: "POST",
			data: _extends({}, formAux),
			headers: Object.assign({ "Authorization": sessionStorage.access_token, "uid": sessionStorage.uid })
		}).request().then(function (response) {
			dispatch((0, _Loading.isLoading)(false));

			dispatch({ type: ACTION_UPDATE_ASSIGNMENT_FILTER, Obj: response.data });
			return true;
		}).catch(function (error) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
			throw error;
		});
	};
};

var setVaribleToPopUp = exports.setVaribleToPopUp = function setVaribleToPopUp(data) {

	return function (dispatch) {
		dispatch({ type: ACTION_SET_VARIABLE_POPUP, Obj: data });
		return data;
	};
};

var sendMailFilterAssignment = exports.sendMailFilterAssignment = function sendMailFilterAssignment(form) {
	delete form.dataFiltros;
	return function (dispatch) {

		dispatch((0, _Loading.isLoading)(true));

		return new _ClientHttpRequest2.default({
			service: 'api/sendMailFilterAssignment',
			method: "POST",
			data: _extends({}, form),
			headers: Object.assign({ "Authorization": sessionStorage.access_token, "Bpm": sessionStorage.bpm_token, "uid": sessionStorage.uid })
		}).request().then(function (response) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse('Hubo un error al activar la evaluación'))));
			//dispatch({ type: ACTION_SEND_ASSIGNMENT_FILTER, Obj: response.data })
			return true;
		}).catch(function (error) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
			throw error;
		});
	};
};

var getSetDonataria = exports.getSetDonataria = function getSetDonataria(form) {
	return function (dispatch) {
		dispatch({ type: ACTION_GET_SET_FILTER, Obj: form });
		var promise = new Promise(function (resolve) {
			resolve(form);
		});
		return promise;
	};
};

/***/ }),

/***/ 453:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.clearDocName = exports.updateDocName = exports.getDocName = exports.searchDocName = exports.addDocName = exports.ACTION_UPDATE_DOC_NAME = exports.ACTION_DELETE_DOC_NAME = exports.ACTION_GET_DOC_NAME_CATALOG = exports.ACTION_SEARCH_DOC_NAME = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _Utils = __webpack_require__(2);

var Utils = _interopRequireWildcard(_Utils);

var _ClientHttpRequest = __webpack_require__(5);

var _ClientHttpRequest2 = _interopRequireDefault(_ClientHttpRequest);

var _immutable = __webpack_require__(1);

var _immutable2 = _interopRequireDefault(_immutable);

var _Modal = __webpack_require__(4);

var _Loading = __webpack_require__(3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var initialState = _immutable2.default.Map({}).set('Search', new _immutable2.default.List([])).set('Response', new _immutable2.default.Map({})).set('Get', new _immutable2.default.Map({}));

/* Types */
var ACTION_SEARCH_DOC_NAME = exports.ACTION_SEARCH_DOC_NAME = 'ACTION_SEARCH_DOC_NAME';
var ACTION_GET_DOC_NAME_CATALOG = exports.ACTION_GET_DOC_NAME_CATALOG = 'ACTION_GET_DOC_NAME_CATALOG';
var ACTION_DELETE_DOC_NAME = exports.ACTION_DELETE_DOC_NAME = 'ACTION_DELETE_DOC_NAME';
var ACTION_UPDATE_DOC_NAME = exports.ACTION_UPDATE_DOC_NAME = 'ACTION_UPDATE_DOC_NAME';

/* Reducer */

exports.default = function () {
	var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	var action = arguments[1];

	switch (action.type) {
		case ACTION_SEARCH_DOC_NAME:
			return state.set('Search', new _immutable2.default.List(action.Obj));
		case ACTION_GET_DOC_NAME_CATALOG:
			return state.set('Get', new _immutable2.default.Map(action.Obj));
		case ACTION_DELETE_DOC_NAME:
			return state.set('Response', new _immutable2.default.Map(action.Obj));
		case ACTION_UPDATE_DOC_NAME:
			return state.set('Response', new _immutable2.default.Map(action.Obj));
		default:
			return state;
	}
};

/* Action Creators */

var addDocName = exports.addDocName = function addDocName(form) {

	return function (dispatch) {

		dispatch((0, _Loading.isLoading)(true));

		return new _ClientHttpRequest2.default({
			service: 'api/newDocName',
			method: "POST",
			data: _extends({}, form),
			headers: Object.assign({ "Authorization": sessionStorage.access_token, "uid": sessionStorage.uid })
		}).request().then(function () {
			dispatch((0, _Loading.isLoading)(false));
			dispatch((0, _Modal.createModal)(Utils.successMessage()));
		}).catch(function (error) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
			throw error;
		});
	};
};

var searchDocName = exports.searchDocName = function searchDocName(form) {

	return function (dispatch) {

		dispatch((0, _Loading.isLoading)(true));

		return new _ClientHttpRequest2.default({
			service: Object.keys(form).length == 0 ? 'api/searchDocName' : 'api/searchParamDocName',
			method: "POST",
			data: _extends({}, form),
			headers: Object.assign({ "Authorization": sessionStorage.access_token, "uid": sessionStorage.uid })
		}).request().then(function (response) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch({ type: ACTION_SEARCH_DOC_NAME, Obj: response.data });
		}).catch(function (error) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
			throw error;
		});
	};
};

var getDocName = exports.getDocName = function getDocName(id) {

	return function (dispatch) {

		dispatch((0, _Loading.isLoading)(true));

		return new _ClientHttpRequest2.default({
			service: 'api/getDocName',
			method: "POST",
			data: { id: id },
			headers: Object.assign({ "Authorization": sessionStorage.access_token, "uid": sessionStorage.uid })
		}).request().then(function (response) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch({ type: ACTION_GET_DOC_NAME_CATALOG, Obj: response.data });
		}).catch(function (error) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
			throw error;
		});
	};
};

var updateDocName = exports.updateDocName = function updateDocName(form) {

	return function (dispatch) {

		dispatch((0, _Loading.isLoading)(true));

		return new _ClientHttpRequest2.default({
			service: 'api/updateDocName',
			method: "POST",
			data: _extends({}, form),
			headers: Object.assign({ "Authorization": sessionStorage.access_token, "uid": sessionStorage.uid })
		}).request().then(function (response) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch({ type: ACTION_UPDATE_DOC_NAME, Obj: response.data });
			dispatch((0, _Modal.createModal)(Utils.successMessage()));
		}).catch(function (error) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
			throw error;
		});
	};
};

var clearDocName = exports.clearDocName = function clearDocName() {
	return function (dispatch) {
		dispatch({ type: ACTION_GET_DOC_NAME_CATALOG, Obj: {} });
		dispatch({ type: ACTION_SEARCH_DOC_NAME, Obj: [] });
	};
};

/***/ }),

/***/ 454:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.clearEligibilityCriteria = exports.deleteEligibilityCriteria = exports.updateEligibilityCriteria = exports.newEligibilityCriteria = exports.getEligibilityCriteria = exports.searchEligibilityCriteria = exports.ACTION_UPDATE_ELIGIBILITY_CRITERIA = exports.ACTION_DELETE_ELIGIBILITY_CRITERIA = exports.ACTION_SEARCH_ELIGIBILITY_CRITERIA = exports.ACTION_GET_ELIGIBILITY_CRITERIA = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _Utils = __webpack_require__(2);

var Utils = _interopRequireWildcard(_Utils);

var _ClientHttpRequest = __webpack_require__(5);

var _ClientHttpRequest2 = _interopRequireDefault(_ClientHttpRequest);

var _immutable = __webpack_require__(1);

var _immutable2 = _interopRequireDefault(_immutable);

var _Modal = __webpack_require__(4);

var _Loading = __webpack_require__(3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var initialState = _immutable2.default.Map({}).set('Search', new _immutable2.default.List([])).set('Response', new _immutable2.default.Map({})).set('Get', new _immutable2.default.Map({}));

/* Types */

var ACTION_GET_ELIGIBILITY_CRITERIA = exports.ACTION_GET_ELIGIBILITY_CRITERIA = 'ACTION_GET_ELIGIBILITY_CRITERIA';
var ACTION_SEARCH_ELIGIBILITY_CRITERIA = exports.ACTION_SEARCH_ELIGIBILITY_CRITERIA = 'ACTION_SEARCH_ELIGIBILITY_CRITERIA';
var ACTION_DELETE_ELIGIBILITY_CRITERIA = exports.ACTION_DELETE_ELIGIBILITY_CRITERIA = 'ACTION_DELETE_ELIGIBILITY_CRITERIA';
var ACTION_UPDATE_ELIGIBILITY_CRITERIA = exports.ACTION_UPDATE_ELIGIBILITY_CRITERIA = 'ACTION_UPDATE_ELIGIBILITY_CRITERIA';

/* Reducer */

exports.default = function () {
	var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	var action = arguments[1];


	switch (action.type) {
		case ACTION_SEARCH_ELIGIBILITY_CRITERIA:
			return state.set('Search', new _immutable2.default.List(action.Obj));
		case ACTION_GET_ELIGIBILITY_CRITERIA:
			return state.set('Get', new _immutable2.default.Map(action.Obj));
		case ACTION_DELETE_ELIGIBILITY_CRITERIA:
		case ACTION_UPDATE_ELIGIBILITY_CRITERIA:
			return state.set('Response', new _immutable2.default.Map(action.Obj));
		default:
			return state;
	}
};

/* Action Creators */

var searchEligibilityCriteria = exports.searchEligibilityCriteria = function searchEligibilityCriteria(form) {

	Utils.clearNullAndEmpty(form);

	return function (dispatch) {

		dispatch((0, _Loading.isLoading)(true));

		return new _ClientHttpRequest2.default({
			service: 'api/searchEligibilityCriteria',
			method: "POST",
			data: _extends({}, form),
			headers: Object.assign({ "Authorization": sessionStorage.access_token, "uid": sessionStorage.uid })
		}).request().then(function (response) {
			var resp = response.data.map(function (i) {
				if (i.id) {
					i.status = i.deleted ? 2 : 1;
					if (i.tipoEvaluacion && i.tipoEvaluacion.evaluacion) {
						i.evaluacionDesc = i.tipoEvaluacion.evaluacion;
					}
					if (i.variable && i.variable.variable) {
						i.variableDesc = i.variable.variable;
					}
					return i;
				}
			});

			dispatch((0, _Loading.isLoading)(false));
			dispatch({ type: ACTION_SEARCH_ELIGIBILITY_CRITERIA, Obj: resp });
			return response;
		}).catch(function (error) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
			return error;
		});
	};
};

var getEligibilityCriteria = exports.getEligibilityCriteria = function getEligibilityCriteria(form) {

	Utils.clearNullAndEmpty(form);

	return function (dispatch) {

		dispatch((0, _Loading.isLoading)(true));

		return new _ClientHttpRequest2.default({
			service: 'api/getEligibilityCriteria',
			method: "POST",
			data: _extends({}, form),
			headers: Object.assign({ "Authorization": sessionStorage.access_token, "uid": sessionStorage.uid })
		}).request().then(function (response) {
			if (response.data.idCriteriosElegibilidad) {
				response.data.id = response.data.idCriteriosElegibilidad;
				response.data.criterio = response.data.criteriosElegibilidad;
				response.data.status = response.data.deleted ? 2 : 1;
				if (response.data.tipoEvaluacion && response.data.tipoEvaluacion.evaluacion) {
					response.data.evaluacionDesc = response.data.tipoEvaluacion.evaluacion;
				}
				if (response.data.variable && response.data.variable.variable) {
					response.data.variableDesc = response.data.variable.variable;
				}
			}
			dispatch((0, _Loading.isLoading)(false));
			dispatch({ type: ACTION_GET_ELIGIBILITY_CRITERIA, Obj: response.data });
			return response;
		}).catch(function (error) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
			return error;
		});
	};
};

var newEligibilityCriteria = exports.newEligibilityCriteria = function newEligibilityCriteria(form) {

	Utils.clearNullAndEmpty(form);

	var tmp = {
		"autor": sessionStorage.uid,
		"autorUltimaModificacion": "",
		"criterio": form.criterio,
		"cumplimiento": form.cumplimiento,
		"deleted": form.status !== 1,
		"descripcion": form.descripcion,
		"fechaCreacion": new Date().toISOString().slice(0, 10),
		"fechaUltimaModificacion": "",
		"idVariable": form.idVariable,
		"idTipoEvaluacion": form.idTipoEvaluacion,
		"id": form.id,
		"idTipoCriterio": form.idTipoCriterio,
		"regla": form.regla
	};

	return function (dispatch) {

		dispatch((0, _Loading.isLoading)(true));

		return new _ClientHttpRequest2.default({
			service: 'api/newEligibilityCriteria',
			method: "POST",
			data: tmp,
			headers: Object.assign({ "Authorization": sessionStorage.access_token, "uid": sessionStorage.uid })
		}).request().then(function (response) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch({ type: ACTION_UPDATE_ELIGIBILITY_CRITERIA, Obj: response.data });
			return response;
		}).catch(function (error) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
			return error;
		});
	};
};

var updateEligibilityCriteria = exports.updateEligibilityCriteria = function updateEligibilityCriteria(form) {

	Utils.clearNullAndEmpty(form);

	var tmp = {
		"autor": sessionStorage.uid,
		"criterio": form.criterio,
		"cumplimiento": form.cumplimiento,
		"deleted": form.status !== 1,
		"descripcion": form.descripcion,
		"fechaUltimaModificacion": new Date().toISOString().slice(0, 10),
		"idVariable": form.idVariable,
		"idTipoEvaluacion": form.idTipoEvaluacion,
		"id": form.id,
		"idTipoCriterio": form.idTipoCriterio,
		"regla": form.regla
	};

	return function (dispatch) {

		dispatch((0, _Loading.isLoading)(true));

		return new _ClientHttpRequest2.default({
			service: 'api/updateEligibilityCriteria',
			method: "POST",
			data: _extends({}, tmp),
			headers: Object.assign({ "Authorization": sessionStorage.access_token, "uid": sessionStorage.uid })
		}).request().then(function (response) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch({ type: ACTION_UPDATE_ELIGIBILITY_CRITERIA, Obj: response.data });
			return response;
		}).catch(function (error) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
			return error;
		});
	};
};

var deleteEligibilityCriteria = exports.deleteEligibilityCriteria = function deleteEligibilityCriteria(form) {

	Utils.clearNullAndEmpty(form);

	return function (dispatch) {

		dispatch((0, _Loading.isLoading)(true));

		return new _ClientHttpRequest2.default({
			service: 'api/deleteEligibilityCriteria',
			method: "POST",
			data: _extends({}, form),
			headers: Object.assign({ "Authorization": sessionStorage.access_token, "uid": sessionStorage.uid })
		}).request().then(function (response) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch({ type: ACTION_DELETE_ELIGIBILITY_CRITERIA, Obj: response.data });
			return response;
		}).catch(function (error) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
			return error;
		});
	};
};

var clearEligibilityCriteria = exports.clearEligibilityCriteria = function clearEligibilityCriteria() {
	return function (dispatch) {
		dispatch({ type: ACTION_GET_ELIGIBILITY_CRITERIA, Obj: {} });
		dispatch({ type: ACTION_SEARCH_ELIGIBILITY_CRITERIA, Obj: [] });
	};
};

/***/ }),

/***/ 455:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.clearEvalCriteria = exports.saveEvalCriteria = exports.getEvalCriteria = exports.GET_EVAL_CRITERIA = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _Utils = __webpack_require__(2);

var Utils = _interopRequireWildcard(_Utils);

var _immutable = __webpack_require__(1);

var _immutable2 = _interopRequireDefault(_immutable);

var _ClientHttpRequest = __webpack_require__(5);

var _ClientHttpRequest2 = _interopRequireDefault(_ClientHttpRequest);

var _Modal = __webpack_require__(4);

var _Loading = __webpack_require__(3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var initialState = _immutable2.default.Map({}).set('Get', new _immutable2.default.Map({ criterios: [] }));

/* Types */
var GET_EVAL_CRITERIA = exports.GET_EVAL_CRITERIA = 'GET_EVAL_CRITERIA';

/* Reducer */

exports.default = function () {
	var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	var action = arguments[1];


	switch (action.type) {
		case GET_EVAL_CRITERIA:
			return state.set('Get', new _immutable2.default.Map(action.Obj));
		default:
			return state;
	}
};

/* Action Creators */


var getEvalCriteria = exports.getEvalCriteria = function getEvalCriteria(form) {
	return function (dispatch) {
		dispatch((0, _Loading.isLoading)(true));
		return new _ClientHttpRequest2.default({
			service: 'api/getEvalCriteria',
			method: "POST",
			data: _extends({}, form),
			headers: Object.assign({ "Authorization": sessionStorage.access_token, "uid": sessionStorage.uid })
		}).request().then(function (response) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch({ type: GET_EVAL_CRITERIA, Obj: response.data });
			return response.data;
		}).catch(function (error) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
			throw error;
		});
	};
};

var saveEvalCriteria = exports.saveEvalCriteria = function saveEvalCriteria(form) {

	var data = Object.assign({}, form);

	data.criterios = Utils.getListPropsOmit(data.criterios, ['tmp', 'validate']);

	return function (dispatch) {
		dispatch((0, _Loading.isLoading)(true));
		return new _ClientHttpRequest2.default({
			service: 'api/saveEvalCriteria',
			method: "POST",
			data: _extends({}, data),
			headers: Object.assign({ "Authorization": sessionStorage.access_token, "uid": sessionStorage.uid })
		}).request().then(function (response) {
			dispatch((0, _Loading.isLoading)(false));
			return response.data;
		}).catch(function (error) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
			throw error;
		});
	};
};

var clearEvalCriteria = exports.clearEvalCriteria = function clearEvalCriteria() {
	return function (dispatch) {
		dispatch({ type: GET_EVAL_CRITERIA, Obj: {} });
	};
};

/***/ }),

/***/ 456:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.searchGranteeEvaluator = exports.searchEvaluator = exports.ACTION_SEARCH_EVALUATOR_GRANTEE = exports.ACTION_SEARCH_EVALUATOR = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _Utils = __webpack_require__(2);

var Utils = _interopRequireWildcard(_Utils);

var _ClientHttpRequest = __webpack_require__(5);

var _ClientHttpRequest2 = _interopRequireDefault(_ClientHttpRequest);

var _immutable = __webpack_require__(1);

var _immutable2 = _interopRequireDefault(_immutable);

var _Modal = __webpack_require__(4);

var _Loading = __webpack_require__(3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var initialState = _immutable2.default.Map({}).set('Search', new _immutable2.default.List([])).set('SearchGrantee', new _immutable2.default.List([])).set('Response', new _immutable2.default.Map({})).set('Get', new _immutable2.default.Map({}));

/* Types */
var ACTION_SEARCH_EVALUATOR = exports.ACTION_SEARCH_EVALUATOR = 'ACTION_SEARCH_EVALUATOR';

var ACTION_SEARCH_EVALUATOR_GRANTEE = exports.ACTION_SEARCH_EVALUATOR_GRANTEE = 'ACTION_SEARCH_EVALUATOR_GRANTEE';

/* Reducer */

exports.default = function () {
	var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	var action = arguments[1];


	switch (action.type) {
		case ACTION_SEARCH_EVALUATOR:
			return state.set('Search', new _immutable2.default.List(action.Obj));
		case ACTION_SEARCH_EVALUATOR_GRANTEE:
			return state.set('SearchGrantee', new _immutable2.default.List(action.Obj));

		default:
			return state;
	}
};

/* Action Creators */

var searchEvaluator = exports.searchEvaluator = function searchEvaluator(form) {

	return function (dispatch) {

		dispatch((0, _Loading.isLoading)(true));

		return new _ClientHttpRequest2.default({
			service: 'api/searchEvaluator',
			method: "POST",
			data: form,
			headers: Object.assign({ "Authorization": sessionStorage.access_token, "uid": sessionStorage.uid })
		}).request().then(function (response) {
			dispatch({ type: ACTION_SEARCH_EVALUATOR, Obj: response.data });
			dispatch((0, _Loading.isLoading)(false));
		}).catch(function (error) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
			throw error;
		});
	};
};

var searchGranteeEvaluator = exports.searchGranteeEvaluator = function searchGranteeEvaluator(form) {

	return function (dispatch) {

		dispatch((0, _Loading.isLoading)(true));

		return new _ClientHttpRequest2.default({
			service: 'api/searchGranteeEvaluator',
			method: "POST",
			data: _extends({}, form),
			headers: Object.assign({ "Authorization": sessionStorage.access_token, "uid": sessionStorage.uid })
		}).request().then(function (response) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch({ type: ACTION_SEARCH_EVALUATOR_GRANTEE, Obj: response.data });
		}).catch(function (error) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
			throw error;
		});
	};
};

/***/ }),

/***/ 457:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.clearEventBudget = exports.addEvent = exports.searchParamGrantee = exports.searchEvent = exports.updateEventBudget = exports.getEvent = exports.getEventBudget = exports.addEventBudget = exports.ACTION_UPDATE_BUDGET = exports.ACTION_SEARCH_EVENT = exports.ACTION_GET_EVENT = exports.ACTION_GET_BUDGET = exports.ACTION_NEW_BUDGET = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _Utils = __webpack_require__(2);

var Utils = _interopRequireWildcard(_Utils);

var _ClientHttpRequest = __webpack_require__(5);

var _ClientHttpRequest2 = _interopRequireDefault(_ClientHttpRequest);

var _immutable = __webpack_require__(1);

var _immutable2 = _interopRequireDefault(_immutable);

var _Modal = __webpack_require__(4);

var _Loading = __webpack_require__(3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var initialState = _immutable2.default.Map({}).set('Search', new _immutable2.default.List([])).set('Response', new _immutable2.default.Map({})).set('Get', new _immutable2.default.Map({})).set('Event', new _immutable2.default.Map({ corrida: {} }));

/* Types */
var ACTION_NEW_BUDGET = exports.ACTION_NEW_BUDGET = 'ACTION_NEW_BUDGET';

var ACTION_GET_BUDGET = exports.ACTION_GET_BUDGET = 'ACTION_GET_BUDGET';

var ACTION_GET_EVENT = exports.ACTION_GET_EVENT = 'ACTION_GET_EVENT';

var ACTION_SEARCH_EVENT = exports.ACTION_SEARCH_EVENT = 'ACTION_SEARCH_EVENT';

var ACTION_UPDATE_BUDGET = exports.ACTION_UPDATE_BUDGET = 'ACTION_UPDATE_BUDGET';

/* Reducer */

exports.default = function () {
	var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	var action = arguments[1];


	switch (action.type) {
		case ACTION_NEW_BUDGET:
			return state.set('Response', new _immutable2.default.Map(action.Obj));
		case ACTION_GET_BUDGET:
			return state.set('Get', new _immutable2.default.Map(action.Obj));
		case ACTION_GET_EVENT:
			return state.set('Event', new _immutable2.default.Map(action.Obj));
		case ACTION_SEARCH_EVENT:
			return state.set('Search', new _immutable2.default.List(action.Obj));
		case ACTION_UPDATE_BUDGET:
			return state.set('Response', new _immutable2.default.Map(action.Obj));
		default:
			return state;
	}
};

/* Action Creators */

var addEventBudget = exports.addEventBudget = function addEventBudget(form) {

	var data = Object.assign({}, form);

	return function (dispatch) {

		dispatch((0, _Loading.isLoading)(true));

		return new _ClientHttpRequest2.default({
			service: 'api/newEventBudget',
			method: "POST",
			data: _extends({}, data),
			headers: Object.assign({ "Authorization": sessionStorage.access_token, "uid": sessionStorage.uid })
		}).request().then(function () {
			dispatch((0, _Loading.isLoading)(false));
			dispatch((0, _Modal.createModal)(Utils.successMessage()));
		}).catch(function (error) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
			throw error;
		});
	};
};

var getEventBudget = exports.getEventBudget = function getEventBudget(id) {

	return function (dispatch) {

		dispatch((0, _Loading.isLoading)(true));

		return new _ClientHttpRequest2.default({
			service: 'api/getEventBudget',
			method: "POST",
			data: { id: id },
			headers: Object.assign({ "Authorization": sessionStorage.access_token, "uid": sessionStorage.uid })
		}).request().then(function (response) {
			dispatch({ type: ACTION_GET_BUDGET, Obj: response.data });
			dispatch((0, _Loading.isLoading)(false));
		}).catch(function (error) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
			throw error;
		});
	};
};

var getEvent = exports.getEvent = function getEvent(id) {

	return function (dispatch) {

		dispatch((0, _Loading.isLoading)(true));

		return new _ClientHttpRequest2.default({
			service: 'api/getEvent',
			method: "POST",
			data: { id: id },
			headers: Object.assign({ "Authorization": sessionStorage.access_token, "uid": sessionStorage.uid })
		}).request().then(function (response) {
			dispatch({ type: ACTION_GET_EVENT, Obj: response.data });
			dispatch((0, _Loading.isLoading)(false));
		}).catch(function (error) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
			throw error;
		});
	};
};

var updateEventBudget = exports.updateEventBudget = function updateEventBudget(form) {

	var data = Object.assign({}, form);
	data.objetivosDesarrolloGrupo = Utils.removeItem(data.objetivosDesarrolloGrupo, { idMeta: -1, idIndicador: -1 });

	return function (dispatch) {

		dispatch((0, _Loading.isLoading)(true));
		dispatch({ type: ACTION_GET_BUDGET, Obj: {} });

		return new _ClientHttpRequest2.default({
			service: 'api/updateEventBudget',
			method: "POST",
			data: _extends({}, data),
			headers: Object.assign({ "Authorization": sessionStorage.access_token, "uid": sessionStorage.uid })
		}).request().then(function (response) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch({ type: ACTION_UPDATE_BUDGET, Obj: response.data });
			dispatch((0, _Modal.createModal)(Utils.successMessage()));
		}).catch(function (error) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
			throw error;
		});
	};
};

var searchEvent = exports.searchEvent = function searchEvent(form) {

	Utils.clearNullAndEmpty(form);

	return function (dispatch) {

		dispatch((0, _Loading.isLoading)(true));

		return new _ClientHttpRequest2.default({
			service: Object.keys(form).length == 0 ? 'api/searchEvent' : 'api/searchParamEvent',
			method: "POST",
			data: _extends({}, form),
			headers: Object.assign({ "Authorization": sessionStorage.access_token, "uid": sessionStorage.uid })
		}).request().then(function (response) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch({ type: ACTION_SEARCH_EVENT, Obj: response.data });
		}).catch(function (error) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
			throw error;
		});
	};
};

var searchParamGrantee = exports.searchParamGrantee = function searchParamGrantee(form) {

	return function (dispatch) {

		dispatch((0, _Loading.isLoading)(true));

		return new _ClientHttpRequest2.default({
			service: 'api/searchParamEvent',
			method: "POST",
			data: _extends({}, form),
			headers: Object.assign({ "Authorization": sessionStorage.access_token, "uid": sessionStorage.uid })
		}).request().then(function (response) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch({ type: ACTION_SEARCH_EVENT, Obj: response.data });
		}).catch(function (error) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
			throw error;
		});
	};
};

var addEvent = exports.addEvent = function addEvent(form) {

	var data = Object.assign({}, form);

	return function (dispatch) {

		dispatch((0, _Loading.isLoading)(true));

		return new _ClientHttpRequest2.default({
			service: !data.id ? 'api/newEvent' : 'api/updateEvent',
			method: "POST",
			data: _extends({}, data),
			headers: Object.assign({ "Authorization": sessionStorage.access_token, "uid": sessionStorage.uid })
		}).request().then(function () {
			dispatch((0, _Loading.isLoading)(false));
			dispatch((0, _Modal.createModal)(Utils.successMessage()));
		}).catch(function (error) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
			throw error;
		});
	};
};

var clearEventBudget = exports.clearEventBudget = function clearEventBudget() {
	return function (dispatch) {
		dispatch({ type: ACTION_GET_BUDGET, Obj: {} });
	};
};

/***/ }),

/***/ 458:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.clearFuncPatron = exports.updateFuncPatron = exports.deleteFuncPatron = exports.getFuncPatron = exports.searchFuncPatron = exports.addFuncPatron = exports.getFunctionPatron = exports.ACTION_UPDATE_FUNCTION_PATRON = exports.ACTION_DELETE_FUNCTION_PATRON = exports.ACTION_GET_FUNCTION_PATRON = exports.ACTION_SEARCH_FUNCTION_PATRON = exports.ACTION_GET_FUNCTION_PATRON_CATALOG = undefined;

var _Utils = __webpack_require__(2);

var Utils = _interopRequireWildcard(_Utils);

var _ClientHttpRequest = __webpack_require__(5);

var _ClientHttpRequest2 = _interopRequireDefault(_ClientHttpRequest);

var _immutable = __webpack_require__(1);

var _immutable2 = _interopRequireDefault(_immutable);

var _Modal = __webpack_require__(4);

var _Loading = __webpack_require__(3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var initialState = _immutable2.default.Map({}).set('Catalog', new _immutable2.default.List([])).set('Search', new _immutable2.default.List([])).set('Response', new _immutable2.default.Map({})).set('Get', new _immutable2.default.Map({}));

/* Types */
var ACTION_GET_FUNCTION_PATRON_CATALOG = exports.ACTION_GET_FUNCTION_PATRON_CATALOG = 'ACTION_GET_FUNCTION_PATRON_CATALOG';

var ACTION_SEARCH_FUNCTION_PATRON = exports.ACTION_SEARCH_FUNCTION_PATRON = 'ACTION_SEARCH_FUNCTION_PATRON';

var ACTION_GET_FUNCTION_PATRON = exports.ACTION_GET_FUNCTION_PATRON = 'ACTION_GET_FUNCTION_PATRON';

var ACTION_DELETE_FUNCTION_PATRON = exports.ACTION_DELETE_FUNCTION_PATRON = 'ACTION_DELETE_FUNCTION_PATRON';

var ACTION_UPDATE_FUNCTION_PATRON = exports.ACTION_UPDATE_FUNCTION_PATRON = 'ACTION_UPDATE_FUNCTION_PATRON';

/* Reducer */

exports.default = function () {
	var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	var action = arguments[1];


	switch (action.type) {

		case ACTION_GET_FUNCTION_PATRON_CATALOG:
			return state.set("Catalog", new _immutable2.default.List(action.Obj));
		case ACTION_SEARCH_FUNCTION_PATRON:
			return state.set('Search', new _immutable2.default.List(action.Obj));
		case ACTION_GET_FUNCTION_PATRON:
			return state.set('Get', new _immutable2.default.Map(action.Obj));
		case ACTION_DELETE_FUNCTION_PATRON:
			return state.set('Response', new _immutable2.default.Map(action.Obj));
		case ACTION_UPDATE_FUNCTION_PATRON:
			return state.set('Response', new _immutable2.default.Map(action.Obj));
		default:
			return state;
	}
};

/* Action Creators */

var getFunctionPatron = exports.getFunctionPatron = function getFunctionPatron(form) {

	return function (dispatch) {

		dispatch((0, _Loading.isLoading)(true));

		return new _ClientHttpRequest2.default({
			service: 'api/functionpatron',
			method: "POST",
			data: form,
			headers: Object.assign({ "Authorization": sessionStorage.access_token, "uid": sessionStorage.uid })
		}).request().then(function (response) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch({ type: ACTION_GET_FUNCTION_PATRON_CATALOG, Obj: response.data });
		}).catch(function (error) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
			//throw error;
		});
	};
};

var addFuncPatron = exports.addFuncPatron = function addFuncPatron(form) {

	return function (dispatch) {

		dispatch((0, _Loading.isLoading)(true));

		return new _ClientHttpRequest2.default({
			service: 'api/newFuncPatron',
			method: "POST",
			data: form,
			headers: Object.assign({ "Authorization": sessionStorage.access_token, "uid": sessionStorage.uid })
		}).request().then(function () {
			dispatch((0, _Loading.isLoading)(false));
			dispatch((0, _Modal.createModal)(Utils.successMessage()));
		}).catch(function (error) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
			throw error;
		});
	};
};

var searchFuncPatron = exports.searchFuncPatron = function searchFuncPatron(form) {

	Utils.clearNullAndEmpty(form);

	return function (dispatch) {

		dispatch((0, _Loading.isLoading)(true));

		return new _ClientHttpRequest2.default({
			service: Object.keys(form).length == 0 ? 'api/searchFuncPatron' : 'api/searchParamFuncPatron',
			method: "POST",
			data: form,
			headers: Object.assign({ "Authorization": sessionStorage.access_token, "uid": sessionStorage.uid })
		}).request().then(function (response) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch({ type: ACTION_SEARCH_FUNCTION_PATRON, Obj: response.data });
		}).catch(function (error) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
			throw error;
		});
	};
};

var getFuncPatron = exports.getFuncPatron = function getFuncPatron(id) {

	return function (dispatch) {

		dispatch((0, _Loading.isLoading)(true));

		return new _ClientHttpRequest2.default({
			service: 'api/getFuncPatron',
			method: "POST",
			data: { id: id },
			headers: Object.assign({ "Authorization": sessionStorage.access_token, "uid": sessionStorage.uid })
		}).request().then(function (response) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch({ type: ACTION_GET_FUNCTION_PATRON, Obj: response.data });
		}).catch(function (error) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
			throw error;
		});
	};
};

var deleteFuncPatron = exports.deleteFuncPatron = function deleteFuncPatron() {
	return function (dispatch) {
		return dispatch({ type: ACTION_DELETE_FUNCTION_PATRON, Obj: { code: '', message: '' } });
	};
};

var updateFuncPatron = exports.updateFuncPatron = function updateFuncPatron(form) {

	return function (dispatch) {

		dispatch((0, _Loading.isLoading)(true));
		dispatch({ type: ACTION_GET_FUNCTION_PATRON, Obj: {} });

		return new _ClientHttpRequest2.default({
			service: 'api/updateFuncPatron',
			method: "POST",
			data: form,
			headers: Object.assign({ "Authorization": sessionStorage.access_token, "uid": sessionStorage.uid })
		}).request().then(function (response) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch({ type: ACTION_UPDATE_FUNCTION_PATRON, Obj: response.data });
			dispatch((0, _Modal.createModal)(Utils.successMessage()));
		}).catch(function (error) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
			throw error;
		});
	};
};

var clearFuncPatron = exports.clearFuncPatron = function clearFuncPatron() {
	return function (dispatch) {
		dispatch({ type: ACTION_GET_FUNCTION_PATRON, Obj: {} });
		dispatch({ type: ACTION_SEARCH_FUNCTION_PATRON, Obj: [] });
	};
};

/***/ }),

/***/ 459:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.clearGoal = exports.updateGoal = exports.deleteGoal = exports.getGoal = exports.searchGoal = exports.addGoal = exports.ACTION_UPDATE_GOAL = exports.ACTION_DELETE_GOAL = exports.ACTION_GET_GOAL = exports.ACTION_SEARCH_GOAL = exports.ACTION_NEW_GOAL = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _Utils = __webpack_require__(2);

var Utils = _interopRequireWildcard(_Utils);

var _ClientHttpRequest = __webpack_require__(5);

var _ClientHttpRequest2 = _interopRequireDefault(_ClientHttpRequest);

var _immutable = __webpack_require__(1);

var _immutable2 = _interopRequireDefault(_immutable);

var _Modal = __webpack_require__(4);

var _Loading = __webpack_require__(3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var initialState = _immutable2.default.Map({}).set('Search', new _immutable2.default.List([])).set('Response', new _immutable2.default.Map({})).set('Get', new _immutable2.default.Map({}));

/* Types */
var ACTION_NEW_GOAL = exports.ACTION_NEW_GOAL = 'ACTION_NEW_GOAL';

var ACTION_SEARCH_GOAL = exports.ACTION_SEARCH_GOAL = 'ACTION_SEARCH_GOAL';

var ACTION_GET_GOAL = exports.ACTION_GET_GOAL = 'ACTION_GET_GOAL';

var ACTION_DELETE_GOAL = exports.ACTION_DELETE_GOAL = 'ACTION_DELETE_GOAL';

var ACTION_UPDATE_GOAL = exports.ACTION_UPDATE_GOAL = 'ACTION_UPDATE_GOAL';

/* Reducer */

exports.default = function () {
	var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	var action = arguments[1];


	switch (action.type) {
		case ACTION_NEW_GOAL:
			return state.set('Response', new _immutable2.default.Map(action.Obj));
		case ACTION_SEARCH_GOAL:
			return state.set('Search', new _immutable2.default.List(action.Obj));
		case ACTION_GET_GOAL:
			return state.set('Get', new _immutable2.default.Map(action.Obj));
		case ACTION_DELETE_GOAL:
			return state.set('Response', new _immutable2.default.Map(action.Obj));
		case ACTION_UPDATE_GOAL:
			return state.set('Response', new _immutable2.default.Map(action.Obj));
		default:
			return state;
	}
};

/* Action Creators */

var addGoal = exports.addGoal = function addGoal(form) {

	return function (dispatch) {

		dispatch((0, _Loading.isLoading)(true));

		return new _ClientHttpRequest2.default({
			service: 'api/newGoal',
			method: "POST",
			data: _extends({}, form),
			headers: Object.assign({ "Authorization": sessionStorage.access_token, "uid": sessionStorage.uid })
		}).request().then(function () {
			dispatch((0, _Loading.isLoading)(false));
			dispatch((0, _Modal.createModal)(Utils.successMessage()));
		}).catch(function (error) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
			throw error;
		});
	};
};

var searchGoal = exports.searchGoal = function searchGoal(form) {

	Utils.clearNullAndEmpty(form);

	return function (dispatch) {

		dispatch((0, _Loading.isLoading)(true));

		return new _ClientHttpRequest2.default({
			service: Object.keys(form).length == 0 ? 'api/searchGoal' : 'api/searchParamGoal',
			method: "POST",
			data: _extends({}, form),
			headers: Object.assign({ "Authorization": sessionStorage.access_token, "uid": sessionStorage.uid })
		}).request().then(function (response) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch({ type: ACTION_SEARCH_GOAL, Obj: response.data });
		}).catch(function (error) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
			throw error;
		});
	};
};

var getGoal = exports.getGoal = function getGoal(id) {

	return function (dispatch) {

		dispatch((0, _Loading.isLoading)(true));

		return new _ClientHttpRequest2.default({
			service: 'api/getGoal',
			method: "POST",
			data: { id: id },
			headers: Object.assign({ "Authorization": sessionStorage.access_token, "uid": sessionStorage.uid })
		}).request().then(function (response) {
			dispatch({ type: ACTION_GET_GOAL, Obj: response.data });
			dispatch((0, _Loading.isLoading)(false));
		}).catch(function (error) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
			throw error;
		});
	};
};

var deleteGoal = exports.deleteGoal = function deleteGoal() {
	return function (dispatch) {
		return dispatch({ type: ACTION_DELETE_GOAL, Obj: { code: '', message: '' } });
	};
};

var updateGoal = exports.updateGoal = function updateGoal(form) {

	var data = Object.assign({}, form);
	data.indicador = Utils.unionArray(data.indicador, data.indicadorRemove);

	return function (dispatch) {

		dispatch((0, _Loading.isLoading)(true));
		dispatch({ type: ACTION_GET_GOAL, Obj: {} });

		return new _ClientHttpRequest2.default({
			service: 'api/updateGoal',
			method: "POST",
			data: _extends({}, data),
			headers: Object.assign({ "Authorization": sessionStorage.access_token, "uid": sessionStorage.uid })
		}).request().then(function (response) {
			dispatch({ type: ACTION_UPDATE_GOAL, Obj: response.data });
			dispatch((0, _Loading.isLoading)(false));
			dispatch((0, _Modal.createModal)(Utils.successMessage()));
		}).catch(function (error) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
			throw error;
		});
	};
};

var clearGoal = exports.clearGoal = function clearGoal() {
	return function (dispatch) {
		dispatch({ type: ACTION_GET_GOAL, Obj: {} });
		dispatch({ type: ACTION_SEARCH_GOAL, Obj: [] });
	};
};

/***/ }),

/***/ 460:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.clearGroup = exports.updateGroup = exports.deleteGroup = exports.getGroup = exports.searchGroup = exports.addGroup = exports.ACTION_UPDATE_GROUP = exports.ACTION_DELETE_GROUP = exports.ACTION_GET_GROUP = exports.ACTION_SEARCH_GROUP = exports.ACTION_NEW_GROUP = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _Utils = __webpack_require__(2);

var Utils = _interopRequireWildcard(_Utils);

var _ClientHttpRequest = __webpack_require__(5);

var _ClientHttpRequest2 = _interopRequireDefault(_ClientHttpRequest);

var _immutable = __webpack_require__(1);

var _immutable2 = _interopRequireDefault(_immutable);

var _Modal = __webpack_require__(4);

var _Loading = __webpack_require__(3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var initialState = _immutable2.default.Map({}).set('Search', new _immutable2.default.List([])).set('Response', new _immutable2.default.Map({})).set('Get', new _immutable2.default.Map({}));

/* Types */
var ACTION_NEW_GROUP = exports.ACTION_NEW_GROUP = 'ACTION_NEW_GROUP';

var ACTION_SEARCH_GROUP = exports.ACTION_SEARCH_GROUP = 'ACTION_SEARCH_GROUP';

var ACTION_GET_GROUP = exports.ACTION_GET_GROUP = 'ACTION_GET_GROUP';

var ACTION_DELETE_GROUP = exports.ACTION_DELETE_GROUP = 'ACTION_DELETE_GROUP';

var ACTION_UPDATE_GROUP = exports.ACTION_UPDATE_GROUP = 'ACTION_UPDATE_GROUP';

/* Reducer */

exports.default = function () {
	var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	var action = arguments[1];


	switch (action.type) {
		case ACTION_NEW_GROUP:
			return state.set('Response', new _immutable2.default.Map(action.Obj));
		case ACTION_SEARCH_GROUP:
			return state.set('Search', new _immutable2.default.List(action.Obj));
		case ACTION_GET_GROUP:
			return state.set('Get', new _immutable2.default.Map(action.Obj));
		case ACTION_DELETE_GROUP:
			return state.set('Response', new _immutable2.default.Map(action.Obj));
		case ACTION_UPDATE_GROUP:
			return state.set('Response', new _immutable2.default.Map(action.Obj));
		default:
			return state;
	}
};

/* Action Creators */

var addGroup = exports.addGroup = function addGroup(form) {

	var data = Object.assign({}, form);
	data.donantesGrupo = Utils.getListPropsOmit(data.donantesGrupo, ['id', 'tmp']);
	data.donantesGrupoRemove = Utils.getListPropsOmit(data.donantesGrupoRemove, ['id']);
	data.donantesGrupo = Utils.unionArray(data.donantesGrupo, data.donantesGrupoRemove);

	data.gruposDonataria = Utils.getListPropsOmit(data.gruposDonataria, ['id', 'tmp']);
	data.gruposDonatariaRemove = Utils.getListPropsOmit(data.gruposDonatariaRemove, ['id']);
	data.gruposDonataria = Utils.unionArray(data.gruposDonataria, data.gruposDonatariaRemove);

	data.documentosFaseGrupo = Utils.getListPropsOmit(data.documentosFaseGrupo, ['id', 'tmp']);
	data.documentosFaseGrupoRemove = Utils.getListPropsOmit(data.documentosFaseGrupoRemove, ['id']);
	data.documentosFaseGrupo = Utils.unionArray(data.documentosFaseGrupo, data.documentosFaseGrupoRemove);

	data.fasesGrupo = Utils.getListPropsOmit(data.fasesGrupo, ['id', 'tmp']);
	data.fasesGrupoRemove = Utils.getListPropsOmit(data.fasesGrupoRemove, ['id']);
	data.fasesGrupo = Utils.unionArray(data.fasesGrupo, data.fasesGrupoRemove);

	data.objetivosDesarrolloGrupo = Utils.getListPropsOmit(data.objetivosDesarrolloGrupo, ['id', 'tmp']);
	data.objetivosDesarrolloGrupoRemove = Utils.getListPropsOmit(data.objetivosDesarrolloGrupoRemove, ['id']);
	data.objetivosDesarrolloGrupo = Utils.unionArray(data.objetivosDesarrolloGrupo, data.objetivosDesarrolloGrupoRemove);

	data.rubrosGrupo = Utils.getListPropsOmit(data.rubrosGrupo, ['id', 'tmp']);
	data.rubrosGrupoRemove = Utils.getListPropsOmit(data.rubrosGrupoRemove, ['id']);
	data.rubrosGrupo = Utils.unionArray(data.rubrosGrupo, data.rubrosGrupoRemove);

	data.evaluadoresGrupo = Utils.getListPropsOmit(data.evaluadoresGrupo, ['id', 'tmp']);
	data.evaluadoresGrupoRemove = Utils.getListPropsOmit(data.evaluadoresGrupoRemove, ['id']);
	data.evaluadoresGrupo = Utils.unionArray(data.evaluadoresGrupo, data.evaluadoresGrupoRemove);

	data.etapaFortalecimientoGrupo = Utils.getListPropsOmit(data.etapaFortalecimientoGrupo, ['id', 'tmp']);
	data.etapaFortalecimientoGrupoRemove = Utils.getListPropsOmit(data.etapaFortalecimientoGrupoRemove, ['id']);
	data.etapaFortalecimientoGrupo = Utils.unionArray(data.etapaFortalecimientoGrupo, data.etapaFortalecimientoGrupoRemove);

	data.tipoEvaluacionGrupo = Utils.getListPropsOmit(data.tipoEvaluacionGrupo, ['id', 'tmp']);
	data.tipoEvaluacionGrupoRemove = Utils.getListPropsOmit(data.tipoEvaluacionGrupoRemove, ['id']);
	data.tipoEvaluacionGrupo = Utils.unionArray(data.tipoEvaluacionGrupo, data.tipoEvaluacionGrupoRemove);

	data.consultorGrupo = Utils.getListPropsOmit(data.consultorGrupo, ['id', 'tmp']);
	data.consultorGrupoRemove = Utils.getListPropsOmit(data.consultorGrupoRemove, ['id']);
	data.consultorGrupo = Utils.unionArray(data.consultorGrupo, data.consultorGrupoRemove);

	data.objetivosDesarrolloGrupo = Utils.removeItem(data.objetivosDesarrolloGrupo, { idMeta: -1, idIndicador: -1 });

	data.requisitosPagoGrupo = Utils.getListPropsOmit(data.requisitosPagoGrupo, ['id', 'tmp']);
	data.requisitosPagoGrupoRemove = Utils.getListPropsOmit(data.requisitosPagoGrupoRemove, ['id']);
	data.requisitosPagoGrupo = Utils.unionArray(data.requisitosPagoGrupo, data.requisitosPagoGrupoRemove);

	data.indicadoresGrupo = Utils.getListPropsOmit(data.indicadoresGrupo, ['id', 'tmp']);
	data.indicadoresGrupoRemove = Utils.getListPropsOmit(data.indicadoresGrupoRemove, ['id']);
	data.indicadoresGrupo = Utils.unionArray(data.indicadoresGrupo, data.indicadoresGrupoRemove);

	data.estatusComprobacionDonativo = Utils.getListPropsOmit(data.estatusComprobacionDonativo, ['id', 'tmp']);
	data.estatusComprobacionDonativoRemove = Utils.getListPropsOmit(data.estatusComprobacionDonativoRemove, ['id']);
	data.estatusComprobacionDonativo = Utils.unionArray(data.estatusComprobacionDonativo, data.estatusComprobacionDonativoRemove);

	data.contratoGrupo = Utils.getListPropsOmit(data.contratoGrupo, ['id', 'tmp']);
	data.contratoGrupoRemove = Utils.getListPropsOmit(data.contratoGrupoRemove, ['id']);
	data.contratoGrupo = Utils.unionArray(data.contratoGrupo, data.contratoGrupoRemove);

	return function (dispatch) {

		dispatch((0, _Loading.isLoading)(true));

		return new _ClientHttpRequest2.default({
			service: 'api/newGroup',
			method: "POST",
			data: _extends({}, data),
			headers: Object.assign({ "Authorization": sessionStorage.access_token, "uid": sessionStorage.uid })
		}).request().then(function () {
			dispatch((0, _Loading.isLoading)(false));
			dispatch((0, _Modal.createModal)(Utils.successMessage()));
		}).catch(function (error) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
			throw error;
		});
	};
};

var searchGroup = exports.searchGroup = function searchGroup(form) {

	Utils.clearNullAndEmpty(form);

	return function (dispatch) {

		dispatch((0, _Loading.isLoading)(true));

		return new _ClientHttpRequest2.default({
			service: Object.keys(form).length == 0 ? 'api/searchGroup' : 'api/searchParamGroup',
			method: "POST",
			data: _extends({}, form),
			headers: Object.assign({ "Authorization": sessionStorage.access_token, "uid": sessionStorage.uid })
		}).request().then(function (response) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch({ type: ACTION_SEARCH_GROUP, Obj: response.data });
		}).catch(function (error) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
			throw error;
		});
	};
};

var getGroup = exports.getGroup = function getGroup(id) {

	return function (dispatch) {

		dispatch((0, _Loading.isLoading)(true));

		return new _ClientHttpRequest2.default({
			service: 'api/getGroup',
			method: "POST",
			data: { id: id },
			headers: Object.assign({ "Authorization": sessionStorage.access_token, "uid": sessionStorage.uid })
		}).request().then(function (response) {
			dispatch({ type: ACTION_GET_GROUP, Obj: response.data });
			dispatch((0, _Loading.isLoading)(false));
		}).catch(function (error) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
			throw error;
		});
	};
};

var deleteGroup = exports.deleteGroup = function deleteGroup() {
	return function (dispatch) {
		return dispatch({ type: ACTION_DELETE_GROUP, Obj: { code: '', message: '' } });
	};
};

var updateGroup = exports.updateGroup = function updateGroup(form) {

	var data = Object.assign({}, form);

	data.donantesGrupo = Utils.getListPropsOmit(data.donantesGrupo, ['id', 'tmp']);
	data.donantesGrupoRemove = Utils.getListPropsOmit(data.donantesGrupoRemove, ['id']);
	data.donantesGrupo = Utils.unionArray(data.donantesGrupo, data.donantesGrupoRemove);

	data.gruposDonataria = Utils.getListPropsOmit(data.gruposDonataria, ['id', 'tmp']);
	data.gruposDonatariaRemove = Utils.getListPropsOmit(data.gruposDonatariaRemove, ['id']);
	data.gruposDonataria = Utils.unionArray(data.gruposDonataria, data.gruposDonatariaRemove);

	data.documentosFaseGrupo = Utils.getListPropsOmit(data.documentosFaseGrupo, ['id', 'tmp']);
	data.documentosFaseGrupoRemove = Utils.getListPropsOmit(data.documentosFaseGrupoRemove, ['id']);
	data.documentosFaseGrupo = Utils.unionArray(data.documentosFaseGrupo, data.documentosFaseGrupoRemove);

	data.fasesGrupo = Utils.getListPropsOmit(data.fasesGrupo, ['id', 'tmp']);
	data.fasesGrupoRemove = Utils.getListPropsOmit(data.fasesGrupoRemove, ['id']);
	data.fasesGrupo = Utils.unionArray(data.fasesGrupo, data.fasesGrupoRemove);

	data.objetivosDesarrolloGrupo = Utils.getListPropsOmit(data.objetivosDesarrolloGrupo, ['id', 'tmp']);
	data.objetivosDesarrolloGrupoRemove = Utils.getListPropsOmit(data.objetivosDesarrolloGrupoRemove, ['id']);
	data.objetivosDesarrolloGrupo = Utils.unionArray(data.objetivosDesarrolloGrupo, data.objetivosDesarrolloGrupoRemove);

	data.rubrosGrupo = Utils.getListPropsOmit(data.rubrosGrupo, ['id', 'tmp']);
	data.rubrosGrupoRemove = Utils.getListPropsOmit(data.rubrosGrupoRemove, ['id']);
	data.rubrosGrupo = Utils.unionArray(data.rubrosGrupo, data.rubrosGrupoRemove);

	data.evaluadoresGrupo = Utils.getListPropsOmit(data.evaluadoresGrupo, ['id', 'tmp']);
	data.evaluadoresGrupoRemove = Utils.getListPropsOmit(data.evaluadoresGrupoRemove, ['id']);
	data.evaluadoresGrupo = Utils.unionArray(data.evaluadoresGrupo, data.evaluadoresGrupoRemove);

	data.etapaFortalecimientoGrupo = Utils.getListPropsOmit(data.etapaFortalecimientoGrupo, ['id', 'tmp']);
	data.etapaFortalecimientoGrupoRemove = Utils.getListPropsOmit(data.etapaFortalecimientoGrupoRemove, ['id']);
	data.etapaFortalecimientoGrupo = Utils.unionArray(data.etapaFortalecimientoGrupo, data.etapaFortalecimientoGrupoRemove);

	data.tipoEvaluacionGrupo = Utils.getListPropsOmit(data.tipoEvaluacionGrupo, ['id', 'tmp']);
	data.tipoEvaluacionGrupoRemove = Utils.getListPropsOmit(data.tipoEvaluacionGrupoRemove, ['id']);
	data.tipoEvaluacionGrupo = Utils.unionArray(data.tipoEvaluacionGrupo, data.tipoEvaluacionGrupoRemove);

	data.consultorGrupo = Utils.getListPropsOmit(data.consultorGrupo, ['id', 'tmp']);
	data.consultorGrupoRemove = Utils.getListPropsOmit(data.consultorGrupoRemove, ['id']);
	data.consultorGrupo = Utils.unionArray(data.consultorGrupo, data.consultorGrupoRemove);

	data.objetivosDesarrolloGrupo = Utils.removeItem(data.objetivosDesarrolloGrupo, { idMeta: -1, idIndicador: -1 });

	data.requisitosPagoGrupo = Utils.getListPropsOmit(data.requisitosPagoGrupo, ['id', 'tmp']);
	data.requisitosPagoGrupoRemove = Utils.getListPropsOmit(data.requisitosPagoGrupoRemove, ['id']);
	data.requisitosPagoGrupo = Utils.unionArray(data.requisitosPagoGrupo, data.requisitosPagoGrupoRemove);

	data.indicadoresGrupo = Utils.getListPropsOmit(data.indicadoresGrupo, ['id', 'tmp']);
	data.indicadoresGrupoRemove = Utils.getListPropsOmit(data.indicadoresGrupoRemove, ['id']);
	data.indicadoresGrupo = Utils.unionArray(data.indicadoresGrupo, data.indicadoresGrupoRemove);

	data.estatusComprobacionDonativo = Utils.getListPropsOmit(data.estatusComprobacionDonativo, ['id', 'tmp']);
	data.estatusComprobacionDonativoRemove = Utils.getListPropsOmit(data.estatusComprobacionDonativoRemove, ['id']);
	data.estatusComprobacionDonativo = Utils.unionArray(data.estatusComprobacionDonativo, data.estatusComprobacionDonativoRemove);

	data.contratoGrupo = Utils.getListPropsOmit(data.contratoGrupo, ['id', 'tmp']);
	data.contratoGrupoRemove = Utils.getListPropsOmit(data.contratoGrupoRemove, ['id']);
	data.contratoGrupo = Utils.unionArray(data.contratoGrupo, data.contratoGrupoRemove);

	return function (dispatch) {
		dispatch((0, _Loading.isLoading)(true));
		dispatch({ type: ACTION_GET_GROUP, Obj: {} });

		return new _ClientHttpRequest2.default({
			service: 'api/updateGroup',
			method: "POST",
			data: _extends({}, data),
			headers: Object.assign({ "Authorization": sessionStorage.access_token, "uid": sessionStorage.uid })
		}).request().then(function (response) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch({ type: ACTION_UPDATE_GROUP, Obj: response.data });
			dispatch((0, _Modal.createModal)(Utils.successMessage()));
		}).catch(function (error) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
			throw error;
		});
	};
};

var clearGroup = exports.clearGroup = function clearGroup() {
	return function (dispatch) {
		dispatch({ type: ACTION_GET_GROUP, Obj: {} });
		dispatch({ type: ACTION_SEARCH_GROUP, Obj: [] });
	};
};

/***/ }),

/***/ 461:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.clearConcept = exports.searchConcept = exports.deleteConcept = exports.updateConcept = exports.getConceptById = exports.getConcepts = exports.newConcept = exports.ACTION_GET_CONCEPT = exports.ACTION_GET_CONCEPTS = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _Utils = __webpack_require__(2);

var Utils = _interopRequireWildcard(_Utils);

var _ClientHttpRequest = __webpack_require__(5);

var _ClientHttpRequest2 = _interopRequireDefault(_ClientHttpRequest);

var _immutable = __webpack_require__(1);

var _immutable2 = _interopRequireDefault(_immutable);

var _Modal = __webpack_require__(4);

var _Loading = __webpack_require__(3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var initialState = _immutable2.default.Map({}).set('conceptos', new _immutable2.default.List([])).set('concepto', new _immutable2.default.Map({}));

/* Types */
var ACTION_GET_CONCEPTS = exports.ACTION_GET_CONCEPTS = 'ACTION_GET_CONCEPTS';
var ACTION_GET_CONCEPT = exports.ACTION_GET_CONCEPT = 'ACTION_GET_CONCEPT';

/* Reducer */

exports.default = function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments[1];

  switch (action.type) {
    case ACTION_GET_CONCEPTS:
      return state.set('conceptos', new _immutable2.default.List(action.Obj));
    case ACTION_GET_CONCEPT:
      return state.set('concepto', new _immutable2.default.Map(action.Obj));
    default:
      return state;
  }
};

/* Action Creators */


var newConcept = exports.newConcept = function newConcept(form) {
  Utils.clearNullAndEmpty(form);
  return function (dispatch) {
    dispatch((0, _Loading.isLoading)(true));

    return new _ClientHttpRequest2.default({
      service: 'api/newConcept',
      method: 'POST',
      data: _extends({}, form),
      headers: Object.assign({ Authorization: sessionStorage.access_token, uid: sessionStorage.uid })
    }).request().then(function () {
      dispatch((0, _Loading.isLoading)(false));
    }).catch(function (error) {
      dispatch((0, _Loading.isLoading)(false));
      dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
      throw error;
    });
  };
};

var getConcepts = exports.getConcepts = function getConcepts() {
  return function (dispatch) {
    dispatch((0, _Loading.isLoading)(true));

    return new _ClientHttpRequest2.default({
      service: 'api/getConcepts',
      method: 'POST',
      data: {},
      headers: Object.assign({ Authorization: sessionStorage.access_token, uid: sessionStorage.uid })
    }).request().then(function (response) {
      dispatch((0, _Loading.isLoading)(false));
      dispatch({ type: ACTION_GET_CONCEPTS, Obj: response.data });
    }).catch(function (error) {
      dispatch((0, _Loading.isLoading)(false));
      dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
      throw error;
    });
  };
};

var getConceptById = exports.getConceptById = function getConceptById(idConcepto) {
  return function (dispatch) {
    dispatch((0, _Loading.isLoading)(true));

    return new _ClientHttpRequest2.default({
      service: 'api/getConceptById',
      method: 'POST',
      data: { idConcepto: idConcepto },
      headers: Object.assign({ Authorization: sessionStorage.access_token, uid: sessionStorage.uid })
    }).request().then(function (response) {
      dispatch((0, _Loading.isLoading)(false));
      dispatch({ type: ACTION_GET_CONCEPT, Obj: response.data });
    }).catch(function (error) {
      dispatch((0, _Loading.isLoading)(false));
      dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
      throw error;
    });
  };
};

var updateConcept = exports.updateConcept = function updateConcept(form) {
  Utils.clearNullAndEmpty(form);
  return function (dispatch) {
    dispatch((0, _Loading.isLoading)(true));

    return new _ClientHttpRequest2.default({
      service: 'api/updateConcept',
      method: 'POST',
      data: _extends({}, form),
      headers: Object.assign({ Authorization: sessionStorage.access_token, uid: sessionStorage.uid })
    }).request().then(function (response) {
      dispatch((0, _Loading.isLoading)(false));
      return response.data;
    }).catch(function (error) {
      dispatch((0, _Loading.isLoading)(false));
      dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
      throw error;
    });
  };
};

var deleteConcept = exports.deleteConcept = function deleteConcept(id) {
  return function (dispatch) {
    dispatch((0, _Loading.isLoading)(true));

    return new _ClientHttpRequest2.default({
      service: 'api/deleteConcept',
      method: 'POST',
      data: { id: id },
      headers: Object.assign({ Authorization: sessionStorage.access_token, uid: sessionStorage.uid })
    }).request().then(function (response) {
      dispatch((0, _Loading.isLoading)(false));
      // dispatch({ type: ACTION_CONCEPT, Obj: response.data })
    }).catch(function (error) {
      dispatch((0, _Loading.isLoading)(false));
      dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
      throw error;
    });
  };
};

var searchConcept = exports.searchConcept = function searchConcept(form) {
  Utils.clearNullAndEmpty(form);

  return function (dispatch) {
    dispatch((0, _Loading.isLoading)(true));

    return new _ClientHttpRequest2.default({
      service: 'api/searchParamConcept',
      method: 'POST',
      data: _extends({}, form),
      headers: Object.assign({ Authorization: sessionStorage.access_token, uid: sessionStorage.uid })
    }).request().then(function (response) {
      dispatch((0, _Loading.isLoading)(false));
      dispatch({ type: ACTION_GET_CONCEPTS, Obj: response.data });
    }).catch(function (error) {
      dispatch((0, _Loading.isLoading)(false));
      dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
      throw error;
    });
  };
};

var clearConcept = exports.clearConcept = function clearConcept() {
  return function (dispatch) {
    dispatch({ type: ACTION_GET_CONCEPTS, Obj: [] });
    dispatch({ type: ACTION_GET_CONCEPT, Obj: {} });
  };
};

/***/ }),

/***/ 462:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.setUpdateMailLegal = exports.clearLegalRepresentative = exports.deleteLegalRepresentative = exports.setLegalRepresentative = exports.getLegalRepresentatives = exports.SET_LEGAL_REPS = undefined;

var _Utils = __webpack_require__(2);

var Utils = _interopRequireWildcard(_Utils);

var _ClientHttpRequest = __webpack_require__(5);

var _ClientHttpRequest2 = _interopRequireDefault(_ClientHttpRequest);

var _immutable = __webpack_require__(1);

var _immutable2 = _interopRequireDefault(_immutable);

var _Modal = __webpack_require__(4);

var _Loading = __webpack_require__(3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var initialState = _immutable2.default.Map({});

/* Types */
var SET_LEGAL_REPS = exports.SET_LEGAL_REPS = 'SET_LEGAL_REPS';
//se elimina variable
/* Reducer */

exports.default = function () {
	var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	var action = arguments[1];

	//se elimina un case inecesario
	switch (action.type) {
		case SET_LEGAL_REPS:
			return new _immutable2.default.Map(action.dataObj);
		default:
			return state;
	}
};

/* Action Creators */

var getLegalRepresentatives = exports.getLegalRepresentatives = function getLegalRepresentatives(form) {

	return function (dispatch) {

		dispatch((0, _Loading.isLoading)(true));

		return new _ClientHttpRequest2.default({
			service: 'api/getLegalData',
			method: "POST",
			data: form,
			headers: Object.assign({ "Authorization": sessionStorage.access_token, "uid": sessionStorage.uid })
		}).request().then(function (response) {
			dispatch((0, _Loading.isLoading)(false));
			var dataObj = response.data.representantesLegales;
			//se cambia el valor de dataObj en la comparacion
			if (dataObj === null) dataObj = { representanteLegal: [] };

			dispatch({ type: SET_LEGAL_REPS, dataObj: dataObj });
		}).catch(function (error) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
			throw error;
		});
	};
};

var setLegalRepresentative = exports.setLegalRepresentative = function setLegalRepresentative(form) {

	form = {
		"idDonataria": form.idDonataria,
		"representantesLegales": {
			"representanteLegal": [{
				"idRepresetanteLegal": form.idRepresetanteLegal,
				"nombre": form.name,
				"apellidoPaterno": form.paternalSurname + "-" + form.mail,
				"apellidoMaterno": form.maternalSurname,
				"email": form.mail,
				"tipoPoder": form.powerType,
				"numeroEscritura": form.deedNumber,
				"fechaEscritura": form.deedDate ? form.deedDate.slice(0, 10) : undefined,
				"notario": {
					"nombre": form.notaryName,
					"apellidoPaterno": form.notaryPaternalSurname,
					"apellidoMaterno": form.notaryMaternalSurname
				},
				"numeroNotaria": form.notaryOfficeNum,
				"estado": form.state,
				"folioRPP": form.RPPFolio,
				"fechaFolioRPP": form.folioDate ? form.folioDate.slice(0, 10) : undefined,
				"inicioVigencia": form.inicioVigenciaDate ? form.inicioVigenciaDate.slice(0, 10) : undefined,
				"finVigencia": form.finVigenciaDate ? form.finVigenciaDate.slice(0, 10) : undefined
			}]
		}
	};

	return function (dispatch) {

		dispatch((0, _Loading.isLoading)(true));
		//se elimina dispatch con variable de persistencia y se retorna el response
		return new _ClientHttpRequest2.default({
			service: 'api/setLegalData',
			method: "POST",
			data: form,
			headers: Object.assign({ "Authorization": sessionStorage.access_token, "uid": sessionStorage.uid })
		}).request().then(function (response) {
			dispatch((0, _Loading.isLoading)(false));
			return response.data;
		}).catch(function (error) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
			throw error;
		});
	};
};

var deleteLegalRepresentative = exports.deleteLegalRepresentative = function deleteLegalRepresentative(idDonataria, idLegalData) {

	return function (dispatch) {

		dispatch((0, _Loading.isLoading)(true));
		//se elimina dispatch con variable de persistencia y se retorna el response
		return new _ClientHttpRequest2.default({
			service: 'api/deleteLegalData',
			method: "POST",
			data: { idDonataria: idDonataria, id: [idLegalData] },
			headers: Object.assign({ "Authorization": sessionStorage.access_token, "uid": sessionStorage.uid })
		}).request().then(function (response) {
			dispatch((0, _Loading.isLoading)(false));
			return response.data;
		}).catch(function (error) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
			throw error;
		});
	};
};

var clearLegalRepresentative = exports.clearLegalRepresentative = function clearLegalRepresentative() {

	return function (dispatch) {
		dispatch({ type: SET_LEGAL_REPS, Obj: [] });
	};
};

var setUpdateMailLegal = exports.setUpdateMailLegal = function setUpdateMailLegal(form) {

	return function (dispatch) {

		dispatch((0, _Loading.isLoading)(true));

		return new _ClientHttpRequest2.default({
			service: 'api/setUpdateMailLegal',
			method: "POST",
			data: form,
			headers: Object.assign({ "Authorization": sessionStorage.access_token, "uid": sessionStorage.uid })
		}).request().then(function (response) {
			dispatch((0, _Loading.isLoading)(false));
		}).catch(function (error) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
			throw error;
		});
	};
};

/***/ }),

/***/ 463:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.clearProject = exports.updateProject = exports.deleteProject = exports.getsProject = exports.getProject = exports.searchProject = exports.addProject = exports.ACTION_UPDATE__PROJECT = exports.ACTION_DELETE__PROJECT = exports.ACTION_GET__PROJECT = exports.ACTION_SEARCH__PROJECT = exports.ACTION_NEW__PROJECT = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _Utils = __webpack_require__(2);

var Utils = _interopRequireWildcard(_Utils);

var _ClientHttpRequest = __webpack_require__(5);

var _ClientHttpRequest2 = _interopRequireDefault(_ClientHttpRequest);

var _immutable = __webpack_require__(1);

var _immutable2 = _interopRequireDefault(_immutable);

var _Modal = __webpack_require__(4);

var _Loading = __webpack_require__(3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var initialState = _immutable2.default.Map({}).set('Search', new _immutable2.default.List([])).set('Response', new _immutable2.default.Map({})).set('Get', new _immutable2.default.Map({}));

/* Types */

var ACTION_NEW__PROJECT = exports.ACTION_NEW__PROJECT = 'ACTION_NEW__PROJECT';

var ACTION_SEARCH__PROJECT = exports.ACTION_SEARCH__PROJECT = 'ACTION_SEARCH__PROJECT';

var ACTION_GET__PROJECT = exports.ACTION_GET__PROJECT = 'ACTION_GET__PROJECT';

var ACTION_DELETE__PROJECT = exports.ACTION_DELETE__PROJECT = 'ACTION_DELETE__PROJECT';

var ACTION_UPDATE__PROJECT = exports.ACTION_UPDATE__PROJECT = 'ACTION_UPDATE__PROJECT';

/* Reducer */

exports.default = function () {
	var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	var action = arguments[1];


	switch (action.type) {
		case ACTION_NEW__PROJECT:
			return state.set('Response', new _immutable2.default.Map(action.Obj));
		case ACTION_SEARCH__PROJECT:
			return state.set('Search', new _immutable2.default.List(action.Obj));
		case ACTION_GET__PROJECT:
			return state.set('Get', new _immutable2.default.Map(action.Obj));
		case ACTION_DELETE__PROJECT:
			return state.set('Response', new _immutable2.default.Map(action.Obj));
		case ACTION_UPDATE__PROJECT:
			return state.set('Response', new _immutable2.default.Map(action.Obj));
		default:
			return state;
	}
};

/* Action Creators */

var addProject = exports.addProject = function addProject(form) {
	var data = Object.assign({}, form);
	data.preguntas = Utils.getListPropsOmit(data.preguntas, ['preguntaItem', 'valor', 'tmp', "id"]);
	data.preguntas.forEach(function (p) {
		p.seccion = p.seccion.trim();
	});
	return function (dispatch) {

		dispatch((0, _Loading.isLoading)(true));

		return new _ClientHttpRequest2.default({
			service: 'api/newProject',
			method: "POST",
			data: _extends({}, data),
			headers: Object.assign({ "Authorization": sessionStorage.access_token, "uid": sessionStorage.uid })
		}).request().then(function (response) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch({ type: ACTION_NEW__PROJECT, Obj: response.data });
			dispatch((0, _Modal.createModal)(Utils.successMessage()));
		}).catch(function (error) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
			throw error;
		});
	};
};

var searchProject = exports.searchProject = function searchProject(form) {

	Utils.clearNullAndEmpty(form);

	return function (dispatch) {

		dispatch((0, _Loading.isLoading)(true));

		return new _ClientHttpRequest2.default({
			service: Object.keys(form).length == 0 ? 'api/searchProject' : 'api/searchParamProject',
			method: "POST",
			data: _extends({}, form),
			headers: Object.assign({ "Authorization": sessionStorage.access_token, "uid": sessionStorage.uid })
		}).request().then(function (response) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch({ type: ACTION_SEARCH__PROJECT, Obj: response.data });
		}).catch(function (error) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
			throw error;
		});
	};
};

var getProject = exports.getProject = function getProject(id) {

	return function (dispatch) {

		dispatch((0, _Loading.isLoading)(true));

		return new _ClientHttpRequest2.default({
			service: 'api/getProject',
			method: "POST",
			data: { id: id },
			headers: Object.assign({ "Authorization": sessionStorage.access_token, "uid": sessionStorage.uid })
		}).request().then(function (response) {
			if (response.data.preguntas) {
				response.data.preguntas.forEach(function (p) {
					if (!p.seccion) p.seccion = "Preguntas generales";
				});
			}
			dispatch({ type: ACTION_GET__PROJECT, Obj: response.data });
			dispatch((0, _Loading.isLoading)(false));
		}).catch(function (error) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
			throw error;
		});
	};
};

var getsProject = exports.getsProject = function getsProject(id) {

	return function (dispatch) {

		dispatch((0, _Loading.isLoading)(true));
		dispatch({ type: ACTION_GET__PROJECT, Obj: {} });

		return new _ClientHttpRequest2.default({
			service: 'api/getsProject',
			method: "POST",
			data: { id: id },
			headers: Object.assign({ "Authorization": sessionStorage.access_token, "uid": sessionStorage.uid })
		}).request().then(function (response) {
			dispatch({ type: ACTION_SEARCH__PROJECT, Obj: response.data });
			dispatch((0, _Loading.isLoading)(false));
		}).catch(function (error) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
			throw error;
		});
	};
};

var deleteProject = exports.deleteProject = function deleteProject() {
	return function (dispatch) {
		return dispatch({ type: ACTION_DELETE__PROJECT, Obj: { code: '', message: '' } });
	};
};

var updateProject = exports.updateProject = function updateProject(form) {

	var data = Object.assign({}, form);

	data.preguntas = Utils.getListPropsOmit(data.preguntas, ['preguntaItem', 'valor', 'tmp', 'custom', "id"]);

	data.preguntas = Utils.unionArray(data.preguntas, data.projectRemove);

	return function (dispatch) {

		dispatch((0, _Loading.isLoading)(true));
		dispatch({ type: ACTION_GET__PROJECT, Obj: {} });

		return new _ClientHttpRequest2.default({
			service: 'api/updateProject',
			method: "POST",
			data: _extends({}, data),
			headers: Object.assign({ "Authorization": sessionStorage.access_token, "uid": sessionStorage.uid })
		}).request().then(function (response) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch({ type: ACTION_UPDATE__PROJECT, Obj: response.data });
			dispatch((0, _Modal.createModal)(Utils.successMessage()));
		}).catch(function (error) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
			throw error;
		});
	};
};

var clearProject = exports.clearProject = function clearProject() {
	return function (dispatch) {
		dispatch({ type: ACTION_GET__PROJECT, Obj: {} });
		dispatch({ type: ACTION_SEARCH__PROJECT, Obj: [] });
	};
};

/***/ }),

/***/ 464:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.clearRange = exports.updateRange = exports.deleteRange = exports.getRange = exports.searchRange = exports.addRange = exports.ACTION_UPDATE_RANGE = exports.ACTION_DELETE_RANGE = exports.ACTION_GET_RANGE = exports.ACTION_SEARCH_RANGE = exports.ACTION_NEW_RANGE = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _Utils = __webpack_require__(2);

var Utils = _interopRequireWildcard(_Utils);

var _ClientHttpRequest = __webpack_require__(5);

var _ClientHttpRequest2 = _interopRequireDefault(_ClientHttpRequest);

var _immutable = __webpack_require__(1);

var _immutable2 = _interopRequireDefault(_immutable);

var _Modal = __webpack_require__(4);

var _Loading = __webpack_require__(3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var initialState = _immutable2.default.Map({}).set('Search', new _immutable2.default.List([])).set('Response', new _immutable2.default.Map({})).set('Get', new _immutable2.default.Map({}));

/* Types */
var ACTION_NEW_RANGE = exports.ACTION_NEW_RANGE = 'ACTION_NEW_RANGE';

var ACTION_SEARCH_RANGE = exports.ACTION_SEARCH_RANGE = 'ACTION_SEARCH_RANGE';

var ACTION_GET_RANGE = exports.ACTION_GET_RANGE = 'ACTION_GET_RANGE';

var ACTION_DELETE_RANGE = exports.ACTION_DELETE_RANGE = 'ACTION_DELETE_RANGE';

var ACTION_UPDATE_RANGE = exports.ACTION_UPDATE_RANGE = 'ACTION_UPDATE_RANGE';

/* Reducer */

exports.default = function () {
	var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	var action = arguments[1];


	switch (action.type) {
		case ACTION_NEW_RANGE:
			return state.set('Response', new _immutable2.default.Map(action.Obj));
		case ACTION_SEARCH_RANGE:
			return state.set('Search', new _immutable2.default.List(action.Obj));
		case ACTION_GET_RANGE:
			return state.set('Get', new _immutable2.default.Map(action.Obj));
		case ACTION_DELETE_RANGE:
			return state.set('Response', new _immutable2.default.Map(action.Obj));
		case ACTION_UPDATE_RANGE:
			return state.set('Response', new _immutable2.default.Map(action.Obj));
		default:
			return state;
	}
};

/* Action Creators */

var addRange = exports.addRange = function addRange(form) {

	var data = Object.assign({}, form);
	data.categoria = Utils.getListPropsOmit(data.categoria, ['id', 'tmp']);

	return function (dispatch) {

		dispatch((0, _Loading.isLoading)(true));

		return new _ClientHttpRequest2.default({
			service: 'api/newRange',
			method: "POST",
			data: _extends({}, data),
			headers: Object.assign({ "Authorization": sessionStorage.access_token, "uid": sessionStorage.uid })
		}).request().then(function () {
			dispatch((0, _Loading.isLoading)(false));
			dispatch((0, _Modal.createModal)(Utils.successMessage()));
		}).catch(function (error) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
			throw error;
		});
	};
};

var searchRange = exports.searchRange = function searchRange(form) {

	Utils.clearNullAndEmpty(form);

	return function (dispatch) {

		dispatch((0, _Loading.isLoading)(true));

		return new _ClientHttpRequest2.default({
			service: Object.keys(form).length == 0 ? 'api/searchRange' : 'api/searchParamRange',
			method: "POST",
			data: _extends({}, form),
			headers: Object.assign({ "Authorization": sessionStorage.access_token, "uid": sessionStorage.uid })
		}).request().then(function (response) {
			dispatch({ type: ACTION_SEARCH_RANGE, Obj: response.data });
			dispatch((0, _Loading.isLoading)(false));
		}).catch(function (error) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
			throw error;
		});
	};
};

var getRange = exports.getRange = function getRange(id) {

	return function (dispatch) {

		dispatch((0, _Loading.isLoading)(true));

		return new _ClientHttpRequest2.default({
			service: 'api/getRange',
			method: "POST",
			data: { id: id },
			headers: Object.assign({ "Authorization": sessionStorage.access_token, "uid": sessionStorage.uid })
		}).request().then(function (response) {
			dispatch({ type: ACTION_GET_RANGE, Obj: response.data });
			dispatch((0, _Loading.isLoading)(false));
		}).catch(function (error) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
			throw error;
		});
	};
};

var deleteRange = exports.deleteRange = function deleteRange(id) {

	return function (dispatch) {

		dispatch((0, _Loading.isLoading)(true));

		return new _ClientHttpRequest2.default({
			service: 'api/deleteRange',
			method: "POST",
			data: { id: id },
			headers: Object.assign({ "Authorization": sessionStorage.access_token, "uid": sessionStorage.uid })
		}).request().then(function (response) {
			dispatch({ type: ACTION_DELETE_RANGE, Obj: response.data });
			dispatch((0, _Loading.isLoading)(false));
		}).catch(function (error) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
			throw error;
		});
	};
};

var updateRange = exports.updateRange = function updateRange(form) {

	var data = Object.assign({}, form);
	data.categoria = data.categoria.map(function (cat) {
		if (cat.tmp) {
			delete cat.id;
			delete cat.tmp;
		}
		return cat;
	});
	data.categoria = Utils.unionArray(data.categoria, data.categoriaRemove);

	return function (dispatch) {

		dispatch((0, _Loading.isLoading)(true));
		dispatch({ type: ACTION_GET_RANGE, Obj: {} });

		return new _ClientHttpRequest2.default({
			service: 'api/updateRange',
			method: "POST",
			data: _extends({}, data),
			headers: Object.assign({ "Authorization": sessionStorage.access_token, "uid": sessionStorage.uid })
		}).request().then(function (response) {
			dispatch({ type: ACTION_UPDATE_RANGE, Obj: response.data });
			dispatch((0, _Loading.isLoading)(false));
			dispatch((0, _Modal.createModal)(Utils.successMessage()));
		}).catch(function (error) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
			throw error;
		});
	};
};

var clearRange = exports.clearRange = function clearRange() {
	return function (dispatch) {
		dispatch({ type: ACTION_GET_RANGE, Obj: {} });
		dispatch({ type: ACTION_SEARCH_RANGE, Obj: [] });
	};
};

/***/ }),

/***/ 465:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.clearScale = exports.updateScale = exports.deleteScale = exports.getScale = exports.searchScale = exports.addScale = exports.ACTION_UPDATE_SCALE = exports.ACTION_DELETE_SCALE = exports.ACTION_GET_SCALE = exports.ACTION_SEARCH_SCALE = exports.ACTION_NEW_SCALE = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _Utils = __webpack_require__(2);

var Utils = _interopRequireWildcard(_Utils);

var _ClientHttpRequest = __webpack_require__(5);

var _ClientHttpRequest2 = _interopRequireDefault(_ClientHttpRequest);

var _immutable = __webpack_require__(1);

var _immutable2 = _interopRequireDefault(_immutable);

var _Modal = __webpack_require__(4);

var _Loading = __webpack_require__(3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var initialState = _immutable2.default.Map({}).set('Search', new _immutable2.default.List([])).set('Response', new _immutable2.default.Map({})).set('Get', new _immutable2.default.Map({}));

/* Types */
var ACTION_NEW_SCALE = exports.ACTION_NEW_SCALE = 'ACTION_NEW_SCALE';

var ACTION_SEARCH_SCALE = exports.ACTION_SEARCH_SCALE = 'ACTION_SEARCH_SCALE';

var ACTION_GET_SCALE = exports.ACTION_GET_SCALE = 'ACTION_GET_SCALE';

var ACTION_DELETE_SCALE = exports.ACTION_DELETE_SCALE = 'ACTION_DELETE_SCALE';

var ACTION_UPDATE_SCALE = exports.ACTION_UPDATE_SCALE = 'ACTION_UPDATE_SCALE';

/* Reducer */

exports.default = function () {
	var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	var action = arguments[1];


	switch (action.type) {
		case ACTION_NEW_SCALE:
			return state.set('Response', new _immutable2.default.Map(action.Obj));
		case ACTION_SEARCH_SCALE:
			return state.set('Search', new _immutable2.default.List(action.Obj));
		case ACTION_GET_SCALE:
			return state.set('Get', new _immutable2.default.Map(action.Obj));
		case ACTION_DELETE_SCALE:
			return state.set('Response', new _immutable2.default.Map(action.Obj));
		case ACTION_UPDATE_SCALE:
			return state.set('Response', new _immutable2.default.Map(action.Obj));
		default:
			return state;
	}
};

/* Action Creators */

var addScale = exports.addScale = function addScale(form) {

	var data = Object.assign({}, form);
	data.categoria = Utils.getListPropsOmit(data.categoria, ['id', 'tmp']);

	return function (dispatch) {

		dispatch((0, _Loading.isLoading)(true));

		return new _ClientHttpRequest2.default({
			service: 'api/newScale',
			method: "POST",
			data: _extends({}, data),
			headers: Object.assign({ "Authorization": sessionStorage.access_token, "uid": sessionStorage.uid })
		}).request().then(function () {
			dispatch((0, _Loading.isLoading)(false));
			dispatch((0, _Modal.createModal)(Utils.successMessage()));
		}).catch(function (error) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
			throw error;
		});
	};
};

var searchScale = exports.searchScale = function searchScale(form) {

	Utils.clearNullAndEmpty(form);

	return function (dispatch) {

		dispatch((0, _Loading.isLoading)(true));

		return new _ClientHttpRequest2.default({
			service: Object.keys(form).length == 0 ? 'api/searchScale' : 'api/searchParamScale',
			method: "POST",
			data: _extends({}, form),
			headers: Object.assign({ "Authorization": sessionStorage.access_token, "uid": sessionStorage.uid })
		}).request().then(function (response) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch({ type: ACTION_SEARCH_SCALE, Obj: response.data });
		}).catch(function (error) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
			throw error;
		});
	};
};

var getScale = exports.getScale = function getScale(id) {

	return function (dispatch) {

		dispatch((0, _Loading.isLoading)(true));

		return new _ClientHttpRequest2.default({
			service: 'api/getScale',
			method: "POST",
			data: { id: id },
			headers: Object.assign({ "Authorization": sessionStorage.access_token, "uid": sessionStorage.uid })
		}).request().then(function (response) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch({ type: ACTION_GET_SCALE, Obj: response.data });
		}).catch(function (error) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
			throw error;
		});
	};
};

var deleteScale = exports.deleteScale = function deleteScale(id) {

	return function (dispatch) {

		dispatch((0, _Loading.isLoading)(true));

		return new _ClientHttpRequest2.default({
			service: 'api/deleteScale',
			method: "POST",
			data: { id: id },
			headers: Object.assign({ "Authorization": sessionStorage.access_token, "uid": sessionStorage.uid })
		}).request().then(function () {
			dispatch((0, _Loading.isLoading)(false));
			dispatch((0, _Modal.createModal)(Utils.successMessage()));
		}).catch(function (error) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
			throw error;
		});
	};
};

var updateScale = exports.updateScale = function updateScale(form) {

	var data = Object.assign({}, form);
	data.categoria = Utils.getListPropsOmitById(data.categoria, "tmp", ['id', 'tmp']);
	data.categoria = Utils.unionArray(data.categoria, data.categoriaRemove);
	delete data.categoriaRemove;

	return function (dispatch) {

		dispatch((0, _Loading.isLoading)(true));
		dispatch({ type: ACTION_GET_SCALE, Obj: {} });

		return new _ClientHttpRequest2.default({
			service: 'api/updateScale',
			method: "POST",
			data: _extends({}, data),
			headers: Object.assign({ "Authorization": sessionStorage.access_token, "uid": sessionStorage.uid })
		}).request().then(function (response) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch({ type: ACTION_UPDATE_SCALE, Obj: response.data });
			dispatch((0, _Modal.createModal)(Utils.successMessage()));
		}).catch(function (error) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
			throw error;
		});
	};
};

var clearScale = exports.clearScale = function clearScale() {
	return function (dispatch) {
		dispatch({ type: ACTION_GET_SCALE, Obj: {} });
		dispatch({ type: ACTION_SEARCH_SCALE, Obj: [] });
	};
};

/***/ }),

/***/ 466:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.clearServices = exports.updateServices = exports.deleteServices = exports.getServices = exports.searchServices = exports.addServices = exports.ACTION_UPDATE_SERVICES = exports.ACTION_DELETE_SERVICES = exports.ACTION_GET_SERVICES = exports.ACTION_SEARCH_SERVICES = exports.ACTION_NEW_SERVICES = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _Utils = __webpack_require__(2);

var Utils = _interopRequireWildcard(_Utils);

var _ClientHttpRequest = __webpack_require__(5);

var _ClientHttpRequest2 = _interopRequireDefault(_ClientHttpRequest);

var _immutable = __webpack_require__(1);

var _immutable2 = _interopRequireDefault(_immutable);

var _Modal = __webpack_require__(4);

var _Loading = __webpack_require__(3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var initialState = _immutable2.default.Map({}).set('Search', new _immutable2.default.List([])).set('Response', new _immutable2.default.Map({})).set('Get', new _immutable2.default.Map({}));

/* Types */
var ACTION_NEW_SERVICES = exports.ACTION_NEW_SERVICES = 'ACTION_NEW_SERVICES';

var ACTION_SEARCH_SERVICES = exports.ACTION_SEARCH_SERVICES = 'ACTION_SEARCH_SERVICES';

var ACTION_GET_SERVICES = exports.ACTION_GET_SERVICES = 'ACTION_GET_SERVICES';

var ACTION_DELETE_SERVICES = exports.ACTION_DELETE_SERVICES = 'ACTION_DELETE_SERVICES';

var ACTION_UPDATE_SERVICES = exports.ACTION_UPDATE_SERVICES = 'ACTION_UPDATE_SERVICES';

/* Reducer */

exports.default = function () {
	var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	var action = arguments[1];


	switch (action.type) {
		case ACTION_NEW_SERVICES:
			return state.set('Response', new _immutable2.default.Map(action.Obj));
		case ACTION_SEARCH_SERVICES:
			return state.set('Search', new _immutable2.default.List(action.Obj));
		case ACTION_GET_SERVICES:
			return state.set('Get', new _immutable2.default.Map(action.Obj));
		case ACTION_DELETE_SERVICES:
			return state.set('Response', new _immutable2.default.Map(action.Obj));
		case ACTION_UPDATE_SERVICES:
			return state.set('Response', new _immutable2.default.Map(action.Obj));
		default:
			return state;
	}
};

/* Action Creators */


var addServices = exports.addServices = function addServices(form) {

	return function (dispatch) {

		dispatch((0, _Loading.isLoading)(true));

		return new _ClientHttpRequest2.default({
			service: 'api/newServices',
			method: "POST",
			data: _extends({}, form),
			headers: Object.assign({ "Authorization": sessionStorage.access_token, "uid": sessionStorage.uid })
		}).request().then(function (response) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch({ type: ACTION_NEW_SERVICES, Obj: response.data });
			dispatch((0, _Modal.createModal)(Utils.successMessage()));
		}).catch(function (error) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
			throw error;
		});
	};
};

var searchServices = exports.searchServices = function searchServices(form) {

	Utils.clearNullAndEmpty(form);

	return function (dispatch) {

		dispatch((0, _Loading.isLoading)(true));

		return new _ClientHttpRequest2.default({
			service: Object.keys(form).length == 0 ? 'api/searchServices' : 'api/searchParamServices',
			method: "POST",
			data: _extends({}, form),
			headers: Object.assign({ "Authorization": sessionStorage.access_token, "uid": sessionStorage.uid })
		}).request().then(function (response) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch({ type: ACTION_SEARCH_SERVICES, Obj: response.data });
		}).catch(function (error) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
			throw error;
		});
	};
};

var getServices = exports.getServices = function getServices(id) {

	return function (dispatch) {

		dispatch((0, _Loading.isLoading)(true));

		return new _ClientHttpRequest2.default({
			service: 'api/getServices',
			method: "POST",
			data: { id: id },
			headers: Object.assign({ "Authorization": sessionStorage.access_token, "uid": sessionStorage.uid })
		}).request().then(function (response) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch({ type: ACTION_GET_SERVICES, Obj: response.data });
		}).catch(function (error) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
			throw error;
		});
	};
};

var deleteServices = exports.deleteServices = function deleteServices() {
	return function (dispatch) {
		return dispatch({ type: ACTION_DELETE_SERVICES, Obj: { code: '', message: '' } });
	};
};

var updateServices = exports.updateServices = function updateServices(form) {

	return function (dispatch) {

		dispatch((0, _Loading.isLoading)(true));
		dispatch({ type: ACTION_GET_SERVICES, Obj: {} });

		return new _ClientHttpRequest2.default({
			service: 'api/updateServices',
			method: "POST",
			data: _extends({}, form),
			headers: Object.assign({ "Authorization": sessionStorage.access_token, "uid": sessionStorage.uid })
		}).request().then(function (response) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch({ type: ACTION_UPDATE_SERVICES, Obj: response.data });
			dispatch((0, _Modal.createModal)(Utils.successMessage()));
		}).catch(function (error) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
			throw error;
		});
	};
};

var clearServices = exports.clearServices = function clearServices() {
	return function (dispatch) {
		dispatch({ type: ACTION_GET_SERVICES, Obj: {} });
		dispatch({ type: ACTION_SEARCH_SERVICES, Obj: [] });
	};
};

/***/ }),

/***/ 467:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.clearStage = exports.updateStage = exports.deleteStage = exports.getStage = exports.searchStage = exports.addStage = exports.ACTION_UPDATE_STAGE_STRENG = exports.ACTION_DELETE_STAGE_STRENG = exports.ACTION_GET_STAGE_STRENG = exports.ACTION_SEARCH_STAGE_STRENG = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _Utils = __webpack_require__(2);

var Utils = _interopRequireWildcard(_Utils);

var _ClientHttpRequest = __webpack_require__(5);

var _ClientHttpRequest2 = _interopRequireDefault(_ClientHttpRequest);

var _immutable = __webpack_require__(1);

var _immutable2 = _interopRequireDefault(_immutable);

var _Modal = __webpack_require__(4);

var _Loading = __webpack_require__(3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var initialState = _immutable2.default.Map({}).set('Search', new _immutable2.default.List([])).set('Response', new _immutable2.default.Map({})).set('Get', new _immutable2.default.Map({}));

/* Types */
var ACTION_SEARCH_STAGE_STRENG = exports.ACTION_SEARCH_STAGE_STRENG = 'ACTION_SEARCH_STAGE_STRENG';

var ACTION_GET_STAGE_STRENG = exports.ACTION_GET_STAGE_STRENG = 'ACTION_GET_STAGE_STRENG';

var ACTION_DELETE_STAGE_STRENG = exports.ACTION_DELETE_STAGE_STRENG = 'ACTION_DELETE_STAGE_STRENG';

var ACTION_UPDATE_STAGE_STRENG = exports.ACTION_UPDATE_STAGE_STRENG = 'ACTION_UPDATE_STAGE_STRENG';

/* Reducer */

exports.default = function () {
	var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	var action = arguments[1];


	switch (action.type) {

		case ACTION_SEARCH_STAGE_STRENG:
			return state.set('Search', new _immutable2.default.List(action.Obj));
		case ACTION_GET_STAGE_STRENG:
			return state.set('Get', new _immutable2.default.Map(action.Obj));
		case ACTION_DELETE_STAGE_STRENG:
			return state.set('Response', new _immutable2.default.Map(action.Obj));
		case ACTION_UPDATE_STAGE_STRENG:
			return state.set('Response', new _immutable2.default.Map(action.Obj));
		default:
			return state;
	}
};

/* Action Creators */

var addStage = exports.addStage = function addStage(form) {

	return function (dispatch) {

		dispatch((0, _Loading.isLoading)(true));

		return new _ClientHttpRequest2.default({
			service: 'api/newStageStreng',
			method: "POST",
			data: _extends({}, form),
			headers: Object.assign({ "Authorization": sessionStorage.access_token, "uid": sessionStorage.uid })
		}).request().then(function () {
			dispatch((0, _Loading.isLoading)(false));
			dispatch((0, _Modal.createModal)(Utils.successMessage()));
		}).catch(function (error) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
			throw error;
		});
	};
};

var searchStage = exports.searchStage = function searchStage(form) {

	Utils.clearNullAndEmpty(form);

	return function (dispatch) {

		dispatch((0, _Loading.isLoading)(true));

		return new _ClientHttpRequest2.default({
			service: Object.keys(form).length == 0 ? 'api/searchStageStreng' : 'api/searchParamStageStreng',
			method: "POST",
			data: _extends({}, form),
			headers: Object.assign({ "Authorization": sessionStorage.access_token, "uid": sessionStorage.uid })
		}).request().then(function (response) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch({ type: ACTION_SEARCH_STAGE_STRENG, Obj: response.data });
		}).catch(function (error) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
			throw error;
		});
	};
};

var getStage = exports.getStage = function getStage(id) {

	return function (dispatch) {

		dispatch((0, _Loading.isLoading)(true));

		return new _ClientHttpRequest2.default({
			service: 'api/getStageStreng',
			method: "POST",
			data: { id: id },
			headers: Object.assign({ "Authorization": sessionStorage.access_token, "uid": sessionStorage.uid })
		}).request().then(function (response) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch({ type: ACTION_GET_STAGE_STRENG, Obj: response.data });
		}).catch(function (error) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
			throw error;
		});
	};
};

var deleteStage = exports.deleteStage = function deleteStage() {
	return function (dispatch) {
		return dispatch({ type: ACTION_DELETE_STAGE_STRENG, Obj: { code: '', message: '' } });
	};
};

var updateStage = exports.updateStage = function updateStage(form) {

	return function (dispatch) {

		dispatch((0, _Loading.isLoading)(true));
		dispatch({ type: ACTION_GET_STAGE_STRENG, Obj: {} });

		return new _ClientHttpRequest2.default({
			service: 'api/updateStageStreng',
			method: "POST",
			data: _extends({}, form),
			headers: Object.assign({ "Authorization": sessionStorage.access_token, "uid": sessionStorage.uid })
		}).request().then(function (response) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch({ type: ACTION_UPDATE_STAGE_STRENG, Obj: response.data });
			dispatch((0, _Modal.createModal)(Utils.successMessage()));
		}).catch(function (error) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
			throw error;
		});
	};
};

var clearStage = exports.clearStage = function clearStage() {
	return function (dispatch) {
		dispatch({ type: ACTION_GET_STAGE_STRENG, Obj: {} });
		dispatch({ type: ACTION_SEARCH_STAGE_STRENG, Obj: [] });
	};
};

/***/ }),

/***/ 468:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.clearStateGrantee = exports.searchStateGrantee = exports.ACTION_SEARCH_STATE_GRANTEE = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _Utils = __webpack_require__(2);

var Utils = _interopRequireWildcard(_Utils);

var _ClientHttpRequest = __webpack_require__(5);

var _ClientHttpRequest2 = _interopRequireDefault(_ClientHttpRequest);

var _immutable = __webpack_require__(1);

var _immutable2 = _interopRequireDefault(_immutable);

var _Modal = __webpack_require__(4);

var _Loading = __webpack_require__(3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var initialState = _immutable2.default.Map({}).set('Search', new _immutable2.default.List([])).set('Response', new _immutable2.default.Map({})).set('Get', new _immutable2.default.Map({}));

/* Types */

var ACTION_SEARCH_STATE_GRANTEE = exports.ACTION_SEARCH_STATE_GRANTEE = 'ACTION_SEARCH_STATE_GRANTEE';

/* Reducer */

exports.default = function () {
	var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	var action = arguments[1];


	switch (action.type) {
		case ACTION_SEARCH_STATE_GRANTEE:
			return state.set('Search', new _immutable2.default.List(action.Obj));
		default:
			return state;
	}
};

/* Action Creators */

var searchStateGrantee = exports.searchStateGrantee = function searchStateGrantee(form) {

	Utils.clearNullAndEmpty(form);

	return function (dispatch) {

		dispatch((0, _Loading.isLoading)(true));

		return new _ClientHttpRequest2.default({
			service: Object.keys(form).length == 0 ? 'api/searchStateGrantee' : 'api/searchParamStateGrantee',
			method: "POST",
			data: _extends({}, form),
			headers: Object.assign({ "Authorization": sessionStorage.access_token, "uid": sessionStorage.uid })
		}).request().then(function (response) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch({ type: ACTION_SEARCH_STATE_GRANTEE, Obj: response.data });
		}).catch(function (error) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
			throw error;
		});
	};
};

var clearStateGrantee = exports.clearStateGrantee = function clearStateGrantee() {
	return function (dispatch) {
		dispatch({ type: ACTION_SEARCH_STATE_GRANTEE, Obj: [] });
	};
};

/***/ }),

/***/ 469:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.clearState = exports.updateState = exports.deleteState = exports.getState = exports.searchState = exports.addState = exports.ACTION_UPDATE_STATE_STRENG = exports.ACTION_DELETE_STATE_STRENG = exports.ACTION_GET_STATE_STRENG = exports.ACTION_SEARCH_STATE_STRENG = exports.ACTION_NEW_STATE_STRENG = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _Utils = __webpack_require__(2);

var Utils = _interopRequireWildcard(_Utils);

var _ClientHttpRequest = __webpack_require__(5);

var _ClientHttpRequest2 = _interopRequireDefault(_ClientHttpRequest);

var _immutable = __webpack_require__(1);

var _immutable2 = _interopRequireDefault(_immutable);

var _Modal = __webpack_require__(4);

var _Loading = __webpack_require__(3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var initialState = _immutable2.default.Map({}).set('Search', new _immutable2.default.List([])).set('Response', new _immutable2.default.Map({})).set('Get', new _immutable2.default.Map({}));

/* Types */
var ACTION_NEW_STATE_STRENG = exports.ACTION_NEW_STATE_STRENG = 'ACTION_NEW_STATE_STRENG';

var ACTION_SEARCH_STATE_STRENG = exports.ACTION_SEARCH_STATE_STRENG = 'ACTION_SEARCH_STATE_STRENG';

var ACTION_GET_STATE_STRENG = exports.ACTION_GET_STATE_STRENG = 'ACTION_GET_STATE_STRENG';

var ACTION_DELETE_STATE_STRENG = exports.ACTION_DELETE_STATE_STRENG = 'ACTION_DELETE_STATE_STRENG';

var ACTION_UPDATE_STATE_STRENG = exports.ACTION_UPDATE_STATE_STRENG = 'ACTION_UPDATE_STATE_STRENG';

/* Reducer */

exports.default = function () {
	var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	var action = arguments[1];


	switch (action.type) {
		case ACTION_NEW_STATE_STRENG:
			return state.set('Response', new _immutable2.default.Map(action.Obj));
		case ACTION_SEARCH_STATE_STRENG:
			return state.set('Search', new _immutable2.default.List(action.Obj));
		case ACTION_GET_STATE_STRENG:
			return state.set('Get', new _immutable2.default.Map(action.Obj));
		case ACTION_DELETE_STATE_STRENG:
			return state.set('Response', new _immutable2.default.Map(action.Obj));
		case ACTION_UPDATE_STATE_STRENG:
			return state.set('Response', new _immutable2.default.Map(action.Obj));
		default:
			return state;
	}
};

/* Action Creators */

var addState = exports.addState = function addState(form) {

	return function (dispatch) {

		dispatch((0, _Loading.isLoading)(true));

		return new _ClientHttpRequest2.default({
			service: 'api/newStatusStreng',
			method: "POST",
			data: _extends({}, form),
			headers: Object.assign({ "Authorization": sessionStorage.access_token, "uid": sessionStorage.uid })
		}).request().then(function () {
			dispatch((0, _Loading.isLoading)(false));
			dispatch((0, _Modal.createModal)(Utils.successMessage()));
		}).catch(function (error) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
			throw error;
		});
	};
};

var searchState = exports.searchState = function searchState(form) {

	Utils.clearNullAndEmpty(form);

	return function (dispatch) {

		dispatch((0, _Loading.isLoading)(true));

		return new _ClientHttpRequest2.default({
			service: Object.keys(form).length == 0 ? 'api/searchStatusStreng' : 'api/searchParamStatusStreng',
			method: "POST",
			data: _extends({}, form),
			headers: Object.assign({ "Authorization": sessionStorage.access_token, "uid": sessionStorage.uid })
		}).request().then(function (response) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch({ type: ACTION_SEARCH_STATE_STRENG, Obj: response.data });
		}).catch(function (error) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
			throw error;
		});
	};
};

var getState = exports.getState = function getState(id) {

	return function (dispatch) {

		dispatch((0, _Loading.isLoading)(true));

		return new _ClientHttpRequest2.default({
			service: 'api/getStatusStreng',
			method: "POST",
			data: { id: id },
			headers: Object.assign({ "Authorization": sessionStorage.access_token, "uid": sessionStorage.uid })
		}).request().then(function (response) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch({ type: ACTION_GET_STATE_STRENG, Obj: response.data });
		}).catch(function (error) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
			throw error;
		});
	};
};

var deleteState = exports.deleteState = function deleteState(id) {

	return function (dispatch) {

		dispatch((0, _Loading.isLoading)(true));

		return new _ClientHttpRequest2.default({
			service: 'api/updateStatusStreng',
			method: "POST",
			data: { id: id },
			headers: Object.assign({ "Authorization": sessionStorage.access_token, "uid": sessionStorage.uid })
		}).request().then(function () {
			dispatch((0, _Loading.isLoading)(false));
			dispatch((0, _Modal.createModal)(Utils.successMessage()));
		}).catch(function (error) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
			throw error;
		});
	};
};

var updateState = exports.updateState = function updateState(form) {

	return function (dispatch) {

		dispatch((0, _Loading.isLoading)(true));
		dispatch({ type: ACTION_GET_STATE_STRENG, Obj: {} });

		return new _ClientHttpRequest2.default({
			service: 'api/updateStatusStreng',
			method: "POST",
			data: _extends({}, form),
			headers: Object.assign({ "Authorization": sessionStorage.access_token, "uid": sessionStorage.uid })
		}).request().then(function (response) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch({ type: ACTION_UPDATE_STATE_STRENG, Obj: response.data });
			dispatch((0, _Modal.createModal)(Utils.successMessage()));
		}).catch(function (error) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
			throw error;
		});
	};
};

var clearState = exports.clearState = function clearState() {
	return function (dispatch) {
		dispatch({ type: ACTION_GET_STATE_STRENG, Obj: {} });
		dispatch({ type: ACTION_SEARCH_STATE_STRENG, Obj: [] });
	};
};

/***/ }),

/***/ 470:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.clearSubtheme = exports.updateSubtheme = exports.deleteSubtheme = exports.getSubtheme2 = exports.getSubtheme = exports.searchSubtheme = exports.addSubtheme = exports.ACTION_UPDATE_SUBTHEME = exports.ACTION_DELETE_SUBTHEME = exports.ACTION_GET_SUBTHEME2 = exports.ACTION_GET_SUBTHEME = exports.ACTION_SEARCH_SUBTHEME = exports.ACTION_NEW_SUBTHEME = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _Utils = __webpack_require__(2);

var Utils = _interopRequireWildcard(_Utils);

var _ClientHttpRequest = __webpack_require__(5);

var _ClientHttpRequest2 = _interopRequireDefault(_ClientHttpRequest);

var _immutable = __webpack_require__(1);

var _immutable2 = _interopRequireDefault(_immutable);

var _Modal = __webpack_require__(4);

var _Loading = __webpack_require__(3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var initialState = _immutable2.default.Map({}).set('Search', new _immutable2.default.List([])).set('Response', new _immutable2.default.Map({})).set('Get', new _immutable2.default.Map({}));

/* Types */
var ACTION_NEW_SUBTHEME = exports.ACTION_NEW_SUBTHEME = 'ACTION_NEW_SUBTHEME';

var ACTION_SEARCH_SUBTHEME = exports.ACTION_SEARCH_SUBTHEME = 'ACTION_SEARCH_SUBTHEME';

var ACTION_GET_SUBTHEME = exports.ACTION_GET_SUBTHEME = 'ACTION_GET_SUBTHEME';

var ACTION_GET_SUBTHEME2 = exports.ACTION_GET_SUBTHEME2 = 'ACTION_GET_SUBTHEME';

var ACTION_DELETE_SUBTHEME = exports.ACTION_DELETE_SUBTHEME = 'ACTION_DELETE_SUBTHEME';

var ACTION_UPDATE_SUBTHEME = exports.ACTION_UPDATE_SUBTHEME = 'ACTION_UPDATE_SUBTHEME';

/* Reducer */

exports.default = function () {
	var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	var action = arguments[1];


	switch (action.type) {
		case ACTION_NEW_SUBTHEME:
			return state.set('Response', new _immutable2.default.Map(action.Obj));
		case ACTION_SEARCH_SUBTHEME:
			return state.set('Search', new _immutable2.default.List(action.Obj));
		case ACTION_GET_SUBTHEME:
			return state.set('Get', new _immutable2.default.Map(action.Obj));
		case ACTION_GET_SUBTHEME2:
			return state.set('Get', new _immutable2.default.Map(action.Obj));
		case ACTION_DELETE_SUBTHEME:
			return state.set('Response', new _immutable2.default.Map(action.Obj));
		case ACTION_UPDATE_SUBTHEME:
			return state.set('Response', new _immutable2.default.Map(action.Obj));
		default:
			return state;
	}
};

/* Action Creators */

var addSubtheme = exports.addSubtheme = function addSubtheme(form) {

	return function (dispatch) {

		dispatch((0, _Loading.isLoading)(true));

		return new _ClientHttpRequest2.default({
			service: 'api/newSubtheme',
			method: "POST",
			data: _extends({}, form),
			headers: Object.assign({ "Authorization": sessionStorage.access_token, "uid": sessionStorage.uid })
		}).request().then(function () {
			dispatch((0, _Loading.isLoading)(false));
			dispatch((0, _Modal.createModal)(Utils.successMessage()));
		}).catch(function (error) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
			throw error;
		});
	};
};

var searchSubtheme = exports.searchSubtheme = function searchSubtheme(form) {
	Utils.clearNullAndEmpty(form);

	return function (dispatch) {

		dispatch((0, _Loading.isLoading)(true));

		return new _ClientHttpRequest2.default({
			service: Object.keys(form).length == 0 ? 'api/searchSubtheme' : 'api/searchParamSubtheme',
			method: "POST",
			data: _extends({}, form),
			headers: Object.assign({ "Authorization": sessionStorage.access_token, "uid": sessionStorage.uid })
		}).request().then(function (response) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch({ type: ACTION_SEARCH_SUBTHEME, Obj: response.data });
		}).catch(function (error) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
			throw error;
		});
	};
};

var getSubtheme = exports.getSubtheme = function getSubtheme(id) {
	return function (dispatch) {

		dispatch((0, _Loading.isLoading)(true));

		return new _ClientHttpRequest2.default({
			service: 'api/getSubtheme',
			method: "POST",
			data: { id: id },
			headers: Object.assign({ "Authorization": sessionStorage.access_token, "uid": sessionStorage.uid })
		}).request().then(function (response) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch({ type: ACTION_GET_SUBTHEME, Obj: response.data });
		}).catch(function (error) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
			throw error;
		});
	};
};

var getSubtheme2 = exports.getSubtheme2 = function getSubtheme2(id) {
	return function (dispatch) {

		dispatch((0, _Loading.isLoading)(true));

		return new _ClientHttpRequest2.default({
			service: 'api/getSubtheme',
			method: "POST",
			data: { id: id },
			headers: Object.assign({ "Authorization": sessionStorage.access_token, "uid": sessionStorage.uid })
		}).request().then(function (response) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch({ type: ACTION_GET_SUBTHEME2, Obj: response.data });
		}).catch(function (error) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
			throw error;
		});
	};
};

var deleteSubtheme = exports.deleteSubtheme = function deleteSubtheme(id) {

	return function (dispatch) {

		dispatch((0, _Loading.isLoading)(true));
		dispatch({ type: ACTION_GET_SUBTHEME, Obj: {} });

		return new _ClientHttpRequest2.default({
			service: 'api/deleteSubtheme',
			method: "POST",
			data: { id: id },
			headers: Object.assign({ "Authorization": sessionStorage.access_token, "uid": sessionStorage.uid })
		}).request().then(function (response) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch({ type: ACTION_DELETE_SUBTHEME, Obj: response.data });
			dispatch((0, _Modal.createModal)(Utils.successMessage()));
		}).catch(function (error) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
			throw error;
		});
	};
};

var updateSubtheme = exports.updateSubtheme = function updateSubtheme(form) {

	return function (dispatch) {

		dispatch((0, _Loading.isLoading)(true));
		dispatch({ type: ACTION_GET_SUBTHEME, Obj: {} });

		return new _ClientHttpRequest2.default({
			service: 'api/updateSubtheme',
			method: "POST",
			data: _extends({}, form),
			headers: Object.assign({ "Authorization": sessionStorage.access_token, "uid": sessionStorage.uid })
		}).request().then(function (response) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch({ type: ACTION_UPDATE_SUBTHEME, Obj: response.data });
			dispatch((0, _Modal.createModal)(Utils.successMessage()));
		}).catch(function (error) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
			throw error;
		});
	};
};

var clearSubtheme = exports.clearSubtheme = function clearSubtheme() {
	return function (dispatch) {
		dispatch({ type: ACTION_GET_SUBTHEME, Obj: {} });
		dispatch({ type: ACTION_SEARCH_SUBTHEME, Obj: [] });
	};
};

/***/ }),

/***/ 471:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.clearSubtheme2 = exports.updateSubtheme2 = exports.deleteSubtheme2 = exports.getSubtheme2 = exports.searchSubtheme2 = exports.addSubtheme2 = exports.ACTION_UPDATE_SUBTHEME2 = exports.ACTION_DELETE_SUBTHEME2 = exports.ACTION_GET_SUBTHEME2 = exports.ACTION_SEARCH_SUBTHEME2 = exports.ACTION_NEW_SUBTHEME2 = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _Utils = __webpack_require__(2);

var Utils = _interopRequireWildcard(_Utils);

var _ClientHttpRequest = __webpack_require__(5);

var _ClientHttpRequest2 = _interopRequireDefault(_ClientHttpRequest);

var _immutable = __webpack_require__(1);

var _immutable2 = _interopRequireDefault(_immutable);

var _Modal = __webpack_require__(4);

var _Loading = __webpack_require__(3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var initialState = _immutable2.default.Map({}).set('Search', new _immutable2.default.List([])).set('Response', new _immutable2.default.Map({})).set('Get', new _immutable2.default.Map({}));

/* Types */
var ACTION_NEW_SUBTHEME2 = exports.ACTION_NEW_SUBTHEME2 = 'ACTION_NEW_SUBTHEME2';

var ACTION_SEARCH_SUBTHEME2 = exports.ACTION_SEARCH_SUBTHEME2 = 'ACTION_SEARCH_SUBTHEME2';

var ACTION_GET_SUBTHEME2 = exports.ACTION_GET_SUBTHEME2 = 'ACTION_GET_SUBTHEME2';

var ACTION_DELETE_SUBTHEME2 = exports.ACTION_DELETE_SUBTHEME2 = 'ACTION_DELETE_SUBTHEME2';

var ACTION_UPDATE_SUBTHEME2 = exports.ACTION_UPDATE_SUBTHEME2 = 'ACTION_UPDATE_SUBTHEME2';

/* Reducer */

exports.default = function () {
	var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	var action = arguments[1];


	switch (action.type) {
		case ACTION_NEW_SUBTHEME2:
			return state.set('Response', new _immutable2.default.Map(action.Obj));
		case ACTION_SEARCH_SUBTHEME2:
			return state.set('Search', new _immutable2.default.List(action.Obj));
		case ACTION_GET_SUBTHEME2:
			return state.set('Get', new _immutable2.default.Map(action.Obj));
		case ACTION_DELETE_SUBTHEME2:
			return state.set('Response', new _immutable2.default.Map(action.Obj));
		case ACTION_UPDATE_SUBTHEME2:
			return state.set('Response', new _immutable2.default.Map(action.Obj));
		default:
			return state;
	}
};

/* Action Creators */

var addSubtheme2 = exports.addSubtheme2 = function addSubtheme2(form) {

	return function (dispatch) {

		dispatch((0, _Loading.isLoading)(true));

		return new _ClientHttpRequest2.default({
			service: 'api/newSubtheme2',
			method: "POST",
			data: _extends({}, form),
			headers: Object.assign({ "Authorization": sessionStorage.access_token, "uid": sessionStorage.uid })
		}).request().then(function () {
			dispatch((0, _Loading.isLoading)(false));
			dispatch((0, _Modal.createModal)(Utils.successMessage()));
		}).catch(function (error) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
			throw error;
		});
	};
};

var searchSubtheme2 = exports.searchSubtheme2 = function searchSubtheme2(form) {
	Utils.clearNullAndEmpty(form);

	return function (dispatch) {

		dispatch((0, _Loading.isLoading)(true));

		return new _ClientHttpRequest2.default({
			service: Object.keys(form).length == 0 ? 'api/searchSubtheme2' : 'api/searchParamSubtheme2',
			method: "POST",
			data: _extends({}, form),
			headers: Object.assign({ "Authorization": sessionStorage.access_token, "uid": sessionStorage.uid })
		}).request().then(function (response) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch({ type: ACTION_SEARCH_SUBTHEME2, Obj: response.data });
		}).catch(function (error) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
			throw error;
		});
	};
};

var getSubtheme2 = exports.getSubtheme2 = function getSubtheme2(id) {
	return function (dispatch) {

		dispatch((0, _Loading.isLoading)(true));

		return new _ClientHttpRequest2.default({
			service: 'api/getSubtheme2',
			method: "POST",
			data: { id: id },
			headers: Object.assign({ "Authorization": sessionStorage.access_token, "uid": sessionStorage.uid })
		}).request().then(function (response) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch({ type: ACTION_GET_SUBTHEME2, Obj: response.data });
		}).catch(function (error) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
			throw error;
		});
	};
};

var deleteSubtheme2 = exports.deleteSubtheme2 = function deleteSubtheme2(id) {

	return function (dispatch) {

		dispatch((0, _Loading.isLoading)(true));
		dispatch({ type: ACTION_GET_SUBTHEME2, Obj: {} });

		return new _ClientHttpRequest2.default({
			service: 'api/deleteSubtheme2',
			method: "POST",
			data: { id: id },
			headers: Object.assign({ "Authorization": sessionStorage.access_token, "uid": sessionStorage.uid })
		}).request().then(function (response) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch({ type: ACTION_DELETE_SUBTHEME2, Obj: response.data });
			dispatch((0, _Modal.createModal)(Utils.successMessage()));
		}).catch(function (error) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
			throw error;
		});
	};
};

var updateSubtheme2 = exports.updateSubtheme2 = function updateSubtheme2(form) {

	return function (dispatch) {

		dispatch((0, _Loading.isLoading)(true));
		dispatch({ type: ACTION_GET_SUBTHEME2, Obj: {} });

		return new _ClientHttpRequest2.default({
			service: 'api/updateSubtheme2',
			method: "POST",
			data: _extends({}, form),
			headers: Object.assign({ "Authorization": sessionStorage.access_token, "uid": sessionStorage.uid })
		}).request().then(function (response) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch({ type: ACTION_UPDATE_SUBTHEME2, Obj: response.data });
			dispatch((0, _Modal.createModal)(Utils.successMessage()));
		}).catch(function (error) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
			throw error;
		});
	};
};

var clearSubtheme2 = exports.clearSubtheme2 = function clearSubtheme2() {
	return function (dispatch) {
		dispatch({ type: ACTION_GET_SUBTHEME2, Obj: {} });
		dispatch({ type: ACTION_SEARCH_SUBTHEME2, Obj: [] });
	};
};

/***/ }),

/***/ 472:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.clearTopic = exports.updateTopic = exports.deleteTopic = exports.getTopic = exports.searchTopic = exports.addTopic = exports.ACTION_UPDATE_TOPIC = exports.ACTION_DELETE_TOPIC = exports.ACTION_GET_TOPIC = exports.ACTION_SEARCH_TOPIC = exports.ACTION_NEW_TOPIC = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _Utils = __webpack_require__(2);

var Utils = _interopRequireWildcard(_Utils);

var _ClientHttpRequest = __webpack_require__(5);

var _ClientHttpRequest2 = _interopRequireDefault(_ClientHttpRequest);

var _immutable = __webpack_require__(1);

var _immutable2 = _interopRequireDefault(_immutable);

var _Modal = __webpack_require__(4);

var _Loading = __webpack_require__(3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var initialState = _immutable2.default.Map({}).set('Search', new _immutable2.default.List([])).set('Response', new _immutable2.default.Map({})).set('Get', new _immutable2.default.Map({}));

/* Types */
var ACTION_NEW_TOPIC = exports.ACTION_NEW_TOPIC = 'ACTION_NEW_TOPIC';

var ACTION_SEARCH_TOPIC = exports.ACTION_SEARCH_TOPIC = 'ACTION_SEARCH_TOPIC';

var ACTION_GET_TOPIC = exports.ACTION_GET_TOPIC = 'ACTION_GET_TOPIC';

var ACTION_DELETE_TOPIC = exports.ACTION_DELETE_TOPIC = 'ACTION_DELETE_TOPIC';

var ACTION_UPDATE_TOPIC = exports.ACTION_UPDATE_TOPIC = 'ACTION_UPDATE_TOPIC';

/* Reducer */

exports.default = function () {
	var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	var action = arguments[1];


	switch (action.type) {
		case ACTION_NEW_TOPIC:
			return state.set('Response', new _immutable2.default.Map(action.Obj));
		case ACTION_SEARCH_TOPIC:
			return state.set('Search', new _immutable2.default.List(action.Obj));
		case ACTION_GET_TOPIC:
			return state.set('Get', new _immutable2.default.Map(action.Obj));
		case ACTION_DELETE_TOPIC:
			return state.set('Response', new _immutable2.default.Map(action.Obj));
		case ACTION_UPDATE_TOPIC:
			return state.set('Response', new _immutable2.default.Map(action.Obj));
		default:
			return state;
	}
};

/* Action Creators */

var addTopic = exports.addTopic = function addTopic(form) {

	return function (dispatch) {

		dispatch((0, _Loading.isLoading)(true));

		return new _ClientHttpRequest2.default({
			service: 'api/newTopic',
			method: "POST",
			data: _extends({}, form),
			headers: Object.assign({ "Authorization": sessionStorage.access_token, "uid": sessionStorage.uid })
		}).request().then(function () {
			dispatch((0, _Loading.isLoading)(false));
			dispatch((0, _Modal.createModal)(Utils.successMessage()));
		}).catch(function (error) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
			throw error;
		});
	};
};

var searchTopic = exports.searchTopic = function searchTopic(form) {
	Utils.clearNullAndEmpty(form);

	return function (dispatch) {

		dispatch((0, _Loading.isLoading)(true));

		return new _ClientHttpRequest2.default({
			service: Object.keys(form).length == 0 ? 'api/searchTopic' : 'api/searchParamTopic',
			method: "POST",
			data: _extends({}, form),
			headers: Object.assign({ "Authorization": sessionStorage.access_token, "uid": sessionStorage.uid })
		}).request().then(function (response) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch({ type: ACTION_SEARCH_TOPIC, Obj: response.data });
		}).catch(function (error) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
			throw error;
		});
	};
};

var getTopic = exports.getTopic = function getTopic(id) {
	return function (dispatch) {

		dispatch((0, _Loading.isLoading)(true));

		return new _ClientHttpRequest2.default({
			service: 'api/getTopic',
			method: "POST",
			data: { id: id },
			headers: Object.assign({ "Authorization": sessionStorage.access_token, "uid": sessionStorage.uid })
		}).request().then(function (response) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch({ type: ACTION_GET_TOPIC, Obj: response.data });
		}).catch(function (error) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
			throw error;
		});
	};
};

var deleteTopic = exports.deleteTopic = function deleteTopic(id) {

	return function (dispatch) {

		dispatch((0, _Loading.isLoading)(true));
		dispatch({ type: ACTION_GET_TOPIC, Obj: {} });

		return new _ClientHttpRequest2.default({
			service: 'api/deleteTopic',
			method: "POST",
			data: { id: id },
			headers: Object.assign({ "Authorization": sessionStorage.access_token, "uid": sessionStorage.uid })
		}).request().then(function (response) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch({ type: ACTION_DELETE_TOPIC, Obj: response.data });
			dispatch((0, _Modal.createModal)(Utils.successMessage()));
		}).catch(function (error) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
			throw error;
		});
	};
};

var updateTopic = exports.updateTopic = function updateTopic(form) {

	return function (dispatch) {

		dispatch((0, _Loading.isLoading)(true));
		dispatch({ type: ACTION_GET_TOPIC, Obj: {} });

		return new _ClientHttpRequest2.default({
			service: 'api/updateTopic',
			method: "POST",
			data: _extends({}, form),
			headers: Object.assign({ "Authorization": sessionStorage.access_token, "uid": sessionStorage.uid })
		}).request().then(function (response) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch({ type: ACTION_UPDATE_TOPIC, Obj: response.data });
			dispatch((0, _Modal.createModal)(Utils.successMessage()));
		}).catch(function (error) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
			throw error;
		});
	};
};

var clearTopic = exports.clearTopic = function clearTopic() {
	return function (dispatch) {
		dispatch({ type: ACTION_GET_TOPIC, Obj: {} });
		dispatch({ type: ACTION_SEARCH_TOPIC, Obj: [] });
	};
};

/***/ }),

/***/ 473:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.clearTypeTable = exports.updateTypeTable = exports.deleteTypeTable = exports.getTypeTable = exports.searchTypeTable = exports.addTypeTable = exports.ACTION_UPDATE_TYPE_TABLE = exports.ACTION_DELETE_TYPE_TABLE = exports.ACTION_GET_TYPE_TABLE = exports.ACTION_SEARCH_TYPE_TABLE = exports.ACTION_NEW_TYPE_TABLE = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _Utils = __webpack_require__(2);

var Utils = _interopRequireWildcard(_Utils);

var _ClientHttpRequest = __webpack_require__(5);

var _ClientHttpRequest2 = _interopRequireDefault(_ClientHttpRequest);

var _immutable = __webpack_require__(1);

var _immutable2 = _interopRequireDefault(_immutable);

var _Modal = __webpack_require__(4);

var _Loading = __webpack_require__(3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var initialState = _immutable2.default.Map({}).set('Search', new _immutable2.default.List([])).set('Response', new _immutable2.default.Map({})).set('Get', new _immutable2.default.Map({}));

/* Types */
var ACTION_NEW_TYPE_TABLE = exports.ACTION_NEW_TYPE_TABLE = 'ACTION_NEW_TYPE_TABLE';

var ACTION_SEARCH_TYPE_TABLE = exports.ACTION_SEARCH_TYPE_TABLE = 'ACTION_SEARCH_TYPE_TABLE';

var ACTION_GET_TYPE_TABLE = exports.ACTION_GET_TYPE_TABLE = 'ACTION_GET_TYPE_TABLE';

var ACTION_DELETE_TYPE_TABLE = exports.ACTION_DELETE_TYPE_TABLE = 'ACTION_DELETE_TYPE_TABLE';

var ACTION_UPDATE_TYPE_TABLE = exports.ACTION_UPDATE_TYPE_TABLE = 'ACTION_UPDATE_TYPE_TABLE';

/* Reducer */

exports.default = function () {
	var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	var action = arguments[1];


	switch (action.type) {
		case ACTION_NEW_TYPE_TABLE:
			return state.set('Response', new _immutable2.default.Map(action.Obj));
		case ACTION_SEARCH_TYPE_TABLE:
			return state.set('Search', new _immutable2.default.List(action.Obj));
		case ACTION_GET_TYPE_TABLE:
			return state.set('Get', new _immutable2.default.Map(action.Obj));
		case ACTION_DELETE_TYPE_TABLE:
			return state.set('Response', new _immutable2.default.Map(action.Obj));
		case ACTION_UPDATE_TYPE_TABLE:
			return state.set('Response', new _immutable2.default.Map(action.Obj));
		default:
			return state;
	}
};

/* Action Creators */

var addTypeTable = exports.addTypeTable = function addTypeTable(form) {

	return function (dispatch) {

		dispatch((0, _Loading.isLoading)(true));

		return new _ClientHttpRequest2.default({
			service: 'api/newTypeTable',
			method: "POST",
			data: _extends({}, form),
			headers: Object.assign({ "Authorization": sessionStorage.access_token, "uid": sessionStorage.uid })
		}).request().then(function () {
			dispatch((0, _Loading.isLoading)(false));
			dispatch((0, _Modal.createModal)(Utils.successMessage()));
		}).catch(function (error) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
			throw error;
		});
	};
};

var searchTypeTable = exports.searchTypeTable = function searchTypeTable(form) {

	Utils.clearNullAndEmpty(form);

	return function (dispatch) {
		dispatch((0, _Loading.isLoading)(true));

		return new _ClientHttpRequest2.default({
			service: Object.keys(form).length == 0 ? 'api/searchTypeTable' : 'api/searchParamTypeTable',
			method: "POST",
			data: _extends({}, form),
			headers: Object.assign({ "Authorization": sessionStorage.access_token, "uid": sessionStorage.uid })
		}).request().then(function (response) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch({ type: ACTION_SEARCH_TYPE_TABLE, Obj: response.data });
		}).catch(function (error) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
			throw error;
		});
	};
};

var getTypeTable = exports.getTypeTable = function getTypeTable(id) {

	return function (dispatch) {

		dispatch((0, _Loading.isLoading)(true));

		return new _ClientHttpRequest2.default({
			service: 'api/getTypeTable',
			method: "POST",
			data: { id: id },
			headers: Object.assign({ "Authorization": sessionStorage.access_token, "uid": sessionStorage.uid })
		}).request().then(function (response) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch({ type: ACTION_GET_TYPE_TABLE, Obj: response.data });
		}).catch(function (error) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
			throw error;
		});
	};
};

var deleteTypeTable = exports.deleteTypeTable = function deleteTypeTable(id) {

	return function (dispatch) {

		dispatch((0, _Loading.isLoading)(true));

		return new _ClientHttpRequest2.default({
			service: 'api/deleteTypeTable',
			method: "POST",
			data: { id: id },
			headers: Object.assign({ "Authorization": sessionStorage.access_token, "uid": sessionStorage.uid })
		}).request().then(function () {
			dispatch((0, _Loading.isLoading)(false));
			dispatch((0, _Modal.createModal)(Utils.successMessage()));
		}).catch(function (error) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
			throw error;
		});
	};
};

var updateTypeTable = exports.updateTypeTable = function updateTypeTable(form) {

	return function (dispatch) {

		dispatch((0, _Loading.isLoading)(true));
		dispatch({ type: ACTION_GET_TYPE_TABLE, Obj: {} });

		return new _ClientHttpRequest2.default({
			service: 'api/updateTypeTable',
			method: "POST",
			data: _extends({}, form),
			headers: Object.assign({ "Authorization": sessionStorage.access_token, "uid": sessionStorage.uid })
		}).request().then(function (response) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch({ type: ACTION_UPDATE_TYPE_TABLE, Obj: response.data });
			dispatch((0, _Modal.createModal)(Utils.successMessage()));
		}).catch(function (error) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
			throw error;
		});
	};
};

var clearTypeTable = exports.clearTypeTable = function clearTypeTable() {
	return function (dispatch) {
		dispatch({ type: ACTION_GET_TYPE_TABLE, Obj: {} });
		dispatch({ type: ACTION_SEARCH_TYPE_TABLE, Obj: [] });
	};
};

/***/ }),

/***/ 474:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.clearActor = exports.deleteDocumentActor = exports.uploadDocumentActor = exports.updateActorDoc = exports.updateActor = exports.getActor = exports.searchActor = exports.addActor = exports.ACTION_UPDATE_ACTOR = exports.ACTION_DELETE_ACTOR = exports.ACTION_GET_ACTOR = exports.ACTION_SEARCH_ACTOR = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _Utils = __webpack_require__(2);

var Utils = _interopRequireWildcard(_Utils);

var _ClientHttpRequest = __webpack_require__(5);

var _ClientHttpRequest2 = _interopRequireDefault(_ClientHttpRequest);

var _immutable = __webpack_require__(1);

var _immutable2 = _interopRequireDefault(_immutable);

var _Modal = __webpack_require__(4);

var _Loading = __webpack_require__(3);

var _axios = __webpack_require__(132);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var initialState = _immutable2.default.Map({}).set('Search', new _immutable2.default.List([])).set('Response', new _immutable2.default.Map({})).set('Get', new _immutable2.default.Map({}));

/* Types */
var ACTION_SEARCH_ACTOR = exports.ACTION_SEARCH_ACTOR = 'ACTION_SEARCH_ACTOR';

var ACTION_GET_ACTOR = exports.ACTION_GET_ACTOR = 'ACTION_GET_ACTOR';

var ACTION_DELETE_ACTOR = exports.ACTION_DELETE_ACTOR = 'ACTION_DELETE_ACTOR';

var ACTION_UPDATE_ACTOR = exports.ACTION_UPDATE_ACTOR = 'ACTION_UPDATE_ACTOR';

/* Reducer */

exports.default = function () {
	var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	var action = arguments[1];


	switch (action.type) {

		case ACTION_SEARCH_ACTOR:
			return state.set('Search', new _immutable2.default.List(action.Obj));
		case ACTION_GET_ACTOR:
			return state.set('Get', new _immutable2.default.Map(action.Obj));
		case ACTION_DELETE_ACTOR:
			return state.set('Response', new _immutable2.default.Map(action.Obj));
		case ACTION_UPDATE_ACTOR:
			return state.set('Response', new _immutable2.default.Map(action.Obj));
		default:
			return state;
	}
};

/* Action Creators */

var addActor = exports.addActor = function addActor(form) {

	var contactos = Utils.getListPropsOmit(form.contactos, ['id', 'tmp', 'name']);

	var temp = {
		"areaEspecialidad": form.expAreas,
		"comentarios": form.commentaries,
		contactos: contactos,
		"createdBy": sessionStorage.uid,
		"createdDate": new Date().toISOString(),
		"deleted": form.status,
		"domicilio": {
			"calle": form.street,
			"deleted": false,
			"entreCalle1": form.bstreet1,
			"entreCalle2": form.bstreet2,
			"idCiudad": form.city,
			"idCodigoPostal": form.cp,
			"idColonia": form.colony,
			"idEstado": form.state,
			"idMunicipioDelegacion": form.town,
			"numeroExterior": form.numext,
			"numeroInterior": form.numint,
			"referencia": form.reference,
			"tipoDomicilio": "Fiscal"
		},
		"email": form.mail,
		"estatus": form.status == 2 ? 'I' : 'A',
		"experiencia": form.experience,
		"extension": form.ext,
		"lastModifiedBy": null,
		"lastModifiedDate": null,
		"paginaWeb": form.website,
		"razonSocial": form.razonSocial,
		"siglas": form.acronym,
		"telefono": form.telefono
	};

	return function (dispatch) {

		dispatch((0, _Loading.isLoading)(true));

		return new _ClientHttpRequest2.default({
			service: 'api/newActor',
			method: "POST",
			data: _extends({}, temp),
			headers: Object.assign({ "Authorization": sessionStorage.access_token, "uid": sessionStorage.uid })
		}).request().then(function (response) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch({ type: ACTION_UPDATE_ACTOR, Obj: _extends({}, form, { id: response.data.id }) });
			return response.data;
		}).catch(function (error) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
			throw error;
		});
	};
};

var searchActor = exports.searchActor = function searchActor(form) {

	Utils.clearNullAndEmpty(form);

	return function (dispatch) {

		dispatch((0, _Loading.isLoading)(true));

		return new _ClientHttpRequest2.default({
			service: Object.keys(form).length == 0 ? 'api/getAllActor' : 'api/searchActor',
			method: "POST",
			data: _extends({}, form),
			headers: Object.assign({ "Authorization": sessionStorage.access_token, "uid": sessionStorage.uid })
		}).request().then(function (response) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch({ type: ACTION_SEARCH_ACTOR, Obj: response.data });
			return response.data;
		}).catch(function (error) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
			throw error;
		});
	};
};

var getActor = exports.getActor = function getActor(id) {

	return function (dispatch) {

		dispatch((0, _Loading.isLoading)(true));

		return new _ClientHttpRequest2.default({
			service: 'api/getActor',
			method: "POST",
			data: { id: id },
			headers: Object.assign({ "Authorization": sessionStorage.access_token, "uid": sessionStorage.uid })
		}).request().then(function (response) {
			dispatch((0, _Loading.isLoading)(false));
			var data = response.data;

			var contactos = [];
			var documentosOtroActor = [];

			if (data.contactos !== null) {
				contactos = data.contactos.map(function (c) {
					return _extends({}, c, { name: c.nombre + ' ' + c.apellidoPaterno + ' ' + c.apellidoMaterno });
				});
				contactos = contactos.filter(function (c) {
					return !c.deleted;
				});
			}

			if (data.documentosOtroActor) {
				documentosOtroActor = data.documentosOtroActor.map(function (d) {
					return {
						id: d.idDocumento,
						nombre: decodeURI(d.nombre),
						descripcion: d.descripcion,
						documento: {
							idDocumento: d.dropboxId
						}
					};
				});
			}

			var temp = {
				id: data.id,
				razonSocial: data.razonSocial,
				acronym: data.siglas,
				status: !data.deleted ? 1 : 2,
				telefono: data.telefono,
				ext: data.extension,
				mail: data.email,
				website: data.paginaWeb,
				cp: data.domicilio.idCodigoPostal,
				state: data.domicilio.idEstado,
				town: data.domicilio.idMunicipioDelegacion,
				city: data.domicilio.idCiudad,
				colony: data.domicilio.idColonia,
				street: data.domicilio.calle,
				numext: data.domicilio.numeroExterior,
				numint: data.domicilio.numeroInterior,
				bstreet1: data.domicilio.entreCalle1,
				bstreet2: data.domicilio.entreCalle2,
				reference: data.domicilio.referencia,
				commentaries: data.comentarios,
				experience: data.experiencia,
				expAreas: data.areaEspecialidad,
				contactos: contactos,
				documentosOtroActor: documentosOtroActor
			};

			dispatch({ type: ACTION_GET_ACTOR, Obj: temp });
			return response.data;
		}).catch(function (error) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
			throw error;
		});
	};
};

var updateActor = exports.updateActor = function updateActor(form) {
	var data = Object.assign({}, form);
	data.contactos = Utils.getListPropsOmit(data.contactos, ['id', 'tmp', 'name']);
	data.contactos = Utils.unionArray(data.contactos, data.contactosRemove);

	var contactos = data.contactos.map(function (c) {
		delete c.name;
		return _extends({}, c);
	});

	var temp = {
		"areaEspecialidad": form.expAreas,
		"comentarios": form.commentaries,
		contactos: contactos,
		"deleted": form.status,
		"domicilio": {
			"calle": form.street,
			"deleted": false,
			"entreCalle1": form.bstreet1,
			"entreCalle2": form.bstreet2,
			"idCiudad": form.city,
			"idCodigoPostal": form.cp,
			"idColonia": form.colony,
			"idEstado": form.state,
			"idMunicipioDelegacion": form.town,
			"numeroExterior": form.numext,
			"numeroInterior": form.numint,
			"referencia": form.reference
		},
		"email": form.mail,
		"id": form.id,
		"estatus": form.status == 2 ? 'I' : 'A',
		"experiencia": form.experience,
		"extension": form.ext,
		"lastModifiedBy": sessionStorage.uid,
		"lastModifiedDate": new Date().toISOString(),
		"paginaWeb": form.website,
		"razonSocial": form.razonSocial,
		"siglas": form.acronym,
		"telefono": form.telefono
	};

	return function (dispatch) {

		dispatch((0, _Loading.isLoading)(true));

		return new _ClientHttpRequest2.default({
			service: 'api/setActor',
			method: "POST",
			data: _extends({}, temp),
			headers: Object.assign({ "Authorization": sessionStorage.access_token, "uid": sessionStorage.uid })
		}).request().then(function (response) {
			dispatch((0, _Loading.isLoading)(false));
			return response.data;
		}).catch(function (error) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
			throw error;
		});
	};
};

var updateActorDoc = exports.updateActorDoc = function updateActorDoc(form) {

	return function (dispatch) {

		dispatch((0, _Loading.isLoading)(true));

		return new _ClientHttpRequest2.default({
			service: 'api/setActorDoc',
			method: "POST",
			data: _extends({}, form),
			headers: Object.assign({ "Authorization": sessionStorage.access_token, "uid": sessionStorage.uid })
		}).request().then(function (response) {
			dispatch((0, _Loading.isLoading)(false));
			return response.data;
		}).catch(function (error) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
			throw error;
		});
	};
};

var uploadDocumentActor = exports.uploadDocumentActor = function uploadDocumentActor(form) {

	var headers = {
		"Content-Type": "multipart/form-data",
		"Authorization": sessionStorage.access_token, "uid": sessionStorage.uid
	};

	if (localStorage.type == 'Donataria') {
		headers.idDonataria = localStorage.idDonataria || '';
	}

	return function (dispatch) {

		dispatch((0, _Loading.isLoading)(true));

		return (0, _axios.post)('/api/uploadDocumentActor', form, { headers: headers }).then(function (response) {
			dispatch((0, _Loading.isLoading)(false));

			return response.data;
		}).catch(function (error) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
			throw error;
		});
	};
};

var deleteDocumentActor = exports.deleteDocumentActor = function deleteDocumentActor(form) {

	return function (dispatch) {

		dispatch((0, _Loading.isLoading)(true));

		return new _ClientHttpRequest2.default({
			service: 'api/deleteDocumentActor',
			method: "POST",
			data: _extends({}, form),
			headers: Object.assign({ "Authorization": sessionStorage.access_token, "uid": sessionStorage.uid })
		}).request().then(function (response) {
			dispatch((0, _Loading.isLoading)(false));

			//dispatch({ type: ACTION_GET_ACTOR, Obj: temp })
			return response.data;
		}).catch(function (error) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
			throw error;
		});
	};
};

var clearActor = exports.clearActor = function clearActor() {
	return function (dispatch) {
		dispatch({ type: ACTION_GET_ACTOR, Obj: {} });
		dispatch({ type: ACTION_SEARCH_ACTOR, Obj: [] });
	};
};

/***/ }),

/***/ 475:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.typeContract = exports.getContract = exports.searchContract = exports.newAndUpdateContract = exports.ACTION_GET_ITEM_CONTRACT = exports.ACTION_SEARCH_CONTRACT = exports.ACTION_TYPE_CONTRACT = exports.ACTION_NEW_CONTRACT = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _Utils = __webpack_require__(2);

var Utils = _interopRequireWildcard(_Utils);

var _ClientHttpRequest = __webpack_require__(5);

var _ClientHttpRequest2 = _interopRequireDefault(_ClientHttpRequest);

var _immutable = __webpack_require__(1);

var _immutable2 = _interopRequireDefault(_immutable);

var _Modal = __webpack_require__(4);

var _Loading = __webpack_require__(3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var initialState = _immutable2.default.Map({}).set('Response', new _immutable2.default.Map({})).set('Search', new _immutable2.default.List([])).set('Contract', new _immutable2.default.List([])).set('TypeContract', new _immutable2.default.List([])).set('ContractItem', new _immutable2.default.Map({}));

/* Types */

var ACTION_NEW_CONTRACT = exports.ACTION_NEW_CONTRACT = 'ACTION_NEW_CONTRACT';
var ACTION_TYPE_CONTRACT = exports.ACTION_TYPE_CONTRACT = 'ACTION_TYPE_CONTRACT';
var ACTION_SEARCH_CONTRACT = exports.ACTION_SEARCH_CONTRACT = 'ACTION_SEARCH_CONTRACT';
var ACTION_GET_ITEM_CONTRACT = exports.ACTION_GET_ITEM_CONTRACT = 'ACTION_GET_ITEM_CONTRACT';

/* Reducer */

exports.default = function () {
	var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	var action = arguments[1];


	switch (action.type) {
		case ACTION_NEW_CONTRACT:
			return state.set('Contract', new _immutable2.default.List(action.Obj));
		case ACTION_TYPE_CONTRACT:
			return state.set('TypeContract', new _immutable2.default.List(action.Obj));
		case ACTION_SEARCH_CONTRACT:
			return state.set('Contract', new _immutable2.default.List(action.Obj));
		case ACTION_GET_ITEM_CONTRACT:
			return state.set('ContractItem', new _immutable2.default.Map(action.Obj));

		default:
			return state;
	}
};

/* Action Creators */

var newAndUpdateContract = exports.newAndUpdateContract = function newAndUpdateContract(form) {

	return function (dispatch) {

		dispatch((0, _Loading.isLoading)(true));

		var formAux = Object.assign({}, form);
		delete formAux.editorState;
		delete formAux.textEditor;
		delete formAux.firmas;
		delete formAux.paginaActual;
		delete formAux.textoActual;
		delete formAux.textoComplementario;
		delete formAux.idTipoContrato;
		delete formAux.nameContrato;

		formAux.createdBy = formAux.lastModifiedBy = sessionStorage.uid;
		//formAux.createdDate = formAux.lastModifiedDate = new Date().toISOString()

		formAux.firma1.map(function (item, i) {
			item.id = i;
			item.createdBy = item.lastModifiedBy = sessionStorage.uid;
			//item.createdDate = new Date().toISOString().replace('abc', '')
			return item;
		});

		formAux.paginas.map(function (item, i) {
			item.id = i;
			item.createdBy = item.lastModifiedBy = sessionStorage.uid;
			//item.createdDate = new Date().toISOString()
			return item;
		});
		formAux.textosComplementarios.map(function (item, i) {
			item.createdBy = item.lastModifiedBy = sessionStorage.uid;
			//item.createdDate = new Date().toISOString()
			item.id = i;
			return item;
		});

		return new _ClientHttpRequest2.default({
			service: formAux.id == 0 ? 'api/newContract' : 'api/updateContract',
			method: "POST",
			data: _extends({}, formAux),
			headers: Object.assign({ "Authorization": sessionStorage.access_token, "uid": sessionStorage.uid })
		}).request().then(function (response) {
			dispatch((0, _Loading.isLoading)(false));
			return response.data;
		}).catch(function (error) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
			throw error;
		});
	};
};

var searchContract = exports.searchContract = function searchContract(form) {

	return function (dispatch) {

		dispatch((0, _Loading.isLoading)(true));

		return new _ClientHttpRequest2.default({
			service: Object.keys(form).length == 0 ? 'api/searchContract' : 'api/searchParamContract',
			method: "POST",
			data: _extends({}, form),
			headers: Object.assign({ "Authorization": sessionStorage.access_token, "uid": sessionStorage.uid })
		}).request().then(function (response) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch({ type: ACTION_SEARCH_CONTRACT, Obj: response.data });
			return response.data;
		}).catch(function (error) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
			throw error;
		});
	};
};

var getContract = exports.getContract = function getContract(form) {

	return function (dispatch) {

		dispatch((0, _Loading.isLoading)(true));

		return new _ClientHttpRequest2.default({
			service: 'api/getContract',
			method: "POST",
			data: _extends({}, form),
			headers: Object.assign({ "Authorization": sessionStorage.access_token, "uid": sessionStorage.uid })
		}).request().then(function (response) {
			dispatch((0, _Loading.isLoading)(false));

			var aux = Object.assign({}, response.data);

			aux.idTipoContrato = response.data.tipoContrato.id;
			aux.paginaActual = aux.textoActual = 1;
			aux.editorState = aux.textEditor = response.data.paginas[0].texto;
			aux.textoComplementario = response.data.textosComplementarios[0].texto;

			dispatch({ type: ACTION_GET_ITEM_CONTRACT, Obj: aux });
			return aux;
		}).catch(function (error) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
			throw error;
		});
	};
};

var typeContract = exports.typeContract = function typeContract(form) {

	return function (dispatch) {

		dispatch((0, _Loading.isLoading)(true));

		return new _ClientHttpRequest2.default({
			service: 'api/typeContract',
			method: "POST",
			data: _extends({}, form),
			headers: Object.assign({ "Authorization": sessionStorage.access_token, "uid": sessionStorage.uid })
		}).request().then(function (response) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch({ type: ACTION_TYPE_CONTRACT, Obj: response.data });
			return response.data;
		}).catch(function (error) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
			throw error;
		});
	};
};

/***/ }),

/***/ 476:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.clearJustification = exports.getJustification = exports.setJustification = exports.GET_JUSTIFICATION = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _Utils = __webpack_require__(2);

var Utils = _interopRequireWildcard(_Utils);

var _immutable = __webpack_require__(1);

var _immutable2 = _interopRequireDefault(_immutable);

var _ClientHttpRequest = __webpack_require__(5);

var _ClientHttpRequest2 = _interopRequireDefault(_ClientHttpRequest);

var _Modal = __webpack_require__(4);

var _Loading = __webpack_require__(3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var initialState = _immutable2.default.Map({}).set('Get', new _immutable2.default.List([]));

/* Types */
var GET_JUSTIFICATION = exports.GET_JUSTIFICATION = 'GET_JUSTIFICATION';

/* Reducer */

exports.default = function () {
	var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	var action = arguments[1];


	switch (action.type) {
		case GET_JUSTIFICATION:
			return state.set('Get', new _immutable2.default.Map(action.Obj));
		default:
			return state;
	}
};

/* Action Creators */


var setJustification = exports.setJustification = function setJustification(form) {

	var estadoEvaluacion = form.evaluacion.cuestionario.estadoEvaluacion;

	var justificacion = form.justificaciones.map(function (j) {

		var pregunta1_radio = j.preguntas[0].pregunta1_radio;
		var pregunta1_observaciones = j.preguntas[0].pregunta1_observaciones;
		var pregunta2_radio = j.preguntas[0].pregunta2_radio;
		var pregunta2_observaciones = j.preguntas[0].pregunta2_observaciones;

		return {
			idDonatariaRubro: j.id,
			idRubro: j.idRubro,
			preguntas: {
				pregunta: [{
					idPregunta: j.preguntas[0].id_pregunta_1,
					respuesta: pregunta1_radio === 'NO' ? false : true,
					observaciones: pregunta1_observaciones || null
				}, {
					idPregunta: j.preguntas[0].id_pregunta_2,
					respuesta: pregunta2_radio === 'NO' ? false : true,
					observaciones: pregunta2_observaciones || null
				}]
			},
			justificacionRubro: true,
			montoJustificado: parseFloat(j.montoJustificado),
			montoSolicitado: null
		};
	});

	var temp = {
		idDonataria: form.idDonataria,
		idCorrida: form.idCorrida,
		justificacionRubros: {
			idEvaluacion: form.idEvaluacion,
			estadoEvaluacion: estadoEvaluacion,
			usuarioModifica: {
				idUsuario: sessionStorage.uid,
				nombreUsuario: sessionStorage.firstname + ' ' + sessionStorage.lastname
			},
			preguntasGenerales: {
				pregunta: [{
					idPregunta: 1000,
					respuesta: form.congruenteRadio === 1 ? true : false,
					observaciones: form.congruente
				}, {
					idPregunta: 1001,
					respuesta: form.solicitadoRadio === 1 ? true : false,
					observaciones: form.solicitado
				}, {
					idPregunta: 1002,
					respuesta: form.identificadaRadio === 1 ? true : false,
					observaciones: form.identificada
				}]
			},
			justificaciones: { justificacion: justificacion },
			revisionOtrasAreas: form.revisionRadio === 1 ? true : false,
			justificacionSolicitud: {
				id: form.justificacionSolicitud === "Completa" ? 1 : form.justificacionSolicitud === "Parcial" ? 2 : 3,
				descripcion: form.justificacionSolicitud
			},
			causaNoJustificacion: form.noJustificacion,
			comentario: ""
		}
	};

	return function (dispatch) {

		dispatch((0, _Loading.isLoading)(true));

		return new _ClientHttpRequest2.default({
			service: 'api/setJustification',
			method: "POST",
			data: _extends({}, temp),
			headers: Object.assign({ "Authorization": sessionStorage.access_token, "uid": sessionStorage.uid })
		}).request().then(function (response) {
			dispatch((0, _Loading.isLoading)(false));
			return response.data;
		}).catch(function (error) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
			throw error;
		});
	};
};

var getJustification = exports.getJustification = function getJustification(form) {

	return function (dispatch) {

		dispatch((0, _Loading.isLoading)(true));

		return new _ClientHttpRequest2.default({
			service: 'api/getJustification',
			method: "POST",
			data: _extends({}, form),
			headers: Object.assign({ "Authorization": sessionStorage.access_token, "uid": sessionStorage.uid })
		}).request().then(function (response) {

			var data = response.data.justificacionRubros;

			var justificaciones = [];

			if (data.justificaciones.justificacion) {

				justificaciones = data.justificaciones.justificacion.map(function (j) {

					var preguntas = [{
						id_pregunta_1: j.preguntas.pregunta[0].idPregunta,
						pregunta1_radio: j.preguntas.pregunta[0].respuesta ? 'SI' : 'NO',
						pregunta1_observaciones: j.preguntas.pregunta[0].observaciones,
						id_pregunta_2: j.preguntas.pregunta[1].idPregunta,
						pregunta2_radio: j.preguntas.pregunta[1].respuesta ? 'SI' : 'NO',
						pregunta2_observaciones: j.preguntas.pregunta[1].observaciones
					}];

					return {
						id: j.idDonatariaRubro,
						idRubro: j.idRubro,
						rubro: j.descripcionRubro,
						concepto: j.concepto,
						montoSolicitado: j.montoSolicitado,
						montoJustificado: j.montoJustificado,
						justificacion: j.preguntas.pregunta[0].respuesta && j.preguntas.pregunta[1].respuesta ? 'SI' : 'NO',
						preguntas: preguntas
					};
				});
			}

			var form = {
				idEvaluacion: data.idEvaluacion,
				congruenteRadio: data.preguntasGenerales.pregunta[0].respuesta ? 1 : 2,
				congruente: data.preguntasGenerales.pregunta[0].observaciones,
				solicitadoRadio: data.preguntasGenerales.pregunta[1].respuesta ? 1 : 2,
				solicitado: data.preguntasGenerales.pregunta[1].observaciones,
				identificadaRadio: data.preguntasGenerales.pregunta[2].respuesta ? 1 : 2,
				identificada: data.preguntasGenerales.pregunta[2].observaciones,
				justificaRadio: data.justifica ? 1 : 2,
				justificaciones: justificaciones,
				revisionRadio: data.revisionOtrasAreas ? 1 : 2,
				justificacionSolicitud: data.justificacionSolicitud.id === 1 ? "Completa" : data.justificacionSolicitud.id === 2 ? "Parcial" : "No justifica",
				noJustificacion: data.causaNoJustificacion || '',
				rubrosDonataria: data.justificaciones.justificacion
			};

			dispatch((0, _Loading.isLoading)(false));
			dispatch({ type: GET_JUSTIFICATION, Obj: form });
		}).catch(function (error) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
			throw error;
		});
	};
};

var clearJustification = exports.clearJustification = function clearJustification() {
	return function (dispatch) {
		dispatch({ type: GET_JUSTIFICATION, Obj: {} });
	};
};

/***/ }),

/***/ 477:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.getSustainableGoals = exports.setSustainableGoals = exports.GET_SUSTAINABLE_GOALS = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _Utils = __webpack_require__(2);

var Utils = _interopRequireWildcard(_Utils);

var _immutable = __webpack_require__(1);

var _immutable2 = _interopRequireDefault(_immutable);

var _ClientHttpRequest = __webpack_require__(5);

var _ClientHttpRequest2 = _interopRequireDefault(_ClientHttpRequest);

var _Modal = __webpack_require__(4);

var _Loading = __webpack_require__(3);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var initialState = _immutable2.default.Map({}).set('Get', new _immutable2.default.Map({}));

/* Types */
var GET_SUSTAINABLE_GOALS = exports.GET_SUSTAINABLE_GOALS = 'GET_SUSTAINABLE_GOALS';

/* Reducer */

exports.default = function () {
	var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	var action = arguments[1];


	switch (action.type) {
		case GET_SUSTAINABLE_GOALS:
			return state.set('Get', new _immutable2.default.Map(action.Obj));
		default:
			return state;
	}
};

/* Action Creators */


var setSustainableGoals = exports.setSustainableGoals = function setSustainableGoals(form) {

	var originalObj = Object.assign({}, form.original);
	originalObj.preguntaObjetivosCorrectos.respuesta = form.objetivosRadio === 1 ? true : false;
	originalObj.preguntaObjetivosCorrectos.observaciones = form.objetivos;

	var objetivos = form.objEjecutivo;

	var metasArr = function metasArr(idObjetivo) {
		var objetivo = Utils.getItem(objetivos, { id: idObjetivo });
		return objetivo.metas.map(function (m) {
			return m.meta.id;
		});
	};

	var indicadoresArr = function indicadoresArr(idObjetivo, param) {
		var objetivo = Utils.getItem(objetivos, { id: idObjetivo });
		return objetivo.metas.map(function (m) {
			return m[param];
		});
	};

	if (form.objetivosRadio === 2) {

		var preguntasRespuestas = [{
			indice: 1,
			respuestas: [objetivos[0].objetivo.idObjetivo]
		}, {
			indice: 2,
			respuestas: metasArr(objetivos[0].objetivo.idObjetivo)
		}, {
			indice: 3,
			respuestas: indicadoresArr(objetivos[0].objetivo.idObjetivo, 'idIndicadoresCobertura')
		}, {
			indice: 4,
			respuestas: indicadoresArr(objetivos[0].objetivo.idObjetivo, 'idIndicadoresCoberturaMetas')
		}, {
			indice: 5,
			respuestas: indicadoresArr(objetivos[0].objetivo.idObjetivo, 'idIndicadoresResultados').map(function (i) {
				if (!i) {
					i = "0";
				}
				return i;
			})
		}, {
			indice: 6,
			respuestas: indicadoresArr(objetivos[0].objetivo.idObjetivo, 'idIndicadoresResultadosMetas').map(function (i) {
				if (!i) {
					i = "0";
				}
				return i;
			})
		}, {
			indice: 7,
			respuestas: objetivos.length > 1 ? [objetivos[1].objetivo.idObjetivo] : ['']
		}, {
			indice: 8,
			respuestas: objetivos.length > 1 ? metasArr(objetivos[1].objetivo.idObjetivo) : ['', '']
		}, {
			indice: 9,
			respuestas: objetivos.length > 1 ? indicadoresArr(objetivos[1].objetivo.idObjetivo, 'idIndicadoresCobertura') : ['', '']
		}, {
			indice: 10,
			respuestas: objetivos.length > 1 ? indicadoresArr(objetivos[1].objetivo.idObjetivo, 'idIndicadoresCoberturaMetas') : ['', '']
		}, {
			indice: 11,
			respuestas: objetivos.length > 1 ? indicadoresArr(objetivos[1].objetivo.idObjetivo, 'idIndicadoresResultados').map(function (i) {
				if (!i) {
					i = "0";
				}
				return i;
			}) : ['', '']
		}, {
			indice: 12,
			respuestas: objetivos.length > 1 ? indicadoresArr(objetivos[1].objetivo.idObjetivo, 'idIndicadoresResultadosMetas').map(function (i) {
				if (!i) {
					i = "0";
				}
				return i;
			}) : ['', '']
		}];
		originalObj.objetivosDesarrolloSostenibleEjecutivo.preguntas[0].formularios[0].preguntasRespuestas = preguntasRespuestas;
	}

	return function (dispatch) {

		dispatch((0, _Loading.isLoading)(true));

		return new _ClientHttpRequest2.default({
			service: 'api/setSustainableGoals',
			method: "POST",
			data: _extends({}, originalObj),
			headers: Object.assign({ "Authorization": sessionStorage.access_token, "uid": sessionStorage.uid })
		}).request().then(function (response) {
			dispatch((0, _Loading.isLoading)(false));
			return response.data;
		}).catch(function (error) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
			throw error;
		});
	};
};

var getSustainableGoals = exports.getSustainableGoals = function getSustainableGoals(form) {

	return function (dispatch) {

		dispatch((0, _Loading.isLoading)(true));

		return new _ClientHttpRequest2.default({
			service: 'api/getSustainableGoals',
			method: "POST",
			data: _extends({}, form),
			headers: Object.assign({ "Authorization": sessionStorage.access_token, "uid": sessionStorage.uid })
		}).request().then(function (response) {
			dispatch((0, _Loading.isLoading)(false));

			var data = response.data;
			var objetivosDesarrolloSostenibleDonataria = data.objetivosDesarrolloSostenibleDonataria || null;
			var objetivosDesarrolloSostenibleEjecutivo = data.objetivosDesarrolloSostenibleEjecutivo;

			var form = Object.assign({}, { uniqueId: Utils.getUUID() });
			var objDonataria = [];
			var objEjecutivo = [];

			form = _extends({}, form, {
				objetivosRadio: data.preguntaObjetivosCorrectos && data.preguntaObjetivosCorrectos.respuesta === true ? 1 : data.preguntaObjetivosCorrectos && data.preguntaObjetivosCorrectos.respuesta === false ? 2 : data.preguntaObjetivosCorrectos && data.preguntaObjetivosCorrectos.respuesta === "true" ? 1 : data.preguntaObjetivosCorrectos && data.preguntaObjetivosCorrectos.respuesta === "false" ? 2 : 1,
				objetivos: data.preguntaObjetivosCorrectos ? data.preguntaObjetivosCorrectos.observaciones : ''
			});

			if (objetivosDesarrolloSostenibleDonataria) {

				if (objetivosDesarrolloSostenibleDonataria.preguntas[0].formularios[0].preguntasRespuestas[0] && objetivosDesarrolloSostenibleDonataria.preguntas[0].formularios[0].preguntasRespuestas[0].respuestas && objetivosDesarrolloSostenibleDonataria.preguntas[0].formularios[0].preguntasRespuestas[0].respuestas[0]) {

					var objetivo = objetivosDesarrolloSostenibleDonataria.preguntas[0].objetivosGrupo.filter(function (i) {
						return i.objetivoDesarrollo.id === parseInt(objetivosDesarrolloSostenibleDonataria.preguntas[0].formularios[0].preguntasRespuestas[0].respuestas);
					}) ? objetivosDesarrolloSostenibleDonataria.preguntas[0].objetivosGrupo.filter(function (i) {
						return i.objetivoDesarrollo.id === parseInt(objetivosDesarrolloSostenibleDonataria.preguntas[0].formularios[0].preguntasRespuestas[0].respuestas);
					}) : [];

					if (objetivo[0]) {

						var objetivoObj = { id: objetivo[0].objetivoDesarrollo.id, objetivo: { idObjetivo: objetivo[0].objetivoDesarrollo.id, descripcion: objetivo[0].objetivoDesarrollo.descripcion, metas: objetivo[0].objetivoDesarrollo.metaObjetivo } };
						var metas = [];

						if (objetivo[0].objetivoDesarrollo.metaObjetivo) {
							objetivosDesarrolloSostenibleDonataria.preguntas[0].formularios[0].preguntasRespuestas[1].respuestas.forEach(function (m, indexMeta) {

								var meta = Utils.getItem(objetivo[0].objetivoDesarrollo.metaObjetivo, { id: parseInt(m) });

								if (meta) {

									var metaObj = { idObjetivo: objetivo[0].objetivoDesarrollo.id, idMeta: meta.id, meta: meta };

									var idIndicadoresCobertura = objetivosDesarrolloSostenibleDonataria.preguntas[0].formularios[0].preguntasRespuestas[2].respuestas[indexMeta === 0 ? 0 : 1] !== "0" ? objetivosDesarrolloSostenibleDonataria.preguntas[0].formularios[0].preguntasRespuestas[2].respuestas[indexMeta === 0 ? 0 : 1] : "";
									var idIndicadoresCoberturaMetas = objetivosDesarrolloSostenibleDonataria.preguntas[0].formularios[0].preguntasRespuestas[3].respuestas[indexMeta === 0 ? 0 : 1];

									var idIndicadoresResultados = objetivosDesarrolloSostenibleDonataria.preguntas[0].formularios[0].preguntasRespuestas[4].respuestas[indexMeta === 0 ? 0 : 1] !== "0" ? objetivosDesarrolloSostenibleDonataria.preguntas[0].formularios[0].preguntasRespuestas[4].respuestas[indexMeta === 0 ? 0 : 1] : "";
									var idIndicadoresResultadosMetas = objetivosDesarrolloSostenibleDonataria.preguntas[0].formularios[0].preguntasRespuestas[5].respuestas[indexMeta === 0 ? 0 : 1];

									var IndicadoresCobertura = function IndicadoresCobertura() {
										var iteratorList = idIndicadoresCobertura ? idIndicadoresCobertura.split(",") : [];
										var indicatorsList = iteratorList.map(function (i, index) {
											var _Utils$getItem = Utils.getItem(meta.indicador, { id: parseInt(i) }),
											    descripcion = _Utils$getItem.descripcion;

											var metaItem = idIndicadoresCoberturaMetas.split(",");

											return _react2.default.createElement(
												'li',
												{ key: descripcion.toString() },
												_react2.default.createElement(
													'p',
													null,
													descripcion,
													_react2.default.createElement('br', null),
													_react2.default.createElement(
														'small',
														null,
														'Meta instituci\xF3n: ' + metaItem[index]
													)
												)
											);
										});
										return _react2.default.createElement(
											'ul',
											{ className: 'indicadores-question' },
											indicatorsList.length ? indicatorsList : '¡No se seleccionaron indicadores!'
										);
									};

									var IndicadoresResultados = function IndicadoresResultados() {
										var iteratorList = idIndicadoresResultados ? idIndicadoresResultados.split(",") : [];
										var indicatorsList = iteratorList.map(function (i, index) {
											var _Utils$getItem2 = Utils.getItem(meta.indicador, { id: parseInt(i) }),
											    descripcion = _Utils$getItem2.descripcion;

											var metaItem = idIndicadoresResultadosMetas.split(",");
											return _react2.default.createElement(
												'li',
												{ key: descripcion.toString() },
												_react2.default.createElement(
													'p',
													null,
													descripcion,
													_react2.default.createElement('br', null),
													_react2.default.createElement(
														'small',
														null,
														'Meta instituci\xF3n: ' + metaItem[index]
													)
												)
											);
										});
										return _react2.default.createElement(
											'ul',
											{ className: 'indicadores-question' },
											indicatorsList.length ? indicatorsList : '¡No se seleccionaron indicadores!'
										);
									};

									metaObj = _extends({}, metaObj, {
										idObjetivo: objetivo[0].objetivoDesarrollo.id,
										idIndicadoresCobertura: idIndicadoresCobertura,
										idIndicadoresResultados: idIndicadoresResultados,
										idIndicadoresCoberturaMetas: idIndicadoresCoberturaMetas,
										idIndicadoresResultadosMetas: idIndicadoresResultadosMetas,
										indicadoresCobertura: _react2.default.createElement(IndicadoresCobertura, null),
										indicadoresResultados: _react2.default.createElement(IndicadoresResultados, null)
									});
									metas.push(metaObj);
								}
							});
							objetivoObj = _extends({}, objetivoObj, { metas: metas });
							objDonataria.push(objetivoObj);
						}
					}
				}

				if (objetivosDesarrolloSostenibleDonataria.preguntas[0].formularios[0].preguntasRespuestas[6] && objetivosDesarrolloSostenibleDonataria.preguntas[0].formularios[0].preguntasRespuestas[6].respuestas && objetivosDesarrolloSostenibleDonataria.preguntas[0].formularios[0].preguntasRespuestas[6].respuestas[0]) {

					var _objetivo = objetivosDesarrolloSostenibleDonataria.preguntas[0].objetivosGrupo.filter(function (i) {
						return i.objetivoDesarrollo.id === parseInt(objetivosDesarrolloSostenibleDonataria.preguntas[0].formularios[0].preguntasRespuestas[6].respuestas);
					}) ? objetivosDesarrolloSostenibleDonataria.preguntas[0].objetivosGrupo.filter(function (i) {
						return i.objetivoDesarrollo.id === parseInt(objetivosDesarrolloSostenibleDonataria.preguntas[0].formularios[0].preguntasRespuestas[6].respuestas);
					}) : [];

					if (_objetivo[0]) {

						var _objetivoObj = { id: _objetivo[0].objetivoDesarrollo.id, objetivo: { idObjetivo: _objetivo[0].objetivoDesarrollo.id, descripcion: _objetivo[0].objetivoDesarrollo.descripcion, metas: _objetivo[0].objetivoDesarrollo.metaObjetivo } };
						var _metas = [];

						if (_objetivo[0].objetivoDesarrollo.metaObjetivo) {
							objetivosDesarrolloSostenibleDonataria.preguntas[0].formularios[0].preguntasRespuestas[7].respuestas.forEach(function (m, indexMeta) {

								var meta = Utils.getItem(_objetivo[0].objetivoDesarrollo.metaObjetivo, { id: parseInt(m) });

								if (meta) {

									var metaObj = { idObjetivo: _objetivo[0].objetivoDesarrollo.id, idMeta: meta.id, meta: meta };

									var idIndicadoresCobertura = objetivosDesarrolloSostenibleDonataria.preguntas[0].formularios[0].preguntasRespuestas[8].respuestas[indexMeta === 0 ? 0 : 1] !== "0" ? objetivosDesarrolloSostenibleDonataria.preguntas[0].formularios[0].preguntasRespuestas[8].respuestas[indexMeta === 0 ? 0 : 1] : "";
									var idIndicadoresCoberturaMetas = objetivosDesarrolloSostenibleDonataria.preguntas[0].formularios[0].preguntasRespuestas[9].respuestas[indexMeta === 0 ? 0 : 1];

									var idIndicadoresResultados = objetivosDesarrolloSostenibleDonataria.preguntas[0].formularios[0].preguntasRespuestas[10].respuestas[indexMeta === 0 ? 0 : 1] !== "0" ? objetivosDesarrolloSostenibleDonataria.preguntas[0].formularios[0].preguntasRespuestas[10].respuestas[indexMeta === 0 ? 0 : 1] : "";
									var idIndicadoresResultadosMetas = objetivosDesarrolloSostenibleDonataria.preguntas[0].formularios[0].preguntasRespuestas[11].respuestas[indexMeta === 0 ? 0 : 1];

									var IndicadoresCobertura = function IndicadoresCobertura() {
										var iteratorList = idIndicadoresCobertura ? idIndicadoresCobertura.split(",") : [];
										var indicatorsList = iteratorList.map(function (i, index) {
											var _Utils$getItem3 = Utils.getItem(meta.indicador, { id: parseInt(i) }),
											    descripcion = _Utils$getItem3.descripcion;

											var metaItem = idIndicadoresCoberturaMetas.split(",");

											return _react2.default.createElement(
												'li',
												{ key: descripcion.toString() },
												_react2.default.createElement(
													'p',
													null,
													descripcion,
													_react2.default.createElement('br', null),
													_react2.default.createElement(
														'small',
														null,
														'Meta instituci\xF3n: ' + metaItem[index]
													)
												)
											);
										});
										return _react2.default.createElement(
											'ul',
											{ className: 'indicadores-question' },
											indicatorsList.length ? indicatorsList : '¡No se seleccionaron indicadores!'
										);
									};

									var IndicadoresResultados = function IndicadoresResultados() {
										var iteratorList = idIndicadoresResultados ? idIndicadoresResultados.split(",") : [];
										var indicatorsList = iteratorList.map(function (i, index) {
											var _Utils$getItem4 = Utils.getItem(meta.indicador, { id: parseInt(i) }),
											    descripcion = _Utils$getItem4.descripcion;

											var metaItem = idIndicadoresResultadosMetas.split(",");

											return _react2.default.createElement(
												'li',
												{ key: descripcion.toString() },
												_react2.default.createElement(
													'p',
													null,
													descripcion,
													_react2.default.createElement('br', null),
													_react2.default.createElement(
														'small',
														null,
														'Meta instituci\xF3n: ' + metaItem[index]
													)
												)
											);
										});
										return _react2.default.createElement(
											'ul',
											{ className: 'indicadores-question' },
											indicatorsList.length ? indicatorsList : '¡No se seleccionaron indicadores!'
										);
									};

									metaObj = _extends({}, metaObj, {
										idObjetivo: _objetivo[0].objetivoDesarrollo.id,
										idIndicadoresCobertura: idIndicadoresCobertura,
										idIndicadoresResultados: idIndicadoresResultados,
										idIndicadoresCoberturaMetas: idIndicadoresCoberturaMetas,
										idIndicadoresResultadosMetas: idIndicadoresResultadosMetas,
										indicadoresCobertura: _react2.default.createElement(IndicadoresCobertura, null),
										indicadoresResultados: _react2.default.createElement(IndicadoresResultados, null)
									});
									_metas.push(metaObj);
								}
							});
							_objetivoObj = _extends({}, _objetivoObj, { metas: _metas });
							objDonataria.push(_objetivoObj);
						}
					}
				}
			}

			form = _extends({}, form, {
				objDonataria: objDonataria,
				objEjecutivo: objEjecutivo
			});

			if (objetivosDesarrolloSostenibleEjecutivo.preguntas[0].formularios[0].preguntasRespuestas[0] && objetivosDesarrolloSostenibleEjecutivo.preguntas[0].formularios[0].preguntasRespuestas[0].respuestas && objetivosDesarrolloSostenibleEjecutivo.preguntas[0].formularios[0].preguntasRespuestas[0].respuestas[0]) {

				var _objetivo2 = objetivosDesarrolloSostenibleDonataria.preguntas[0].objetivosGrupo.filter(function (i) {
					return i.objetivoDesarrollo.id === parseInt(objetivosDesarrolloSostenibleDonataria.preguntas[0].formularios[0].preguntasRespuestas[0].respuestas);
				}) ? objetivosDesarrolloSostenibleDonataria.preguntas[0].objetivosGrupo.filter(function (i) {
					return i.objetivoDesarrollo.id === parseInt(objetivosDesarrolloSostenibleEjecutivo.preguntas[0].formularios[0].preguntasRespuestas[0].respuestas);
				}) : [];

				if (_objetivo2[0]) {

					var _objetivoObj2 = { id: _objetivo2[0].objetivoDesarrollo.id, objetivo: { idObjetivo: _objetivo2[0].objetivoDesarrollo.id, descripcion: _objetivo2[0].objetivoDesarrollo.descripcion } };
					var _metas2 = [];

					if (_objetivo2[0].objetivoDesarrollo.metaObjetivo) {
						objetivosDesarrolloSostenibleEjecutivo.preguntas[0].formularios[0].preguntasRespuestas[1].respuestas.forEach(function (m, indexMeta) {

							var meta = Utils.getItem(_objetivo2[0].objetivoDesarrollo.metaObjetivo, { id: parseInt(m) });

							if (meta) {

								var metaObj = { idObjetivo: _objetivo2[0].objetivoDesarrollo.id, idMeta: meta.id, meta: meta };
								var idIndicadoresCobertura = objetivosDesarrolloSostenibleEjecutivo.preguntas[0].formularios[0].preguntasRespuestas[2].respuestas[indexMeta === 0 ? 0 : 1] !== "0" ? objetivosDesarrolloSostenibleEjecutivo.preguntas[0].formularios[0].preguntasRespuestas[2].respuestas[indexMeta === 0 ? 0 : 1] : "";
								var idIndicadoresCoberturaMetas = objetivosDesarrolloSostenibleEjecutivo.preguntas[0].formularios[0].preguntasRespuestas[3].respuestas[indexMeta === 0 ? 0 : 1];

								var idIndicadoresResultados = objetivosDesarrolloSostenibleEjecutivo.preguntas[0].formularios[0].preguntasRespuestas[4].respuestas[indexMeta === 0 ? 0 : 1] !== "0" ? objetivosDesarrolloSostenibleEjecutivo.preguntas[0].formularios[0].preguntasRespuestas[4].respuestas[indexMeta === 0 ? 0 : 1] : "";
								var idIndicadoresResultadosMetas = objetivosDesarrolloSostenibleEjecutivo.preguntas[0].formularios[0].preguntasRespuestas[5].respuestas[indexMeta === 0 ? 0 : 1];

								var IndicadoresCobertura = function IndicadoresCobertura() {
									var iteratorList = idIndicadoresCobertura ? idIndicadoresCobertura.split(",") : [];
									var indicatorsList = iteratorList.map(function (i, index) {
										var _Utils$getItem5 = Utils.getItem(meta.indicador, { id: parseInt(i) }),
										    descripcion = _Utils$getItem5.descripcion;

										var metaItem = idIndicadoresCoberturaMetas.split(",");

										return _react2.default.createElement(
											'li',
											{ key: descripcion.toString() },
											_react2.default.createElement(
												'p',
												null,
												descripcion,
												_react2.default.createElement('br', null),
												_react2.default.createElement(
													'small',
													null,
													'Meta instituci\xF3n: ' + metaItem[index]
												)
											)
										);
									});
									return _react2.default.createElement(
										'ul',
										{ className: 'indicadores-question' },
										indicatorsList.length ? indicatorsList : '¡No se seleccionaron indicadores!'
									);
								};

								var IndicadoresResultados = function IndicadoresResultados() {
									var iteratorList = idIndicadoresResultados ? idIndicadoresResultados.split(",") : [];
									var indicatorsList = iteratorList.map(function (i, index) {
										var _Utils$getItem6 = Utils.getItem(meta.indicador, { id: parseInt(i) }),
										    descripcion = _Utils$getItem6.descripcion;

										var metaItem = idIndicadoresResultadosMetas.split(",");

										return _react2.default.createElement(
											'li',
											{ key: descripcion.toString() },
											_react2.default.createElement(
												'p',
												null,
												descripcion,
												_react2.default.createElement('br', null),
												_react2.default.createElement(
													'small',
													null,
													'Meta instituci\xF3n: ' + metaItem[index]
												)
											)
										);
									});
									return _react2.default.createElement(
										'ul',
										{ className: 'indicadores-question' },
										indicatorsList.length ? indicatorsList : '¡No se seleccionaron indicadores!'
									);
								};

								metaObj = _extends({}, metaObj, {
									idObjetivo: _objetivo2[0].objetivoDesarrollo.id,
									idIndicadoresCobertura: idIndicadoresCobertura,
									idIndicadoresResultados: idIndicadoresResultados,
									idIndicadoresCoberturaMetas: idIndicadoresCoberturaMetas,
									idIndicadoresResultadosMetas: idIndicadoresResultadosMetas,
									indicadoresCobertura: _react2.default.createElement(IndicadoresCobertura, null),
									indicadoresResultados: _react2.default.createElement(IndicadoresResultados, null)
								});
								_metas2.push(metaObj);
							}
						});
						_objetivoObj2 = _extends({}, _objetivoObj2, { metas: _metas2 });
						objEjecutivo.push(_objetivoObj2);
					}
				}
			}

			if (objetivosDesarrolloSostenibleEjecutivo.preguntas[0].formularios[0].preguntasRespuestas[6] && objetivosDesarrolloSostenibleEjecutivo.preguntas[0].formularios[0].preguntasRespuestas[6].respuestas && objetivosDesarrolloSostenibleEjecutivo.preguntas[0].formularios[0].preguntasRespuestas[6].respuestas[0]) {

				var _objetivo3 = objetivosDesarrolloSostenibleDonataria.preguntas[0].objetivosGrupo.filter(function (i) {
					return i.objetivoDesarrollo.id === parseInt(objetivosDesarrolloSostenibleDonataria.preguntas[0].formularios[0].preguntasRespuestas[6].respuestas);
				}) ? objetivosDesarrolloSostenibleDonataria.preguntas[0].objetivosGrupo.filter(function (i) {
					return i.objetivoDesarrollo.id === parseInt(objetivosDesarrolloSostenibleEjecutivo.preguntas[0].formularios[0].preguntasRespuestas[6].respuestas);
				}) : [];

				if (_objetivo3[0]) {
					var _objetivoObj3 = { id: _objetivo3[0].objetivoDesarrollo.id, objetivo: { idObjetivo: _objetivo3[0].objetivoDesarrollo.id, descripcion: _objetivo3[0].objetivoDesarrollo.descripcion } };
					var _metas3 = [];

					if (_objetivo3[0].objetivoDesarrollo.metaObjetivo) {
						objetivosDesarrolloSostenibleEjecutivo.preguntas[0].formularios[0].preguntasRespuestas[7].respuestas.forEach(function (m, indexMeta) {

							var meta = Utils.getItem(_objetivo3[0].objetivoDesarrollo.metaObjetivo, { id: parseInt(m) });

							if (meta) {

								var metaObj = { idObjetivo: _objetivo3[0].objetivoDesarrollo.id, idMeta: meta.id, meta: meta };

								var idIndicadoresCobertura = objetivosDesarrolloSostenibleEjecutivo.preguntas[0].formularios[0].preguntasRespuestas[8].respuestas[indexMeta === 0 ? 0 : 1] !== "0" ? objetivosDesarrolloSostenibleEjecutivo.preguntas[0].formularios[0].preguntasRespuestas[8].respuestas[indexMeta === 0 ? 0 : 1] : "";
								var idIndicadoresCoberturaMetas = objetivosDesarrolloSostenibleEjecutivo.preguntas[0].formularios[0].preguntasRespuestas[9].respuestas[indexMeta === 0 ? 0 : 1];

								var idIndicadoresResultados = objetivosDesarrolloSostenibleEjecutivo.preguntas[0].formularios[0].preguntasRespuestas[10].respuestas[indexMeta === 0 ? 0 : 1] !== "0" ? objetivosDesarrolloSostenibleEjecutivo.preguntas[0].formularios[0].preguntasRespuestas[10].respuestas[indexMeta === 0 ? 0 : 1] : "";
								var idIndicadoresResultadosMetas = objetivosDesarrolloSostenibleEjecutivo.preguntas[0].formularios[0].preguntasRespuestas[11].respuestas[indexMeta === 0 ? 0 : 1];

								var IndicadoresCobertura = function IndicadoresCobertura() {
									var iteratorList = idIndicadoresCobertura ? idIndicadoresCobertura.split(",") : [];
									var indicatorsList = iteratorList.map(function (i, index) {
										var _Utils$getItem7 = Utils.getItem(meta.indicador, { id: parseInt(i) }),
										    descripcion = _Utils$getItem7.descripcion;

										var metaItem = idIndicadoresCoberturaMetas.split(",");

										return _react2.default.createElement(
											'li',
											{ key: descripcion.toString() },
											_react2.default.createElement(
												'p',
												null,
												descripcion,
												_react2.default.createElement('br', null),
												_react2.default.createElement(
													'small',
													null,
													'Meta instituci\xF3n: ' + metaItem[index]
												)
											)
										);
									});
									return _react2.default.createElement(
										'ul',
										{ className: 'indicadores-question' },
										indicatorsList.length ? indicatorsList : '¡No se seleccionaron indicadores!'
									);
								};

								var IndicadoresResultados = function IndicadoresResultados() {
									var iteratorList = idIndicadoresResultados ? idIndicadoresResultados.split(",") : [];
									var indicatorsList = iteratorList.map(function (i, index) {
										var _Utils$getItem8 = Utils.getItem(meta.indicador, { id: parseInt(i) }),
										    descripcion = _Utils$getItem8.descripcion;

										var metaItem = idIndicadoresResultadosMetas.split(",");

										return _react2.default.createElement(
											'li',
											{ key: descripcion.toString() },
											_react2.default.createElement(
												'p',
												null,
												descripcion,
												_react2.default.createElement('br', null),
												_react2.default.createElement(
													'small',
													null,
													'Meta instituci\xF3n: ' + metaItem[index]
												)
											)
										);
									});
									return _react2.default.createElement(
										'ul',
										{ className: 'indicadores-question' },
										indicatorsList.length ? indicatorsList : '¡No se seleccionaron indicadores!'
									);
								};

								metaObj = _extends({}, metaObj, {
									idObjetivo: _objetivo3[0].objetivoDesarrollo.id,
									idIndicadoresCobertura: idIndicadoresCobertura,
									idIndicadoresResultados: idIndicadoresResultados,
									idIndicadoresCoberturaMetas: idIndicadoresCoberturaMetas,
									idIndicadoresResultadosMetas: idIndicadoresResultadosMetas,
									indicadoresCobertura: _react2.default.createElement(IndicadoresCobertura, null),
									indicadoresResultados: _react2.default.createElement(IndicadoresResultados, null)
								});
								_metas3.push(metaObj);
							}
						});
						_objetivoObj3 = _extends({}, _objetivoObj3, { metas: _metas3 });
						objEjecutivo.push(_objetivoObj3);
					}
				}
			}

			form = _extends({}, form, {
				objDonataria: objDonataria,
				objEjecutivo: objEjecutivo
			});

			var objetivosDesarrollo = [];

			if (objetivosDesarrolloSostenibleDonataria) {

				objetivosDesarrollo = objetivosDesarrolloSostenibleDonataria.preguntas[0].objetivosGrupo.map(function (o) {
					return {
						id: o.objetivoDesarrollo.id,
						descripcion: o.objetivoDesarrollo.descripcion,
						metaObjetivo: o.objetivoDesarrollo.metaObjetivo
					};
				});
			}

			form = _extends({}, form, {
				objetivosDesarrolloSostenibleDonataria: objetivosDesarrolloSostenibleDonataria,
				objetivosDesarrolloSostenibleEjecutivo: objetivosDesarrolloSostenibleEjecutivo,
				objetivosDesarrollo: objetivosDesarrollo,
				original: data,
				disabledAll: data.preguntaObjetivosCorrectos.respuesta,
				editODS: form.objetivosRadio === 1 ? false : form.objetivosRadio === 2 ? true : false
			});

			dispatch({ type: GET_SUSTAINABLE_GOALS, Obj: form });
		}).catch(function (error) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
			throw error;
		});
	};
};

/***/ }),

/***/ 478:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.updateObsEvaluation = exports.updateCriterioEvaluation = exports.getEvaluationPerformance = exports.ACTION_UPDATE_OBS_EVALUATION = exports.ACTION_UPDATE_CRITERIO_EVALUATION = exports.ACTION_GET_EVALUATION_PERFORMANCE = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _Utils = __webpack_require__(2);

var Utils = _interopRequireWildcard(_Utils);

var _ClientHttpRequest = __webpack_require__(5);

var _ClientHttpRequest2 = _interopRequireDefault(_ClientHttpRequest);

var _immutable = __webpack_require__(1);

var _immutable2 = _interopRequireDefault(_immutable);

var _Modal = __webpack_require__(4);

var _Loading = __webpack_require__(3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var initialState = _immutable2.default.Map({}).set('Evaluacion', new _immutable2.default.Map({})).set('SaveCriterio', new _immutable2.default.Map({})).set('SaveObs', new _immutable2.default.Map({}));

/* Types */
var ACTION_GET_EVALUATION_PERFORMANCE = exports.ACTION_GET_EVALUATION_PERFORMANCE = 'ACTION_GET_EVALUATION_PERFORMANCE';
var ACTION_UPDATE_CRITERIO_EVALUATION = exports.ACTION_UPDATE_CRITERIO_EVALUATION = 'ACTION_UPDATE_CRITERIO_EVALUATION';
var ACTION_UPDATE_OBS_EVALUATION = exports.ACTION_UPDATE_OBS_EVALUATION = 'ACTION_UPDATE_OBS_EVALUATION';

/* Reducer */

exports.default = function () {
	var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	var action = arguments[1];

	switch (action.type) {
		case ACTION_GET_EVALUATION_PERFORMANCE:
			return state.set('Evaluacion', new _immutable2.default.Map(action.Obj));
		case ACTION_UPDATE_CRITERIO_EVALUATION:
			return state.set('SaveCriterio', new _immutable2.default.Map(action.Obj));
		case ACTION_UPDATE_OBS_EVALUATION:
			return state.set('SaveObs', new _immutable2.default.Map(action.Obj));
		default:
			return state;
	}
};

/* Action Creators */


var getEvaluationPerformance = exports.getEvaluationPerformance = function getEvaluationPerformance(form) {
	return function (dispatch) {
		dispatch((0, _Loading.isLoading)(true));

		return new _ClientHttpRequest2.default({
			service: 'api/getEvaluationPerformance',
			method: 'POST',
			data: _extends({}, form),
			headers: Object.assign({ Authorization: sessionStorage.access_token, uid: sessionStorage.uid })
		}).request().then(function (response) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch({ type: ACTION_GET_EVALUATION_PERFORMANCE, Obj: response.data });
			return response;
		}).catch(function (error) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
			throw error;
		});
	};
};

var updateCriterioEvaluation = exports.updateCriterioEvaluation = function updateCriterioEvaluation(form) {
	var tmp = {
		"usuario": sessionStorage.uid,
		"idCriterio": form.idCriterio,
		"idDonataria": form.idDonataria,
		"idCorrida": form.idCorrida,
		"idNivelCumplimiento": form.idNivelCumplimiento || null,
		"observaciones": form.observacion || ""
	};
	return function (dispatch) {
		dispatch((0, _Loading.isLoading)(true));

		return new _ClientHttpRequest2.default({
			service: 'api/updateCriterioEvaluation',
			method: 'POST',
			data: _extends({}, tmp),
			headers: Object.assign({ Authorization: sessionStorage.access_token, uid: sessionStorage.uid })
		}).request().then(function (response) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch({ type: ACTION_UPDATE_CRITERIO_EVALUATION, Obj: response.data });
			return response.data;
		}).catch(function (error) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
			throw error;
		});
	};
};

var updateObsEvaluation = exports.updateObsEvaluation = function updateObsEvaluation(form) {
	var tmp = {
		"usuario": sessionStorage.uid,
		"idEvaluacion": form.idEvaluacion,
		"idDonataria": form.idDonataria,
		"idCorrida": form.idCorrida,
		"observacion": form.recomendaciones || ""
	};
	return function (dispatch) {
		dispatch((0, _Loading.isLoading)(true));

		return new _ClientHttpRequest2.default({
			service: 'api/updateObsEvaluation',
			method: 'POST',
			data: _extends({}, tmp),
			headers: Object.assign({ Authorization: sessionStorage.access_token, uid: sessionStorage.uid })
		}).request().then(function (response) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch({ type: ACTION_UPDATE_OBS_EVALUATION, Obj: response.data });
			return response.data;
		}).catch(function (error) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
			throw error;
		});
	};
};

/***/ }),

/***/ 479:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.getRounding = exports.GET_ROUNDING = undefined;

var _Utils = __webpack_require__(2);

var Utils = _interopRequireWildcard(_Utils);

var _ClientHttpRequest = __webpack_require__(5);

var _ClientHttpRequest2 = _interopRequireDefault(_ClientHttpRequest);

var _immutable = __webpack_require__(1);

var _immutable2 = _interopRequireDefault(_immutable);

var _Modal = __webpack_require__(4);

var _Loading = __webpack_require__(3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var initialState = _immutable2.default.Map({}).set('Search', new _immutable2.default.List([]));

/* Types */
var GET_ROUNDING = exports.GET_ROUNDING = 'GET_ROUNDING';

/* Reducer */

exports.default = function () {
	var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	var action = arguments[1];


	switch (action.type) {
		case GET_ROUNDING:
			return state.set('Search', new _immutable2.default.List(action.Obj));
		default:
			return state;
	}
};

/* Action Creators */


var getRounding = exports.getRounding = function getRounding() {

	return function (dispatch) {

		dispatch((0, _Loading.isLoading)(true));

		return new _ClientHttpRequest2.default({
			service: 'api/getRounding',
			method: "POST",
			data: {},
			headers: Object.assign({ "Authorization": sessionStorage.access_token, "uid": sessionStorage.uid })
		}).request().then(function (response) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch({ type: GET_ROUNDING, Obj: response.data });
		}).catch(function (error) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
			throw error;
		});
	};
};

/***/ }),

/***/ 480:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.updateAuthorization = exports.updateProjectEjectivo = exports.setEjectivo = exports.rejectEjectivo = exports.exportEjecutivoExcel = exports.SET_PROPOSAL = exports.REJECT_PROPOSAL = exports.GET_EXCEL = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _Utils = __webpack_require__(2);

var Utils = _interopRequireWildcard(_Utils);

var _ClientHttpRequest = __webpack_require__(5);

var _ClientHttpRequest2 = _interopRequireDefault(_ClientHttpRequest);

var _immutable = __webpack_require__(1);

var _immutable2 = _interopRequireDefault(_immutable);

var _Modal = __webpack_require__(4);

var _Loading = __webpack_require__(3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var initialState = _immutable2.default.Map({}).set('Get', new _immutable2.default.List([])).set('Response', new _immutable2.default.List([])).set('Search', new _immutable2.default.List([])).set('Excel', new _immutable2.default.Map({})).set('Reject', new _immutable2.default.Map({})).set('Set', new _immutable2.default.Map({}));

/* Types */
var GET_EXCEL = exports.GET_EXCEL = 'GET_EXCEL';
var REJECT_PROPOSAL = exports.REJECT_PROPOSAL = 'REJECT_PROPOSAL';
var SET_PROPOSAL = exports.SET_PROPOSAL = 'SET_PROPOSAL';

/* Reducer */

exports.default = function () {
	var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	var action = arguments[1];


	switch (action.type) {
		case GET_EXCEL:
			return state.set('Excel', new _immutable2.default.Map(action.Obj));
		case REJECT_PROPOSAL:
			return state.set('Reject', new _immutable2.default.Map(action.Obj));
		case SET_PROPOSAL:
			return state.set('Set', new _immutable2.default.Map(action.Obj));
		default:
			return state;
	}
};

/* Action Creators */

var exportEjecutivoExcel = exports.exportEjecutivoExcel = function exportEjecutivoExcel(propuestaId) {

	return function (dispatch) {

		dispatch((0, _Loading.isLoading)(true));

		return new _ClientHttpRequest2.default({
			service: 'api/exportEjecutivoExcel',
			method: "POST",
			data: { propuestaId: propuestaId },
			headers: Object.assign({ "Authorization": sessionStorage.access_token, "uid": sessionStorage.uid }),
			responseType: 'arraybuffer'
		}).request().then(function (response) {
			dispatch((0, _Loading.isLoading)(false));

			var blob = new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
			var fileName = 'propuesta-asignacion-' + Utils.getToday() + '.xlsx';
			var objectUrl = URL.createObjectURL(blob);
			var a = document.createElement('a');

			a.href = objectUrl;
			a.download = fileName;
			document.body.appendChild(a);
			a.click();

			document.body.removeChild(a);
			URL.revokeObjectURL(objectUrl);

			return response.data;
		}).catch(function (error) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
			throw error;
		});
	};
};

var rejectEjectivo = exports.rejectEjectivo = function rejectEjectivo(form) {

	return function (dispatch) {

		dispatch((0, _Loading.isLoading)(true));

		return new _ClientHttpRequest2.default({
			service: 'api/rejectEjectivo',
			method: "POST",
			data: _extends({}, form),
			headers: Object.assign({ "Authorization": sessionStorage.access_token, "uid": sessionStorage.uid })
		}).request().then(function (response) {
			dispatch((0, _Loading.isLoading)(false));

			dispatch({ type: REJECT_PROPOSAL, Obj: response.data });
			return response.data;
		}).catch(function (error) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
			throw error;
		});
	};
};

var setEjectivo = exports.setEjectivo = function setEjectivo(form) {

	return function (dispatch) {

		dispatch((0, _Loading.isLoading)(true));

		return new _ClientHttpRequest2.default({
			service: 'api/setEjectivo',
			method: "POST",
			data: _extends({}, form),
			headers: Object.assign({ "Authorization": sessionStorage.access_token, "uid": sessionStorage.uid })
		}).request().then(function (response) {
			dispatch((0, _Loading.isLoading)(false));

			dispatch({ type: SET_PROPOSAL, Obj: response.data });
			return response.data;
		}).catch(function (error) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
			throw error;
		});
	};
};

var updateProjectEjectivo = exports.updateProjectEjectivo = function updateProjectEjectivo(form) {

	return function (dispatch) {

		dispatch((0, _Loading.isLoading)(true));

		return new _ClientHttpRequest2.default({
			service: 'api/updateProjectEjectivo',
			method: "POST",
			data: _extends({}, form),
			headers: Object.assign({ "Authorization": sessionStorage.access_token, "uid": sessionStorage.uid })
		}).request().then(function (response) {
			dispatch((0, _Loading.isLoading)(false));

			dispatch({ type: SET_PROPOSAL, Obj: response.data });
			return response.data;
		}).catch(function (error) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
			throw error;
		});
	};
};

var updateAuthorization = exports.updateAuthorization = function updateAuthorization(form) {

	var temp = {
		fechaAutorizacion: form.fechaFinAutoriza,
		organoId: form.item.organoId,
		propuestaId: form.propuestaId,
		usuario: sessionStorage.uid
	};

	return function (dispatch) {

		dispatch((0, _Loading.isLoading)(true));

		return new _ClientHttpRequest2.default({
			service: 'api/updateAuthorization',
			method: "POST",
			data: _extends({}, temp),
			headers: Object.assign({ "Authorization": sessionStorage.access_token, "uid": sessionStorage.uid })
		}).request().then(function (response) {
			dispatch((0, _Loading.isLoading)(false));
			return response.data;
		}).catch(function (error) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
			throw error;
		});
	};
};

/***/ }),

/***/ 481:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.clearTypeContract = exports.deleteTypeContract = exports.getTypeContract = exports.searchTypeContract = exports.addTypeContract = exports.ACTION_UPDATE_TYPE_CONTRACT_STATUS = exports.ACTION_DELETE_TYPE_CONTRACT_STATUS = exports.ACTION_GET_TYPE_CONTRACT_STATUS = exports.ACTION_SEARCH_TYPE_CONTRACT_STATUS = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _Utils = __webpack_require__(2);

var Utils = _interopRequireWildcard(_Utils);

var _ClientHttpRequest = __webpack_require__(5);

var _ClientHttpRequest2 = _interopRequireDefault(_ClientHttpRequest);

var _immutable = __webpack_require__(1);

var _immutable2 = _interopRequireDefault(_immutable);

var _Modal = __webpack_require__(4);

var _Loading = __webpack_require__(3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var initialState = _immutable2.default.Map({}).set('Search', new _immutable2.default.List([])).set('Response', new _immutable2.default.Map({})).set('Get', new _immutable2.default.Map({}));

/* Types */
var ACTION_SEARCH_TYPE_CONTRACT_STATUS = exports.ACTION_SEARCH_TYPE_CONTRACT_STATUS = 'ACTION_SEARCH_TYPE_CONTRACT_STATUS';
var ACTION_GET_TYPE_CONTRACT_STATUS = exports.ACTION_GET_TYPE_CONTRACT_STATUS = 'ACTION_GET_TYPE_CONTRACT_STATUS';
var ACTION_DELETE_TYPE_CONTRACT_STATUS = exports.ACTION_DELETE_TYPE_CONTRACT_STATUS = 'ACTION_DELETE_TYPE_CONTRACT_STATUS';
var ACTION_UPDATE_TYPE_CONTRACT_STATUS = exports.ACTION_UPDATE_TYPE_CONTRACT_STATUS = 'ACTION_UPDATE_TYPE_CONTRACT_STATUS';

/* Reducer */

exports.default = function () {
	var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	var action = arguments[1];

	switch (action.type) {
		case ACTION_SEARCH_TYPE_CONTRACT_STATUS:
			return state.set('Search', new _immutable2.default.List(action.Obj));
		case ACTION_GET_TYPE_CONTRACT_STATUS:
			return state.set('Get', new _immutable2.default.Map(action.Obj));
		case ACTION_DELETE_TYPE_CONTRACT_STATUS:
			return state.set('Response', new _immutable2.default.Map(action.Obj));
		case ACTION_UPDATE_TYPE_CONTRACT_STATUS:
			return state.set('Response', new _immutable2.default.Map(action.Obj));
		default:
			return state;
	}
};

/* Action Creators */


var addTypeContract = exports.addTypeContract = function addTypeContract(form) {

	var temp = {
		id: form.idContrato || 0,
		deleted: form.state === 1 ? false : true,
		tipoContrato: form.tipoContrato,
		createdBy: sessionStorage.uid
	};

	return function (dispatch) {
		dispatch((0, _Loading.isLoading)(true));
		return new _ClientHttpRequest2.default({
			service: form.idContrato ? 'api/updateTypeContract' : 'api/newTypeContract',
			method: "POST",
			data: _extends({}, temp),
			headers: Object.assign({ "Authorization": sessionStorage.access_token, "uid": sessionStorage.uid })
		}).request().then(function () {
			dispatch((0, _Loading.isLoading)(false));
			dispatch((0, _Modal.createModal)(Utils.successMessage()));
		}).catch(function (error) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
			throw error;
		});
	};
};

var searchTypeContract = exports.searchTypeContract = function searchTypeContract(form) {
	Utils.clearNullAndEmpty(form);

	var temp = {
		id: form.idContrato || null,
		deleted: form.state === 1 ? false : form.state === 2 ? true : null,
		tipoContrato: form.tipoContrato || ''
	};

	return function (dispatch) {
		dispatch((0, _Loading.isLoading)(true));
		return new _ClientHttpRequest2.default({
			service: Object.keys(form).length === 0 ? 'api/searchTypeContract' : 'api/searchParamTypeContract',
			method: "POST",
			data: _extends({}, temp),
			headers: Object.assign({ "Authorization": sessionStorage.access_token, "uid": sessionStorage.uid })
		}).request().then(function (response) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch({ type: ACTION_SEARCH_TYPE_CONTRACT_STATUS, Obj: response.data });
		}).catch(function (error) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
			throw error;
		});
	};
};

var getTypeContract = exports.getTypeContract = function getTypeContract(id) {
	return function (dispatch) {
		dispatch((0, _Loading.isLoading)(true));
		return new _ClientHttpRequest2.default({
			service: 'api/getTypeContract',
			method: "POST",
			data: { id: id },
			headers: Object.assign({ "Authorization": sessionStorage.access_token, "uid": sessionStorage.uid })
		}).request().then(function (response) {

			var data = response.data;

			var obj = {
				uniqueId: Utils.getUUID(),
				idContrato: data.id,
				state: data.deleted === false ? 1 : 2,
				tipoContrato: data.tipoContrato
			};

			dispatch({ type: ACTION_GET_TYPE_CONTRACT_STATUS, Obj: obj });
			dispatch((0, _Loading.isLoading)(false));
		}).catch(function (error) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
			throw error;
		});
	};
};

var deleteTypeContract = exports.deleteTypeContract = function deleteTypeContract() {
	return function (dispatch) {
		return dispatch({ type: ACTION_DELETE_TYPE_CONTRACT_STATUS, Obj: { code: '', message: '' } });
	};
};

var clearTypeContract = exports.clearTypeContract = function clearTypeContract() {
	return function (dispatch) {
		dispatch({ type: ACTION_GET_TYPE_CONTRACT_STATUS, Obj: {} });
		dispatch({ type: ACTION_SEARCH_TYPE_CONTRACT_STATUS, Obj: [] });
	};
};

/***/ }),

/***/ 482:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.updatePayment = exports.getConsultantGrantees = exports.getGrantees = exports.REACTIVATE_PAY = exports.SEARCH_GRANTEES = exports.GET_GRANTEES = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _Utils = __webpack_require__(2);

var Utils = _interopRequireWildcard(_Utils);

var _ClientHttpRequest = __webpack_require__(5);

var _ClientHttpRequest2 = _interopRequireDefault(_ClientHttpRequest);

var _immutable = __webpack_require__(1);

var _Modal = __webpack_require__(4);

var _Loading = __webpack_require__(3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var initialState = (0, _immutable.Map)({}).set('Get', new _immutable.List([])).set('Search', new _immutable.List([]));

/* Types */
var GET_GRANTEES = exports.GET_GRANTEES = 'GET_GRANTEES';
var SEARCH_GRANTEES = exports.SEARCH_GRANTEES = 'SEARCH_GRANTEES';
var REACTIVATE_PAY = exports.REACTIVATE_PAY = 'REACTIVATE_PAY';

/* Reducer */

exports.default = function () {
	var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	var action = arguments[1];


	switch (action.type) {
		case GET_GRANTEES:
			return state.set('Get', new _immutable.List(action.Obj));
		case SEARCH_GRANTEES:
			return state.set('Search', new _immutable.List(action.Obj));
		case REACTIVATE_PAY:
			return state.set('Response', new _immutable.List(action.Obj));
		default:
			return state;
	}
};

/* Action Creators */

var getGrantees = exports.getGrantees = function getGrantees() {

	var temp = {
		idCorrida: null,
		idTipoPago: 2
	};

	return function (dispatch) {

		dispatch((0, _Loading.isLoading)(true));

		return new _ClientHttpRequest2.default({
			service: 'api/getGrantees',
			method: "POST",
			data: _extends({}, temp),
			headers: Object.assign({ "Authorization": sessionStorage.access_token, "uid": sessionStorage.uid })
		}).request().then(function (response) {

			dispatch((0, _Loading.isLoading)(false));

			var contabilizadas = [];
			response.data.map(function (item) {
				contabilizadas.push({
					idDonataria: item.donataria.idDonataria,
					nombreDonataria: item.donataria.nombreDonataria,
					corridaId: item.corrida.corridaId,
					nombreCorrida: item.corrida.nombre
				});
			});
			dispatch({ type: GET_GRANTEES, Obj: contabilizadas });
		}).catch(function (error) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
			throw error;
		});
	};
};

var getConsultantGrantees = exports.getConsultantGrantees = function getConsultantGrantees() {

	var temp = {
		idCorrida: null,
		idTipoPago: null
	};

	return function (dispatch) {

		dispatch((0, _Loading.isLoading)(true));

		return new _ClientHttpRequest2.default({
			service: 'api/getGrantees',
			method: "POST",
			data: _extends({}, temp),
			headers: Object.assign({ "Authorization": sessionStorage.access_token, "uid": sessionStorage.uid })
		}).request().then(function (response) {

			dispatch((0, _Loading.isLoading)(false));

			var contabilizadas = [];
			response.data.map(function (item) {
				contabilizadas.push({
					idDonataria: item.donataria.idDonataria,
					nombreDonataria: item.donataria.nombreDonataria,
					corridaId: item.corrida.corridaId,
					nombreCorrida: item.corrida.nombre
				});
			});
			dispatch({ type: SEARCH_GRANTEES, Obj: contabilizadas });
			return response.contabilizadas;
		}).catch(function (error) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
			throw error;
		});
	};
};

var updatePayment = exports.updatePayment = function updatePayment(form) {

	var temp = {
		"donataria": {
			"idDonataria": form.idDonataria,
			"nombreDonataria": form.nombreDonataria,
			"idCorrida": form.corridaId,
			"descripcionOportunidad": form.nombreCorrida,
			"reactivacion": true
		}
	};

	return function (dispatch) {
		dispatch((0, _Loading.isLoading)(true));
		return new _ClientHttpRequest2.default({
			service: 'api/updatePayment',
			method: "POST",
			data: _extends({}, temp),
			headers: Object.assign({ "Authorization": sessionStorage.access_token, "Bpm": sessionStorage.bpm_token, "uid": sessionStorage.uid })
		}).request().then(function (response) {
			dispatch((0, _Loading.isLoading)(false));
			return response.data;
		}).catch(function (error) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
			throw error;
		});
	};
};

/***/ }),

/***/ 483:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.clearResultsReport = exports.generateReport = exports.addReport = exports.deleteDocumentItem = exports.updateExpenditureItem = exports.updateExpenditure = exports.getExpenditure = exports.updateIndicatorsResultsProgram = exports.addBreakdownIndicator = exports.breakdownIndicator = exports.updateResponsibleProgram = exports.getResponsibleProgram = exports.updateImprovementActions = exports.getImprovementActions = exports.updatePromotionHumanRights = exports.getPromotionHumanRights = exports.updateLessonsDecisions = exports.getLessonsDecisions = exports.updateIndicatorsResults = exports.getIndicatorsResults = exports.ACTION_GET_REPORT = exports.ACTION_UPDATE_EXPENDITURE = exports.ACTION_GET_EXPENDITURE = exports.ACTION_UPDATE_INDICATORS_RESULTS_PROGRAM = exports.ACTION_ADD_BREAKDOWN_INDICATOR = exports.ACTION_GET_BREAKDOWN_INDICATOR = exports.ACTION_UPDATE_RESPONSIBLE = exports.ACTION_GET_RESPONSIBLE = exports.ACTION_UPDATE_IMPROVEMENT = exports.ACTION_GET_IMPROVEMENT = exports.ACTION_UPDATE_PROMOTION = exports.ACTION_GET_PROMOTION = exports.ACTION_UPDATE_LESSONS = exports.ACTION_GET_LESSONS = exports.ACTION_UPDATE_INDICATORS_RESULTS = exports.ACTION_GET_INDICATORS_RESULTS = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _Utils = __webpack_require__(2);

var Utils = _interopRequireWildcard(_Utils);

var _ClientHttpRequest = __webpack_require__(5);

var _ClientHttpRequest2 = _interopRequireDefault(_ClientHttpRequest);

var _immutable = __webpack_require__(1);

var _immutable2 = _interopRequireDefault(_immutable);

var _Modal = __webpack_require__(4);

var _Loading = __webpack_require__(3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var initialState = _immutable2.default.Map({}).set('GetIndicators', new _immutable2.default.Map({})).set('UpdateIndicators', new _immutable2.default.Map({})).set('GetLessons', new _immutable2.default.Map({})).set('UpdateLessons', new _immutable2.default.Map({})).set('GetPromotion', new _immutable2.default.Map({})).set('UpdatePromotion', new _immutable2.default.Map({})).set('GetImprovement', new _immutable2.default.Map({})).set('UpdateImprovement', new _immutable2.default.Map({})).set('GetResponsible', new _immutable2.default.Map({})).set('UpdateResponsible', new _immutable2.default.Map({})).set('GetBreakdownIndicator', new _immutable2.default.Map({})).set('AddBreakdownIndicator', new _immutable2.default.Map({})).set('UpdateIndicatorsResults', new _immutable2.default.Map({})).set('GetExpenditure', new _immutable2.default.Map({})).set('UpdateExpenditure', new _immutable2.default.Map({})).set('AddReport', new _immutable2.default.Map({}));

/*Types*/
var ACTION_GET_INDICATORS_RESULTS = exports.ACTION_GET_INDICATORS_RESULTS = 'ACTION_GET_INDICATORS_RESULTS';
var ACTION_UPDATE_INDICATORS_RESULTS = exports.ACTION_UPDATE_INDICATORS_RESULTS = 'ACTION_UPDATE_INDICATORS_RESULTS';
var ACTION_GET_LESSONS = exports.ACTION_GET_LESSONS = 'ACTION_GET_LESSONS';
var ACTION_UPDATE_LESSONS = exports.ACTION_UPDATE_LESSONS = 'ACTION_UPDATE_LESSONS';
var ACTION_GET_PROMOTION = exports.ACTION_GET_PROMOTION = 'ACTION_GET_PROMOTION';
var ACTION_UPDATE_PROMOTION = exports.ACTION_UPDATE_PROMOTION = 'ACTION_UPDATE_PROMOTION';
var ACTION_GET_IMPROVEMENT = exports.ACTION_GET_IMPROVEMENT = 'ACTION_GET_IMPROVEMENT';
var ACTION_UPDATE_IMPROVEMENT = exports.ACTION_UPDATE_IMPROVEMENT = 'ACTION_UPDATE_IMPROVEMENT';
var ACTION_GET_RESPONSIBLE = exports.ACTION_GET_RESPONSIBLE = 'ACTION_GET_RESPONSIBLE';
var ACTION_UPDATE_RESPONSIBLE = exports.ACTION_UPDATE_RESPONSIBLE = 'ACTION_UPDATE_RESPONSIBLE';
var ACTION_GET_BREAKDOWN_INDICATOR = exports.ACTION_GET_BREAKDOWN_INDICATOR = 'ACTION_GET_BREAKDOWN_INDICATOR';
var ACTION_ADD_BREAKDOWN_INDICATOR = exports.ACTION_ADD_BREAKDOWN_INDICATOR = 'ACTION_ADD_BREAKDOWN_INDICATOR';
var ACTION_UPDATE_INDICATORS_RESULTS_PROGRAM = exports.ACTION_UPDATE_INDICATORS_RESULTS_PROGRAM = 'ACTION_UPDATE_INDICATORS_RESULTS_PROGRAM';
var ACTION_GET_EXPENDITURE = exports.ACTION_GET_EXPENDITURE = 'ACTION_GET_EXPENDITURE';
var ACTION_UPDATE_EXPENDITURE = exports.ACTION_UPDATE_EXPENDITURE = 'ACTION_UPDATE_EXPENDITURE';
var ACTION_GET_REPORT = exports.ACTION_GET_REPORT = 'ACTION_GET_REPORT';

/*Reducer*/

exports.default = function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments[1];

  switch (action.type) {
    case ACTION_GET_INDICATORS_RESULTS:
      return state.set('GetIndicators', new _immutable2.default.Map(action.Obj));
    case ACTION_UPDATE_INDICATORS_RESULTS:
      return state.set('UpdateIndicators', new _immutable2.default.Map(action.Obj));
    case ACTION_GET_LESSONS:
      return state.set('GetLessons', new _immutable2.default.Map(action.Obj));
    case ACTION_UPDATE_LESSONS:
      return state.set('UpdateLessons', new _immutable2.default.Map(action.Obj));
    case ACTION_GET_PROMOTION:
      return state.set('GetPromotion', new _immutable2.default.Map(action.Obj));
    case ACTION_UPDATE_PROMOTION:
      return state.set('UpdatePromotion', new _immutable2.default.Map(action.Obj));
    case ACTION_GET_IMPROVEMENT:
      return state.set('GetImprovement', new _immutable2.default.Map(action.Obj));
    case ACTION_UPDATE_IMPROVEMENT:
      return state.set('UpdateImprovement', new _immutable2.default.Map(action.Obj));
    case ACTION_GET_RESPONSIBLE:
      return state.set('GetResponsible', new _immutable2.default.Map(action.Obj));
    case ACTION_UPDATE_RESPONSIBLE:
      return state.set('UpdateResponsible', new _immutable2.default.Map(action.Obj));
    case ACTION_GET_BREAKDOWN_INDICATOR:
      return state.set('GetBreakdownIndicator', new _immutable2.default.Map(action.Obj));
    case ACTION_ADD_BREAKDOWN_INDICATOR:
      return state.set('AddBreakdownIndicator', new _immutable2.default.Map(action.Obj));
    case ACTION_UPDATE_INDICATORS_RESULTS_PROGRAM:
      return state.set('UpdateIndicatorsResults', new _immutable2.default.Map(action.Obj));
    case ACTION_GET_EXPENDITURE:
      return state.set('GetExpenditure', new _immutable2.default.Map(action.Obj));
    case ACTION_UPDATE_EXPENDITURE:
      return state.set('UpdateExpenditure', new _immutable2.default.Map(action.Obj));
    default:
      return state;
  }
};

/*Action Creators*/

var getIndicatorsResults = exports.getIndicatorsResults = function getIndicatorsResults(form) {
  return function (dispatch) {
    dispatch((0, _Loading.isLoading)(true));

    return new _ClientHttpRequest2.default({
      service: 'api/getIndicatorsResults',
      method: 'POST',
      data: _extends({}, form),
      headers: Object.assign({ Authorization: sessionStorage.access_token, uid: sessionStorage.uid })
    }).request().then(function (response) {
      dispatch((0, _Loading.isLoading)(false));
      dispatch({ type: ACTION_GET_INDICATORS_RESULTS, Obj: response.data });
      return response;
    }).catch(function (error) {
      dispatch((0, _Loading.isLoading)(false));
      dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
      throw error;
    });
  };
};

var updateIndicatorsResults = exports.updateIndicatorsResults = function updateIndicatorsResults(form) {
  var temp = {
    idInformeResultado: form.idInformeResultado,
    idDonataria: form.idDonataria,
    idCorrida: form.idCorrida,
    preguntas: [{
      idPregunta: form.preguntas.programResultsData[0].idPregunta,
      respuesta: form.questionResult2 || ''
    }, {
      idPregunta: form.preguntas.programResultsData[1].idPregunta,
      respuesta: form.questionResult3 || ''
    }, {
      idPregunta: form.preguntas.programResultsData[2].idPregunta,
      respuesta: form.questionResult4 || ''
    }, {
      idPregunta: form.preguntas.programResultsData[3].idPregunta,
      respuesta: form.questionResult5 || ''
    }, {
      idPregunta: form.preguntas.programResultsData[4].idPregunta,
      respuesta: form.questionResult6 || ''
    }, {
      idPregunta: form.preguntas.programResultsData[5].idPregunta,
      respuesta: form.questionResult7 || ''
    }, {
      idPregunta: form.preguntas.programResultsData[6].idPregunta,
      respuesta: form.questionResult8 || ''
    }],
    evidenciasIndicadores: Utils.unionArray(Utils.getListPropsOmit(form.programResultsDocs, ['documento', 'nombre', 'id']), form.programResultsDocsRemove)
  };

  return function (dispatch) {
    dispatch((0, _Loading.isLoading)(true));

    return new _ClientHttpRequest2.default({
      service: 'api/updateIndicatorsResults',
      method: 'POST',
      data: _extends({}, temp),
      headers: Object.assign({ Authorization: sessionStorage.access_token, uid: sessionStorage.uid })
    }).request().then(function (response) {
      dispatch((0, _Loading.isLoading)(false));
      dispatch({ type: ACTION_UPDATE_INDICATORS_RESULTS, Obj: response.data });
    }).catch(function (error) {
      dispatch((0, _Loading.isLoading)(false));
      dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
      throw error;
    });
  };
};

var getLessonsDecisions = exports.getLessonsDecisions = function getLessonsDecisions(form) {
  return function (dispatch) {
    dispatch((0, _Loading.isLoading)(true));

    return new _ClientHttpRequest2.default({
      service: 'api/getLessonsDecisions',
      method: 'POST',
      data: _extends({}, form),
      headers: Object.assign({ Authorization: sessionStorage.access_token, uid: sessionStorage.uid })
    }).request().then(function (response) {
      dispatch((0, _Loading.isLoading)(false));
      dispatch({ type: ACTION_GET_LESSONS, Obj: response.data });
      return response;
    }).catch(function (error) {
      dispatch((0, _Loading.isLoading)(false));
      dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
      throw error;
    });
  };
};

var updateLessonsDecisions = exports.updateLessonsDecisions = function updateLessonsDecisions(form) {
  var temp = {
    idInformeResultado: form.idInformeResultado,
    idDonataria: form.idDonataria,
    idCorrida: form.idCorrida,
    preguntas: [{
      idPregunta: form.preguntas.lessonsData[0].idPregunta,
      respuesta: form.questionLesson21 || ''
    }, {
      idPregunta: form.preguntas.lessonsData[1].idPregunta,
      respuesta: form.questionLesson22 || ''
    }],
    otrosActores: null
  };
  return function (dispatch) {
    dispatch((0, _Loading.isLoading)(true));

    return new _ClientHttpRequest2.default({
      service: 'api/updateLessonsDecisions',
      method: 'POST',
      data: _extends({}, temp),
      headers: Object.assign({ Authorization: sessionStorage.access_token, uid: sessionStorage.uid })
    }).request().then(function (response) {
      dispatch((0, _Loading.isLoading)(false));
      dispatch({ type: ACTION_UPDATE_LESSONS, Obj: response.data });
    }).catch(function (error) {
      dispatch((0, _Loading.isLoading)(false));
      dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
      throw error;
    });
  };
};

var getPromotionHumanRights = exports.getPromotionHumanRights = function getPromotionHumanRights(form) {
  return function (dispatch) {
    dispatch((0, _Loading.isLoading)(true));

    return new _ClientHttpRequest2.default({
      service: 'api/getPromotionHumanRights',
      method: 'POST',
      data: _extends({}, form),
      headers: Object.assign({ Authorization: sessionStorage.access_token, uid: sessionStorage.uid })
    }).request().then(function (response) {
      dispatch((0, _Loading.isLoading)(false));
      dispatch({ type: ACTION_GET_PROMOTION, Obj: response.data });
      return response;
    }).catch(function (error) {
      dispatch((0, _Loading.isLoading)(false));
      dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
      throw error;
    });
  };
};

var updatePromotionHumanRights = exports.updatePromotionHumanRights = function updatePromotionHumanRights(form) {
  var otrosActores = Utils.unionArray(Utils.getListPropsOmit(form.promotionData, ['id', 'tmp', 'consecutivo']), Utils.getListPropsOmit(form.promotionDataRemove, ['id', 'tmp', 'consecutivo']));
  var temp = {
    idInformeResultado: form.idInformeResultado,
    idDonataria: form.idDonataria,
    idCorrida: form.idCorrida,
    preguntas: [{
      idPregunta: form.preguntas.promotionData[0].idPregunta,
      respuesta: form.questionPromotion31 || ''
    }, {
      idPregunta: form.preguntas.promotionData[1].idPregunta,
      respuesta: form.questionPromotion32 || ''
    }, {
      idPregunta: form.preguntas.promotionData[2].idPregunta,
      respuesta: form.questionPromotion33 || ''
    }],
    otrosActores: otrosActores
  };

  return function (dispatch) {
    dispatch((0, _Loading.isLoading)(true));

    return new _ClientHttpRequest2.default({
      service: 'api/updatePromotionHumanRights',
      method: 'POST',
      data: _extends({}, temp),
      headers: Object.assign({ Authorization: sessionStorage.access_token, uid: sessionStorage.uid })
    }).request().then(function (response) {
      dispatch((0, _Loading.isLoading)(false));
      dispatch({ type: ACTION_UPDATE_PROMOTION, Obj: response.data });
    }).catch(function (error) {
      dispatch((0, _Loading.isLoading)(false));
      dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
      throw error;
    });
  };
};

var getImprovementActions = exports.getImprovementActions = function getImprovementActions(form) {
  return function (dispatch) {
    dispatch((0, _Loading.isLoading)(true));

    return new _ClientHttpRequest2.default({
      service: 'api/getImprovementActions',
      method: 'POST',
      data: _extends({}, form),
      headers: Object.assign({ Authorization: sessionStorage.access_token, uid: sessionStorage.uid })
    }).request().then(function (response) {
      dispatch((0, _Loading.isLoading)(false));
      dispatch({ type: ACTION_GET_IMPROVEMENT, Obj: response.data });
      return response;
    }).catch(function (error) {
      dispatch((0, _Loading.isLoading)(false));
      dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
      throw error;
    });
  };
};

var updateImprovementActions = exports.updateImprovementActions = function updateImprovementActions(form) {
  var temp = {
    idInformeResultado: form.idInformeResultado,
    idDonataria: form.idDonataria,
    idCorrida: form.idCorrida,
    preguntas: [{
      idPregunta: form.preguntas.improvementData[0].idPregunta,
      respuesta: form.questionImprovement51 || ''
    }, {
      idPregunta: form.preguntas.improvementData[1].idPregunta,
      respuesta: form.questionImprovement52 || ''
    }],
    otrosActores: null
  };

  return function (dispatch) {
    dispatch((0, _Loading.isLoading)(true));

    return new _ClientHttpRequest2.default({
      service: 'api/updateImprovementActions',
      method: 'POST',
      data: _extends({}, temp),
      headers: Object.assign({ Authorization: sessionStorage.access_token, uid: sessionStorage.uid })
    }).request().then(function (response) {
      dispatch((0, _Loading.isLoading)(false));
      dispatch({ type: ACTION_UPDATE_IMPROVEMENT, Obj: response.data });
    }).catch(function (error) {
      dispatch((0, _Loading.isLoading)(false));
      dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
      throw error;
    });
  };
};

var getResponsibleProgram = exports.getResponsibleProgram = function getResponsibleProgram(form) {
  return function (dispatch) {
    dispatch((0, _Loading.isLoading)(true));

    return new _ClientHttpRequest2.default({
      service: 'api/getResponsibleProgram',
      method: 'POST',
      data: _extends({}, form),
      headers: Object.assign({ Authorization: sessionStorage.access_token, uid: sessionStorage.uid })
    }).request().then(function (response) {
      dispatch((0, _Loading.isLoading)(false));
      dispatch({ type: ACTION_GET_RESPONSIBLE, Obj: response.data });
      return response;
    }).catch(function (error) {
      dispatch((0, _Loading.isLoading)(false));
      dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
      throw error;
    });
  };
};

var updateResponsibleProgram = exports.updateResponsibleProgram = function updateResponsibleProgram(form) {
  var date = null;

  if (form.sendDate) {
    var str = form.sendDate.substr(0, 10).split('-');
    date = str[2] + '-' + str[1] + '-' + str[0];
  }

  var temp = {
    idInformeResultado: form.idInformeResultado,
    idDonataria: form.idDonataria,
    idCorrida: form.idCorrida,
    responsablePrograma: form.responsablePrograma,
    fecha: date,
    estado: null
  };

  return function (dispatch) {
    dispatch((0, _Loading.isLoading)(true));

    return new _ClientHttpRequest2.default({
      service: 'api/updateResponsibleProgram',
      method: 'POST',
      data: _extends({}, temp),
      headers: Object.assign({ Authorization: sessionStorage.access_token, uid: sessionStorage.uid })
    }).request().then(function (response) {
      dispatch((0, _Loading.isLoading)(false));
      dispatch({ type: ACTION_UPDATE_RESPONSIBLE, Obj: response.data });
      return response;
    }).catch(function (error) {
      dispatch((0, _Loading.isLoading)(false));
      dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
      throw error;
    });
  };
};

var breakdownIndicator = exports.breakdownIndicator = function breakdownIndicator(form) {
  return function (dispatch) {
    dispatch((0, _Loading.isLoading)(true));

    return new _ClientHttpRequest2.default({
      service: 'api/breakdownIndicator',
      method: 'POST',
      data: _extends({}, form),
      headers: Object.assign({ Authorization: sessionStorage.access_token, uid: sessionStorage.uid })
    }).request().then(function (response) {
      dispatch((0, _Loading.isLoading)(false));
      dispatch({ type: ACTION_GET_BREAKDOWN_INDICATOR, Obj: response.data });
      return response;
    }).catch(function (error) {
      dispatch((0, _Loading.isLoading)(false));
      dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
      throw error;
    });
  };
};

var addBreakdownIndicator = exports.addBreakdownIndicator = function addBreakdownIndicator(form) {
  var respuestasNuevas = Utils.getListPropsOmit(form.respuestasNuevas, ['tmp']);

  return function (dispatch) {
    dispatch((0, _Loading.isLoading)(true));

    return new _ClientHttpRequest2.default({
      service: 'api/addBreakdownIndicator',
      method: 'POST',
      data: { respuestasNuevas: respuestasNuevas },
      headers: Object.assign({ Authorization: sessionStorage.access_token, uid: sessionStorage.uid })
    }).request().then(function (response) {
      dispatch((0, _Loading.isLoading)(false));
      dispatch({ type: ACTION_ADD_BREAKDOWN_INDICATOR, Obj: response.data });
      return response;
    }).catch(function (error) {
      dispatch((0, _Loading.isLoading)(false));
      dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
      throw error;
    });
  };
};

var updateIndicatorsResultsProgram = exports.updateIndicatorsResultsProgram = function updateIndicatorsResultsProgram(form) {
  var temp = {
    idResultadoProgramaIndicador: form.idResultadoProgramaIndicador,
    metaAlcanzada: form.goalAchieved
  };

  return function (dispatch) {
    dispatch((0, _Loading.isLoading)(true));

    return new _ClientHttpRequest2.default({
      service: 'api/updateIndicatorsResultsProgram',
      method: 'POST',
      data: _extends({}, temp),
      headers: Object.assign({ Authorization: sessionStorage.access_token, uid: sessionStorage.uid })
    }).request().then(function (response) {
      dispatch((0, _Loading.isLoading)(false));
      dispatch({ type: ACTION_UPDATE_INDICATORS_RESULTS_PROGRAM, Obj: response.data });
    }).catch(function (error) {
      dispatch((0, _Loading.isLoading)(false));
      dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
      throw error;
    });
  };
};

var getExpenditure = exports.getExpenditure = function getExpenditure(form) {
  return function (dispatch) {
    dispatch((0, _Loading.isLoading)(true));

    return new _ClientHttpRequest2.default({
      service: 'api/getExpenditure',
      method: 'POST',
      data: _extends({}, form),
      headers: Object.assign({ Authorization: sessionStorage.access_token, uid: sessionStorage.uid })
    }).request().then(function (response) {
      dispatch((0, _Loading.isLoading)(false));
      dispatch({ type: ACTION_GET_EXPENDITURE, Obj: response.data });
    }).catch(function (error) {
      dispatch((0, _Loading.isLoading)(false));
      dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
      throw error;
    });
  };
};

var updateExpenditure = exports.updateExpenditure = function updateExpenditure(form) {
  var temp = {
    idDonataria: form.idDonataria,
    idInforme: form.idInformeResultado,
    idCorrida: form.idCorrida,
    comprobanteGasto: form.distributionDataRubros,
    preguntas: [{
      idPregunta: form.preguntas.distributionDataRubros[0].idPregunta,
      respuesta: form.questionDistribution
    }, {
      idPregunta: form.preguntas.distributionDataRubros[1].idPregunta,
      respuesta: form.questionDistribution43
    }]
  };

  return function (dispatch) {
    dispatch((0, _Loading.isLoading)(true));

    return new _ClientHttpRequest2.default({
      service: 'api/updateExpenditure',
      method: 'POST',
      data: _extends({}, temp),
      headers: Object.assign({ Authorization: sessionStorage.access_token, uid: sessionStorage.uid })
    }).request().then(function (response) {
      dispatch((0, _Loading.isLoading)(false));
      dispatch({ type: ACTION_UPDATE_EXPENDITURE, Obj: response.data });
    }).catch(function (error) {
      dispatch((0, _Loading.isLoading)(false));
      dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
      throw error;
    });
  };
};

var updateExpenditureItem = exports.updateExpenditureItem = function updateExpenditureItem(form) {
  var idDonataria = form.idDonataria,
      idCorrida = form.idCorrida,
      idInformeResultado = form.idInformeResultado;
  var rubroEdited = form.rubroEdited;

  delete rubroEdited.conceptoTabla;
  delete rubroEdited.conceptoEditadoTabla;

  var temp = {
    idDonataria: idDonataria,
    idInforme: idInformeResultado,
    idCorrida: idCorrida,
    comprobanteGasto: [rubroEdited]
  };

  return function (dispatch) {
    dispatch((0, _Loading.isLoading)(true));

    return new _ClientHttpRequest2.default({
      service: 'api/updateExpenditure',
      method: 'POST',
      data: _extends({}, temp),
      headers: Object.assign({ Authorization: sessionStorage.access_token, uid: sessionStorage.uid })
    }).request().then(function (response) {
      dispatch((0, _Loading.isLoading)(false));
      return response.data;
    }).catch(function (error) {
      dispatch((0, _Loading.isLoading)(false));
      dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
      throw error;
    });
  };
};

var deleteDocumentItem = exports.deleteDocumentItem = function deleteDocumentItem(id) {
  return function (dispatch) {
    dispatch((0, _Loading.isLoading)(true));

    return new _ClientHttpRequest2.default({
      service: 'api/deleteDocumentItem',
      method: 'POST',
      data: { id: id },
      headers: Object.assign({ Authorization: sessionStorage.access_token, uid: sessionStorage.uid })
    }).request().then(function (response) {
      dispatch((0, _Loading.isLoading)(false));
      return response.data;
    }).catch(function (error) {
      dispatch((0, _Loading.isLoading)(false));
      dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
      throw error;
    });
  };
};

var addReport = exports.addReport = function addReport(form) {
  var params = {
    idIndicador: form.idIndicador,
    idMeta: form.idMeta,
    idObjetivo: form.idObjetivo,
    id_informe_resultado: form.idInformeResultado
  };

  return function (dispatch) {
    dispatch((0, _Loading.isLoading)(true));

    return new _ClientHttpRequest2.default({
      service: 'api/addReport',
      method: 'POST',
      data: _extends({}, params),
      headers: Object.assign({ Authorization: sessionStorage.access_token, uid: sessionStorage.uid }),
      responseType: 'arraybuffer'
    }).request().then(function (response) {
      dispatch((0, _Loading.isLoading)(false));

      var blob = new Blob([response.data], { type: 'application/pdf' });
      var fileName = 'desglose-indicadores-resultados-' + Utils.getToday() + '.pdf';
      var objectUrl = URL.createObjectURL(blob);
      var a = document.createElement('a');

      a.href = objectUrl;
      a.download = fileName;
      document.body.appendChild(a);
      a.click();

      document.body.removeChild(a);
      URL.revokeObjectURL(objectUrl);
    }).catch(function (error) {
      dispatch((0, _Loading.isLoading)(false));
      dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
      throw error;
    });
  };
};

var generateReport = exports.generateReport = function generateReport(idReporte) {
  return function (dispatch) {
    dispatch((0, _Loading.isLoading)(true));

    return new _ClientHttpRequest2.default({
      service: 'api/generateReport',
      method: 'POST',
      data: { idReporte: idReporte },
      headers: Object.assign({ Authorization: sessionStorage.access_token, uid: sessionStorage.uid }),
      responseType: 'arraybuffer'
    }).request().then(function (response) {
      dispatch((0, _Loading.isLoading)(false));

      var blob = new Blob([response.data], { type: 'application/pdf' });
      var fileName = 'informe-resultados-reporte-' + Utils.getToday() + '.pdf';
      var objectUrl = URL.createObjectURL(blob);
      var a = document.createElement('a');

      a.href = objectUrl;
      a.download = fileName;
      document.body.appendChild(a);
      a.click();

      document.body.removeChild(a);
      URL.revokeObjectURL(objectUrl);
    }).catch(function (error) {
      dispatch((0, _Loading.isLoading)(false));
      dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
      throw error;
    });
  };
};

var clearResultsReport = exports.clearResultsReport = function clearResultsReport() {
  return function (dispatch) {
    dispatch({ type: ACTION_GET_INDICATORS_RESULTS, Obj: {} });
    dispatch({ type: ACTION_UPDATE_INDICATORS_RESULTS, Obj: {} });
    dispatch({ type: ACTION_GET_LESSONS, Obj: {} });
    dispatch({ type: ACTION_UPDATE_LESSONS, Obj: {} });
    dispatch({ type: ACTION_GET_PROMOTION, Obj: {} });
    dispatch({ type: ACTION_UPDATE_PROMOTION, Obj: {} });
    dispatch({ type: ACTION_GET_IMPROVEMENT, Obj: {} });
    dispatch({ type: ACTION_UPDATE_IMPROVEMENT, Obj: {} });
    dispatch({ type: ACTION_GET_RESPONSIBLE, Obj: {} });
    dispatch({ type: ACTION_UPDATE_RESPONSIBLE, Obj: {} });
    dispatch({ type: ACTION_GET_BREAKDOWN_INDICATOR, Obj: {} });
    dispatch({ type: ACTION_ADD_BREAKDOWN_INDICATOR, Obj: {} });
    dispatch({ type: ACTION_UPDATE_INDICATORS_RESULTS_PROGRAM, Obj: {} });
    dispatch({ type: ACTION_GET_EXPENDITURE, Obj: {} });
    dispatch({ type: ACTION_UPDATE_EXPENDITURE, Obj: {} });
  };
};

/***/ }),

/***/ 484:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.getGoodsCatalog = exports.searchGoodsCatalog = exports.addGoodsCatalog = exports.ACTION_GET_GOODS_CATALOG = exports.ACTION_SEARCH_GOODS_CATALOG = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _Utils = __webpack_require__(2);

var Utils = _interopRequireWildcard(_Utils);

var _ClientHttpRequest = __webpack_require__(5);

var _ClientHttpRequest2 = _interopRequireDefault(_ClientHttpRequest);

var _immutable = __webpack_require__(1);

var _immutable2 = _interopRequireDefault(_immutable);

var _Modal = __webpack_require__(4);

var _Loading = __webpack_require__(3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var initialState = _immutable2.default.Map({}).set('Search', new _immutable2.default.List([])).set('Get', new _immutable2.default.Map({}));

/* Types */

var ACTION_SEARCH_GOODS_CATALOG = exports.ACTION_SEARCH_GOODS_CATALOG = 'ACTION_SEARCH_GOODS_CATALOG';
var ACTION_GET_GOODS_CATALOG = exports.ACTION_GET_GOODS_CATALOG = 'ACTION_GET_GOODS_CATALOG';

/* Reducer */

exports.default = function () {
	var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	var action = arguments[1];


	switch (action.type) {
		case ACTION_SEARCH_GOODS_CATALOG:
			return state.set('Search', new _immutable2.default.List(action.Obj));
		case ACTION_GET_GOODS_CATALOG:
			return state.set('Get', new _immutable2.default.Map(action.Obj));
		default:
			return state;
	}
};

/* Action Creators */

var addGoodsCatalog = exports.addGoodsCatalog = function addGoodsCatalog(form) {

	var temp = {
		id: form.id,
		deleted: form.state,
		autor: sessionStorage.uid,
		descripcion: form.bien
	};

	return function (dispatch) {

		dispatch((0, _Loading.isLoading)(true));

		return new _ClientHttpRequest2.default({
			service: temp.id ? 'api/updateGoodsCatalog' : 'api/addGoodsCatalog',
			method: "POST",
			data: _extends({}, temp),
			headers: Object.assign({ "Authorization": sessionStorage.access_token, "uid": sessionStorage.uid })
		}).request().then(function (response) {
			dispatch((0, _Loading.isLoading)(false));
			return response.data;
		}).catch(function (error) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
			throw error;
		});
	};
};

var searchGoodsCatalog = exports.searchGoodsCatalog = function searchGoodsCatalog(form) {

	return function (dispatch) {

		dispatch((0, _Loading.isLoading)(true));

		return new _ClientHttpRequest2.default({
			service: Object.keys(form).length ? 'api/searchGoodsCatalogByParams' : 'api/searchGoodsCatalog',
			method: "POST",
			data: _extends({}, form),
			headers: Object.assign({ "Authorization": sessionStorage.access_token, "uid": sessionStorage.uid })
		}).request().then(function (response) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch({ type: ACTION_SEARCH_GOODS_CATALOG, Obj: response.data });
			return response.data;
		}).catch(function (error) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
			throw error;
		});
	};
};

var getGoodsCatalog = exports.getGoodsCatalog = function getGoodsCatalog(id) {

	return function (dispatch) {

		dispatch((0, _Loading.isLoading)(true));

		return new _ClientHttpRequest2.default({
			service: 'api/getGoodsCatalog',
			method: "POST",
			data: { id: id },
			headers: Object.assign({ "Authorization": sessionStorage.access_token, "uid": sessionStorage.uid })
		}).request().then(function (response) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch({ type: ACTION_GET_GOODS_CATALOG, Obj: response.data });
			return response.data;
		}).catch(function (error) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
			throw error;
		});
	};
};

/***/ }),

/***/ 485:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.clearTypeCatalog = exports.updateTypeCatalog = exports.deleteTypeCatalog = exports.searchTypeCatalog = exports.addTypeCatalog = exports.getTypeCatalog = exports.ACTION_UPDATE_TYPECATALOG = exports.ACTION_DELETE_TYPECATALOG = exports.ACTION_SEARCH_TYPECATALOG = exports.ACTION_GET_TYPECATALOG = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _Utils = __webpack_require__(2);

var Utils = _interopRequireWildcard(_Utils);

var _ClientHttpRequest = __webpack_require__(5);

var _ClientHttpRequest2 = _interopRequireDefault(_ClientHttpRequest);

var _immutable = __webpack_require__(1);

var _immutable2 = _interopRequireDefault(_immutable);

var _Modal = __webpack_require__(4);

var _Loading = __webpack_require__(3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var initialState = _immutable2.default.Map({}).set('Search', new _immutable2.default.List([])).set('Response', new _immutable2.default.Map({})).set('Get', new _immutable2.default.Map({}));

/* Types */
var ACTION_GET_TYPECATALOG = exports.ACTION_GET_TYPECATALOG = 'ACTION_GET_TYPECATALOG';
var ACTION_SEARCH_TYPECATALOG = exports.ACTION_SEARCH_TYPECATALOG = 'ACTION_SEARCH_TYPECATALOG';
var ACTION_DELETE_TYPECATALOG = exports.ACTION_DELETE_TYPECATALOG = 'ACTION_DELETE_TYPECATALOG';
var ACTION_UPDATE_TYPECATALOG = exports.ACTION_UPDATE_TYPECATALOG = 'ACTION_UPDATE_TYPECATALOG';

/* Reducer */

exports.default = function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments[1];

  switch (action.type) {
    case ACTION_GET_TYPECATALOG:
      return state.set('Get', new _immutable2.default.Map(action.Obj));
    case ACTION_SEARCH_TYPECATALOG:
      return state.set('Search', new _immutable2.default.List(action.Obj));
    case ACTION_DELETE_TYPECATALOG:
      return state.set('Response', new _immutable2.default.Map(action.Obj));
    case ACTION_UPDATE_TYPECATALOG:
      return state.set('Response', new _immutable2.default.Map(action.Obj));
    default:
      return state;
  }
};

/* Action Creators */

var getTypeCatalog = exports.getTypeCatalog = function getTypeCatalog(id) {
  return function (dispatch) {
    dispatch((0, _Loading.isLoading)(true));

    return new _ClientHttpRequest2.default({
      service: 'api/getTypeCatalog',
      method: "POST",
      data: { id: id },
      headers: Object.assign({ "Authorization": sessionStorage.access_token, "uid": sessionStorage.uid })
    }).request().then(function (response) {
      dispatch((0, _Loading.isLoading)(false));
      dispatch({ type: ACTION_GET_TYPECATALOG, Obj: response.data });
    }).catch(function (error) {
      dispatch((0, _Loading.isLoading)(false));
      dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
      throw error;
    });
  };
};

var addTypeCatalog = exports.addTypeCatalog = function addTypeCatalog(form) {

  var temp = {
    aplica: {
      id: form.aplica
    },
    autor: sessionStorage.uid,
    deleted: form.state === 1 ? false : true,
    descripcion: form.tipoCatalogo
  };

  return function (dispatch) {
    dispatch((0, _Loading.isLoading)(true));

    return new _ClientHttpRequest2.default({
      service: 'api/addTypeCatalog',
      method: 'POST',
      data: _extends({}, temp),
      headers: Object.assign({ Authorization: sessionStorage.access_token, uid: sessionStorage.uid })
    }).request().then(function () {
      dispatch((0, _Loading.isLoading)(false));
      dispatch((0, _Modal.createModal)(Utils.successMessage()));
    }).catch(function (error) {
      dispatch((0, _Loading.isLoading)(false));
      dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
      throw error;
    });
  };
};

var searchTypeCatalog = exports.searchTypeCatalog = function searchTypeCatalog(form) {

  Utils.clearNullAndEmpty(form);

  var temp = {
    aplica: {
      id: form.aplica ? form.aplica : null
    },
    deleted: form.state === 1 ? false : form.state === 2 ? true : null,
    descripcion: form.tipoCatalogo ? form.tipoCatalogo : null
  };

  return function (dispatch) {

    dispatch((0, _Loading.isLoading)(true));
    // service: Object.keys(form).length == 0 ? 'api/searchTypeCatalog' : 'api/searchParamTypeCatalog',

    return new _ClientHttpRequest2.default({
      service: 'api/searchTypeCatalog',
      method: "POST",
      data: _extends({}, temp),
      headers: Object.assign({ "Authorization": sessionStorage.access_token, "uid": sessionStorage.uid })
    }).request().then(function (response) {
      dispatch((0, _Loading.isLoading)(false));
      dispatch({ type: ACTION_SEARCH_TYPECATALOG, Obj: response.data });
    }).catch(function (error) {
      dispatch((0, _Loading.isLoading)(false));
      dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
      throw error;
    });
  };
};

var deleteTypeCatalog = exports.deleteTypeCatalog = function deleteTypeCatalog(id) {
  return function (dispatch) {
    dispatch((0, _Loading.isLoading)(true));
    dispatch({ type: ACTION_GET_TYPECATALOG, Obj: {} });

    return new _ClientHttpRequest2.default({
      service: 'api/deleteTypeCatalog',
      method: 'POST',
      data: { id: id },
      headers: Object.assign({ Authorization: sessionStorage.access_token, uid: sessionStorage.uid })
    }).request().then(function (response) {
      dispatch((0, _Loading.isLoading)(false));
      dispatch({ type: ACTION_DELETE_TYPECATALOG, Obj: response.data });
      dispatch((0, _Modal.createModal)(Utils.successMessage()));
    }).catch(function (error) {
      dispatch((0, _Loading.isLoading)(false));
      dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
      throw error;
    });
  };
};

var updateTypeCatalog = exports.updateTypeCatalog = function updateTypeCatalog(form) {

  var temp = {
    aplica: {
      id: form.aplica
    },
    autor: sessionStorage.uid,
    deleted: form.state === 1 ? false : form.state === 2 ? true : null,
    descripcion: form.tipoCatalogo,
    id: form.id
  };

  return function (dispatch) {
    dispatch((0, _Loading.isLoading)(true));
    dispatch({ type: ACTION_GET_TYPECATALOG, Obj: {} });

    return new _ClientHttpRequest2.default({
      service: 'api/updateTypeCatalog',
      method: 'POST',
      data: _extends({}, temp),
      headers: Object.assign({ Authorization: sessionStorage.access_token, uid: sessionStorage.uid })
    }).request().then(function (response) {
      dispatch((0, _Loading.isLoading)(false));
      dispatch({ type: ACTION_UPDATE_TYPECATALOG, Obj: response.data });
      dispatch((0, _Modal.createModal)(Utils.successMessage()));
    }).catch(function (error) {
      dispatch((0, _Loading.isLoading)(false));
      dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
      throw error;
    });
  };
};

var clearTypeCatalog = exports.clearTypeCatalog = function clearTypeCatalog() {
  return function (dispatch) {
    dispatch({ type: ACTION_GET_TYPECATALOG, Obj: {} });
    dispatch({ type: ACTION_SEARCH_TYPECATALOG, Obj: [] });
  };
};

/***/ }),

/***/ 486:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.clearIntegralValuation = exports.updateIntegralValuation = exports.getIntegralValuationConsultant = exports.searchIntegralValuation = exports.addIntegralValuation = exports.ACTION_GET_INTEGRALVALUATION_CONSULTANT = exports.ACTION_SEARCH_INTEGRALVALUATION = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _Utils = __webpack_require__(2);

var Utils = _interopRequireWildcard(_Utils);

var _ClientHttpRequest = __webpack_require__(5);

var _ClientHttpRequest2 = _interopRequireDefault(_ClientHttpRequest);

var _immutable = __webpack_require__(1);

var _immutable2 = _interopRequireDefault(_immutable);

var _Modal = __webpack_require__(4);

var _Loading = __webpack_require__(3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var initialState = _immutable2.default.Map({}).set('GetAll', new _immutable2.default.List([])).set('GetConsultant', new _immutable2.default.Map({}));

/* Types */
var ACTION_SEARCH_INTEGRALVALUATION = exports.ACTION_SEARCH_INTEGRALVALUATION = 'ACTION_SEARCH_INTEGRALVALUATION';
var ACTION_GET_INTEGRALVALUATION_CONSULTANT = exports.ACTION_GET_INTEGRALVALUATION_CONSULTANT = 'ACTION_GET_INTEGRALVALUATION_CONSULTANT';

/* Reducer */

exports.default = function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments[1];

  switch (action.type) {
    case ACTION_SEARCH_INTEGRALVALUATION:
      return state.set('GetAll', new _immutable2.default.List(action.Obj));
    case ACTION_GET_INTEGRALVALUATION_CONSULTANT:
      return state.set('GetConsultant', new _immutable2.default.Map(action.Obj));
    default:
      return state;
  }
};

/* Action Creators */

var addIntegralValuation = exports.addIntegralValuation = function addIntegralValuation(form) {

  var data = Object.assign({}, form);

  var tmp = {
    id: data.id,
    descripcion: data.descriptionIntegral,
    estatus: data.status === 1 ? false : true,
    autor: sessionStorage.uid,
    rangos: Utils.unionArray(data.rangeNew, data.rangeNewRemove),
    ponderaciones: Utils.unionArray(data.evaluationNew, data.evaluationNewRemove)
  };

  return function (dispatch) {
    dispatch((0, _Loading.isLoading)(true));

    return new _ClientHttpRequest2.default({
      service: data.id ? 'api/updateIntegralValuation' : 'api/addIntegralValuation',
      method: 'POST',
      data: _extends({}, tmp),
      headers: Object.assign({ Authorization: sessionStorage.access_token, uid: sessionStorage.uid })
    }).request().then(function (response) {
      dispatch((0, _Loading.isLoading)(false));
      return response.data;
    }).catch(function (error) {
      dispatch((0, _Loading.isLoading)(false));
      dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
      throw error;
    });
  };
};

var searchIntegralValuation = exports.searchIntegralValuation = function searchIntegralValuation(form) {

  return function (dispatch) {
    dispatch((0, _Loading.isLoading)(true));

    return new _ClientHttpRequest2.default({
      service: Object.keys(form).length ? 'api/searchIntegralValuationByParams' : 'api/searchIntegralValuation',
      method: 'POST',
      data: _extends({}, form),
      headers: Object.assign({ Authorization: sessionStorage.access_token, uid: sessionStorage.uid })
    }).request().then(function (response) {
      dispatch((0, _Loading.isLoading)(false));

      response.data = response.data.map(function (r) {
        r.deleted = r.estatus ? r.estatus : r.deleted;
        return r;
      });

      dispatch({ type: ACTION_SEARCH_INTEGRALVALUATION, Obj: response.data });
      return response;
    }).catch(function (error) {
      dispatch((0, _Loading.isLoading)(false));
      dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
      throw error;
    });
  };
};

var getIntegralValuationConsultant = exports.getIntegralValuationConsultant = function getIntegralValuationConsultant(idConfiguracionValoracionIntegral) {
  return function (dispatch) {
    dispatch((0, _Loading.isLoading)(true));

    return new _ClientHttpRequest2.default({
      service: 'api/getIntegralValuationConsultant',
      method: 'POST',
      data: { idConfiguracionValoracionIntegral: idConfiguracionValoracionIntegral },
      headers: Object.assign({ Authorization: sessionStorage.access_token, uid: sessionStorage.uid })
    }).request().then(function (response) {
      dispatch((0, _Loading.isLoading)(false));
      dispatch({ type: ACTION_GET_INTEGRALVALUATION_CONSULTANT, Obj: response.data });
      return response;
    }).catch(function (error) {
      dispatch((0, _Loading.isLoading)(false));
      dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
      throw error;
    });
  };
};

var updateIntegralValuation = exports.updateIntegralValuation = function updateIntegralValuation(form) {
  return function (dispatch) {
    dispatch((0, _Loading.isLoading)(true));

    return new _ClientHttpRequest2.default({
      service: 'api/updateIntegralValuation',
      method: 'POST',
      data: _extends({}, form),
      headers: Object.assign({ Authorization: sessionStorage.access_token, uid: sessionStorage.uid })
    }).request().then(function (response) {
      dispatch((0, _Loading.isLoading)(false));
      return response;
    }).catch(function (error) {
      dispatch((0, _Loading.isLoading)(false));
      dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
      throw error;
    });
  };
};

var clearIntegralValuation = exports.clearIntegralValuation = function clearIntegralValuation() {
  return function (dispatch) {
    dispatch({ type: ACTION_SEARCH_INTEGRALVALUATION, Obj: [] });
    return Promise.resolve();
  };
};

/***/ }),

/***/ 487:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.clearAllData = exports.clearCalculationDetail = exports.generateCertificateCalculation = exports.saveCertificateCalculation = exports.getCertificateCalculation = exports.updateStatusCalculationDetail = exports.exportPreDonationDetail = exports.updatePreDonationGrantee = exports.getPreCalculationDetail = exports.asignarMontosDonativoPre = exports.calculationPreDonation = exports.getPreCalculations = exports.getPreDonationsEvents = exports.CERTIFICATE_CALCULATION = exports.GET_PRE_CALCULATION_DETAIL = exports.GET_PRE_CALCULATIONS = exports.GET_PRE_DONATION_EVENTS = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _Utils = __webpack_require__(2);

var Utils = _interopRequireWildcard(_Utils);

var _ClientHttpRequest = __webpack_require__(5);

var _ClientHttpRequest2 = _interopRequireDefault(_ClientHttpRequest);

var _immutable = __webpack_require__(1);

var _immutable2 = _interopRequireDefault(_immutable);

var _Modal = __webpack_require__(4);

var _Loading = __webpack_require__(3);

var _Loader = __webpack_require__(205);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var initialState = _immutable2.default.Map({}).set('Search', new _immutable2.default.List([])).set('Response', new _immutable2.default.List([])).set('Get', new _immutable2.default.Map({ donatarias: [], totalDonantes: [] })).set('Certificate', new _immutable2.default.Map({}));

/* Types */
var GET_PRE_DONATION_EVENTS = exports.GET_PRE_DONATION_EVENTS = 'GET_PRE_DONATION_EVENTS';
var GET_PRE_CALCULATIONS = exports.GET_PRE_CALCULATIONS = 'GET_PRE_CALCULATIONS';
var GET_PRE_CALCULATION_DETAIL = exports.GET_PRE_CALCULATION_DETAIL = 'GET_PRE_CALCULATION_DETAIL';
var CERTIFICATE_CALCULATION = exports.CERTIFICATE_CALCULATION = 'CERTIFICATE_CALCULATION';

/* Reducer*/

exports.default = function () {
	var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	var action = arguments[1];


	switch (action.type) {
		case GET_PRE_DONATION_EVENTS:
			return state.set('Search', new _immutable2.default.List(action.Obj));
		case GET_PRE_CALCULATIONS:
			return state.set('Response', new _immutable2.default.List(action.Obj));
		case GET_PRE_CALCULATION_DETAIL:
			return state.set('Get', new _immutable2.default.Map(action.Obj));
		case CERTIFICATE_CALCULATION:
			return state.set('Certificate', new _immutable2.default.Map(action.Obj));
		default:
			return state;
	}
};

/* Action Creators */

var getPreDonationsEvents = exports.getPreDonationsEvents = function getPreDonationsEvents() {

	return function (dispatch) {
		dispatch((0, _Loading.isLoading)(true));

		return new _ClientHttpRequest2.default({
			service: 'api/donativoPre/getPreDonationsEvents',
			method: "POST",
			data: {},
			headers: Object.assign({ "Authorization": sessionStorage.access_token, "uid": sessionStorage.uid })
		}).request().then(function (response) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch({ type: GET_PRE_DONATION_EVENTS, Obj: response.data });
			return response.data;
		}).catch(function (error) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
			throw error;
		});
	};
};

var getPreCalculations = exports.getPreCalculations = function getPreCalculations(idDonataria) {

	return function (dispatch) {
		dispatch((0, _Loading.isLoading)(true));

		return new _ClientHttpRequest2.default({
			service: 'api/donativoPre/getPreCalculations',
			method: "POST",
			data: { idDonataria: idDonataria },
			headers: Object.assign({ "Authorization": sessionStorage.access_token, "uid": sessionStorage.uid })
		}).request().then(function (response) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch({ type: GET_PRE_CALCULATIONS, Obj: response.data });
		}).catch(function (error) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
			throw error;
		});
	};
};

var calculationPreDonation = exports.calculationPreDonation = function calculationPreDonation(form) {

	var temp = {
		usuario: sessionStorage.uid,
		configuracionFuncionId: form.configuracionFuncionId || null,
		corridaId: form.corrida,
		evaluaciones: form.evaluaciones ? form.evaluaciones.split(',') : [],
		funcion: form.funcion,
		funcionId: form.funcionId,
		redondeo: form.redondeo,
		redondeoId: form.redondeoId
	};

	return function (dispatch) {
		dispatch((0, _Loading.isLoading)(true));

		return new _ClientHttpRequest2.default({
			service: 'api/donativoPre/calculationPreDonation',
			method: "POST",
			data: _extends({}, temp),
			headers: Object.assign({ "Authorization": sessionStorage.access_token, "uid": sessionStorage.uid })
		}).request().then(function (response) {
			dispatch((0, _Loading.isLoading)(false));
			return response.data;
		}).catch(function (error) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
			throw error;
		});
	};
};

var asignarMontosDonativoPre = exports.asignarMontosDonativoPre = function asignarMontosDonativoPre(form) {

	return function (dispatch) {
		dispatch((0, _Loader.isLoader)(true));

		return new _ClientHttpRequest2.default({
			service: 'api/donativoPre/asignarMontosDonativoPre',
			method: "POST",
			data: _extends({}, form),
			headers: Object.assign({ "Authorization": sessionStorage.access_token, "uid": sessionStorage.uid })
		}).request().then(function (response) {
			dispatch((0, _Loader.isLoader)(false));
			return response.data;
		}).catch(function (error) {
			dispatch((0, _Loader.isLoader)(false));
			dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
			throw error;
		});
	};
};

var getPreCalculationDetail = exports.getPreCalculationDetail = function getPreCalculationDetail(form) {

	var temp = {
		corridaId: form.corrida,
		configuracionId: form.item.configuracionId,
		funcionId: form.item.funcionId
	};

	return function (dispatch) {
		dispatch((0, _Loading.isLoading)(true));

		return new _ClientHttpRequest2.default({
			service: 'api/donativoPre/getPreCalculationDetail',
			method: "POST",
			data: _extends({}, temp),
			headers: Object.assign({ "Authorization": sessionStorage.access_token, "uid": sessionStorage.uid })
		}).request().then(function (response) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch({ type: GET_PRE_CALCULATION_DETAIL, Obj: response.data });
			return response.data;
		}).catch(function (error) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
			throw error;
		});
	};
};

var updatePreDonationGrantee = exports.updatePreDonationGrantee = function updatePreDonationGrantee(form) {

	var temp = {
		usuario: sessionStorage.uid,
		corridaId: form.corrida,
		configuracionId: form.item.configuracionId,
		funcionId: form.item.funcionId,
		donatariaId: form.donatariaId,
		donativoPre: parseFloat(form.montoDonativoPre)
	};

	return function (dispatch) {
		dispatch((0, _Loading.isLoading)(true));

		return new _ClientHttpRequest2.default({
			service: 'api/donativoPre/updatePreDonationGrantee',
			method: "POST",
			data: _extends({}, temp),
			headers: Object.assign({ "Authorization": sessionStorage.access_token, "uid": sessionStorage.uid })
		}).request().then(function (response) {
			dispatch((0, _Loading.isLoading)(false));
			return response.data;
		}).catch(function (error) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
			throw error;
		});
	};
};

var exportPreDonationDetail = exports.exportPreDonationDetail = function exportPreDonationDetail(form) {

	var temp = {
		corridaId: form.corrida,
		configuracionId: form.item.configuracionId,
		funcionId: form.item.funcionId
	};

	return function (dispatch) {
		dispatch((0, _Loading.isLoading)(true));

		return new _ClientHttpRequest2.default({
			service: 'api/donativoPre/exportPreDonationDetail',
			method: "POST",
			data: _extends({}, temp),
			headers: Object.assign({ "Authorization": sessionStorage.access_token, "uid": sessionStorage.uid }),
			responseType: 'arraybuffer'
		}).request().then(function (response) {
			dispatch((0, _Loading.isLoading)(false));

			var blob = new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
			var fileName = 'donativoPre-corrida-' + temp.corridaId + '-' + Utils.getToday() + '.xlsx';
			var objectUrl = URL.createObjectURL(blob);
			var a = document.createElement('a');

			a.href = objectUrl;
			a.download = fileName;
			document.body.appendChild(a);
			a.click();

			document.body.removeChild(a);
			URL.revokeObjectURL(objectUrl);
		}).catch(function (error) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
			throw error;
		});
	};
};

var updateStatusCalculationDetail = exports.updateStatusCalculationDetail = function updateStatusCalculationDetail(form) {

	var temp = {
		usuario: {
			idUsuario: sessionStorage.uid
		},
		idCorrida: form.corrida,
		descripcionOportunidad: form.descripcionOportunidad,
		idConfiguracion: form.item.configuracionId,
		idFuncion: form.item.funcionId,
		comentarios: form.comentarios || "",
		idEstado: form.statusUpdated
	};

	return function (dispatch) {
		dispatch((0, _Loading.isLoading)(true));

		return new _ClientHttpRequest2.default({
			service: 'api/donativoPre/updateStatusCalculationDetail',
			method: "POST",
			data: _extends({}, temp),
			headers: Object.assign({ "Authorization": sessionStorage.access_token, "uid": sessionStorage.uid })
		}).request().then(function (response) {
			dispatch((0, _Loading.isLoading)(false));
			return response.data;
		}).catch(function (error) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
			throw error;
		});
	};
};

var getCertificateCalculation = exports.getCertificateCalculation = function getCertificateCalculation(form) {

	var temp = {
		corridaId: form.corrida,
		funcionId: form.item.funcionId,
		configuracionFuncionId: form.item.configuracionId
	};

	return function (dispatch) {
		dispatch((0, _Loading.isLoading)(true));

		return new _ClientHttpRequest2.default({
			service: 'api/donativoPre/getCertificateCalculation',
			method: "POST",
			data: _extends({}, temp),
			headers: Object.assign({ "Authorization": sessionStorage.access_token, "uid": sessionStorage.uid })
		}).request().then(function (response) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch({ type: CERTIFICATE_CALCULATION, Obj: response.data });
			return response.data;
		}).catch(function (error) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
			throw error;
		});
	};
};

var saveCertificateCalculation = exports.saveCertificateCalculation = function saveCertificateCalculation(form) {

	var temp = {
		configuracionFuncionId: form.item.configuracionId,
		funcionId: form.item.funcionId,
		corridaId: form.corrida,
		certificadoId: form.certificadoId ? form.certificadoId : 0,
		dropboxId: form.logotipo || null,
		texto1: form.texto1,
		texto2: form.texto2,
		texto3: form.texto3,
		texto4: form.textEditor,
		texto5: form.texto5,
		texto6: form.texto6,
		texto7: form.texto7,
		piePagina: form.pieDePagina,
		firma1: form.firma1,
		firma2: form.firma2,
		firma3: form.texto7Firma1,
		firma4: form.texto7Firma2,
		usuario: sessionStorage.uid
	};

	temp.participantesDTO = [];
	temp.equiposTrabajoDTO = [];

	form.signs.map(function (item) {
		temp.participantesDTO.push({
			apellidoMaterno: item.maternoOriginal,
			apellidoPaterno: item.paternoOriginal,
			nombre: item.nombreOriginal,
			puesto: item.puesto,
			titulo: item.titulo
		});
	});

	form.body.map(function (item) {
		var auxArrayParticipantes = [];

		item.original.map(function (data) {
			auxArrayParticipantes.push({ firmaParticipanteEquipo: data.firma });
		});

		temp.equiposTrabajoDTO.push({
			participantesEquipoDTO: auxArrayParticipantes,
			texto8: item.texto8,
			texto9: item.texto9
		});
	});

	return function (dispatch) {

		dispatch((0, _Loading.isLoading)(true));

		return new _ClientHttpRequest2.default({
			service: 'api/donativoPre/saveCertificateCalculation',
			method: "POST",
			data: _extends({}, temp),
			headers: Object.assign({ "Authorization": sessionStorage.access_token, "uid": sessionStorage.uid }),
			responseType: 'arraybuffer'
		}).request().then(function (response) {
			dispatch((0, _Loading.isLoading)(false));
			return response.data;
		}).catch(function (error) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
			throw error;
		});
	};
};

var generateCertificateCalculation = exports.generateCertificateCalculation = function generateCertificateCalculation(form) {

	var temp = {
		configuracionFuncionId: form.item.configuracionId,
		funcionId: form.item.funcionId,
		corridaId: form.corrida,
		usuario: sessionStorage.uid
	};

	return function (dispatch) {

		dispatch((0, _Loading.isLoading)(true));

		return new _ClientHttpRequest2.default({
			service: 'api/donativoPre/generateCertificateCalculation',
			method: "POST",
			data: _extends({}, temp),
			headers: Object.assign({ "Authorization": sessionStorage.access_token, "uid": sessionStorage.uid }),
			responseType: 'arraybuffer'
		}).request().then(function (response) {
			dispatch((0, _Loading.isLoading)(false));

			var blob = new Blob([response.data], { type: 'application/pdf' });
			var fileName = 'certificado DonativoPre-corrida-' + form.corrida + Utils.getToday() + '.pdf';
			var objectUrl = URL.createObjectURL(blob);
			var a = document.createElement('a');

			a.href = objectUrl;
			a.download = fileName;
			document.body.appendChild(a);
			a.click();

			document.body.removeChild(a);
			URL.revokeObjectURL(objectUrl);
		}).catch(function (error) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
			throw error;
		});
	};
};

var clearCalculationDetail = exports.clearCalculationDetail = function clearCalculationDetail() {

	return function (dispatch) {
		dispatch({ type: GET_PRE_CALCULATIONS, Obj: [] });
		dispatch({ type: GET_PRE_CALCULATION_DETAIL, Obj: { donatarias: [], totalDonantes: [] } });
		return Promise.resolve();
	};
};

var clearAllData = exports.clearAllData = function clearAllData() {

	return function (dispatch) {
		dispatch({ type: GET_PRE_DONATION_EVENTS, Obj: [] });
		dispatch({ type: GET_PRE_CALCULATIONS, Obj: [] });
		dispatch({ type: GET_PRE_CALCULATION_DETAIL, Obj: { donatarias: [], totalDonantes: [] } });
		return Promise.resolve();
	};
};

/***/ }),

/***/ 488:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.postSolicitudes = exports.getSolicitudes = exports.getReportes = exports.ACTION_GET_SOLICITUDES_LIST = exports.ACTION_GET_REPORTES_LIST = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _Utils = __webpack_require__(2);

var Utils = _interopRequireWildcard(_Utils);

var _ClientHttpRequest = __webpack_require__(5);

var _ClientHttpRequest2 = _interopRequireDefault(_ClientHttpRequest);

var _immutable = __webpack_require__(1);

var _immutable2 = _interopRequireDefault(_immutable);

var _Modal = __webpack_require__(4);

var _Loading = __webpack_require__(3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var initialState = _immutable2.default.Map({}).set('GetListReportes', new _immutable2.default.List([])).set('GetListSolicitudes', new _immutable2.default.List([]));

/*Types*/
var ACTION_GET_REPORTES_LIST = exports.ACTION_GET_REPORTES_LIST = "ACTION_GET_REPORTES_LIST";
var ACTION_GET_SOLICITUDES_LIST = exports.ACTION_GET_SOLICITUDES_LIST = "ACTION_GET_SOLICITUDES_LIST";

/*Reducer*/

exports.default = function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments[1];


  switch (action.type) {
    case ACTION_GET_REPORTES_LIST:
      return state.set('GetListReportes', new _immutable2.default.List(action.Obj));
    case ACTION_GET_SOLICITUDES_LIST:
      return state.set('GetListSolicitudes', new _immutable2.default.List(action.Obj));
    default:
      return state;
  }
};

/*Action Creators*/

var getReportes = exports.getReportes = function getReportes(form) {

  return function (dispatch) {
    dispatch((0, _Loading.isLoading)(true));
    return new _ClientHttpRequest2.default({
      service: 'api/listReports',
      method: 'POST',
      data: _extends({}, form),
      headers: Object.assign({ 'Authorization': sessionStorage.access_token, 'uid': sessionStorage.uid })
    }).request().then(function (response) {
      dispatch((0, _Loading.isLoading)(false));
      dispatch({
        type: ACTION_GET_REPORTES_LIST,
        Obj: new _immutable2.default.List(Utils.createSelectReportes(response.data))
      });
      // dispatch({ type: ACTION_GET_REPORTES_LIST, Obj: response.data })
      return response;
    }).catch(function (error) {
      dispatch((0, _Loading.isLoading)(false));

      dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
      throw error;
    });
  };
};

var getSolicitudes = exports.getSolicitudes = function getSolicitudes(form) {

  return function (dispatch) {
    dispatch((0, _Loading.isLoading)(true));

    return new _ClientHttpRequest2.default({
      service: 'api/listSolicitudes',
      method: 'POST',
      data: _extends({}, form),
      headers: Object.assign({ 'Authorization': sessionStorage.access_token, 'uid': sessionStorage.uid })
    }).request().then(function (response) {
      dispatch((0, _Loading.isLoading)(false));
      dispatch({ type: ACTION_GET_SOLICITUDES_LIST, Obj: response.data });
      return response;
    }).catch(function (error) {
      dispatch((0, _Loading.isLoading)(false));
      dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
      throw error;
    });
  };
};

var postSolicitudes = exports.postSolicitudes = function postSolicitudes(form) {
  return function (dispatch) {
    dispatch((0, _Loading.isLoading)(true));

    return new _ClientHttpRequest2.default({
      service: 'api/SolicitudesReports',
      method: 'POST',
      // responseType:'arraybuffer',
      data: _extends({}, form),
      headers: Object.assign({ 'Authorization': sessionStorage.access_token, 'uid': sessionStorage.uid })
    }).request().then(function (response) {
      dispatch((0, _Loading.isLoading)(false));

      /*  const blob = new Blob([response.nombre], { type: 'application/pdf' })
        const fileName = `reporte-${Utils.getToday()}.pdf`
        const objectUrl = URL.createObjectURL(blob)
        const a = document.createElement('a')
        //a.href = objectUrl
        a.href = 'http://www.ite.educacion.es/formacion/materiales/107/cd/html/pdf/html11.pdf'
         a.download = fileName
        document.body.appendChild(a)
        a.click()
        document.body.removeChild(a)
        URL.revokeObjectURL(objectUrl)*/
      return response;
    }).catch(function (error) {
      dispatch((0, _Loading.isLoading)(false));
      dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
      throw error;
    });
  };
};

/***/ }),

/***/ 489:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.getDataReceptionAudit = exports.ACTION_GET_SERVICE_RECEPTION_AUDIT = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _Utils = __webpack_require__(2);

var Utils = _interopRequireWildcard(_Utils);

var _ClientHttpRequest = __webpack_require__(5);

var _ClientHttpRequest2 = _interopRequireDefault(_ClientHttpRequest);

var _immutable = __webpack_require__(1);

var _immutable2 = _interopRequireDefault(_immutable);

var _Modal = __webpack_require__(4);

var _Loading = __webpack_require__(3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var initialState = _immutable2.default.Map({}).set('request_reception_audit', new _immutable2.default.Map({}));

var ACTION_GET_SERVICE_RECEPTION_AUDIT = exports.ACTION_GET_SERVICE_RECEPTION_AUDIT = 'ACTION_GET_SERVICE_RECEPTION_AUDIT';

exports.default = function () {
	var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	var action = arguments[1];


	switch (action.type) {
		case ACTION_GET_SERVICE_RECEPTION_AUDIT:
			return state.set('request_reception_audit', new _immutable2.default.Map(action.Obj));
		default:
			return state;
	}
};

var getDataReceptionAudit = exports.getDataReceptionAudit = function getDataReceptionAudit(form) {

	return function (dispatch) {

		dispatch((0, _Loading.isLoading)(true));
		dispatch({ type: ACTION_GET_SERVICE_RECEPTION_AUDIT, Obj: {} });
		return new _ClientHttpRequest2.default({
			service: 'api/getDataReceptionAudit/',
			method: "POST",
			data: _extends({}, form),
			headers: Object.assign({ "Authorization": sessionStorage.access_token, "uid": sessionStorage.uid })
		}).request().then(function (response) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch({ type: ACTION_GET_SERVICE_RECEPTION_AUDIT, Obj: response.data });
		}).catch(function (error) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
			throw error;
		});
	};
};

/***/ }),

/***/ 490:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.clearConfPld = exports.clearPLDDocuments = exports.updateConfPld = exports.getConfPld = exports.deletePldDocument = exports.updatePldDocument = exports.getPldDonataria = exports.getPldDocument = exports.searchPldDocuments = exports.getDocumentById = exports.addPldDocument = exports.ACTION_GET_PLD_DOCUMENTBYID = exports.ACTION_GET_EXISTS_COMPROBANTE = exports.ACTION_SEARCH_PLD_DOCUMENTS = exports.ACTION_DELETE_PLD_DOCUMENT = exports.ACTION_UPDATE_PLD_DOCUMENT = exports.ACTION_GET_PLD_DOCUMENT = exports.ACTION_UPDATE_CONF_PLD = exports.ACTION_GET_CONF_PLD = exports.SAVE_FILE = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _Utils = __webpack_require__(2);

var Utils = _interopRequireWildcard(_Utils);

var _ClientHttpRequest = __webpack_require__(5);

var _ClientHttpRequest2 = _interopRequireDefault(_ClientHttpRequest);

var _immutable = __webpack_require__(1);

var _immutable2 = _interopRequireDefault(_immutable);

var _Modal = __webpack_require__(4);

var _Loading = __webpack_require__(3);

var _axios = __webpack_require__(132);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var initialState = _immutable2.default.Map({}).set('Search', new _immutable2.default.List([])).set('Response', new _immutable2.default.Map({})).set('Response', new _immutable2.default.Map({})).set('Get', new _immutable2.default.Map({})).set('GetDoc', new _immutable2.default.Map({})).set('GetExists', new _immutable2.default.Map({})).set('GetDocById', new _immutable2.default.Map({}));

/* Types */
var SAVE_FILE = exports.SAVE_FILE = "SAVE_FILE";
var ACTION_GET_CONF_PLD = exports.ACTION_GET_CONF_PLD = 'ACTION_GET_CONF_PLD';
var ACTION_UPDATE_CONF_PLD = exports.ACTION_UPDATE_CONF_PLD = 'ACTION_UPDATE_CONF_PLD';
var ACTION_GET_PLD_DOCUMENT = exports.ACTION_GET_PLD_DOCUMENT = 'ACTION_GET_PLD_DOCUMENT';
var ACTION_UPDATE_PLD_DOCUMENT = exports.ACTION_UPDATE_PLD_DOCUMENT = 'ACTION_UPDATE_PLD_DOCUMENT';
var ACTION_DELETE_PLD_DOCUMENT = exports.ACTION_DELETE_PLD_DOCUMENT = 'ACTION_DELETE_PLD_DOCUMENT';
var ACTION_SEARCH_PLD_DOCUMENTS = exports.ACTION_SEARCH_PLD_DOCUMENTS = 'ACTION_SEARCH_PLD_DOCUMENTS';
var ACTION_GET_EXISTS_COMPROBANTE = exports.ACTION_GET_EXISTS_COMPROBANTE = 'ACTION_GET_EXISTS_COMPROBANTE';
var ACTION_GET_PLD_DOCUMENTBYID = exports.ACTION_GET_PLD_DOCUMENTBYID = 'ACTION_GET_PLD_DOCUMENTBYID';

/* Reducer */

exports.default = function () {
	var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	var action = arguments[1];

	switch (action.type) {
		case ACTION_SEARCH_PLD_DOCUMENTS:
			return state.set('Search', new _immutable2.default.List(action.Obj));
		case ACTION_GET_CONF_PLD:
			return state.set('Get', new _immutable2.default.Map(action.Obj));
		case SAVE_FILE:
			return state.set("Response", new _immutable2.default.Map(action.Obj));
		case ACTION_UPDATE_CONF_PLD:
			return state.set('Response', new _immutable2.default.Map(action.Obj));
		case ACTION_GET_PLD_DOCUMENT:
			return state.set('GetDoc', new _immutable2.default.Map(action.Obj));
		case ACTION_UPDATE_PLD_DOCUMENT:
			return state.set('Response', new _immutable2.default.Map(action.Obj));
		case ACTION_DELETE_PLD_DOCUMENT:
			return state.set('Response', new _immutable2.default.Map(action.Obj));
		case ACTION_GET_EXISTS_COMPROBANTE:
			return state.set('GetExists', new _immutable2.default.Map(action.Obj));
		case ACTION_GET_PLD_DOCUMENTBYID:
			return state.set('GetDocById', new _immutable2.default.Map(action.Obj));
		default:
			return state;
	}
};

/* Action Creators */

var addPldDocument = exports.addPldDocument = function addPldDocument(form) {
	var headers = {
		"Content-Type": "multipart/form-data",
		Authorization: sessionStorage.access_token,
		uid: sessionStorage.uid
	};

	if (localStorage.type == 'Donataria') {
		headers.idDonataria = localStorage.idDonataria || '';
	}

	return function (dispatch) {
		dispatch((0, _Loading.isLoading)(true));

		return (0, _axios.post)("/api/addPldDocument", form, { headers: headers }).then(function (response) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch((0, _Modal.createModal)(Utils.successMessage()));
			return response.data;
		}).catch(function (error) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
			throw error;
		});
	};
};

var getDocumentById = exports.getDocumentById = function getDocumentById(id) {
	var headers = {
		Authorization: sessionStorage.access_token,
		uid: sessionStorage.uid,
		responseType: 'arraybuffer'
	};

	return function (dispatch) {

		dispatch((0, _Loading.isLoading)(true));

		return new _ClientHttpRequest2.default({
			service: 'api/getDocumentById',
			method: "POST",
			data: { id: id },
			headers: headers
		}).request().then(function (response) {
			dispatch((0, _Loading.isLoading)(false));
			response.data = Utils.conver_(response.data['documento']);
		}).catch(function (error) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
			throw error;
		});
	};
};

var searchPldDocuments = exports.searchPldDocuments = function searchPldDocuments(form) {

	return function (dispatch) {

		dispatch((0, _Loading.isLoading)(true));

		return new _ClientHttpRequest2.default({
			service: 'api/searchPldDocuments',
			method: "POST",
			data: _extends({}, form),
			headers: Object.assign({ "Authorization": sessionStorage.access_token, "uid": sessionStorage.uid })
		}).request().then(function (response) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch({ type: ACTION_SEARCH_PLD_DOCUMENTS, Obj: response.data });
		}).catch(function (error) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
			throw error;
		});
	};
};

var getPldDocument = exports.getPldDocument = function getPldDocument(id) {

	return function (dispatch) {

		dispatch((0, _Loading.isLoading)(true));

		return new _ClientHttpRequest2.default({
			service: 'api/getPldDocument',
			method: "POST",
			data: { id: id },
			headers: Object.assign({ "Authorization": sessionStorage.access_token, "uid": sessionStorage.uid })
		}).request().then(function (response) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch({ type: ACTION_GET_PLD_DOCUMENT, Obj: response.data });
		}).catch(function (error) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
			throw error;
		});
	};
};

var getPldDonataria = exports.getPldDonataria = function getPldDonataria(idDonataria) {

	return function (dispatch) {

		dispatch((0, _Loading.isLoading)(true));

		return new _ClientHttpRequest2.default({
			service: 'api/pldDonataria',
			method: "POST",
			data: _extends({}, idDonataria),
			headers: Object.assign({ "Authorization": sessionStorage.access_token, "uid": sessionStorage.uid })
		}).request().then(function (response) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch({ type: ACTION_GET_EXISTS_COMPROBANTE, Obj: response.data });
		}).catch(function (error) {
			dispatch((0, _Loading.isLoading)(false));
			throw error;
		});
	};
};

var updatePldDocument = exports.updatePldDocument = function updatePldDocument(form) {
	var headers = {
		"Content-Type": "multipart/form-data",
		Authorization: sessionStorage.access_token,
		uid: sessionStorage.uid
	};

	if (localStorage.type == 'Donataria') {
		headers.idDonataria = localStorage.idDonataria || '';
	}

	return function (dispatch) {
		dispatch((0, _Loading.isLoading)(true));

		return (0, _axios.post)("/api/updatePldDocument", form, { headers: headers }).then(function (response) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch((0, _Modal.createModal)(Utils.successMessage()));
			return response.data;
		}).catch(function (error) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
			throw error;
		});
	};
};

var deletePldDocument = exports.deletePldDocument = function deletePldDocument(id) {

	return function (dispatch) {

		dispatch((0, _Loading.isLoading)(true));

		return new _ClientHttpRequest2.default({
			service: 'api/deletePldDocument',
			method: "POST",
			data: { id: id },
			headers: Object.assign({ "Authorization": sessionStorage.access_token, "uid": sessionStorage.uid })
		}).request().then(function (response) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch({ type: ACTION_DELETE_PLD_DOCUMENT, Obj: response.data });
			dispatch((0, _Modal.createModal)(Utils.successMessage()));
		}).catch(function (error) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
			throw error;
		});
	};
};

var getConfPld = exports.getConfPld = function getConfPld(id) {

	return function (dispatch) {

		dispatch((0, _Loading.isLoading)(true));

		return new _ClientHttpRequest2.default({
			service: 'api/getConfPld',
			method: "POST",
			data: { id: id },
			headers: Object.assign({ "Authorization": sessionStorage.access_token, "uid": sessionStorage.uid })
		}).request().then(function (response) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch({ type: ACTION_GET_CONF_PLD, Obj: response.data });
		}).catch(function (error) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
			throw error;
		});
	};
};

var updateConfPld = exports.updateConfPld = function updateConfPld(form) {

	return function (dispatch) {

		dispatch((0, _Loading.isLoading)(true));

		return new _ClientHttpRequest2.default({
			service: 'api/updateConfPld',
			method: "POST",
			data: _extends({}, form),
			headers: Object.assign({ "Authorization": sessionStorage.access_token, "uid": sessionStorage.uid })
		}).request().then(function (response) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch({ type: ACTION_UPDATE_CONF_PLD, Obj: response.data });
			dispatch((0, _Modal.createModal)(Utils.successMessage()));
		}).catch(function (error) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
			throw error;
		});
	};
};

var clearPLDDocuments = exports.clearPLDDocuments = function clearPLDDocuments() {
	return function (dispatch) {
		dispatch({ type: ACTION_GET_PLD_DOCUMENT, Obj: {} });
		dispatch({ type: ACTION_SEARCH_PLD_DOCUMENTS, Obj: [] });
	};
};

var clearConfPld = exports.clearConfPld = function clearConfPld() {
	return function (dispatch) {
		dispatch({ type: ACTION_GET_CONF_PLD, Obj: {
				activarPld: 0,
				montoMinimoActivacion: 0,
				diasActivacion: 0
			} });
	};
};

/***/ }),

/***/ 499:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.updateAdditionalInfo = exports.getCatalogInformacionAnual = exports.getAdditionalInfo = exports.CLEAR_TEMP_ADDITIONAL_INFO = exports.UPDATE_ADDITIONAL_INFO = exports.GET_ADDITIONAL_YEAR = exports.GET_ADDITIONAL_INFO = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _Utils = __webpack_require__(2);

var Utils = _interopRequireWildcard(_Utils);

var _ClientHttpRequest = __webpack_require__(5);

var _ClientHttpRequest2 = _interopRequireDefault(_ClientHttpRequest);

var _immutable = __webpack_require__(1);

var _Modal = __webpack_require__(4);

var _Loading = __webpack_require__(3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var initialState = (0, _immutable.Map)({}).set('additionalInfo', new _immutable.Map({})).set('informationYear', new _immutable.Map({})).set('resetedData', new _immutable.Map({}));

/* Types */
var GET_ADDITIONAL_INFO = exports.GET_ADDITIONAL_INFO = 'GET_ADDITIONAL_INFO';
var GET_ADDITIONAL_YEAR = exports.GET_ADDITIONAL_YEAR = 'GET_ADDITIONAL_YEAR';

var UPDATE_ADDITIONAL_INFO = exports.UPDATE_ADDITIONAL_INFO = 'UPDATE_ADDITIONAL_INFO';
var CLEAR_TEMP_ADDITIONAL_INFO = exports.CLEAR_TEMP_ADDITIONAL_INFO = 'CLEAR_TEMP_ADDITIONAL_INFO';

/* Reducer */

exports.default = function () {
	var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	var action = arguments[1];


	switch (action.type) {
		case GET_ADDITIONAL_INFO:
			return state.set('additionalInfo', new _immutable.Map(action.Obj));
		case UPDATE_ADDITIONAL_INFO:
			return state.set('additionalInfo', new _immutable.Map(action.Obj));
		case GET_ADDITIONAL_YEAR:
			return state.set('informationYear', new _immutable.Map(action.Obj));
		case CLEAR_TEMP_ADDITIONAL_INFO:
			return state.set('resetedData', new _immutable.Map(action.Obj));
		default:
			return state;
	}
};

/* Action Creators */

var getAdditionalInfo = exports.getAdditionalInfo = function getAdditionalInfo(form) {

	return function (dispatch) {

		dispatch((0, _Loading.isLoading)(true));

		return new _ClientHttpRequest2.default({
			service: 'api/getGeneralInformation',
			method: "POST",
			data: _extends({}, form),
			headers: Object.assign({ "Authorization": sessionStorage.access_token, "uid": sessionStorage.uid })
		}).request().then(function (response) {
			dispatch((0, _Loading.isLoading)(false));

			var data = response.data;
			data.uniqueId = Utils.getUUID();
			response.data = _extends({}, response.data, {
				enfoqueCartera: response.data.enfoqueCartera || {
					esEliminado: false,
					idEnfoque: null,
					idDetalle: form.idDonataria,
					cuentaConEnfoqueSistemico: "",
					proyectoEnfoqueSistemico: "",
					principalesProgramas: ""
				},
				carteras: response.data.carteras || { cartera: [] },
				proveedores: response.data.proveedores || { proveedor: [] },
				donantes: response.data.donantes || { donante: [] },
				alianzas: response.data.alianzas || { alianza: [] },
				evaluacionMonitoreo: response.data.evaluacionMonitoreo || {
					esEliminado: false,
					idEvaluacionMonitoreo: null,
					idDetalle: form.idDonataria,
					cuentaConInstrumentos: "",
					nombreInstrumentos: "",
					tipoInformacionSolicitada: "",
					periodicidadInformacion: "",
					titularesResponsabilidades: "",
					utilizaHerramientasTecnologicas: "",
					nombreHerramientasTecnologicas: "",
					usoDatosAnalizados: "",
					programasSometidosAEvaluacion: "",
					tiposEvaluacionEnOrganizacion: ""
				},
				resultado: response.data.resultado || {
					esEliminado: false,
					idResultado: null,
					idDetalle: form.idDonataria,
					resultadoPrograma: "",
					participacionTitularesDerecho: "",
					participacionTitularesResponsabilidad: "",
					participacionTitularesObligacion: "",
					informacionAdicional: "",
					impactoDemostrado: ""
				}
			});

			dispatch({ type: GET_ADDITIONAL_INFO, Obj: response.data });
		}).catch(function (error) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
			throw error;
		});
	};
};
var getCatalogInformacionAnual = exports.getCatalogInformacionAnual = function getCatalogInformacionAnual(form) {

	return function (dispatch) {

		dispatch((0, _Loading.isLoading)(true));

		return new _ClientHttpRequest2.default({
			service: 'api/getCatalogInformacionAnual',
			method: "POST",
			data: _extends({}, form),
			headers: Object.assign({ "Authorization": sessionStorage.access_token, "uid": sessionStorage.uid })
		}).request().then(function (response) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch({ type: GET_ADDITIONAL_YEAR, Obj: response.data.data[0] });
		}).catch(function (error) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
			throw error;
		});
	};
};
var updateAdditionalInfo = exports.updateAdditionalInfo = function updateAdditionalInfo(form) {

	return function (dispatch) {

		dispatch((0, _Loading.isLoading)(true));

		return new _ClientHttpRequest2.default({
			service: 'api/updateGeneralInformation',
			method: "POST",
			data: _extends({}, form),
			headers: Object.assign({ "Authorization": sessionStorage.access_token, "uid": sessionStorage.uid })
		}).request().then(function (response) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch({ type: UPDATE_ADDITIONAL_INFO, Obj: response.data });
		}).catch(function (error) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
			throw error;
		});
	};
};

/***/ }),

/***/ 5:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.default = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _Utils = __webpack_require__(2);

var Utils = _interopRequireWildcard(_Utils);

var _axios = __webpack_require__(132);

var _axios2 = _interopRequireDefault(_axios);

var _Labels = __webpack_require__(211);

var _Labels2 = _interopRequireDefault(_Labels);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ClientHttpRequest = function () {
	function ClientHttpRequest(config) {
		_classCallCheck(this, ClientHttpRequest);

		this.config = config;

		this.instanceAxios = _axios2.default.create({
			baseURL: "https://donatarias.montepiedad.com.mx",
			timeout: 9000000,
			url: config.service,
			responseType: config.responseType ? config.responseType : 'json',
			headers: {
				"Content-Type": 'application/json'
			}
		});
	}

	_createClass(ClientHttpRequest, [{
		key: 'request',
		value: function request() {
			var _this2 = this;

			var TIEMPO_SESION_ALERTA = Number("12000");

			var TIEMPO_SESION_INACTIVIDAD = Number("22200000");

			var CODE_REFRESH = ["NMP-902", "NMP-901"];

			var CODE_REFRESH_BPM = ["NMP-902", "NMP-901"];

			var CODE_SESSION_OUT = "NMP-902";

			var _this = this;

			return new Promise(function (resolve, reject) {
				if (_this.config.headers) {
					_this.config.headers = _extends({}, _this.config.headers, {
						Authorization: sessionStorage.access_token,
						uid: sessionStorage.uid
					});

					if (localStorage.type == 'Donataria') {
						_this.config.headers = _extends({}, _this.config.headers, {
							idDonataria: localStorage.idDonataria || ''
						});
					}
				}

				_this.instanceAxios.request(_this.config).then(function (response) {
					sessionStorage.session_time = Number(new Date()) - TIEMPO_SESION_ALERTA + TIEMPO_SESION_INACTIVIDAD;
					resolve(response);
				}).catch(function (error) {

					var __this = _this2;

					if (error.response) {

						if (error.response.data && Utils.indexOfItem(CODE_REFRESH, error.response.data.codigoError) != -1) {
							// Refresh and Recall Service

							__this.refreshToken = {
								baseURL: "https://donatarias.montepiedad.com.mx",
								url: 'auth/oauth/refresh',
								method: "POST",
								data: {
									"idUser": sessionStorage.uid,
									"refreshToken": sessionStorage.refresh_token,
									"bpmToken": sessionStorage.bpm_token
								}
							};

							__this.refreshTokenAxios = _axios2.default.create({
								baseURL: "https://donatarias.montepiedad.com.mx",
								timeout: 45000,
								url: __this.refreshToken.endpoint,
								responseType: "json",
								headers: {
									"Content-Type": "application/json"
								}
							});

							__this.refreshTokenAxios.request(__this.refreshToken) // Refresh token
							.then(function (response) {

								sessionStorage.access_token = response.data.access_token;
								sessionStorage.refresh_token = response.data.refresh_token;
								sessionStorage.bpm_token = response.data.bpm_token;

								_this.config.headers.Authorization = response.data.access_token;

								_this.instanceAxios.request(_this.config) // Recall Service New Token
								.then(function (response) {
									resolve(response);
								}).catch(function (error) {
									reject(error);
								});
							}).catch(function () {
								sessionStorage.clear();
								window.location.href = '/' + "Donativos" + '/login';
							});
						} else if (error.response.data && Utils.indexOfItem(CODE_REFRESH_BPM, error.response.data.codigoError) != -1) {
							// Refresh and Recall Service

							__this.refreshToken = {
								baseURL: "https://donatarias.montepiedad.com.mx",
								url: 'auth/oauth/refresh',
								method: "POST",
								data: {
									"idUser": sessionStorage.uid,
									"refreshToken": sessionStorage.refresh_token,
									"bpmToken": sessionStorage.bpm_token
								}
							};

							__this.refreshTokenAxios = _axios2.default.create({
								baseURL: "https://donatarias.montepiedad.com.mx",
								timeout: 45000,
								url: __this.refreshToken.endpoint,
								responseType: "json",
								headers: {
									"Content-Type": "application/json"
								}
							});

							__this.refreshTokenAxios.request(__this.refreshToken) // Refresh token
							.then(function (response) {

								sessionStorage.access_token = response.data.access_token;
								sessionStorage.refresh_token = response.data.refresh_token;
								sessionStorage.bpm_token = response.data.bpm_token;

								_this.config.headers.Authorization = response.data.bpm_token;

								_this.instanceAxios.request(_this.config) // Recall Service New Token
								.then(function (response) {
									resolve(response);
								}).catch(function (error) {
									reject(error);
								});
							}).catch(function () {
								sessionStorage.clear();
								window.location.href = '/' + "Donativos" + '/login';
							});
						} else if (error.response.data && error.response.data.codigoError === CODE_SESSION_OUT) {
							// Session Out Service

							reject(error);
						} else if (error.response.data) {
							// Error Service

							//if(error.response.status == 400){
							//	reject({response: {data: {message: Labels.existsMessage}}})
							//} else {
							reject({ response: { data: error.response.data } });
							//}

							//reject(error)
						} else if (error.response.data == undefined) {
							// Error Service

							reject({ response: { data: { message: _Labels2.default.errorMessage } } });
						}
					} else {
						// Error Connect

						reject({ response: { data: { message: "Error de conexión, intente de nuevo" } } });
					}
				});
			});
		}
	}]);

	return ClientHttpRequest;
}();

exports.default = ClientHttpRequest;

/***/ }),

/***/ 500:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.beginProcess = exports.getSummary = exports.GET_SUMMARY = undefined;

var _Utils = __webpack_require__(2);

var Utils = _interopRequireWildcard(_Utils);

var _Loading = __webpack_require__(3);

var _Modal = __webpack_require__(4);

var _ClientHttpRequest = __webpack_require__(5);

var _ClientHttpRequest2 = _interopRequireDefault(_ClientHttpRequest);

var _immutable = __webpack_require__(1);

var _immutable2 = _interopRequireDefault(_immutable);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var initialState = _immutable2.default.Map({});

/* Types */
var GET_SUMMARY = exports.GET_SUMMARY = 'GET_SUMMARY';

/* Reducer */

exports.default = function () {
	var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	var action = arguments[1];


	switch (action.type) {
		case GET_SUMMARY:
			return new _immutable2.default.Map(action.Obj);
		default:
			return state;
	}
};

/* Action Creators */

var getSummary = exports.getSummary = function getSummary(form) {

	return function (dispatch) {

		dispatch((0, _Loading.isLoading)(true));

		return new _ClientHttpRequest2.default({
			service: 'api/getApplicationSummary',
			method: "POST",
			data: form,
			headers: Object.assign({ "Authorization": sessionStorage.access_token, "uid": sessionStorage.uid })
		}).request().then(function (response) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch({ type: GET_SUMMARY, Obj: response.data });
		}).catch(function (error) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
			throw error;
		});
	};
};

var beginProcess = exports.beginProcess = function beginProcess(form) {

	return function (dispatch) {

		dispatch((0, _Loading.isLoading)(true));

		return new _ClientHttpRequest2.default({
			service: 'api/beginApplicationProcess',
			method: "POST",
			data: form,
			headers: Object.assign({ "Authorization": sessionStorage.access_token, "Bpm": sessionStorage.bpm_token, "uid": sessionStorage.uid })
		}).request().then(function (response) {
			dispatch((0, _Loading.isLoading)(false));
			return response.data;
		}).catch(function (error) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
			throw error;
		});
	};
};

/***/ }),

/***/ 501:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.searchAverageOfExpenses = exports.getAverageOfExpenses = exports.newAverageOfExpenses = exports.ACTION_UPDATE_AVERAGE = exports.ACTION_SEARCH_AVERAGE = exports.ACTION_GET_AVERAGE = exports.ACTION_NEW_AVERAGE = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _Utils = __webpack_require__(2);

var Utils = _interopRequireWildcard(_Utils);

var _ClientHttpRequest = __webpack_require__(5);

var _ClientHttpRequest2 = _interopRequireDefault(_ClientHttpRequest);

var _immutable = __webpack_require__(1);

var _immutable2 = _interopRequireDefault(_immutable);

var _Modal = __webpack_require__(4);

var _Loading = __webpack_require__(3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var initialState = _immutable2.default.Map({}).set('Response', new _immutable2.default.Map({})).set('Get', new _immutable2.default.Map({})).set('Search', new _immutable2.default.List([]));

/* Types */

var ACTION_NEW_AVERAGE = exports.ACTION_NEW_AVERAGE = 'ACTION_NEW_AVERAGE';

var ACTION_GET_AVERAGE = exports.ACTION_GET_AVERAGE = 'ACTION_GET_AVERAGE';

var ACTION_SEARCH_AVERAGE = exports.ACTION_SEARCH_AVERAGE = 'ACTION_SEARCH_AVERAGE';

var ACTION_UPDATE_AVERAGE = exports.ACTION_UPDATE_AVERAGE = 'ACTION_UPDATE_AVERAGE';

/* Reducer */

exports.default = function () {
	var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	var action = arguments[1];


	switch (action.type) {
		case ACTION_NEW_AVERAGE:
			return state.set('Response', new _immutable2.default.Map(action.Obj));
		case ACTION_GET_AVERAGE:
			return state.set('Get', new _immutable2.default.Map(action.Obj));
		case ACTION_SEARCH_AVERAGE:
			return state.set('Search', new _immutable2.default.List(action.Obj));
		case ACTION_UPDATE_AVERAGE:
			return state.set('Response', new _immutable2.default.Map(action.Obj));
		default:
			return state;
	}
};

/* Action Creators */

var newAverageOfExpenses = exports.newAverageOfExpenses = function newAverageOfExpenses(form) {

	var temp = {
		configuracionId: !form.configuracionId ? 0 : form.configuracionId,
		descripcion: form.descripcion,
		deleted: form.state === 1 ? false : true,
		limiteExcepcion: form.limite || false,
		monto: form.monto ? parseInt(form.monto) : 0,
		usuario: sessionStorage.uid,
		"variables": [{
			"codigoVariable": "ANIOS_EGRESOS",
			"variableValor": Number(form.anios)
		}, {
			"codigoVariable": "VARIABLE_M",
			"variableValor": form.m
		}, {
			"codigoVariable": "VARIABLE_A",
			"variableValor": form.a
		}, {
			"codigoVariable": "VARIABLE_B",
			"variableValor": form.b
		}, {
			"codigoVariable": "MONTO_MAX",
			"variableValor": form.montoMaximo
		}, {
			"codigoVariable": "MONTO_MIN",
			"variableValor": form.montoMinimo
		}]
	};

	return function (dispatch) {

		dispatch((0, _Loading.isLoading)(true));

		return new _ClientHttpRequest2.default({
			service: !form.configuracionId ? 'api/newAverageOfExpenses' : 'api/updateAverageOfExpenses',
			method: "POST",
			data: temp,
			headers: Object.assign({ "Authorization": sessionStorage.access_token, "uid": sessionStorage.uid })
		}).request().then(function (response) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch({ type: ACTION_NEW_AVERAGE, Obj: response.data });
			dispatch((0, _Modal.createModal)(Utils.successMessage()));
		}).catch(function (error) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
			throw error;
		});
	};
};

var getAverageOfExpenses = exports.getAverageOfExpenses = function getAverageOfExpenses(id) {

	return function (dispatch) {

		dispatch((0, _Loading.isLoading)(true));

		return new _ClientHttpRequest2.default({
			service: 'api/getAverageOfExpenses',
			method: "POST",
			data: { id: id },
			headers: Object.assign({ "Authorization": sessionStorage.access_token, "uid": sessionStorage.uid })
		}).request().then(function (response) {
			dispatch((0, _Loading.isLoading)(false));
			var data = response.data.configuracionFuncion;
			var variables = response.data.variables;

			var temp = {
				uniqueId: Utils.getUUID(),
				configuracionId: data.configuracionFuncionPK.configuracionId,
				descripcion: data.descripcion,
				state: !data.deleted ? 1 : 2,
				limite: data.limiteExcepcion,
				monto: data.monto || '',
				anios: variables[0].variableValor || '',
				m: variables[1].variableValor || '',
				a: variables[2].variableValor || '',
				b: variables[3].variableValor || '',
				montoMaximo: variables[4].variableValor || '',
				montoMinimo: variables[5].variableValor || ''
			};

			dispatch({ type: ACTION_GET_AVERAGE, Obj: temp });
		}).catch(function (error) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
			throw error;
		});
	};
};

var searchAverageOfExpenses = exports.searchAverageOfExpenses = function searchAverageOfExpenses(form) {

	return function (dispatch) {

		dispatch((0, _Loading.isLoading)(true));

		return new _ClientHttpRequest2.default({
			service: Object.keys(form).length == 0 ? 'api/searchAverageOfExpenses' : 'api/searchParamAverageOfExpenses',
			method: "POST",
			data: _extends({}, form),
			headers: Object.assign({ "Authorization": sessionStorage.access_token, "uid": sessionStorage.uid })
		}).request().then(function (response) {
			dispatch((0, _Loading.isLoading)(false));

			var data = response.data.map(function (d) {
				return _extends({}, d, {
					id: d.configuracionFuncionPK.configuracionId
				});
			});
			data.uniqueId = Utils.getUUID();

			dispatch({ type: ACTION_SEARCH_AVERAGE, Obj: data });
		}).catch(function (error) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
			throw error;
		});
	};
};

/***/ }),

/***/ 502:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.searchEvaluacionVarAverageExpAndSeveralEval = exports.searchAverageExpAndSeveralEval = exports.getAverageExpAndSeveralEval = exports.newAverageExpAndSeveralEval = exports.ACTION_UPDATE_AVERAGE_EXP_SEVERAL = exports.ACTION_SEARCH_EVAL_VAR_AVERAGE_EXP_SEVERAL = exports.ACTION_SEARCH_AVERAGE_EXP_SEVERAL = exports.ACTION_GET_AVERAGE_EXP_SEVERAL = exports.ACTION_NEW_AVERAGE_EXP_SEVERAL = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _Utils = __webpack_require__(2);

var Utils = _interopRequireWildcard(_Utils);

var _ClientHttpRequest = __webpack_require__(5);

var _ClientHttpRequest2 = _interopRequireDefault(_ClientHttpRequest);

var _immutable = __webpack_require__(1);

var _immutable2 = _interopRequireDefault(_immutable);

var _Modal = __webpack_require__(4);

var _Loading = __webpack_require__(3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var initialState = _immutable2.default.Map({}).set('Response', new _immutable2.default.Map({})).set('Get', new _immutable2.default.Map({})).set('Search', new _immutable2.default.List([])).set('SearchEval', new _immutable2.default.List([]));

/* Types */

var ACTION_NEW_AVERAGE_EXP_SEVERAL = exports.ACTION_NEW_AVERAGE_EXP_SEVERAL = 'ACTION_NEW_AVERAGE_EXP_SEVERAL';
var ACTION_GET_AVERAGE_EXP_SEVERAL = exports.ACTION_GET_AVERAGE_EXP_SEVERAL = 'ACTION_GET_AVERAGE_EXP_SEVERAL';
var ACTION_SEARCH_AVERAGE_EXP_SEVERAL = exports.ACTION_SEARCH_AVERAGE_EXP_SEVERAL = 'ACTION_SEARCH_AVERAGE_EXP_SEVERAL';
var ACTION_SEARCH_EVAL_VAR_AVERAGE_EXP_SEVERAL = exports.ACTION_SEARCH_EVAL_VAR_AVERAGE_EXP_SEVERAL = 'ACTION_SEARCH_EVAL_VAR_AVERAGE_EXP_SEVERAL';
var ACTION_UPDATE_AVERAGE_EXP_SEVERAL = exports.ACTION_UPDATE_AVERAGE_EXP_SEVERAL = 'ACTION_UPDATE_AVERAGE_EXP_SEVERAL';

/* Reducer */

exports.default = function () {
	var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	var action = arguments[1];


	switch (action.type) {
		case ACTION_NEW_AVERAGE_EXP_SEVERAL:
			return state.set('Response', new _immutable2.default.Map(action.Obj));
		case ACTION_GET_AVERAGE_EXP_SEVERAL:
			return state.set('Get', new _immutable2.default.Map(action.Obj));
		case ACTION_SEARCH_AVERAGE_EXP_SEVERAL:
			return state.set('Search', new _immutable2.default.List(action.Obj));
		case ACTION_SEARCH_EVAL_VAR_AVERAGE_EXP_SEVERAL:
			return state.set('SearchEval', new _immutable2.default.List(action.Obj));
		case ACTION_UPDATE_AVERAGE_EXP_SEVERAL:
			return state.set('Response', new _immutable2.default.Map(action.Obj));
		default:
			return state;
	}
};

/* Action Creators */

var newAverageExpAndSeveralEval = exports.newAverageExpAndSeveralEval = function newAverageExpAndSeveralEval(form) {
	var temp = {
		configuracionId: !form.configuracionId ? 0 : form.configuracionId,
		descripcion: form.descripcion,
		deleted: form.state === 1 ? false : true,
		limiteExcepcion: form.limite || false,
		monto: form.monto ? parseInt(form.monto) : 0,
		usuario: sessionStorage.uid,

		evaluacionesRango: form.formWithVariableSelected,
		"variables": [{
			"codigoVariable": "ANIOS_EGRESOS",
			"variableValor": Number(form.anios)
		}, {
			"codigoVariable": "VARIABLE_M",
			"variableValor": form.m
		}, {
			"codigoVariable": "VARIABLE_A",
			"variableValor": form.a
		}, {
			"codigoVariable": "VARIABLE_B",
			"variableValor": form.b
		}, {
			"codigoVariable": "MONTO_MAX",
			"variableValor": form.montoMaximo
		}, {
			"codigoVariable": "MONTO_MIN",
			"variableValor": form.montoMinimo
		}, {
			"codigoVariable": "PONDERACION_EGRESOS",
			"variableValor": form.ponderacionEgresos
		}]
	};

	return function (dispatch) {

		dispatch((0, _Loading.isLoading)(true));

		return new _ClientHttpRequest2.default({
			service: !form.configuracionId ? 'api/newAverageExpAndSeveralEval' : 'api/updateAverageExpAndSeveralEval',
			method: "POST",
			data: temp,
			headers: Object.assign({ "Authorization": sessionStorage.access_token, "uid": sessionStorage.uid })
		}).request().then(function (response) {

			dispatch((0, _Loading.isLoading)(false));
			dispatch({ type: ACTION_NEW_AVERAGE_EXP_SEVERAL, Obj: response.data });
			dispatch((0, _Modal.createModal)(Utils.successMessage()));

			return response.data;
		}).catch(function (error) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
			throw error;
		});
	};
};

var getAverageExpAndSeveralEval = exports.getAverageExpAndSeveralEval = function getAverageExpAndSeveralEval(id) {

	return function (dispatch) {

		dispatch((0, _Loading.isLoading)(true));

		return new _ClientHttpRequest2.default({
			service: 'api/getAverageExpAndSeveralEval',
			method: "POST",
			data: { id: id },
			headers: Object.assign({ "Authorization": sessionStorage.access_token, "uid": sessionStorage.uid })
		}).request().then(function (response) {
			dispatch((0, _Loading.isLoading)(false));

			var data = response.data.configuracionFuncion;
			var variables = response.data.variables;
			var evaluacionesRango = response.data.evaluacionesRango;

			var temp = {
				uniqueId: Utils.getUUID(),
				configuracionId: data.configuracionFuncionPK.configuracionId,
				descripcion: data.descripcion,
				state: !data.deleted ? 1 : 2,
				limite: data.limiteExcepcion,
				monto: data.monto || '',
				anios: Utils.getItem(variables, { codigoVariable: "ANIOS_EGRESOS" }).variableValor,
				m: Utils.getItem(variables, { codigoVariable: "VARIABLE_M" }).variableValor,
				a: Utils.getItem(variables, { codigoVariable: "VARIABLE_A" }).variableValor,
				b: Utils.getItem(variables, { codigoVariable: "VARIABLE_B" }).variableValor,
				montoMaximo: Utils.getItem(variables, { codigoVariable: "MONTO_MAX" }).variableValor,
				montoMinimo: Utils.getItem(variables, { codigoVariable: "MONTO_MIN" }).variableValor,
				ponderacionEgresos: Utils.getItem(variables, { codigoVariable: "PONDERACION_EGRESOS" }).variableValor,

				evaluacionesRangoUpdate: evaluacionesRango
			};

			dispatch({ type: ACTION_GET_AVERAGE_EXP_SEVERAL, Obj: temp });
		}).catch(function (error) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
			throw error;
		});
	};
};

var searchAverageExpAndSeveralEval = exports.searchAverageExpAndSeveralEval = function searchAverageExpAndSeveralEval(form) {

	return function (dispatch) {

		dispatch((0, _Loading.isLoading)(true));

		return new _ClientHttpRequest2.default({
			service: Object.keys(form).length == 0 ? 'api/searchAverageExpAndSeveralEval' : 'api/searchParamAverageExpAndSeveralEval',
			method: "POST",
			data: _extends({}, form),
			headers: Object.assign({ "Authorization": sessionStorage.access_token, "uid": sessionStorage.uid })
		}).request().then(function (response) {
			dispatch((0, _Loading.isLoading)(false));

			var data = response.data.map(function (d) {
				return _extends({}, d, {
					id: d.configuracionFuncionPK.configuracionId
				});
			});
			data.uniqueId = Utils.getUUID();

			dispatch({ type: ACTION_SEARCH_AVERAGE_EXP_SEVERAL, Obj: data });
		}).catch(function (error) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
			throw error;
		});
	};
};

var searchEvaluacionVarAverageExpAndSeveralEval = exports.searchEvaluacionVarAverageExpAndSeveralEval = function searchEvaluacionVarAverageExpAndSeveralEval() {

	return function (dispatch) {

		dispatch((0, _Loading.isLoading)(true));

		return new _ClientHttpRequest2.default({
			service: 'api/searchEvaluacionVarAverageExpAndSeveralEval',
			method: "POST",
			data: {},
			headers: Object.assign({ "Authorization": sessionStorage.access_token, "uid": sessionStorage.uid })
		}).request().then(function (response) {
			dispatch((0, _Loading.isLoading)(false));

			dispatch({ type: ACTION_SEARCH_EVAL_VAR_AVERAGE_EXP_SEVERAL, Obj: response.data });
			return response.data;
		}).catch(function (error) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
			throw error;
		});
	};
};

/***/ }),

/***/ 503:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.searchEvaluacionVarDecOrIncDonationAssigned = exports.searchDecOrIncDonationAssigned = exports.getDecOrIncDonationAssigned = exports.newDecOrIncDonationAssigned = exports.ACTION_UPDATE_DEC_OR_INC_DONATION = exports.ACTION_SEARCH_EVAL_VAR_DEC_OR_INC_DONATION = exports.ACTION_SEARCH_DEC_OR_INC_DONATION = exports.ACTION_GET_DEC_OR_INC_DONATION = exports.ACTION_NEW_DEC_OR_INC_DONATION = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _Utils = __webpack_require__(2);

var Utils = _interopRequireWildcard(_Utils);

var _ClientHttpRequest = __webpack_require__(5);

var _ClientHttpRequest2 = _interopRequireDefault(_ClientHttpRequest);

var _immutable = __webpack_require__(1);

var _immutable2 = _interopRequireDefault(_immutable);

var _Modal = __webpack_require__(4);

var _Loading = __webpack_require__(3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var initialState = _immutable2.default.Map({}).set('Response', new _immutable2.default.Map({})).set('Get', new _immutable2.default.Map({})).set('Search', new _immutable2.default.List([])).set('SearchEval', new _immutable2.default.List([]));

/* Types */

var ACTION_NEW_DEC_OR_INC_DONATION = exports.ACTION_NEW_DEC_OR_INC_DONATION = 'ACTION_NEW_DEC_OR_INC_DONATION';

var ACTION_GET_DEC_OR_INC_DONATION = exports.ACTION_GET_DEC_OR_INC_DONATION = 'ACTION_GET_DEC_OR_INC_DONATION';

var ACTION_SEARCH_DEC_OR_INC_DONATION = exports.ACTION_SEARCH_DEC_OR_INC_DONATION = 'ACTION_SEARCH_DEC_OR_INC_DONATION';

var ACTION_SEARCH_EVAL_VAR_DEC_OR_INC_DONATION = exports.ACTION_SEARCH_EVAL_VAR_DEC_OR_INC_DONATION = 'ACTION_SEARCH_EVAL_VAR_DEC_OR_INC_DONATION';

var ACTION_UPDATE_DEC_OR_INC_DONATION = exports.ACTION_UPDATE_DEC_OR_INC_DONATION = 'ACTION_UPDATE_DEC_OR_INC_DONATION';

/* Reducer */

exports.default = function () {
	var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	var action = arguments[1];


	switch (action.type) {
		case ACTION_NEW_DEC_OR_INC_DONATION:
			return state.set('Response', new _immutable2.default.Map(action.Obj));
		case ACTION_GET_DEC_OR_INC_DONATION:
			return state.set('Get', new _immutable2.default.Map(action.Obj));
		case ACTION_SEARCH_DEC_OR_INC_DONATION:
			return state.set('Search', new _immutable2.default.List(action.Obj));
		case ACTION_SEARCH_EVAL_VAR_DEC_OR_INC_DONATION:
			return state.set('SearchEval', new _immutable2.default.List(action.Obj));
		case ACTION_UPDATE_DEC_OR_INC_DONATION:
			return state.set('Response', new _immutable2.default.Map(action.Obj));
		default:
			return state;
	}
};

/* Action Creators */

var newDecOrIncDonationAssigned = exports.newDecOrIncDonationAssigned = function newDecOrIncDonationAssigned(form) {

	var temp = {
		configuracionId: !form.configuracionId ? 0 : form.configuracionId,
		descripcion: form.descripcion,
		deleted: form.state === 1 ? false : true,
		limiteExcepcion: form.limite || false,
		monto: form.monto ? parseInt(form.monto) : 0,
		usuario: sessionStorage.uid,

		evaluacionesRango: form.formWithVariableSelected
	};

	return function (dispatch) {

		dispatch((0, _Loading.isLoading)(true));

		return new _ClientHttpRequest2.default({
			service: !form.configuracionId ? 'api/newDecOrIncDonationAssigned' : 'api/updateDecOrIncDonationAssigned',
			method: "POST",
			data: temp,
			headers: Object.assign({ "Authorization": sessionStorage.access_token, "uid": sessionStorage.uid })
		}).request().then(function (response) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch({ type: ACTION_NEW_DEC_OR_INC_DONATION, Obj: response.data });
			dispatch((0, _Modal.createModal)(Utils.successMessage()));
		}).catch(function (error) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
			throw error;
		});
	};
};

var getDecOrIncDonationAssigned = exports.getDecOrIncDonationAssigned = function getDecOrIncDonationAssigned(id) {

	return function (dispatch) {

		dispatch((0, _Loading.isLoading)(true));

		return new _ClientHttpRequest2.default({
			service: 'api/getDecOrIncDonationAssigned',
			method: "POST",
			data: { id: id },
			headers: Object.assign({ "Authorization": sessionStorage.access_token, "uid": sessionStorage.uid })
		}).request().then(function (response) {
			dispatch((0, _Loading.isLoading)(false));

			var data = response.data.configuracionFuncion;
			var evaluacionesRango = response.data.evaluacionesRango;

			var temp = {
				uniqueId: Utils.getUUID(),
				configuracionId: data.configuracionFuncionPK.configuracionId,
				descripcion: data.descripcion,
				state: !data.deleted ? 1 : 2,
				limite: data.limiteExcepcion,
				monto: data.monto || '',

				evaluacionesRangoUpdate: evaluacionesRango
			};

			dispatch({ type: ACTION_GET_DEC_OR_INC_DONATION, Obj: temp });
		}).catch(function (error) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
			throw error;
		});
	};
};

var searchDecOrIncDonationAssigned = exports.searchDecOrIncDonationAssigned = function searchDecOrIncDonationAssigned(form) {

	return function (dispatch) {

		dispatch((0, _Loading.isLoading)(true));

		return new _ClientHttpRequest2.default({
			service: Object.keys(form).length == 0 ? 'api/searchDecOrIncDonationAssigned' : 'api/searchParamDecOrIncDonationAssigned',
			method: "POST",
			data: _extends({}, form),
			headers: Object.assign({ "Authorization": sessionStorage.access_token, "uid": sessionStorage.uid })
		}).request().then(function (response) {
			dispatch((0, _Loading.isLoading)(false));

			var data = response.data.map(function (d) {
				return _extends({}, d, {
					id: d.configuracionFuncionPK.configuracionId
				});
			});

			data.uniqueId = Utils.getUUID();

			dispatch({ type: ACTION_SEARCH_DEC_OR_INC_DONATION, Obj: data });
		}).catch(function (error) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
			throw error;
		});
	};
};

var searchEvaluacionVarDecOrIncDonationAssigned = exports.searchEvaluacionVarDecOrIncDonationAssigned = function searchEvaluacionVarDecOrIncDonationAssigned() {

	return function (dispatch) {

		dispatch((0, _Loading.isLoading)(true));

		return new _ClientHttpRequest2.default({
			service: 'api/searchEvaluacionVarDecOrIncDonationAssigned',
			method: "POST",
			data: {},
			headers: Object.assign({ "Authorization": sessionStorage.access_token, "uid": sessionStorage.uid })
		}).request().then(function (response) {
			dispatch((0, _Loading.isLoading)(false));

			dispatch({ type: ACTION_SEARCH_EVAL_VAR_DEC_OR_INC_DONATION, Obj: response.data });
			return response.data;
		}).catch(function (error) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
			throw error;
		});
	};
};

/***/ }),

/***/ 504:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.searchEvaluacionVarVariationEvaluationClosed = exports.searchVariationEvaluationClosed = exports.getVariationEvaluationClosed = exports.newVariationEvaluationClosed = exports.ACTION_UPDATE_EVALUATION_CLOSED = exports.ACTION_SEARCH_EVAL_VAR_EVALUATION_CLOSED = exports.ACTION_SEARCH_EVALUATION_CLOSED = exports.ACTION_GET_EVALUATION_CLOSED = exports.ACTION_NEW_EVALUATION_CLOSED = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _Utils = __webpack_require__(2);

var Utils = _interopRequireWildcard(_Utils);

var _ClientHttpRequest = __webpack_require__(5);

var _ClientHttpRequest2 = _interopRequireDefault(_ClientHttpRequest);

var _immutable = __webpack_require__(1);

var _immutable2 = _interopRequireDefault(_immutable);

var _Modal = __webpack_require__(4);

var _Loading = __webpack_require__(3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var initialState = _immutable2.default.Map({}).set('Response', new _immutable2.default.Map({})).set('Get', new _immutable2.default.Map({})).set('Search', new _immutable2.default.List([])).set('SearchEval', new _immutable2.default.List([]));

/* Types */

var ACTION_NEW_EVALUATION_CLOSED = exports.ACTION_NEW_EVALUATION_CLOSED = 'ACTION_NEW_EVALUATION_CLOSED';

var ACTION_GET_EVALUATION_CLOSED = exports.ACTION_GET_EVALUATION_CLOSED = 'ACTION_GET_EVALUATION_CLOSED';

var ACTION_SEARCH_EVALUATION_CLOSED = exports.ACTION_SEARCH_EVALUATION_CLOSED = 'ACTION_SEARCH_EVALUATION_CLOSED';

var ACTION_SEARCH_EVAL_VAR_EVALUATION_CLOSED = exports.ACTION_SEARCH_EVAL_VAR_EVALUATION_CLOSED = 'ACTION_SEARCH_EVAL_VAR_EVALUATION_CLOSED';

var ACTION_UPDATE_EVALUATION_CLOSED = exports.ACTION_UPDATE_EVALUATION_CLOSED = 'ACTION_UPDATE_EVALUATION_CLOSED';

/* Reducer */

exports.default = function () {
	var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	var action = arguments[1];


	switch (action.type) {
		case ACTION_NEW_EVALUATION_CLOSED:
			return state.set('Response', new _immutable2.default.Map(action.Obj));
		case ACTION_GET_EVALUATION_CLOSED:
			return state.set('Get', new _immutable2.default.Map(action.Obj));
		case ACTION_SEARCH_EVALUATION_CLOSED:
			return state.set('Search', new _immutable2.default.List(action.Obj));
		case ACTION_SEARCH_EVAL_VAR_EVALUATION_CLOSED:
			return state.set('SearchEval', new _immutable2.default.List(action.Obj));
		case ACTION_UPDATE_EVALUATION_CLOSED:
			return state.set('Response', new _immutable2.default.Map(action.Obj));
		default:
			return state;
	}
};

/* Action Creators */

var newVariationEvaluationClosed = exports.newVariationEvaluationClosed = function newVariationEvaluationClosed(form) {
	var temp = {
		configuracionId: !form.configuracionId ? 0 : form.configuracionId,
		descripcion: form.descripcion,
		deleted: form.state === 1 ? false : true,
		limiteExcepcion: form.limiteExcepcion || false,
		monto: form.monto ? parseInt(form.monto) : 0,
		usuario: sessionStorage.uid,

		evaluacionesNivel: form.evaluacionesNivel,

		"variables": [{
			"codigoVariable": "EGRESO_ANIO_ANTERIOR",
			"variableValor": Number(form.egresoAnoAnterior)
		}, {
			"codigoVariable": "ANIOS_EGRESOS",
			"variableValor": Number(form.anios)
		}, {
			"codigoVariable": "PORCENTAJE_MAXIMO_APORTACION_INGRESOS",
			"variableValor": form.maximoAportacionIngreso
		}, {
			"codigoVariable": "MONTO_MAX",
			"variableValor": form.montoMaximo
		}, {
			"codigoVariable": "MONTO_MIN",
			"variableValor": form.montoMinimo
		}]
	};

	return function (dispatch) {

		dispatch((0, _Loading.isLoading)(true));

		return new _ClientHttpRequest2.default({
			service: !form.configuracionId ? 'api/newVariationEvaluationClosed' : 'api/updateVariationEvaluationClosed',
			method: "POST",
			data: temp,
			headers: Object.assign({ "Authorization": sessionStorage.access_token, "uid": sessionStorage.uid })
		}).request().then(function (response) {

			dispatch((0, _Loading.isLoading)(false));
			dispatch({ type: ACTION_NEW_EVALUATION_CLOSED, Obj: response.data });
			dispatch((0, _Modal.createModal)(Utils.successMessage()));

			return response.data;
		}).catch(function (error) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
			throw error;
		});
	};
};

var getVariationEvaluationClosed = exports.getVariationEvaluationClosed = function getVariationEvaluationClosed(id) {

	return function (dispatch) {

		dispatch((0, _Loading.isLoading)(true));

		return new _ClientHttpRequest2.default({
			service: 'api/getVariationEvaluationClosed',
			method: "POST",
			data: { id: id },
			headers: Object.assign({ "Authorization": sessionStorage.access_token, "uid": sessionStorage.uid })
		}).request().then(function (response) {
			dispatch((0, _Loading.isLoading)(false));

			var data = response.data.configuracionFuncion;
			var variables = response.data.variables;
			var evaluacionesNivel = response.data.evaluacionesNivel;

			var temp = {
				uniqueId: Utils.getUUID(),
				configuracionId: data.configuracionFuncionPK.configuracionId,
				descripcion: data.descripcion,
				state: !data.deleted ? 1 : 2,
				limiteExcepcion: data.limiteExcepcion,
				monto: data.monto || '',

				egresoAnoAnterior: Utils.getItem(variables, { codigoVariable: "EGRESO_ANIO_ANTERIOR" }).variableValor,
				anios: Utils.getItem(variables, { codigoVariable: "ANIOS_EGRESOS" }).variableValor,
				montoMaximo: Utils.getItem(variables, { codigoVariable: "MONTO_MAX" }).variableValor,
				montoMinimo: Utils.getItem(variables, { codigoVariable: "MONTO_MIN" }).variableValor,
				maximoAportacionIngreso: Utils.getItem(variables, { codigoVariable: "PORCENTAJE_MAXIMO_APORTACION_INGRESOS" }).variableValor,

				evaluacionesNivelUpdate: evaluacionesNivel
			};

			dispatch({ type: ACTION_GET_EVALUATION_CLOSED, Obj: temp });
		}).catch(function (error) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
			throw error;
		});
	};
};

var searchVariationEvaluationClosed = exports.searchVariationEvaluationClosed = function searchVariationEvaluationClosed(form) {

	return function (dispatch) {

		dispatch((0, _Loading.isLoading)(true));

		return new _ClientHttpRequest2.default({
			service: Object.keys(form).length == 0 ? 'api/searchVariationEvaluationClosed' : 'api/searchParamVariationEvaluationClosed',
			method: "POST",
			data: _extends({}, form),
			headers: Object.assign({ "Authorization": sessionStorage.access_token, "uid": sessionStorage.uid })
		}).request().then(function (response) {
			dispatch((0, _Loading.isLoading)(false));

			var data = response.data.map(function (d) {
				return _extends({}, d, {
					id: d.configuracionFuncionPK.configuracionId
				});
			});
			data.uniqueId = Utils.getUUID();

			dispatch({ type: ACTION_SEARCH_EVALUATION_CLOSED, Obj: data });
		}).catch(function (error) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
			throw error;
		});
	};
};

var searchEvaluacionVarVariationEvaluationClosed = exports.searchEvaluacionVarVariationEvaluationClosed = function searchEvaluacionVarVariationEvaluationClosed() {

	return function (dispatch) {

		dispatch((0, _Loading.isLoading)(true));

		return new _ClientHttpRequest2.default({
			service: 'api/searchEvaluacionVarVariationEvaluationClosed',
			method: "POST",
			data: {},
			headers: Object.assign({ "Authorization": sessionStorage.access_token, "uid": sessionStorage.uid })
		}).request().then(function (response) {
			dispatch((0, _Loading.isLoading)(false));

			dispatch({ type: ACTION_SEARCH_EVAL_VAR_EVALUATION_CLOSED, Obj: response.data });
			return response.data;
		}).catch(function (error) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
			throw error;
		});
	};
};

/***/ }),

/***/ 505:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.searchEvaluacionVarVariationEvaluationOpened = exports.searchVariationEvaluationOpened = exports.getVariationEvaluationOpened = exports.newVariationEvaluationOpened = exports.ACTION_UPDATE_EVALUATION_OPENED = exports.ACTION_SEARCH_EVAL_VAR_EVALUATION_OPENED = exports.ACTION_SEARCH_EVALUATION_OPENED = exports.ACTION_GET_EVALUATION_OPENED = exports.ACTION_NEW_EVALUATION_OPENED = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _Utils = __webpack_require__(2);

var Utils = _interopRequireWildcard(_Utils);

var _ClientHttpRequest = __webpack_require__(5);

var _ClientHttpRequest2 = _interopRequireDefault(_ClientHttpRequest);

var _immutable = __webpack_require__(1);

var _immutable2 = _interopRequireDefault(_immutable);

var _Modal = __webpack_require__(4);

var _Loading = __webpack_require__(3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var initialState = _immutable2.default.Map({}).set('Response', new _immutable2.default.Map({})).set('Get', new _immutable2.default.Map({})).set('Search', new _immutable2.default.List([])).set('SearchEval', new _immutable2.default.List([]));

/* Types */

var ACTION_NEW_EVALUATION_OPENED = exports.ACTION_NEW_EVALUATION_OPENED = 'ACTION_NEW_EVALUATION_OPENED';

var ACTION_GET_EVALUATION_OPENED = exports.ACTION_GET_EVALUATION_OPENED = 'ACTION_GET_EVALUATION_OPENED';

var ACTION_SEARCH_EVALUATION_OPENED = exports.ACTION_SEARCH_EVALUATION_OPENED = 'ACTION_SEARCH_EVALUATION_OPENED';

var ACTION_SEARCH_EVAL_VAR_EVALUATION_OPENED = exports.ACTION_SEARCH_EVAL_VAR_EVALUATION_OPENED = 'ACTION_SEARCH_EVAL_VAR_EVALUATION_OPENED';

var ACTION_UPDATE_EVALUATION_OPENED = exports.ACTION_UPDATE_EVALUATION_OPENED = 'ACTION_UPDATE_EVALUATION_OPENED';

/* Reducer */

exports.default = function () {
	var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	var action = arguments[1];


	switch (action.type) {
		case ACTION_NEW_EVALUATION_OPENED:
			return state.set('Response', new _immutable2.default.Map(action.Obj));
		case ACTION_GET_EVALUATION_OPENED:
			return state.set('Get', new _immutable2.default.Map(action.Obj));
		case ACTION_SEARCH_EVALUATION_OPENED:
			return state.set('Search', new _immutable2.default.List(action.Obj));
		case ACTION_SEARCH_EVAL_VAR_EVALUATION_OPENED:
			return state.set('SearchEval', new _immutable2.default.List(action.Obj));
		case ACTION_UPDATE_EVALUATION_OPENED:
			return state.set('Response', new _immutable2.default.Map(action.Obj));
		default:
			return state;
	}
};

/* Action Creators */

var newVariationEvaluationOpened = exports.newVariationEvaluationOpened = function newVariationEvaluationOpened(form) {
	var temp = {
		configuracionId: !form.configuracionId ? 0 : form.configuracionId,
		descripcion: form.descripcion,
		deleted: form.state === 1 ? false : true,
		limiteExcepcion: form.limite || false,
		monto: form.monto ? parseInt(form.monto) : 0,
		usuario: sessionStorage.uid,

		evaluacionesNivel: form.formWithVariableSelected,

		"variables": [{
			"codigoVariable": "ANIOS_EGRESOS",
			"variableValor": Number(form.anios)
		}, {
			"codigoVariable": "MONTO_MAX",
			"variableValor": form.montoMaximo
		}, {
			"codigoVariable": "MONTO_MIN",
			"variableValor": form.montoMinimo
		}, {
			"codigoVariable": "PORCENTAJE_MAXIMO_APORTACION_INGRESOS",
			"variableValor": form.maximoAportacionIngreso
		}, {
			"codigoVariable": "EXPONENTE",
			"variableValor": form.exponente

		}]
	};

	return function (dispatch) {

		dispatch((0, _Loading.isLoading)(true));

		return new _ClientHttpRequest2.default({
			service: !form.configuracionId ? 'api/newVariationEvaluationOpened' : 'api/updateVariationEvaluationOpened',
			method: "POST",
			data: temp,
			headers: Object.assign({ "Authorization": sessionStorage.access_token, "uid": sessionStorage.uid })
		}).request().then(function (response) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch({ type: ACTION_NEW_EVALUATION_OPENED, Obj: response.data });
			dispatch((0, _Modal.createModal)(Utils.successMessage()));

			return response.data;
		}).catch(function (error) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
			throw error;
		});
	};
};

var getVariationEvaluationOpened = exports.getVariationEvaluationOpened = function getVariationEvaluationOpened(id) {

	return function (dispatch) {

		dispatch((0, _Loading.isLoading)(true));

		return new _ClientHttpRequest2.default({
			service: 'api/getVariationEvaluationOpened',
			method: "POST",
			data: { id: id },
			headers: Object.assign({ "Authorization": sessionStorage.access_token, "uid": sessionStorage.uid })
		}).request().then(function (response) {
			dispatch((0, _Loading.isLoading)(false));

			var data = response.data.configuracionFuncion;
			var variables = response.data.variables;
			var evaluacionesNivel = response.data.evaluacionesNivel;

			var temp = {
				uniqueId: Utils.getUUID(),
				configuracionId: data.configuracionFuncionPK.configuracionId,
				descripcion: data.descripcion,
				state: !data.deleted ? 1 : 2,
				limite: data.limiteExcepcion,
				monto: data.monto || '',

				exponente: Utils.getItem(variables, { codigoVariable: "EXPONENTE" }).variableValor,
				anios: Utils.getItem(variables, { codigoVariable: "ANIOS_EGRESOS" }).variableValor,
				montoMaximo: Utils.getItem(variables, { codigoVariable: "MONTO_MAX" }).variableValor,
				montoMinimo: Utils.getItem(variables, { codigoVariable: "MONTO_MIN" }).variableValor,
				maximoAportacionIngreso: Utils.getItem(variables, { codigoVariable: "PORCENTAJE_MAXIMO_APORTACION_INGRESOS" }).variableValor,

				evaluacionesNivelUpdate: evaluacionesNivel
			};

			dispatch({ type: ACTION_GET_EVALUATION_OPENED, Obj: temp });
		}).catch(function (error) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
			throw error;
		});
	};
};

var searchVariationEvaluationOpened = exports.searchVariationEvaluationOpened = function searchVariationEvaluationOpened(form) {

	return function (dispatch) {

		dispatch((0, _Loading.isLoading)(true));

		return new _ClientHttpRequest2.default({
			service: Object.keys(form).length == 0 ? 'api/searchVariationEvaluationOpened' : 'api/searchParamVariationEvaluationOpened',
			method: "POST",
			data: _extends({}, form),
			headers: Object.assign({ "Authorization": sessionStorage.access_token, "uid": sessionStorage.uid })
		}).request().then(function (response) {
			dispatch((0, _Loading.isLoading)(false));

			var data = response.data.map(function (d) {
				return _extends({}, d, {
					id: d.configuracionFuncionPK.configuracionId
				});
			});
			data.uniqueId = Utils.getUUID();

			dispatch({ type: ACTION_SEARCH_EVALUATION_OPENED, Obj: data });
		}).catch(function (error) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
			throw error;
		});
	};
};

var searchEvaluacionVarVariationEvaluationOpened = exports.searchEvaluacionVarVariationEvaluationOpened = function searchEvaluacionVarVariationEvaluationOpened() {

	return function (dispatch) {

		dispatch((0, _Loading.isLoading)(true));

		return new _ClientHttpRequest2.default({
			service: 'api/searchEvaluacionVarVariationEvaluationOpened',
			method: "POST",
			data: {},
			headers: Object.assign({ "Authorization": sessionStorage.access_token, "uid": sessionStorage.uid })
		}).request().then(function (response) {
			dispatch((0, _Loading.isLoading)(false));

			dispatch({ type: ACTION_SEARCH_EVAL_VAR_EVALUATION_OPENED, Obj: response.data });
			return response.data;
		}).catch(function (error) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
			throw error;
		});
	};
};

/***/ }),

/***/ 506:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.setCompanyCharter = exports.getCompanyCharter = exports.PERSIST_COMPANY_CHARTER = exports.SET_COMPANY_CHARTER = undefined;

var _Utils = __webpack_require__(2);

var Utils = _interopRequireWildcard(_Utils);

var _ClientHttpRequest = __webpack_require__(5);

var _ClientHttpRequest2 = _interopRequireDefault(_ClientHttpRequest);

var _immutable = __webpack_require__(1);

var _immutable2 = _interopRequireDefault(_immutable);

var _Modal = __webpack_require__(4);

var _Loading = __webpack_require__(3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var initialState = _immutable2.default.Map({});

/* Types */
var SET_COMPANY_CHARTER = exports.SET_COMPANY_CHARTER = 'SET_COMPANY_CHARTER';

var PERSIST_COMPANY_CHARTER = exports.PERSIST_COMPANY_CHARTER = 'PERSIST_COMPANY_CHARTER';

/* Reducer */

exports.default = function () {
	var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	var action = arguments[1];


	switch (action.type) {
		case SET_COMPANY_CHARTER:
			return new _immutable2.default.Map(action.dataObj);
		case PERSIST_COMPANY_CHARTER:
			return state.set('persisted', action.persisted);
		default:
			return state;
	}
};

/* Action Creators */

var getCompanyCharter = exports.getCompanyCharter = function getCompanyCharter(form) {

	return function (dispatch) {

		dispatch((0, _Loading.isLoading)(true));

		return new _ClientHttpRequest2.default({
			service: 'api/getConstitutiveAct',
			method: "POST",
			data: form,
			headers: Object.assign({ "Authorization": sessionStorage.access_token, "uid": sessionStorage.uid, "n": localStorage.n })
		}).request().then(function (response) {
			dispatch((0, _Loading.isLoading)(false));
			var d = response.data.actaConstitutiva;
			var dataObj = {
				idActaConstitutiva: d.idActaConstitutiva,
				deedNumber: d.numeroEscritura,
				deedDate: d.fechaEscritura ? new Date(d.fechaEscritura).toISOString() : undefined,
				notaryName: d.notario.nombre,
				notaryPSurname: d.notario.apellidoPaterno,
				notaryMSurname: d.notario.apellidoMaterno,
				notaryOfficeNum: d.numeroNotaria,
				state: Number(d.estado.clave[0].$),
				RPPFolio: d.folioRPP,
				folioDate: d.fechaFolioRPP ? new Date(d.fechaFolioRPP).toISOString() : undefined,
				persisted: false
			};

			dispatch({ type: SET_COMPANY_CHARTER, dataObj: dataObj });
			return response.data;
		}).catch(function (error) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
			throw error;
		});
	};
};

var setCompanyCharter = exports.setCompanyCharter = function setCompanyCharter(form) {

	form = {
		"idDonataria": form.idDonataria,
		"actaConstitutiva": {
			"idActaConstitutiva": form.idActaConstitutiva,
			"numeroEscritura": form.deedNumber,
			"fechaEscritura": form.deedDate.slice(0, 10),
			"notario": {
				nombre: form.notaryName,
				apellidoPaterno: form.notaryPSurname,
				apellidoMaterno: form.notaryMSurname
			},
			"numeroNotaria": form.notaryOfficeNum,
			"estado": form.state,
			"folioRPP": form.RPPFolio,
			"fechaFolioRPP": form.folioDate ? form.folioDate.slice(0, 10) : undefined
		}
	};

	return function (dispatch) {

		dispatch((0, _Loading.isLoading)(true));

		return new _ClientHttpRequest2.default({
			service: 'api/setConstitutiveAct',
			method: "POST",
			data: form,
			headers: Object.assign({ "Authorization": sessionStorage.access_token, "uid": sessionStorage.uid })
		}).request().then(function (response) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch({ type: PERSIST_COMPANY_CHARTER, persisted: true });
			dispatch({ type: PERSIST_COMPANY_CHARTER, persisted: false });
			return response.data;
		}).catch(function (error) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
			throw error;
		});
	};
};

/***/ }),

/***/ 507:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.setContactData = exports.getContactData = exports.PERSIST_CONTACT_DATA = exports.SET_CONTACT_DATA = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _Utils = __webpack_require__(2);

var Utils = _interopRequireWildcard(_Utils);

var _ClientHttpRequest = __webpack_require__(5);

var _ClientHttpRequest2 = _interopRequireDefault(_ClientHttpRequest);

var _immutable = __webpack_require__(1);

var _immutable2 = _interopRequireDefault(_immutable);

var _Modal = __webpack_require__(4);

var _Loading = __webpack_require__(3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var initialState = _immutable2.default.Map({});

/* Types */
var SET_CONTACT_DATA = exports.SET_CONTACT_DATA = 'SET_CONTACT_DATA';

var PERSIST_CONTACT_DATA = exports.PERSIST_CONTACT_DATA = 'PERSIST_CONTACT_DATA';

/* Reducer */

exports.default = function () {
	var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	var action = arguments[1];


	switch (action.type) {
		case SET_CONTACT_DATA:
			return new _immutable2.default.Map(action.dataObj);
		case PERSIST_CONTACT_DATA:
			return state.set('persisted', action.persisted);
		default:
			return state;
	}
};

/* Action Creators */

var getContactData = exports.getContactData = function getContactData(form) {
	return function (dispatch) {

		dispatch((0, _Loading.isLoading)(true));

		return new _ClientHttpRequest2.default({
			service: 'api/getContactData',
			method: "POST",
			data: form,
			headers: Object.assign({ "Authorization": sessionStorage.access_token, "uid": sessionStorage.uid })
		}).request().then(function (response) {

			var domFiscal = void 0,
			    domCorreo = void 0,
			    domicilios = response.data.datosContacto.domicilios,
			    dataObj = {};

			if (domicilios && domicilios.direccion) {
				domFiscal = domicilios.direccion.filter(function (d) {
					return d.tipoDomicilio === "1";
				})[0];
				domCorreo = domicilios.direccion.filter(function (d) {
					return d.tipoDomicilio === "2";
				})[0];

				dataObj = {
					idDomicilio: domFiscal.idDomicilio,
					state: parseInt(domFiscal.estado.clave[0].$),
					estado: [{ id: parseInt(domFiscal.estado.clave[0].$), valor: domFiscal.estado.descripcion }],
					city: parseInt(domFiscal.ciudad.clave[0].$),
					ciudad: [{ id: parseInt(domFiscal.ciudad.clave[0].$), valor: domFiscal.ciudad.descripcion }],
					town: parseInt(domFiscal.delegacionMunicipio.clave[0].$),
					municipio: [{ id: parseInt(domFiscal.delegacionMunicipio.clave[0].$), valor: domFiscal.delegacionMunicipio.descripcion }],
					colony: parseInt(domFiscal.colonia.clave[0].$),
					//colonia: [{id: parseInt(domFiscal.colonia.clave[0].$), valor: domFiscal.colonia.descripcion}],
					colonia: [{ id: parseInt(domFiscal.colonia.clave[0].$), colonia: domFiscal.colonia.descripcion }],
					street: domFiscal.calle,
					numberExt: domFiscal.numeroExterior,
					numberInt: domFiscal.numeroInterior,
					cp: parseInt(domFiscal.codigoPostal.clave[0].$),
					street1: domFiscal.entreCalle1,
					street2: domFiscal.entreCalle2,
					reference: domFiscal.referencia,
					persisted: false
				};
			}

			if (domCorreo) {
				var dataObjMail = {
					mailToggle: 'true',
					mailIdDomicilio: domCorreo.idDomicilio,
					mailState: parseInt(domCorreo.estado.clave[0].$),
					mailEstado: [{ id: parseInt(domCorreo.estado.clave[0].$), valor: domCorreo.estado.descripcion }],
					mailCity: parseInt(domCorreo.ciudad.clave[0].$),
					mailCiudad: [{ id: parseInt(domCorreo.ciudad.clave[0].$), valor: domCorreo.ciudad.descripcion }],
					mailTown: parseInt(domCorreo.delegacionMunicipio.clave[0].$),
					mailMunicipio: [{ id: parseInt(domCorreo.delegacionMunicipio.clave[0].$), valor: domCorreo.delegacionMunicipio.descripcion }],
					mailColony: parseInt(domCorreo.colonia.clave[0].$),
					mailColonia: [{ id: parseInt(domCorreo.colonia.clave[0].$), colonia: domCorreo.colonia.descripcion }],
					mailStreet: domCorreo.calle,
					mailNumberExt: domCorreo.numeroExterior,
					mailNumberInt: domCorreo.numeroInterior,
					mailCp: parseInt(domCorreo.codigoPostal.clave[0].$),
					mailStreet1: domCorreo.entreCalle1,
					mailStreet2: domCorreo.entreCalle2,
					mailReference: domCorreo.referencia
				};
				dataObj = _extends({}, dataObj, dataObjMail);
			}

			dispatch({ type: SET_CONTACT_DATA, dataObj: dataObj });
			dispatch((0, _Loading.isLoading)(false));

			return response.data;
		}).catch(function (error) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
			throw error;
		});
	};
};

var setContactData = exports.setContactData = function setContactData(form) {

	var formRes = {
		idDonataria: form.idDonataria,
		datosContacto: {
			domicilios: {
				mismoDomicilioCorrespondencia: form.mailToggle === 'false',
				direccion: [{
					idDomicilio: form.idDomicilio,
					tipoDomicilio: 1,
					calle: form.street,
					numeroExterior: form.numberExt,
					numeroInterior: form.numberInt,
					codigoPostal: form.cp,
					entreCalle1: form.street1,
					entreCalle2: form.street2,
					referencia: form.reference,
					colonia: form.colony,
					delegacionMunicipio: form.town,
					estado: form.state,
					ciudad: form.city
				}]
			}
		}
	};

	if (form.mailIdDomicilio || form.mailToggle === 'true') {
		formRes.datosContacto.domicilios.direccion.push({
			idDomicilio: form.mailIdDomicilio,
			tipoDomicilio: 2,
			calle: form.mailStreet,
			numeroExterior: form.mailNumberExt,
			numeroInterior: form.mailNumberInt,
			codigoPostal: form.mailCp,
			entreCalle1: form.mailStreet1,
			entreCalle2: form.mailStreet2,
			referencia: form.mailReference,
			colonia: form.mailColony,
			delegacionMunicipio: form.mailTown,
			estado: form.mailState,
			ciudad: form.mailCity
		});
	}

	return function (dispatch) {

		dispatch((0, _Loading.isLoading)(true));

		return new _ClientHttpRequest2.default({
			service: 'api/setContactData',
			method: "POST",
			data: formRes,
			headers: Object.assign({ "Authorization": sessionStorage.access_token, "uid": sessionStorage.uid })
		}).request().then(function (response) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch({ type: PERSIST_CONTACT_DATA, persisted: true });
			dispatch({ type: PERSIST_CONTACT_DATA, persisted: false });
			return response.data;
		}).catch(function (error) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
			throw error;
		});
	};
};

/***/ }),

/***/ 508:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.saveFlagNotification = exports.deleteContacts = exports.newContacts = exports.getContacts = exports.DELETE_CONTACTS = exports.NEW_CONTACTS = exports.GET_CONTACTS = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _Utils = __webpack_require__(2);

var Utils = _interopRequireWildcard(_Utils);

var _immutable = __webpack_require__(1);

var _ClientHttpRequest = __webpack_require__(5);

var _ClientHttpRequest2 = _interopRequireDefault(_ClientHttpRequest);

var _Modal = __webpack_require__(4);

var _Loading = __webpack_require__(3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var initialState = (0, _immutable.Map)({}).set('contacts', new _immutable.Map({}).set('contactos', new _immutable.Map({}).set('contacto', new _immutable.List([]))));

/* Types */
var GET_CONTACTS = exports.GET_CONTACTS = 'GET_CONTACTS';
var NEW_CONTACTS = exports.NEW_CONTACTS = 'NEW_CONTACTS';
var DELETE_CONTACTS = exports.DELETE_CONTACTS = 'DELETE_CONTACTS';

/* Reducer */

exports.default = function () {
	var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	var action = arguments[1];


	switch (action.type) {
		case GET_CONTACTS:
			return state.set('contacts', new _immutable.Map(action.Obj));
		case NEW_CONTACTS:
			return state.set('newContact', true);
		case DELETE_CONTACTS:
			return state.set('deleteContact', true);
		default:
			return state;
	}
};

/* Action Creators */


var getContacts = exports.getContacts = function getContacts(form) {

	return function (dispatch) {

		dispatch((0, _Loading.isLoading)(true));

		return new _ClientHttpRequest2.default({
			service: 'api/getInformationContacts',
			method: "POST",
			data: _extends({}, form),
			headers: Object.assign({ "Authorization": sessionStorage.access_token, "uid": sessionStorage.uid })
		}).request().then(function (response) {

			var data = response.data;
			var obj = {};

			if (data.contactos === null) {
				obj = { contacto: [] };
			} else {
				obj = { contacto: data.contactos.contacto };
			}
			dispatch((0, _Loading.isLoading)(false));
			dispatch({ type: GET_CONTACTS, Obj: obj });
		}).catch(function (error) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
			throw error;
		});
	};
};

var newContacts = exports.newContacts = function newContacts(form) {
	return function (dispatch) {

		dispatch((0, _Loading.isLoading)(true));

		return new _ClientHttpRequest2.default({
			service: 'api/newInformationContacts',
			method: "POST",
			data: _extends({}, form),
			headers: Object.assign({ "Authorization": sessionStorage.access_token, "uid": sessionStorage.uid })
		}).request().then(function (response) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch({ type: NEW_CONTACTS, Obj: response.data });
		}).catch(function (error) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
			throw error;
		});
	};
};

var deleteContacts = exports.deleteContacts = function deleteContacts(form) {

	return function (dispatch) {

		dispatch((0, _Loading.isLoading)(true));

		return new _ClientHttpRequest2.default({
			service: 'api/deleteInformationContacts',
			method: "POST",
			data: _extends({}, form),
			headers: Object.assign({ "Authorization": sessionStorage.access_token, "uid": sessionStorage.uid })
		}).request().then(function (response) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch({ type: DELETE_CONTACTS, Obj: response.data });
		}).catch(function (error) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
			throw error;
		});
	};
};

var saveFlagNotification = exports.saveFlagNotification = function saveFlagNotification(form) {

	var contactos = form.contactsList.map(function (c) {
		return {
			deleted: false,
			enviarCorreo: c.enviarCorreo,
			idContacto: c.idContacto,
			idDonataria: form.idDonataria
		};
	});

	return function (dispatch) {

		dispatch((0, _Loading.isLoading)(true));

		return new _ClientHttpRequest2.default({
			service: 'api/saveFlagNotification',
			method: "POST",
			data: { contactos: contactos },
			headers: Object.assign({ "Authorization": sessionStorage.access_token, "uid": sessionStorage.uid })
		}).request().then(function (response) {
			dispatch((0, _Loading.isLoading)(false));
			return response.data;
		}).catch(function (error) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
			throw error;
		});
	};
};

/***/ }),

/***/ 509:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.getRequiredPay = exports.ACTION_GET_DOC_NAME = undefined;

var _Utils = __webpack_require__(2);

var Utils = _interopRequireWildcard(_Utils);

var _ClientHttpRequest = __webpack_require__(5);

var _ClientHttpRequest2 = _interopRequireDefault(_ClientHttpRequest);

var _immutable = __webpack_require__(1);

var _immutable2 = _interopRequireDefault(_immutable);

var _Modal = __webpack_require__(4);

var _Loading = __webpack_require__(3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var initialState = _immutable2.default.Map({}).set('Search', new _immutable2.default.List([])).set('Response', new _immutable2.default.Map({})).set('Get', new _immutable2.default.List([]));

/* Types */

var ACTION_GET_DOC_NAME = exports.ACTION_GET_DOC_NAME = 'ACTION_GET_DOC_NAME';

/* Reducer */

exports.default = function () {
	var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	var action = arguments[1];


	switch (action.type) {

		case ACTION_GET_DOC_NAME:
			return state.set('Get', new _immutable2.default.List(action.Obj));
		default:
			return state;
	}
};

/* Action Creators */

var getRequiredPay = exports.getRequiredPay = function getRequiredPay() {

	return function (dispatch) {

		dispatch((0, _Loading.isLoading)(true));

		return new _ClientHttpRequest2.default({
			service: 'api/getRequiredPay',
			method: "POST",
			data: {},
			headers: Object.assign({ "Authorization": sessionStorage.access_token, "uid": sessionStorage.uid })
		}).request().then(function (response) {
			dispatch((0, _Loading.isLoading)(false));

			dispatch({ type: ACTION_GET_DOC_NAME, Obj: response.data });
			return response.data;
		}).catch(function (error) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
			throw error;
		});
	};
};

/***/ }),

/***/ 510:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.clearDocStatus = exports.updateDocStatus = exports.deleteDocStatus = exports.getDocStatus = exports.searchDocStatus = exports.addDocStatus = exports.ACTION_UPDATE_DOC_STATUS = exports.ACTION_DELETE_DOC_STATUS = exports.ACTION_GET_DOC_STATUS = exports.ACTION_SEARCH_DOC_STATUS = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _Utils = __webpack_require__(2);

var Utils = _interopRequireWildcard(_Utils);

var _ClientHttpRequest = __webpack_require__(5);

var _ClientHttpRequest2 = _interopRequireDefault(_ClientHttpRequest);

var _immutable = __webpack_require__(1);

var _immutable2 = _interopRequireDefault(_immutable);

var _Modal = __webpack_require__(4);

var _Loading = __webpack_require__(3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var initialState = _immutable2.default.Map({}).set('Search', new _immutable2.default.List([])).set('Response', new _immutable2.default.Map({})).set('Get', new _immutable2.default.Map({}));

/* Types */
var ACTION_SEARCH_DOC_STATUS = exports.ACTION_SEARCH_DOC_STATUS = 'ACTION_SEARCH_DOC_STATUS';

var ACTION_GET_DOC_STATUS = exports.ACTION_GET_DOC_STATUS = 'ACTION_GET_DOC_STATUS';

var ACTION_DELETE_DOC_STATUS = exports.ACTION_DELETE_DOC_STATUS = 'ACTION_DELETE_DOC_STATUS';

var ACTION_UPDATE_DOC_STATUS = exports.ACTION_UPDATE_DOC_STATUS = 'ACTION_UPDATE_DOC_STATUS';

/* Reducer */

exports.default = function () {
	var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	var action = arguments[1];


	switch (action.type) {

		case ACTION_SEARCH_DOC_STATUS:
			return state.set('Search', new _immutable2.default.List(action.Obj));
		case ACTION_GET_DOC_STATUS:
			return state.set('Get', new _immutable2.default.Map(action.Obj));
		case ACTION_DELETE_DOC_STATUS:
			return state.set('Response', new _immutable2.default.Map(action.Obj));
		case ACTION_UPDATE_DOC_STATUS:
			return state.set('Response', new _immutable2.default.Map(action.Obj));
		default:
			return state;
	}
};

/* Action Creators */

var addDocStatus = exports.addDocStatus = function addDocStatus(form) {

	return function (dispatch) {

		dispatch((0, _Loading.isLoading)(true));

		return new _ClientHttpRequest2.default({
			service: 'api/newDocStatus',
			method: "POST",
			data: _extends({}, form),
			headers: Object.assign({ "Authorization": sessionStorage.access_token, "uid": sessionStorage.uid })
		}).request().then(function () {
			dispatch((0, _Loading.isLoading)(false));
			dispatch((0, _Modal.createModal)(Utils.successMessage()));
		}).catch(function (error) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
			throw error;
		});
	};
};

var searchDocStatus = exports.searchDocStatus = function searchDocStatus(form) {

	Utils.clearNullAndEmpty(form);

	return function (dispatch) {

		dispatch((0, _Loading.isLoading)(true));

		return new _ClientHttpRequest2.default({
			service: Object.keys(form).length == 0 ? 'api/searchDocStatus' : 'api/searchParamDocStatus',
			method: "POST",
			data: _extends({}, form),
			headers: Object.assign({ "Authorization": sessionStorage.access_token, "uid": sessionStorage.uid })
		}).request().then(function (response) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch({ type: ACTION_SEARCH_DOC_STATUS, Obj: response.data });
		}).catch(function (error) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
			throw error;
		});
	};
};

var getDocStatus = exports.getDocStatus = function getDocStatus(id) {

	return function (dispatch) {

		dispatch((0, _Loading.isLoading)(true));

		return new _ClientHttpRequest2.default({
			service: 'api/getDocStatus',
			method: "POST",
			data: { id: id },
			headers: Object.assign({ "Authorization": sessionStorage.access_token, "uid": sessionStorage.uid })
		}).request().then(function (response) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch({ type: ACTION_GET_DOC_STATUS, Obj: response.data });
		}).catch(function (error) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
			throw error;
		});
	};
};

var deleteDocStatus = exports.deleteDocStatus = function deleteDocStatus() {
	return function (dispatch) {
		return dispatch({ type: ACTION_DELETE_DOC_STATUS, Obj: { code: '', message: '' } });
	};
};

var updateDocStatus = exports.updateDocStatus = function updateDocStatus(form) {

	return function (dispatch) {

		dispatch((0, _Loading.isLoading)(true));
		dispatch({ type: ACTION_GET_DOC_STATUS, Obj: {} });

		return new _ClientHttpRequest2.default({
			service: 'api/updateDocStatus',
			method: "POST",
			data: _extends({}, form),
			headers: Object.assign({ "Authorization": sessionStorage.access_token, "uid": sessionStorage.uid })
		}).request().then(function (response) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch({ type: ACTION_UPDATE_DOC_STATUS, Obj: response.data });
			dispatch((0, _Modal.createModal)(Utils.successMessage()));
		}).catch(function (error) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
			throw error;
		});
	};
};

var clearDocStatus = exports.clearDocStatus = function clearDocStatus() {
	return function (dispatch) {
		dispatch({ type: ACTION_GET_DOC_STATUS, Obj: {} });
		dispatch({ type: ACTION_SEARCH_DOC_STATUS, Obj: [] });
	};
};

/***/ }),

/***/ 511:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.clearExerciseInfo = exports.searchExerciseCalendar = exports.ACTION_SEARCH_EXERCISE_CALENDAR = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _Utils = __webpack_require__(2);

var Utils = _interopRequireWildcard(_Utils);

var _ClientHttpRequest = __webpack_require__(5);

var _ClientHttpRequest2 = _interopRequireDefault(_ClientHttpRequest);

var _immutable = __webpack_require__(1);

var _immutable2 = _interopRequireDefault(_immutable);

var _Modal = __webpack_require__(4);

var _Loading = __webpack_require__(3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var initialState = _immutable2.default.Map({}).set('Search', new _immutable2.default.List([]));

/* Types */

var ACTION_SEARCH_EXERCISE_CALENDAR = exports.ACTION_SEARCH_EXERCISE_CALENDAR = 'ACTION_SEARCH_EXERCISE_CALENDAR';

/* Reducer */

exports.default = function () {
	var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	var action = arguments[1];


	switch (action.type) {
		case ACTION_SEARCH_EXERCISE_CALENDAR:
			return state.set('Search', new _immutable2.default.List(action.Obj));
		default:
			return state;
	}
};

var searchExerciseCalendar = exports.searchExerciseCalendar = function searchExerciseCalendar(form) {

	Utils.clearNullAndEmpty(form);

	return function (dispatch) {

		dispatch((0, _Loading.isLoading)(true));

		return new _ClientHttpRequest2.default({
			service: 'api/searchParamExerciseCalendar',
			method: "POST",
			data: _extends({}, form),
			headers: Object.assign({ "Authorization": sessionStorage.access_token, "uid": sessionStorage.uid })
		}).request().then(function (response) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch({ type: ACTION_SEARCH_EXERCISE_CALENDAR, Obj: response.data });
		}).catch(function (error) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
			throw error;
		});
	};
};

var clearExerciseInfo = exports.clearExerciseInfo = function clearExerciseInfo() {
	return function (dispatch) {
		dispatch({ type: ACTION_SEARCH_EXERCISE_CALENDAR, Obj: [] });
	};
};

/***/ }),

/***/ 512:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.searchFeatures = exports.ACTION_GET_FEATURES = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _Utils = __webpack_require__(2);

var Utils = _interopRequireWildcard(_Utils);

var _ClientHttpRequest = __webpack_require__(5);

var _ClientHttpRequest2 = _interopRequireDefault(_ClientHttpRequest);

var _immutable = __webpack_require__(1);

var _immutable2 = _interopRequireDefault(_immutable);

var _Modal = __webpack_require__(4);

var _Loading = __webpack_require__(3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var initialState = _immutable2.default.Map({}).set('Search', new _immutable2.default.List([]));

/* Types */
var ACTION_GET_FEATURES = exports.ACTION_GET_FEATURES = 'ACTION_GET_FEATURES';

/* Reducer */

exports.default = function () {
	var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	var action = arguments[1];


	switch (action.type) {
		case ACTION_GET_FEATURES:
			return state.set('Search', new _immutable2.default.List(action.Obj));
		default:
			return state;
	}
};

/* Action Creators */

var searchFeatures = exports.searchFeatures = function searchFeatures(form) {

	return function (dispatch) {

		dispatch((0, _Loading.isLoading)(true));

		return new _ClientHttpRequest2.default({
			service: 'api/searchFeatures',
			method: "POST",
			data: _extends({}, form),
			headers: Object.assign({ "Authorization": sessionStorage.access_token, "uid": sessionStorage.uid })
		}).request().then(function (response) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch({ type: ACTION_GET_FEATURES, Obj: response.data });
		}).catch(function (error) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
			throw error;
		});
	};
};

/***/ }),

/***/ 513:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.validateYear = exports.updateValidateYear = exports.setValidateYear = exports.getValidateYear = exports.setFinancial = exports.getFinancial = exports.VALIDATE_YEAR = exports.GET_VALIDATE_YEAR = exports.GET_FINANCIAL = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _Utils = __webpack_require__(2);

var Utils = _interopRequireWildcard(_Utils);

var _ClientHttpRequest = __webpack_require__(5);

var _ClientHttpRequest2 = _interopRequireDefault(_ClientHttpRequest);

var _immutable = __webpack_require__(1);

var _immutable2 = _interopRequireDefault(_immutable);

var _Modal = __webpack_require__(4);

var _Loading = __webpack_require__(3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var initialState = _immutable2.default.Map({}).set('Search', new _immutable2.default.List([])).set('Response', new _immutable2.default.Map({})).set('Get', new _immutable2.default.Map({})).set('GetValidateYear', new _immutable2.default.Map({})).set('ValidateYear', new _immutable2.default.Map({}));

/* Types */
var GET_FINANCIAL = exports.GET_FINANCIAL = 'GET_FINANCIAL';
var GET_VALIDATE_YEAR = exports.GET_VALIDATE_YEAR = 'GET_VALIDATE_YEAR';
var VALIDATE_YEAR = exports.VALIDATE_YEAR = 'VALIDATE_YEAR';

/* Reducer */

exports.default = function () {
	var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	var action = arguments[1];


	switch (action.type) {
		case GET_FINANCIAL:
			return state.set('Get', new _immutable2.default.Map(action.Obj));
		case GET_VALIDATE_YEAR:
			return state.set('GetValidateYear', new _immutable2.default.Map(action.Obj));
		case VALIDATE_YEAR:
			return state.set('ValidateYear', new _immutable2.default.Map(action.Obj));
		default:
			return state;
	}
};

/* Action Creators */

var getFinancial = exports.getFinancial = function getFinancial(form) {

	return function (dispatch) {

		dispatch((0, _Loading.isLoading)(true));

		return new _ClientHttpRequest2.default({
			service: 'api/getFinancial',
			method: "POST",
			data: _extends({}, form),
			headers: Object.assign({ "Authorization": sessionStorage.access_token, "uid": sessionStorage.uid })
		}).request().then(function (response) {
			dispatch((0, _Loading.isLoading)(false));

			var data = response.data;

			var formFinancial = {};

			if (data.informacionFinanciera.financieraEjercicioFiscal[0]) {

				var dataFinancial = data.informacionFinanciera.financieraEjercicioFiscal[0];

				var ingresos = dataFinancial.ingresos || {};
				var egresos = dataFinancial.egresos || {};
				var activos = dataFinancial.activos || {};
				var pasivos = dataFinancial.pasivos || {};

				formFinancial = {
					uniqueId: Utils.getUUID(),
					aportacionPatronos: ingresos.aportacionPatronConsejero || "",
					gastosOperativos: egresos.gastosOperativos || "",
					cuotasAsociados: ingresos.cuotasAsociados || "",
					gastosAdministrativos: egresos.gastosAdministrativos || "",
					donativosPersonas: ingresos.donativosPersonasFisicas || "",
					otrosGastos: egresos.otrosGastos || "",
					donativosEmpresas: ingresos.donativosPersonasMorales || "",
					donativosNMP: ingresos.donativosNMP || "",
					oscNacionales: ingresos.oscNacionales || "",
					oscInternacionales: ingresos.oscInternacionales || "",
					gastosRecaudacion: egresos.recaudacionFondos || "",
					donativosGobierno: ingresos.donativosGobierno || "",
					rendimientoPatrimoniales: ingresos.rendimientoFondosPatrimoniales || "",
					ingresosArrendamiento: ingresos.arrendamiento || "",
					cuotasRecuperacion: ingresos.cuotasRecuperacion || "",
					actividadesProductivas: ingresos.actividadesProductivas || "",
					otrasActividades: ingresos.otrasActividades || "",
					descripcionOtrasActividades: ingresos.descripcionOtrasActividades || "",
					activoCirculante: activos.activoCirculante || "",
					proveedores: pasivos.proveedores || "",
					activoFijo: activos.activoFijo || "",
					cuentasPagar: pasivos.cuentasPorPagar || "",
					activoDiferido: activos.activoDiferido || "",
					impuestos: pasivos.impuestos || "",
					otrosPasivos: pasivos.otrosPasivos || "",
					pasivoLargo: pasivos.pasivoLargoPlazo || "",
					pasivoCorto: pasivos.patrimonio || "",
					numeroEmpleados: dataFinancial.numeroEmpleados || "",
					numeroHombresRemunerados: dataFinancial.numeroHombresRemunerados || "",
					numeroMujeresRemunerados: dataFinancial.numeroMujeresRemunerados || "",
					numeroOtrosGenerosRemunerados: dataFinancial.numeroOtrosGenerosRemunerados || "",
					numeroVoluntarios: dataFinancial.numeroVoluntarios || "",
					numeroHombresVoluntarios: dataFinancial.numeroHombresVoluntarios || "",
					numeroMujeresVoluntarios: dataFinancial.numeroMujeresVoluntarios || "",
					numeroOtrosGenerosVoluntarios: dataFinancial.numeroOtrosGenerosVoluntarios || "",
					numeroTransporte: dataFinancial.numeroEquiposTransporte || "",
					speciesDonationCheck: dataFinancial.donativoEspecie.descripcionDonativo && dataFinancial.donativoEspecie.descripcionDonativo !== "" ? true : false,
					speciesDonation: dataFinancial.donativoEspecie.descripcionDonativo || "",
					ammountDonation: dataFinancial.donativoEspecie.montoDonativo || "",
					subtotalEgresos: egresos.subtotalEgreso || "",
					totalIngresos: ingresos.totalIngreso || "",
					totalegresos: egresos.totalEgreso || "",
					subtotalPasivos: pasivos.subtotalPasivoCirculante || "",
					totalActivos: activos.totalActivo || "",
					totalPasivos: pasivos.totalPasivoMasCapital || "",
					firstTotal: dataFinancial.resultadoEjercicio || "",
					secondTotal: dataFinancial.gastoAdministrativo || ""
					// se asignan a hombres los voluntarios y remunerados por defecto para donatarias existentes
				};if (!formFinancial.numeroHombresRemunerados && !formFinancial.numeroMujeresVoluntarios && !formFinancial.numeroOtrosGenerosRemunerados) formFinancial.numeroHombresRemunerados = formFinancial.numeroEmpleados;
				if (!formFinancial.numeroHombresVoluntarios && !formFinancial.numeroMujeresVoluntarios && !formFinancial.numeroOtrosGenerosVoluntarios) formFinancial.numeroHombresVoluntarios = formFinancial.numeroVoluntarios;
			}

			dispatch({ type: GET_FINANCIAL, Obj: formFinancial });
		}).catch(function (error) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
			throw error;
		});
	};
};

var setFinancial = exports.setFinancial = function setFinancial(form) {

	var temp = {
		idDonataria: form.idDonataria,
		ejercicioFiscal: {
			idEjercicioFiscal: form.idEjercicioFiscal
		},
		informacionFinanciera: {
			ingresos: {
				aportacionPatronConsejero: form.aportacionPatronos || 0,
				cuotasAsociados: form.cuotasAsociados || 0,
				donativosPersonasFisicas: form.donativosPersonas || 0,
				donativosPersonasMorales: form.donativosEmpresas || 0,
				donativosNMP: form.donativosNMP || 0,
				oscNacionales: form.oscNacionales || 0,
				oscInternacionales: form.oscInternacionales || 0,
				donativosGobierno: form.donativosGobierno || 0,
				rendimientosFondos: form.rendimientoPatrimoniales || 0,
				rendimientoFondosPatrimoniales: form.rendimientoPatrimoniales || 0,
				arrendamiento: form.ingresosArrendamiento || 0,
				cuotasRecuperacion: form.cuotasRecuperacion || 0,
				actividadesProductivas: form.actividadesProductivas || 0,
				otrasActividades: form.otrasActividades || 0,
				totalIngreso: form.totalIngresos || 0,
				descripcionOtrasActividades: form.descripcionOtrasActividades || ""
			},
			egresos: {
				gastosOperativos: form.gastosOperativos || 0,
				gastosAdministrativos: form.gastosAdministrativos || 0,
				otrosGastos: form.otrosGastos || 0,
				subtotalEgreso: form.subtotalEgresos || 0,
				recaudacionFondos: form.gastosRecaudacion || 0,
				totalEgreso: form.totalEgresos || 0
			},
			pasivos: {
				proveedores: form.proveedores || 0,
				cuentasPorPagar: form.cuentasPagar || 0,
				impuestos: form.impuestos || 0,
				otrosPasivos: form.otrosPasivos || 0,
				subtotalPasivoCirculante: form.subtotalPasivos || 0,
				pasivoLargoPlazo: form.pasivoLargo || 0,
				patrimonio: form.pasivoCorto || 0,
				totalPasivoMasCapital: form.totalPasivos || 0
			},
			activos: {
				activoCirculante: form.activoCirculante || 0,
				activoFijo: form.activoFijo || 0,
				activoDiferido: form.activoDiferido || 0,
				totalActivo: form.totalActivos || 0
			},
			resultadoEjercicio: form.firstTotal || 0,
			gastoAdministrativo: form.secondTotal || 0,
			numeroEmpleados: form.numeroEmpleados || 0,
			numeroVoluntarios: form.numeroVoluntarios || 0,
			numeroEquiposTransporte: form.numeroTransporte || 0,
			donativoEspecie: {
				descripcionDonativo: form.speciesDonationCheck ? form.speciesDonation : "",
				montoDonativo: form.speciesDonationCheck ? form.ammountDonation : 0
			},
			numeroHombresVoluntarios: form.numeroHombresVoluntarios || 0,
			numeroMujeresVoluntarios: form.numeroMujeresVoluntarios || 0,
			numeroOtrosGenerosVoluntarios: form.numeroOtrosGenerosVoluntarios || 0,
			numeroHombresRemunerados: form.numeroHombresRemunerados || 0,
			numeroMujeresRemunerados: form.numeroMujeresRemunerados || 0,
			numeroOtrosGenerosRemunerados: form.numeroOtrosGenerosRemunerados || 0
		}
	};

	return function (dispatch) {

		dispatch((0, _Loading.isLoading)(true));

		return new _ClientHttpRequest2.default({
			service: 'api/setFinancial',
			method: "POST",
			data: temp,
			headers: Object.assign({ "Authorization": sessionStorage.access_token, "uid": sessionStorage.uid })
		}).request().then(function (response) {
			dispatch((0, _Loading.isLoading)(false));
			return response.data;
		}).catch(function (error) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
			throw error;
		});
	};
};

var getValidateYear = exports.getValidateYear = function getValidateYear(form) {

	return function (dispatch) {

		dispatch((0, _Loading.isLoading)(true));

		return new _ClientHttpRequest2.default({
			service: 'api/getValidateYear',
			method: "POST",
			data: _extends({}, form),
			headers: Object.assign({ "Authorization": sessionStorage.access_token, "uid": sessionStorage.uid })
		}).request().then(function (response) {
			dispatch((0, _Loading.isLoading)(false));

			var data = response.data;

			dispatch({ type: GET_VALIDATE_YEAR, Obj: data });
			return data;
		}).catch(function (error) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
			throw error;
		});
	};
};

var setValidateYear = exports.setValidateYear = function setValidateYear(form) {

	return function (dispatch) {

		dispatch((0, _Loading.isLoading)(true));

		return new _ClientHttpRequest2.default({
			service: 'api/setValidateYear',
			method: "POST",
			data: _extends({}, form),
			headers: Object.assign({ "Authorization": sessionStorage.access_token, "uid": sessionStorage.uid })
		}).request().then(function (response) {
			dispatch((0, _Loading.isLoading)(false));
			return 0;
		}).catch(function (error) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
			throw error;
		});
	};
};

var updateValidateYear = exports.updateValidateYear = function updateValidateYear(form) {

	return function (dispatch) {

		dispatch((0, _Loading.isLoading)(true));

		return new _ClientHttpRequest2.default({
			service: 'api/updateValidateYear',
			method: "POST",
			data: _extends({}, form),
			headers: Object.assign({ "Authorization": sessionStorage.access_token, "uid": sessionStorage.uid })
		}).request().then(function (response) {
			dispatch((0, _Loading.isLoading)(false));
			return 0;
		}).catch(function (error) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
			throw error;
		});
	};
};

var validateYear = exports.validateYear = function validateYear(form) {

	return function (dispatch) {

		dispatch((0, _Loading.isLoading)(true));

		return new _ClientHttpRequest2.default({
			service: 'api/validateYear',
			method: "POST",
			data: _extends({}, form),
			headers: Object.assign({ "Authorization": sessionStorage.access_token, "uid": sessionStorage.uid })
		}).request().then(function (response) {
			dispatch((0, _Loading.isLoading)(false));
			var data = response.data;

			dispatch({ type: VALIDATE_YEAR, Obj: data });
		}).catch(function (error) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
			throw error;
		});
	};
};

/***/ }),

/***/ 514:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.clearGeneralInfo = exports.setGeneralInfo = exports.getGeneralInfo = exports.PERSIST_GENERAL_INFO = exports.GET_GENERAL_INFO = undefined;

var _Utils = __webpack_require__(2);

var Utils = _interopRequireWildcard(_Utils);

var _ClientHttpRequest = __webpack_require__(5);

var _ClientHttpRequest2 = _interopRequireDefault(_ClientHttpRequest);

var _immutable = __webpack_require__(1);

var _immutable2 = _interopRequireDefault(_immutable);

var _Modal = __webpack_require__(4);

var _Loading = __webpack_require__(3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var initialState = _immutable2.default.Map({});

/* Types */
var GET_GENERAL_INFO = exports.GET_GENERAL_INFO = 'GET_GENERAL_INFO';

var PERSIST_GENERAL_INFO = exports.PERSIST_GENERAL_INFO = 'PERSIST_GENERAL_INFO';

/* Reducer */

exports.default = function () {
	var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	var action = arguments[1];


	switch (action.type) {
		case GET_GENERAL_INFO:
			return new _immutable2.default.Map(action.dataObj);
		case PERSIST_GENERAL_INFO:
			return state.set('persisted', action.persisted);
		default:
			return state;
	}
};

/* Action Creators */

var getGeneralInfo = exports.getGeneralInfo = function getGeneralInfo(form) {

	return function (dispatch) {

		dispatch((0, _Loading.isLoading)(true));

		return new _ClientHttpRequest2.default({
			service: 'api/getInfoGeneral',
			method: "POST",
			data: form,
			headers: Object.assign({ "Authorization": sessionStorage.access_token, "uid": sessionStorage.uid, "n": localStorage.n })
		}).request().then(function (response) {
			dispatch((0, _Loading.isLoading)(false));

			response.data = Utils.ds_(response.data.reference);

			var info = response.data.informacionGeneral;
			var dataObj = {
				granteeName: response.data.nombreDonataria,
				cluni: info.cluni,
				constitutionDate: info.fechaConstitucion,
				operationsDate: info.fechaInicioOperacion,
				iap: info.transformadaIAP,
				jap: info.organismoRegulador.id,
				socialIntervention: info.intervencionSocial,
				phone: info.telefono,
				webpage: info.paginaWeb || '',
				mail1: info.correoElectronico[0],
				mail2: info.correoElectronico[1] || '',
				twitter: info.twitter || '',
				facebook: info.facebook || '',
				persisted: false,
				checkInfo: response.data.recibeInfoNMP
			};
			dispatch({ type: GET_GENERAL_INFO, dataObj: dataObj });
			return response.data;
		}).catch(function (error) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
			throw error;
		});
	};
};

var setGeneralInfo = exports.setGeneralInfo = function setGeneralInfo(form) {

	var correoElectronico = [form.mail1];
	form.mail2 && correoElectronico.push(form.mail2);

	form = {
		idDonataria: form.idDonataria,
		nombreDonataria: form.granteeName,
		recibeInfoNMP: !form.checkInfo ? false : form.checkInfo,
		informacionGeneral: {
			cluni: form.cluni,
			fechaConstitucion: form.constitutionDate.slice(0, 10),
			fechaInicioOperacion: form.operationsDate.slice(0, 10),
			transformadaIAP: form.iap,
			organismoRegulador: form.jap,
			intervencionSocial: form.socialIntervention,
			telefono: Number(form.phone),
			paginaWeb: form.webpage || undefined,
			correoElectronico: correoElectronico,
			facebook: form.facebook || undefined,
			twitter: form.twitter || undefined
		}
	};

	form = { reference: Utils.ec_(form) };

	return function (dispatch) {
		dispatch((0, _Loading.isLoading)(true));

		return new _ClientHttpRequest2.default({
			service: 'api/setInfoGeneral',
			method: "POST",
			data: form,
			headers: Object.assign({ "Authorization": sessionStorage.access_token, "uid": sessionStorage.uid, "n": localStorage.n })
		}).request().then(function (response) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch({ type: PERSIST_GENERAL_INFO, persisted: true });
			dispatch({ type: PERSIST_GENERAL_INFO, persisted: false });
			return response.data;
		}).catch(function (error) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
			throw error;
		});
	};
};

var clearGeneralInfo = exports.clearGeneralInfo = function clearGeneralInfo() {

	return function (dispatch) {
		dispatch({ type: GET_GENERAL_INFO, Obj: {} });
	};
};
// pendiente encriptar con llave de usuario desde el middleware

/***/ }),

/***/ 515:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.deleteObjective = exports.setObjective = exports.getObjectives = exports.DELETE_OBJECTIVE = exports.NEW_OBJECTIVE = exports.GET_OBJECTIVES = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _Utils = __webpack_require__(2);

var Utils = _interopRequireWildcard(_Utils);

var _ClientHttpRequest = __webpack_require__(5);

var _ClientHttpRequest2 = _interopRequireDefault(_ClientHttpRequest);

var _immutable = __webpack_require__(1);

var _immutable2 = _interopRequireDefault(_immutable);

var _Modal = __webpack_require__(4);

var _Loading = __webpack_require__(3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var initialState = _immutable2.default.Map({}).set('Search', new _immutable2.default.List([])).set('Response', new _immutable2.default.Map({})).set('Get', new _immutable2.default.Map({}));

/* Types */
var GET_OBJECTIVES = exports.GET_OBJECTIVES = 'GET_OBJECTIVES';

var NEW_OBJECTIVE = exports.NEW_OBJECTIVE = 'NEW_OBJECTIVE';

var DELETE_OBJECTIVE = exports.DELETE_OBJECTIVE = 'DELETE_OBJECTIVE';

/* Reducer */

exports.default = function () {
	var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	var action = arguments[1];


	switch (action.type) {
		case GET_OBJECTIVES:
			return state.set('Get', new _immutable2.default.Map(action.Obj));
		default:
			return state;
	}
};

/* Action Creators */


var getObjectives = exports.getObjectives = function getObjectives(form) {

	return function (dispatch) {

		dispatch((0, _Loading.isLoading)(true));

		return new _ClientHttpRequest2.default({
			service: 'api/getInformationObjective',
			method: "POST",
			data: _extends({}, form),
			headers: Object.assign({ "Authorization": sessionStorage.access_token, "uid": sessionStorage.uid })
		}).request().then(function (response) {
			dispatch((0, _Loading.isLoading)(false));

			var data = response.data;
			data.uniqueId = Utils.getUUID();

			if (data.objetivos === null) data = { objetivos: { objetivoMeta: [] } };

			dispatch({ type: GET_OBJECTIVES, Obj: data });
		}).catch(function (error) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
			throw error;
		});
	};
};
var setObjective = exports.setObjective = function setObjective(form) {

	return function (dispatch) {

		dispatch((0, _Loading.isLoading)(true));

		return new _ClientHttpRequest2.default({
			service: 'api/setInformationObjective',
			method: "POST",
			data: form,
			headers: Object.assign({ "Authorization": sessionStorage.access_token, "uid": sessionStorage.uid })
		}).request().then(function () {
			dispatch((0, _Loading.isLoading)(false));
		}).catch(function (error) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch((0, _Modal.createModal)(Utils.errorMessage(error.response.data.message)));
			throw error;
		});
	};
};
var deleteObjective = exports.deleteObjective = function deleteObjective(form) {

	return function (dispatch) {

		dispatch((0, _Loading.isLoading)(true));

		return new _ClientHttpRequest2.default({
			service: 'api/deleteInformationObjective',
			method: "POST",
			data: form,
			headers: Object.assign({ "Authorization": sessionStorage.access_token, "uid": sessionStorage.uid })
		}).request().then(function () {
			dispatch((0, _Loading.isLoading)(false));
		}).catch(function (error) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch((0, _Modal.createModal)(Utils.errorMessage(error.response.data.message)));
			throw error;
		});
	};
};

/***/ }),

/***/ 516:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.beginAdminProcess = exports.getInfoSummary = exports.GET_SUMMARY = undefined;

var _Utils = __webpack_require__(2);

var Utils = _interopRequireWildcard(_Utils);

var _ClientHttpRequest = __webpack_require__(5);

var _ClientHttpRequest2 = _interopRequireDefault(_ClientHttpRequest);

var _immutable = __webpack_require__(1);

var _Modal = __webpack_require__(4);

var _Loading = __webpack_require__(3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var initialState = (0, _immutable.Map)({});

/* Types */
var GET_SUMMARY = exports.GET_SUMMARY = 'GET_SUMMARY';

/* Reducer */

exports.default = function () {
	var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	var action = arguments[1];


	switch (action.type) {
		case GET_SUMMARY:
			return new _immutable.Map(action.Obj);
		default:
			return state;
	}
};

/* Action Creators */


var getInfoSummary = exports.getInfoSummary = function getInfoSummary(form) {

	return function (dispatch) {
		dispatch((0, _Loading.isLoading)(true));
		return new _ClientHttpRequest2.default({
			service: 'api/getInfoSummary',
			method: "POST",
			data: form,
			headers: Object.assign({ "Authorization": sessionStorage.access_token, "uid": sessionStorage.uid })
		}).request().then(function (response) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch({ type: GET_SUMMARY, Obj: response.data });
		}).catch(function (error) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
			throw error;
		});
	};
};

var beginAdminProcess = exports.beginAdminProcess = function beginAdminProcess(form) {
	return function (dispatch) {
		dispatch((0, _Loading.isLoading)(true));
		return new _ClientHttpRequest2.default({
			service: 'api/beginAdmin',
			method: "POST",
			data: form,
			headers: Object.assign({ "Authorization": sessionStorage.access_token, "uid": sessionStorage.uid })
		}).request().then(function () {
			dispatch((0, _Loading.isLoading)(false));
		}).catch(function (error) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
			throw error;
		});
	};
};

/***/ }),

/***/ 517:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.deleteLocations = exports.setLocations = exports.getLocations = exports.GET_LOCATIONS = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _Utils = __webpack_require__(2);

var Utils = _interopRequireWildcard(_Utils);

var _ClientHttpRequest = __webpack_require__(5);

var _ClientHttpRequest2 = _interopRequireDefault(_ClientHttpRequest);

var _immutable = __webpack_require__(1);

var _immutable2 = _interopRequireDefault(_immutable);

var _Modal = __webpack_require__(4);

var _Loading = __webpack_require__(3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var initialState = _immutable2.default.Map({}).set('Search', new _immutable2.default.List([])).set('Response', new _immutable2.default.Map({})).set('Get', new _immutable2.default.Map({}));

/* Types */
var GET_LOCATIONS = exports.GET_LOCATIONS = 'GET_LOCATIONS';

/* Reducer */

exports.default = function () {
	var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	var action = arguments[1];


	switch (action.type) {
		case GET_LOCATIONS:
			return state.set('Get', new _immutable2.default.Map(action.Obj));
		default:
			return state;
	}
};

/* Action Creators */

var getLocations = exports.getLocations = function getLocations(form) {

	return function (dispatch) {

		dispatch((0, _Loading.isLoading)(true));

		return new _ClientHttpRequest2.default({
			service: 'api/getLocations',
			method: "POST",
			data: _extends({}, form),
			headers: Object.assign({ "Authorization": sessionStorage.access_token, "uid": sessionStorage.uid })
		}).request().then(function (response) {

			var data = response.data;

			var dataLocations = new Array();

			if (data.ubicaciones.ubicacionEjercicioFiscal[0].ubicaciones) {

				data.ubicaciones.ubicacionEjercicioFiscal[0].ubicaciones.ubicacion.map(function (l) {
					var obj = {
						uniqueId: Utils.getUUID(),
						actividadDesarrolla: l.actividadDesarrolla,
						calle: l.calle,
						ciudad: l.ciudad,
						codigoPostal: l.codigoPostal,
						colonia: l.colonia,
						entreCalle1: l.entreCalle1,
						entreCalle2: l.entreCalle2,
						estado: l.estado,
						id: l.idUbicacion,
						municipio: l.municipio,
						numeroExterior: l.numeroExterior,
						numeroInterior: l.numeroInterior,
						poblacionAtendida: l.poblacionAtendida,
						referencia: l.referencia,
						domicilio: l.estado.descripcion + ', ' + l.municipio.descripcion + ', ' + l.ciudad.descripcion + ', ' + l.calle + ', ' + l.numeroExterior + ', ' + (l.numeroInterior || ''),
						clasificacion: Number(l.clasificacion) || 1
					};
					obj.checkSede = obj.clasificacion === 2 ? true : false;
					dataLocations.push(obj);
				});
			}

			console.log(dataLocations);

			dispatch((0, _Loading.isLoading)(false));
			dispatch({ type: GET_LOCATIONS, Obj: { dataLocations: dataLocations } });
		}).catch(function (error) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
			throw error;
		});
	};
};

var setLocations = exports.setLocations = function setLocations(form) {

	return function (dispatch) {

		dispatch((0, _Loading.isLoading)(true));

		return new _ClientHttpRequest2.default({
			service: 'api/setLocations',
			method: "POST",
			data: _extends({}, form),
			headers: Object.assign({ "Authorization": sessionStorage.access_token, "uid": sessionStorage.uid })
		}).request().then(function (response) {
			dispatch((0, _Loading.isLoading)(false));
			return response.data;
		}).catch(function (error) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
			throw error;
		});
	};
};

var deleteLocations = exports.deleteLocations = function deleteLocations(form) {

	return function (dispatch) {

		dispatch((0, _Loading.isLoading)(true));

		return new _ClientHttpRequest2.default({
			service: 'api/deleteLocations',
			method: "POST",
			data: _extends({}, form),
			headers: Object.assign({ "Authorization": sessionStorage.access_token, "uid": sessionStorage.uid })
		}).request().then(function (response) {
			dispatch((0, _Loading.isLoading)(false));
			return response.data;
		}).catch(function (error) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
			throw error;
		});
	};
};

/***/ }),

/***/ 518:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.searchOrigenEvaluation = exports.ACTION_SEARCH_ORIGEN_EVALUATION = undefined;

var _Utils = __webpack_require__(2);

var Utils = _interopRequireWildcard(_Utils);

var _ClientHttpRequest = __webpack_require__(5);

var _ClientHttpRequest2 = _interopRequireDefault(_ClientHttpRequest);

var _immutable = __webpack_require__(1);

var _immutable2 = _interopRequireDefault(_immutable);

var _Modal = __webpack_require__(4);

var _Loading = __webpack_require__(3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var initialState = _immutable2.default.Map({}).set('Search', new _immutable2.default.List([])).set('Response', new _immutable2.default.Map({})).set('Get', new _immutable2.default.Map({}));

/* Types */
var ACTION_SEARCH_ORIGEN_EVALUATION = exports.ACTION_SEARCH_ORIGEN_EVALUATION = 'ACTION_SEARCH_ORIGEN_EVALUATION';

/* Reducer */

exports.default = function () {
	var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	var action = arguments[1];


	switch (action.type) {
		case ACTION_SEARCH_ORIGEN_EVALUATION:
			return state.set('Search', new _immutable2.default.List(action.Obj));
		default:
			return state;
	}
};

/* Action Creators */


var searchOrigenEvaluation = exports.searchOrigenEvaluation = function searchOrigenEvaluation() {

	return function (dispatch) {

		dispatch((0, _Loading.isLoading)(true));

		return new _ClientHttpRequest2.default({
			service: 'api/searchOrigenEvaluation',
			method: "POST",
			data: {},
			headers: Object.assign({ "Authorization": sessionStorage.access_token, "uid": sessionStorage.uid })
		}).request().then(function (response) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch({ type: ACTION_SEARCH_ORIGEN_EVALUATION, Obj: response.data });
		}).catch(function (error) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
			throw error;
		});
	};
};

/***/ }),

/***/ 519:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.deletePatron = exports.savePatron = exports.getPatrons = exports.PERSIST_PATRONS_COUNCELORS = exports.SET_PATRONS_COUNCELORS = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _Utils = __webpack_require__(2);

var Utils = _interopRequireWildcard(_Utils);

var _ClientHttpRequest = __webpack_require__(5);

var _ClientHttpRequest2 = _interopRequireDefault(_ClientHttpRequest);

var _immutable = __webpack_require__(1);

var _immutable2 = _interopRequireDefault(_immutable);

var _Modal = __webpack_require__(4);

var _Loading = __webpack_require__(3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var initialState = _immutable2.default.Map({});

/* Types */
var SET_PATRONS_COUNCELORS = exports.SET_PATRONS_COUNCELORS = 'SET_PATRONS_COUNCELORS';

var PERSIST_PATRONS_COUNCELORS = exports.PERSIST_PATRONS_COUNCELORS = 'PERSIST_PATRONS_COUNCELORS';

/* Reducer */

exports.default = function () {
	var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	var action = arguments[1];


	switch (action.type) {
		case SET_PATRONS_COUNCELORS:
			return new _immutable2.default.Map(action.dataObj);
		case PERSIST_PATRONS_COUNCELORS:
			return state.set('persisted', action.persisted);
		default:
			return state;
	}
};

/* Action Creators */

var getPatrons = exports.getPatrons = function getPatrons(form) {

	return function (dispatch) {

		form = Utils.ec_(form);

		form = { reference: form };

		dispatch((0, _Loading.isLoading)(true));

		return new _ClientHttpRequest2.default({
			service: 'api/getPatronData',
			method: "POST",
			data: form,
			headers: Object.assign({ "Authorization": sessionStorage.access_token, "uid": sessionStorage.uid, "n": localStorage.n })
		}).request().then(function (response) {
			dispatch((0, _Loading.isLoading)(false));

			response.data = Utils.ds_(response.data.reference);

			response.data.patronosConsejeros.consejero.forEach(function (item, i) {
				try {
					if (item.correoElectronico.includes("|")) {
						var arr = item.correoElectronico.split("|");
						item.correoElectronico = arr[0];
						item.telefono = arr[1];
					}
				} catch (e) {
					console.log(e, '<--- err');
				}
			});

			var dataObj = _extends({}, response.data.patronosConsejeros, { persisted: false });

			dispatch({ type: SET_PATRONS_COUNCELORS, dataObj: dataObj });
		}).catch(function (error) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
			throw error;
		});
	};
};

var savePatron = exports.savePatron = function savePatron(form) {

	return function (dispatch) {

		dispatch((0, _Loading.isLoading)(true));

		return new _ClientHttpRequest2.default({
			service: 'api/savePatron',
			method: "POST",
			data: form,
			headers: Object.assign({ "Authorization": sessionStorage.access_token, "uid": sessionStorage.uid })
		}).request().then(function () {
			dispatch((0, _Loading.isLoading)(false));
			dispatch({ type: PERSIST_PATRONS_COUNCELORS, persisted: true });
			dispatch({ type: PERSIST_PATRONS_COUNCELORS, persisted: false });
		}).catch(function (error) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
			throw error;
		});
	};
};

var deletePatron = exports.deletePatron = function deletePatron(idDonataria, idPatron) {

	return function (dispatch) {

		dispatch((0, _Loading.isLoading)(true));

		return new _ClientHttpRequest2.default({
			service: 'api/deletePatron',
			method: "POST",
			data: { idDonataria: idDonataria, idPatron: idPatron },
			headers: Object.assign({ "Authorization": sessionStorage.access_token, "uid": sessionStorage.uid })
		}).request().then(function () {
			dispatch((0, _Loading.isLoading)(false));
			dispatch({ type: PERSIST_PATRONS_COUNCELORS, persisted: true });
			dispatch({ type: PERSIST_PATRONS_COUNCELORS, persisted: false });
		}).catch(function (error) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
			throw error;
		});
	};
};
// pendiente encriptar en mid con llave de usuario

/***/ }),

/***/ 520:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.getPatronsCatalog = exports.GET_PATRONS_CATALOG = undefined;

var _Utils = __webpack_require__(2);

var Utils = _interopRequireWildcard(_Utils);

var _ClientHttpRequest = __webpack_require__(5);

var _ClientHttpRequest2 = _interopRequireDefault(_ClientHttpRequest);

var _immutable = __webpack_require__(1);

var _immutable2 = _interopRequireDefault(_immutable);

var _Modal = __webpack_require__(4);

var _Loading = __webpack_require__(3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var initialState = _immutable2.default.Map({}).set('Search', new _immutable2.default.List([])).set('Response', new _immutable2.default.Map({})).set('Get', new _immutable2.default.Map({}));

/* Types */
var GET_PATRONS_CATALOG = exports.GET_PATRONS_CATALOG = 'GET_PATRONS_CATALOG';

/* Reducer */

exports.default = function () {
	var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	var action = arguments[1];


	switch (action.type) {
		case GET_PATRONS_CATALOG:
			return state.set('Search', new _immutable2.default.List(action.Obj));
		default:
			return state;
	}
};

/* Action Creators */


var getPatronsCatalog = exports.getPatronsCatalog = function getPatronsCatalog() {

	return function (dispatch) {

		dispatch((0, _Loading.isLoading)(true));

		return new _ClientHttpRequest2.default({
			service: 'api/getPatronsCatalog',
			method: "POST",
			data: {},
			headers: Object.assign({ "Authorization": sessionStorage.access_token, "uid": sessionStorage.uid })
		}).request().then(function (response) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch({ type: GET_PATRONS_CATALOG, Obj: response.data });
		}).catch(function (error) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
			throw error;
		});
	};
};

/***/ }),

/***/ 521:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.searchPhase = exports.ACTION_SEARCH_PHASE = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _Utils = __webpack_require__(2);

var Utils = _interopRequireWildcard(_Utils);

var _ClientHttpRequest = __webpack_require__(5);

var _ClientHttpRequest2 = _interopRequireDefault(_ClientHttpRequest);

var _immutable = __webpack_require__(1);

var _immutable2 = _interopRequireDefault(_immutable);

var _Modal = __webpack_require__(4);

var _Loading = __webpack_require__(3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var initialState = _immutable2.default.Map({}).set('Search', new _immutable2.default.List([])).set('Response', new _immutable2.default.Map({})).set('Get', new _immutable2.default.Map({}));

/* Types */

var ACTION_SEARCH_PHASE = exports.ACTION_SEARCH_PHASE = 'ACTION_SEARCH_PHASE';

/* Reducer */

exports.default = function () {
	var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	var action = arguments[1];


	switch (action.type) {
		case ACTION_SEARCH_PHASE:
			return state.set('Search', new _immutable2.default.List(action.Obj));
		default:
			return state;
	}
};

/* Action Creators */

var searchPhase = exports.searchPhase = function searchPhase(form) {

	Utils.clearNullAndEmpty(form);

	return function (dispatch) {

		dispatch((0, _Loading.isLoading)(true));

		return new _ClientHttpRequest2.default({
			service: 'api/searchPhase',
			method: "POST",
			data: _extends({}, form),
			headers: Object.assign({ "Authorization": sessionStorage.access_token, "uid": sessionStorage.uid })
		}).request().then(function (response) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch({ type: ACTION_SEARCH_PHASE, Obj: response.data });
		}).catch(function (error) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
			throw error;
		});
	};
};

/***/ }),

/***/ 522:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.setPopulation = exports.getPopulation = exports.GET_POPULATION = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _Utils = __webpack_require__(2);

var Utils = _interopRequireWildcard(_Utils);

var _AgeRanges = __webpack_require__(523);

var _AgeRanges2 = _interopRequireDefault(_AgeRanges);

var _ClientHttpRequest = __webpack_require__(5);

var _ClientHttpRequest2 = _interopRequireDefault(_ClientHttpRequest);

var _immutable = __webpack_require__(1);

var _immutable2 = _interopRequireDefault(_immutable);

var _SocioeconomicRanges = __webpack_require__(524);

var _SocioeconomicRanges2 = _interopRequireDefault(_SocioeconomicRanges);

var _Modal = __webpack_require__(4);

var _Loading = __webpack_require__(3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var initialState = _immutable2.default.Map({}).set('Search', new _immutable2.default.List([])).set('Response', new _immutable2.default.Map({})).set('Get', new _immutable2.default.Map({}));

/* Types */
var GET_POPULATION = exports.GET_POPULATION = 'GET_POPULATION';

/* Reducer */

exports.default = function () {
	var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	var action = arguments[1];


	switch (action.type) {
		case GET_POPULATION:
			return state.set('Get', new _immutable2.default.Map(action.Obj));
		default:
			return state;
	}
};

/* Action Creators */

var getPopulation = exports.getPopulation = function getPopulation(form) {

	return function (dispatch) {

		var poblacionPorUbicacion = {
			numeroOrganizaciones: 0,
			tipoDonataria: "",
			etnias: "",
			recuperacionPromedio: "",
			atiendePoblacionIndigena: 0,
			atiendePersonasDiscapacidad: 0,
			apoyaOtrasOrganizaciones: 0,
			nombreOtrasOrganizaciones: "",
			tieneCriteriosSeleccion: 0,
			criteriosSeleccionDestinataria: ""
		};

		dispatch((0, _Loading.isLoading)(true));

		return new _ClientHttpRequest2.default({
			service: 'api/getPopulation',
			method: "POST",
			data: _extends({}, form),
			headers: Object.assign({ "Authorization": sessionStorage.access_token, "uid": sessionStorage.uid })
		}).request().then(function (response) {
			dispatch((0, _Loading.isLoading)(false));

			var data = response.data;

			var formPopulation = {};

			if (data.poblacion.poblacionEjercicioFiscal[0]) {

				var rangoEdad = [];

				if (data.poblacion.poblacionEjercicioFiscal[0].rangosEdades) {

					rangoEdad = data.poblacion.poblacionEjercicioFiscal[0].rangosEdades.rangoEdad.map(function (r) {
						return {
							rangoEdad: r.rangoEdad,
							subtotalMujeres: Number(r.subtotalMujeres),
							subtotalHombres: Number(r.subtotalHombres),
							subtotal: Number(r.subtotalMujeres) + Number(r.subtotalHombres) + Number(r.subtotalOtrosGeneros),
							esEliminado: r.esEliminado || false,
							subtotalOtrosGeneros: Number(r.subtotalOtrosGeneros),
							id: Utils.getUUID(),
							idRango: Utils.getItem(_AgeRanges2.default, { id: r.rangoEdad.id }).valor
						};
					});
				}

				var nivelSocioeconomico = [];

				if (data.poblacion.poblacionEjercicioFiscal[0].nivelesSocioeconomicos) {

					nivelSocioeconomico = data.poblacion.poblacionEjercicioFiscal[0].nivelesSocioeconomicos.nivelSocioeconomico.map(function (n) {
						var nivelTemp = {
							rangoSocioeconomico: n.rangoSocioeconomico,
							numeroPersonas: Number(n.numeroPersonas),
							esEliminado: n.esEliminado || false,
							numeroHombres: Number(n.numeroHombres),
							numeroMujeres: Number(n.numeroMujeres),
							numeroOtrosGeneros: Number(n.numeroOtrosGeneros),
							id: Utils.getUUID(),
							range: Utils.getItem(_SocioeconomicRanges2.default, { id: n.rangoSocioeconomico.id }).valor
						};
						if (nivelTemp.numeroHombres === 0 && nivelTemp.numeroMujeres === 0 && nivelTemp.numeroOtrosGeneros === 0) nivelTemp.numeroHombres = nivelTemp.numeroPersonas;
						return nivelTemp;
					});
				}

				var radio = data.poblacion.poblacionEjercicioFiscal[0].poblacionPorUbicacion.tipoDonataria || "";
				var indigenousAttention = data.poblacion.poblacionEjercicioFiscal[0].poblacionPorUbicacion.etnias || "";
				var recoveryFree = data.poblacion.poblacionEjercicioFiscal[0].poblacionPorUbicacion.recuperacionPromedio || "";

				formPopulation = {
					uniqueId: Utils.getUUID(),
					rangoEdad: rangoEdad,
					nivelSocioeconomico: nivelSocioeconomico,
					supports: data.poblacion.poblacionEjercicioFiscal[0].poblacionPorUbicacion.numeroOrganizaciones || "",
					radio: radio === "Primer piso" ? 1 : radio === "Segundo piso" ? 2 : radio === "Mixta" ? 3 : 0,
					indigenousAttention: indigenousAttention === "" ? false : true,
					specifyEtnies: indigenousAttention,
					recoveryFree: recoveryFree === "" ? false : true,
					average: recoveryFree,
					poblacionPorUbicacion: _extends({}, poblacionPorUbicacion, data.poblacion.poblacionEjercicioFiscal[0].poblacionPorUbicacion)

					// para las donatarias que ya existen, si las etnias vienen con datos, se escoge la pregunta de radio button como Si
				};if (formPopulation.poblacionPorUbicacion.etnias) formPopulation.poblacionPorUbicacion.atiendePoblacionIndigena = 1;
			}

			dispatch({ type: GET_POPULATION, Obj: formPopulation });
		}).catch(function (error) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
			throw error;
		});
	};
};

var setPopulation = exports.setPopulation = function setPopulation(form) {

	return function (dispatch) {

		dispatch((0, _Loading.isLoading)(true));

		return new _ClientHttpRequest2.default({
			service: 'api/setPopulation',
			method: "POST",
			data: _extends({}, form),
			headers: Object.assign({ "Authorization": sessionStorage.access_token, "uid": sessionStorage.uid })
		}).request().then(function (response) {
			dispatch((0, _Loading.isLoading)(false));
			return response.data;
		}).catch(function (error) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
			throw error;
		});
	};
};

/***/ }),

/***/ 523:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = [{ id: 1, valor: "0 - 1" }, { id: 11, valor: "1 - 6" }, { id: 21, valor: "6 - 12" }, { id: 31, valor: "12 - 15" }, { id: 41, valor: "15 - 18" }, { id: 51, valor: "18 - 30" }, { id: 61, valor: "30 - 60" }, { id: 71, valor: "+  60" }];

/***/ }),

/***/ 524:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = [{ id: 1, valor: "Pobreza Extrema" }, { id: 31, valor: "Pobreza" }, { id: 11, valor: "Media" }, { id: 21, valor: " Alta" }];

/***/ }),

/***/ 525:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.clearStateEvent = exports.searchStateEvent = exports.ACTION_SEARCH_STATE_EVENT = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _Utils = __webpack_require__(2);

var Utils = _interopRequireWildcard(_Utils);

var _ClientHttpRequest = __webpack_require__(5);

var _ClientHttpRequest2 = _interopRequireDefault(_ClientHttpRequest);

var _immutable = __webpack_require__(1);

var _immutable2 = _interopRequireDefault(_immutable);

var _Modal = __webpack_require__(4);

var _Loading = __webpack_require__(3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var initialState = _immutable2.default.Map({}).set('Search', new _immutable2.default.List([])).set('Response', new _immutable2.default.Map({})).set('Get', new _immutable2.default.Map({}));

/* Types */

var ACTION_SEARCH_STATE_EVENT = exports.ACTION_SEARCH_STATE_EVENT = 'ACTION_SEARCH_STATE_EVENT';

/* Reducer */

exports.default = function () {
	var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	var action = arguments[1];


	switch (action.type) {
		case ACTION_SEARCH_STATE_EVENT:
			return state.set('Search', new _immutable2.default.List(action.Obj));
		default:
			return state;
	}
};

/* Action Creators */

var searchStateEvent = exports.searchStateEvent = function searchStateEvent(form) {

	Utils.clearNullAndEmpty(form);

	return function (dispatch) {

		dispatch((0, _Loading.isLoading)(true));

		return new _ClientHttpRequest2.default({
			service: 'api/searchStateEvent',
			method: "POST",
			data: _extends({}, form),
			headers: Object.assign({ "Authorization": sessionStorage.access_token, "uid": sessionStorage.uid })
		}).request().then(function (response) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch({ type: ACTION_SEARCH_STATE_EVENT, Obj: response.data });
		}).catch(function (error) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
			throw error;
		});
	};
};

var clearStateEvent = exports.clearStateEvent = function clearStateEvent() {
	return function (dispatch) {
		dispatch({ type: ACTION_SEARCH_STATE_EVENT, Obj: [] });
	};
};

/***/ }),

/***/ 526:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.beginProcess = exports.getSummary = exports.SET_SUMMARY = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _Utils = __webpack_require__(2);

var Utils = _interopRequireWildcard(_Utils);

var _ClientHttpRequest = __webpack_require__(5);

var _ClientHttpRequest2 = _interopRequireDefault(_ClientHttpRequest);

var _immutable = __webpack_require__(1);

var _immutable2 = _interopRequireDefault(_immutable);

var _Modal = __webpack_require__(4);

var _Loading = __webpack_require__(3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var initialState = _immutable2.default.Map({});

/* Types */
var SET_SUMMARY = exports.SET_SUMMARY = 'SET_SUMMARY';

/* Reducer */

exports.default = function () {
	var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	var action = arguments[1];


	switch (action.type) {
		case SET_SUMMARY:
			return new _immutable2.default.Map(action.Obj);
		default:
			return state;
	}
};

/* Action Creators */

var getSummary = exports.getSummary = function getSummary(form) {

	return function (dispatch) {

		dispatch((0, _Loading.isLoading)(true));

		return new _ClientHttpRequest2.default({
			service: 'api/getSummary',
			method: "POST",
			data: form,
			headers: Object.assign({ "Authorization": sessionStorage.access_token, "uid": sessionStorage.uid, "n": localStorage.n })
		}).request().then(function (response) {
			dispatch((0, _Loading.isLoading)(false));
			response.data = Utils.ds_(response.data.reference);
			dispatch({ type: SET_SUMMARY, Obj: response.data });
		}).catch(function (error) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
			throw error;
		});
	};
};

var beginProcess = exports.beginProcess = function beginProcess(form) {

	return function (dispatch) {

		dispatch((0, _Loading.isLoading)(true));

		return new _ClientHttpRequest2.default({
			service: 'api/beginProcess',
			method: "POST",
			data: _extends({}, form),
			headers: Object.assign({ "Authorization": sessionStorage.access_token, "uid": sessionStorage.uid })
		}).request().then(function () {
			dispatch((0, _Loading.isLoading)(false));
		}).catch(function (error) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
			throw error;
		});
	};
};
// pendiente encriptar en mid con llave de usuario

/***/ }),

/***/ 527:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.clearTemplLetters = exports.deleteTemplLetters = exports.getTemplLetters = exports.searchTemplLetters = exports.addTemplLetters = exports.ACTION_UPDATE_LETTERS_STATUS = exports.ACTION_DELETE_LETTERS_STATUS = exports.ACTION_GET_LETTERS_STATUS = exports.ACTION_SEARCH_LETTERS_STATUS = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _Utils = __webpack_require__(2);

var Utils = _interopRequireWildcard(_Utils);

var _ClientHttpRequest = __webpack_require__(5);

var _ClientHttpRequest2 = _interopRequireDefault(_ClientHttpRequest);

var _immutable = __webpack_require__(1);

var _immutable2 = _interopRequireDefault(_immutable);

var _Modal = __webpack_require__(4);

var _Loading = __webpack_require__(3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var initialState = _immutable2.default.Map({}).set('Search', new _immutable2.default.List([])).set('Response', new _immutable2.default.Map({})).set('Get', new _immutable2.default.Map({}));

/* Types */
var ACTION_SEARCH_LETTERS_STATUS = exports.ACTION_SEARCH_LETTERS_STATUS = 'ACTION_SEARCH_LETTERS_STATUS';
var ACTION_GET_LETTERS_STATUS = exports.ACTION_GET_LETTERS_STATUS = 'ACTION_GET_LETTERS_STATUS';
var ACTION_DELETE_LETTERS_STATUS = exports.ACTION_DELETE_LETTERS_STATUS = 'ACTION_DELETE_LETTERS_STATUS';
var ACTION_UPDATE_LETTERS_STATUS = exports.ACTION_UPDATE_LETTERS_STATUS = 'ACTION_UPDATE_LETTERS_STATUS';

/* Reducer */

exports.default = function () {
	var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	var action = arguments[1];

	switch (action.type) {
		case ACTION_SEARCH_LETTERS_STATUS:
			return state.set('Search', new _immutable2.default.List(action.Obj));
		case ACTION_GET_LETTERS_STATUS:
			return state.set('Get', new _immutable2.default.Map(action.Obj));
		case ACTION_DELETE_LETTERS_STATUS:
			return state.set('Response', new _immutable2.default.Map(action.Obj));
		case ACTION_UPDATE_LETTERS_STATUS:
			return state.set('Response', new _immutable2.default.Map(action.Obj));
		default:
			return state;
	}
};

/* Action Creators */


var addTemplLetters = exports.addTemplLetters = function addTemplLetters(form) {

	var temp = {
		id: form.idTemplLetter || 0,
		deleted: form.state === 1 ? false : true,
		nombre: form.nombre,
		rutaLogotipo1: form.logo1,
		rutaLogotipo2: form.logo2,
		texto: form.logodescription,
		para: form.logopara,
		cuerpo: form.textEditor || null,
		firma1: form.signatureFullName1 + '<br>' + form.position1,
		firma2: form.signatureFullName2 + '<br>' + form.position2,
		ccp: form.ccp,
		piePagina: form.footer
	};

	return function (dispatch) {
		dispatch((0, _Loading.isLoading)(true));
		return new _ClientHttpRequest2.default({
			service: temp.id ? 'api/updateTemplLetters' : 'api/newTemplLetters',
			method: "POST",
			data: _extends({}, temp),
			headers: Object.assign({ "Authorization": sessionStorage.access_token, "uid": sessionStorage.uid })
		}).request().then(function () {
			dispatch((0, _Loading.isLoading)(false));
			dispatch((0, _Modal.createModal)(Utils.successMessage()));
		}).catch(function (error) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
			throw error;
		});
	};
};

var searchTemplLetters = exports.searchTemplLetters = function searchTemplLetters(form) {
	Utils.clearNullAndEmpty(form);

	var temp = {
		deleted: form.state === 1 ? false : form.state === 2 ? true : null,
		nombre: form.nombre
	};

	return function (dispatch) {
		dispatch((0, _Loading.isLoading)(true));
		return new _ClientHttpRequest2.default({
			service: Object.keys(form).length === 0 ? 'api/searchTemplLetters' : 'api/searchParamTemplLetters',
			method: "POST",
			data: _extends({}, temp),
			headers: Object.assign({ "Authorization": sessionStorage.access_token, "uid": sessionStorage.uid })
		}).request().then(function (response) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch({ type: ACTION_SEARCH_LETTERS_STATUS, Obj: response.data });
		}).catch(function (error) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
			throw error;
		});
	};
};

var getTemplLetters = exports.getTemplLetters = function getTemplLetters(id) {
	return function (dispatch) {
		dispatch((0, _Loading.isLoading)(true));
		return new _ClientHttpRequest2.default({
			service: 'api/getTemplLetters',
			method: "POST",
			data: { id: id },
			headers: Object.assign({ "Authorization": sessionStorage.access_token, "uid": sessionStorage.uid })
		}).request().then(function (response) {

			var data = response.data;

			var firma1 = void 0,
			    firma2 = void 0,
			    firmaNombre1 = void 0,
			    firmaPosicion1 = void 0,
			    firmaNombre2 = void 0,
			    firmaPosicion2 = void 0;

			if (data.firma1 !== null && data.firma1 !== undefined) {

				firma1 = data.firma1.split('<br>');

				if (firma1[2]) {
					firmaNombre1 = firma1[2];
				} else {
					firmaNombre1 = firma1[0];
				}
				if (firma1[3]) {
					firmaPosicion1 = firma1[3];
				} else {
					firmaPosicion1 = firma1[1];
				}
			}
			if (data.firma2 !== null && data.firma2 !== undefined) {

				firma2 = data.firma2.split('<br>');

				if (firma2[2]) {
					firmaNombre2 = firma2[2];
				} else {
					firmaNombre2 = firma2[0];
				}
				if (firma2[3]) {
					firmaPosicion2 = firma2[3];
				} else {
					firmaPosicion2 = firma2[1];
				}
			}

			var obj = {
				uniqueId: Utils.getUUID(),
				idTemplLetter: data.id,
				state: data.deleted === false ? 1 : 2,
				nombre: data.nombre,
				logo1: data.rutaLogotipo1 !== null ? data.rutaLogotipo1.trim() : data.rutaLogotipo1,
				logo2: data.rutaLogotipo2 !== null ? data.rutaLogotipo2.trim() : data.rutaLogotipo2,
				logodescription: data.texto,
				logopara: data.para !== null ? data.para.trim() : data.para,
				textEditor: data.cuerpo,
				signatureFullName1: firmaNombre1,
				position1: firmaPosicion1,
				signatureFullName2: firmaNombre2,
				position2: firmaPosicion2,
				ccp: data.ccp,
				footer: data.piePagina
			};

			dispatch({ type: ACTION_GET_LETTERS_STATUS, Obj: obj });
			dispatch((0, _Loading.isLoading)(false));
		}).catch(function (error) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
			throw error;
		});
	};
};

var deleteTemplLetters = exports.deleteTemplLetters = function deleteTemplLetters() {
	return function (dispatch) {
		return dispatch({ type: ACTION_DELETE_LETTERS_STATUS, Obj: { code: '', message: '' } });
	};
};

var clearTemplLetters = exports.clearTemplLetters = function clearTemplLetters() {
	return function (dispatch) {
		dispatch({ type: ACTION_GET_LETTERS_STATUS, Obj: {} });
		dispatch({ type: ACTION_SEARCH_LETTERS_STATUS, Obj: [] });
	};
};

/***/ }),

/***/ 528:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.setActiveKey = exports.clearGranteeFilter = exports.getGranteesFilterByEvaluation = exports.getFiltersFilterByEvaluation = exports.getEvaluationsFilterByEvaluation = exports.SET_ACTIVE_KEY = exports.GET_GRANTEES_FILTER = exports.GET_FILTER_FILTER = exports.GET_EVALUATIONS_FILTER = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _Utils = __webpack_require__(2);

var Utils = _interopRequireWildcard(_Utils);

var _ClientHttpRequest = __webpack_require__(5);

var _ClientHttpRequest2 = _interopRequireDefault(_ClientHttpRequest);

var _immutable = __webpack_require__(1);

var _immutable2 = _interopRequireDefault(_immutable);

var _Modal = __webpack_require__(4);

var _Loading = __webpack_require__(3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var initialState = _immutable2.default.Map({}).set('GetEvaluations', new _immutable2.default.Map({ evaluaciones: { evaluacion: [] } })).set('GetFilters', new _immutable2.default.List([])).set('GetGrantees', new _immutable2.default.Map({ donatariaEvaluacion: [] })).set('ActiveKey', new _immutable2.default.Map({ activeKey: 1 }));

/* Types */

var GET_EVALUATIONS_FILTER = exports.GET_EVALUATIONS_FILTER = 'GET_EVALUATIONS_FILTER';
var GET_FILTER_FILTER = exports.GET_FILTER_FILTER = 'GET_FILTER_FILTER';
var GET_GRANTEES_FILTER = exports.GET_GRANTEES_FILTER = 'GET_GRANTEES_FILTER';
var SET_ACTIVE_KEY = exports.SET_ACTIVE_KEY = 'SET_ACTIVE_KEY';

/* Reducer */

exports.default = function () {
	var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	var action = arguments[1];

	switch (action.type) {
		case GET_EVALUATIONS_FILTER:
			return state.set('GetEvaluations', new _immutable2.default.Map(action.Obj));
		case GET_FILTER_FILTER:
			return state.set('GetFilters', new _immutable2.default.List(action.Obj));
		case GET_GRANTEES_FILTER:
			return state.set('GetGrantees', new _immutable2.default.Map(action.Obj));
		case SET_ACTIVE_KEY:
			return state.set('ActiveKey', new _immutable2.default.Map(action.Obj));
		default:
			return state;
	}
};

/* Action Creators */

var getEvaluationsFilterByEvaluation = exports.getEvaluationsFilterByEvaluation = function getEvaluationsFilterByEvaluation() {

	return function (dispatch) {

		dispatch((0, _Loading.isLoading)(true));

		return new _ClientHttpRequest2.default({
			service: 'api/getEvaluationsFilterByEvaluation',
			method: "POST",
			data: {},
			headers: Object.assign({ "Authorization": sessionStorage.access_token, "uid": sessionStorage.uid })
		}).request().then(function (response) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch({ type: GET_EVALUATIONS_FILTER, Obj: response.data });
		}).catch(function (error) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
			throw error;
		});
	};
};

var getFiltersFilterByEvaluation = exports.getFiltersFilterByEvaluation = function getFiltersFilterByEvaluation() {

	return function (dispatch) {

		dispatch((0, _Loading.isLoading)(true));

		return new _ClientHttpRequest2.default({
			service: 'api/getFiltersFilterByEvaluation',
			method: "POST",
			data: {},
			headers: Object.assign({ "Authorization": sessionStorage.access_token, "uid": sessionStorage.uid })
		}).request().then(function (response) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch({ type: GET_FILTER_FILTER, Obj: response.data });
		}).catch(function (error) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
			throw error;
		});
	};
};

var getGranteesFilterByEvaluation = exports.getGranteesFilterByEvaluation = function getGranteesFilterByEvaluation(form) {

	delete form.item;
	return function (dispatch) {

		dispatch((0, _Loading.isLoading)(true));

		return new _ClientHttpRequest2.default({
			service: 'api/getGranteesFilterByEvaluation',
			method: "POST",
			data: _extends({}, form),
			headers: Object.assign({ "Authorization": sessionStorage.access_token, "uid": sessionStorage.uid })
		}).request().then(function (response) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch({ type: GET_GRANTEES_FILTER, Obj: response.data });
		}).catch(function (error) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
			throw error;
		});
	};
};

var clearGranteeFilter = exports.clearGranteeFilter = function clearGranteeFilter() {
	return function (dispatch) {
		dispatch({ type: GET_GRANTEES_FILTER, Obj: { donatariaEvaluacion: [] } });
	};
};

var setActiveKey = exports.setActiveKey = function setActiveKey(activeKey) {
	return function (dispatch) {
		dispatch({ type: SET_ACTIVE_KEY, Obj: _extends({}, activeKey) });
	};
};

/***/ }),

/***/ 529:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.corridasDonatariaNotification = exports.enviarNotificacion = exports.imprimirNotificacion = exports.estpagoNotificacion = exports.estappNotificacion = exports.catalogoresNotificacion = exports.estadodonNotificacion = exports.grupoNotificacion = exports.corridaNotificacion = exports.consultorNotificacion = exports.organismoregNotificacion = exports.donanteNotificacion = exports.donatariaNotificacion = exports.tiposEnvio = exports.plantillas = exports.tiposNotificacion = exports.ACTION_PRINT_NOTIFICATION = exports.ACTION_CORRIDAS_DONATARIA = exports.ACTION_ENVIAR_NOTIFICACION = exports.ACTION_IMPRIMIR_NOTIFICACION = exports.ACTION_ESTPAGO_NOTIFICACION = exports.ACTION_ESTAPP_NOTIFICACION = exports.ACTION_CATALOGORES_NOTIFICACION = exports.ACTION_ESTADODON_NOTIFICACION = exports.ACTION_GRUPO_NOTIFICACION = exports.ACTION_CORRIDA_NOTIFICACION = exports.ACTION_CONSULTOR_NOTIFICACION = exports.ACTION_ORGANISMOREG_NOTIFICACION = exports.ACTION_DONANTE_NOTIFICACION = exports.ACTION_DONATARIA_NOTIFICACION = exports.ACTION_TIPOS_ENVIO = exports.ACTION_PLANTILLAS = exports.ACTION_TIPOS_NOTIFICATION = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _Utils = __webpack_require__(2);

var Utils = _interopRequireWildcard(_Utils);

var _ClientHttpRequest = __webpack_require__(5);

var _ClientHttpRequest2 = _interopRequireDefault(_ClientHttpRequest);

var _immutable = __webpack_require__(1);

var _immutable2 = _interopRequireDefault(_immutable);

var _Modal = __webpack_require__(4);

var _Loading = __webpack_require__(3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var initialState = _immutable2.default.Map({}).set('Search', new _immutable2.default.List([])).set('plantilla', new _immutable2.default.List([])).set('envio', new _immutable2.default.List([])).set('donataria', new _immutable2.default.List([])).set('donante', new _immutable2.default.List([])).set('organismo', new _immutable2.default.List([])).set('consultor', new _immutable2.default.List([])).set('corrida', new _immutable2.default.List([])).set('grupo', new _immutable2.default.List([])).set('estado', new _immutable2.default.List([])).set('catalogo', new _immutable2.default.List([])).set('estadoApp', new _immutable2.default.List([])).set('estadoPago', new _immutable2.default.List([])).set('imprimir', new _immutable2.default.Map({})).set('enviar', new _immutable2.default.Map({})).set('corridas', new _immutable2.default.List([])).set('Uid', new _immutable2.default.Map({})).set('Socket', new _immutable2.default.Map({}));

/* Types */
var ACTION_TIPOS_NOTIFICATION = exports.ACTION_TIPOS_NOTIFICATION = 'ACTION_TIPOS_NOTIFICATION';
var ACTION_PLANTILLAS = exports.ACTION_PLANTILLAS = 'ACTION_PLANTILLAS';
var ACTION_TIPOS_ENVIO = exports.ACTION_TIPOS_ENVIO = 'ACTION_TIPOS_ENVIO';
var ACTION_DONATARIA_NOTIFICACION = exports.ACTION_DONATARIA_NOTIFICACION = 'ACTION_DONATARIA_NOTIFICACION';
var ACTION_DONANTE_NOTIFICACION = exports.ACTION_DONANTE_NOTIFICACION = 'ACTION_DONANTE_NOTIFICACION';
var ACTION_ORGANISMOREG_NOTIFICACION = exports.ACTION_ORGANISMOREG_NOTIFICACION = 'ACTION_ORGANISMOREG_NOTIFICACION';
var ACTION_CONSULTOR_NOTIFICACION = exports.ACTION_CONSULTOR_NOTIFICACION = 'ACTION_CONSULTOR_NOTIFICACION';
var ACTION_CORRIDA_NOTIFICACION = exports.ACTION_CORRIDA_NOTIFICACION = 'ACTION_CORRIDA_NOTIFICACION';
var ACTION_GRUPO_NOTIFICACION = exports.ACTION_GRUPO_NOTIFICACION = 'ACTION_GRUPO_NOTIFICACION';
var ACTION_ESTADODON_NOTIFICACION = exports.ACTION_ESTADODON_NOTIFICACION = 'ACTION_ESTADODON_NOTIFICACION';
var ACTION_CATALOGORES_NOTIFICACION = exports.ACTION_CATALOGORES_NOTIFICACION = 'ACTION_CATALOGORES_NOTIFICACION';
var ACTION_ESTAPP_NOTIFICACION = exports.ACTION_ESTAPP_NOTIFICACION = 'ACTION_ESTAPP_NOTIFICACION';
var ACTION_ESTPAGO_NOTIFICACION = exports.ACTION_ESTPAGO_NOTIFICACION = 'ACTION_ESTPAGO_NOTIFICACION';
var ACTION_IMPRIMIR_NOTIFICACION = exports.ACTION_IMPRIMIR_NOTIFICACION = 'ACTION_IMPRIMIR_NOTIFICACION';
var ACTION_ENVIAR_NOTIFICACION = exports.ACTION_ENVIAR_NOTIFICACION = "ACTION_ENVIAR_NOTIFICACION";
var ACTION_CORRIDAS_DONATARIA = exports.ACTION_CORRIDAS_DONATARIA = "ACTION_CORRIDAS_DONATARIA";
var ACTION_PRINT_NOTIFICATION = exports.ACTION_PRINT_NOTIFICATION = "ACTION_PRINT_NOTIFICATION";

/* Reducer*/

exports.default = function () {
	var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	var action = arguments[1];


	switch (action.type) {
		case ACTION_TIPOS_NOTIFICATION:
			return state.set('Search', new _immutable2.default.List(action.Obj));
		case ACTION_PLANTILLAS:
			return state.set('plantilla', new _immutable2.default.List(action.Obj));
		case ACTION_TIPOS_ENVIO:
			return state.set('envio', new _immutable2.default.List(action.Obj));
		case ACTION_DONATARIA_NOTIFICACION:
			return state.set('donataria', new _immutable2.default.List(action.Obj));
		case ACTION_DONANTE_NOTIFICACION:
			return state.set('donante', new _immutable2.default.List(action.Obj));
		case ACTION_ORGANISMOREG_NOTIFICACION:
			return state.set('organismo', new _immutable2.default.List(action.Obj));
		case ACTION_CONSULTOR_NOTIFICACION:
			return state.set('consultor', new _immutable2.default.List(action.Obj));
		case ACTION_CORRIDA_NOTIFICACION:
			return state.set('corrida', new _immutable2.default.List(action.Obj));
		case ACTION_GRUPO_NOTIFICACION:
			return state.set('grupo', new _immutable2.default.List(action.Obj));
		case ACTION_ESTADODON_NOTIFICACION:
			return state.set('estado', new _immutable2.default.List(action.Obj));
		case ACTION_CATALOGORES_NOTIFICACION:
			return state.set('catalogo', new _immutable2.default.List(action.Obj));
		case ACTION_ESTAPP_NOTIFICACION:
			return state.set('estadoApp', new _immutable2.default.List(action.Obj));
		case ACTION_ESTPAGO_NOTIFICACION:
			return state.set('estadoPago', new _immutable2.default.List(action.Obj));
		case ACTION_IMPRIMIR_NOTIFICACION:
			return state.set('imprimir', new _immutable2.default.Map(action.Obj));
		case ACTION_ENVIAR_NOTIFICACION:
			return state.set('enviar', new _immutable2.default.Map(action.Obj));
		case ACTION_CORRIDAS_DONATARIA:
			return state.set('corridas', new _immutable2.default.List(action.Obj));
		case ACTION_PRINT_NOTIFICATION:
			return state.set('Uid', new _immutable2.default.Map(action.Obj));
		default:
			return state;
	}
};

/* Action Creators */

var tiposNotificacion = exports.tiposNotificacion = function tiposNotificacion() {

	return function (dispatch) {
		dispatch((0, _Loading.isLoading)(true));

		return new _ClientHttpRequest2.default({
			service: 'api/tiposNotificacion',
			method: "POST",
			data: {},
			headers: Object.assign({ "Authorization": sessionStorage.access_token, "uid": sessionStorage.uid })
		}).request().then(function (response) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch({ type: ACTION_TIPOS_NOTIFICATION, Obj: response.data });
		}).catch(function (error) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
			throw error;
		});
	};
};

var plantillas = exports.plantillas = function plantillas() {

	return function (dispatch) {
		dispatch((0, _Loading.isLoading)(true));

		return new _ClientHttpRequest2.default({
			service: 'api/plantillas',
			method: "POST",
			data: {},
			headers: Object.assign({ "Authorization": sessionStorage.access_token, "uid": sessionStorage.uid })
		}).request().then(function (response) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch({ type: ACTION_PLANTILLAS, Obj: response.data });
		}).catch(function (error) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
			throw error;
		});
	};
};

var tiposEnvio = exports.tiposEnvio = function tiposEnvio() {
	return function (dispatch) {
		dispatch((0, _Loading.isLoading)(true));

		return new _ClientHttpRequest2.default({
			service: 'api/tiposEnvio',
			method: "POST",
			data: {},
			headers: Object.assign({ "Authorization": sessionStorage.access_token, "uid": sessionStorage.uid })
		}).request().then(function (response) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch({ type: ACTION_TIPOS_ENVIO, Obj: response.data });
		}).catch(function (error) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
			throw error;
		});
	};
};

var donatariaNotificacion = exports.donatariaNotificacion = function donatariaNotificacion() {
	return function (dispatch) {
		dispatch((0, _Loading.isLoading)(true));

		return new _ClientHttpRequest2.default({
			service: 'api/donatariaNotificacion',
			method: "POST",
			data: {},
			headers: Object.assign({ "Authorization": sessionStorage.access_token, "uid": sessionStorage.uid })
		}).request().then(function (response) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch({ type: ACTION_DONATARIA_NOTIFICACION, Obj: response.data });
		}).catch(function (error) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
			throw error;
		});
	};
};

var donanteNotificacion = exports.donanteNotificacion = function donanteNotificacion() {
	return function (dispatch) {
		dispatch((0, _Loading.isLoading)(true));

		return new _ClientHttpRequest2.default({
			service: 'api/donanteNotificacion',
			method: "POST",
			data: {},
			headers: Object.assign({ "Authorization": sessionStorage.access_token, "uid": sessionStorage.uid })
		}).request().then(function (response) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch({ type: ACTION_DONANTE_NOTIFICACION, Obj: response.data });
		}).catch(function (error) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
			throw error;
		});
	};
};

var organismoregNotificacion = exports.organismoregNotificacion = function organismoregNotificacion() {
	return function (dispatch) {
		dispatch((0, _Loading.isLoading)(true));

		return new _ClientHttpRequest2.default({
			service: 'api/organismoregNotificacion',
			method: "POST",
			data: {},
			headers: Object.assign({ "Authorization": sessionStorage.access_token, "uid": sessionStorage.uid })
		}).request().then(function (response) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch({ type: ACTION_ORGANISMOREG_NOTIFICACION, Obj: response.data });
		}).catch(function (error) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
			throw error;
		});
	};
};

var consultorNotificacion = exports.consultorNotificacion = function consultorNotificacion() {
	return function (dispatch) {
		dispatch((0, _Loading.isLoading)(true));

		return new _ClientHttpRequest2.default({
			service: 'api/consultorNotificacion',
			method: "POST",
			data: {},
			headers: Object.assign({ "Authorization": sessionStorage.access_token, "uid": sessionStorage.uid })
		}).request().then(function (response) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch({ type: ACTION_CONSULTOR_NOTIFICACION, Obj: response.data });
		}).catch(function (error) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
			throw error;
		});
	};
};

var corridaNotificacion = exports.corridaNotificacion = function corridaNotificacion() {

	return function (dispatch) {
		dispatch((0, _Loading.isLoading)(true));

		return new _ClientHttpRequest2.default({
			service: 'api/corridaNotificacion',
			method: "POST",
			data: {},
			headers: Object.assign({ "Authorization": sessionStorage.access_token, "uid": sessionStorage.uid })
		}).request().then(function (response) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch({ type: ACTION_CORRIDA_NOTIFICACION, Obj: response.data });
		}).catch(function (error) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
			throw error;
		});
	};
};

var grupoNotificacion = exports.grupoNotificacion = function grupoNotificacion() {
	return function (dispatch) {
		dispatch((0, _Loading.isLoading)(true));

		return new _ClientHttpRequest2.default({
			service: 'api/grupoNotificacion',
			method: "POST",
			data: {},
			headers: Object.assign({ "Authorization": sessionStorage.access_token, "uid": sessionStorage.uid })
		}).request().then(function (response) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch({ type: ACTION_GRUPO_NOTIFICACION, Obj: response.data });
		}).catch(function (error) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
			throw error;
		});
	};
};

var estadodonNotificacion = exports.estadodonNotificacion = function estadodonNotificacion() {
	return function (dispatch) {
		dispatch((0, _Loading.isLoading)(true));

		return new _ClientHttpRequest2.default({
			service: 'api/estadodonNotificacion',
			method: "POST",
			data: {},
			headers: Object.assign({ "Authorization": sessionStorage.access_token, "uid": sessionStorage.uid })
		}).request().then(function (response) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch({ type: ACTION_ESTADODON_NOTIFICACION, Obj: response.data });
		}).catch(function (error) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
			throw error;
		});
	};
};

var catalogoresNotificacion = exports.catalogoresNotificacion = function catalogoresNotificacion() {
	return function (dispatch) {
		dispatch((0, _Loading.isLoading)(true));

		return new _ClientHttpRequest2.default({
			service: 'api/catalogoresNotificacion',
			method: "POST",
			data: {},
			headers: Object.assign({ "Authorization": sessionStorage.access_token, "uid": sessionStorage.uid })
		}).request().then(function (response) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch({ type: ACTION_CATALOGORES_NOTIFICACION, Obj: response.data });
		}).catch(function (error) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
			throw error;
		});
	};
};

var estappNotificacion = exports.estappNotificacion = function estappNotificacion() {
	return function (dispatch) {
		dispatch((0, _Loading.isLoading)(true));

		return new _ClientHttpRequest2.default({
			service: 'api/estappNotificacion',
			method: "POST",
			data: {},
			headers: Object.assign({ "Authorization": sessionStorage.access_token, "uid": sessionStorage.uid })
		}).request().then(function (response) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch({ type: ACTION_ESTAPP_NOTIFICACION, Obj: response.data });
		}).catch(function (error) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
			throw error;
		});
	};
};

var estpagoNotificacion = exports.estpagoNotificacion = function estpagoNotificacion() {

	return function (dispatch) {
		dispatch((0, _Loading.isLoading)(true));

		return new _ClientHttpRequest2.default({
			service: 'api/estpagoNotificacion',
			method: "POST",
			data: {},
			headers: Object.assign({ "Authorization": sessionStorage.access_token, "uid": sessionStorage.uid })
		}).request().then(function (response) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch({ type: ACTION_ESTPAGO_NOTIFICACION, Obj: response.data });
		}).catch(function (error) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
			throw error;
		});
	};
};

var imprimirNotificacion = exports.imprimirNotificacion = function imprimirNotificacion(form /* ,option */) {

	var tmp = {
		asunto: form.asunto || null,
		catalogoResultadosSelected: form.catalogoSelected || null,
		consultorSelected: form.masiveFilter.selected.consultorSelected ? form.masiveFilter.selected.consultorSelected : form.individualFilter.consultorSelected ? form.individualFilter.consultorSelected : false,
		cuerpo: form.cuerpoDeTexto || null,
		declaracion: form.declaracion || null,
		donanteSelected: form.masiveFilter.selected.donanteSelected ? form.masiveFilter.selected.donanteSelected : form.individualFilter.donanteSelected ? form.individualFilter.donanteSelected : false,
		donatariaSelected: form.masiveFilter.selected.donatariaSelected ? form.masiveFilter.selected.donatariaSelected : form.individualFilter.donatariaSelected ? form.individualFilter.donatariaSelected : false,
		estatusAplicacionDelDonativoSelected: form.estatusAppSelected || null,
		estatusDonatariaSelected: form.estatusDonatariaSelected || null,
		estatusPagoSelected: form.estPagoSelected || null,
		figuraJuridicaSelected: form.figuraSelected || null,
		idCatalogoResultados: form.masiveFilter.filterOne.catalogoResultados || null,
		idConsultorSelected: form.individualFilter.Consultor || null,
		idCorrida: form.masiveFilter.Corrida ? form.masiveFilter.Corrida : form.individualFilter.corridasDeLaDonataria ? form.individualFilter.corridasDeLaDonataria : null,
		idDonanteSelected: form.individualFilter.Donante || null,
		idDonatariaSelected: form.individualFilter.donataria || null,
		idEstatusAplicacionDelDonativo: form.masiveFilter.filterOne.estAplnDonativo || null,
		idEstatusDonataria: form.masiveFilter.filterOne.EstatusDonataria || null,
		idEstatusPago: form.masiveFilter.filterOne.estPago || null,
		idFiguraJuridica: form.masiveFilter.filterOne.figuraJuridica || null,
		idGrupo: form.masiveFilter.Grupo || null,
		idOrganoReguladorSelected: form.individualFilter.OrgRegulador || null,
		idOtroActorSelected: form.individualFilter.Otros || null,
		idPlantillaCarta: form.Plantilla || null,
		idProgramaAsociado: form.valueSelected || null,
		idTipoEvio: form.TipoDeEnvio || null,
		idTipoNotificacion: form.TipoDeNotificacion || null,
		dropBoxIds: form.documents.map(function (d) {
			return d.documento.idDocumento;
		}),
		organoReguladorSelected: form.masiveFilter.selected.OrgReguladorSelected ? form.masiveFilter.selected.OrgReguladorSelected : form.individualFilter.OrgReguladorSelected ? form.individualFilter.OrgReguladorSelected : false,
		otrosActoresSelected: form.masiveFilter.selected.otrosSelected ? form.masiveFilter.selected.otrosSelected : form.individualFilter.otrosSelected ? form.individualFilter.otrosSelected : false,
		programaAsociadoSelected: form.progAsociadoSelected || null,
		showCorridas: form.corridaSelected || null,
		showGrupos: form.grupoSelected,
		todoElUniverso: false
	};

	return function (dispatch) {

		dispatch((0, _Loading.isLoading)(true));

		return new _ClientHttpRequest2.default({
			service: 'api/imprimirNotificacion',
			method: 'POST',
			data: _extends({}, tmp),
			headers: Object.assign({ "Authorization": sessionStorage.access_token, "uid": sessionStorage.iud })
		}).request().then(function (response) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch({ type: ACTION_PRINT_NOTIFICATION, Obj: response.data });
			return response;
		}).catch(function (error) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
			return error;
		});
	};
};

var enviarNotificacion = exports.enviarNotificacion = function enviarNotificacion(form /* ,option */) {

	var tmp = {
		asunto: form.asunto || null,
		catalogoResultadosSelected: form.catalogoSelected || null,
		consultorSelected: form.masiveFilter.selected.consultorSelected ? form.masiveFilter.selected.consultorSelected : form.individualFilter.consultorSelected ? form.individualFilter.consultorSelected : false,
		cuerpo: form.cuerpoDeTexto || null,
		declaracion: form.declaracion || null,
		donanteSelected: form.masiveFilter.selected.donanteSelected ? form.masiveFilter.selected.donanteSelected : form.individualFilter.donanteSelected ? form.individualFilter.donanteSelected : false,
		donatariaSelected: form.masiveFilter.selected.donatariaSelected ? form.masiveFilter.selected.donatariaSelected : form.individualFilter.donatariaSelected ? form.individualFilter.donatariaSelected : false,
		estatusAplicacionDelDonativoSelected: form.estatusAppSelected || null,
		estatusDonatariaSelected: form.estatusDonatariaSelected || null,
		estatusPagoSelected: form.estPagoSelected || null,
		figuraJuridicaSelected: form.figuraSelected || null,
		idCatalogoResultados: form.masiveFilter.filterOne.catalogoResultados || null,
		idConsultorSelected: form.individualFilter.Consultor || null,
		idCorrida: form.masiveFilter.Corrida ? form.masiveFilter.Corrida : form.individualFilter.corridasDeLaDonataria ? form.individualFilter.corridasDeLaDonataria : null,
		idDonanteSelected: form.individualFilter.Donante || null,
		idDonatariaSelected: form.individualFilter.donataria || null,
		idEstatusAplicacionDelDonativo: form.masiveFilter.filterOne.estAplnDonativo || null,
		idEstatusDonataria: form.masiveFilter.filterOne.EstatusDonataria || null,
		idEstatusPago: form.masiveFilter.filterOne.estPago || null,
		idFiguraJuridica: form.masiveFilter.filterOne.figuraJuridica || null,
		idGrupo: form.masiveFilter.Grupo || null,
		idOrganoReguladorSelected: form.individualFilter.OrgRegulador || null,
		idOtroActorSelected: form.individualFilter.Otros || null,
		idPlantillaCarta: form.Plantilla || null,
		idProgramaAsociado: form.valueSelected || null,
		idTipoEvio: form.TipoDeEnvio || null,
		idTipoNotificacion: form.TipoDeNotificacion || null,
		dropBoxIds: form.documents.map(function (d) {
			return d.documento.idDocumento;
		}),
		organoReguladorSelected: form.masiveFilter.selected.OrgReguladorSelected ? form.masiveFilter.selected.OrgReguladorSelected : form.individualFilter.OrgReguladorSelected ? form.individualFilter.OrgReguladorSelected : false,
		otrosActoresSelected: form.masiveFilter.selected.otrosSelected ? form.masiveFilter.selected.otrosSelected : form.individualFilter.otrosSelected ? form.individualFilter.otrosSelected : false,
		programaAsociadoSelected: form.progAsociadoSelected || null,
		showCorridas: form.corridaSelected || null,
		showGrupos: form.grupoSelected,
		todoElUniverso: false
	};

	return function (dispatch) {

		dispatch((0, _Loading.isLoading)(true));

		return new _ClientHttpRequest2.default({
			service: 'api/enviarNotificacion',
			method: 'POST',
			data: _extends({}, tmp),
			headers: Object.assign({ "Authorization": sessionStorage.access_token, "uid": sessionStorage.iud })
		}).request().then(function (response) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch({ type: ACTION_ENVIAR_NOTIFICACION, Obj: response.data });
			return response;
		}).catch(function (error) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
			return error;
		});
	};
};

var corridasDonatariaNotification = exports.corridasDonatariaNotification = function corridasDonatariaNotification(form) {

	return function (dispatch) {

		dispatch((0, _Loading.isLoading)(true));

		return new _ClientHttpRequest2.default({
			service: 'api/corridasDonatariaNotification',
			method: "POST",
			data: _extends({}, form),
			headers: Object.assign({ "Authorization": sessionStorage.access_token, "uid": sessionStorage.uid })
		}).request().then(function (response) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch({ type: ACTION_CORRIDAS_DONATARIA, Obj: response.data });
		}).catch(function (error) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
			throw error;
		});
	};
};

/***/ }),

/***/ 530:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.getCodeTemplLetters = exports.ACTION_GET_CODE_LETTERS_STATUS = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _Utils = __webpack_require__(2);

var Utils = _interopRequireWildcard(_Utils);

var _ClientHttpRequest = __webpack_require__(5);

var _ClientHttpRequest2 = _interopRequireDefault(_ClientHttpRequest);

var _immutable = __webpack_require__(1);

var _immutable2 = _interopRequireDefault(_immutable);

var _Modal = __webpack_require__(4);

var _Loading = __webpack_require__(3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var initialState = _immutable2.default.Map({}).set('Get', new _immutable2.default.List([]));

/* Types */
var ACTION_GET_CODE_LETTERS_STATUS = exports.ACTION_GET_CODE_LETTERS_STATUS = 'ACTION_GET_CODE_LETTERS_STATUS';

/* Reducer */

exports.default = function () {
	var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	var action = arguments[1];

	switch (action.type) {
		case ACTION_GET_CODE_LETTERS_STATUS:
			return state.set('Get', new _immutable2.default.List(action.Obj));
		default:
			return state;
	}
};

/* Action Creators */


var getCodeTemplLetters = exports.getCodeTemplLetters = function getCodeTemplLetters(form) {
	return function (dispatch) {
		dispatch((0, _Loading.isLoading)(true));
		return new _ClientHttpRequest2.default({
			service: 'api/getCodeTemplLetters',
			method: "POST",
			data: _extends({}, form),
			headers: Object.assign({ "Authorization": sessionStorage.access_token, "uid": sessionStorage.uid })
		}).request().then(function (response) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch({ type: ACTION_GET_CODE_LETTERS_STATUS, Obj: response.data });
		}).catch(function (error) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
			throw error;
		});
	};
};

/***/ }),

/***/ 531:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.clearContracts = exports.updateContractsInfo = exports.saveContracts = exports.getContract = exports.getContracts = exports.getGranteeContracts = exports.GET_GRANTEE_CONTRACTS = exports.GET_CONTRACTS = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _Utils = __webpack_require__(2);

var Utils = _interopRequireWildcard(_Utils);

var _ClientHttpRequest = __webpack_require__(5);

var _ClientHttpRequest2 = _interopRequireDefault(_ClientHttpRequest);

var _immutable = __webpack_require__(1);

var _Modal = __webpack_require__(4);

var _Loading = __webpack_require__(3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var initialState = (0, _immutable.Map)({}).set('Get', new _immutable.List([])).set('Contracts', new _immutable.List([]));

/* Types */
var GET_CONTRACTS = exports.GET_CONTRACTS = 'GET_CONTRACTS';
var GET_GRANTEE_CONTRACTS = exports.GET_GRANTEE_CONTRACTS = 'GET_GRANTEE_CONTRACTS';

/* Reducer */

exports.default = function () {
	var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	var action = arguments[1];


	switch (action.type) {
		case GET_CONTRACTS:
			return state.set('Get', new _immutable.List(action.Obj));
		case GET_GRANTEE_CONTRACTS:
			return state.set('Contracts', new _immutable.List(action.Obj));
		default:
			return state;
	}
};

/* Action Creators */

var getGranteeContracts = exports.getGranteeContracts = function getGranteeContracts(form) {

	return function (dispatch) {

		dispatch((0, _Loading.isLoading)(true));

		return new _ClientHttpRequest2.default({
			service: 'api/getGranteeContracts',
			method: "POST",
			data: _extends({}, form),
			headers: Object.assign({ "Authorization": sessionStorage.access_token, "uid": sessionStorage.uid })
		}).request().then(function (response) {
			dispatch((0, _Loading.isLoading)(false));
			var data = response.data;

			data = data.map(function (c) {
				var tipoContrato = c.tipoContrato;

				return {
					tmp: 'tmp',
					id: tipoContrato.id,
					tipoContrato: tipoContrato.tipoContrato,
					documento: { idDocumento: null },
					fase: { id: "contrato", uniqueId: Utils.getUUID() },
					idContrato: c.id,
					nombre: "",
					revisado: false
				};
			});
			dispatch({ type: GET_GRANTEE_CONTRACTS, Obj: data });
		}).catch(function (error) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
			throw error;
		});
	};
};

var getContracts = exports.getContracts = function getContracts(form) {

	return function (dispatch) {

		dispatch((0, _Loading.isLoading)(true));

		return new _ClientHttpRequest2.default({
			service: 'api/getContracts',
			method: "POST",
			data: _extends({}, form),
			headers: Object.assign({ "Authorization": sessionStorage.access_token, "uid": sessionStorage.uid })
		}).request().then(function (response) {
			dispatch((0, _Loading.isLoading)(false));

			var contratos = response.data.contratos.map(function (c) {

				return {
					id: c.idDonatariaContrato,
					idTipocontrato: c.tipoContrato.idContrato,
					tipoContrato: c.tipoContrato.tipoContrato,
					documento: { idDocumento: c.documentoDropbox && c.documentoDropbox.dropboxId ? c.documentoDropbox.dropboxId : null },
					fase: { id: "contrato" },
					contrato: c.tipoContrato.idContrato,
					nombre: c.documentoDropbox && c.documentoDropbox.nombre ? decodeURI(c.documentoDropbox.nombre) : null,
					revisado: c.revisado,
					idDocumento: c.documentoDropbox && c.documentoDropbox.documentoId ? c.documentoDropbox.documentoId : null
				};
			});

			dispatch({ type: GET_CONTRACTS, Obj: contratos });
		}).catch(function (error) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
			throw error;
		});
	};
};

var getContract = exports.getContract = function getContract(form) {

	return function (dispatch) {

		dispatch((0, _Loading.isLoading)(true));

		return new _ClientHttpRequest2.default({
			service: 'api/downloadContract',
			method: "POST",
			data: _extends({}, form),
			headers: Object.assign({ "Authorization": sessionStorage.access_token, "uid": sessionStorage.uid }),
			responseType: 'arraybuffer'
		}).request().then(function (response) {

			dispatch((0, _Loading.isLoading)(false));

			var blob = new Blob([response.data], { type: 'application/pdf' });
			var fileName = 'contratoDescarga-' + Utils.getToday() + '.pdf';
			var objectUrl = URL.createObjectURL(blob);
			var a = document.createElement('a');

			a.href = objectUrl;
			a.download = fileName;
			document.body.appendChild(a);
			a.click();

			document.body.removeChild(a);
			URL.revokeObjectURL(objectUrl);
		}).catch(function (error) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
			throw error;
		});
	};
};

var saveContracts = exports.saveContracts = function saveContracts(form) {

	form.autor = sessionStorage.uid;
	form.contratos = form.contratos.map(function (c /* , index */) {
		return {
			revisado: c.revisado || false,
			tipoContrato: {
				idContrato: c.id
			}
		};
	});

	return function (dispatch) {

		dispatch((0, _Loading.isLoading)(true));

		return new _ClientHttpRequest2.default({
			service: 'api/saveContracts',
			method: "POST",
			data: _extends({}, form),
			headers: Object.assign({ "Authorization": sessionStorage.access_token, "uid": sessionStorage.uid })
		}).request().then(function (response) {
			dispatch((0, _Loading.isLoading)(false));
			return response.data;
		}).catch(function (error) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
			throw error;
		});
	};
};

var updateContractsInfo = exports.updateContractsInfo = function updateContractsInfo(form) {

	var temp = {
		autor: sessionStorage.uid,
		contratos: form.contratos,
		idCorrida: form.idCorrida,
		idDonataria: form.idDonataria
	};

	return function (dispatch) {

		dispatch((0, _Loading.isLoading)(true));

		return new _ClientHttpRequest2.default({
			service: 'api/updateContractsInfo',
			method: "POST",
			data: _extends({}, temp),
			headers: Object.assign({ "Authorization": sessionStorage.access_token, "uid": sessionStorage.uid })
		}).request().then(function (response) {
			dispatch((0, _Loading.isLoading)(false));
			return response.data;
		}).catch(function (error) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
			throw error;
		});
	};
};

var clearContracts = exports.clearContracts = function clearContracts() {
	return function (dispatch) {
		dispatch({ type: GET_CONTRACTS, Obj: [] });
	};
};

/***/ }),

/***/ 532:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.clearData = exports.liberarDonataria = exports.guardarDonataria = exports.corridaAsignacion = exports.corridaDelivery = exports.ACTION_LIBERAR_DONATARIA = exports.ACTION_GUARDAR_DONATARIA = exports.ACTION_CORRIDAS_ASIGNACION = exports.ACTION_GET_CORRIDA = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _Utils = __webpack_require__(2);

var Utils = _interopRequireWildcard(_Utils);

var _ClientHttpRequest = __webpack_require__(5);

var _ClientHttpRequest2 = _interopRequireDefault(_ClientHttpRequest);

var _immutable = __webpack_require__(1);

var _immutable2 = _interopRequireDefault(_immutable);

var _Modal = __webpack_require__(4);

var _Loading = __webpack_require__(3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var initialState = _immutable2.default.Map({}).set('Search', new _immutable2.default.List([])).set('Get', new _immutable2.default.List([])).set('Update', new _immutable2.default.Map({})).set('UpdateFree', new _immutable2.default.Map({}));

/*Types*/
var ACTION_GET_CORRIDA = exports.ACTION_GET_CORRIDA = "ACTION_GET_CORRIDA";
var ACTION_CORRIDAS_ASIGNACION = exports.ACTION_CORRIDAS_ASIGNACION = "ACTION_CORRIDAS_ASIGNACION";
var ACTION_GUARDAR_DONATARIA = exports.ACTION_GUARDAR_DONATARIA = "ACTION_GUARDAR_DONATARIA";
var ACTION_LIBERAR_DONATARIA = exports.ACTION_LIBERAR_DONATARIA = "ACTION_LIBERAR_DONATARIA";
/*Reducer*/

exports.default = function () {
	var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	var action = arguments[1];


	switch (action.type) {
		case ACTION_GET_CORRIDA:
			return state.set('Search', new _immutable2.default.List(action.Obj));
		case ACTION_CORRIDAS_ASIGNACION:
			return state.set('Get', new _immutable2.default.List(action.Obj));
		case ACTION_GUARDAR_DONATARIA:
			return state.set('Update', new _immutable2.default.Map(action.Obj));
		case ACTION_LIBERAR_DONATARIA:
			return state.set('UpdateFree', new _immutable2.default.Map(action.Obj));
		default:
			return state;
	}
};

/*Action Creators*/

var corridaDelivery = exports.corridaDelivery = function corridaDelivery() {

	return function (dispatch) {
		dispatch((0, _Loading.isLoading)(true));

		return new _ClientHttpRequest2.default({
			service: 'api/corridaDelivery',
			method: 'POST',
			data: {},
			headers: Object.assign({ "Authorization": sessionStorage.access_token, "uid": sessionStorage.uid })
		}).request().then(function (response) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch({ type: ACTION_GET_CORRIDA, Obj: response.data });
		}).catch(function (error) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
			throw error;
		});
	};
};

var corridaAsignacion = exports.corridaAsignacion = function corridaAsignacion(form) {

	return function (dispatch) {
		dispatch((0, _Loading.isLoading)(true));

		return new _ClientHttpRequest2.default({
			service: 'api/corridaAsignacion',
			method: 'POST',
			data: _extends({}, form),
			headers: Object.assign({ 'Authorization': sessionStorage.access_token, 'uid': sessionStorage.uid })
		}).request().then(function (response) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch({ type: ACTION_CORRIDAS_ASIGNACION, Obj: response.data });
		}).catch(function (error) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
			throw error;
		});
	};
};

var guardarDonataria = exports.guardarDonataria = function guardarDonataria(form) {

	var donatariasAsignacion = form.dataT.map(function (a) {
		return {
			comentario: a.comentario || "",
			createdByComentario: sessionStorage.uid,
			createdDateComentario: new Date().toISOString().slice(0, 10),
			idCondicionPago: a.liberar === true ? 1 : a.condicionar === true ? 2 : null,
			idTipoPago: "",
			idDonataria: a.idDonataria
		};
	});

	var tmp = {
		donatariasAsignacion: donatariasAsignacion,
		idCorrida: form.corridasDelivery
	};

	return function (dispatch) {
		dispatch((0, _Loading.isLoading)(true));

		return new _ClientHttpRequest2.default({
			service: 'api/guardarDonataria',
			method: 'POST',
			data: _extends({}, tmp),
			headers: Object.assign({ 'Authorization': sessionStorage.access_token, 'uid': sessionStorage.uid })
		}).request().then(function (response) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch({ type: ACTION_GUARDAR_DONATARIA, Obj: response.data });
			return response;
		}).catch(function (error) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
			throw error;
		});
	};
};

var liberarDonataria = exports.liberarDonataria = function liberarDonataria(form) {

	var donatarias = [];

	form.dataT.forEach(function (a) {

		if (a.liberar || a.condicionar) {

			if (a.liberar && a.comentario) {
				a.comentario = "";
			}
			var obj = {
				idDonataria: a.idDonataria,
				nombreDonataria: a.donataria,
				nivelIntervencion: {
					tipo: {
						id: a.idNivel || 0,
						descripcion: a.nivelIntervencion
					},
					montoAutorizado: a.montoAutorizado,
					etapaFortalecimiento: a.etapaDelFortalecimiento || "",
					porcentajeAvancePlanTrabajo: a.porcentajeDeAvancePandeTrabajo || 0,
					totalTecnicasHerramientasConRetraso: a.totalDeTecnicasoHerramientasConRetraso || 0,
					tecnicasHerramientasConMayorRetraso: a.tecnicasOHerramientasConMayorRetraso || "",
					diasRetraso: a.diasDeRetraso || 0,
					liberar: a.liberar === true ? 1 : a.condicionar === true ? 2 : null
				},
				comentario: {
					usuario: sessionStorage.firstname + " " + sessionStorage.lastname,
					destinatario: 'donataria',
					comentario: a.comentario || "",
					seccion: 'Condiciones de entrega del donativo',
					activo: true
				}
			};
			donatarias.push(obj);
		}
	});

	var tmp = {
		donatarias: donatarias,
		idCorrida: form.corridasDelivery,
		descripcionOportunidad: form.corrida,
		supervisor: {
			idUsuario: sessionStorage.uid,
			nombreUsuario: sessionStorage.firstname + " " + sessionStorage.lastname
		}
	};

	return function (dispatch) {
		dispatch((0, _Loading.isLoading)(true));

		return new _ClientHttpRequest2.default({
			service: 'api/liberarDonataria',
			method: 'POST',
			data: _extends({}, tmp),
			headers: Object.assign({ 'Authorization': sessionStorage.access_token, "Bpm": sessionStorage.bpm_token, 'uid': sessionStorage.uid })
		}).request().then(function (response) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch({ type: ACTION_LIBERAR_DONATARIA, Obj: response.data });
			return response;
		}).catch(function (error) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
			throw error;
		});
	};
};

var clearData = exports.clearData = function clearData() {

	return function (dispatch) {
		dispatch({ type: ACTION_CORRIDAS_ASIGNACION, Obj: [] });
	};
};

/***/ }),

/***/ 533:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.clearPaymentRequirement = exports.deletePaymentRequirement = exports.getPaymentRequirement = exports.searchPaymentRequirement = exports.addPaymentRequirement = exports.ACTION_UPDATE_PAYMENT_REQUIREMENT_STATUS = exports.ACTION_DELETE_PAYMENT_REQUIREMENT_STATUS = exports.ACTION_GET_PAYMENT_REQUIREMENT_STATUS = exports.ACTION_SEARCH_PAYMENT_REQUIREMENT_STATUS = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _Utils = __webpack_require__(2);

var Utils = _interopRequireWildcard(_Utils);

var _ClientHttpRequest = __webpack_require__(5);

var _ClientHttpRequest2 = _interopRequireDefault(_ClientHttpRequest);

var _immutable = __webpack_require__(1);

var _immutable2 = _interopRequireDefault(_immutable);

var _Modal = __webpack_require__(4);

var _Loading = __webpack_require__(3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var initialState = _immutable2.default.Map({}).set('Search', new _immutable2.default.List([])).set('Response', new _immutable2.default.Map({})).set('Get', new _immutable2.default.Map({}));

/* Types */
var ACTION_SEARCH_PAYMENT_REQUIREMENT_STATUS = exports.ACTION_SEARCH_PAYMENT_REQUIREMENT_STATUS = 'ACTION_SEARCH_PAYMENT_REQUIREMENT_STATUS';
var ACTION_GET_PAYMENT_REQUIREMENT_STATUS = exports.ACTION_GET_PAYMENT_REQUIREMENT_STATUS = 'ACTION_GET_PAYMENT_REQUIREMENT_STATUS';
var ACTION_DELETE_PAYMENT_REQUIREMENT_STATUS = exports.ACTION_DELETE_PAYMENT_REQUIREMENT_STATUS = 'ACTION_DELETE_PAYMENT_REQUIREMENT_STATUS';
var ACTION_UPDATE_PAYMENT_REQUIREMENT_STATUS = exports.ACTION_UPDATE_PAYMENT_REQUIREMENT_STATUS = 'ACTION_UPDATE_PAYMENT_REQUIREMENT_STATUS';

/* Reducer */

exports.default = function () {
	var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	var action = arguments[1];

	switch (action.type) {
		case ACTION_SEARCH_PAYMENT_REQUIREMENT_STATUS:
			return state.set('Search', new _immutable2.default.List(action.Obj));
		case ACTION_GET_PAYMENT_REQUIREMENT_STATUS:
			return state.set('Get', new _immutable2.default.Map(action.Obj));
		case ACTION_DELETE_PAYMENT_REQUIREMENT_STATUS:
			return state.set('Response', new _immutable2.default.Map(action.Obj));
		case ACTION_UPDATE_PAYMENT_REQUIREMENT_STATUS:
			return state.set('Response', new _immutable2.default.Map(action.Obj));
		default:
			return state;
	}
};

/* Action Creators */


var addPaymentRequirement = exports.addPaymentRequirement = function addPaymentRequirement(form) {

	var temp = {
		id: form.id ? parseInt(form.id) : null,
		deleted: form.state === 1 ? false : form.state === 2 ? true : null,
		requisitoPago: form.requisitoPago || "",
		detalle: form.detalleRequisitoPago || "",
		tipoRequisitoPago: {
			id: form.tiposPago || null
		},
		createdBy: sessionStorage.uid
	};

	return function (dispatch) {
		dispatch((0, _Loading.isLoading)(true));
		return new _ClientHttpRequest2.default({
			service: temp.id ? 'api/updatePaymentRequirement' : 'api/newPaymentRequirement',
			method: "POST",
			data: _extends({}, temp),
			headers: Object.assign({ "Authorization": sessionStorage.access_token, "uid": sessionStorage.uid })
		}).request().then(function () {
			dispatch((0, _Loading.isLoading)(false));
			dispatch((0, _Modal.createModal)(Utils.successMessage()));
		}).catch(function (error) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
			throw error;
		});
	};
};

var searchPaymentRequirement = exports.searchPaymentRequirement = function searchPaymentRequirement(form) {
	Utils.clearNullAndEmpty(form);

	var temp = {
		deleted: form.state === 1 ? false : form.state === 2 ? true : null,
		id: form.id ? parseInt(form.id) : null,
		requisitoPago: form.requisitoPago || "",
		tipoRequisitoPago: {
			id: form.tiposPago || null
		}
	};

	return function (dispatch) {
		dispatch((0, _Loading.isLoading)(true));
		return new _ClientHttpRequest2.default({
			service: Object.keys(form).length === 0 ? 'api/searchPaymentRequirement' : 'api/searchParamPaymentRequirement',
			method: "POST",
			data: _extends({}, temp),
			headers: Object.assign({ "Authorization": sessionStorage.access_token, "uid": sessionStorage.uid })
		}).request().then(function (response) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch({ type: ACTION_SEARCH_PAYMENT_REQUIREMENT_STATUS, Obj: response.data });
		}).catch(function (error) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
			throw error;
		});
	};
};

var getPaymentRequirement = exports.getPaymentRequirement = function getPaymentRequirement(id) {
	return function (dispatch) {
		dispatch((0, _Loading.isLoading)(true));
		return new _ClientHttpRequest2.default({
			service: 'api/getPaymentRequirement',
			method: "POST",
			data: { id: id },
			headers: Object.assign({ "Authorization": sessionStorage.access_token, "uid": sessionStorage.uid })
		}).request().then(function (response) {

			var data = response.data;

			var obj = {
				uniqueId: Utils.getUUID(),
				id: data.id,
				state: data.deleted === false ? 1 : 2,
				requisitoPago: data.requisitoPago,
				tiposPago: data.tipoRequisitoPago.id,
				detalleRequisitoPago: data.detalle
			};

			dispatch({ type: ACTION_GET_PAYMENT_REQUIREMENT_STATUS, Obj: obj });
			dispatch((0, _Loading.isLoading)(false));
		}).catch(function (error) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
			throw error;
		});
	};
};

var deletePaymentRequirement = exports.deletePaymentRequirement = function deletePaymentRequirement() {
	return function (dispatch) {
		return dispatch({ type: ACTION_DELETE_PAYMENT_REQUIREMENT_STATUS, Obj: { code: '', message: '' } });
	};
};

var clearPaymentRequirement = exports.clearPaymentRequirement = function clearPaymentRequirement() {
	return function (dispatch) {
		dispatch({ type: ACTION_GET_PAYMENT_REQUIREMENT_STATUS, Obj: {} });
		dispatch({ type: ACTION_SEARCH_PAYMENT_REQUIREMENT_STATUS, Obj: [] });
	};
};

/***/ }),

/***/ 534:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.getTypePaymentRequirement = exports.ACTION_GET_TYPE_PAYMENT_REQUIREMENTS_STATUS = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _Utils = __webpack_require__(2);

var Utils = _interopRequireWildcard(_Utils);

var _ClientHttpRequest = __webpack_require__(5);

var _ClientHttpRequest2 = _interopRequireDefault(_ClientHttpRequest);

var _immutable = __webpack_require__(1);

var _immutable2 = _interopRequireDefault(_immutable);

var _Modal = __webpack_require__(4);

var _Loading = __webpack_require__(3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var initialState = _immutable2.default.Map({}).set('Get', new _immutable2.default.List([]));

/* Types */
var ACTION_GET_TYPE_PAYMENT_REQUIREMENTS_STATUS = exports.ACTION_GET_TYPE_PAYMENT_REQUIREMENTS_STATUS = 'ACTION_GET_TYPE_PAYMENT_REQUIREMENTS_STATUS';

/* Reducer */

exports.default = function () {
	var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	var action = arguments[1];

	switch (action.type) {
		case ACTION_GET_TYPE_PAYMENT_REQUIREMENTS_STATUS:
			return state.set('Get', new _immutable2.default.List(action.Obj));
		default:
			return state;
	}
};

/* Action Creators */


var getTypePaymentRequirement = exports.getTypePaymentRequirement = function getTypePaymentRequirement(form) {
	return function (dispatch) {
		dispatch((0, _Loading.isLoading)(true));
		return new _ClientHttpRequest2.default({
			service: 'api/getTypePaymentRequirement',
			method: "POST",
			data: _extends({}, form),
			headers: Object.assign({ "Authorization": sessionStorage.access_token, "uid": sessionStorage.uid })
		}).request().then(function (response) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch({ type: ACTION_GET_TYPE_PAYMENT_REQUIREMENTS_STATUS, Obj: response.data });
		}).catch(function (error) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
			throw error;
		});
	};
};

/***/ }),

/***/ 535:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.saveDocumentsAndLegalReps = exports.TYPE = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _Utils = __webpack_require__(2);

var Utils = _interopRequireWildcard(_Utils);

var _ClientHttpRequest = __webpack_require__(5);

var _ClientHttpRequest2 = _interopRequireDefault(_ClientHttpRequest);

var _immutable = __webpack_require__(1);

var _Modal = __webpack_require__(4);

var _Loading = __webpack_require__(3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var initialState = (0, _immutable.Map)({}).set('Get', new _immutable.List([]));

/* Types */
var TYPE = exports.TYPE = 'TYPE';

/* Reducer */

exports.default = function () {
	var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	var action = arguments[1];


	switch (action.type) {
		case TYPE:
			return state.set('Get', new _immutable.List(action.Obj));
		default:
			return state;
	}
};

/* Action Creators */

var saveDocumentsAndLegalReps = exports.saveDocumentsAndLegalReps = function saveDocumentsAndLegalReps(form) {

	var documentos = form.documentos.map(function (d) {
		return {
			idDocumento: d.tipo.id,
			idFase: d.fase.id,
			revisado: d.revisado || false
		};
	});

	var representanteLegal = form.representanteLegal.map(function (r) {
		return {
			idRepresentanteLegal: r.idRepresetanteLegal,
			revisado: r.revisado || false
		};
	});

	var temp = {
		usuario: sessionStorage.uid,
		documentosRegistro: documentos,
		idDonataria: form.idDonataria,
		representantesLegales: representanteLegal
	};

	return function (dispatch) {

		dispatch((0, _Loading.isLoading)(true));

		return new _ClientHttpRequest2.default({
			service: 'api/saveDocumentsAndLegalReps',
			method: "POST",
			data: _extends({}, temp),
			headers: Object.assign({ "Authorization": sessionStorage.access_token, "uid": sessionStorage.uid })
		}).request().then(function (response) {
			dispatch((0, _Loading.isLoading)(false));
			return response.data;
		}).catch(function (error) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
			throw error;
		});
	};
};

/***/ }),

/***/ 536:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.clearRequirements = exports.saveRequirements = exports.deleteBankInfo = exports.saveBankInfo = exports.getRequirementDocuments = exports.BANK_ACCOUNT_INFO = exports.GET_REQUIREMENT_DOCS = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _Utils = __webpack_require__(2);

var Utils = _interopRequireWildcard(_Utils);

var _ClientHttpRequest = __webpack_require__(5);

var _ClientHttpRequest2 = _interopRequireDefault(_ClientHttpRequest);

var _immutable = __webpack_require__(1);

var _Modal = __webpack_require__(4);

var _Loading = __webpack_require__(3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var initialState = (0, _immutable.Map)({}).set('Get', new _immutable.Map({})).set('Response', new _immutable.Map({}));

/* Types */
var GET_REQUIREMENT_DOCS = exports.GET_REQUIREMENT_DOCS = 'GET_REQUIREMENT_DOCS';
var BANK_ACCOUNT_INFO = exports.BANK_ACCOUNT_INFO = 'BANK_ACCOUNT_INFO';

/* Reducer */

exports.default = function () {
	var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	var action = arguments[1];


	switch (action.type) {
		case GET_REQUIREMENT_DOCS:
			return state.set('Get', new _immutable.Map(action.Obj));
		case BANK_ACCOUNT_INFO:
			return state.set('Response', new _immutable.Map(action.Obj));
		default:
			return state;
	}
};

/* Action Creators */

var getRequirementDocuments = exports.getRequirementDocuments = function getRequirementDocuments(form) {

	return function (dispatch) {

		dispatch((0, _Loading.isLoading)(true));

		return new _ClientHttpRequest2.default({
			service: 'api/getRequirementDocuments',
			method: "POST",
			data: _extends({}, form),
			headers: Object.assign({ "Authorization": sessionStorage.access_token, "uid": sessionStorage.uid })
		}).request().then(function (response) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch({ type: GET_REQUIREMENT_DOCS, Obj: response.data });
		}).catch(function (error) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
			throw error;
		});
	};
};

var saveBankInfo = exports.saveBankInfo = function saveBankInfo(form) {

	var temp = {
		banco: form.banco,
		clabe: form.clabe,
		createdBy: sessionStorage.uid,
		deleted: false,
		id: form.idDonatariaDatoPago || 0,
		idCorrida: form.idCorrida,
		idDonataria: form.idDonataria,
		numeroRecibo: form.recibo,
		montoSolicitado: parseFloat(form.montoEntregar),
		referencia1: form.referencia1 || "",
		referencia2: form.referencia2 || "",
		referencia3: form.referencia3 || ""
	};

	if (form.idDonatariaRecibo) {
		temp.idDonatariaRecibo = form.idDonatariaRecibo;
	}

	return function (dispatch) {

		dispatch((0, _Loading.isLoading)(true));

		return new _ClientHttpRequest2.default({
			service: form.idDonatariaRecibo ? 'api/updateBankInfo' : 'api/saveBankInfo',
			method: "POST",
			data: _extends({}, temp),
			headers: Object.assign({ "Authorization": sessionStorage.access_token, "uid": sessionStorage.uid })
		}).request().then(function (response) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch({ type: BANK_ACCOUNT_INFO, Obj: response.data });
		}).catch(function (error) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
			throw error;
		});
	};
};

var deleteBankInfo = exports.deleteBankInfo = function deleteBankInfo(form) {

	var temp = {
		banco: form.banco,
		clabe: form.clabeInterbancaria,
		createdBy: sessionStorage.uid,
		deleted: true,
		id: form.idDonatariaDatoPago,
		idDonatariaRecibo: form.idDonatariaRecibo,
		idCorrida: form.idCorrida,
		idDonataria: form.idDonataria,
		numeroRecibo: form.numeroRecibo,
		montoSolicitado: parseFloat(form.montoSolicitado),
		referencia1: form.referencia1 || "",
		referencia2: form.referencia2 || "",
		referencia3: form.referencia3 || ""
	};

	return function (dispatch) {

		dispatch((0, _Loading.isLoading)(true));

		return new _ClientHttpRequest2.default({
			service: 'api/updateBankInfo',
			method: "POST",
			data: _extends({}, temp),
			headers: Object.assign({ "Authorization": sessionStorage.access_token, "uid": sessionStorage.uid })
		}).request().then(function (response) {
			dispatch((0, _Loading.isLoading)(false));
			return response.data;
		}).catch(function (error) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
			throw error;
		});
	};
};

var saveRequirements = exports.saveRequirements = function saveRequirements(form) {

	var documentos = form.form.documentosRequeridos.filter(function (d) {
		return d.fase.id === "requisitos-documentos";
	}).map(function (d) {
		return {
			deleted: false,
			entregado: d.entregoId || null,
			idDonatariaDocumento: d.idDonatariaDocumento,
			revisado: d.revisado || false
		};
	});

	var documentosRequsitosPago = form.form.documentosRequeridos.filter(function (d) {
		return d.fase.id === "requisitos-pago";
	}).map(function (d) {
		return {
			deleted: false,
			entregado: d.entregoId || null,
			idDonatariaRequisitoPago: d.idDonatariaRequisitoPago,
			revisado: d.revisado || false
		};
	});

	var informacionBancaria = form.form.informacionBancaria.map(function (i) {

		return {
			deleted: false,
			idDonatariaRecibo: i.idDonatariaRecibo,
			revisado: i.revisado || false
		};
	});

	var temp = {
		usuario: sessionStorage.uid,
		documentos: documentos,
		documentosRequsitosPago: documentosRequsitosPago,
		idCorrida: form.idCorrida,
		idDonataria: form.idDonataria,
		informacionBancaria: informacionBancaria,
		tipoPago: { id: form.form.validatePay || null }
	};

	return function (dispatch) {

		dispatch((0, _Loading.isLoading)(true));

		return new _ClientHttpRequest2.default({
			service: 'api/saveRequirements',
			method: "POST",
			data: _extends({}, temp),
			headers: Object.assign({ "Authorization": sessionStorage.access_token, "uid": sessionStorage.uid })
		}).request().then(function (response) {
			dispatch((0, _Loading.isLoading)(false));
			return response.data;
		}).catch(function (error) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
			throw error;
		});
	};
};

var clearRequirements = exports.clearRequirements = function clearRequirements() {
	return function (dispatch) {
		dispatch({ type: GET_REQUIREMENT_DOCS, Obj: {} });
	};
};

/***/ }),

/***/ 537:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.clearApplicationDonation = exports.searchApplicationDonation = exports.getDataApplicationDonation = exports.getStatusDonative = exports.addStatusDonative = exports.ACTION_SEARCH_DONATION = exports.ACTION_GET_DATA_DONATIVE = exports.ACTION_GET_STATUS_DONATIVE = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _Utils = __webpack_require__(2);

var Utils = _interopRequireWildcard(_Utils);

var _ClientHttpRequest = __webpack_require__(5);

var _ClientHttpRequest2 = _interopRequireDefault(_ClientHttpRequest);

var _immutable = __webpack_require__(1);

var _immutable2 = _interopRequireDefault(_immutable);

var _Modal = __webpack_require__(4);

var _Loading = __webpack_require__(3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var initialState = _immutable2.default.Map({}).set('Add', new _immutable2.default.Map({})).set('Status', new _immutable2.default.List([])).set('Get', new _immutable2.default.Map({})).set('Search', new _immutable2.default.List([]));

/* Types */
var ACTION_GET_STATUS_DONATIVE = exports.ACTION_GET_STATUS_DONATIVE = 'ACTION_GET_STATUS_DONATIVE';
var ACTION_GET_DATA_DONATIVE = exports.ACTION_GET_DATA_DONATIVE = 'ACTION_GET_DATA_DONATIVE';
var ACTION_SEARCH_DONATION = exports.ACTION_SEARCH_DONATION = 'ACTION_SEARCH_DONATION';

/* Reducer */

exports.default = function () {
	var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	var action = arguments[1];

	switch (action.type) {
		case ACTION_GET_STATUS_DONATIVE:
			return state.set('Status', new _immutable2.default.List(action.Obj));
		case ACTION_GET_DATA_DONATIVE:
			return state.set('Get', new _immutable2.default.Map(action.Obj));
		case ACTION_SEARCH_DONATION:
			return state.set('Search', new _immutable2.default.List(action.Obj));
		default:
			return state;
	}
};

/* Action Creators */

var addStatusDonative = exports.addStatusDonative = function addStatusDonative(form) {

	var temp = {
		id: form.idApplicationStatus || null,
		descripcion: form.applicationDonation,
		deleted: form.newStatusApp,
		usuario: sessionStorage.uid
	};

	return function (dispatch) {
		dispatch((0, _Loading.isLoading)(true));

		return new _ClientHttpRequest2.default({
			service: form.idApplicationStatus ? "api/updateStatusDonative" : "api/addStatusDonative",
			method: "POST",
			data: _extends({}, temp),
			headers: Object.assign({ "Authorization": sessionStorage.access_token, "uid": sessionStorage.uid })
		}).request().then(function (response) {
			dispatch((0, _Loading.isLoading)(false));
			return response.data;
		}).catch(function (error) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
			throw error;
		});
	};
};

var getStatusDonative = exports.getStatusDonative = function getStatusDonative() {
	return function (dispatch) {
		dispatch((0, _Loading.isLoading)(true));

		return new _ClientHttpRequest2.default({
			service: "api/getStatusDonative",
			method: "POST",
			data: {},
			headers: Object.assign({ "Authorization": sessionStorage.access_token, "uid": sessionStorage.uid })
		}).request().then(function (response) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch({ type: ACTION_GET_STATUS_DONATIVE, Obj: response.data });
		}).catch(function (error) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
			throw error;
		});
	};
};

var getDataApplicationDonation = exports.getDataApplicationDonation = function getDataApplicationDonation(form) {
	return function (dispatch) {
		dispatch((0, _Loading.isLoading)(true));

		return new _ClientHttpRequest2.default({
			service: "api/getDataApplicationDonation",
			method: "POST",
			data: _extends({}, form),
			headers: Object.assign({ "Authorization": sessionStorage.access_token, "uid": sessionStorage.uid })
		}).request().then(function (response) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch({ type: ACTION_GET_DATA_DONATIVE, Obj: response.data });
		}).catch(function (error) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
			throw error;
		});
	};
};

var searchApplicationDonation = exports.searchApplicationDonation = function searchApplicationDonation(form) {

	var temp = {
		id: parseInt(form.idApplicationStatus) || null,
		descripcion: form.appDonation || null,
		deleted: form.searchStatusApp || null
	};

	return function (dispatch) {
		dispatch((0, _Loading.isLoading)(true));

		return new _ClientHttpRequest2.default({
			service: "api/searchApplicationDonation",
			method: "POST",
			data: _extends({}, temp),
			headers: Object.assign({ "Authorization": sessionStorage.access_token, "uid": sessionStorage.uid })
		}).request().then(function (response) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch({ type: ACTION_GET_STATUS_DONATIVE, Obj: response.data });
		}).catch(function (error) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
			throw error;
		});
	};
};

var clearApplicationDonation = exports.clearApplicationDonation = function clearApplicationDonation() {
	return function (dispatch) {
		dispatch({ type: ACTION_GET_STATUS_DONATIVE, Obj: [] });
		dispatch({ type: ACTION_GET_DATA_DONATIVE, Obj: {} });
		return Promise.resolve();
	};
};

/***/ }),

/***/ 538:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.clearCheckDonation = exports.searchCheckDonation = exports.updateDataCheckDonation = exports.getStatusCheck = exports.addCheckDonative = exports.ACTION_SEARCH_CHECK_DONATION = exports.ACTION_GET_DATA_CHECK = exports.ACTION_GET_DESCRIPTION_CHECK = exports.ACTION_GET_STATUS_CHECK = exports.ACTION_ADD_CHECK = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _Utils = __webpack_require__(2);

var Utils = _interopRequireWildcard(_Utils);

var _ClientHttpRequest = __webpack_require__(5);

var _ClientHttpRequest2 = _interopRequireDefault(_ClientHttpRequest);

var _immutable = __webpack_require__(1);

var _immutable2 = _interopRequireDefault(_immutable);

var _Modal = __webpack_require__(4);

var _Loading = __webpack_require__(3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var initialState = _immutable2.default.Map({}).set('Add', new _immutable2.default.Map({})).set('Status', new _immutable2.default.Map({})).set('Description', new _immutable2.default.Map({})).set('Get', new _immutable2.default.Map({})).set('Search', new _immutable2.default.List([]));

/* Types */
var ACTION_ADD_CHECK = exports.ACTION_ADD_CHECK = 'ACTION_ADD_CHECK';
var ACTION_GET_STATUS_CHECK = exports.ACTION_GET_STATUS_CHECK = 'ACTION_GET_STATUS_CHECK';
var ACTION_GET_DESCRIPTION_CHECK = exports.ACTION_GET_DESCRIPTION_CHECK = 'ACTION_GET_DESCRIPTION_CHECK';
var ACTION_GET_DATA_CHECK = exports.ACTION_GET_DATA_CHECK = 'ACTION_GET_DATA_CHECK';
var ACTION_SEARCH_CHECK_DONATION = exports.ACTION_SEARCH_CHECK_DONATION = 'ACTION_SEARCH_CHECK_DONATION';

/* Reducer */

exports.default = function () {
	var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	var action = arguments[1];

	switch (action.type) {
		case ACTION_ADD_CHECK:
			return state.set('Add', new _immutable2.default.Map(action.Obj));
		case ACTION_GET_STATUS_CHECK:
			return state.set('Status', new _immutable2.default.Map(action.Obj));
		case ACTION_GET_DESCRIPTION_CHECK:
			return state.set('Description', new _immutable2.default.Map(action.Obj));
		case ACTION_GET_DATA_CHECK:
			return state.set('Get', new _immutable2.default.Map(action.Obj));
		case ACTION_SEARCH_CHECK_DONATION:
			return state.set('Search', new _immutable2.default.List(action.Obj));
		default:
			return state;
	}
};

/* Action Creators */


var addCheckDonative = exports.addCheckDonative = function addCheckDonative(form) {

	var temp = {
		id: form.idSearchCheck || null,
		idEstatusAplicacion: null,
		descripcion: form.descriptionDonation,
		deleted: form.newStatusCheck,
		retroalimentacion: form.feedbackDonation,
		dePorcentaje: parseFloat(form.ofPercent),
		hastaPorcentaje: parseFloat(form.untilPercent),
		deMonto: parseFloat(form.ofNumber),
		hastaMonto: parseFloat(form.untilNumber),
		usuario: sessionStorage.uid
	};

	return function (dispatch) {
		dispatch((0, _Loading.isLoading)(true));

		return new _ClientHttpRequest2.default({
			service: form.idSearchCheck ? "api/updateDataCheckDonation" : "api/addCheckDonative",
			method: "POST",
			data: _extends({}, temp),
			headers: Object.assign({ "Authorization": sessionStorage.access_token, "uid": sessionStorage.uid })
		}).request().then(function (response) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch({ type: ACTION_ADD_CHECK, Obj: response.data });
		}).catch(function (error) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
			throw error;
		});
	};
};

var getStatusCheck = exports.getStatusCheck = function getStatusCheck(form) {

	return function (dispatch) {
		dispatch((0, _Loading.isLoading)(true));

		return new _ClientHttpRequest2.default({
			service: "api/getStatusCheck",
			method: "POST",
			data: _extends({}, form),
			headers: Object.assign({ "Authorization": sessionStorage.access_token, "uid": sessionStorage.uid })
		}).request().then(function (response) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch({ type: ACTION_GET_STATUS_CHECK, Obj: response.data });
			return response.data;
		}).catch(function (error) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
			throw error;
		});
	};
};

var updateDataCheckDonation = exports.updateDataCheckDonation = function updateDataCheckDonation() {

	return function (dispatch) {
		dispatch((0, _Loading.isLoading)(true));

		return (0, _ClientHttpRequest2.default)({
			servie: "api/updateDataCheckDonation",
			method: "POST",
			data: {},
			headers: Object.assign({ "Authorization": sessionStorage.access_token, "uid": sessionStorage.uid })
		}).request().then(function (response) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch({ type: ACTION_GET_DATA_CHECK, Obj: response.data });
		}).catch(function (error) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
			throw error;
		});
	};
};

var searchCheckDonation = exports.searchCheckDonation = function searchCheckDonation(form) {

	return function (dispatch) {
		dispatch((0, _Loading.isLoading)(true));

		return new _ClientHttpRequest2.default({
			service: Object.keys(form).length ? "api/searchCheckDonationByParams" : "api/searchCheckDonation",
			method: "POST",
			data: _extends({}, form),
			headers: Object.assign({ "Authorization": sessionStorage.access_token, "uid": sessionStorage.uid })
		}).request().then(function (response) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch({ type: ACTION_SEARCH_CHECK_DONATION, Obj: response.data });
		}).catch(function (error) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
			throw error;
		});
	};
};

var clearCheckDonation = exports.clearCheckDonation = function clearCheckDonation() {
	return function (dispatch) {
		dispatch({ type: ACTION_SEARCH_CHECK_DONATION, Obj: [] });
	};
};

/***/ }),

/***/ 539:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.clearData = exports.deleteDonationDetail = exports.setDonationDetail = exports.getYearGrantee = exports.getDonationDetail = exports.ACTION_GET_YEAR_GRANTEE = exports.ACTION_GET_DONATIONS_DETAIL = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _Utils = __webpack_require__(2);

var Utils = _interopRequireWildcard(_Utils);

var _ClientHttpRequest = __webpack_require__(5);

var _ClientHttpRequest2 = _interopRequireDefault(_ClientHttpRequest);

var _immutable = __webpack_require__(1);

var _immutable2 = _interopRequireDefault(_immutable);

var _Modal = __webpack_require__(4);

var _Loading = __webpack_require__(3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var initialState = _immutable2.default.Map({}).set('Get', new _immutable2.default.List([])).set('Search', new _immutable2.default.List([]));

/* Types */
var ACTION_GET_DONATIONS_DETAIL = exports.ACTION_GET_DONATIONS_DETAIL = "ACTION_GET_DONATIONS_DETAIL";
var ACTION_GET_YEAR_GRANTEE = exports.ACTION_GET_YEAR_GRANTEE = "ACTION_GET_YEAR_GRANTEE";

/* Reducer */

exports.default = function () {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
    var action = arguments[1];


    switch (action.type) {
        case ACTION_GET_DONATIONS_DETAIL:
            return state.set('Get', new _immutable2.default.List(action.Obj));
        case ACTION_GET_YEAR_GRANTEE:
            return state.set('Search', new _immutable2.default.List(action.Obj));
        default:
            return state;
    }
};

/* Action Creators */


var getDonationDetail = exports.getDonationDetail = function getDonationDetail(id) {

    return function (dispatch) {
        dispatch((0, _Loading.isLoading)(true));

        return new _ClientHttpRequest2.default({
            service: 'api/DonationsDetail/getDonationDetail',
            method: 'POST',
            data: { id: id },
            headers: Object.assign({ "Authorization": sessionStorage.access_token, "uid": sessionStorage.uid })
        }).request().then(function (response) {
            dispatch((0, _Loading.isLoading)(false));
            dispatch({ type: ACTION_GET_DONATIONS_DETAIL, Obj: response.data });
        }).catch(function (error) {
            dispatch((0, _Loading.isLoading)(false));
            dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
            throw error;
        });
    };
};

var getYearGrantee = exports.getYearGrantee = function getYearGrantee(id) {

    return function (dispatch) {
        dispatch((0, _Loading.isLoading)(true));

        return new _ClientHttpRequest2.default({
            service: 'api/DonationsDetail/getYearGrantee',
            method: 'POST',
            data: { id: id },
            headers: Object.assign({ "Authorization": sessionStorage.access_token, "uid": sessionStorage.uid })
        }).request().then(function (response) {
            dispatch((0, _Loading.isLoading)(false));
            dispatch({ type: ACTION_GET_YEAR_GRANTEE, Obj: response.data });
        }).catch(function (error) {
            dispatch((0, _Loading.isLoading)(false));
            dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
            throw error;
        });
    };
};

var setDonationDetail = exports.setDonationDetail = function setDonationDetail(form) {

    var temp = {
        deleted: false,
        idDetalleDonacion: form.idDetalleDonacion || null,
        donataria: {
            idDonataria: form.donataria
        },
        anio: form.anio,
        corrida: {
            corridaId: form.corrida
        },
        bien: {
            id: form.bien
        },
        cantidad: form.cantidad,
        municipioDelegacion: {
            id: form.municipio,
            estado: {
                id: form.estado
            }
        },
        montoRepresenta: form.monto
    };

    return function (dispatch) {
        dispatch((0, _Loading.isLoading)(true));

        return new _ClientHttpRequest2.default({
            service: form.idDetalleDonacion ? 'api/DonationsDetail/updateDonationDetail' : 'api/DonationsDetail/setDonationDetail',
            method: 'POST',
            data: _extends({}, temp),
            headers: Object.assign({ "Authorization": sessionStorage.access_token, "uid": sessionStorage.uid })
        }).request().then(function (response) {
            dispatch((0, _Loading.isLoading)(false));
            return response.data;
        }).catch(function (error) {
            dispatch((0, _Loading.isLoading)(false));
            dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
            throw error;
        });
    };
};

var deleteDonationDetail = exports.deleteDonationDetail = function deleteDonationDetail(idDetalleDonacion) {

    return function (dispatch) {
        dispatch((0, _Loading.isLoading)(true));

        return new _ClientHttpRequest2.default({
            service: 'api/DonationsDetail/deleteDonationDetail',
            method: 'POST',
            data: { idDetalleDonacion: idDetalleDonacion },
            headers: Object.assign({ "Authorization": sessionStorage.access_token, "uid": sessionStorage.uid })
        }).request().then(function (response) {
            dispatch((0, _Loading.isLoading)(false));
            return response.data;
        }).catch(function (error) {
            dispatch((0, _Loading.isLoading)(false));
            dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
            throw error;
        });
    };
};

var clearData = exports.clearData = function clearData() {

    return function (dispatch) {
        dispatch({ type: ACTION_GET_YEAR_GRANTEE, Obj: [] });
    };
};

/***/ }),

/***/ 540:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.getControlPanel = exports.ACTION_GET_CONTROL_PANEL = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _Utils = __webpack_require__(2);

var Utils = _interopRequireWildcard(_Utils);

var _ClientHttpRequest = __webpack_require__(5);

var _ClientHttpRequest2 = _interopRequireDefault(_ClientHttpRequest);

var _immutable = __webpack_require__(1);

var _immutable2 = _interopRequireDefault(_immutable);

var _Modal = __webpack_require__(4);

var _Loading = __webpack_require__(3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var initialState = _immutable2.default.Map({}).set('GetControlPanel', new _immutable2.default.Map({}));

/* Types */
var ACTION_GET_CONTROL_PANEL = exports.ACTION_GET_CONTROL_PANEL = 'ACTION_GET_CONTROL_PANEL';

/* Reducer */

exports.default = function () {
	var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	var action = arguments[1];


	switch (action.type) {
		case ACTION_GET_CONTROL_PANEL:
			return state.set('GetControlPanel', new _immutable2.default.Map(action.Obj));
		default:
			return state;
	}
};

/* Action Creators */


var getControlPanel = exports.getControlPanel = function getControlPanel(id) {
	return function (dispatch) {
		dispatch((0, _Loading.isLoading)(true));

		return new _ClientHttpRequest2.default({
			service: 'api/getControlPanel',
			method: "POST",
			data: _extends({}, id),
			headers: Object.assign({ "Authorization": sessionStorage.access_token, "uid": sessionStorage.uid })
		}).request().then(function (response) {
			var data = response.data;
			var obj = {};
			if (data !== null) {
				obj = { fortalecimientos: data.fortalecimientos, solicitudes: data.solicitudes };
			} else {
				obj = { fortalecimientos: [], solicitudes: [] };
			}
			dispatch((0, _Loading.isLoading)(false));
			dispatch({ type: ACTION_GET_CONTROL_PANEL, Obj: obj });
			return obj;
		}).catch(function (error) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
			throw error;
		});
	};
};

/***/ }),

/***/ 541:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.clearData = exports.publishIntegralValuation = exports.runIntegralValuation = exports.saveIntegralValuation = exports.updateIntegralValuationContainer = exports.getIntegralEvaluation = exports.getIntegralValuation = exports.ACTION_PUBLISH_INTEGRAL_VALUATION = exports.ACTION_SAVE_INTEGRAL_VALUATION = exports.ACTION_RUN_INTEGRAL_VALUATION = exports.ACTION_GET_INTEGRAL_EVALUATION = exports.ACTION_UPDATE_INTEGRAL_VALUATION = exports.ACTION_GET_INTEGRAL_VALUATION_SELECTED = exports.ACTION_GET_INTEGRAL_VALUATION = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _Utils = __webpack_require__(2);

var Utils = _interopRequireWildcard(_Utils);

var _ClientHttpRequest = __webpack_require__(5);

var _ClientHttpRequest2 = _interopRequireDefault(_ClientHttpRequest);

var _immutable = __webpack_require__(1);

var _immutable2 = _interopRequireDefault(_immutable);

var _Modal = __webpack_require__(4);

var _Loading = __webpack_require__(3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var initiaState = _immutable2.default.Map({}).set('GetValuation', new _immutable2.default.List([])).set('GetValuationSelected', new _immutable2.default.List([])).set('UpdateValuation', new _immutable2.default.Map({})).set('GetIntegralEvaluation', new _immutable2.default.List([])).set('RunValuation', new _immutable2.default.Map({})).set('SaveValuation', new _immutable2.default.Map({})).set('PublishValuation', new _immutable2.default.Map({}));

/*Types*/
var ACTION_GET_INTEGRAL_VALUATION = exports.ACTION_GET_INTEGRAL_VALUATION = "ACTION_GET_INTEGRAL_VALUATION";
var ACTION_GET_INTEGRAL_VALUATION_SELECTED = exports.ACTION_GET_INTEGRAL_VALUATION_SELECTED = "ACTION_GET_INTEGRAL_VALUATION_SELECTED";
var ACTION_UPDATE_INTEGRAL_VALUATION = exports.ACTION_UPDATE_INTEGRAL_VALUATION = "ACTION_UPDATE_INTEGRAL_VALUATION";
var ACTION_GET_INTEGRAL_EVALUATION = exports.ACTION_GET_INTEGRAL_EVALUATION = "ACTION_GET_INTEGRAL_EVALUATION";
var ACTION_RUN_INTEGRAL_VALUATION = exports.ACTION_RUN_INTEGRAL_VALUATION = "ACTION_RUN_INTEGRAL_VALUATION";
var ACTION_SAVE_INTEGRAL_VALUATION = exports.ACTION_SAVE_INTEGRAL_VALUATION = "ACTION_SAVE_INTEGRAL_VALUATION";
var ACTION_PUBLISH_INTEGRAL_VALUATION = exports.ACTION_PUBLISH_INTEGRAL_VALUATION = "ACTION_PUBLISH_INTEGRAL_VALUATION";

/*Reducers*/

exports.default = function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initiaState;
  var action = arguments[1];


  switch (action.type) {
    case ACTION_GET_INTEGRAL_VALUATION:
      return state.set('GetValuation', new _immutable2.default.List(action.Obj));
    case ACTION_GET_INTEGRAL_VALUATION_SELECTED:
      return state.set('GetValuationSelected', new _immutable2.default.List(action.Obj));
    case ACTION_UPDATE_INTEGRAL_VALUATION:
      return state.set('UpdateValuation', new _immutable2.default.Map(action.Obj));
    case ACTION_GET_INTEGRAL_EVALUATION:
      return state.set('GetIntegralEvaluation', new _immutable2.default.List(action.Obj));
    case ACTION_RUN_INTEGRAL_VALUATION:
      return state.set('RunValuation', new _immutable2.default.Map(action.Obj));
    case ACTION_SAVE_INTEGRAL_VALUATION:
      return state.set('SaveValuation', new _immutable2.default.Map(action.Obj));
    case ACTION_PUBLISH_INTEGRAL_VALUATION:
      return state.set('PublishValuation', new _immutable2.default.Map(action.Obj));
    default:
      return state;
  }
};

/*Action Creators*/

var getIntegralValuation = exports.getIntegralValuation = function getIntegralValuation(idEjecutivo) {
  return function (dispatch) {
    dispatch((0, _Loading.isLoading)(true));

    return new _ClientHttpRequest2.default({
      service: 'api/getIntegralValuation',
      method: 'POST',
      data: { idEjecutivo: idEjecutivo },
      headers: Object.assign({ 'Authorization': sessionStorage.access_token, 'uid': sessionStorage.uid })
    }).request().then(function (response) {
      dispatch((0, _Loading.isLoading)(false));
      dispatch({ type: ACTION_GET_INTEGRAL_VALUATION, Obj: response.data });
      return response;
    }).catch(function (error) {
      dispatch((0, _Loading.isLoading)(false));
      dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
      throw error;
    });
  };
};

var getIntegralEvaluation = exports.getIntegralEvaluation = function getIntegralEvaluation(idDonataria) {

  return function (dispatch) {
    dispatch((0, _Loading.isLoading)(true));

    return new _ClientHttpRequest2.default({
      service: 'api/getIntegralEvaluation',
      method: 'POST',
      data: { idDonataria: idDonataria },
      headers: Object.assign({ 'Authorization': sessionStorage.access_token, 'uid': sessionStorage.uid })
    }).request().then(function (response) {
      dispatch((0, _Loading.isLoading)(false));
      dispatch({ type: ACTION_GET_INTEGRAL_EVALUATION, Obj: response.data });
      return response;
    }).catch(function (error) {
      dispatch((0, _Loading.isLoading)(false));
      dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
      throw error;
    });
  };
};

var updateIntegralValuationContainer = exports.updateIntegralValuationContainer = function updateIntegralValuationContainer(form) {

  var request = [];

  form.data.map(function (i) {
    var obj = {
      donataria: {
        id: i.id
      },
      correcto: i.correcto
    };
    request.push(obj);
  });

  return function (dispatch) {
    dispatch((0, _Loading.isLoading)(true));

    return new _ClientHttpRequest2.default({
      service: 'api/updateIntegralValuationContainer',
      method: 'POST',
      data: { request: request },
      headers: Object.assign({ 'Authorization': sessionStorage.access_token, 'uid': sessionStorage.uid })
    }).request().then(function (response) {
      dispatch((0, _Loading.isLoading)(false));
      dispatch({ type: ACTION_UPDATE_INTEGRAL_VALUATION, Obj: response.data });
      return response;
    }).catch(function (error) {
      dispatch((0, _Loading.isLoading)(false));
      dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
      throw error;
    });
  };
};

var saveIntegralValuation = exports.saveIntegralValuation = function saveIntegralValuation(form) {
  var tmp = {
    donataria: {
      id: form.idDonataria
    },
    valoracion: {
      id: form.valuationSelection
    },
    comentario: form.valuationComments,
    objetivoNMP: form.goalNMP,
    observacion: form.executiveObservations
  };

  return function (dispatch) {
    dispatch((0, _Loading.isLoading)(true));

    return new _ClientHttpRequest2.default({
      service: 'api/saveIntegralValuation',
      method: 'POST',
      data: _extends({}, tmp),
      headers: Object.assign({ 'Authorization': sessionStorage.access_token, 'uid': sessionStorage.uid })
    }).request().then(function (response) {
      dispatch((0, _Loading.isLoading)(false));
      dispatch({ type: ACTION_SAVE_INTEGRAL_VALUATION, Obj: response.data });
      return response.data;
    }).catch(function (error) {
      dispatch((0, _Loading.isLoading)(false));
      dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
      throw error;
    });
  };
};

var runIntegralValuation = exports.runIntegralValuation = function runIntegralValuation(idEjecutivo) {

  return function (dispatch) {
    dispatch((0, _Loading.isLoading)(true));

    return new _ClientHttpRequest2.default({
      service: 'api/runIntegralValuation',
      method: 'POST',
      data: { idEjecutivo: idEjecutivo },
      headers: Object.assign({ 'Authorization': sessionStorage.access_token, 'uid': sessionStorage.uid })
    }).request().then(function (response) {
      dispatch((0, _Loading.isLoading)(false));
      dispatch({ type: ACTION_RUN_INTEGRAL_VALUATION, Obj: response.data });
      return response;
    }).catch(function (error) {
      dispatch((0, _Loading.isLoading)(false));
      dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
      throw error;
    });
  };
};

var publishIntegralValuation = exports.publishIntegralValuation = function publishIntegralValuation(idEjecutivo) {

  return function (dispatch) {
    dispatch((0, _Loading.isLoading)(true));

    return new _ClientHttpRequest2.default({
      service: 'api/publishIntegralValuation',
      method: 'POST',
      data: { idEjecutivo: idEjecutivo },
      headers: Object.assign({ 'Authorization': sessionStorage.access_token, 'uid': sessionStorage.uid })
    }).request().then(function (response) {
      dispatch((0, _Loading.isLoading)(false));
      dispatch({ type: ACTION_PUBLISH_INTEGRAL_VALUATION, Obj: response.data });
      return response;
    }).catch(function (error) {
      dispatch((0, _Loading.isLoading)(false));
      dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
      throw error;
    });
  };
};

var clearData = exports.clearData = function clearData() {
  return function (dispatch) {
    dispatch({ type: ACTION_GET_INTEGRAL_VALUATION, Obj: [] });
  };
};

/***/ }),

/***/ 542:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.clearContactData = exports.informarBitGen = exports.eliminaDocumentos = exports.eliminaBitacora = exports.agregaBitacora = exports.getConsultaBitacora = exports.getConsultaTipoBitacora = exports.getConsultaPersonalInterno = exports.getConsultaPerfil = exports.ACTION_GET_BITACORA = exports.ACTION_SEARCH_CONSULTA_BITACORA = exports.ACTION_SEARCH_CONSULTA_TIPO_BITACORA = exports.ACTION_SEARCH_CONSULTA_PERSONAL_INTERNO = exports.ACTION_SEARCH_CONSULTA_PERFIL = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _Utils = __webpack_require__(2);

var Utils = _interopRequireWildcard(_Utils);

var _ClientHttpRequest = __webpack_require__(5);

var _ClientHttpRequest2 = _interopRequireDefault(_ClientHttpRequest);

var _immutable = __webpack_require__(1);

var _immutable2 = _interopRequireDefault(_immutable);

var _Modal = __webpack_require__(4);

var _Loading = __webpack_require__(3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var initialState = _immutable2.default.Map({}).set('Perfil', new _immutable2.default.List([])).set('PersonalInterno', new _immutable2.default.List([])).set('tipoBitacora', new _immutable2.default.List([])).set('Bitacora', new _immutable2.default.List([])).set('Get', new _immutable2.default.Map({}));

/* Types */
var ACTION_SEARCH_CONSULTA_PERFIL = exports.ACTION_SEARCH_CONSULTA_PERFIL = 'ACTION_SEARCH_CONSULTA_PERFIL';
var ACTION_SEARCH_CONSULTA_PERSONAL_INTERNO = exports.ACTION_SEARCH_CONSULTA_PERSONAL_INTERNO = 'ACTION_SEARCH_CONSULTA_PERSONAL_INTERNO';
var ACTION_SEARCH_CONSULTA_TIPO_BITACORA = exports.ACTION_SEARCH_CONSULTA_TIPO_BITACORA = 'ACTION_SEARCH_CONSULTA_TIPO_BITACORA';
var ACTION_SEARCH_CONSULTA_BITACORA = exports.ACTION_SEARCH_CONSULTA_BITACORA = 'ACTION_SEARCH_CONSULTA_BITACORA';
var ACTION_GET_BITACORA = exports.ACTION_GET_BITACORA = 'ACTION_GET_BITACORA';

/* Reducer */

exports.default = function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments[1];


  switch (action.type) {

    case ACTION_SEARCH_CONSULTA_PERFIL:
      return state.set('Perfil', new _immutable2.default.List(action.Obj));
    case ACTION_SEARCH_CONSULTA_PERSONAL_INTERNO:
      return state.set('PersonalInterno', new _immutable2.default.List(action.Obj));
    case ACTION_SEARCH_CONSULTA_TIPO_BITACORA:
      return state.set('tipoBitacora', new _immutable2.default.List(action.Obj));
    case ACTION_SEARCH_CONSULTA_BITACORA:
      return state.set('Bitacora', new _immutable2.default.List(action.Obj));
    case ACTION_GET_BITACORA:
      return state.set('Get', new _immutable2.default.Map(action.Obj));
    default:
      return state;
  }
};

/* Action Creators */

var getConsultaPerfil = exports.getConsultaPerfil = function getConsultaPerfil(idTipoPerfil) {
  return function (dispatch) {

    dispatch((0, _Loading.isLoading)(true));

    return new _ClientHttpRequest2.default({
      service: 'api/getConsultaPerfil',
      method: "POST",
      data: { idTipoPerfil: idTipoPerfil },
      headers: Object.assign({ "Authorization": sessionStorage.access_token, "uid": sessionStorage.uid })
    }).request().then(function (response) {
      dispatch((0, _Loading.isLoading)(false));
      dispatch({ type: ACTION_SEARCH_CONSULTA_PERFIL, Obj: response.data });
    }).catch(function (error) {
      dispatch((0, _Loading.isLoading)(false));
      dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
      throw error;
    });
  };
};

var getConsultaPersonalInterno = exports.getConsultaPersonalInterno = function getConsultaPersonalInterno() {
  return function (dispatch) {

    dispatch((0, _Loading.isLoading)(true));

    return new _ClientHttpRequest2.default({
      service: 'api/getConsultaPersonalInterno',
      method: "POST",
      data: {},
      headers: Object.assign({ "Authorization": sessionStorage.access_token, "uid": sessionStorage.uid })
    }).request().then(function (response) {
      dispatch((0, _Loading.isLoading)(false));
      dispatch({ type: ACTION_SEARCH_CONSULTA_PERSONAL_INTERNO, Obj: response.data });
    }).catch(function (error) {
      dispatch((0, _Loading.isLoading)(false));
      dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
      throw error;
    });
  };
};

var getConsultaTipoBitacora = exports.getConsultaTipoBitacora = function getConsultaTipoBitacora() {
  return function (dispatch) {
    dispatch((0, _Loading.isLoading)(true));
    return new _ClientHttpRequest2.default({
      service: 'api/getConsultaTipoBitacora',
      method: "POST",
      data: {},
      headers: Object.assign({ "Authorization": sessionStorage.access_token, "uid": sessionStorage.uid })
    }).request().then(function (response) {
      dispatch((0, _Loading.isLoading)(false));
      dispatch({ type: ACTION_SEARCH_CONSULTA_TIPO_BITACORA, Obj: response.data });
    }).catch(function (error) {
      dispatch((0, _Loading.isLoading)(false));
      dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
      throw error;
    });
  };
};

var getConsultaBitacora = exports.getConsultaBitacora = function getConsultaBitacora(form) {

  return function (dispatch) {
    dispatch((0, _Loading.isLoading)(true));
    return new _ClientHttpRequest2.default({
      service: 'api/getConsultaBitacora',
      method: "POST",
      data: _extends({}, form),
      headers: Object.assign({ "Authorization": sessionStorage.access_token, "uid": sessionStorage.uid })
    }).request().then(function (response) {
      dispatch((0, _Loading.isLoading)(false));
      dispatch({ type: ACTION_SEARCH_CONSULTA_BITACORA, Obj: response.data });
    }).catch(function (error) {
      dispatch((0, _Loading.isLoading)(false));
      dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
      throw error;
    });
  };
};

var agregaBitacora = exports.agregaBitacora = function agregaBitacora(form) {

  var aux = [];
  var tipos = form.idTipo.split(",");
  tipos.map(function (tipo) {
    var auxAs = { id: parseInt(tipo) };
    aux.push(auxAs);
  });
  tipos = aux;
  var temp = {
    nombre: form.nombre,
    fechaCreacion: form.fecha,
    tipos: tipos,
    asistentes: form.asistentes,
    tema: form.tema,
    acuerdo: form.acuerdo,
    fechaCompromiso: form.fechaCompromiso,
    usuario: sessionStorage.uid
  };

  if (form.idBitacora) {
    temp.idBitacora = form.idBitacora;
  } else {
    temp.idCatalogoPerfil = form.itemSelected.idCatalogoPerfil;
    temp.idTipoPerfil = form.radioSelected;
  }

  return function (dispatch) {
    dispatch((0, _Loading.isLoading)(true));
    return new _ClientHttpRequest2.default({
      service: form.idBitacora ? 'api/editarBitacora' : 'api/agregaBitacora',
      method: "POST",
      data: _extends({}, temp),
      headers: Object.assign({ "Authorization": sessionStorage.access_token, "uid": sessionStorage.uid })
    }).request().then(function (response) {
      dispatch((0, _Loading.isLoading)(false));
      dispatch({ type: ACTION_GET_BITACORA, Obj: response.data });
      return response.data;
    }).catch(function (error) {
      dispatch((0, _Loading.isLoading)(false));
      dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
      throw error;
    });
  };
};

var eliminaBitacora = exports.eliminaBitacora = function eliminaBitacora(idBitacora) {
  var temp = {
    idBitacora: idBitacora,
    usuario: sessionStorage.uid
  };
  return function (dispatch) {
    dispatch((0, _Loading.isLoading)(true));
    return new _ClientHttpRequest2.default({
      service: 'api/eliminaBitacora',
      method: "POST",
      data: _extends({}, temp),
      headers: Object.assign({ "Authorization": sessionStorage.access_token, "uid": sessionStorage.uid })
    }).request().then(function (response) {
      dispatch((0, _Loading.isLoading)(false));
      return response.data;
    }).catch(function (error) {
      dispatch((0, _Loading.isLoading)(false));
      dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
      throw error;
    });
  };
};

var eliminaDocumentos = exports.eliminaDocumentos = function eliminaDocumentos(idDocumento) {

  return function (dispatch) {

    dispatch((0, _Loading.isLoading)(true));

    return new _ClientHttpRequest2.default({
      service: 'api/eliminaDocumentos',
      method: "POST",
      data: { idDocumento: idDocumento },
      headers: Object.assign({ "Authorization": sessionStorage.access_token, "uid": sessionStorage.uid })
    }).request().then(function (response) {
      dispatch((0, _Loading.isLoading)(false));
      return response.data;
    }).catch(function (error) {
      dispatch((0, _Loading.isLoading)(false));
      dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
      throw error;
    });
  };
};

var informarBitGen = exports.informarBitGen = function informarBitGen(form) {
  var informe = form.informar.split(',').map(function (item) {
    return { idUsuario: item };
  });
  var temp = {
    bitacora: form.descripcion,
    //   {
    //   idTipoPerfil: form.itemSelected.idTipoPerfil,
    //   idCatalogoPerfil: form.itemSelected.idCatalogoPerfil,
    //   nombrePerfil: form.itemSelected.descripcion
    // },
    remitente: {
      idUsuario: sessionStorage.uid
    },
    destinatarios: {
      destinatario: informe
    }
  };

  return function (dispatch) {

    dispatch((0, _Loading.isLoading)(true));

    return new _ClientHttpRequest2.default({
      service: 'api/bpm/informarBitGen',
      method: "POST",
      data: _extends({}, temp),
      headers: Object.assign({
        "Authorization": sessionStorage.access_token,
        "Bpm": sessionStorage.bpm_token,
        "uid": sessionStorage.uid
      })
    }).request().then(function (response) {
      dispatch((0, _Loading.isLoading)(false));
      return response.data;
    }).catch(function (error) {
      dispatch((0, _Loading.isLoading)(false));
      dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
      throw error;
    });
  };
};

var clearContactData = exports.clearContactData = function clearContactData() {

  return function (dispatch) {

    dispatch({ type: ACTION_SEARCH_CONSULTA_PERFIL, Obj: [] });
    dispatch({ type: ACTION_SEARCH_CONSULTA_PERSONAL_INTERNO, Obj: [] });
    dispatch({ type: ACTION_SEARCH_CONSULTA_TIPO_BITACORA, Obj: [] });
    dispatch({ type: ACTION_SEARCH_CONSULTA_BITACORA, Obj: [] });
    dispatch({ type: ACTION_GET_BITACORA, Obj: {} });
  };
};

/***/ }),

/***/ 543:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.clearContactData = exports.deleteAvisosDonataria = exports.sendAvisosDonataria = exports.saveAvisosDonataria = exports.getAvisosDonataria = exports.getContactData = exports.ACTION_GET_MENSAJES_PAGINACION = exports.ACTION_SEARCH_AVISOS = exports.ACTION_SEARCH_CONTACT_DATA = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _Utils = __webpack_require__(2);

var Utils = _interopRequireWildcard(_Utils);

var _ClientHttpRequest = __webpack_require__(5);

var _ClientHttpRequest2 = _interopRequireDefault(_ClientHttpRequest);

var _immutable = __webpack_require__(1);

var _immutable2 = _interopRequireDefault(_immutable);

var _Modal = __webpack_require__(4);

var _Loading = __webpack_require__(3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var initialState = _immutable2.default.Map({}).set('ContactData', new _immutable2.default.Map({})).set('Avisos', new _immutable2.default.List([])).set('GetListMensajesPaginacion', new _immutable2.default.Map({}));

/* Types */
var ACTION_SEARCH_CONTACT_DATA = exports.ACTION_SEARCH_CONTACT_DATA = 'ACTION_SEARCH_CONTACT_DATA';
var ACTION_SEARCH_AVISOS = exports.ACTION_SEARCH_AVISOS = 'ACTION_SEARCH_AVISOS';
var ACTION_GET_MENSAJES_PAGINACION = exports.ACTION_GET_MENSAJES_PAGINACION = "ACTION_GET_MENSAJES_PAGINACION";

/* Reducer */

exports.default = function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments[1];


  switch (action.type) {

    case ACTION_SEARCH_CONTACT_DATA:
      return state.set('ContactData', new _immutable2.default.Map(action.Obj));
    case ACTION_SEARCH_AVISOS:
      return state.set('Avisos', new _immutable2.default.List(action.Obj));
    case ACTION_GET_MENSAJES_PAGINACION:
      return state.set('GetListMensajesPaginacion', new _immutable2.default.Map(action.Obj));
    default:
      return state;
  }
};

/* Action Creators */

var getContactData = exports.getContactData = function getContactData(idDonataria) {
  return function (dispatch) {

    dispatch((0, _Loading.isLoading)(true));

    return new _ClientHttpRequest2.default({
      service: 'api/bpm/getContactData',
      method: "POST",
      data: { idDonataria: idDonataria },
      headers: Object.assign({ "Authorization": sessionStorage.access_token, "Bpm": sessionStorage.bpm_token, "uid": sessionStorage.uid })
    }).request().then(function (response) {
      dispatch((0, _Loading.isLoading)(false));
      dispatch({ type: ACTION_SEARCH_CONTACT_DATA, Obj: response.data });
    }).catch(function (error) {
      dispatch((0, _Loading.isLoading)(false));
      dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
      throw error;
    });
  };
};

var getAvisosDonataria = exports.getAvisosDonataria = function getAvisosDonataria(form) {
  return function (dispatch) {

    dispatch((0, _Loading.isLoading)(true));

    return new _ClientHttpRequest2.default({
      service: 'api/getAvisosDonataria',
      method: "POST",
      data: _extends({}, form),
      headers: Object.assign({ "Authorization": sessionStorage.access_token, "uid": sessionStorage.uid })
    }).request().then(function (response) {
      dispatch((0, _Loading.isLoading)(false));
      dispatch({ type: ACTION_SEARCH_AVISOS, Obj: response.data.mensajes });
      dispatch({ type: ACTION_GET_MENSAJES_PAGINACION, Obj: response.data.paginacion });
    }).catch(function (error) {
      dispatch((0, _Loading.isLoading)(false));
      console.log(error);
    });
  };
};

var saveAvisosDonataria = exports.saveAvisosDonataria = function saveAvisosDonataria(form) {
  return function (dispatch) {
    var temp = {
      idDonataria: form.idDonataria,
      ejecutivo: form.ejecutivo,
      aviso: form.aviso,
      usuario: form.nombreDonataria
    };
    dispatch((0, _Loading.isLoading)(true));

    return new _ClientHttpRequest2.default({
      service: 'api/saveAvisosDonataria',
      method: "POST",
      data: _extends({}, temp),
      headers: Object.assign({ "Authorization": sessionStorage.access_token, "uid": sessionStorage.uid })
    }).request().then(function (response) {
      dispatch((0, _Loading.isLoading)(false));
      return response.data;
    }).catch(function (error) {
      dispatch((0, _Loading.isLoading)(false));
      dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
      throw error;
    });
  };
};

var sendAvisosDonataria = exports.sendAvisosDonataria = function sendAvisosDonataria(form) {
  return function (dispatch) {
    var temp = {
      idDonataria: form.idDonataria,
      nombreDonataria: form.nombreDonataria,
      ejecutivo: {
        idUsuario: form.ejecutivo
      },
      aviso: form.aviso
    };
    dispatch((0, _Loading.isLoading)(true));

    return new _ClientHttpRequest2.default({
      service: 'api/bpm/sendAvisosDonataria',
      method: "POST",
      data: _extends({}, temp),
      headers: Object.assign({ "Authorization": sessionStorage.access_token, "Bpm": sessionStorage.bpm_token, "uid": sessionStorage.uid })
    }).request().then(function (response) {
      dispatch((0, _Loading.isLoading)(false));
      return response.data;
    }).catch(function (error) {
      dispatch((0, _Loading.isLoading)(false));
      dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
      throw error;
    });
  };
};

var deleteAvisosDonataria = exports.deleteAvisosDonataria = function deleteAvisosDonataria(idValor) {
  return function (dispatch) {
    var temp = {
      id: idValor,
      usuario: sessionStorage.uid
    };
    dispatch((0, _Loading.isLoading)(true));

    return new _ClientHttpRequest2.default({
      service: 'api/deleteAvisosDonataria',
      method: "POST",
      data: _extends({}, temp),
      headers: Object.assign({ "Authorization": sessionStorage.access_token, "uid": sessionStorage.uid })
    }).request().then(function (response) {
      dispatch((0, _Loading.isLoading)(false));
      return response.data;
    }).catch(function (error) {
      dispatch((0, _Loading.isLoading)(false));
      dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
      throw error;
    });
  };
};

var clearContactData = exports.clearContactData = function clearContactData() {

  return function (dispatch) {

    dispatch({ type: ACTION_SEARCH_CONTACT_DATA, Obj: {} });
    dispatch({ type: ACTION_SEARCH_AVISOS, Obj: [] });
  };
};

/***/ }),

/***/ 544:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.getPreDonationApprovalEvents = exports.GET_PRE_DONATION_APPROVED_EVENTS = undefined;

var _Utils = __webpack_require__(2);

var Utils = _interopRequireWildcard(_Utils);

var _ClientHttpRequest = __webpack_require__(5);

var _ClientHttpRequest2 = _interopRequireDefault(_ClientHttpRequest);

var _immutable = __webpack_require__(1);

var _immutable2 = _interopRequireDefault(_immutable);

var _Modal = __webpack_require__(4);

var _Loading = __webpack_require__(3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var initialState = _immutable2.default.Map({}).set('Search', new _immutable2.default.List([]));

/* Types */
var GET_PRE_DONATION_APPROVED_EVENTS = exports.GET_PRE_DONATION_APPROVED_EVENTS = 'GET_PRE_DONATION_APPROVED_EVENTS';

/* Reducer*/

exports.default = function () {
	var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	var action = arguments[1];


	switch (action.type) {
		case GET_PRE_DONATION_APPROVED_EVENTS:
			return state.set('Search', new _immutable2.default.List(action.Obj));
		default:
			return state;
	}
};

/* Action Creators */

var getPreDonationApprovalEvents = exports.getPreDonationApprovalEvents = function getPreDonationApprovalEvents() {

	return function (dispatch) {
		dispatch((0, _Loading.isLoading)(true));

		return new _ClientHttpRequest2.default({
			service: 'api/donativoPre/getPreDonationApprovalEvents',
			method: "POST",
			data: {},
			headers: Object.assign({ "Authorization": sessionStorage.access_token, "uid": sessionStorage.uid })
		}).request().then(function (response) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch({ type: GET_PRE_DONATION_APPROVED_EVENTS, Obj: response.data });
			return response.data;
		}).catch(function (error) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
			throw error;
		});
	};
};

/***/ }),

/***/ 545:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.clearReassignment = exports.getReassignment = exports.ACTION_GET_REASSIGNMENT = undefined;

var _Utils = __webpack_require__(2);

var Utils = _interopRequireWildcard(_Utils);

var _ClientHttpRequest = __webpack_require__(5);

var _ClientHttpRequest2 = _interopRequireDefault(_ClientHttpRequest);

var _immutable = __webpack_require__(1);

var _immutable2 = _interopRequireDefault(_immutable);

var _Modal = __webpack_require__(4);

var _Loading = __webpack_require__(3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var initialState = _immutable2.default.Map({}).set('GetReassignment', new _immutable2.default.Map({ tareas: { tarea: [] } }));

/*Types*/

var ACTION_GET_REASSIGNMENT = exports.ACTION_GET_REASSIGNMENT = 'ACTION_GET_REASSIGNMENT';

/*Reducer*/

exports.default = function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments[1];

  switch (action.type) {
    case ACTION_GET_REASSIGNMENT:
      return state.set('GetReassignment', new _immutable2.default.Map(action.Obj));
    default:
      return state;
  }
};

/*Action Creators*/

var getReassignment = exports.getReassignment = function getReassignment() {

  return function (dispatch) {
    dispatch((0, _Loading.isLoading)(true));

    return new _ClientHttpRequest2.default({
      service: 'api/getReassignment',
      method: 'POST',
      data: { usuarioReasignado: sessionStorage.uid },
      headers: Object.assign({ 'Authorization': sessionStorage.access_token, "Bpm": sessionStorage.bpm_token, 'uid': sessionStorage.uid })
    }).request().then(function (response) {
      dispatch((0, _Loading.isLoading)(false));
      dispatch({ type: ACTION_GET_REASSIGNMENT, Obj: !response.data.tareas ? { tareas: { tarea: [] } } : response.data });
      return response;
    }).catch(function (error) {
      dispatch((0, _Loading.isLoading)(false));
      dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
      throw error;
    });
  };
};

var clearReassignment = exports.clearReassignment = function clearReassignment() {

  return function (dispatch) {
    dispatch({ type: ACTION_GET_REASSIGNMENT, Obj: { tareas: { tarea: [] } } });
  };
};

/***/ }),

/***/ 546:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.postCheckAssignment = exports.getMaxAssignment = exports.getDataBank = exports.ACTION_POST_CHECK_ASSIGNMENT = exports.ACTION_GET_MAX_ASSIGNMENT = exports.ACTION_GET_DATA_BANK = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _Utils = __webpack_require__(2);

var Utils = _interopRequireWildcard(_Utils);

var _ClientHttpRequest = __webpack_require__(5);

var _ClientHttpRequest2 = _interopRequireDefault(_ClientHttpRequest);

var _immutable = __webpack_require__(1);

var _immutable2 = _interopRequireDefault(_immutable);

var _Modal = __webpack_require__(4);

var _Loading = __webpack_require__(3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var initialState = _immutable2.default.Map({}).set('Get', new _immutable2.default.List([])).set('GetAssignment', new _immutable2.default.List([])).set('CheckAssignment', new _immutable2.default.List([]));

/*Types*/
var ACTION_GET_DATA_BANK = exports.ACTION_GET_DATA_BANK = "ACTION_GET_DATA_BANK";
var ACTION_GET_MAX_ASSIGNMENT = exports.ACTION_GET_MAX_ASSIGNMENT = "ACTION_GET_MAX_ASSIGNMENT";
var ACTION_POST_CHECK_ASSIGNMENT = exports.ACTION_POST_CHECK_ASSIGNMENT = "ACTION_POST_CHECK_ASSIGNMENT";

/*Reducer*/

exports.default = function () {
	var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	var action = arguments[1];


	switch (action.type) {
		case ACTION_GET_DATA_BANK:
			return state.set('Get', new _immutable2.default.List(action.Obj));
		case ACTION_GET_MAX_ASSIGNMENT:
			return state.set('GetAssignment', new _immutable2.default.List(action.Obj));
		case ACTION_POST_CHECK_ASSIGNMENT:
			return state.set('CheckAssignment', new _immutable2.default.List(action.Obj));
		default:
			return state;
	}
};

/*Action Creators*/


var getDataBank = exports.getDataBank = function getDataBank(idDonataria) {
	return function (dispatch) {
		dispatch((0, _Loading.isLoading)(true));

		return new _ClientHttpRequest2.default({
			service: 'api/getDataBank',
			method: 'POST',
			data: _extends({}, idDonataria),
			headers: Object.assign({ "Authorization": sessionStorage.access_token, "uid": sessionStorage.uid })
		}).request().then(function (response) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch({ type: ACTION_GET_DATA_BANK, Obj: response.data });
		}).catch(function (error) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
			throw error;
		});
	};
};

var getMaxAssignment = exports.getMaxAssignment = function getMaxAssignment(form) {
	return function (dispatch) {
		dispatch((0, _Loading.isLoading)(true));

		return new _ClientHttpRequest2.default({
			service: 'api/getMaxAssignment',
			method: 'POST',
			data: _extends({}, form),
			headers: Object.assign({ "Authorization": sessionStorage.access_token, "uid": sessionStorage.uid })
		}).request().then(function (response) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch({ type: ACTION_GET_MAX_ASSIGNMENT, Obj: response.data });
		}).catch(function (error) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
			throw error;
		});
	};
};

var postCheckAssignment = exports.postCheckAssignment = function postCheckAssignment(form) {
	return function (dispatch) {
		dispatch((0, _Loading.isLoading)(true));

		return new _ClientHttpRequest2.default({
			service: 'api/postAssignment',
			method: 'POST',
			data: _extends({}, form),
			headers: Object.assign({ "Authorization": sessionStorage.access_token, "uid": sessionStorage.uid })
		}).request().then(function (response) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch({ type: ACTION_POST_CHECK_ASSIGNMENT, Obj: response.data });
		}).catch(function (error) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
			throw error;
		});
	};
};

/***/ }),

/***/ 547:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setSearchBuzon = exports.setClearInformation = exports.setInformation = exports.ACTION_SEARCH_COMPONENT = exports.ACTION_INFORMATION_COMPONENT = undefined;

var _immutable = __webpack_require__(1);

var _immutable2 = _interopRequireDefault(_immutable);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var initialState = _immutable2.default.Map({}).set('Information', new _immutable2.default.Map({})).set('SearchBuzon', new _immutable2.default.Map({}));

/* Types */
var ACTION_INFORMATION_COMPONENT = exports.ACTION_INFORMATION_COMPONENT = 'ACTION_INFORMATION_COMPONENT';
var ACTION_SEARCH_COMPONENT = exports.ACTION_SEARCH_COMPONENT = 'ACTION_SEARCH_COMPONENT';

/* Reducer */

exports.default = function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments[1];


  switch (action.type) {

    case ACTION_INFORMATION_COMPONENT:
      return state.set('Information', new _immutable2.default.Map(action.Obj));
    case ACTION_SEARCH_COMPONENT:
      return state.set('SearchBuzon', new _immutable2.default.Map(action.Obj));
    default:
      return state;
  }
};

/* Action Creators */

var setInformation = exports.setInformation = function setInformation(form) {
  return function (dispatch) {
    dispatch({ type: ACTION_INFORMATION_COMPONENT, Obj: form });
  };
};

var setClearInformation = exports.setClearInformation = function setClearInformation() {
  return function (dispatch) {
    dispatch({ type: ACTION_INFORMATION_COMPONENT, Obj: {} });
  };
};

var setSearchBuzon = exports.setSearchBuzon = function setSearchBuzon(form) {

  return function (dispatch) {
    dispatch({ type: ACTION_SEARCH_COMPONENT, Obj: form });
  };
};

/***/ }),

/***/ 548:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.clearDonatios = exports.insertDonatarias = exports.clearIndicadores = exports.getCorrida5Anios = exports.getIndicadores = exports.getDonation = exports.getDonatariaIndicador = exports.ACTION_GET_CORRIDA_5 = exports.ACTION_GET_INDICADORES = exports.ACTION_GET_DONATIONS = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _Utils = __webpack_require__(2);

var Utils = _interopRequireWildcard(_Utils);

var _ClientHttpRequest = __webpack_require__(5);

var _ClientHttpRequest2 = _interopRequireDefault(_ClientHttpRequest);

var _immutable = __webpack_require__(1);

var _immutable2 = _interopRequireDefault(_immutable);

var _Modal = __webpack_require__(4);

var _Loading = __webpack_require__(3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var initialState = _immutable2.default.Map({}).set('listDonatarias', new _immutable2.default.List([])).set('listCorrida', new _immutable2.default.List([])).set('listIndicadores', new _immutable2.default.List([]));

/* Types */
var ACTION_GET_DONATIONS = exports.ACTION_GET_DONATIONS = "ACTION_GET_DONATIONS";
var ACTION_GET_INDICADORES = exports.ACTION_GET_INDICADORES = "ACTION_GET_INDICADORES";
var ACTION_GET_CORRIDA_5 = exports.ACTION_GET_CORRIDA_5 = "ACTION_GET_CORRIDA_5";

/* Reducer */

exports.default = function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments[1];


  switch (action.type) {
    case ACTION_GET_DONATIONS:
      return state.set('listDonatarias', new _immutable2.default.List(action.Obj));
    case ACTION_GET_INDICADORES:
      return state.set('listIndicadores', new _immutable2.default.List(action.Obj));
    case ACTION_GET_CORRIDA_5:
      return state.set('listCorrida', new _immutable2.default.List(action.Obj));
    default:
      return state;
  }
};

var getDonatariaIndicador = exports.getDonatariaIndicador = function getDonatariaIndicador(form) {

  return function (dispatch) {
    dispatch((0, _Loading.isLoading)(true));

    return new _ClientHttpRequest2.default({
      service: 'api/getDonatariaIndicador',
      method: 'POST',
      data: _extends({}, form),
      headers: Object.assign({ "Authorization": sessionStorage.access_token, "uid": sessionStorage.uid })
    }).request().then(function (response) {
      dispatch((0, _Loading.isLoading)(false));

      dispatch({
        type: ACTION_GET_DONATIONS,
        Obj: response.data
      });
    }).catch(function (error) {
      dispatch((0, _Loading.isLoading)(false));

      dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
      throw error;
    });
  };
};

/* Action Creators */
var getDonation = exports.getDonation = function getDonation(form) {

  return function (dispatch) {
    dispatch((0, _Loading.isLoading)(true));

    return new _ClientHttpRequest2.default({
      service: 'api/getDonationCorridas',
      method: 'POST',
      data: _extends({}, form),
      headers: Object.assign({ "Authorization": sessionStorage.access_token, "uid": sessionStorage.uid })
    }).request().then(function (response) {
      dispatch((0, _Loading.isLoading)(false));

      dispatch({
        type: ACTION_GET_DONATIONS,
        Obj: response.data
      });
    }).catch(function (error) {
      dispatch((0, _Loading.isLoading)(false));

      dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
      throw error;
    });
  };
};

var getIndicadores = exports.getIndicadores = function getIndicadores(form) {

  return function (dispatch) {
    dispatch((0, _Loading.isLoading)(true));

    return new _ClientHttpRequest2.default({
      service: 'api/getIndicadorCorridas',
      method: 'POST',
      data: _extends({}, form),
      headers: Object.assign({ "Authorization": sessionStorage.access_token, "uid": sessionStorage.uid })
    }).request().then(function (response) {
      dispatch((0, _Loading.isLoading)(false));

      dispatch({
        type: ACTION_GET_INDICADORES,
        Obj: response.data
      });
    }).catch(function (error) {
      dispatch((0, _Loading.isLoading)(false));

      dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
      throw error;
    });
  };
};

var getCorrida5Anios = exports.getCorrida5Anios = function getCorrida5Anios(form) {

  return function (dispatch) {
    dispatch((0, _Loading.isLoading)(true));

    return new _ClientHttpRequest2.default({
      service: 'api/getCorrida5Anios',
      method: 'POST',
      data: _extends({}, form),
      headers: Object.assign({ "Authorization": sessionStorage.access_token, "uid": sessionStorage.uid })
    }).request().then(function (response) {
      dispatch((0, _Loading.isLoading)(false));

      dispatch({
        type: ACTION_GET_CORRIDA_5,
        Obj: response.data
      });
    }).catch(function (error) {
      dispatch((0, _Loading.isLoading)(false));

      dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
      throw error;
    });
  };
};

var clearIndicadores = exports.clearIndicadores = function clearIndicadores(form) {

  return function (dispatch) {
    dispatch({
      type: ACTION_GET_INDICADORES,
      Obj: new _immutable2.default.List(Utils.createTableDonatarias([]))
    });
  };
};

var insertDonatarias = exports.insertDonatarias = function insertDonatarias(form) {
  return function (dispatch) {
    dispatch({
      type: ACTION_GET_DONATIONS,
      Obj: new _immutable2.default.List(Utils.createTableDonatarias(form))
    });
  };
};

var clearDonatios = exports.clearDonatios = function clearDonatios(form) {

  return function (dispatch) {
    dispatch({
      type: ACTION_GET_DONATIONS,
      Obj: new _immutable2.default.List(Utils.createTableDonatarias([]))
    });
  };
};

/***/ }),

/***/ 549:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.getExpressDonation = exports.ACTION_EXPRESS_DONATION = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _Utils = __webpack_require__(2);

var Utils = _interopRequireWildcard(_Utils);

var _ClientHttpRequest = __webpack_require__(5);

var _ClientHttpRequest2 = _interopRequireDefault(_ClientHttpRequest);

var _immutable = __webpack_require__(1);

var _immutable2 = _interopRequireDefault(_immutable);

var _Modal = __webpack_require__(4);

var _Loading = __webpack_require__(3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var initialState = _immutable2.default.Map({}).set('Search', new _immutable2.default.List([]));

/* Types */
var ACTION_EXPRESS_DONATION = exports.ACTION_EXPRESS_DONATION = 'ACTION_EXPRESS_DONATION';

/* Reducer */

exports.default = function () {
	var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	var action = arguments[1];


	switch (action.type) {

		case ACTION_EXPRESS_DONATION:
			return state.set('Search', new _immutable2.default.List(action.Obj));
		default:
			return state;
	}
};

/* Action Creators */

var getExpressDonation = exports.getExpressDonation = function getExpressDonation(form) {

	return function (dispatch) {

		dispatch((0, _Loading.isLoading)(true));

		return new _ClientHttpRequest2.default({
			service: 'api/getExpressDonation',
			method: "POST",
			data: _extends({}, form),
			headers: Object.assign({ "Authorization": sessionStorage.access_token, "uid": sessionStorage.uid })
		}).request().then(function (response) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch({ type: ACTION_EXPRESS_DONATION, Obj: response.data });
			return response.data;
		}).catch(function (error) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch({ type: ACTION_EXPRESS_DONATION, Obj: [] });
			dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
			throw error;
		});
	};
};

/***/ }),

/***/ 550:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.setDonataria = exports.getDonatarias = exports.ACTION_SET_DATA = exports.ACTION_GET_DATA = undefined;

var _Utils = __webpack_require__(2);

var Utils = _interopRequireWildcard(_Utils);

var _ClientHttpRequest = __webpack_require__(5);

var _ClientHttpRequest2 = _interopRequireDefault(_ClientHttpRequest);

var _immutable = __webpack_require__(1);

var _immutable2 = _interopRequireDefault(_immutable);

var _Modal = __webpack_require__(4);

var _Loading = __webpack_require__(3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var initialState = _immutable2.default.Map({}).set('Get', new _immutable2.default.Map({})).set('Set', new _immutable2.default.Map({}));

/* Types */

var ACTION_GET_DATA = exports.ACTION_GET_DATA = 'ACTION_GET_DATA';
var ACTION_SET_DATA = exports.ACTION_SET_DATA = 'ACTION_SET_DATA';

/* Reducer */

exports.default = function () {
	var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	var action = arguments[1];


	switch (action.type) {
		case ACTION_GET_DATA:
			return state.set('Get', new _immutable2.default.Map(action.Obj));
		case ACTION_SET_DATA:
			return state.set('Set', new _immutable2.default.Map(action.Obj));
		default:
			return state;
	}
};

/* Action Creators */

var getDonatarias = exports.getDonatarias = function getDonatarias() {

	return function (dispatch) {

		dispatch((0, _Loading.isLoading)(true));
		dispatch({ type: ACTION_GET_DATA, Obj: {} });

		return new _ClientHttpRequest2.default({
			service: 'api/getDonatarias',
			method: "GET",
			data: {},
			headers: Object.assign({ "Authorization": sessionStorage.access_token, "uid": sessionStorage.uid })
		}).request().then(function (response) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch({ type: ACTION_GET_DATA, Obj: response.data });
		}).catch(function (error) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
			throw error;
		});
	};
};

var setDonataria = exports.setDonataria = function setDonataria(form) {

	return function (dispatch) {

		dispatch((0, _Loading.isLoading)(true));
		dispatch({ type: ACTION_SET_DATA, Obj: {} });

		return new _ClientHttpRequest2.default({
			service: 'api/setDonataria',
			method: "POST",
			data: form,
			headers: Object.assign({ "Authorization": sessionStorage.access_token, "uid": sessionStorage.uid })
		}).request().then(function (response) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch({ type: ACTION_SET_DATA, Obj: response.data });
		}).catch(function (error) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
			throw error;
		});
	};
};

/***/ }),

/***/ 551:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.setEvaluacionDonataria = exports.putBanderaCorridaDonataria = exports.getCatalogEstadoBandera = exports.getCatalogTipoEvaluacion = exports.getCatalogEstadoEvaluacion = exports.getCatalogEstados = exports.getCatalogCorrida = exports.ACTION_SET_SERVICE_EVALUACION = exports.ACTION_PUT_SERVICE_BANDERA_ESTADO = exports.ACTION_GET_SERVICE_BANDERA_ESTADO = exports.ACTION_GET_SERVICE_EVALUACION_ESTADO = exports.ACTION_GET_SERVICE_EVALUACION_TIPO = exports.ACTION_GET_SERVICE_ESTADOS = exports.ACTION_GET_SERVICE_CORRIDA = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _Utils = __webpack_require__(2);

var Utils = _interopRequireWildcard(_Utils);

var _ClientHttpRequest = __webpack_require__(5);

var _ClientHttpRequest2 = _interopRequireDefault(_ClientHttpRequest);

var _immutable = __webpack_require__(1);

var _immutable2 = _interopRequireDefault(_immutable);

var _Modal = __webpack_require__(4);

var _Loading = __webpack_require__(3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var initialState = _immutable2.default.Map({}).set('request_corrida', new _immutable2.default.Map({})).set('request_estados', new _immutable2.default.Map({})).set('request_evaluacion_estado', new _immutable2.default.Map({})).set('request_evaluacion_tipo', new _immutable2.default.Map({})).set('request_estado_bandera', new _immutable2.default.Map({})).set('set_evaluacion', new _immutable2.default.Map({}));

/* Types */

var ACTION_GET_SERVICE_CORRIDA = exports.ACTION_GET_SERVICE_CORRIDA = 'ACTION_GET_SERVICE_CORRIDA';
var ACTION_GET_SERVICE_ESTADOS = exports.ACTION_GET_SERVICE_ESTADOS = 'ACTION_GET_SERVICE_ESTADOS';
var ACTION_GET_SERVICE_EVALUACION_TIPO = exports.ACTION_GET_SERVICE_EVALUACION_TIPO = 'ACTION_GET_SERVICE_EVALUACION_TIPO';
var ACTION_GET_SERVICE_EVALUACION_ESTADO = exports.ACTION_GET_SERVICE_EVALUACION_ESTADO = 'ACTION_GET_SERVICE_EVALUACION_ESTADO';
var ACTION_GET_SERVICE_BANDERA_ESTADO = exports.ACTION_GET_SERVICE_BANDERA_ESTADO = 'ACTION_GET_SERVICE_BANDERA_ESTADO';
var ACTION_PUT_SERVICE_BANDERA_ESTADO = exports.ACTION_PUT_SERVICE_BANDERA_ESTADO = 'ACTION_PUT_SERVICE_BANDERA_ESTADO';
var ACTION_SET_SERVICE_EVALUACION = exports.ACTION_SET_SERVICE_EVALUACION = 'ACTION_SET_SERVICE_EVALUACION';

/* Reducer */

exports.default = function () {
	var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	var action = arguments[1];


	switch (action.type) {
		case ACTION_GET_SERVICE_CORRIDA:
			return state.set('request_corrida', new _immutable2.default.Map(action.Obj));
		case ACTION_GET_SERVICE_ESTADOS:
			return state.set('request_estados', new _immutable2.default.Map(action.Obj));
		case ACTION_GET_SERVICE_EVALUACION_TIPO:
			return state.set('request_evaluacion_estado', new _immutable2.default.Map(action.Obj));
		case ACTION_GET_SERVICE_EVALUACION_ESTADO:
			return state.set('request_evaluacion_tipo', new _immutable2.default.Map(action.Obj));
		case ACTION_GET_SERVICE_BANDERA_ESTADO:
			return state.set('request_estado_bandera', new _immutable2.default.Map(action.Obj));
		case ACTION_PUT_SERVICE_BANDERA_ESTADO:
			return state.set('put_estado_bandera', new _immutable2.default.Map(action.Obj));
		case ACTION_SET_SERVICE_EVALUACION:
			return state.set('set_evaluacion', new _immutable2.default.Map(action.Obj));
		default:
			return state;
	}
};

/* Action Creators */

var getCatalogCorrida = exports.getCatalogCorrida = function getCatalogCorrida(form) {

	return function (dispatch) {

		dispatch((0, _Loading.isLoading)(true));
		dispatch({ type: ACTION_GET_SERVICE_CORRIDA, Obj: {} });

		return new _ClientHttpRequest2.default({
			service: 'api/getCatalogCorrida',
			method: "POST",
			data: _extends({}, form),
			headers: Object.assign({ "Authorization": sessionStorage.access_token, "uid": sessionStorage.uid })
		}).request().then(function (response) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch({ type: ACTION_GET_SERVICE_CORRIDA, Obj: response.data });
		}).catch(function (error) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
			throw error;
		});
	};
};

var getCatalogEstados = exports.getCatalogEstados = function getCatalogEstados(form) {

	return function (dispatch) {

		dispatch((0, _Loading.isLoading)(true));
		dispatch({ type: ACTION_GET_SERVICE_ESTADOS, Obj: {} });

		return new _ClientHttpRequest2.default({
			service: 'api/getCatalogEstados',
			method: "POST",
			data: _extends({}, form),
			headers: Object.assign({ "Authorization": sessionStorage.access_token, "uid": sessionStorage.uid })
		}).request().then(function (response) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch({ type: ACTION_GET_SERVICE_ESTADOS, Obj: response.data });
		}).catch(function (error) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
			throw error;
		});
	};
};

var getCatalogEstadoEvaluacion = exports.getCatalogEstadoEvaluacion = function getCatalogEstadoEvaluacion(form) {

	return function (dispatch) {

		dispatch((0, _Loading.isLoading)(true));
		dispatch({ type: ACTION_GET_SERVICE_EVALUACION_ESTADO, Obj: {} });

		return new _ClientHttpRequest2.default({
			service: 'api/getCatalogEstadoEvaluacion',
			method: "GET",
			data: {},
			headers: Object.assign({ "Authorization": sessionStorage.access_token, "uid": sessionStorage.uid })
		}).request().then(function (response) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch({ type: ACTION_GET_SERVICE_EVALUACION_ESTADO, Obj: response.data });
		}).catch(function (error) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
			throw error;
		});
	};
};

var getCatalogTipoEvaluacion = exports.getCatalogTipoEvaluacion = function getCatalogTipoEvaluacion(form) {

	return function (dispatch) {

		dispatch((0, _Loading.isLoading)(true));
		dispatch({ type: ACTION_GET_SERVICE_EVALUACION_TIPO, Obj: {} });

		return new _ClientHttpRequest2.default({
			service: 'api/getCatalogTipoEvaluacion',
			method: "GET",
			data: {},
			headers: Object.assign({ "Authorization": sessionStorage.access_token, "uid": sessionStorage.uid })
		}).request().then(function (response) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch({ type: ACTION_GET_SERVICE_EVALUACION_TIPO, Obj: response.data });
		}).catch(function (error) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
			throw error;
		});
	};
};

var getCatalogEstadoBandera = exports.getCatalogEstadoBandera = function getCatalogEstadoBandera(form) {

	return function (dispatch) {

		dispatch((0, _Loading.isLoading)(true));
		dispatch({ type: ACTION_GET_SERVICE_BANDERA_ESTADO, Obj: {} });

		return new _ClientHttpRequest2.default({
			service: 'api/getCatalogEstadoBandera',
			method: "GET",
			data: {},
			headers: Object.assign({ "Authorization": sessionStorage.access_token, "uid": sessionStorage.uid })
		}).request().then(function (response) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch({ type: ACTION_GET_SERVICE_BANDERA_ESTADO, Obj: response.data });
		}).catch(function (error) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
			throw error;
		});
	};
};

var putBanderaCorridaDonataria = exports.putBanderaCorridaDonataria = function putBanderaCorridaDonataria(form) {

	return function (dispatch) {

		dispatch((0, _Loading.isLoading)(true));
		dispatch({ type: ACTION_PUT_SERVICE_BANDERA_ESTADO, Obj: {} });

		return new _ClientHttpRequest2.default({
			service: 'api/putBanderaCorridaDonataria',
			method: "POST",
			data: _extends({}, form),
			headers: Object.assign({ "Authorization": sessionStorage.access_token, "uid": sessionStorage.uid })
		}).request().then(function (response) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch({ type: ACTION_PUT_SERVICE_BANDERA_ESTADO, Obj: response.data });
		}).catch(function (error) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
			throw error;
		});
	};
};

var setEvaluacionDonataria = exports.setEvaluacionDonataria = function setEvaluacionDonataria(form) {

	return function (dispatch) {

		dispatch((0, _Loading.isLoading)(true));
		dispatch({ type: ACTION_SET_SERVICE_EVALUACION, Obj: {} });

		return new _ClientHttpRequest2.default({
			service: 'api/setEvaluacionDonataria',
			method: "POST",
			data: _extends({}, form),
			headers: Object.assign({ "Authorization": sessionStorage.access_token, "uid": sessionStorage.uid })
		}).request().then(function (response) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch({ type: ACTION_SET_SERVICE_EVALUACION, Obj: response.data });
		}).catch(function (error) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
			throw error;
		});
	};
};

/***/ }),

/***/ 552:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.postReassignmentTaskGroup = exports.reassignmentTastDirect = exports.getReassignmentTask = exports.ACTION_POST_REASSIGNMENT_TASK_GROUP = exports.ACTION_POST_REASSIGNMENT_TASK_DIRECT = exports.ACTION_GET_REASSIGNMENT_TASK = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _Utils = __webpack_require__(2);

var Utils = _interopRequireWildcard(_Utils);

var _ClientHttpRequest = __webpack_require__(5);

var _ClientHttpRequest2 = _interopRequireDefault(_ClientHttpRequest);

var _immutable = __webpack_require__(1);

var _immutable2 = _interopRequireDefault(_immutable);

var _Modal = __webpack_require__(4);

var _Loading = __webpack_require__(3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var initialState = _immutable2.default.Map({}).set('get_reassignment_task', new _immutable2.default.Map({})).set('post_reassignment_task_direct', new _immutable2.default.Map({})).set('post_reassignment_task_group', new _immutable2.default.Map({}));

/* Types */

var ACTION_GET_REASSIGNMENT_TASK = exports.ACTION_GET_REASSIGNMENT_TASK = 'ACTION_GET_REASSIGNMENT_TASK';
var ACTION_POST_REASSIGNMENT_TASK_DIRECT = exports.ACTION_POST_REASSIGNMENT_TASK_DIRECT = 'ACTION_POST_REASSIGNMENT_TASK_DIRECT';
var ACTION_POST_REASSIGNMENT_TASK_GROUP = exports.ACTION_POST_REASSIGNMENT_TASK_GROUP = 'ACTION_POST_REASSIGNMENT_TASK_GROUP';

/* Reducer */

exports.default = function () {
	var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	var action = arguments[1];


	switch (action.type) {
		case ACTION_GET_REASSIGNMENT_TASK:
			return state.set('get_reassignment_task', new _immutable2.default.Map(action.Obj));
		case ACTION_POST_REASSIGNMENT_TASK_DIRECT:
			return state.set('post_reassignment_task_direct', new _immutable2.default.Map(action.Obj));
		case ACTION_POST_REASSIGNMENT_TASK_GROUP:
			return state.set('post_reassignment_task_group', new _immutable2.default.Map(action.Obj));
		default:
			return state;
	}
};

/* Action Creators */

var getReassignmentTask = exports.getReassignmentTask = function getReassignmentTask(form) {

	return function (dispatch) {

		dispatch((0, _Loading.isLoading)(true));
		dispatch({ type: ACTION_GET_REASSIGNMENT_TASK, Obj: {} });

		return new _ClientHttpRequest2.default({
			service: 'api/getReassignmentTask/',
			method: "POST",
			data: _extends({}, form),
			headers: Object.assign({ "Authorization": sessionStorage.access_token, "uid": sessionStorage.uid })
		}).request().then(function (response) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch({ type: ACTION_GET_REASSIGNMENT_TASK, Obj: response.data });
		}).catch(function (error) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
			throw error;
		});
	};
};

var reassignmentTastDirect = exports.reassignmentTastDirect = function reassignmentTastDirect(form) {

	return function (dispatch) {

		dispatch((0, _Loading.isLoading)(true));
		dispatch({ type: ACTION_POST_REASSIGNMENT_TASK_DIRECT, Obj: {} });

		return new _ClientHttpRequest2.default({
			service: 'api/reassignmentTastDirect/',
			method: "POST",
			data: _extends({}, form),
			headers: Object.assign({ "Authorization": sessionStorage.access_token, "uid": sessionStorage.uid })
		}).request().then(function (response) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch({ type: ACTION_POST_REASSIGNMENT_TASK_DIRECT, Obj: response.data });
		}).catch(function (error) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
			throw error;
		});
	};
};

var postReassignmentTaskGroup = exports.postReassignmentTaskGroup = function postReassignmentTaskGroup(form) {

	return function (dispatch) {

		dispatch((0, _Loading.isLoading)(true));
		dispatch({ type: ACTION_POST_REASSIGNMENT_TASK_GROUP, Obj: {} });

		return new _ClientHttpRequest2.default({
			service: 'api/postReassignmentTaskGroup/',
			method: "POST",
			data: _extends({}, form),
			headers: Object.assign({ "Authorization": sessionStorage.access_token, "uid": sessionStorage.uid })
		}).request().then(function (response) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch({ type: ACTION_POST_REASSIGNMENT_TASK_GROUP, Obj: response.data });
		}).catch(function (error) {
			dispatch((0, _Loading.isLoading)(false));
			dispatch((0, _Modal.createModal)(Utils.errorMessage(Utils.getMessageResponse(error.response.data))));
			throw error;
		});
	};
};

/***/ }),

/***/ 553:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _reactCodeSplitting = __webpack_require__(554);

var _reactCodeSplitting2 = _interopRequireDefault(_reactCodeSplitting);

__webpack_require__(558);

__webpack_require__(560);

__webpack_require__(561);

__webpack_require__(562);

__webpack_require__(563);

__webpack_require__(564);

__webpack_require__(565);

__webpack_require__(566);

var _reactRouterDom = __webpack_require__(396);

var _reactRedux = __webpack_require__(390);

var _store = __webpack_require__(633);

var _store2 = _interopRequireDefault(_store);

var _reactDom = __webpack_require__(23);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var App = function App(props) {
	return _react2.default.createElement(_reactCodeSplitting2.default, { load: __webpack_require__.e/* import() */(42).then(__webpack_require__.bind(null, 1051)), componentProps: props });
};
var Activate = function Activate(props) {
	return _react2.default.createElement(_reactCodeSplitting2.default, { load: __webpack_require__.e/* import() */(47).then(__webpack_require__.bind(null, 1052)), componentProps: props });
};
var EvaluationApp = function EvaluationApp(props) {
	return _react2.default.createElement(_reactCodeSplitting2.default, { load: __webpack_require__.e/* import() */(57).then(__webpack_require__.bind(null, 1053)), componentProps: props });
};
var GranteeApp = function GranteeApp(props) {
	return _react2.default.createElement(_reactCodeSplitting2.default, { load: __webpack_require__.e/* import() */(46).then(__webpack_require__.bind(null, 1054)), componentProps: props });
};
var OportunitiesApp = function OportunitiesApp(props) {
	return _react2.default.createElement(_reactCodeSplitting2.default, { load: __webpack_require__.e/* import() */(55).then(__webpack_require__.bind(null, 1055)), componentProps: props });
};
var PrincipalApp = function PrincipalApp(props) {
	return _react2.default.createElement(_reactCodeSplitting2.default, { load: __webpack_require__.e/* import() */(54).then(__webpack_require__.bind(null, 1056)), componentProps: props });
};
var PreRegister = function PreRegister(props) {
	return _react2.default.createElement(_reactCodeSplitting2.default, { load: __webpack_require__.e/* import() */(31).then(__webpack_require__.bind(null, 1057)), componentProps: props });
};
var Loading = function Loading(props) {
	return _react2.default.createElement(_reactCodeSplitting2.default, { load: __webpack_require__.e/* import() */(60).then(__webpack_require__.bind(null, 1058)), componentProps: props });
};
var Login = function Login(props) {
	return _react2.default.createElement(_reactCodeSplitting2.default, { load: __webpack_require__.e/* import() */(35).then(__webpack_require__.bind(null, 1059)), componentProps: props });
};
var Dashboard = function Dashboard(props) {
	return _react2.default.createElement(_reactCodeSplitting2.default, { load: __webpack_require__.e/* import() */(51).then(__webpack_require__.bind(null, 1060)), componentProps: props });
};
var DashboardDetail = function DashboardDetail(props) {
	return _react2.default.createElement(_reactCodeSplitting2.default, { load: __webpack_require__.e/* import() */(45).then(__webpack_require__.bind(null, 1061)), componentProps: props });
};
var DashboardSupervisor = function DashboardSupervisor(props) {
	return _react2.default.createElement(_reactCodeSplitting2.default, { load: __webpack_require__.e/* import() */(48).then(__webpack_require__.bind(null, 1062)), componentProps: props });
};
var AssignmentFilter = function AssignmentFilter(props) {
	return _react2.default.createElement(_reactCodeSplitting2.default, { load: __webpack_require__.e/* import() */(0).then(__webpack_require__.bind(null, 1063)), componentProps: props });
};
var ProposalAssignment = function ProposalAssignment(props) {
	return _react2.default.createElement(_reactCodeSplitting2.default, { load: __webpack_require__.e/* import() */(4).then(__webpack_require__.bind(null, 1064)), componentProps: props });
};
var ProposalAssignmentEjec = function ProposalAssignmentEjec(props) {
	return _react2.default.createElement(_reactCodeSplitting2.default, { load: __webpack_require__.e/* import() */(1).then(__webpack_require__.bind(null, 1065)), componentProps: props });
};
var ChangeDestination = function ChangeDestination(props) {
	return _react2.default.createElement(_reactCodeSplitting2.default, { load: __webpack_require__.e/* import() */(17).then(__webpack_require__.bind(null, 1066)), componentProps: props });
};
var ChangeDestinitySuperDirector = function ChangeDestinitySuperDirector(props) {
	return _react2.default.createElement(_reactCodeSplitting2.default, { load: __webpack_require__.e/* import() */(29).then(__webpack_require__.bind(null, 1067)), componentProps: props });
};
var Announcement = function Announcement(props) {
	return _react2.default.createElement(_reactCodeSplitting2.default, { load: __webpack_require__.e/* import() */(36).then(__webpack_require__.bind(null, 1068)), componentProps: props });
};
var Approach = function Approach(props) {
	return _react2.default.createElement(_reactCodeSplitting2.default, { load: __webpack_require__.e/* import() */(8).then(__webpack_require__.bind(null, 1069)), componentProps: props });
};
var AssignmentProfile = function AssignmentProfile(props) {
	return _react2.default.createElement(_reactCodeSplitting2.default, { load: __webpack_require__.e/* import() */(7).then(__webpack_require__.bind(null, 1070)), componentProps: props });
};
var AverageOfExpenses = function AverageOfExpenses(props) {
	return _react2.default.createElement(_reactCodeSplitting2.default, { load: __webpack_require__.e/* import() */(14).then(__webpack_require__.bind(null, 1071)), componentProps: props });
};
var AverageExpAndSeveralEval = function AverageExpAndSeveralEval(props) {
	return _react2.default.createElement(_reactCodeSplitting2.default, { load: __webpack_require__.e/* import() */(34).then(__webpack_require__.bind(null, 1072)), componentProps: props });
};
var DecOrIncDonationAssigned = function DecOrIncDonationAssigned(props) {
	return _react2.default.createElement(_reactCodeSplitting2.default, { load: __webpack_require__.e/* import() */(19).then(__webpack_require__.bind(null, 1073)), componentProps: props });
};
var VariationEvaluationClosed = function VariationEvaluationClosed(props) {
	return _react2.default.createElement(_reactCodeSplitting2.default, { load: __webpack_require__.e/* import() */(19/* aggressive-merge */).then(__webpack_require__.bind(null, 1074)), componentProps: props });
};
var VariationEvaluationOpened = function VariationEvaluationOpened(props) {
	return _react2.default.createElement(_reactCodeSplitting2.default, { load: __webpack_require__.e/* import() */(33).then(__webpack_require__.bind(null, 1075)), componentProps: props });
};
var ClosedQuestion = function ClosedQuestion(props) {
	return _react2.default.createElement(_reactCodeSplitting2.default, { load: __webpack_require__.e/* import() */(2).then(__webpack_require__.bind(null, 1076)), componentProps: props });
};
var CommentsQuestion = function CommentsQuestion(props) {
	return _react2.default.createElement(_reactCodeSplitting2.default, { load: __webpack_require__.e/* import() */(2/* aggressive-merge */).then(__webpack_require__.bind(null, 1077)), componentProps: props });
};
var Congrats = function Congrats(props) {
	return _react2.default.createElement(_reactCodeSplitting2.default, { load: __webpack_require__.e/* import() */(56).then(__webpack_require__.bind(null, 1078)), componentProps: props });
};
var Consultant = function Consultant(props) {
	return _react2.default.createElement(_reactCodeSplitting2.default, { load: __webpack_require__.e/* import() */(11).then(__webpack_require__.bind(null, 1079)), componentProps: props });
};
var Criteria = function Criteria(props) {
	return _react2.default.createElement(_reactCodeSplitting2.default, { load: __webpack_require__.e/* import() */(0/* aggressive-merge */).then(__webpack_require__.bind(null, 1080)), componentProps: props });
};
var DocNames = function DocNames(props) {
	return _react2.default.createElement(_reactCodeSplitting2.default, { load: __webpack_require__.e/* import() */(9).then(__webpack_require__.bind(null, 1081)), componentProps: props });
};
var DocStatus = function DocStatus(props) {
	return _react2.default.createElement(_reactCodeSplitting2.default, { load: __webpack_require__.e/* import() */(6).then(__webpack_require__.bind(null, 1082)), componentProps: props });
};
var Donors = function Donors(props) {
	return _react2.default.createElement(_reactCodeSplitting2.default, { load: __webpack_require__.e/* import() */(16).then(__webpack_require__.bind(null, 1083)), componentProps: props });
};
var EligibilityCriteria = function EligibilityCriteria(props) {
	return _react2.default.createElement(_reactCodeSplitting2.default, { load: __webpack_require__.e/* import() */(20).then(__webpack_require__.bind(null, 1084)), componentProps: props });
};
var EmployerRole = function EmployerRole(props) {
	return _react2.default.createElement(_reactCodeSplitting2.default, { load: __webpack_require__.e/* import() */(13).then(__webpack_require__.bind(null, 1085)), componentProps: props });
};
var EvaluationVariable = function EvaluationVariable(props) {
	return _react2.default.createElement(_reactCodeSplitting2.default, { load: __webpack_require__.e/* import() */(0/* aggressive-merge */).then(__webpack_require__.bind(null, 1048)), componentProps: props });
};
var EvaluationGrantee = function EvaluationGrantee(props) {
	return _react2.default.createElement(_reactCodeSplitting2.default, { load: __webpack_require__.e/* import() */(0/* aggressive-merge */).then(__webpack_require__.bind(null, 1086)), componentProps: props });
};
var GranteesChangeDestiny = function GranteesChangeDestiny(props) {
	return _react2.default.createElement(_reactCodeSplitting2.default, { load: __webpack_require__.e/* import() */(1/* aggressive-merge */).then(__webpack_require__.bind(null, 1087)), componentProps: props });
};
var Events = function Events(props) {
	return _react2.default.createElement(_reactCodeSplitting2.default, { load: __webpack_require__.e/* import() */(1/* aggressive-merge */).then(__webpack_require__.bind(null, 1088)), componentProps: props });
};
var ExerciseInformation = function ExerciseInformation(props) {
	return _react2.default.createElement(_reactCodeSplitting2.default, { load: __webpack_require__.e/* import() */(1/* aggressive-merge */).then(__webpack_require__.bind(null, 1089)), componentProps: props });
};
var Goals = function Goals(props) {
	return _react2.default.createElement(_reactCodeSplitting2.default, { load: __webpack_require__.e/* import() */(2/* aggressive-merge */).then(__webpack_require__.bind(null, 1090)), componentProps: props });
};
var Grantee = function Grantee(props) {
	return _react2.default.createElement(_reactCodeSplitting2.default, { load: __webpack_require__.e/* import() */(9/* aggressive-merge */).then(__webpack_require__.bind(null, 1091)), componentProps: props });
};
var Groups = function Groups(props) {
	return _react2.default.createElement(_reactCodeSplitting2.default, { load: __webpack_require__.e/* import() */(28).then(__webpack_require__.bind(null, 1092)), componentProps: props });
};
var Home = function Home(props) {
	return _react2.default.createElement(_reactCodeSplitting2.default, { load: __webpack_require__.e/* import() */(53).then(__webpack_require__.bind(null, 1093)), componentProps: props });
};
var Indicators = function Indicators(props) {
	return _react2.default.createElement(_reactCodeSplitting2.default, { load: __webpack_require__.e/* import() */(3).then(__webpack_require__.bind(null, 1094)), componentProps: props });
};
var Information = function Information(props) {
	return _react2.default.createElement(_reactCodeSplitting2.default, { load: __webpack_require__.e/* import() */(23).then(__webpack_require__.bind(null, 1095)), componentProps: props });
};
var InterventionLevel = function InterventionLevel(props) {
	return _react2.default.createElement(_reactCodeSplitting2.default, { load: __webpack_require__.e/* import() */(10).then(__webpack_require__.bind(null, 1096)), componentProps: props });
};
var Items = function Items(props) {
	return _react2.default.createElement(_reactCodeSplitting2.default, { load: __webpack_require__.e/* import() */(2/* aggressive-merge */).then(__webpack_require__.bind(null, 1097)), componentProps: props });
};
var Concepts = function Concepts(props) {
	return _react2.default.createElement(_reactCodeSplitting2.default, { load: __webpack_require__.e/* import() */(10/* aggressive-merge */).then(__webpack_require__.bind(null, 1098)), componentProps: props });
};
var LegalEntity = function LegalEntity(props) {
	return _react2.default.createElement(_reactCodeSplitting2.default, { load: __webpack_require__.e/* import() */(9/* aggressive-merge */).then(__webpack_require__.bind(null, 1099)), componentProps: props });
};
var Modal = function Modal(props) {
	return _react2.default.createElement(_reactCodeSplitting2.default, { load: __webpack_require__.e/* import() */(59).then(__webpack_require__.bind(null, 1100)), componentProps: props });
};
var Notifications = function Notifications(props) {
	return _react2.default.createElement(_reactCodeSplitting2.default, { load: __webpack_require__.e/* import() */(39).then(__webpack_require__.bind(null, 1101)), componentProps: props });
};
var Objectives = function Objectives(props) {
	return _react2.default.createElement(_reactCodeSplitting2.default, { load: __webpack_require__.e/* import() */(7/* aggressive-merge */).then(__webpack_require__.bind(null, 1102)), componentProps: props });
};
var OpenQuestion = function OpenQuestion(props) {
	return _react2.default.createElement(_reactCodeSplitting2.default, { load: __webpack_require__.e/* import() */(2/* aggressive-merge */).then(__webpack_require__.bind(null, 1103)), componentProps: props });
};
var Profile = function Profile(props) {
	return _react2.default.createElement(_reactCodeSplitting2.default, { load: __webpack_require__.e/* import() */(7/* aggressive-merge */).then(__webpack_require__.bind(null, 1104)), componentProps: props });
};
var ProjectConfig = function ProjectConfig(props) {
	return _react2.default.createElement(_reactCodeSplitting2.default, { load: __webpack_require__.e/* import() */(20/* aggressive-merge */).then(__webpack_require__.bind(null, 1105)), componentProps: props });
};
var Projects = function Projects(props) {
	return _react2.default.createElement(_reactCodeSplitting2.default, { load: __webpack_require__.e/* import() */(24).then(__webpack_require__.bind(null, 1106)), componentProps: props });
};
var Question = function Question(props) {
	return _react2.default.createElement(_reactCodeSplitting2.default, { load: __webpack_require__.e/* import() */(12).then(__webpack_require__.bind(null, 1107)), componentProps: props });
};
var Ranges = function Ranges(props) {
	return _react2.default.createElement(_reactCodeSplitting2.default, { load: __webpack_require__.e/* import() */(5).then(__webpack_require__.bind(null, 1108)), componentProps: props });
};
var Register = function Register(props) {
	return _react2.default.createElement(_reactCodeSplitting2.default, { load: __webpack_require__.e/* import() */(16/* aggressive-merge */).then(__webpack_require__.bind(null, 1109)), componentProps: props });
};
var RegulatoryBody = function RegulatoryBody(props) {
	return _react2.default.createElement(_reactCodeSplitting2.default, { load: __webpack_require__.e/* import() */(11/* aggressive-merge */).then(__webpack_require__.bind(null, 1110)), componentProps: props });
};
var SolutionRequest = function SolutionRequest(props) {
	return _react2.default.createElement(_reactCodeSplitting2.default, { load: __webpack_require__.e/* import() */(3/* aggressive-merge */).then(__webpack_require__.bind(null, 1111)), componentProps: props });
};
var DataUpdate = function DataUpdate(props) {
	return _react2.default.createElement(_reactCodeSplitting2.default, { load: __webpack_require__.e/* import() */(37).then(__webpack_require__.bind(null, 1112)), componentProps: props });
};
var Results = function Results(props) {
	return _react2.default.createElement(_reactCodeSplitting2.default, { load: __webpack_require__.e/* import() */(22).then(__webpack_require__.bind(null, 1113)), componentProps: props });
};
var Scales = function Scales(props) {
	return _react2.default.createElement(_reactCodeSplitting2.default, { load: __webpack_require__.e/* import() */(7/* aggressive-merge */).then(__webpack_require__.bind(null, 1114)), componentProps: props });
};
var Services = function Services(props) {
	return _react2.default.createElement(_reactCodeSplitting2.default, { load: __webpack_require__.e/* import() */(8/* aggressive-merge */).then(__webpack_require__.bind(null, 1115)), componentProps: props });
};
var Actors = function Actors(props) {
	return _react2.default.createElement(_reactCodeSplitting2.default, { load: __webpack_require__.e/* import() */(11/* aggressive-merge */).then(__webpack_require__.bind(null, 1116)), componentProps: props });
};
var SpecialQuestion = function SpecialQuestion(props) {
	return _react2.default.createElement(_reactCodeSplitting2.default, { load: __webpack_require__.e/* import() */(30).then(__webpack_require__.bind(null, 1117)), componentProps: props });
};
var StageStreng = function StageStreng(props) {
	return _react2.default.createElement(_reactCodeSplitting2.default, { load: __webpack_require__.e/* import() */(8/* aggressive-merge */).then(__webpack_require__.bind(null, 1118)), componentProps: props });
};
var StateStreng = function StateStreng(props) {
	return _react2.default.createElement(_reactCodeSplitting2.default, { load: __webpack_require__.e/* import() */(8/* aggressive-merge */).then(__webpack_require__.bind(null, 1119)), componentProps: props });
};
var Subtheme = function Subtheme(props) {
	return _react2.default.createElement(_reactCodeSplitting2.default, { load: __webpack_require__.e/* import() */(5/* aggressive-merge */).then(__webpack_require__.bind(null, 1120)), componentProps: props });
};
var Subtheme2 = function Subtheme2(props) {
	return _react2.default.createElement(_reactCodeSplitting2.default, { load: __webpack_require__.e/* import() */(10/* aggressive-merge */).then(__webpack_require__.bind(null, 1121)), componentProps: props });
};
var Topic = function Topic(props) {
	return _react2.default.createElement(_reactCodeSplitting2.default, { load: __webpack_require__.e/* import() */(5/* aggressive-merge */).then(__webpack_require__.bind(null, 1122)), componentProps: props });
};
var TypeEvaluation = function TypeEvaluation(props) {
	return _react2.default.createElement(_reactCodeSplitting2.default, { load: __webpack_require__.e/* import() */(12/* aggressive-merge */).then(__webpack_require__.bind(null, 1123)), componentProps: props });
};
var TypeTable = function TypeTable(props) {
	return _react2.default.createElement(_reactCodeSplitting2.default, { load: __webpack_require__.e/* import() */(6/* aggressive-merge */).then(__webpack_require__.bind(null, 1124)), componentProps: props });
};
var ValuationItems = function ValuationItems(props) {
	return _react2.default.createElement(_reactCodeSplitting2.default, { load: __webpack_require__.e/* import() */(0/* aggressive-merge */).then(__webpack_require__.bind(null, 1125)), componentProps: props });
};
var ValuationMenu = function ValuationMenu(props) {
	return _react2.default.createElement(_reactCodeSplitting2.default, { load: __webpack_require__.e/* import() */(38).then(__webpack_require__.bind(null, 1126)), componentProps: props });
};
var Variable = function Variable(props) {
	return _react2.default.createElement(_reactCodeSplitting2.default, { load: __webpack_require__.e/* import() */(12/* aggressive-merge */).then(__webpack_require__.bind(null, 1127)), componentProps: props });
};
var NotFound = function NotFound(props) {
	return _react2.default.createElement(_reactCodeSplitting2.default, { load: __webpack_require__.e/* import() */(58).then(__webpack_require__.bind(null, 1128)), componentProps: props });
};
var Notification = function Notification(props) {
	return _react2.default.createElement(_reactCodeSplitting2.default, { load: __webpack_require__.e/* import() */(32).then(__webpack_require__.bind(null, 1129)), componentProps: props });
};
var TemplLetters = function TemplLetters(props) {
	return _react2.default.createElement(_reactCodeSplitting2.default, { load: __webpack_require__.e/* import() */(4/* aggressive-merge */).then(__webpack_require__.bind(null, 1130)), componentProps: props });
};
var FilterByEvaluation = function FilterByEvaluation(props) {
	return _react2.default.createElement(_reactCodeSplitting2.default, { load: __webpack_require__.e/* import() */(15).then(__webpack_require__.bind(null, 1131)), componentProps: props });
};
var Contracts = function Contracts(props) {
	return _react2.default.createElement(_reactCodeSplitting2.default, { load: __webpack_require__.e/* import() */(4/* aggressive-merge */).then(__webpack_require__.bind(null, 1132)), componentProps: props });
};
var TypeContracts = function TypeContracts(props) {
	return _react2.default.createElement(_reactCodeSplitting2.default, { load: __webpack_require__.e/* import() */(13/* aggressive-merge */).then(__webpack_require__.bind(null, 1133)), componentProps: props });
};
var PaymentRequirement = function PaymentRequirement(props) {
	return _react2.default.createElement(_reactCodeSplitting2.default, { load: __webpack_require__.e/* import() */(5/* aggressive-merge */).then(__webpack_require__.bind(null, 1134)), componentProps: props });
};
var Requirements = function Requirements(props) {
	return _react2.default.createElement(_reactCodeSplitting2.default, { load: __webpack_require__.e/* import() */(27).then(__webpack_require__.bind(null, 1135)), componentProps: props });
};
var ConditionDelivery = function ConditionDelivery(props) {
	return _react2.default.createElement(_reactCodeSplitting2.default, { load: __webpack_require__.e/* import() */(10/* aggressive-merge */).then(__webpack_require__.bind(null, 1136)), componentProps: props });
};
var MonitoringStrength = function MonitoringStrength(props) {
	return _react2.default.createElement(_reactCodeSplitting2.default, { load: __webpack_require__.e/* import() */(0/* aggressive-merge */).then(__webpack_require__.bind(null, 1137)), componentProps: props });
};
var ApplicationStatus = function ApplicationStatus(props) {
	return _react2.default.createElement(_reactCodeSplitting2.default, { load: __webpack_require__.e/* import() */(6/* aggressive-merge */).then(__webpack_require__.bind(null, 1138)), componentProps: props });
};
var CheckStatus = function CheckStatus(props) {
	return _react2.default.createElement(_reactCodeSplitting2.default, { load: __webpack_require__.e/* import() */(14/* aggressive-merge */).then(__webpack_require__.bind(null, 1139)), componentProps: props });
};
var MonitoringStrengthGrantee = function MonitoringStrengthGrantee(props) {
	return _react2.default.createElement(_reactCodeSplitting2.default, { load: __webpack_require__.e/* import() */(17/* aggressive-merge */).then(__webpack_require__.bind(null, 1047)), componentProps: props });
};
var ResultsReport = function ResultsReport(props) {
	return _react2.default.createElement(_reactCodeSplitting2.default, { load: __webpack_require__.e/* import() */(26).then(__webpack_require__.bind(null, 1140)), componentProps: props });
};
var ProgramPerformance = function ProgramPerformance(props) {
	return _react2.default.createElement(_reactCodeSplitting2.default, { load: __webpack_require__.e/* import() */(0/* aggressive-merge */).then(__webpack_require__.bind(null, 1141)), componentProps: props });
};
var Goods = function Goods(props) {
	return _react2.default.createElement(_reactCodeSplitting2.default, { load: __webpack_require__.e/* import() */(6/* aggressive-merge */).then(__webpack_require__.bind(null, 1142)), componentProps: props });
};
var TypeCatalog = function TypeCatalog(props) {
	return _react2.default.createElement(_reactCodeSplitting2.default, { load: __webpack_require__.e/* import() */(9/* aggressive-merge */).then(__webpack_require__.bind(null, 1143)), componentProps: props });
};
var IntegralValuation = function IntegralValuation(props) {
	return _react2.default.createElement(_reactCodeSplitting2.default, { load: __webpack_require__.e/* import() */(13/* aggressive-merge */).then(__webpack_require__.bind(null, 1144)), componentProps: props });
};
var IntegralValuationContainer = function IntegralValuationContainer(props) {
	return _react2.default.createElement(_reactCodeSplitting2.default, { load: __webpack_require__.e/* import() */(3/* aggressive-merge */).then(__webpack_require__.bind(null, 1145)), componentProps: props });
};
var DonationsDetail = function DonationsDetail(props) {
	return _react2.default.createElement(_reactCodeSplitting2.default, { load: __webpack_require__.e/* import() */(14/* aggressive-merge */).then(__webpack_require__.bind(null, 1146)), componentProps: props });
};
var ControlPanel = function ControlPanel(props) {
	return _react2.default.createElement(_reactCodeSplitting2.default, { load: __webpack_require__.e/* import() */(21).then(__webpack_require__.bind(null, 1147)), componentProps: props });
};
var BlogGeneral = function BlogGeneral(props) {
	return _react2.default.createElement(_reactCodeSplitting2.default, { load: __webpack_require__.e/* import() */(1/* aggressive-merge */).then(__webpack_require__.bind(null, 1148)), componentProps: props });
};
var Reports = function Reports(props) {
	return _react2.default.createElement(_reactCodeSplitting2.default, { load: __webpack_require__.e/* import() */(25).then(__webpack_require__.bind(null, 1149)), componentProps: props });
};
var ReportsOption = function ReportsOption(props) {
	return _react2.default.createElement(_reactCodeSplitting2.default, { load: __webpack_require__.e/* import() */(15/* aggressive-merge */).then(__webpack_require__.bind(null, 1150)), componentProps: props });
};
var ContactData = function ContactData(props) {
	return _react2.default.createElement(_reactCodeSplitting2.default, { load: __webpack_require__.e/* import() */(44).then(__webpack_require__.bind(null, 1151)), componentProps: props });
};
var DashboardPreDonation = function DashboardPreDonation(props) {
	return _react2.default.createElement(_reactCodeSplitting2.default, { load: __webpack_require__.e/* import() */(50).then(__webpack_require__.bind(null, 1152)), componentProps: props });
};
var Calculation = function Calculation(props) {
	return _react2.default.createElement(_reactCodeSplitting2.default, { load: __webpack_require__.e/* import() */(4/* aggressive-merge */).then(__webpack_require__.bind(null, 1153)), componentProps: props });
};
var Approval = function Approval(props) {
	return _react2.default.createElement(_reactCodeSplitting2.default, { load: __webpack_require__.e/* import() */(18).then(__webpack_require__.bind(null, 1154)), componentProps: props });
};
var Reassignment = function Reassignment(props) {
	return _react2.default.createElement(_reactCodeSplitting2.default, { load: __webpack_require__.e/* import() */(52).then(__webpack_require__.bind(null, 1155)), componentProps: props });
};
var PreRegisterForm = function PreRegisterForm(props) {
	return _react2.default.createElement(_reactCodeSplitting2.default, { load: __webpack_require__.e/* import() */(40).then(__webpack_require__.bind(null, 1156)), componentProps: props });
};
var ReportResults = function ReportResults(props) {
	return _react2.default.createElement(_reactCodeSplitting2.default, { load: __webpack_require__.e/* import() */(15/* aggressive-merge */).then(__webpack_require__.bind(null, 1157)), componentProps: props });
};
var ReceptionAudit = function ReceptionAudit(props) {
	return _react2.default.createElement(_reactCodeSplitting2.default, { load: __webpack_require__.e/* import() */(3/* aggressive-merge */).then(__webpack_require__.bind(null, 1158)), componentProps: props });
};
var PortfolioReallocation = function PortfolioReallocation(props) {
	return _react2.default.createElement(_reactCodeSplitting2.default, { load: __webpack_require__.e/* import() */(3/* aggressive-merge */).then(__webpack_require__.bind(null, 1159)), componentProps: props });
};
var DashboardProfile = function DashboardProfile(props) {
	return _react2.default.createElement(_reactCodeSplitting2.default, { load: __webpack_require__.e/* import() */(49).then(__webpack_require__.bind(null, 1160)), componentProps: props });
};
var ConfPld = function ConfPld(props) {
	return _react2.default.createElement(_reactCodeSplitting2.default, { load: __webpack_require__.e/* import() */(18/* aggressive-merge */).then(__webpack_require__.bind(null, 1161)), componentProps: props });
};
// mensajes
var MensajesList = function MensajesList(props) {
	return _react2.default.createElement(_reactCodeSplitting2.default, { load: __webpack_require__.e/* import() */(41).then(__webpack_require__.bind(null, 1162)), componentProps: props });
};
var FormContactDataEjec = function FormContactDataEjec(props) {
	return _react2.default.createElement(_reactCodeSplitting2.default, { load: __webpack_require__.e/* import() */(43).then(__webpack_require__.bind(null, 1163)), componentProps: props });
};

var store = (0, _store2.default)();

var Config = function Config(props) {
	return _react2.default.createElement(
		App,
		null,
		_react2.default.createElement(_reactRouterDom.Route, { path: props.match.url + '/configuracion-proyecto', component: ProjectConfig }),
		_react2.default.createElement(_reactRouterDom.Route, { path: props.match.url + '/preguntas-abiertas', component: OpenQuestion }),
		_react2.default.createElement(_reactRouterDom.Route, { path: props.match.url + '/preguntas-cerradas', component: ClosedQuestion }),
		_react2.default.createElement(_reactRouterDom.Route, { path: props.match.url + '/preguntas-comentarios', component: CommentsQuestion }),
		_react2.default.createElement(_reactRouterDom.Route, { exact: true, path: props.match.url + '/preguntas-especiales', component: SpecialQuestion }),
		_react2.default.createElement(_reactRouterDom.Route, { path: props.match.url + '/preguntas-especiales/:pregunta', component: SpecialQuestion }),
		_react2.default.createElement(_reactRouterDom.Route, { path: props.match.url + '/rangos', component: Ranges }),
		_react2.default.createElement(_reactRouterDom.Route, { path: props.match.url + '/tipo-tabla', component: TypeTable }),
		_react2.default.createElement(_reactRouterDom.Route, { path: props.match.url + '/escalas', component: Scales }),
		_react2.default.createElement(_reactRouterDom.Route, { path: props.match.url + '/indicadores', component: Indicators }),
		_react2.default.createElement(_reactRouterDom.Route, { path: props.match.url + '/metas', component: Goals }),
		_react2.default.createElement(_reactRouterDom.Route, { path: props.match.url + '/configuracion-objetivo', component: Objectives }),
		_react2.default.createElement(_reactRouterDom.Route, { path: props.match.url + '/pregunta', component: Question }),
		_react2.default.createElement(_reactRouterDom.Route, { path: props.match.url + '/variable', component: Variable }),
		_react2.default.createElement(_reactRouterDom.Route, { path: props.match.url + '/evaluacion', component: TypeEvaluation }),
		_react2.default.createElement(_reactRouterDom.Route, { path: props.match.url + '/estatus-fortalecimiento', component: StateStreng }),
		_react2.default.createElement(_reactRouterDom.Route, { path: props.match.url + '/configuracion-fortalecimiento', component: StageStreng }),
		_react2.default.createElement(_reactRouterDom.Route, { path: props.match.url + '/estatus-documentos', component: DocStatus }),
		_react2.default.createElement(_reactRouterDom.Route, { path: props.match.url + '/nombres-documentos', component: DocNames }),
		_react2.default.createElement(_reactRouterDom.Route, { path: props.match.url + '/donatarias', component: Grantee }),
		_react2.default.createElement(_reactRouterDom.Route, { path: props.match.url + '/grupos', component: Groups }),
		_react2.default.createElement(_reactRouterDom.Route, { path: props.match.url + '/corridas', component: Events }),
		_react2.default.createElement(_reactRouterDom.Route, { path: props.match.url + '/configurar-pld', component: ConfPld }),
		_react2.default.createElement(_reactRouterDom.Route, { path: props.match.url + '/criterios-elegibilidad', component: EligibilityCriteria }),
		_react2.default.createElement(_reactRouterDom.Route, { path: props.match.url + '/catalogo/rubros', component: Items }),
		_react2.default.createElement(_reactRouterDom.Route, { path: props.match.url + '/catalogo/conceptos', component: Concepts }),
		_react2.default.createElement(_reactRouterDom.Route, { path: props.match.url + '/subtema', component: Subtheme }),
		_react2.default.createElement(_reactRouterDom.Route, { path: props.match.url + '/subtema2', component: Subtheme2 }),
		_react2.default.createElement(_reactRouterDom.Route, { path: props.match.url + '/tema', component: Topic }),
		_react2.default.createElement(_reactRouterDom.Route, { path: props.match.url + '/funcion-patrono', component: EmployerRole }),
		_react2.default.createElement(_reactRouterDom.Route, { path: props.match.url + '/figura-juridica', component: LegalEntity }),
		_react2.default.createElement(_reactRouterDom.Route, { path: props.match.url + '/nivel-intervencion', component: InterventionLevel }),
		_react2.default.createElement(_reactRouterDom.Route, { path: props.match.url + '/informacion-ejercicio', component: ExerciseInformation }),
		_react2.default.createElement(_reactRouterDom.Route, { path: props.match.url + '/enfoque', component: Approach }),
		_react2.default.createElement(_reactRouterDom.Route, { path: props.match.url + '/servicios', component: Services }),
		_react2.default.createElement(_reactRouterDom.Route, { path: props.match.url + '/otros-actores', component: Actors }),
		_react2.default.createElement(_reactRouterDom.Route, { path: props.match.url + '/organismo-regulador', component: RegulatoryBody }),
		_react2.default.createElement(_reactRouterDom.Route, { path: props.match.url + '/recepcion-solicitudes', component: SolutionRequest }),
		_react2.default.createElement(_reactRouterDom.Route, { path: props.match.url + '/actualizacion-datos', component: DataUpdate }),
		_react2.default.createElement(_reactRouterDom.Route, { path: props.match.url + '/consultor', component: Consultant }),
		_react2.default.createElement(_reactRouterDom.Route, { path: props.match.url + '/donantes', component: Donors }),
		_react2.default.createElement(_reactRouterDom.Route, { path: props.match.url + '/promedio-egresos', component: AverageOfExpenses }),
		_react2.default.createElement(_reactRouterDom.Route, { path: props.match.url + '/promedio-egresos-y-diversas-evaluaciones', component: AverageExpAndSeveralEval }),
		_react2.default.createElement(_reactRouterDom.Route, { path: props.match.url + '/disminuci\xF3n-incremento-donativo-asignado', component: DecOrIncDonationAssigned }),
		_react2.default.createElement(_reactRouterDom.Route, { path: props.match.url + '/variacion-evaluaciones-grupo-cerrado', component: VariationEvaluationClosed }),
		_react2.default.createElement(_reactRouterDom.Route, { path: props.match.url + '/variacion-evaluaciones-grupo-abierto', component: VariationEvaluationOpened }),
		_react2.default.createElement(_reactRouterDom.Route, { path: props.match.url + '/plantilla-cartas', component: TemplLetters }),
		_react2.default.createElement(_reactRouterDom.Route, { path: props.match.url + '/contratos', component: Contracts }),
		_react2.default.createElement(_reactRouterDom.Route, { path: props.match.url + '/tipo-contratos', component: TypeContracts }),
		_react2.default.createElement(_reactRouterDom.Route, { path: props.match.url + '/requisito-pagos', component: PaymentRequirement }),
		_react2.default.createElement(_reactRouterDom.Route, { path: props.match.url + '/estatus-aplicacion-donativo', component: ApplicationStatus }),
		_react2.default.createElement(_reactRouterDom.Route, { path: props.match.url + '/estatus-comprobacion-donativo', component: CheckStatus }),
		_react2.default.createElement(_reactRouterDom.Route, { path: props.match.url + '/bienes', component: Goods }),
		_react2.default.createElement(_reactRouterDom.Route, { path: props.match.url + '/tipo', component: TypeCatalog }),
		_react2.default.createElement(_reactRouterDom.Route, { path: props.match.url + '/valoracion-integral', component: IntegralValuation }),
		_react2.default.createElement(_reactRouterDom.Route, { path: props.match.url + '/informe-resultados', component: ReportResults }),
		_react2.default.createElement(_reactRouterDom.Route, { path: props.match.url + '/recepcion-auditoria', component: ReceptionAudit }),
		_react2.default.createElement(_reactRouterDom.Route, { path: props.match.url + '/asignacion-cartera', component: PortfolioReallocation })
	);
};

var Principal = function Principal(props) {
	return _react2.default.createElement(
		PrincipalApp,
		props,
		_react2.default.createElement(_reactRouterDom.Route, { exact: true, path: props.match.url + '/detalle/:option', component: DashboardDetail }),
		_react2.default.createElement(_reactRouterDom.Route, { path: props.match.url + '/dashboard', component: Dashboard }),
		_react2.default.createElement(_reactRouterDom.Route, { path: props.match.url + '/dashboard-supervisor/:option', component: DashboardSupervisor }),
		_react2.default.createElement(_reactRouterDom.Route, { path: props.match.url + '/ver-destino', component: ChangeDestination }),
		_react2.default.createElement(_reactRouterDom.Route, { path: props.match.url + '/cambio-destino', component: ChangeDestinitySuperDirector }),
		_react2.default.createElement(_reactRouterDom.Route, { path: props.match.url + '/notificaciones', component: Notification }),
		_react2.default.createElement(_reactRouterDom.Route, { path: props.match.url + '/donatario-pre', component: AssignmentFilter }),
		_react2.default.createElement(_reactRouterDom.Route, { path: props.match.url + '/filtro-de-asignacion', component: AssignmentFilter }),
		_react2.default.createElement(_reactRouterDom.Route, { path: props.match.url + '/propuesta-de-asignacion', component: ProposalAssignment }),
		_react2.default.createElement(_reactRouterDom.Route, { path: props.match.url + '/propuesta-de-asignacion-ejec', component: ProposalAssignmentEjec }),
		_react2.default.createElement(_reactRouterDom.Route, { path: props.match.url + '/filtro-por-evaluacion', component: FilterByEvaluation }),
		_react2.default.createElement(_reactRouterDom.Route, { path: props.match.url + '/entrega-donativo', component: ConditionDelivery }),
		_react2.default.createElement(_reactRouterDom.Route, { path: props.match.url + '/valoracion-integral', component: IntegralValuationContainer }),
		_react2.default.createElement(_reactRouterDom.Route, { path: props.match.url + '/detalle-donaciones', component: DonationsDetail }),
		_react2.default.createElement(_reactRouterDom.Route, { path: props.match.url + '/bitacora-general', component: BlogGeneral }),
		_react2.default.createElement(_reactRouterDom.Route, { path: props.match.url + '/reportes-opciones', component: ReportsOption }),
		_react2.default.createElement(_reactRouterDom.Route, { path: props.match.url + '/reportes/:id', component: Reports }),
		_react2.default.createElement(_reactRouterDom.Route, { path: props.match.url + '/dashboard-donativo-pre', component: DashboardPreDonation }),
		_react2.default.createElement(_reactRouterDom.Route, { path: props.match.url + '/calculo-donativo-pre', component: Calculation }),
		_react2.default.createElement(_reactRouterDom.Route, { path: props.match.url + '/aprobacion-donativo-pre', component: Approval }),
		_react2.default.createElement(_reactRouterDom.Route, { path: props.match.url + '/reasignacion', component: Reassignment }),
		_react2.default.createElement(_reactRouterDom.Route, { path: props.match.url + '/nuevo-usuario', component: PreRegisterForm }),
		_react2.default.createElement(_reactRouterDom.Route, { path: props.match.url + '/perfiles', component: DashboardProfile }),
		_react2.default.createElement(_reactRouterDom.Route, { path: props.match.url + '/perfil', component: Profile }),
		_react2.default.createElement(_reactRouterDom.Route, { path: props.match.url + '/asignacion-perfil', component: AssignmentProfile }),
		_react2.default.createElement(_reactRouterDom.Route, { path: props.match.url + '/mensajes', component: MensajesList }),
		_react2.default.createElement(_reactRouterDom.Route, { path: props.match.url + '/datosContactoEjecutivo', component: FormContactDataEjec })
	);
};

var Evaluations = function Evaluations(props) {
	return _react2.default.createElement(
		EvaluationApp,
		props,
		_react2.default.createElement(_reactRouterDom.Route, { path: props.match.url + '/convocatoria', component: EvaluationGrantee }),
		_react2.default.createElement(_reactRouterDom.Route, { path: props.match.url + '/menu', component: ValuationMenu }),
		_react2.default.createElement(_reactRouterDom.Route, { path: props.match.url + '/evaluacion-variable', component: EvaluationVariable }),
		_react2.default.createElement(_reactRouterDom.Route, { path: props.match.url + '/valoracion-rubros', component: ValuationItems }),
		_react2.default.createElement(_reactRouterDom.Route, { path: props.match.url + '/resultados', component: Results }),
		_react2.default.createElement(_reactRouterDom.Route, { path: props.match.url + '/criterios-elegibilidad', component: Criteria }),
		_react2.default.createElement(_reactRouterDom.Route, { path: props.match.url + '/fortalecimiento', component: MonitoringStrength }),
		_react2.default.createElement(_reactRouterDom.Route, { path: props.match.url + '/monitoreo', component: MonitoringStrengthGrantee }),
		_react2.default.createElement(_reactRouterDom.Route, { path: props.match.url + '/desempeno-programa', component: ProgramPerformance })
	);
};

var Oportunities = function Oportunities(props) {
	return _react2.default.createElement(
		OportunitiesApp,
		props,
		_react2.default.createElement(_reactRouterDom.Route, { path: props.match.url + '/felicitaciones', component: Congrats }),
		_react2.default.createElement(_reactRouterDom.Route, { path: props.match.url + '/convocatoria', component: Announcement }),
		_react2.default.createElement(_reactRouterDom.Route, { path: props.match.url + '/proyectos', component: Projects })
	);
};

var Grantees = function Grantees(props) {
	return _react2.default.createElement(
		GranteeApp,
		props,
		_react2.default.createElement(_reactRouterDom.Route, { path: props.match.url + '/principal', component: Principal }),
		_react2.default.createElement(_reactRouterDom.Route, { path: props.match.url + '/registro', component: Register }),
		_react2.default.createElement(_reactRouterDom.Route, { path: props.match.url + '/informacion', component: Information }),
		_react2.default.createElement(_reactRouterDom.Route, { path: props.match.url + '/oportunidades', component: Oportunities }),
		_react2.default.createElement(_reactRouterDom.Route, { path: props.match.url + '/evaluaciones', component: Evaluations }),
		_react2.default.createElement(_reactRouterDom.Route, { path: props.match.url + '/notificaciones', component: Notifications }),
		_react2.default.createElement(_reactRouterDom.Route, { path: props.match.url + '/requisitos-pago', component: Requirements }),
		_react2.default.createElement(_reactRouterDom.Route, { path: props.match.url + '/cambio-destino', component: GranteesChangeDestiny }),
		_react2.default.createElement(_reactRouterDom.Route, { path: props.match.url + '/informe-resultados-fortalecimiento', component: ResultsReport }),
		_react2.default.createElement(_reactRouterDom.Route, { path: props.match.url + '/tableroControl', component: ControlPanel }),
		_react2.default.createElement(_reactRouterDom.Route, { path: props.match.url + '/datosContacto', component: ContactData })
	);
};

(0, _reactDom.render)(_react2.default.createElement(
	_reactRedux.Provider,
	{ store: store },
	_react2.default.createElement(
		_reactRouterDom.BrowserRouter,
		null,
		_react2.default.createElement(
			'div',
			null,
			_react2.default.createElement(Loading, null),
			_react2.default.createElement(
				_reactRouterDom.Switch,
				null,
				_react2.default.createElement(_reactRouterDom.Route, { path: '/' + "Donativos" + '/login', component: Login }),
				_react2.default.createElement(_reactRouterDom.Route, { path: '/' + "Donativos" + '/home', component: Home }),
				_react2.default.createElement(_reactRouterDom.Route, { path: '/' + "Donativos" + '/configuracion', component: Config }),
				_react2.default.createElement(_reactRouterDom.Route, { path: '/' + "Donativos" + '/donataria', component: Grantees }),
				_react2.default.createElement(_reactRouterDom.Route, { path: '/' + "Donativos" + '/pre-registro', component: PreRegister, exact: true }),
				_react2.default.createElement(_reactRouterDom.Route, { path: '/' + "Donativos" + '/activate', component: Activate }),
				_react2.default.createElement(_reactRouterDom.Route, { component: NotFound })
			),
			_react2.default.createElement(Modal, null)
		)
	)
), document.getElementById('app'));

/***/ }),

/***/ 558:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 560:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 561:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 562:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 563:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 564:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 565:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 566:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 633:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _redux = __webpack_require__(144);

var _reduxThunk = __webpack_require__(634);

var _reduxThunk2 = _interopRequireDefault(_reduxThunk);

var _Modules = __webpack_require__(635);

var _Modules2 = _interopRequireDefault(_Modules);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var configureStore = function configureStore() {
	var composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || _redux.compose;
	return (0, _redux.createStore)(_Modules2.default, composeEnhancers((0, _redux.applyMiddleware)(_reduxThunk2.default)));
};

exports.default = configureStore;

/***/ }),

/***/ 635:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Account = __webpack_require__(401);

var _Account2 = _interopRequireDefault(_Account);

var _AdditionalInfo = __webpack_require__(499);

var _AdditionalInfo2 = _interopRequireDefault(_AdditionalInfo);

var _Applications = __webpack_require__(500);

var _Applications2 = _interopRequireDefault(_Applications);

var _Approach = __webpack_require__(451);

var _Approach2 = _interopRequireDefault(_Approach);

var _AverageOfExpenses = __webpack_require__(501);

var _AverageOfExpenses2 = _interopRequireDefault(_AverageOfExpenses);

var _AverageExpAndSeveralEval = __webpack_require__(502);

var _AverageExpAndSeveralEval2 = _interopRequireDefault(_AverageExpAndSeveralEval);

var _DecOrIncDonationAssigned = __webpack_require__(503);

var _DecOrIncDonationAssigned2 = _interopRequireDefault(_DecOrIncDonationAssigned);

var _VariationEvaluationClosed = __webpack_require__(504);

var _VariationEvaluationClosed2 = _interopRequireDefault(_VariationEvaluationClosed);

var _VariationEvaluationOpened = __webpack_require__(505);

var _VariationEvaluationOpened2 = _interopRequireDefault(_VariationEvaluationOpened);

var _AssignmentFilter = __webpack_require__(452);

var _AssignmentFilter2 = _interopRequireDefault(_AssignmentFilter);

var _ChangeDestination = __webpack_require__(408);

var _ChangeDestination2 = _interopRequireDefault(_ChangeDestination);

var _Process = __webpack_require__(394);

var _Process2 = _interopRequireDefault(_Process);

var _CompanyCharter = __webpack_require__(506);

var _CompanyCharter2 = _interopRequireDefault(_CompanyCharter);

var _ContactData = __webpack_require__(507);

var _ContactData2 = _interopRequireDefault(_ContactData);

var _Contacts = __webpack_require__(508);

var _Contacts2 = _interopRequireDefault(_Contacts);

var _Classification = __webpack_require__(435);

var _Classification2 = _interopRequireDefault(_Classification);

var _Delegation = __webpack_require__(1017);

var _Delegation2 = _interopRequireDefault(_Delegation);

var _DocName = __webpack_require__(453);

var _DocName2 = _interopRequireDefault(_DocName);

var _Pay = __webpack_require__(509);

var _Pay2 = _interopRequireDefault(_Pay);

var _DocStatus = __webpack_require__(510);

var _DocStatus2 = _interopRequireDefault(_DocStatus);

var _Documents = __webpack_require__(1018);

var _Documents2 = _interopRequireDefault(_Documents);

var _Donor = __webpack_require__(436);

var _Donor2 = _interopRequireDefault(_Donor);

var _EligibilityCriteria = __webpack_require__(454);

var _EligibilityCriteria2 = _interopRequireDefault(_EligibilityCriteria);

var _Evaluation = __webpack_require__(416);

var _Evaluation2 = _interopRequireDefault(_Evaluation);

var _EvalCriteria = __webpack_require__(455);

var _EvalCriteria2 = _interopRequireDefault(_EvalCriteria);

var _Evaluator = __webpack_require__(456);

var _Evaluator2 = _interopRequireDefault(_Evaluator);

var _Config = __webpack_require__(457);

var _Config2 = _interopRequireDefault(_Config);

var _ExerciseInformation = __webpack_require__(437);

var _ExerciseInformation2 = _interopRequireDefault(_ExerciseInformation);

var _ExerciseInfoCalendar = __webpack_require__(511);

var _ExerciseInfoCalendar2 = _interopRequireDefault(_ExerciseInfoCalendar);

var _Features = __webpack_require__(512);

var _Features2 = _interopRequireDefault(_Features);

var _Documents3 = __webpack_require__(395);

var _Documents4 = _interopRequireDefault(_Documents3);

var _Financial = __webpack_require__(513);

var _Financial2 = _interopRequireDefault(_Financial);

var _FunctionPatron = __webpack_require__(458);

var _FunctionPatron2 = _interopRequireDefault(_FunctionPatron);

var _GeneralInfo = __webpack_require__(514);

var _GeneralInfo2 = _interopRequireDefault(_GeneralInfo);

var _Goals = __webpack_require__(459);

var _Goals2 = _interopRequireDefault(_Goals);

var _Government = __webpack_require__(1019);

var _Government2 = _interopRequireDefault(_Government);

var _Grantee = __webpack_require__(409);

var _Grantee2 = _interopRequireDefault(_Grantee);

var _Status = __webpack_require__(410);

var _Status2 = _interopRequireDefault(_Status);

var _Config3 = __webpack_require__(460);

var _Config4 = _interopRequireDefault(_Config3);

var _Home = __webpack_require__(1020);

var _Home2 = _interopRequireDefault(_Home);

var _Objectives = __webpack_require__(515);

var _Objectives2 = _interopRequireDefault(_Objectives);

var _Summary = __webpack_require__(516);

var _Summary2 = _interopRequireDefault(_Summary);

var _Indicators = __webpack_require__(438);

var _Indicators2 = _interopRequireDefault(_Indicators);

var _InterventionLevel = __webpack_require__(439);

var _InterventionLevel2 = _interopRequireDefault(_InterventionLevel);

var _Items = __webpack_require__(411);

var _Items2 = _interopRequireDefault(_Items);

var _Concept = __webpack_require__(461);

var _Concept2 = _interopRequireDefault(_Concept);

var _LegalConcept = __webpack_require__(417);

var _LegalConcept2 = _interopRequireDefault(_LegalConcept);

var _LegalRepresentation = __webpack_require__(462);

var _LegalRepresentation2 = _interopRequireDefault(_LegalRepresentation);

var _Loading = __webpack_require__(3);

var _Loading2 = _interopRequireDefault(_Loading);

var _Loader = __webpack_require__(205);

var _Loader2 = _interopRequireDefault(_Loader);

var _Locations = __webpack_require__(517);

var _Locations2 = _interopRequireDefault(_Locations);

var _Login = __webpack_require__(440);

var _Login2 = _interopRequireDefault(_Login);

var _Modal = __webpack_require__(4);

var _Modal2 = _interopRequireDefault(_Modal);

var _Notifications = __webpack_require__(398);

var _Notifications2 = _interopRequireDefault(_Notifications);

var _Objectives3 = __webpack_require__(441);

var _Objectives4 = _interopRequireDefault(_Objectives3);

var _Opportunities = __webpack_require__(442);

var _Opportunities2 = _interopRequireDefault(_Opportunities);

var _OrigenEvaluation = __webpack_require__(518);

var _OrigenEvaluation2 = _interopRequireDefault(_OrigenEvaluation);

var _PatronsCouncelors = __webpack_require__(519);

var _PatronsCouncelors2 = _interopRequireDefault(_PatronsCouncelors);

var _PatronsCouncelors3 = __webpack_require__(520);

var _PatronsCouncelors4 = _interopRequireDefault(_PatronsCouncelors3);

var _Phase = __webpack_require__(521);

var _Phase2 = _interopRequireDefault(_Phase);

var _Population = __webpack_require__(522);

var _Population2 = _interopRequireDefault(_Population);

var _Postal = __webpack_require__(404);

var _Postal2 = _interopRequireDefault(_Postal);

var _Profile = __webpack_require__(412);

var _Profile2 = _interopRequireDefault(_Profile);

var _ProfileUser = __webpack_require__(405);

var _ProfileUser2 = _interopRequireDefault(_ProfileUser);

var _Project = __webpack_require__(463);

var _Project2 = _interopRequireDefault(_Project);

var _Projects = __webpack_require__(402);

var _Projects2 = _interopRequireDefault(_Projects);

var _Question = __webpack_require__(443);

var _Question2 = _interopRequireDefault(_Question);

var _QuestionProject = __webpack_require__(216);

var _QuestionProject2 = _interopRequireDefault(_QuestionProject);

var _QuestionType = __webpack_require__(413);

var _QuestionType2 = _interopRequireDefault(_QuestionType);

var _Ranges = __webpack_require__(464);

var _Ranges2 = _interopRequireDefault(_Ranges);

var _Items3 = __webpack_require__(403);

var _Items4 = _interopRequireDefault(_Items3);

var _Scales = __webpack_require__(465);

var _Scales2 = _interopRequireDefault(_Scales);

var _Services = __webpack_require__(466);

var _Services2 = _interopRequireDefault(_Services);

var _StageStreng = __webpack_require__(467);

var _StageStreng2 = _interopRequireDefault(_StageStreng);

var _StateEvent = __webpack_require__(525);

var _StateEvent2 = _interopRequireDefault(_StateEvent);

var _StateGrantee = __webpack_require__(468);

var _StateGrantee2 = _interopRequireDefault(_StateGrantee);

var _StateStreng = __webpack_require__(469);

var _StateStreng2 = _interopRequireDefault(_StateStreng);

var _States = __webpack_require__(406);

var _States2 = _interopRequireDefault(_States);

var _Subtheme = __webpack_require__(470);

var _Subtheme2 = _interopRequireDefault(_Subtheme);

var _Subtheme3 = __webpack_require__(471);

var _Subtheme4 = _interopRequireDefault(_Subtheme3);

var _Summary3 = __webpack_require__(526);

var _Summary4 = _interopRequireDefault(_Summary3);

var _Symbols = __webpack_require__(418);

var _Symbols2 = _interopRequireDefault(_Symbols);

var _Topic = __webpack_require__(472);

var _Topic2 = _interopRequireDefault(_Topic);

var _Town = __webpack_require__(419);

var _Town2 = _interopRequireDefault(_Town);

var _TypeFunction = __webpack_require__(444);

var _TypeFunction2 = _interopRequireDefault(_TypeFunction);

var _TypeTable = __webpack_require__(473);

var _TypeTable2 = _interopRequireDefault(_TypeTable);

var _Variable = __webpack_require__(414);

var _Variable2 = _interopRequireDefault(_Variable);

var _RegulatoryBody = __webpack_require__(420);

var _RegulatoryBody2 = _interopRequireDefault(_RegulatoryBody);

var _Consultant = __webpack_require__(445);

var _Consultant2 = _interopRequireDefault(_Consultant);

var _Actor = __webpack_require__(474);

var _Actor2 = _interopRequireDefault(_Actor);

var _Contracts = __webpack_require__(475);

var _Contracts2 = _interopRequireDefault(_Contracts);

var _MonitoringStrength = __webpack_require__(421);

var _MonitoringStrength2 = _interopRequireDefault(_MonitoringStrength);

var _Justification = __webpack_require__(476);

var _Justification2 = _interopRequireDefault(_Justification);

var _Variable3 = __webpack_require__(446);

var _Variable4 = _interopRequireDefault(_Variable3);

var _SustainableGoals = __webpack_require__(477);

var _SustainableGoals2 = _interopRequireDefault(_SustainableGoals);

var _Results = __webpack_require__(422);

var _Results2 = _interopRequireDefault(_Results);

var _Evaluations = __webpack_require__(447);

var _Evaluations2 = _interopRequireDefault(_Evaluations);

var _EvaluationPerformance = __webpack_require__(478);

var _EvaluationPerformance2 = _interopRequireDefault(_EvaluationPerformance);

var _Rounding = __webpack_require__(479);

var _Rounding2 = _interopRequireDefault(_Rounding);

var _ProposalAssignment = __webpack_require__(407);

var _ProposalAssignment2 = _interopRequireDefault(_ProposalAssignment);

var _ProposalAssignmentEjec = __webpack_require__(480);

var _ProposalAssignmentEjec2 = _interopRequireDefault(_ProposalAssignmentEjec);

var _TemplLetters = __webpack_require__(527);

var _TemplLetters2 = _interopRequireDefault(_TemplLetters);

var _FilterByEvaluation = __webpack_require__(528);

var _FilterByEvaluation2 = _interopRequireDefault(_FilterByEvaluation);

var _Notifications3 = __webpack_require__(529);

var _Notifications4 = _interopRequireDefault(_Notifications3);

var _Claves = __webpack_require__(530);

var _Claves2 = _interopRequireDefault(_Claves);

var _Contracts3 = __webpack_require__(531);

var _Contracts4 = _interopRequireDefault(_Contracts3);

var _TypeContracts = __webpack_require__(481);

var _TypeContracts2 = _interopRequireDefault(_TypeContracts);

var _Delivery = __webpack_require__(532);

var _Delivery2 = _interopRequireDefault(_Delivery);

var _PaymentRequirement = __webpack_require__(533);

var _PaymentRequirement2 = _interopRequireDefault(_PaymentRequirement);

var _TypePaymentRequirements = __webpack_require__(534);

var _TypePaymentRequirements2 = _interopRequireDefault(_TypePaymentRequirements);

var _DocumentsAndLegalReps = __webpack_require__(535);

var _DocumentsAndLegalReps2 = _interopRequireDefault(_DocumentsAndLegalReps);

var _Grantees = __webpack_require__(482);

var _Grantees2 = _interopRequireDefault(_Grantees);

var _Requirements = __webpack_require__(536);

var _Requirements2 = _interopRequireDefault(_Requirements);

var _ApplicationStatus = __webpack_require__(537);

var _ApplicationStatus2 = _interopRequireDefault(_ApplicationStatus);

var _CheckStatus = __webpack_require__(538);

var _CheckStatus2 = _interopRequireDefault(_CheckStatus);

var _ResultsReport = __webpack_require__(483);

var _ResultsReport2 = _interopRequireDefault(_ResultsReport);

var _Goods = __webpack_require__(484);

var _Goods2 = _interopRequireDefault(_Goods);

var _TypeCatalog = __webpack_require__(485);

var _TypeCatalog2 = _interopRequireDefault(_TypeCatalog);

var _IntegralValuation = __webpack_require__(486);

var _IntegralValuation2 = _interopRequireDefault(_IntegralValuation);

var _DonationsDetail = __webpack_require__(539);

var _DonationsDetail2 = _interopRequireDefault(_DonationsDetail);

var _ControlPanel = __webpack_require__(540);

var _ControlPanel2 = _interopRequireDefault(_ControlPanel);

var _IntegralValuation3 = __webpack_require__(541);

var _IntegralValuation4 = _interopRequireDefault(_IntegralValuation3);

var _General = __webpack_require__(542);

var _General2 = _interopRequireDefault(_General);

var _ContactData3 = __webpack_require__(543);

var _ContactData4 = _interopRequireDefault(_ContactData3);

var _Calculation = __webpack_require__(487);

var _Calculation2 = _interopRequireDefault(_Calculation);

var _Approval = __webpack_require__(544);

var _Approval2 = _interopRequireDefault(_Approval);

var _Reassignment = __webpack_require__(545);

var _Reassignment2 = _interopRequireDefault(_Reassignment);

var _DataBankInfo = __webpack_require__(546);

var _DataBankInfo2 = _interopRequireDefault(_DataBankInfo);

var _Reports = __webpack_require__(1046);

var _Reports2 = _interopRequireDefault(_Reports);

var _ReportsDis = __webpack_require__(488);

var _ReportsDis2 = _interopRequireDefault(_ReportsDis);

var _InformationComponent = __webpack_require__(547);

var _InformationComponent2 = _interopRequireDefault(_InformationComponent);

var _Donations = __webpack_require__(548);

var _Donations2 = _interopRequireDefault(_Donations);

var _PreRegister = __webpack_require__(415);

var _PreRegister2 = _interopRequireDefault(_PreRegister);

var _ExpressDonation = __webpack_require__(549);

var _ExpressDonation2 = _interopRequireDefault(_ExpressDonation);

var _redux = __webpack_require__(144);

var _SolutionRequest = __webpack_require__(423);

var _SolutionRequest2 = _interopRequireDefault(_SolutionRequest);

var _DataUpdate = __webpack_require__(550);

var _DataUpdate2 = _interopRequireDefault(_DataUpdate);

var _ReportResults = __webpack_require__(551);

var _ReportResults2 = _interopRequireDefault(_ReportResults);

var _ReceptionAudit = __webpack_require__(489);

var _ReceptionAudit2 = _interopRequireDefault(_ReceptionAudit);

var _ReassignmentTask = __webpack_require__(552);

var _ReassignmentTask2 = _interopRequireDefault(_ReassignmentTask);

var _ConfPld = __webpack_require__(490);

var _ConfPld2 = _interopRequireDefault(_ConfPld);

var _Mensajes = __webpack_require__(424);

var _Mensajes2 = _interopRequireDefault(_Mensajes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var rootReducer = (0, _redux.combineReducers)({
  Applications: _Applications2.default,
  Approach: _Approach2.default,
  AverageOfExpenses: _AverageOfExpenses2.default,
  AverageExpAndSeveralEval: _AverageExpAndSeveralEval2.default,
  DecOrIncDonationAssigned: _DecOrIncDonationAssigned2.default,
  VariationEvaluationClosed: _VariationEvaluationClosed2.default,
  VariationEvaluationOpened: _VariationEvaluationOpened2.default,
  AssignmentFilter: _AssignmentFilter2.default,
  ChangeDestination: _ChangeDestination2.default,
  BpmProcess: _Process2.default,
  DocStatus: _DocStatus2.default,
  DocName: _DocName2.default,
  Pay: _Pay2.default,
  Evaluator: _Evaluator2.default,
  EvalCriteria: _EvalCriteria2.default,
  EligibilityCriteria: _EligibilityCriteria2.default,
  EventBudget: _Config2.default,
  Exercises: _ExerciseInformation2.default,
  ExercisesCaledar: _ExerciseInfoCalendar2.default,
  Features: _Features2.default,
  Financial: _Financial2.default,
  Home: _Home2.default,
  Ranges: _Ranges2.default,
  TypeTable: _TypeTable2.default,
  Scales: _Scales2.default,
  StateEvent: _StateEvent2.default,
  StateGrantee: _StateGrantee2.default,
  States: _States2.default,
  Indicators: _Indicators2.default,
  Goals: _Goals2.default,
  Groups: _Config4.default,
  Objectives: _Objectives4.default,
  Items: _Items2.default,
  conceptos: _Concept2.default,
  StateStreng: _StateStreng2.default,
  StageStreng: _StageStreng2.default,
  Subtheme: _Subtheme2.default,
  Subtheme2: _Subtheme4.default,
  Symbols: _Symbols2.default,
  TypeFunction: _TypeFunction2.default,
  Loading: _Loading2.default,
  Login: _Login2.default,
  LegalConcept: _LegalConcept2.default,
  Modal: _Modal2.default,
  Notifications: _Notifications2.default,
  Register: (0, _redux.combineReducers)({
    Account: _Account2.default,
    GeneralInfo: _GeneralInfo2.default,
    ContactData: _ContactData2.default,
    PatronsCouncelors: _PatronsCouncelors2.default,
    CompanyCharter: _CompanyCharter2.default,
    LegalRepresentation: _LegalRepresentation2.default,
    Documents: _Documents2.default,
    Summary: _Summary4.default
  }),
  Opportunities: _Opportunities2.default,
  Rubros: _Items4.default,
  Question: _Question2.default,
  OrigenEvaluation: _OrigenEvaluation2.default,
  PatronsCatalog: _PatronsCouncelors4.default,
  Project: _Project2.default,
  Phase: _Phase2.default,
  Postal: _Postal2.default,
  QuestionProject: _QuestionProject2.default,
  QuestionType: _QuestionType2.default,
  Population: _Population2.default,
  ProfileUser: _ProfileUser2.default,
  Profile: _Profile2.default,
  Topic: _Topic2.default,
  Town: _Town2.default,
  Grantee: _Grantee2.default,
  Donor: _Donor2.default,
  Variable: _Variable2.default,
  Evaluation: _Evaluation2.default,
  Locations: _Locations2.default,
  Files: _Documents4.default,
  FunctionPatron: _FunctionPatron2.default,
  Information: (0, _redux.combineReducers)({
    AdditionalInfo: _AdditionalInfo2.default,
    Objectives: _Objectives2.default,
    Contacts: _Contacts2.default,
    Classification: _Classification2.default,
    Summary: _Summary2.default
  }),
  Services: _Services2.default,
  Projects: _Projects2.default,
  Delegation: _Delegation2.default,
  Government: _Government2.default,
  InterventionLevel: _InterventionLevel2.default,
  GranteeStatus: _Status2.default,
  RegulatoryBody: _RegulatoryBody2.default,
  Consultant: _Consultant2.default,
  Actor: _Actor2.default,
  Contracts: _Contracts2.default,
  MonitoringStrength: _MonitoringStrength2.default,
  Justification: _Justification2.default,
  EvaluationVariable: _Variable4.default,
  SustainableGoals: _SustainableGoals2.default,
  Results: _Results2.default,
  Evaluations: _Evaluations2.default,
  EvaluationPerformance: _EvaluationPerformance2.default,
  Rounding: _Rounding2.default,
  ProposalAssignment: _ProposalAssignment2.default,
  ProposalAssignmentEjec: _ProposalAssignmentEjec2.default,
  Loader: _Loader2.default,
  TemplLetters: _TemplLetters2.default,
  FilterByEvaluation: _FilterByEvaluation2.default,
  Notification: _Notifications4.default,
  Claves: _Claves2.default,
  Contratos: _Contracts4.default,
  TypeContracts: _TypeContracts2.default,
  Delivery: _Delivery2.default,
  PaymentRequirement: _PaymentRequirement2.default,
  TypePaymentRequirement: _TypePaymentRequirements2.default,
  DocsAndReps: _DocumentsAndLegalReps2.default,
  Contabilizadas: _Grantees2.default,
  PaymentRequirements: _Requirements2.default,
  ApplicationStatus: _ApplicationStatus2.default,
  CheckStatus: _CheckStatus2.default,
  ResultsReport: _ResultsReport2.default,
  Goods: _Goods2.default,
  TypeCatalog: _TypeCatalog2.default,
  IntegralValuation: _IntegralValuation2.default,
  DonationsDetail: _DonationsDetail2.default,
  ControlPanel: _ControlPanel2.default,
  IntegralValuationContainer: _IntegralValuation4.default,
  BlogGeneral: _General2.default,
  ContactDataGrantee: _ContactData4.default,
  PreDonationCalculation: _Calculation2.default,
  PreDonationApproval: _Approval2.default,
  Reassignment: _Reassignment2.default,
  PaymentBank: _DataBankInfo2.default,
  Reports: _Reports2.default,
  ReportsDis: _ReportsDis2.default,
  InformationComponent: _InformationComponent2.default,
  Donations: _Donations2.default,
  PreRegister: _PreRegister2.default,
  ExpressDonation: _ExpressDonation2.default,
  SolutionRequest: _SolutionRequest2.default,
  DataUpdate: _DataUpdate2.default,
  ReportResults: _ReportResults2.default,
  ReceptionAudit: _ReceptionAudit2.default,
  ReassignmentTask: _ReassignmentTask2.default,
  ConfPld: _ConfPld2.default,
  Mensajes: _Mensajes2.default
});

exports.default = rootReducer;

/***/ }),

/***/ 641:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 643:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 654:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 656:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 681:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 682:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 687:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 689:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 696:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 715:
/***/ (function(module, exports) {

/* (ignored) */

/***/ })

},[553]);


// WEBPACK FOOTER //
// bundle.js